
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hlXCZ", function(module, exports) {

$parcel$export(module.exports, "register", () => $ca22a6b09b25fc1d$export$6503ec6e8aabbaf, (v) => $ca22a6b09b25fc1d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $ca22a6b09b25fc1d$export$f7ad0328861e2f03, (v) => $ca22a6b09b25fc1d$export$f7ad0328861e2f03 = v);
var $ca22a6b09b25fc1d$export$6503ec6e8aabbaf;
var $ca22a6b09b25fc1d$export$f7ad0328861e2f03;
"use strict";
var $ca22a6b09b25fc1d$var$mapping = new Map();
function $ca22a6b09b25fc1d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ca22a6b09b25fc1d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ca22a6b09b25fc1d$var$resolve(id) {
    var resolved = $ca22a6b09b25fc1d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ca22a6b09b25fc1d$export$6503ec6e8aabbaf = $ca22a6b09b25fc1d$var$register;
$ca22a6b09b25fc1d$export$f7ad0328861e2f03 = $ca22a6b09b25fc1d$var$resolve;

});

parcelRegister("bHSF9", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $885e1cb707aa147b$export$ffb0004e005737fa, (v) => $885e1cb707aa147b$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $885e1cb707aa147b$export$34b9dba7ce09269b, (v) => $885e1cb707aa147b$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $885e1cb707aa147b$export$25062201e9e25d76, (v) => $885e1cb707aa147b$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $885e1cb707aa147b$export$ffb0004e005737fa;
var $885e1cb707aa147b$export$34b9dba7ce09269b;
var $885e1cb707aa147b$export$25062201e9e25d76;
'use strict';

var $l7WPE = parcelRequire("l7WPE");
var $885e1cb707aa147b$var$k = Symbol.for("react.element"), $885e1cb707aa147b$var$l = Symbol.for("react.fragment"), $885e1cb707aa147b$var$m = Object.prototype.hasOwnProperty, $885e1cb707aa147b$var$n = $l7WPE.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $885e1cb707aa147b$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $885e1cb707aa147b$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$885e1cb707aa147b$var$m.call(a, b) && !$885e1cb707aa147b$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $885e1cb707aa147b$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $885e1cb707aa147b$var$n.current
    };
}
$885e1cb707aa147b$export$ffb0004e005737fa = $885e1cb707aa147b$var$l;
$885e1cb707aa147b$export$34b9dba7ce09269b = $885e1cb707aa147b$var$q;
$885e1cb707aa147b$export$25062201e9e25d76 = $885e1cb707aa147b$var$q;

});
parcelRegister("l7WPE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bkCMv"));

});
parcelRegister("bkCMv", function(module, exports) {

$parcel$export(module.exports, "Children", () => $83ffa5259cab4623$export$dca3b0875bd9a954, (v) => $83ffa5259cab4623$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $83ffa5259cab4623$export$16fa2f45be04daa8, (v) => $83ffa5259cab4623$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $83ffa5259cab4623$export$ffb0004e005737fa, (v) => $83ffa5259cab4623$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $83ffa5259cab4623$export$e2c29f18771995cb, (v) => $83ffa5259cab4623$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $83ffa5259cab4623$export$221d75b3f55bb0bd, (v) => $83ffa5259cab4623$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $83ffa5259cab4623$export$5f8d39834fd61797, (v) => $83ffa5259cab4623$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $83ffa5259cab4623$export$74bf444e3cd11ea5, (v) => $83ffa5259cab4623$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $83ffa5259cab4623$export$ae55be85d98224ed, (v) => $83ffa5259cab4623$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $83ffa5259cab4623$export$3ba232387fd5d6dd, (v) => $83ffa5259cab4623$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $83ffa5259cab4623$export$e530037191fcd5d7, (v) => $83ffa5259cab4623$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $83ffa5259cab4623$export$fd42f52fd3ae1109, (v) => $83ffa5259cab4623$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $83ffa5259cab4623$export$c8a8987d4410bf2d, (v) => $83ffa5259cab4623$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $83ffa5259cab4623$export$d38cd72104c1f0e9, (v) => $83ffa5259cab4623$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $83ffa5259cab4623$export$7d1e3a5e95ceca43, (v) => $83ffa5259cab4623$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $83ffa5259cab4623$export$257a8862b851cb5b, (v) => $83ffa5259cab4623$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $83ffa5259cab4623$export$a8257692ac88316c, (v) => $83ffa5259cab4623$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $83ffa5259cab4623$export$488013bae63b21da, (v) => $83ffa5259cab4623$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $83ffa5259cab4623$export$7c73462e0d25e514, (v) => $83ffa5259cab4623$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $83ffa5259cab4623$export$7568632d0d33d16d, (v) => $83ffa5259cab4623$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $83ffa5259cab4623$export$88948ce120ea2619, (v) => $83ffa5259cab4623$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $83ffa5259cab4623$export$35808ee640e87ca7, (v) => $83ffa5259cab4623$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $83ffa5259cab4623$export$fae74005e78b1a27, (v) => $83ffa5259cab4623$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $83ffa5259cab4623$export$dc8fbce3eb94dc1e, (v) => $83ffa5259cab4623$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $83ffa5259cab4623$export$6a7bc4e911dc01cf, (v) => $83ffa5259cab4623$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $83ffa5259cab4623$export$6d9c69b0de29b591, (v) => $83ffa5259cab4623$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $83ffa5259cab4623$export$f680877a34711e37, (v) => $83ffa5259cab4623$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $83ffa5259cab4623$export$d5a552a76deda3c2, (v) => $83ffa5259cab4623$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $83ffa5259cab4623$export$aaabe4eda9ed9969, (v) => $83ffa5259cab4623$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $83ffa5259cab4623$export$e5c5a5f917a5871c, (v) => $83ffa5259cab4623$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $83ffa5259cab4623$export$1538c33de8887b59, (v) => $83ffa5259cab4623$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $83ffa5259cab4623$export$13e3392192263954, (v) => $83ffa5259cab4623$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $83ffa5259cab4623$export$b8f5890fc79d6aca, (v) => $83ffa5259cab4623$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $83ffa5259cab4623$export$60241385465d0a34, (v) => $83ffa5259cab4623$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $83ffa5259cab4623$export$306c0aa65ff9ec16, (v) => $83ffa5259cab4623$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $83ffa5259cab4623$export$7b286972b8d8ccbf, (v) => $83ffa5259cab4623$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $83ffa5259cab4623$export$83d89fbfd8236492, (v) => $83ffa5259cab4623$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $83ffa5259cab4623$export$dca3b0875bd9a954;
var $83ffa5259cab4623$export$16fa2f45be04daa8;
var $83ffa5259cab4623$export$ffb0004e005737fa;
var $83ffa5259cab4623$export$e2c29f18771995cb;
var $83ffa5259cab4623$export$221d75b3f55bb0bd;
var $83ffa5259cab4623$export$5f8d39834fd61797;
var $83ffa5259cab4623$export$74bf444e3cd11ea5;
var $83ffa5259cab4623$export$ae55be85d98224ed;
var $83ffa5259cab4623$export$3ba232387fd5d6dd;
var $83ffa5259cab4623$export$e530037191fcd5d7;
var $83ffa5259cab4623$export$fd42f52fd3ae1109;
var $83ffa5259cab4623$export$c8a8987d4410bf2d;
var $83ffa5259cab4623$export$d38cd72104c1f0e9;
var $83ffa5259cab4623$export$7d1e3a5e95ceca43;
var $83ffa5259cab4623$export$257a8862b851cb5b;
var $83ffa5259cab4623$export$a8257692ac88316c;
var $83ffa5259cab4623$export$488013bae63b21da;
var $83ffa5259cab4623$export$7c73462e0d25e514;
var $83ffa5259cab4623$export$7568632d0d33d16d;
var $83ffa5259cab4623$export$88948ce120ea2619;
var $83ffa5259cab4623$export$35808ee640e87ca7;
var $83ffa5259cab4623$export$fae74005e78b1a27;
var $83ffa5259cab4623$export$dc8fbce3eb94dc1e;
var $83ffa5259cab4623$export$6a7bc4e911dc01cf;
var $83ffa5259cab4623$export$6d9c69b0de29b591;
var $83ffa5259cab4623$export$f680877a34711e37;
var $83ffa5259cab4623$export$d5a552a76deda3c2;
var $83ffa5259cab4623$export$aaabe4eda9ed9969;
var $83ffa5259cab4623$export$e5c5a5f917a5871c;
var $83ffa5259cab4623$export$1538c33de8887b59;
var $83ffa5259cab4623$export$13e3392192263954;
var $83ffa5259cab4623$export$b8f5890fc79d6aca;
var $83ffa5259cab4623$export$60241385465d0a34;
var $83ffa5259cab4623$export$306c0aa65ff9ec16;
var $83ffa5259cab4623$export$7b286972b8d8ccbf;
var $83ffa5259cab4623$export$83d89fbfd8236492;
'use strict';
var $83ffa5259cab4623$var$l = Symbol.for("react.element"), $83ffa5259cab4623$var$n = Symbol.for("react.portal"), $83ffa5259cab4623$var$p = Symbol.for("react.fragment"), $83ffa5259cab4623$var$q = Symbol.for("react.strict_mode"), $83ffa5259cab4623$var$r = Symbol.for("react.profiler"), $83ffa5259cab4623$var$t = Symbol.for("react.provider"), $83ffa5259cab4623$var$u = Symbol.for("react.context"), $83ffa5259cab4623$var$v = Symbol.for("react.forward_ref"), $83ffa5259cab4623$var$w = Symbol.for("react.suspense"), $83ffa5259cab4623$var$x = Symbol.for("react.memo"), $83ffa5259cab4623$var$y = Symbol.for("react.lazy"), $83ffa5259cab4623$var$z = Symbol.iterator;
function $83ffa5259cab4623$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $83ffa5259cab4623$var$z && a[$83ffa5259cab4623$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $83ffa5259cab4623$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $83ffa5259cab4623$var$C = Object.assign, $83ffa5259cab4623$var$D = {};
function $83ffa5259cab4623$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $83ffa5259cab4623$var$D;
    this.updater = e || $83ffa5259cab4623$var$B;
}
$83ffa5259cab4623$var$E.prototype.isReactComponent = {};
$83ffa5259cab4623$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$83ffa5259cab4623$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $83ffa5259cab4623$var$F() {}
$83ffa5259cab4623$var$F.prototype = $83ffa5259cab4623$var$E.prototype;
function $83ffa5259cab4623$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $83ffa5259cab4623$var$D;
    this.updater = e || $83ffa5259cab4623$var$B;
}
var $83ffa5259cab4623$var$H = $83ffa5259cab4623$var$G.prototype = new $83ffa5259cab4623$var$F;
$83ffa5259cab4623$var$H.constructor = $83ffa5259cab4623$var$G;
$83ffa5259cab4623$var$C($83ffa5259cab4623$var$H, $83ffa5259cab4623$var$E.prototype);
$83ffa5259cab4623$var$H.isPureReactComponent = !0;
var $83ffa5259cab4623$var$I = Array.isArray, $83ffa5259cab4623$var$J = Object.prototype.hasOwnProperty, $83ffa5259cab4623$var$K = {
    current: null
}, $83ffa5259cab4623$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $83ffa5259cab4623$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$83ffa5259cab4623$var$J.call(b, d) && !$83ffa5259cab4623$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $83ffa5259cab4623$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $83ffa5259cab4623$var$K.current
    };
}
function $83ffa5259cab4623$var$N(a, b) {
    return {
        $$typeof: $83ffa5259cab4623$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $83ffa5259cab4623$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $83ffa5259cab4623$var$l;
}
function $83ffa5259cab4623$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $83ffa5259cab4623$var$P = /\/+/g;
function $83ffa5259cab4623$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $83ffa5259cab4623$var$escape("" + a.key) : b.toString(36);
}
function $83ffa5259cab4623$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $83ffa5259cab4623$var$l:
                case $83ffa5259cab4623$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $83ffa5259cab4623$var$Q(h, 0) : d, $83ffa5259cab4623$var$I(c) ? (e = "", null != a && (e = a.replace($83ffa5259cab4623$var$P, "$&/") + "/"), $83ffa5259cab4623$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($83ffa5259cab4623$var$O(c) && (c = $83ffa5259cab4623$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($83ffa5259cab4623$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($83ffa5259cab4623$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $83ffa5259cab4623$var$Q(k, g);
        h += $83ffa5259cab4623$var$R(k, b, e, f, c);
    }
    else if (f = $83ffa5259cab4623$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $83ffa5259cab4623$var$Q(k, g++), h += $83ffa5259cab4623$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $83ffa5259cab4623$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $83ffa5259cab4623$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $83ffa5259cab4623$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $83ffa5259cab4623$var$U = {
    current: null
}, $83ffa5259cab4623$var$V = {
    transition: null
}, $83ffa5259cab4623$var$W = {
    ReactCurrentDispatcher: $83ffa5259cab4623$var$U,
    ReactCurrentBatchConfig: $83ffa5259cab4623$var$V,
    ReactCurrentOwner: $83ffa5259cab4623$var$K
};
function $83ffa5259cab4623$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$83ffa5259cab4623$export$dca3b0875bd9a954 = {
    map: $83ffa5259cab4623$var$S,
    forEach: function(a, b, e) {
        $83ffa5259cab4623$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $83ffa5259cab4623$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $83ffa5259cab4623$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$83ffa5259cab4623$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$83ffa5259cab4623$export$16fa2f45be04daa8 = $83ffa5259cab4623$var$E;
$83ffa5259cab4623$export$ffb0004e005737fa = $83ffa5259cab4623$var$p;
$83ffa5259cab4623$export$e2c29f18771995cb = $83ffa5259cab4623$var$r;
$83ffa5259cab4623$export$221d75b3f55bb0bd = $83ffa5259cab4623$var$G;
$83ffa5259cab4623$export$5f8d39834fd61797 = $83ffa5259cab4623$var$q;
$83ffa5259cab4623$export$74bf444e3cd11ea5 = $83ffa5259cab4623$var$w;
$83ffa5259cab4623$export$ae55be85d98224ed = $83ffa5259cab4623$var$W;
$83ffa5259cab4623$export$3ba232387fd5d6dd = $83ffa5259cab4623$var$X;
$83ffa5259cab4623$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $83ffa5259cab4623$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $83ffa5259cab4623$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$83ffa5259cab4623$var$J.call(b, f) && !$83ffa5259cab4623$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $83ffa5259cab4623$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$83ffa5259cab4623$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $83ffa5259cab4623$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $83ffa5259cab4623$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$83ffa5259cab4623$export$c8a8987d4410bf2d = $83ffa5259cab4623$var$M;
$83ffa5259cab4623$export$d38cd72104c1f0e9 = function(a) {
    var b = $83ffa5259cab4623$var$M.bind(null, a);
    b.type = a;
    return b;
};
$83ffa5259cab4623$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$83ffa5259cab4623$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $83ffa5259cab4623$var$v,
        render: a
    };
};
$83ffa5259cab4623$export$a8257692ac88316c = $83ffa5259cab4623$var$O;
$83ffa5259cab4623$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $83ffa5259cab4623$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $83ffa5259cab4623$var$T
    };
};
$83ffa5259cab4623$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $83ffa5259cab4623$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$83ffa5259cab4623$export$7568632d0d33d16d = function(a) {
    var b = $83ffa5259cab4623$var$V.transition;
    $83ffa5259cab4623$var$V.transition = {};
    try {
        a();
    } finally{
        $83ffa5259cab4623$var$V.transition = b;
    }
};
$83ffa5259cab4623$export$88948ce120ea2619 = $83ffa5259cab4623$var$X;
$83ffa5259cab4623$export$35808ee640e87ca7 = function(a, b) {
    return $83ffa5259cab4623$var$U.current.useCallback(a, b);
};
$83ffa5259cab4623$export$fae74005e78b1a27 = function(a) {
    return $83ffa5259cab4623$var$U.current.useContext(a);
};
$83ffa5259cab4623$export$dc8fbce3eb94dc1e = function() {};
$83ffa5259cab4623$export$6a7bc4e911dc01cf = function(a) {
    return $83ffa5259cab4623$var$U.current.useDeferredValue(a);
};
$83ffa5259cab4623$export$6d9c69b0de29b591 = function(a, b) {
    return $83ffa5259cab4623$var$U.current.useEffect(a, b);
};
$83ffa5259cab4623$export$f680877a34711e37 = function() {
    return $83ffa5259cab4623$var$U.current.useId();
};
$83ffa5259cab4623$export$d5a552a76deda3c2 = function(a, b, e) {
    return $83ffa5259cab4623$var$U.current.useImperativeHandle(a, b, e);
};
$83ffa5259cab4623$export$aaabe4eda9ed9969 = function(a, b) {
    return $83ffa5259cab4623$var$U.current.useInsertionEffect(a, b);
};
$83ffa5259cab4623$export$e5c5a5f917a5871c = function(a, b) {
    return $83ffa5259cab4623$var$U.current.useLayoutEffect(a, b);
};
$83ffa5259cab4623$export$1538c33de8887b59 = function(a, b) {
    return $83ffa5259cab4623$var$U.current.useMemo(a, b);
};
$83ffa5259cab4623$export$13e3392192263954 = function(a, b, e) {
    return $83ffa5259cab4623$var$U.current.useReducer(a, b, e);
};
$83ffa5259cab4623$export$b8f5890fc79d6aca = function(a) {
    return $83ffa5259cab4623$var$U.current.useRef(a);
};
$83ffa5259cab4623$export$60241385465d0a34 = function(a) {
    return $83ffa5259cab4623$var$U.current.useState(a);
};
$83ffa5259cab4623$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $83ffa5259cab4623$var$U.current.useSyncExternalStore(a, b, e);
};
$83ffa5259cab4623$export$7b286972b8d8ccbf = function() {
    return $83ffa5259cab4623$var$U.current.useTransition();
};
$83ffa5259cab4623$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("e1xeM", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $a35af0f53d067c81$export$ae55be85d98224ed, (v) => $a35af0f53d067c81$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $a35af0f53d067c81$export$d39a5bbd09211389, (v) => $a35af0f53d067c81$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $a35af0f53d067c81$export$882461b6382ed46c, (v) => $a35af0f53d067c81$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $a35af0f53d067c81$export$466bfc07425424d5, (v) => $a35af0f53d067c81$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $a35af0f53d067c81$export$cd75ccfd720a3cd4, (v) => $a35af0f53d067c81$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $a35af0f53d067c81$export$fa8d919ba61d84db, (v) => $a35af0f53d067c81$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $a35af0f53d067c81$export$757ceba2d55c277e, (v) => $a35af0f53d067c81$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $a35af0f53d067c81$export$b3890eb0ae9dca99, (v) => $a35af0f53d067c81$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $a35af0f53d067c81$export$502457920280e6be, (v) => $a35af0f53d067c81$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $a35af0f53d067c81$export$c78a37762a8d58e1, (v) => $a35af0f53d067c81$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $a35af0f53d067c81$export$dc54d992c10e8a18, (v) => $a35af0f53d067c81$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $a35af0f53d067c81$export$83d89fbfd8236492, (v) => $a35af0f53d067c81$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $a35af0f53d067c81$export$ae55be85d98224ed;
var $a35af0f53d067c81$export$d39a5bbd09211389;
var $a35af0f53d067c81$export$882461b6382ed46c;
var $a35af0f53d067c81$export$466bfc07425424d5;
var $a35af0f53d067c81$export$cd75ccfd720a3cd4;
var $a35af0f53d067c81$export$fa8d919ba61d84db;
var $a35af0f53d067c81$export$757ceba2d55c277e;
var $a35af0f53d067c81$export$b3890eb0ae9dca99;
var $a35af0f53d067c81$export$502457920280e6be;
var $a35af0f53d067c81$export$c78a37762a8d58e1;
var $a35af0f53d067c81$export$dc54d992c10e8a18;
var $a35af0f53d067c81$export$83d89fbfd8236492;
'use strict';

var $l7WPE = parcelRequire("l7WPE");

var $fB1dE = parcelRequire("fB1dE");
function $a35af0f53d067c81$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a35af0f53d067c81$var$da = new Set, $a35af0f53d067c81$var$ea = {};
function $a35af0f53d067c81$var$fa(a, b) {
    $a35af0f53d067c81$var$ha(a, b);
    $a35af0f53d067c81$var$ha(a + "Capture", b);
}
function $a35af0f53d067c81$var$ha(a, b) {
    $a35af0f53d067c81$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$a35af0f53d067c81$var$da.add(b[a]);
}
var $a35af0f53d067c81$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a35af0f53d067c81$var$ja = Object.prototype.hasOwnProperty, $a35af0f53d067c81$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a35af0f53d067c81$var$la = {}, $a35af0f53d067c81$var$ma = {};
function $a35af0f53d067c81$var$oa(a) {
    if ($a35af0f53d067c81$var$ja.call($a35af0f53d067c81$var$ma, a)) return !0;
    if ($a35af0f53d067c81$var$ja.call($a35af0f53d067c81$var$la, a)) return !1;
    if ($a35af0f53d067c81$var$ka.test(a)) return $a35af0f53d067c81$var$ma[a] = !0;
    $a35af0f53d067c81$var$la[a] = !0;
    return !1;
}
function $a35af0f53d067c81$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $a35af0f53d067c81$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $a35af0f53d067c81$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $a35af0f53d067c81$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $a35af0f53d067c81$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a35af0f53d067c81$var$z[a] = new $a35af0f53d067c81$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a35af0f53d067c81$var$z[b] = new $a35af0f53d067c81$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a35af0f53d067c81$var$z[a] = new $a35af0f53d067c81$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a35af0f53d067c81$var$z[a] = new $a35af0f53d067c81$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a35af0f53d067c81$var$z[a] = new $a35af0f53d067c81$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a35af0f53d067c81$var$z[a] = new $a35af0f53d067c81$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a35af0f53d067c81$var$z[a] = new $a35af0f53d067c81$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a35af0f53d067c81$var$z[a] = new $a35af0f53d067c81$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a35af0f53d067c81$var$z[a] = new $a35af0f53d067c81$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a35af0f53d067c81$var$ra = /[\-:]([a-z])/g;
function $a35af0f53d067c81$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a35af0f53d067c81$var$ra, $a35af0f53d067c81$var$sa);
    $a35af0f53d067c81$var$z[b] = new $a35af0f53d067c81$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a35af0f53d067c81$var$ra, $a35af0f53d067c81$var$sa);
    $a35af0f53d067c81$var$z[b] = new $a35af0f53d067c81$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a35af0f53d067c81$var$ra, $a35af0f53d067c81$var$sa);
    $a35af0f53d067c81$var$z[b] = new $a35af0f53d067c81$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a35af0f53d067c81$var$z[a] = new $a35af0f53d067c81$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a35af0f53d067c81$var$z.xlinkHref = new $a35af0f53d067c81$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a35af0f53d067c81$var$z[a] = new $a35af0f53d067c81$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $a35af0f53d067c81$var$ta(a, b, c, d) {
    var e = $a35af0f53d067c81$var$z.hasOwnProperty(b) ? $a35af0f53d067c81$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $a35af0f53d067c81$var$qa(b, c, e, d) && (c = null), d || null === e ? $a35af0f53d067c81$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $a35af0f53d067c81$var$ua = $l7WPE.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $a35af0f53d067c81$var$va = Symbol.for("react.element"), $a35af0f53d067c81$var$wa = Symbol.for("react.portal"), $a35af0f53d067c81$var$ya = Symbol.for("react.fragment"), $a35af0f53d067c81$var$za = Symbol.for("react.strict_mode"), $a35af0f53d067c81$var$Aa = Symbol.for("react.profiler"), $a35af0f53d067c81$var$Ba = Symbol.for("react.provider"), $a35af0f53d067c81$var$Ca = Symbol.for("react.context"), $a35af0f53d067c81$var$Da = Symbol.for("react.forward_ref"), $a35af0f53d067c81$var$Ea = Symbol.for("react.suspense"), $a35af0f53d067c81$var$Fa = Symbol.for("react.suspense_list"), $a35af0f53d067c81$var$Ga = Symbol.for("react.memo"), $a35af0f53d067c81$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $a35af0f53d067c81$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $a35af0f53d067c81$var$Ja = Symbol.iterator;
function $a35af0f53d067c81$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a35af0f53d067c81$var$Ja && a[$a35af0f53d067c81$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a35af0f53d067c81$var$A = Object.assign, $a35af0f53d067c81$var$La;
function $a35af0f53d067c81$var$Ma(a) {
    if (void 0 === $a35af0f53d067c81$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $a35af0f53d067c81$var$La = b && b[1] || "";
    }
    return "\n" + $a35af0f53d067c81$var$La + a;
}
var $a35af0f53d067c81$var$Na = !1;
function $a35af0f53d067c81$var$Oa(a, b) {
    if (!a || $a35af0f53d067c81$var$Na) return "";
    $a35af0f53d067c81$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $a35af0f53d067c81$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $a35af0f53d067c81$var$Ma(a) : "";
}
function $a35af0f53d067c81$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $a35af0f53d067c81$var$Ma(a.type);
        case 16:
            return $a35af0f53d067c81$var$Ma("Lazy");
        case 13:
            return $a35af0f53d067c81$var$Ma("Suspense");
        case 19:
            return $a35af0f53d067c81$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $a35af0f53d067c81$var$Oa(a.type, !1), a;
        case 11:
            return a = $a35af0f53d067c81$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $a35af0f53d067c81$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $a35af0f53d067c81$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a35af0f53d067c81$var$ya:
            return "Fragment";
        case $a35af0f53d067c81$var$wa:
            return "Portal";
        case $a35af0f53d067c81$var$Aa:
            return "Profiler";
        case $a35af0f53d067c81$var$za:
            return "StrictMode";
        case $a35af0f53d067c81$var$Ea:
            return "Suspense";
        case $a35af0f53d067c81$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a35af0f53d067c81$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $a35af0f53d067c81$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $a35af0f53d067c81$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a35af0f53d067c81$var$Ga:
            return b = a.displayName || null, null !== b ? b : $a35af0f53d067c81$var$Qa(a.type) || "Memo";
        case $a35af0f53d067c81$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $a35af0f53d067c81$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $a35af0f53d067c81$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $a35af0f53d067c81$var$Qa(b);
        case 8:
            return b === $a35af0f53d067c81$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $a35af0f53d067c81$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $a35af0f53d067c81$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $a35af0f53d067c81$var$Ua(a) {
    var b = $a35af0f53d067c81$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $a35af0f53d067c81$var$Va(a) {
    a._valueTracker || (a._valueTracker = $a35af0f53d067c81$var$Ua(a));
}
function $a35af0f53d067c81$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $a35af0f53d067c81$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $a35af0f53d067c81$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $a35af0f53d067c81$var$Ya(a, b) {
    var c = b.checked;
    return $a35af0f53d067c81$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $a35af0f53d067c81$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $a35af0f53d067c81$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a35af0f53d067c81$var$ab(a, b) {
    b = b.checked;
    null != b && $a35af0f53d067c81$var$ta(a, "checked", b, !1);
}
function $a35af0f53d067c81$var$bb(a, b) {
    $a35af0f53d067c81$var$ab(a, b);
    var c = $a35af0f53d067c81$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $a35af0f53d067c81$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $a35af0f53d067c81$var$cb(a, b.type, $a35af0f53d067c81$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $a35af0f53d067c81$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $a35af0f53d067c81$var$cb(a, b, c) {
    if ("number" !== b || $a35af0f53d067c81$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $a35af0f53d067c81$var$eb = Array.isArray;
function $a35af0f53d067c81$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $a35af0f53d067c81$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $a35af0f53d067c81$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($a35af0f53d067c81$var$p(91));
    return $a35af0f53d067c81$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $a35af0f53d067c81$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($a35af0f53d067c81$var$p(92));
            if ($a35af0f53d067c81$var$eb(c)) {
                if (1 < c.length) throw Error($a35af0f53d067c81$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $a35af0f53d067c81$var$Sa(c)
    };
}
function $a35af0f53d067c81$var$ib(a, b) {
    var c = $a35af0f53d067c81$var$Sa(b.value), d = $a35af0f53d067c81$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $a35af0f53d067c81$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $a35af0f53d067c81$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $a35af0f53d067c81$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $a35af0f53d067c81$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $a35af0f53d067c81$var$mb, $a35af0f53d067c81$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $a35af0f53d067c81$var$mb = $a35af0f53d067c81$var$mb || document.createElement("div");
        $a35af0f53d067c81$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $a35af0f53d067c81$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $a35af0f53d067c81$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $a35af0f53d067c81$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a35af0f53d067c81$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a35af0f53d067c81$var$pb).forEach(function(a) {
    $a35af0f53d067c81$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a35af0f53d067c81$var$pb[b] = $a35af0f53d067c81$var$pb[a];
    });
});
function $a35af0f53d067c81$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $a35af0f53d067c81$var$pb.hasOwnProperty(a) && $a35af0f53d067c81$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $a35af0f53d067c81$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $a35af0f53d067c81$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $a35af0f53d067c81$var$tb = $a35af0f53d067c81$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $a35af0f53d067c81$var$ub(a, b) {
    if (b) {
        if ($a35af0f53d067c81$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($a35af0f53d067c81$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($a35af0f53d067c81$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($a35af0f53d067c81$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($a35af0f53d067c81$var$p(62));
    }
}
function $a35af0f53d067c81$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a35af0f53d067c81$var$wb = null;
function $a35af0f53d067c81$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $a35af0f53d067c81$var$yb = null, $a35af0f53d067c81$var$zb = null, $a35af0f53d067c81$var$Ab = null;
function $a35af0f53d067c81$var$Bb(a) {
    if (a = $a35af0f53d067c81$var$Cb(a)) {
        if ("function" !== typeof $a35af0f53d067c81$var$yb) throw Error($a35af0f53d067c81$var$p(280));
        var b = a.stateNode;
        b && (b = $a35af0f53d067c81$var$Db(b), $a35af0f53d067c81$var$yb(a.stateNode, a.type, b));
    }
}
function $a35af0f53d067c81$var$Eb(a) {
    $a35af0f53d067c81$var$zb ? $a35af0f53d067c81$var$Ab ? $a35af0f53d067c81$var$Ab.push(a) : $a35af0f53d067c81$var$Ab = [
        a
    ] : $a35af0f53d067c81$var$zb = a;
}
function $a35af0f53d067c81$var$Fb() {
    if ($a35af0f53d067c81$var$zb) {
        var a = $a35af0f53d067c81$var$zb, b = $a35af0f53d067c81$var$Ab;
        $a35af0f53d067c81$var$Ab = $a35af0f53d067c81$var$zb = null;
        $a35af0f53d067c81$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$a35af0f53d067c81$var$Bb(b[a]);
    }
}
function $a35af0f53d067c81$var$Gb(a, b) {
    return a(b);
}
function $a35af0f53d067c81$var$Hb() {}
var $a35af0f53d067c81$var$Ib = !1;
function $a35af0f53d067c81$var$Jb(a, b, c) {
    if ($a35af0f53d067c81$var$Ib) return a(b, c);
    $a35af0f53d067c81$var$Ib = !0;
    try {
        return $a35af0f53d067c81$var$Gb(a, b, c);
    } finally{
        if ($a35af0f53d067c81$var$Ib = !1, null !== $a35af0f53d067c81$var$zb || null !== $a35af0f53d067c81$var$Ab) $a35af0f53d067c81$var$Hb(), $a35af0f53d067c81$var$Fb();
    }
}
function $a35af0f53d067c81$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $a35af0f53d067c81$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($a35af0f53d067c81$var$p(231, b, typeof c));
    return c;
}
var $a35af0f53d067c81$var$Lb = !1;
if ($a35af0f53d067c81$var$ia) try {
    var $a35af0f53d067c81$var$Mb = {};
    Object.defineProperty($a35af0f53d067c81$var$Mb, "passive", {
        get: function() {
            $a35af0f53d067c81$var$Lb = !0;
        }
    });
    window.addEventListener("test", $a35af0f53d067c81$var$Mb, $a35af0f53d067c81$var$Mb);
    window.removeEventListener("test", $a35af0f53d067c81$var$Mb, $a35af0f53d067c81$var$Mb);
} catch (a) {
    $a35af0f53d067c81$var$Lb = !1;
}
function $a35af0f53d067c81$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $a35af0f53d067c81$var$Ob = !1, $a35af0f53d067c81$var$Pb = null, $a35af0f53d067c81$var$Qb = !1, $a35af0f53d067c81$var$Rb = null, $a35af0f53d067c81$var$Sb = {
    onError: function(a) {
        $a35af0f53d067c81$var$Ob = !0;
        $a35af0f53d067c81$var$Pb = a;
    }
};
function $a35af0f53d067c81$var$Tb(a, b, c, d, e, f, g, h, k) {
    $a35af0f53d067c81$var$Ob = !1;
    $a35af0f53d067c81$var$Pb = null;
    $a35af0f53d067c81$var$Nb.apply($a35af0f53d067c81$var$Sb, arguments);
}
function $a35af0f53d067c81$var$Ub(a, b, c, d, e, f, g, h, k) {
    $a35af0f53d067c81$var$Tb.apply(this, arguments);
    if ($a35af0f53d067c81$var$Ob) {
        if ($a35af0f53d067c81$var$Ob) {
            var l = $a35af0f53d067c81$var$Pb;
            $a35af0f53d067c81$var$Ob = !1;
            $a35af0f53d067c81$var$Pb = null;
        } else throw Error($a35af0f53d067c81$var$p(198));
        $a35af0f53d067c81$var$Qb || ($a35af0f53d067c81$var$Qb = !0, $a35af0f53d067c81$var$Rb = l);
    }
}
function $a35af0f53d067c81$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $a35af0f53d067c81$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $a35af0f53d067c81$var$Xb(a) {
    if ($a35af0f53d067c81$var$Vb(a) !== a) throw Error($a35af0f53d067c81$var$p(188));
}
function $a35af0f53d067c81$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $a35af0f53d067c81$var$Vb(a);
        if (null === b) throw Error($a35af0f53d067c81$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $a35af0f53d067c81$var$Xb(e), a;
                if (f === d) return $a35af0f53d067c81$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($a35af0f53d067c81$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($a35af0f53d067c81$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($a35af0f53d067c81$var$p(190));
    }
    if (3 !== c.tag) throw Error($a35af0f53d067c81$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $a35af0f53d067c81$var$Zb(a) {
    a = $a35af0f53d067c81$var$Yb(a);
    return null !== a ? $a35af0f53d067c81$var$$b(a) : null;
}
function $a35af0f53d067c81$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $a35af0f53d067c81$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $a35af0f53d067c81$var$ac = $fB1dE.unstable_scheduleCallback, $a35af0f53d067c81$var$bc = $fB1dE.unstable_cancelCallback, $a35af0f53d067c81$var$cc = $fB1dE.unstable_shouldYield, $a35af0f53d067c81$var$dc = $fB1dE.unstable_requestPaint, $a35af0f53d067c81$var$B = $fB1dE.unstable_now, $a35af0f53d067c81$var$ec = $fB1dE.unstable_getCurrentPriorityLevel, $a35af0f53d067c81$var$fc = $fB1dE.unstable_ImmediatePriority, $a35af0f53d067c81$var$gc = $fB1dE.unstable_UserBlockingPriority, $a35af0f53d067c81$var$hc = $fB1dE.unstable_NormalPriority, $a35af0f53d067c81$var$ic = $fB1dE.unstable_LowPriority, $a35af0f53d067c81$var$jc = $fB1dE.unstable_IdlePriority, $a35af0f53d067c81$var$kc = null, $a35af0f53d067c81$var$lc = null;
function $a35af0f53d067c81$var$mc(a) {
    if ($a35af0f53d067c81$var$lc && "function" === typeof $a35af0f53d067c81$var$lc.onCommitFiberRoot) try {
        $a35af0f53d067c81$var$lc.onCommitFiberRoot($a35af0f53d067c81$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $a35af0f53d067c81$var$oc = Math.clz32 ? Math.clz32 : $a35af0f53d067c81$var$nc, $a35af0f53d067c81$var$pc = Math.log, $a35af0f53d067c81$var$qc = Math.LN2;
function $a35af0f53d067c81$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a35af0f53d067c81$var$pc(a) / $a35af0f53d067c81$var$qc | 0) | 0;
}
var $a35af0f53d067c81$var$rc = 64, $a35af0f53d067c81$var$sc = 4194304;
function $a35af0f53d067c81$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $a35af0f53d067c81$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $a35af0f53d067c81$var$tc(h) : (f &= g, 0 !== f && (d = $a35af0f53d067c81$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $a35af0f53d067c81$var$tc(g) : 0 !== f && (d = $a35af0f53d067c81$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $a35af0f53d067c81$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $a35af0f53d067c81$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a35af0f53d067c81$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $a35af0f53d067c81$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $a35af0f53d067c81$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $a35af0f53d067c81$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $a35af0f53d067c81$var$yc() {
    var a = $a35af0f53d067c81$var$rc;
    $a35af0f53d067c81$var$rc <<= 1;
    0 === ($a35af0f53d067c81$var$rc & 4194240) && ($a35af0f53d067c81$var$rc = 64);
    return a;
}
function $a35af0f53d067c81$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $a35af0f53d067c81$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $a35af0f53d067c81$var$oc(b);
    a[b] = c;
}
function $a35af0f53d067c81$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $a35af0f53d067c81$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $a35af0f53d067c81$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $a35af0f53d067c81$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $a35af0f53d067c81$var$C = 0;
function $a35af0f53d067c81$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $a35af0f53d067c81$var$Ec, $a35af0f53d067c81$var$Fc, $a35af0f53d067c81$var$Gc, $a35af0f53d067c81$var$Hc, $a35af0f53d067c81$var$Ic, $a35af0f53d067c81$var$Jc = !1, $a35af0f53d067c81$var$Kc = [], $a35af0f53d067c81$var$Lc = null, $a35af0f53d067c81$var$Mc = null, $a35af0f53d067c81$var$Nc = null, $a35af0f53d067c81$var$Oc = new Map, $a35af0f53d067c81$var$Pc = new Map, $a35af0f53d067c81$var$Qc = [], $a35af0f53d067c81$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $a35af0f53d067c81$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $a35af0f53d067c81$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $a35af0f53d067c81$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $a35af0f53d067c81$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $a35af0f53d067c81$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a35af0f53d067c81$var$Pc.delete(b.pointerId);
    }
}
function $a35af0f53d067c81$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $a35af0f53d067c81$var$Cb(b), null !== b && $a35af0f53d067c81$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $a35af0f53d067c81$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $a35af0f53d067c81$var$Lc = $a35af0f53d067c81$var$Tc($a35af0f53d067c81$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $a35af0f53d067c81$var$Mc = $a35af0f53d067c81$var$Tc($a35af0f53d067c81$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $a35af0f53d067c81$var$Nc = $a35af0f53d067c81$var$Tc($a35af0f53d067c81$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $a35af0f53d067c81$var$Oc.set(f, $a35af0f53d067c81$var$Tc($a35af0f53d067c81$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $a35af0f53d067c81$var$Pc.set(f, $a35af0f53d067c81$var$Tc($a35af0f53d067c81$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $a35af0f53d067c81$var$Vc(a) {
    var b = $a35af0f53d067c81$var$Wc(a.target);
    if (null !== b) {
        var c = $a35af0f53d067c81$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $a35af0f53d067c81$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $a35af0f53d067c81$var$Ic(a.priority, function() {
                        $a35af0f53d067c81$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $a35af0f53d067c81$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $a35af0f53d067c81$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $a35af0f53d067c81$var$wb = d;
            c.target.dispatchEvent(d);
            $a35af0f53d067c81$var$wb = null;
        } else return b = $a35af0f53d067c81$var$Cb(c), null !== b && $a35af0f53d067c81$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $a35af0f53d067c81$var$Zc(a, b, c) {
    $a35af0f53d067c81$var$Xc(a) && c.delete(b);
}
function $a35af0f53d067c81$var$$c() {
    $a35af0f53d067c81$var$Jc = !1;
    null !== $a35af0f53d067c81$var$Lc && $a35af0f53d067c81$var$Xc($a35af0f53d067c81$var$Lc) && ($a35af0f53d067c81$var$Lc = null);
    null !== $a35af0f53d067c81$var$Mc && $a35af0f53d067c81$var$Xc($a35af0f53d067c81$var$Mc) && ($a35af0f53d067c81$var$Mc = null);
    null !== $a35af0f53d067c81$var$Nc && $a35af0f53d067c81$var$Xc($a35af0f53d067c81$var$Nc) && ($a35af0f53d067c81$var$Nc = null);
    $a35af0f53d067c81$var$Oc.forEach($a35af0f53d067c81$var$Zc);
    $a35af0f53d067c81$var$Pc.forEach($a35af0f53d067c81$var$Zc);
}
function $a35af0f53d067c81$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $a35af0f53d067c81$var$Jc || ($a35af0f53d067c81$var$Jc = !0, $fB1dE.unstable_scheduleCallback($fB1dE.unstable_NormalPriority, $a35af0f53d067c81$var$$c)));
}
function $a35af0f53d067c81$var$bd(a) {
    function b(b) {
        return $a35af0f53d067c81$var$ad(b, a);
    }
    if (0 < $a35af0f53d067c81$var$Kc.length) {
        $a35af0f53d067c81$var$ad($a35af0f53d067c81$var$Kc[0], a);
        for(var c = 1; c < $a35af0f53d067c81$var$Kc.length; c++){
            var d = $a35af0f53d067c81$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $a35af0f53d067c81$var$Lc && $a35af0f53d067c81$var$ad($a35af0f53d067c81$var$Lc, a);
    null !== $a35af0f53d067c81$var$Mc && $a35af0f53d067c81$var$ad($a35af0f53d067c81$var$Mc, a);
    null !== $a35af0f53d067c81$var$Nc && $a35af0f53d067c81$var$ad($a35af0f53d067c81$var$Nc, a);
    $a35af0f53d067c81$var$Oc.forEach(b);
    $a35af0f53d067c81$var$Pc.forEach(b);
    for(c = 0; c < $a35af0f53d067c81$var$Qc.length; c++)d = $a35af0f53d067c81$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $a35af0f53d067c81$var$Qc.length && (c = $a35af0f53d067c81$var$Qc[0], null === c.blockedOn);)$a35af0f53d067c81$var$Vc(c), null === c.blockedOn && $a35af0f53d067c81$var$Qc.shift();
}
var $a35af0f53d067c81$var$cd = $a35af0f53d067c81$var$ua.ReactCurrentBatchConfig, $a35af0f53d067c81$var$dd = !0;
function $a35af0f53d067c81$var$ed(a, b, c, d) {
    var e = $a35af0f53d067c81$var$C, f = $a35af0f53d067c81$var$cd.transition;
    $a35af0f53d067c81$var$cd.transition = null;
    try {
        $a35af0f53d067c81$var$C = 1, $a35af0f53d067c81$var$fd(a, b, c, d);
    } finally{
        $a35af0f53d067c81$var$C = e, $a35af0f53d067c81$var$cd.transition = f;
    }
}
function $a35af0f53d067c81$var$gd(a, b, c, d) {
    var e = $a35af0f53d067c81$var$C, f = $a35af0f53d067c81$var$cd.transition;
    $a35af0f53d067c81$var$cd.transition = null;
    try {
        $a35af0f53d067c81$var$C = 4, $a35af0f53d067c81$var$fd(a, b, c, d);
    } finally{
        $a35af0f53d067c81$var$C = e, $a35af0f53d067c81$var$cd.transition = f;
    }
}
function $a35af0f53d067c81$var$fd(a, b, c, d) {
    if ($a35af0f53d067c81$var$dd) {
        var e = $a35af0f53d067c81$var$Yc(a, b, c, d);
        if (null === e) $a35af0f53d067c81$var$hd(a, b, d, $a35af0f53d067c81$var$id, c), $a35af0f53d067c81$var$Sc(a, d);
        else if ($a35af0f53d067c81$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($a35af0f53d067c81$var$Sc(a, d), b & 4 && -1 < $a35af0f53d067c81$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $a35af0f53d067c81$var$Cb(e);
                null !== f && $a35af0f53d067c81$var$Ec(f);
                f = $a35af0f53d067c81$var$Yc(a, b, c, d);
                null === f && $a35af0f53d067c81$var$hd(a, b, d, $a35af0f53d067c81$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $a35af0f53d067c81$var$hd(a, b, d, null, c);
    }
}
var $a35af0f53d067c81$var$id = null;
function $a35af0f53d067c81$var$Yc(a, b, c, d) {
    $a35af0f53d067c81$var$id = null;
    a = $a35af0f53d067c81$var$xb(d);
    a = $a35af0f53d067c81$var$Wc(a);
    if (null !== a) {
        if (b = $a35af0f53d067c81$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $a35af0f53d067c81$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $a35af0f53d067c81$var$id = a;
    return null;
}
function $a35af0f53d067c81$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($a35af0f53d067c81$var$ec()){
                case $a35af0f53d067c81$var$fc:
                    return 1;
                case $a35af0f53d067c81$var$gc:
                    return 4;
                case $a35af0f53d067c81$var$hc:
                case $a35af0f53d067c81$var$ic:
                    return 16;
                case $a35af0f53d067c81$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $a35af0f53d067c81$var$kd = null, $a35af0f53d067c81$var$ld = null, $a35af0f53d067c81$var$md = null;
function $a35af0f53d067c81$var$nd() {
    if ($a35af0f53d067c81$var$md) return $a35af0f53d067c81$var$md;
    var a, b = $a35af0f53d067c81$var$ld, c = b.length, d, e = "value" in $a35af0f53d067c81$var$kd ? $a35af0f53d067c81$var$kd.value : $a35af0f53d067c81$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $a35af0f53d067c81$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $a35af0f53d067c81$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $a35af0f53d067c81$var$pd() {
    return !0;
}
function $a35af0f53d067c81$var$qd() {
    return !1;
}
function $a35af0f53d067c81$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $a35af0f53d067c81$var$pd : $a35af0f53d067c81$var$qd;
        this.isPropagationStopped = $a35af0f53d067c81$var$qd;
        return this;
    }
    $a35af0f53d067c81$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $a35af0f53d067c81$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $a35af0f53d067c81$var$pd);
        },
        persist: function() {},
        isPersistent: $a35af0f53d067c81$var$pd
    });
    return b;
}
var $a35af0f53d067c81$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a35af0f53d067c81$var$td = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$sd), $a35af0f53d067c81$var$ud = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$sd, {
    view: 0,
    detail: 0
}), $a35af0f53d067c81$var$vd = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$ud), $a35af0f53d067c81$var$wd, $a35af0f53d067c81$var$xd, $a35af0f53d067c81$var$yd, $a35af0f53d067c81$var$Ad = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a35af0f53d067c81$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $a35af0f53d067c81$var$yd && ($a35af0f53d067c81$var$yd && "mousemove" === a.type ? ($a35af0f53d067c81$var$wd = a.screenX - $a35af0f53d067c81$var$yd.screenX, $a35af0f53d067c81$var$xd = a.screenY - $a35af0f53d067c81$var$yd.screenY) : $a35af0f53d067c81$var$xd = $a35af0f53d067c81$var$wd = 0, $a35af0f53d067c81$var$yd = a);
        return $a35af0f53d067c81$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $a35af0f53d067c81$var$xd;
    }
}), $a35af0f53d067c81$var$Bd = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$Ad), $a35af0f53d067c81$var$Cd = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$Ad, {
    dataTransfer: 0
}), $a35af0f53d067c81$var$Dd = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$Cd), $a35af0f53d067c81$var$Ed = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$ud, {
    relatedTarget: 0
}), $a35af0f53d067c81$var$Fd = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$Ed), $a35af0f53d067c81$var$Gd = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a35af0f53d067c81$var$Hd = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$Gd), $a35af0f53d067c81$var$Id = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $a35af0f53d067c81$var$Jd = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$Id), $a35af0f53d067c81$var$Kd = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$sd, {
    data: 0
}), $a35af0f53d067c81$var$Ld = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$Kd), $a35af0f53d067c81$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a35af0f53d067c81$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a35af0f53d067c81$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a35af0f53d067c81$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $a35af0f53d067c81$var$Od[a]) ? !!b[a] : !1;
}
function $a35af0f53d067c81$var$zd() {
    return $a35af0f53d067c81$var$Pd;
}
var $a35af0f53d067c81$var$Qd = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $a35af0f53d067c81$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $a35af0f53d067c81$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $a35af0f53d067c81$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a35af0f53d067c81$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $a35af0f53d067c81$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $a35af0f53d067c81$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $a35af0f53d067c81$var$Rd = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$Qd), $a35af0f53d067c81$var$Sd = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a35af0f53d067c81$var$Td = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$Sd), $a35af0f53d067c81$var$Ud = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a35af0f53d067c81$var$zd
}), $a35af0f53d067c81$var$Vd = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$Ud), $a35af0f53d067c81$var$Wd = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a35af0f53d067c81$var$Xd = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$Wd), $a35af0f53d067c81$var$Yd = $a35af0f53d067c81$var$A({}, $a35af0f53d067c81$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a35af0f53d067c81$var$Zd = $a35af0f53d067c81$var$rd($a35af0f53d067c81$var$Yd), $a35af0f53d067c81$var$$d = [
    9,
    13,
    27,
    32
], $a35af0f53d067c81$var$ae = $a35af0f53d067c81$var$ia && "CompositionEvent" in window, $a35af0f53d067c81$var$be = null;
$a35af0f53d067c81$var$ia && "documentMode" in document && ($a35af0f53d067c81$var$be = document.documentMode);
var $a35af0f53d067c81$var$ce = $a35af0f53d067c81$var$ia && "TextEvent" in window && !$a35af0f53d067c81$var$be, $a35af0f53d067c81$var$de = $a35af0f53d067c81$var$ia && (!$a35af0f53d067c81$var$ae || $a35af0f53d067c81$var$be && 8 < $a35af0f53d067c81$var$be && 11 >= $a35af0f53d067c81$var$be), $a35af0f53d067c81$var$ee = String.fromCharCode(32), $a35af0f53d067c81$var$fe = !1;
function $a35af0f53d067c81$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $a35af0f53d067c81$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a35af0f53d067c81$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $a35af0f53d067c81$var$ie = !1;
function $a35af0f53d067c81$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $a35af0f53d067c81$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $a35af0f53d067c81$var$fe = !0;
            return $a35af0f53d067c81$var$ee;
        case "textInput":
            return a = b.data, a === $a35af0f53d067c81$var$ee && $a35af0f53d067c81$var$fe ? null : a;
        default:
            return null;
    }
}
function $a35af0f53d067c81$var$ke(a, b) {
    if ($a35af0f53d067c81$var$ie) return "compositionend" === a || !$a35af0f53d067c81$var$ae && $a35af0f53d067c81$var$ge(a, b) ? (a = $a35af0f53d067c81$var$nd(), $a35af0f53d067c81$var$md = $a35af0f53d067c81$var$ld = $a35af0f53d067c81$var$kd = null, $a35af0f53d067c81$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $a35af0f53d067c81$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $a35af0f53d067c81$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a35af0f53d067c81$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$a35af0f53d067c81$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $a35af0f53d067c81$var$ne(a, b, c, d) {
    $a35af0f53d067c81$var$Eb(d);
    b = $a35af0f53d067c81$var$oe(b, "onChange");
    0 < b.length && (c = new $a35af0f53d067c81$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $a35af0f53d067c81$var$pe = null, $a35af0f53d067c81$var$qe = null;
function $a35af0f53d067c81$var$re(a) {
    $a35af0f53d067c81$var$se(a, 0);
}
function $a35af0f53d067c81$var$te(a) {
    var b = $a35af0f53d067c81$var$ue(a);
    if ($a35af0f53d067c81$var$Wa(b)) return a;
}
function $a35af0f53d067c81$var$ve(a, b) {
    if ("change" === a) return b;
}
var $a35af0f53d067c81$var$we = !1;
if ($a35af0f53d067c81$var$ia) {
    var $a35af0f53d067c81$var$xe;
    if ($a35af0f53d067c81$var$ia) {
        var $a35af0f53d067c81$var$ye = "oninput" in document;
        if (!$a35af0f53d067c81$var$ye) {
            var $a35af0f53d067c81$var$ze = document.createElement("div");
            $a35af0f53d067c81$var$ze.setAttribute("oninput", "return;");
            $a35af0f53d067c81$var$ye = "function" === typeof $a35af0f53d067c81$var$ze.oninput;
        }
        $a35af0f53d067c81$var$xe = $a35af0f53d067c81$var$ye;
    } else $a35af0f53d067c81$var$xe = !1;
    $a35af0f53d067c81$var$we = $a35af0f53d067c81$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $a35af0f53d067c81$var$Ae() {
    $a35af0f53d067c81$var$pe && ($a35af0f53d067c81$var$pe.detachEvent("onpropertychange", $a35af0f53d067c81$var$Be), $a35af0f53d067c81$var$qe = $a35af0f53d067c81$var$pe = null);
}
function $a35af0f53d067c81$var$Be(a) {
    if ("value" === a.propertyName && $a35af0f53d067c81$var$te($a35af0f53d067c81$var$qe)) {
        var b = [];
        $a35af0f53d067c81$var$ne(b, $a35af0f53d067c81$var$qe, a, $a35af0f53d067c81$var$xb(a));
        $a35af0f53d067c81$var$Jb($a35af0f53d067c81$var$re, b);
    }
}
function $a35af0f53d067c81$var$Ce(a, b, c) {
    "focusin" === a ? ($a35af0f53d067c81$var$Ae(), $a35af0f53d067c81$var$pe = b, $a35af0f53d067c81$var$qe = c, $a35af0f53d067c81$var$pe.attachEvent("onpropertychange", $a35af0f53d067c81$var$Be)) : "focusout" === a && $a35af0f53d067c81$var$Ae();
}
function $a35af0f53d067c81$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $a35af0f53d067c81$var$te($a35af0f53d067c81$var$qe);
}
function $a35af0f53d067c81$var$Ee(a, b) {
    if ("click" === a) return $a35af0f53d067c81$var$te(b);
}
function $a35af0f53d067c81$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $a35af0f53d067c81$var$te(b);
}
function $a35af0f53d067c81$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a35af0f53d067c81$var$He = "function" === typeof Object.is ? Object.is : $a35af0f53d067c81$var$Ge;
function $a35af0f53d067c81$var$Ie(a, b) {
    if ($a35af0f53d067c81$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$a35af0f53d067c81$var$ja.call(b, e) || !$a35af0f53d067c81$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $a35af0f53d067c81$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $a35af0f53d067c81$var$Ke(a, b) {
    var c = $a35af0f53d067c81$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $a35af0f53d067c81$var$Je(c);
    }
}
function $a35af0f53d067c81$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $a35af0f53d067c81$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $a35af0f53d067c81$var$Me() {
    for(var a = window, b = $a35af0f53d067c81$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $a35af0f53d067c81$var$Xa(a.document);
    }
    return b;
}
function $a35af0f53d067c81$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $a35af0f53d067c81$var$Oe(a) {
    var b = $a35af0f53d067c81$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $a35af0f53d067c81$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $a35af0f53d067c81$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $a35af0f53d067c81$var$Ke(c, f);
                var g = $a35af0f53d067c81$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $a35af0f53d067c81$var$Pe = $a35af0f53d067c81$var$ia && "documentMode" in document && 11 >= document.documentMode, $a35af0f53d067c81$var$Qe = null, $a35af0f53d067c81$var$Re = null, $a35af0f53d067c81$var$Se = null, $a35af0f53d067c81$var$Te = !1;
function $a35af0f53d067c81$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $a35af0f53d067c81$var$Te || null == $a35af0f53d067c81$var$Qe || $a35af0f53d067c81$var$Qe !== $a35af0f53d067c81$var$Xa(d) || (d = $a35af0f53d067c81$var$Qe, "selectionStart" in d && $a35af0f53d067c81$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $a35af0f53d067c81$var$Se && $a35af0f53d067c81$var$Ie($a35af0f53d067c81$var$Se, d) || ($a35af0f53d067c81$var$Se = d, d = $a35af0f53d067c81$var$oe($a35af0f53d067c81$var$Re, "onSelect"), 0 < d.length && (b = new $a35af0f53d067c81$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $a35af0f53d067c81$var$Qe)));
}
function $a35af0f53d067c81$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $a35af0f53d067c81$var$We = {
    animationend: $a35af0f53d067c81$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $a35af0f53d067c81$var$Ve("Animation", "AnimationIteration"),
    animationstart: $a35af0f53d067c81$var$Ve("Animation", "AnimationStart"),
    transitionend: $a35af0f53d067c81$var$Ve("Transition", "TransitionEnd")
}, $a35af0f53d067c81$var$Xe = {}, $a35af0f53d067c81$var$Ye = {};
$a35af0f53d067c81$var$ia && ($a35af0f53d067c81$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $a35af0f53d067c81$var$We.animationend.animation, delete $a35af0f53d067c81$var$We.animationiteration.animation, delete $a35af0f53d067c81$var$We.animationstart.animation), "TransitionEvent" in window || delete $a35af0f53d067c81$var$We.transitionend.transition);
function $a35af0f53d067c81$var$Ze(a) {
    if ($a35af0f53d067c81$var$Xe[a]) return $a35af0f53d067c81$var$Xe[a];
    if (!$a35af0f53d067c81$var$We[a]) return a;
    var b = $a35af0f53d067c81$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $a35af0f53d067c81$var$Ye) return $a35af0f53d067c81$var$Xe[a] = b[c];
    return a;
}
var $a35af0f53d067c81$var$$e = $a35af0f53d067c81$var$Ze("animationend"), $a35af0f53d067c81$var$af = $a35af0f53d067c81$var$Ze("animationiteration"), $a35af0f53d067c81$var$bf = $a35af0f53d067c81$var$Ze("animationstart"), $a35af0f53d067c81$var$cf = $a35af0f53d067c81$var$Ze("transitionend"), $a35af0f53d067c81$var$df = new Map, $a35af0f53d067c81$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $a35af0f53d067c81$var$ff(a, b) {
    $a35af0f53d067c81$var$df.set(a, b);
    $a35af0f53d067c81$var$fa(b, [
        a
    ]);
}
for(var $a35af0f53d067c81$var$gf = 0; $a35af0f53d067c81$var$gf < $a35af0f53d067c81$var$ef.length; $a35af0f53d067c81$var$gf++){
    var $a35af0f53d067c81$var$hf = $a35af0f53d067c81$var$ef[$a35af0f53d067c81$var$gf], $a35af0f53d067c81$var$jf = $a35af0f53d067c81$var$hf.toLowerCase(), $a35af0f53d067c81$var$kf = $a35af0f53d067c81$var$hf[0].toUpperCase() + $a35af0f53d067c81$var$hf.slice(1);
    $a35af0f53d067c81$var$ff($a35af0f53d067c81$var$jf, "on" + $a35af0f53d067c81$var$kf);
}
$a35af0f53d067c81$var$ff($a35af0f53d067c81$var$$e, "onAnimationEnd");
$a35af0f53d067c81$var$ff($a35af0f53d067c81$var$af, "onAnimationIteration");
$a35af0f53d067c81$var$ff($a35af0f53d067c81$var$bf, "onAnimationStart");
$a35af0f53d067c81$var$ff("dblclick", "onDoubleClick");
$a35af0f53d067c81$var$ff("focusin", "onFocus");
$a35af0f53d067c81$var$ff("focusout", "onBlur");
$a35af0f53d067c81$var$ff($a35af0f53d067c81$var$cf, "onTransitionEnd");
$a35af0f53d067c81$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a35af0f53d067c81$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a35af0f53d067c81$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a35af0f53d067c81$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a35af0f53d067c81$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a35af0f53d067c81$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a35af0f53d067c81$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a35af0f53d067c81$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a35af0f53d067c81$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a35af0f53d067c81$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a35af0f53d067c81$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a35af0f53d067c81$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($a35af0f53d067c81$var$lf));
function $a35af0f53d067c81$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $a35af0f53d067c81$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $a35af0f53d067c81$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a35af0f53d067c81$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a35af0f53d067c81$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($a35af0f53d067c81$var$Qb) throw a = $a35af0f53d067c81$var$Rb, $a35af0f53d067c81$var$Qb = !1, $a35af0f53d067c81$var$Rb = null, a;
}
function $a35af0f53d067c81$var$D(a, b) {
    var c = b[$a35af0f53d067c81$var$of];
    void 0 === c && (c = b[$a35af0f53d067c81$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($a35af0f53d067c81$var$pf(b, a, 2, !1), c.add(d));
}
function $a35af0f53d067c81$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $a35af0f53d067c81$var$pf(c, a, d, b);
}
var $a35af0f53d067c81$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $a35af0f53d067c81$var$sf(a) {
    if (!a[$a35af0f53d067c81$var$rf]) {
        a[$a35af0f53d067c81$var$rf] = !0;
        $a35af0f53d067c81$var$da.forEach(function(b) {
            "selectionchange" !== b && ($a35af0f53d067c81$var$mf.has(b) || $a35af0f53d067c81$var$qf(b, !1, a), $a35af0f53d067c81$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$a35af0f53d067c81$var$rf] || (b[$a35af0f53d067c81$var$rf] = !0, $a35af0f53d067c81$var$qf("selectionchange", !1, b));
    }
}
function $a35af0f53d067c81$var$pf(a, b, c, d) {
    switch($a35af0f53d067c81$var$jd(b)){
        case 1:
            var e = $a35af0f53d067c81$var$ed;
            break;
        case 4:
            e = $a35af0f53d067c81$var$gd;
            break;
        default:
            e = $a35af0f53d067c81$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$a35af0f53d067c81$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $a35af0f53d067c81$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $a35af0f53d067c81$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $a35af0f53d067c81$var$Jb(function() {
        var d = f, e = $a35af0f53d067c81$var$xb(c), g = [];
        a: {
            var h = $a35af0f53d067c81$var$df.get(a);
            if (void 0 !== h) {
                var k = $a35af0f53d067c81$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $a35af0f53d067c81$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $a35af0f53d067c81$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $a35af0f53d067c81$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $a35af0f53d067c81$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $a35af0f53d067c81$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $a35af0f53d067c81$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $a35af0f53d067c81$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $a35af0f53d067c81$var$Vd;
                        break;
                    case $a35af0f53d067c81$var$$e:
                    case $a35af0f53d067c81$var$af:
                    case $a35af0f53d067c81$var$bf:
                        k = $a35af0f53d067c81$var$Hd;
                        break;
                    case $a35af0f53d067c81$var$cf:
                        k = $a35af0f53d067c81$var$Xd;
                        break;
                    case "scroll":
                        k = $a35af0f53d067c81$var$vd;
                        break;
                    case "wheel":
                        k = $a35af0f53d067c81$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $a35af0f53d067c81$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $a35af0f53d067c81$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $a35af0f53d067c81$var$Kb(w, x), null != F && t.push($a35af0f53d067c81$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $a35af0f53d067c81$var$wb && (n = c.relatedTarget || c.fromElement) && ($a35af0f53d067c81$var$Wc(n) || n[$a35af0f53d067c81$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $a35af0f53d067c81$var$Wc(n) : null, null !== n && (J = $a35af0f53d067c81$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $a35af0f53d067c81$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $a35af0f53d067c81$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $a35af0f53d067c81$var$ue(k);
                        u = null == n ? h : $a35af0f53d067c81$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $a35af0f53d067c81$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $a35af0f53d067c81$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $a35af0f53d067c81$var$vf(F))u++;
                            for(; 0 < w - u;)t = $a35af0f53d067c81$var$vf(t), w--;
                            for(; 0 < u - w;)x = $a35af0f53d067c81$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $a35af0f53d067c81$var$vf(t);
                                x = $a35af0f53d067c81$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $a35af0f53d067c81$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $a35af0f53d067c81$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $a35af0f53d067c81$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $a35af0f53d067c81$var$ve;
                else if ($a35af0f53d067c81$var$me(h)) {
                    if ($a35af0f53d067c81$var$we) na = $a35af0f53d067c81$var$Fe;
                    else {
                        na = $a35af0f53d067c81$var$De;
                        var xa = $a35af0f53d067c81$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $a35af0f53d067c81$var$Ee);
                if (na && (na = na(a, d))) {
                    $a35af0f53d067c81$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $a35af0f53d067c81$var$cb(h, "number", h.value);
            }
            xa = d ? $a35af0f53d067c81$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($a35af0f53d067c81$var$me(xa) || "true" === xa.contentEditable) $a35af0f53d067c81$var$Qe = xa, $a35af0f53d067c81$var$Re = d, $a35af0f53d067c81$var$Se = null;
                    break;
                case "focusout":
                    $a35af0f53d067c81$var$Se = $a35af0f53d067c81$var$Re = $a35af0f53d067c81$var$Qe = null;
                    break;
                case "mousedown":
                    $a35af0f53d067c81$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a35af0f53d067c81$var$Te = !1;
                    $a35af0f53d067c81$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($a35af0f53d067c81$var$Pe) break;
                case "keydown":
                case "keyup":
                    $a35af0f53d067c81$var$Ue(g, c, e);
            }
            var $a;
            if ($a35af0f53d067c81$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $a35af0f53d067c81$var$ie ? $a35af0f53d067c81$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($a35af0f53d067c81$var$de && "ko" !== c.locale && ($a35af0f53d067c81$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $a35af0f53d067c81$var$ie && ($a = $a35af0f53d067c81$var$nd()) : ($a35af0f53d067c81$var$kd = e, $a35af0f53d067c81$var$ld = "value" in $a35af0f53d067c81$var$kd ? $a35af0f53d067c81$var$kd.value : $a35af0f53d067c81$var$kd.textContent, $a35af0f53d067c81$var$ie = !0)), xa = $a35af0f53d067c81$var$oe(d, ba), 0 < xa.length && (ba = new $a35af0f53d067c81$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $a35af0f53d067c81$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $a35af0f53d067c81$var$ce ? $a35af0f53d067c81$var$je(a, c) : $a35af0f53d067c81$var$ke(a, c)) d = $a35af0f53d067c81$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $a35af0f53d067c81$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $a35af0f53d067c81$var$se(g, b);
    });
}
function $a35af0f53d067c81$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $a35af0f53d067c81$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $a35af0f53d067c81$var$Kb(a, c), null != f && d.unshift($a35af0f53d067c81$var$tf(a, f, e)), f = $a35af0f53d067c81$var$Kb(a, b), null != f && d.push($a35af0f53d067c81$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $a35af0f53d067c81$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $a35af0f53d067c81$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $a35af0f53d067c81$var$Kb(c, f), null != k && g.unshift($a35af0f53d067c81$var$tf(c, k, h))) : e || (k = $a35af0f53d067c81$var$Kb(c, f), null != k && g.push($a35af0f53d067c81$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $a35af0f53d067c81$var$xf = /\r\n?/g, $a35af0f53d067c81$var$yf = /\u0000|\uFFFD/g;
function $a35af0f53d067c81$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($a35af0f53d067c81$var$xf, "\n").replace($a35af0f53d067c81$var$yf, "");
}
function $a35af0f53d067c81$var$Af(a, b, c) {
    b = $a35af0f53d067c81$var$zf(b);
    if ($a35af0f53d067c81$var$zf(a) !== b && c) throw Error($a35af0f53d067c81$var$p(425));
}
function $a35af0f53d067c81$var$Bf() {}
var $a35af0f53d067c81$var$Cf = null, $a35af0f53d067c81$var$Df = null;
function $a35af0f53d067c81$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $a35af0f53d067c81$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $a35af0f53d067c81$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $a35af0f53d067c81$var$Hf = "function" === typeof Promise ? Promise : void 0, $a35af0f53d067c81$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a35af0f53d067c81$var$Hf ? function(a) {
    return $a35af0f53d067c81$var$Hf.resolve(null).then(a).catch($a35af0f53d067c81$var$If);
} : $a35af0f53d067c81$var$Ff;
function $a35af0f53d067c81$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $a35af0f53d067c81$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $a35af0f53d067c81$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $a35af0f53d067c81$var$bd(b);
}
function $a35af0f53d067c81$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $a35af0f53d067c81$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $a35af0f53d067c81$var$Nf = Math.random().toString(36).slice(2), $a35af0f53d067c81$var$Of = "__reactFiber$" + $a35af0f53d067c81$var$Nf, $a35af0f53d067c81$var$Pf = "__reactProps$" + $a35af0f53d067c81$var$Nf, $a35af0f53d067c81$var$uf = "__reactContainer$" + $a35af0f53d067c81$var$Nf, $a35af0f53d067c81$var$of = "__reactEvents$" + $a35af0f53d067c81$var$Nf, $a35af0f53d067c81$var$Qf = "__reactListeners$" + $a35af0f53d067c81$var$Nf, $a35af0f53d067c81$var$Rf = "__reactHandles$" + $a35af0f53d067c81$var$Nf;
function $a35af0f53d067c81$var$Wc(a) {
    var b = a[$a35af0f53d067c81$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$a35af0f53d067c81$var$uf] || c[$a35af0f53d067c81$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $a35af0f53d067c81$var$Mf(a); null !== a;){
                if (c = a[$a35af0f53d067c81$var$Of]) return c;
                a = $a35af0f53d067c81$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $a35af0f53d067c81$var$Cb(a) {
    a = a[$a35af0f53d067c81$var$Of] || a[$a35af0f53d067c81$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $a35af0f53d067c81$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($a35af0f53d067c81$var$p(33));
}
function $a35af0f53d067c81$var$Db(a) {
    return a[$a35af0f53d067c81$var$Pf] || null;
}
var $a35af0f53d067c81$var$Sf = [], $a35af0f53d067c81$var$Tf = -1;
function $a35af0f53d067c81$var$Uf(a) {
    return {
        current: a
    };
}
function $a35af0f53d067c81$var$E(a) {
    0 > $a35af0f53d067c81$var$Tf || (a.current = $a35af0f53d067c81$var$Sf[$a35af0f53d067c81$var$Tf], $a35af0f53d067c81$var$Sf[$a35af0f53d067c81$var$Tf] = null, $a35af0f53d067c81$var$Tf--);
}
function $a35af0f53d067c81$var$G(a, b) {
    $a35af0f53d067c81$var$Tf++;
    $a35af0f53d067c81$var$Sf[$a35af0f53d067c81$var$Tf] = a.current;
    a.current = b;
}
var $a35af0f53d067c81$var$Vf = {}, $a35af0f53d067c81$var$H = $a35af0f53d067c81$var$Uf($a35af0f53d067c81$var$Vf), $a35af0f53d067c81$var$Wf = $a35af0f53d067c81$var$Uf(!1), $a35af0f53d067c81$var$Xf = $a35af0f53d067c81$var$Vf;
function $a35af0f53d067c81$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $a35af0f53d067c81$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $a35af0f53d067c81$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $a35af0f53d067c81$var$$f() {
    $a35af0f53d067c81$var$E($a35af0f53d067c81$var$Wf);
    $a35af0f53d067c81$var$E($a35af0f53d067c81$var$H);
}
function $a35af0f53d067c81$var$ag(a, b, c) {
    if ($a35af0f53d067c81$var$H.current !== $a35af0f53d067c81$var$Vf) throw Error($a35af0f53d067c81$var$p(168));
    $a35af0f53d067c81$var$G($a35af0f53d067c81$var$H, b);
    $a35af0f53d067c81$var$G($a35af0f53d067c81$var$Wf, c);
}
function $a35af0f53d067c81$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($a35af0f53d067c81$var$p(108, $a35af0f53d067c81$var$Ra(a) || "Unknown", e));
    return $a35af0f53d067c81$var$A({}, c, d);
}
function $a35af0f53d067c81$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $a35af0f53d067c81$var$Vf;
    $a35af0f53d067c81$var$Xf = $a35af0f53d067c81$var$H.current;
    $a35af0f53d067c81$var$G($a35af0f53d067c81$var$H, a);
    $a35af0f53d067c81$var$G($a35af0f53d067c81$var$Wf, $a35af0f53d067c81$var$Wf.current);
    return !0;
}
function $a35af0f53d067c81$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($a35af0f53d067c81$var$p(169));
    c ? (a = $a35af0f53d067c81$var$bg(a, b, $a35af0f53d067c81$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $a35af0f53d067c81$var$E($a35af0f53d067c81$var$Wf), $a35af0f53d067c81$var$E($a35af0f53d067c81$var$H), $a35af0f53d067c81$var$G($a35af0f53d067c81$var$H, a)) : $a35af0f53d067c81$var$E($a35af0f53d067c81$var$Wf);
    $a35af0f53d067c81$var$G($a35af0f53d067c81$var$Wf, c);
}
var $a35af0f53d067c81$var$eg = null, $a35af0f53d067c81$var$fg = !1, $a35af0f53d067c81$var$gg = !1;
function $a35af0f53d067c81$var$hg(a) {
    null === $a35af0f53d067c81$var$eg ? $a35af0f53d067c81$var$eg = [
        a
    ] : $a35af0f53d067c81$var$eg.push(a);
}
function $a35af0f53d067c81$var$ig(a) {
    $a35af0f53d067c81$var$fg = !0;
    $a35af0f53d067c81$var$hg(a);
}
function $a35af0f53d067c81$var$jg() {
    if (!$a35af0f53d067c81$var$gg && null !== $a35af0f53d067c81$var$eg) {
        $a35af0f53d067c81$var$gg = !0;
        var a = 0, b = $a35af0f53d067c81$var$C;
        try {
            var c = $a35af0f53d067c81$var$eg;
            for($a35af0f53d067c81$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $a35af0f53d067c81$var$eg = null;
            $a35af0f53d067c81$var$fg = !1;
        } catch (e) {
            throw null !== $a35af0f53d067c81$var$eg && ($a35af0f53d067c81$var$eg = $a35af0f53d067c81$var$eg.slice(a + 1)), $a35af0f53d067c81$var$ac($a35af0f53d067c81$var$fc, $a35af0f53d067c81$var$jg), e;
        } finally{
            $a35af0f53d067c81$var$C = b, $a35af0f53d067c81$var$gg = !1;
        }
    }
    return null;
}
var $a35af0f53d067c81$var$kg = [], $a35af0f53d067c81$var$lg = 0, $a35af0f53d067c81$var$mg = null, $a35af0f53d067c81$var$ng = 0, $a35af0f53d067c81$var$og = [], $a35af0f53d067c81$var$pg = 0, $a35af0f53d067c81$var$qg = null, $a35af0f53d067c81$var$rg = 1, $a35af0f53d067c81$var$sg = "";
function $a35af0f53d067c81$var$tg(a, b) {
    $a35af0f53d067c81$var$kg[$a35af0f53d067c81$var$lg++] = $a35af0f53d067c81$var$ng;
    $a35af0f53d067c81$var$kg[$a35af0f53d067c81$var$lg++] = $a35af0f53d067c81$var$mg;
    $a35af0f53d067c81$var$mg = a;
    $a35af0f53d067c81$var$ng = b;
}
function $a35af0f53d067c81$var$ug(a, b, c) {
    $a35af0f53d067c81$var$og[$a35af0f53d067c81$var$pg++] = $a35af0f53d067c81$var$rg;
    $a35af0f53d067c81$var$og[$a35af0f53d067c81$var$pg++] = $a35af0f53d067c81$var$sg;
    $a35af0f53d067c81$var$og[$a35af0f53d067c81$var$pg++] = $a35af0f53d067c81$var$qg;
    $a35af0f53d067c81$var$qg = a;
    var d = $a35af0f53d067c81$var$rg;
    a = $a35af0f53d067c81$var$sg;
    var e = 32 - $a35af0f53d067c81$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $a35af0f53d067c81$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $a35af0f53d067c81$var$rg = 1 << 32 - $a35af0f53d067c81$var$oc(b) + e | c << e | d;
        $a35af0f53d067c81$var$sg = f + a;
    } else $a35af0f53d067c81$var$rg = 1 << f | c << e | d, $a35af0f53d067c81$var$sg = a;
}
function $a35af0f53d067c81$var$vg(a) {
    null !== a.return && ($a35af0f53d067c81$var$tg(a, 1), $a35af0f53d067c81$var$ug(a, 1, 0));
}
function $a35af0f53d067c81$var$wg(a) {
    for(; a === $a35af0f53d067c81$var$mg;)$a35af0f53d067c81$var$mg = $a35af0f53d067c81$var$kg[--$a35af0f53d067c81$var$lg], $a35af0f53d067c81$var$kg[$a35af0f53d067c81$var$lg] = null, $a35af0f53d067c81$var$ng = $a35af0f53d067c81$var$kg[--$a35af0f53d067c81$var$lg], $a35af0f53d067c81$var$kg[$a35af0f53d067c81$var$lg] = null;
    for(; a === $a35af0f53d067c81$var$qg;)$a35af0f53d067c81$var$qg = $a35af0f53d067c81$var$og[--$a35af0f53d067c81$var$pg], $a35af0f53d067c81$var$og[$a35af0f53d067c81$var$pg] = null, $a35af0f53d067c81$var$sg = $a35af0f53d067c81$var$og[--$a35af0f53d067c81$var$pg], $a35af0f53d067c81$var$og[$a35af0f53d067c81$var$pg] = null, $a35af0f53d067c81$var$rg = $a35af0f53d067c81$var$og[--$a35af0f53d067c81$var$pg], $a35af0f53d067c81$var$og[$a35af0f53d067c81$var$pg] = null;
}
var $a35af0f53d067c81$var$xg = null, $a35af0f53d067c81$var$yg = null, $a35af0f53d067c81$var$I = !1, $a35af0f53d067c81$var$zg = null;
function $a35af0f53d067c81$var$Ag(a, b) {
    var c = $a35af0f53d067c81$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $a35af0f53d067c81$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $a35af0f53d067c81$var$xg = a, $a35af0f53d067c81$var$yg = $a35af0f53d067c81$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $a35af0f53d067c81$var$xg = a, $a35af0f53d067c81$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $a35af0f53d067c81$var$qg ? {
                id: $a35af0f53d067c81$var$rg,
                overflow: $a35af0f53d067c81$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $a35af0f53d067c81$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $a35af0f53d067c81$var$xg = a, $a35af0f53d067c81$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $a35af0f53d067c81$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $a35af0f53d067c81$var$Eg(a) {
    if ($a35af0f53d067c81$var$I) {
        var b = $a35af0f53d067c81$var$yg;
        if (b) {
            var c = b;
            if (!$a35af0f53d067c81$var$Cg(a, b)) {
                if ($a35af0f53d067c81$var$Dg(a)) throw Error($a35af0f53d067c81$var$p(418));
                b = $a35af0f53d067c81$var$Lf(c.nextSibling);
                var d = $a35af0f53d067c81$var$xg;
                b && $a35af0f53d067c81$var$Cg(a, b) ? $a35af0f53d067c81$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $a35af0f53d067c81$var$I = !1, $a35af0f53d067c81$var$xg = a);
            }
        } else {
            if ($a35af0f53d067c81$var$Dg(a)) throw Error($a35af0f53d067c81$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $a35af0f53d067c81$var$I = !1;
            $a35af0f53d067c81$var$xg = a;
        }
    }
}
function $a35af0f53d067c81$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $a35af0f53d067c81$var$xg = a;
}
function $a35af0f53d067c81$var$Gg(a) {
    if (a !== $a35af0f53d067c81$var$xg) return !1;
    if (!$a35af0f53d067c81$var$I) return $a35af0f53d067c81$var$Fg(a), $a35af0f53d067c81$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$a35af0f53d067c81$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $a35af0f53d067c81$var$yg)) {
        if ($a35af0f53d067c81$var$Dg(a)) throw $a35af0f53d067c81$var$Hg(), Error($a35af0f53d067c81$var$p(418));
        for(; b;)$a35af0f53d067c81$var$Ag(a, b), b = $a35af0f53d067c81$var$Lf(b.nextSibling);
    }
    $a35af0f53d067c81$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($a35af0f53d067c81$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $a35af0f53d067c81$var$yg = $a35af0f53d067c81$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $a35af0f53d067c81$var$yg = null;
        }
    } else $a35af0f53d067c81$var$yg = $a35af0f53d067c81$var$xg ? $a35af0f53d067c81$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $a35af0f53d067c81$var$Hg() {
    for(var a = $a35af0f53d067c81$var$yg; a;)a = $a35af0f53d067c81$var$Lf(a.nextSibling);
}
function $a35af0f53d067c81$var$Ig() {
    $a35af0f53d067c81$var$yg = $a35af0f53d067c81$var$xg = null;
    $a35af0f53d067c81$var$I = !1;
}
function $a35af0f53d067c81$var$Jg(a) {
    null === $a35af0f53d067c81$var$zg ? $a35af0f53d067c81$var$zg = [
        a
    ] : $a35af0f53d067c81$var$zg.push(a);
}
var $a35af0f53d067c81$var$Kg = $a35af0f53d067c81$var$ua.ReactCurrentBatchConfig;
function $a35af0f53d067c81$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($a35af0f53d067c81$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($a35af0f53d067c81$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($a35af0f53d067c81$var$p(284));
        if (!c._owner) throw Error($a35af0f53d067c81$var$p(290, a));
    }
    return a;
}
function $a35af0f53d067c81$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($a35af0f53d067c81$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $a35af0f53d067c81$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $a35af0f53d067c81$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $a35af0f53d067c81$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $a35af0f53d067c81$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $a35af0f53d067c81$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $a35af0f53d067c81$var$Ha && $a35af0f53d067c81$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $a35af0f53d067c81$var$Lg(a, b, c), d.return = a, d;
        d = $a35af0f53d067c81$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $a35af0f53d067c81$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $a35af0f53d067c81$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $a35af0f53d067c81$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $a35af0f53d067c81$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $a35af0f53d067c81$var$va:
                    return c = $a35af0f53d067c81$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $a35af0f53d067c81$var$Lg(a, null, b), c.return = a, c;
                case $a35af0f53d067c81$var$wa:
                    return b = $a35af0f53d067c81$var$Sg(b, a.mode, c), b.return = a, b;
                case $a35af0f53d067c81$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($a35af0f53d067c81$var$eb(b) || $a35af0f53d067c81$var$Ka(b)) return b = $a35af0f53d067c81$var$Tg(b, a.mode, c, null), b.return = a, b;
            $a35af0f53d067c81$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $a35af0f53d067c81$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $a35af0f53d067c81$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $a35af0f53d067c81$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($a35af0f53d067c81$var$eb(c) || $a35af0f53d067c81$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $a35af0f53d067c81$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $a35af0f53d067c81$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $a35af0f53d067c81$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $a35af0f53d067c81$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($a35af0f53d067c81$var$eb(d) || $a35af0f53d067c81$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $a35af0f53d067c81$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $a35af0f53d067c81$var$I && $a35af0f53d067c81$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $a35af0f53d067c81$var$I && $a35af0f53d067c81$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $a35af0f53d067c81$var$I && $a35af0f53d067c81$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $a35af0f53d067c81$var$Ka(h);
        if ("function" !== typeof l) throw Error($a35af0f53d067c81$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($a35af0f53d067c81$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $a35af0f53d067c81$var$I && $a35af0f53d067c81$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $a35af0f53d067c81$var$I && $a35af0f53d067c81$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $a35af0f53d067c81$var$I && $a35af0f53d067c81$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $a35af0f53d067c81$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $a35af0f53d067c81$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $a35af0f53d067c81$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $a35af0f53d067c81$var$Ha && $a35af0f53d067c81$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $a35af0f53d067c81$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $a35af0f53d067c81$var$ya ? (d = $a35af0f53d067c81$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $a35af0f53d067c81$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $a35af0f53d067c81$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $a35af0f53d067c81$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $a35af0f53d067c81$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $a35af0f53d067c81$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($a35af0f53d067c81$var$eb(f)) return n(a, d, f, h);
            if ($a35af0f53d067c81$var$Ka(f)) return t(a, d, f, h);
            $a35af0f53d067c81$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $a35af0f53d067c81$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $a35af0f53d067c81$var$Ug = $a35af0f53d067c81$var$Og(!0), $a35af0f53d067c81$var$Vg = $a35af0f53d067c81$var$Og(!1), $a35af0f53d067c81$var$Wg = $a35af0f53d067c81$var$Uf(null), $a35af0f53d067c81$var$Xg = null, $a35af0f53d067c81$var$Yg = null, $a35af0f53d067c81$var$Zg = null;
function $a35af0f53d067c81$var$$g() {
    $a35af0f53d067c81$var$Zg = $a35af0f53d067c81$var$Yg = $a35af0f53d067c81$var$Xg = null;
}
function $a35af0f53d067c81$var$ah(a) {
    var b = $a35af0f53d067c81$var$Wg.current;
    $a35af0f53d067c81$var$E($a35af0f53d067c81$var$Wg);
    a._currentValue = b;
}
function $a35af0f53d067c81$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $a35af0f53d067c81$var$ch(a, b) {
    $a35af0f53d067c81$var$Xg = a;
    $a35af0f53d067c81$var$Zg = $a35af0f53d067c81$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($a35af0f53d067c81$var$dh = !0), a.firstContext = null);
}
function $a35af0f53d067c81$var$eh(a) {
    var b = a._currentValue;
    if ($a35af0f53d067c81$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $a35af0f53d067c81$var$Yg) {
            if (null === $a35af0f53d067c81$var$Xg) throw Error($a35af0f53d067c81$var$p(308));
            $a35af0f53d067c81$var$Yg = a;
            $a35af0f53d067c81$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $a35af0f53d067c81$var$Yg = $a35af0f53d067c81$var$Yg.next = a;
    }
    return b;
}
var $a35af0f53d067c81$var$fh = null;
function $a35af0f53d067c81$var$gh(a) {
    null === $a35af0f53d067c81$var$fh ? $a35af0f53d067c81$var$fh = [
        a
    ] : $a35af0f53d067c81$var$fh.push(a);
}
function $a35af0f53d067c81$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $a35af0f53d067c81$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $a35af0f53d067c81$var$ih(a, d);
}
function $a35af0f53d067c81$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $a35af0f53d067c81$var$jh = !1;
function $a35af0f53d067c81$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $a35af0f53d067c81$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $a35af0f53d067c81$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a35af0f53d067c81$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($a35af0f53d067c81$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $a35af0f53d067c81$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $a35af0f53d067c81$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $a35af0f53d067c81$var$ih(a, c);
}
function $a35af0f53d067c81$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a35af0f53d067c81$var$Cc(a, c);
    }
}
function $a35af0f53d067c81$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $a35af0f53d067c81$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $a35af0f53d067c81$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $a35af0f53d067c81$var$A({}, q, r);
                            break a;
                        case 2:
                            $a35af0f53d067c81$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $a35af0f53d067c81$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $a35af0f53d067c81$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($a35af0f53d067c81$var$p(191, e));
            e.call(d);
        }
    }
}
var $a35af0f53d067c81$var$th = {}, $a35af0f53d067c81$var$uh = $a35af0f53d067c81$var$Uf($a35af0f53d067c81$var$th), $a35af0f53d067c81$var$vh = $a35af0f53d067c81$var$Uf($a35af0f53d067c81$var$th), $a35af0f53d067c81$var$wh = $a35af0f53d067c81$var$Uf($a35af0f53d067c81$var$th);
function $a35af0f53d067c81$var$xh(a) {
    if (a === $a35af0f53d067c81$var$th) throw Error($a35af0f53d067c81$var$p(174));
    return a;
}
function $a35af0f53d067c81$var$yh(a, b) {
    $a35af0f53d067c81$var$G($a35af0f53d067c81$var$wh, b);
    $a35af0f53d067c81$var$G($a35af0f53d067c81$var$vh, a);
    $a35af0f53d067c81$var$G($a35af0f53d067c81$var$uh, $a35af0f53d067c81$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $a35af0f53d067c81$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $a35af0f53d067c81$var$lb(b, a);
    }
    $a35af0f53d067c81$var$E($a35af0f53d067c81$var$uh);
    $a35af0f53d067c81$var$G($a35af0f53d067c81$var$uh, b);
}
function $a35af0f53d067c81$var$zh() {
    $a35af0f53d067c81$var$E($a35af0f53d067c81$var$uh);
    $a35af0f53d067c81$var$E($a35af0f53d067c81$var$vh);
    $a35af0f53d067c81$var$E($a35af0f53d067c81$var$wh);
}
function $a35af0f53d067c81$var$Ah(a) {
    $a35af0f53d067c81$var$xh($a35af0f53d067c81$var$wh.current);
    var b = $a35af0f53d067c81$var$xh($a35af0f53d067c81$var$uh.current);
    var c = $a35af0f53d067c81$var$lb(b, a.type);
    b !== c && ($a35af0f53d067c81$var$G($a35af0f53d067c81$var$vh, a), $a35af0f53d067c81$var$G($a35af0f53d067c81$var$uh, c));
}
function $a35af0f53d067c81$var$Bh(a) {
    $a35af0f53d067c81$var$vh.current === a && ($a35af0f53d067c81$var$E($a35af0f53d067c81$var$uh), $a35af0f53d067c81$var$E($a35af0f53d067c81$var$vh));
}
var $a35af0f53d067c81$var$L = $a35af0f53d067c81$var$Uf(0);
function $a35af0f53d067c81$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $a35af0f53d067c81$var$Dh = [];
function $a35af0f53d067c81$var$Eh() {
    for(var a = 0; a < $a35af0f53d067c81$var$Dh.length; a++)$a35af0f53d067c81$var$Dh[a]._workInProgressVersionPrimary = null;
    $a35af0f53d067c81$var$Dh.length = 0;
}
var $a35af0f53d067c81$var$Fh = $a35af0f53d067c81$var$ua.ReactCurrentDispatcher, $a35af0f53d067c81$var$Gh = $a35af0f53d067c81$var$ua.ReactCurrentBatchConfig, $a35af0f53d067c81$var$Hh = 0, $a35af0f53d067c81$var$M = null, $a35af0f53d067c81$var$N = null, $a35af0f53d067c81$var$O = null, $a35af0f53d067c81$var$Ih = !1, $a35af0f53d067c81$var$Jh = !1, $a35af0f53d067c81$var$Kh = 0, $a35af0f53d067c81$var$Lh = 0;
function $a35af0f53d067c81$var$P() {
    throw Error($a35af0f53d067c81$var$p(321));
}
function $a35af0f53d067c81$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$a35af0f53d067c81$var$He(a[c], b[c])) return !1;
    return !0;
}
function $a35af0f53d067c81$var$Nh(a, b, c, d, e, f) {
    $a35af0f53d067c81$var$Hh = f;
    $a35af0f53d067c81$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $a35af0f53d067c81$var$Fh.current = null === a || null === a.memoizedState ? $a35af0f53d067c81$var$Oh : $a35af0f53d067c81$var$Ph;
    a = c(d, e);
    if ($a35af0f53d067c81$var$Jh) {
        f = 0;
        do {
            $a35af0f53d067c81$var$Jh = !1;
            $a35af0f53d067c81$var$Kh = 0;
            if (25 <= f) throw Error($a35af0f53d067c81$var$p(301));
            f += 1;
            $a35af0f53d067c81$var$O = $a35af0f53d067c81$var$N = null;
            b.updateQueue = null;
            $a35af0f53d067c81$var$Fh.current = $a35af0f53d067c81$var$Qh;
            a = c(d, e);
        }while ($a35af0f53d067c81$var$Jh);
    }
    $a35af0f53d067c81$var$Fh.current = $a35af0f53d067c81$var$Rh;
    b = null !== $a35af0f53d067c81$var$N && null !== $a35af0f53d067c81$var$N.next;
    $a35af0f53d067c81$var$Hh = 0;
    $a35af0f53d067c81$var$O = $a35af0f53d067c81$var$N = $a35af0f53d067c81$var$M = null;
    $a35af0f53d067c81$var$Ih = !1;
    if (b) throw Error($a35af0f53d067c81$var$p(300));
    return a;
}
function $a35af0f53d067c81$var$Sh() {
    var a = 0 !== $a35af0f53d067c81$var$Kh;
    $a35af0f53d067c81$var$Kh = 0;
    return a;
}
function $a35af0f53d067c81$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a35af0f53d067c81$var$O ? $a35af0f53d067c81$var$M.memoizedState = $a35af0f53d067c81$var$O = a : $a35af0f53d067c81$var$O = $a35af0f53d067c81$var$O.next = a;
    return $a35af0f53d067c81$var$O;
}
function $a35af0f53d067c81$var$Uh() {
    if (null === $a35af0f53d067c81$var$N) {
        var a = $a35af0f53d067c81$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $a35af0f53d067c81$var$N.next;
    var b = null === $a35af0f53d067c81$var$O ? $a35af0f53d067c81$var$M.memoizedState : $a35af0f53d067c81$var$O.next;
    if (null !== b) $a35af0f53d067c81$var$O = b, $a35af0f53d067c81$var$N = a;
    else {
        if (null === a) throw Error($a35af0f53d067c81$var$p(310));
        $a35af0f53d067c81$var$N = a;
        a = {
            memoizedState: $a35af0f53d067c81$var$N.memoizedState,
            baseState: $a35af0f53d067c81$var$N.baseState,
            baseQueue: $a35af0f53d067c81$var$N.baseQueue,
            queue: $a35af0f53d067c81$var$N.queue,
            next: null
        };
        null === $a35af0f53d067c81$var$O ? $a35af0f53d067c81$var$M.memoizedState = $a35af0f53d067c81$var$O = a : $a35af0f53d067c81$var$O = $a35af0f53d067c81$var$O.next = a;
    }
    return $a35af0f53d067c81$var$O;
}
function $a35af0f53d067c81$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a35af0f53d067c81$var$Wh(a) {
    var b = $a35af0f53d067c81$var$Uh(), c = b.queue;
    if (null === c) throw Error($a35af0f53d067c81$var$p(311));
    c.lastRenderedReducer = a;
    var d = $a35af0f53d067c81$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($a35af0f53d067c81$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $a35af0f53d067c81$var$M.lanes |= m;
                $a35af0f53d067c81$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $a35af0f53d067c81$var$He(d, b.memoizedState) || ($a35af0f53d067c81$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $a35af0f53d067c81$var$M.lanes |= f, $a35af0f53d067c81$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $a35af0f53d067c81$var$Xh(a) {
    var b = $a35af0f53d067c81$var$Uh(), c = b.queue;
    if (null === c) throw Error($a35af0f53d067c81$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $a35af0f53d067c81$var$He(f, b.memoizedState) || ($a35af0f53d067c81$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $a35af0f53d067c81$var$Yh() {}
function $a35af0f53d067c81$var$Zh(a, b) {
    var c = $a35af0f53d067c81$var$M, d = $a35af0f53d067c81$var$Uh(), e = b(), f = !$a35af0f53d067c81$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $a35af0f53d067c81$var$dh = !0);
    d = d.queue;
    $a35af0f53d067c81$var$$h($a35af0f53d067c81$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $a35af0f53d067c81$var$O && $a35af0f53d067c81$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $a35af0f53d067c81$var$bi(9, $a35af0f53d067c81$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $a35af0f53d067c81$var$Q) throw Error($a35af0f53d067c81$var$p(349));
        0 !== ($a35af0f53d067c81$var$Hh & 30) || $a35af0f53d067c81$var$di(c, b, e);
    }
    return e;
}
function $a35af0f53d067c81$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $a35af0f53d067c81$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a35af0f53d067c81$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $a35af0f53d067c81$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $a35af0f53d067c81$var$ei(b) && $a35af0f53d067c81$var$fi(a);
}
function $a35af0f53d067c81$var$ai(a, b, c) {
    return c(function() {
        $a35af0f53d067c81$var$ei(b) && $a35af0f53d067c81$var$fi(a);
    });
}
function $a35af0f53d067c81$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$a35af0f53d067c81$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $a35af0f53d067c81$var$fi(a) {
    var b = $a35af0f53d067c81$var$ih(a, 1);
    null !== b && $a35af0f53d067c81$var$gi(b, a, 1, -1);
}
function $a35af0f53d067c81$var$hi(a) {
    var b = $a35af0f53d067c81$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a35af0f53d067c81$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $a35af0f53d067c81$var$ii.bind(null, $a35af0f53d067c81$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $a35af0f53d067c81$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $a35af0f53d067c81$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a35af0f53d067c81$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $a35af0f53d067c81$var$ji() {
    return $a35af0f53d067c81$var$Uh().memoizedState;
}
function $a35af0f53d067c81$var$ki(a, b, c, d) {
    var e = $a35af0f53d067c81$var$Th();
    $a35af0f53d067c81$var$M.flags |= a;
    e.memoizedState = $a35af0f53d067c81$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $a35af0f53d067c81$var$li(a, b, c, d) {
    var e = $a35af0f53d067c81$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $a35af0f53d067c81$var$N) {
        var g = $a35af0f53d067c81$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $a35af0f53d067c81$var$Mh(d, g.deps)) {
            e.memoizedState = $a35af0f53d067c81$var$bi(b, c, f, d);
            return;
        }
    }
    $a35af0f53d067c81$var$M.flags |= a;
    e.memoizedState = $a35af0f53d067c81$var$bi(1 | b, c, f, d);
}
function $a35af0f53d067c81$var$mi(a, b) {
    return $a35af0f53d067c81$var$ki(8390656, 8, a, b);
}
function $a35af0f53d067c81$var$$h(a, b) {
    return $a35af0f53d067c81$var$li(2048, 8, a, b);
}
function $a35af0f53d067c81$var$ni(a, b) {
    return $a35af0f53d067c81$var$li(4, 2, a, b);
}
function $a35af0f53d067c81$var$oi(a, b) {
    return $a35af0f53d067c81$var$li(4, 4, a, b);
}
function $a35af0f53d067c81$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $a35af0f53d067c81$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $a35af0f53d067c81$var$li(4, 4, $a35af0f53d067c81$var$pi.bind(null, b, a), c);
}
function $a35af0f53d067c81$var$ri() {}
function $a35af0f53d067c81$var$si(a, b) {
    var c = $a35af0f53d067c81$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a35af0f53d067c81$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a35af0f53d067c81$var$ti(a, b) {
    var c = $a35af0f53d067c81$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a35af0f53d067c81$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a35af0f53d067c81$var$ui(a, b, c) {
    if (0 === ($a35af0f53d067c81$var$Hh & 21)) return a.baseState && (a.baseState = !1, $a35af0f53d067c81$var$dh = !0), a.memoizedState = c;
    $a35af0f53d067c81$var$He(c, b) || (c = $a35af0f53d067c81$var$yc(), $a35af0f53d067c81$var$M.lanes |= c, $a35af0f53d067c81$var$rh |= c, a.baseState = !0);
    return b;
}
function $a35af0f53d067c81$var$vi(a, b) {
    var c = $a35af0f53d067c81$var$C;
    $a35af0f53d067c81$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $a35af0f53d067c81$var$Gh.transition;
    $a35af0f53d067c81$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $a35af0f53d067c81$var$C = c, $a35af0f53d067c81$var$Gh.transition = d;
    }
}
function $a35af0f53d067c81$var$wi() {
    return $a35af0f53d067c81$var$Uh().memoizedState;
}
function $a35af0f53d067c81$var$xi(a, b, c) {
    var d = $a35af0f53d067c81$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a35af0f53d067c81$var$zi(a)) $a35af0f53d067c81$var$Ai(b, c);
    else if (c = $a35af0f53d067c81$var$hh(a, b, c, d), null !== c) {
        var e = $a35af0f53d067c81$var$R();
        $a35af0f53d067c81$var$gi(c, a, d, e);
        $a35af0f53d067c81$var$Bi(c, b, d);
    }
}
function $a35af0f53d067c81$var$ii(a, b, c) {
    var d = $a35af0f53d067c81$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a35af0f53d067c81$var$zi(a)) $a35af0f53d067c81$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($a35af0f53d067c81$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $a35af0f53d067c81$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $a35af0f53d067c81$var$hh(a, b, e, d);
        null !== c && (e = $a35af0f53d067c81$var$R(), $a35af0f53d067c81$var$gi(c, a, d, e), $a35af0f53d067c81$var$Bi(c, b, d));
    }
}
function $a35af0f53d067c81$var$zi(a) {
    var b = a.alternate;
    return a === $a35af0f53d067c81$var$M || null !== b && b === $a35af0f53d067c81$var$M;
}
function $a35af0f53d067c81$var$Ai(a, b) {
    $a35af0f53d067c81$var$Jh = $a35af0f53d067c81$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $a35af0f53d067c81$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a35af0f53d067c81$var$Cc(a, c);
    }
}
var $a35af0f53d067c81$var$Rh = {
    readContext: $a35af0f53d067c81$var$eh,
    useCallback: $a35af0f53d067c81$var$P,
    useContext: $a35af0f53d067c81$var$P,
    useEffect: $a35af0f53d067c81$var$P,
    useImperativeHandle: $a35af0f53d067c81$var$P,
    useInsertionEffect: $a35af0f53d067c81$var$P,
    useLayoutEffect: $a35af0f53d067c81$var$P,
    useMemo: $a35af0f53d067c81$var$P,
    useReducer: $a35af0f53d067c81$var$P,
    useRef: $a35af0f53d067c81$var$P,
    useState: $a35af0f53d067c81$var$P,
    useDebugValue: $a35af0f53d067c81$var$P,
    useDeferredValue: $a35af0f53d067c81$var$P,
    useTransition: $a35af0f53d067c81$var$P,
    useMutableSource: $a35af0f53d067c81$var$P,
    useSyncExternalStore: $a35af0f53d067c81$var$P,
    useId: $a35af0f53d067c81$var$P,
    unstable_isNewReconciler: !1
}, $a35af0f53d067c81$var$Oh = {
    readContext: $a35af0f53d067c81$var$eh,
    useCallback: function(a, b) {
        $a35af0f53d067c81$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $a35af0f53d067c81$var$eh,
    useEffect: $a35af0f53d067c81$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $a35af0f53d067c81$var$ki(4194308, 4, $a35af0f53d067c81$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $a35af0f53d067c81$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $a35af0f53d067c81$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $a35af0f53d067c81$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $a35af0f53d067c81$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $a35af0f53d067c81$var$xi.bind(null, $a35af0f53d067c81$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $a35af0f53d067c81$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $a35af0f53d067c81$var$hi,
    useDebugValue: $a35af0f53d067c81$var$ri,
    useDeferredValue: function(a) {
        return $a35af0f53d067c81$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $a35af0f53d067c81$var$hi(!1), b = a[0];
        a = $a35af0f53d067c81$var$vi.bind(null, a[1]);
        $a35af0f53d067c81$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $a35af0f53d067c81$var$M, e = $a35af0f53d067c81$var$Th();
        if ($a35af0f53d067c81$var$I) {
            if (void 0 === c) throw Error($a35af0f53d067c81$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $a35af0f53d067c81$var$Q) throw Error($a35af0f53d067c81$var$p(349));
            0 !== ($a35af0f53d067c81$var$Hh & 30) || $a35af0f53d067c81$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $a35af0f53d067c81$var$mi($a35af0f53d067c81$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $a35af0f53d067c81$var$bi(9, $a35af0f53d067c81$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $a35af0f53d067c81$var$Th(), b = $a35af0f53d067c81$var$Q.identifierPrefix;
        if ($a35af0f53d067c81$var$I) {
            var c = $a35af0f53d067c81$var$sg;
            var d = $a35af0f53d067c81$var$rg;
            c = (d & ~(1 << 32 - $a35af0f53d067c81$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $a35af0f53d067c81$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $a35af0f53d067c81$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $a35af0f53d067c81$var$Ph = {
    readContext: $a35af0f53d067c81$var$eh,
    useCallback: $a35af0f53d067c81$var$si,
    useContext: $a35af0f53d067c81$var$eh,
    useEffect: $a35af0f53d067c81$var$$h,
    useImperativeHandle: $a35af0f53d067c81$var$qi,
    useInsertionEffect: $a35af0f53d067c81$var$ni,
    useLayoutEffect: $a35af0f53d067c81$var$oi,
    useMemo: $a35af0f53d067c81$var$ti,
    useReducer: $a35af0f53d067c81$var$Wh,
    useRef: $a35af0f53d067c81$var$ji,
    useState: function() {
        return $a35af0f53d067c81$var$Wh($a35af0f53d067c81$var$Vh);
    },
    useDebugValue: $a35af0f53d067c81$var$ri,
    useDeferredValue: function(a) {
        var b = $a35af0f53d067c81$var$Uh();
        return $a35af0f53d067c81$var$ui(b, $a35af0f53d067c81$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $a35af0f53d067c81$var$Wh($a35af0f53d067c81$var$Vh)[0], b = $a35af0f53d067c81$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a35af0f53d067c81$var$Yh,
    useSyncExternalStore: $a35af0f53d067c81$var$Zh,
    useId: $a35af0f53d067c81$var$wi,
    unstable_isNewReconciler: !1
}, $a35af0f53d067c81$var$Qh = {
    readContext: $a35af0f53d067c81$var$eh,
    useCallback: $a35af0f53d067c81$var$si,
    useContext: $a35af0f53d067c81$var$eh,
    useEffect: $a35af0f53d067c81$var$$h,
    useImperativeHandle: $a35af0f53d067c81$var$qi,
    useInsertionEffect: $a35af0f53d067c81$var$ni,
    useLayoutEffect: $a35af0f53d067c81$var$oi,
    useMemo: $a35af0f53d067c81$var$ti,
    useReducer: $a35af0f53d067c81$var$Xh,
    useRef: $a35af0f53d067c81$var$ji,
    useState: function() {
        return $a35af0f53d067c81$var$Xh($a35af0f53d067c81$var$Vh);
    },
    useDebugValue: $a35af0f53d067c81$var$ri,
    useDeferredValue: function(a) {
        var b = $a35af0f53d067c81$var$Uh();
        return null === $a35af0f53d067c81$var$N ? b.memoizedState = a : $a35af0f53d067c81$var$ui(b, $a35af0f53d067c81$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $a35af0f53d067c81$var$Xh($a35af0f53d067c81$var$Vh)[0], b = $a35af0f53d067c81$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a35af0f53d067c81$var$Yh,
    useSyncExternalStore: $a35af0f53d067c81$var$Zh,
    useId: $a35af0f53d067c81$var$wi,
    unstable_isNewReconciler: !1
};
function $a35af0f53d067c81$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $a35af0f53d067c81$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $a35af0f53d067c81$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $a35af0f53d067c81$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $a35af0f53d067c81$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $a35af0f53d067c81$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a35af0f53d067c81$var$R(), e = $a35af0f53d067c81$var$yi(a), f = $a35af0f53d067c81$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a35af0f53d067c81$var$nh(a, f, e);
        null !== b && ($a35af0f53d067c81$var$gi(b, a, e, d), $a35af0f53d067c81$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a35af0f53d067c81$var$R(), e = $a35af0f53d067c81$var$yi(a), f = $a35af0f53d067c81$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a35af0f53d067c81$var$nh(a, f, e);
        null !== b && ($a35af0f53d067c81$var$gi(b, a, e, d), $a35af0f53d067c81$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $a35af0f53d067c81$var$R(), d = $a35af0f53d067c81$var$yi(a), e = $a35af0f53d067c81$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $a35af0f53d067c81$var$nh(a, e, d);
        null !== b && ($a35af0f53d067c81$var$gi(b, a, d, c), $a35af0f53d067c81$var$oh(b, a, d));
    }
};
function $a35af0f53d067c81$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$a35af0f53d067c81$var$Ie(c, d) || !$a35af0f53d067c81$var$Ie(e, f) : !0;
}
function $a35af0f53d067c81$var$Gi(a, b, c) {
    var d = !1, e = $a35af0f53d067c81$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $a35af0f53d067c81$var$eh(f) : (e = $a35af0f53d067c81$var$Zf(b) ? $a35af0f53d067c81$var$Xf : $a35af0f53d067c81$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $a35af0f53d067c81$var$Yf(a, e) : $a35af0f53d067c81$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $a35af0f53d067c81$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $a35af0f53d067c81$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $a35af0f53d067c81$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $a35af0f53d067c81$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $a35af0f53d067c81$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $a35af0f53d067c81$var$eh(f) : (f = $a35af0f53d067c81$var$Zf(b) ? $a35af0f53d067c81$var$Xf : $a35af0f53d067c81$var$H.current, e.context = $a35af0f53d067c81$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($a35af0f53d067c81$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $a35af0f53d067c81$var$Ei.enqueueReplaceState(e, e.state, null), $a35af0f53d067c81$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $a35af0f53d067c81$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $a35af0f53d067c81$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $a35af0f53d067c81$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $a35af0f53d067c81$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $a35af0f53d067c81$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $a35af0f53d067c81$var$Ni(a, b, c) {
    c = $a35af0f53d067c81$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $a35af0f53d067c81$var$Oi || ($a35af0f53d067c81$var$Oi = !0, $a35af0f53d067c81$var$Pi = d);
        $a35af0f53d067c81$var$Li(a, b);
    };
    return c;
}
function $a35af0f53d067c81$var$Qi(a, b, c) {
    c = $a35af0f53d067c81$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $a35af0f53d067c81$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $a35af0f53d067c81$var$Li(a, b);
        "function" !== typeof d && (null === $a35af0f53d067c81$var$Ri ? $a35af0f53d067c81$var$Ri = new Set([
            this
        ]) : $a35af0f53d067c81$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $a35af0f53d067c81$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $a35af0f53d067c81$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $a35af0f53d067c81$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $a35af0f53d067c81$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $a35af0f53d067c81$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $a35af0f53d067c81$var$mh(-1, 1), b.tag = 2, $a35af0f53d067c81$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $a35af0f53d067c81$var$Wi = $a35af0f53d067c81$var$ua.ReactCurrentOwner, $a35af0f53d067c81$var$dh = !1;
function $a35af0f53d067c81$var$Xi(a, b, c, d) {
    b.child = null === a ? $a35af0f53d067c81$var$Vg(b, null, c, d) : $a35af0f53d067c81$var$Ug(b, a.child, c, d);
}
function $a35af0f53d067c81$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $a35af0f53d067c81$var$ch(b, e);
    d = $a35af0f53d067c81$var$Nh(a, b, c, d, f, e);
    c = $a35af0f53d067c81$var$Sh();
    if (null !== a && !$a35af0f53d067c81$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a35af0f53d067c81$var$Zi(a, b, e);
    $a35af0f53d067c81$var$I && c && $a35af0f53d067c81$var$vg(b);
    b.flags |= 1;
    $a35af0f53d067c81$var$Xi(a, b, d, e);
    return b.child;
}
function $a35af0f53d067c81$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$a35af0f53d067c81$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $a35af0f53d067c81$var$bj(a, b, f, d, e);
        a = $a35af0f53d067c81$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $a35af0f53d067c81$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $a35af0f53d067c81$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $a35af0f53d067c81$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $a35af0f53d067c81$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($a35af0f53d067c81$var$Ie(f, d) && a.ref === b.ref) {
            if ($a35af0f53d067c81$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($a35af0f53d067c81$var$dh = !0);
            else return b.lanes = a.lanes, $a35af0f53d067c81$var$Zi(a, b, e);
        }
    }
    return $a35af0f53d067c81$var$cj(a, b, c, d, e);
}
function $a35af0f53d067c81$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $a35af0f53d067c81$var$G($a35af0f53d067c81$var$ej, $a35af0f53d067c81$var$fj), $a35af0f53d067c81$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $a35af0f53d067c81$var$G($a35af0f53d067c81$var$ej, $a35af0f53d067c81$var$fj), $a35af0f53d067c81$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $a35af0f53d067c81$var$G($a35af0f53d067c81$var$ej, $a35af0f53d067c81$var$fj);
            $a35af0f53d067c81$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $a35af0f53d067c81$var$G($a35af0f53d067c81$var$ej, $a35af0f53d067c81$var$fj), $a35af0f53d067c81$var$fj |= d;
    $a35af0f53d067c81$var$Xi(a, b, e, c);
    return b.child;
}
function $a35af0f53d067c81$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $a35af0f53d067c81$var$cj(a, b, c, d, e) {
    var f = $a35af0f53d067c81$var$Zf(c) ? $a35af0f53d067c81$var$Xf : $a35af0f53d067c81$var$H.current;
    f = $a35af0f53d067c81$var$Yf(b, f);
    $a35af0f53d067c81$var$ch(b, e);
    c = $a35af0f53d067c81$var$Nh(a, b, c, d, f, e);
    d = $a35af0f53d067c81$var$Sh();
    if (null !== a && !$a35af0f53d067c81$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a35af0f53d067c81$var$Zi(a, b, e);
    $a35af0f53d067c81$var$I && d && $a35af0f53d067c81$var$vg(b);
    b.flags |= 1;
    $a35af0f53d067c81$var$Xi(a, b, c, e);
    return b.child;
}
function $a35af0f53d067c81$var$hj(a, b, c, d, e) {
    if ($a35af0f53d067c81$var$Zf(c)) {
        var f = !0;
        $a35af0f53d067c81$var$cg(b);
    } else f = !1;
    $a35af0f53d067c81$var$ch(b, e);
    if (null === b.stateNode) $a35af0f53d067c81$var$ij(a, b), $a35af0f53d067c81$var$Gi(b, c, d), $a35af0f53d067c81$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $a35af0f53d067c81$var$eh(l) : (l = $a35af0f53d067c81$var$Zf(c) ? $a35af0f53d067c81$var$Xf : $a35af0f53d067c81$var$H.current, l = $a35af0f53d067c81$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $a35af0f53d067c81$var$Hi(b, g, d, l);
        $a35af0f53d067c81$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $a35af0f53d067c81$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $a35af0f53d067c81$var$Wf.current || $a35af0f53d067c81$var$jh ? ("function" === typeof m && ($a35af0f53d067c81$var$Di(b, c, m, d), k = b.memoizedState), (h = $a35af0f53d067c81$var$jh || $a35af0f53d067c81$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $a35af0f53d067c81$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $a35af0f53d067c81$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $a35af0f53d067c81$var$eh(k) : (k = $a35af0f53d067c81$var$Zf(c) ? $a35af0f53d067c81$var$Xf : $a35af0f53d067c81$var$H.current, k = $a35af0f53d067c81$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $a35af0f53d067c81$var$Hi(b, g, d, k);
        $a35af0f53d067c81$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $a35af0f53d067c81$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $a35af0f53d067c81$var$Wf.current || $a35af0f53d067c81$var$jh ? ("function" === typeof y && ($a35af0f53d067c81$var$Di(b, c, y, d), n = b.memoizedState), (l = $a35af0f53d067c81$var$jh || $a35af0f53d067c81$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $a35af0f53d067c81$var$jj(a, b, c, d, f, e);
}
function $a35af0f53d067c81$var$jj(a, b, c, d, e, f) {
    $a35af0f53d067c81$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $a35af0f53d067c81$var$dg(b, c, !1), $a35af0f53d067c81$var$Zi(a, b, f);
    d = b.stateNode;
    $a35af0f53d067c81$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $a35af0f53d067c81$var$Ug(b, a.child, null, f), b.child = $a35af0f53d067c81$var$Ug(b, null, h, f)) : $a35af0f53d067c81$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $a35af0f53d067c81$var$dg(b, c, !0);
    return b.child;
}
function $a35af0f53d067c81$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $a35af0f53d067c81$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $a35af0f53d067c81$var$ag(a, b.context, !1);
    $a35af0f53d067c81$var$yh(a, b.containerInfo);
}
function $a35af0f53d067c81$var$lj(a, b, c, d, e) {
    $a35af0f53d067c81$var$Ig();
    $a35af0f53d067c81$var$Jg(e);
    b.flags |= 256;
    $a35af0f53d067c81$var$Xi(a, b, c, d);
    return b.child;
}
var $a35af0f53d067c81$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $a35af0f53d067c81$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $a35af0f53d067c81$var$oj(a, b, c) {
    var d = b.pendingProps, e = $a35af0f53d067c81$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $a35af0f53d067c81$var$G($a35af0f53d067c81$var$L, e & 1);
    if (null === a) {
        $a35af0f53d067c81$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $a35af0f53d067c81$var$pj(g, d, 0, null), a = $a35af0f53d067c81$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $a35af0f53d067c81$var$nj(c), b.memoizedState = $a35af0f53d067c81$var$mj, a) : $a35af0f53d067c81$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $a35af0f53d067c81$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $a35af0f53d067c81$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $a35af0f53d067c81$var$Pg(h, f) : (f = $a35af0f53d067c81$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $a35af0f53d067c81$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $a35af0f53d067c81$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $a35af0f53d067c81$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $a35af0f53d067c81$var$qj(a, b) {
    b = $a35af0f53d067c81$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $a35af0f53d067c81$var$sj(a, b, c, d) {
    null !== d && $a35af0f53d067c81$var$Jg(d);
    $a35af0f53d067c81$var$Ug(b, a.child, null, c);
    a = $a35af0f53d067c81$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $a35af0f53d067c81$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $a35af0f53d067c81$var$Ki(Error($a35af0f53d067c81$var$p(422))), $a35af0f53d067c81$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $a35af0f53d067c81$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $a35af0f53d067c81$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $a35af0f53d067c81$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $a35af0f53d067c81$var$nj(g);
        b.memoizedState = $a35af0f53d067c81$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $a35af0f53d067c81$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($a35af0f53d067c81$var$p(419));
        d = $a35af0f53d067c81$var$Ki(f, d, void 0);
        return $a35af0f53d067c81$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($a35af0f53d067c81$var$dh || h) {
        d = $a35af0f53d067c81$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $a35af0f53d067c81$var$ih(a, e), $a35af0f53d067c81$var$gi(d, a, e, -1));
        }
        $a35af0f53d067c81$var$tj();
        d = $a35af0f53d067c81$var$Ki(Error($a35af0f53d067c81$var$p(421)));
        return $a35af0f53d067c81$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $a35af0f53d067c81$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $a35af0f53d067c81$var$yg = $a35af0f53d067c81$var$Lf(e.nextSibling);
    $a35af0f53d067c81$var$xg = b;
    $a35af0f53d067c81$var$I = !0;
    $a35af0f53d067c81$var$zg = null;
    null !== a && ($a35af0f53d067c81$var$og[$a35af0f53d067c81$var$pg++] = $a35af0f53d067c81$var$rg, $a35af0f53d067c81$var$og[$a35af0f53d067c81$var$pg++] = $a35af0f53d067c81$var$sg, $a35af0f53d067c81$var$og[$a35af0f53d067c81$var$pg++] = $a35af0f53d067c81$var$qg, $a35af0f53d067c81$var$rg = a.id, $a35af0f53d067c81$var$sg = a.overflow, $a35af0f53d067c81$var$qg = b);
    b = $a35af0f53d067c81$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $a35af0f53d067c81$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $a35af0f53d067c81$var$bh(a.return, b, c);
}
function $a35af0f53d067c81$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $a35af0f53d067c81$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $a35af0f53d067c81$var$Xi(a, b, d.children, c);
    d = $a35af0f53d067c81$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $a35af0f53d067c81$var$vj(a, c, b);
            else if (19 === a.tag) $a35af0f53d067c81$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $a35af0f53d067c81$var$G($a35af0f53d067c81$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $a35af0f53d067c81$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $a35af0f53d067c81$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $a35af0f53d067c81$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $a35af0f53d067c81$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $a35af0f53d067c81$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $a35af0f53d067c81$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $a35af0f53d067c81$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $a35af0f53d067c81$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($a35af0f53d067c81$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $a35af0f53d067c81$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $a35af0f53d067c81$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $a35af0f53d067c81$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $a35af0f53d067c81$var$kj(b);
            $a35af0f53d067c81$var$Ig();
            break;
        case 5:
            $a35af0f53d067c81$var$Ah(b);
            break;
        case 1:
            $a35af0f53d067c81$var$Zf(b.type) && $a35af0f53d067c81$var$cg(b);
            break;
        case 4:
            $a35af0f53d067c81$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $a35af0f53d067c81$var$G($a35af0f53d067c81$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $a35af0f53d067c81$var$G($a35af0f53d067c81$var$L, $a35af0f53d067c81$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $a35af0f53d067c81$var$oj(a, b, c);
                $a35af0f53d067c81$var$G($a35af0f53d067c81$var$L, $a35af0f53d067c81$var$L.current & 1);
                a = $a35af0f53d067c81$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $a35af0f53d067c81$var$G($a35af0f53d067c81$var$L, $a35af0f53d067c81$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $a35af0f53d067c81$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $a35af0f53d067c81$var$G($a35af0f53d067c81$var$L, $a35af0f53d067c81$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $a35af0f53d067c81$var$dj(a, b, c);
    }
    return $a35af0f53d067c81$var$Zi(a, b, c);
}
var $a35af0f53d067c81$var$zj, $a35af0f53d067c81$var$Aj, $a35af0f53d067c81$var$Bj, $a35af0f53d067c81$var$Cj;
$a35af0f53d067c81$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$a35af0f53d067c81$var$Aj = function() {};
$a35af0f53d067c81$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $a35af0f53d067c81$var$xh($a35af0f53d067c81$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $a35af0f53d067c81$var$Ya(a, e);
                d = $a35af0f53d067c81$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $a35af0f53d067c81$var$A({}, e, {
                    value: void 0
                });
                d = $a35af0f53d067c81$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $a35af0f53d067c81$var$gb(a, e);
                d = $a35af0f53d067c81$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $a35af0f53d067c81$var$Bf);
        }
        $a35af0f53d067c81$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($a35af0f53d067c81$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($a35af0f53d067c81$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $a35af0f53d067c81$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$a35af0f53d067c81$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $a35af0f53d067c81$var$Dj(a, b) {
    if (!$a35af0f53d067c81$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $a35af0f53d067c81$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $a35af0f53d067c81$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $a35af0f53d067c81$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a35af0f53d067c81$var$S(b), null;
        case 1:
            return $a35af0f53d067c81$var$Zf(b.type) && $a35af0f53d067c81$var$$f(), $a35af0f53d067c81$var$S(b), null;
        case 3:
            d = b.stateNode;
            $a35af0f53d067c81$var$zh();
            $a35af0f53d067c81$var$E($a35af0f53d067c81$var$Wf);
            $a35af0f53d067c81$var$E($a35af0f53d067c81$var$H);
            $a35af0f53d067c81$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $a35af0f53d067c81$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $a35af0f53d067c81$var$zg && ($a35af0f53d067c81$var$Fj($a35af0f53d067c81$var$zg), $a35af0f53d067c81$var$zg = null));
            $a35af0f53d067c81$var$Aj(a, b);
            $a35af0f53d067c81$var$S(b);
            return null;
        case 5:
            $a35af0f53d067c81$var$Bh(b);
            var e = $a35af0f53d067c81$var$xh($a35af0f53d067c81$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $a35af0f53d067c81$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($a35af0f53d067c81$var$p(166));
                    $a35af0f53d067c81$var$S(b);
                    return null;
                }
                a = $a35af0f53d067c81$var$xh($a35af0f53d067c81$var$uh.current);
                if ($a35af0f53d067c81$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$a35af0f53d067c81$var$Of] = b;
                    d[$a35af0f53d067c81$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $a35af0f53d067c81$var$D("cancel", d);
                            $a35af0f53d067c81$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $a35af0f53d067c81$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $a35af0f53d067c81$var$lf.length; e++)$a35af0f53d067c81$var$D($a35af0f53d067c81$var$lf[e], d);
                            break;
                        case "source":
                            $a35af0f53d067c81$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $a35af0f53d067c81$var$D("error", d);
                            $a35af0f53d067c81$var$D("load", d);
                            break;
                        case "details":
                            $a35af0f53d067c81$var$D("toggle", d);
                            break;
                        case "input":
                            $a35af0f53d067c81$var$Za(d, f);
                            $a35af0f53d067c81$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $a35af0f53d067c81$var$D("invalid", d);
                            break;
                        case "textarea":
                            $a35af0f53d067c81$var$hb(d, f), $a35af0f53d067c81$var$D("invalid", d);
                    }
                    $a35af0f53d067c81$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $a35af0f53d067c81$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $a35af0f53d067c81$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $a35af0f53d067c81$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $a35af0f53d067c81$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $a35af0f53d067c81$var$Va(d);
                            $a35af0f53d067c81$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $a35af0f53d067c81$var$Va(d);
                            $a35af0f53d067c81$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $a35af0f53d067c81$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $a35af0f53d067c81$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$a35af0f53d067c81$var$Of] = b;
                    a[$a35af0f53d067c81$var$Pf] = d;
                    $a35af0f53d067c81$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $a35af0f53d067c81$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $a35af0f53d067c81$var$D("cancel", a);
                                $a35af0f53d067c81$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $a35af0f53d067c81$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $a35af0f53d067c81$var$lf.length; e++)$a35af0f53d067c81$var$D($a35af0f53d067c81$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $a35af0f53d067c81$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $a35af0f53d067c81$var$D("error", a);
                                $a35af0f53d067c81$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $a35af0f53d067c81$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $a35af0f53d067c81$var$Za(a, d);
                                e = $a35af0f53d067c81$var$Ya(a, d);
                                $a35af0f53d067c81$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $a35af0f53d067c81$var$A({}, d, {
                                    value: void 0
                                });
                                $a35af0f53d067c81$var$D("invalid", a);
                                break;
                            case "textarea":
                                $a35af0f53d067c81$var$hb(a, d);
                                e = $a35af0f53d067c81$var$gb(a, d);
                                $a35af0f53d067c81$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $a35af0f53d067c81$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $a35af0f53d067c81$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $a35af0f53d067c81$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $a35af0f53d067c81$var$ob(a, k) : "number" === typeof k && $a35af0f53d067c81$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($a35af0f53d067c81$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $a35af0f53d067c81$var$D("scroll", a) : null != k && $a35af0f53d067c81$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $a35af0f53d067c81$var$Va(a);
                                $a35af0f53d067c81$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $a35af0f53d067c81$var$Va(a);
                                $a35af0f53d067c81$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $a35af0f53d067c81$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $a35af0f53d067c81$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $a35af0f53d067c81$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $a35af0f53d067c81$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $a35af0f53d067c81$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $a35af0f53d067c81$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($a35af0f53d067c81$var$p(166));
                c = $a35af0f53d067c81$var$xh($a35af0f53d067c81$var$wh.current);
                $a35af0f53d067c81$var$xh($a35af0f53d067c81$var$uh.current);
                if ($a35af0f53d067c81$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$a35af0f53d067c81$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $a35af0f53d067c81$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $a35af0f53d067c81$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $a35af0f53d067c81$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$a35af0f53d067c81$var$Of] = b, b.stateNode = d;
            }
            $a35af0f53d067c81$var$S(b);
            return null;
        case 13:
            $a35af0f53d067c81$var$E($a35af0f53d067c81$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($a35af0f53d067c81$var$I && null !== $a35af0f53d067c81$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $a35af0f53d067c81$var$Hg(), $a35af0f53d067c81$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $a35af0f53d067c81$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($a35af0f53d067c81$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($a35af0f53d067c81$var$p(317));
                        f[$a35af0f53d067c81$var$Of] = b;
                    } else $a35af0f53d067c81$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $a35af0f53d067c81$var$S(b);
                    f = !1;
                } else null !== $a35af0f53d067c81$var$zg && ($a35af0f53d067c81$var$Fj($a35af0f53d067c81$var$zg), $a35af0f53d067c81$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($a35af0f53d067c81$var$L.current & 1) ? 0 === $a35af0f53d067c81$var$T && ($a35af0f53d067c81$var$T = 3) : $a35af0f53d067c81$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $a35af0f53d067c81$var$S(b);
            return null;
        case 4:
            return $a35af0f53d067c81$var$zh(), $a35af0f53d067c81$var$Aj(a, b), null === a && $a35af0f53d067c81$var$sf(b.stateNode.containerInfo), $a35af0f53d067c81$var$S(b), null;
        case 10:
            return $a35af0f53d067c81$var$ah(b.type._context), $a35af0f53d067c81$var$S(b), null;
        case 17:
            return $a35af0f53d067c81$var$Zf(b.type) && $a35af0f53d067c81$var$$f(), $a35af0f53d067c81$var$S(b), null;
        case 19:
            $a35af0f53d067c81$var$E($a35af0f53d067c81$var$L);
            f = b.memoizedState;
            if (null === f) return $a35af0f53d067c81$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $a35af0f53d067c81$var$Dj(f, !1);
                else {
                    if (0 !== $a35af0f53d067c81$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $a35af0f53d067c81$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $a35af0f53d067c81$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $a35af0f53d067c81$var$G($a35af0f53d067c81$var$L, $a35af0f53d067c81$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $a35af0f53d067c81$var$B() > $a35af0f53d067c81$var$Gj && (b.flags |= 128, d = !0, $a35af0f53d067c81$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $a35af0f53d067c81$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $a35af0f53d067c81$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$a35af0f53d067c81$var$I) return $a35af0f53d067c81$var$S(b), null;
                    } else 2 * $a35af0f53d067c81$var$B() - f.renderingStartTime > $a35af0f53d067c81$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $a35af0f53d067c81$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $a35af0f53d067c81$var$B(), b.sibling = null, c = $a35af0f53d067c81$var$L.current, $a35af0f53d067c81$var$G($a35af0f53d067c81$var$L, d ? c & 1 | 2 : c & 1), b;
            $a35af0f53d067c81$var$S(b);
            return null;
        case 22:
        case 23:
            return $a35af0f53d067c81$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($a35af0f53d067c81$var$fj & 1073741824) && ($a35af0f53d067c81$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $a35af0f53d067c81$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($a35af0f53d067c81$var$p(156, b.tag));
}
function $a35af0f53d067c81$var$Ij(a, b) {
    $a35af0f53d067c81$var$wg(b);
    switch(b.tag){
        case 1:
            return $a35af0f53d067c81$var$Zf(b.type) && $a35af0f53d067c81$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $a35af0f53d067c81$var$zh(), $a35af0f53d067c81$var$E($a35af0f53d067c81$var$Wf), $a35af0f53d067c81$var$E($a35af0f53d067c81$var$H), $a35af0f53d067c81$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $a35af0f53d067c81$var$Bh(b), null;
        case 13:
            $a35af0f53d067c81$var$E($a35af0f53d067c81$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($a35af0f53d067c81$var$p(340));
                $a35af0f53d067c81$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $a35af0f53d067c81$var$E($a35af0f53d067c81$var$L), null;
        case 4:
            return $a35af0f53d067c81$var$zh(), null;
        case 10:
            return $a35af0f53d067c81$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $a35af0f53d067c81$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $a35af0f53d067c81$var$Jj = !1, $a35af0f53d067c81$var$U = !1, $a35af0f53d067c81$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $a35af0f53d067c81$var$V = null;
function $a35af0f53d067c81$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $a35af0f53d067c81$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $a35af0f53d067c81$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $a35af0f53d067c81$var$W(a, b, d);
    }
}
var $a35af0f53d067c81$var$Nj = !1;
function $a35af0f53d067c81$var$Oj(a, b) {
    $a35af0f53d067c81$var$Cf = $a35af0f53d067c81$var$dd;
    a = $a35af0f53d067c81$var$Me();
    if ($a35af0f53d067c81$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $a35af0f53d067c81$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $a35af0f53d067c81$var$dd = !1;
    for($a35af0f53d067c81$var$V = b; null !== $a35af0f53d067c81$var$V;)if (b = $a35af0f53d067c81$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $a35af0f53d067c81$var$V = a;
    else for(; null !== $a35af0f53d067c81$var$V;){
        b = $a35af0f53d067c81$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $a35af0f53d067c81$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($a35af0f53d067c81$var$p(163));
            }
        } catch (F) {
            $a35af0f53d067c81$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $a35af0f53d067c81$var$V = a;
            break;
        }
        $a35af0f53d067c81$var$V = b.return;
    }
    n = $a35af0f53d067c81$var$Nj;
    $a35af0f53d067c81$var$Nj = !1;
    return n;
}
function $a35af0f53d067c81$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $a35af0f53d067c81$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $a35af0f53d067c81$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $a35af0f53d067c81$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $a35af0f53d067c81$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $a35af0f53d067c81$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$a35af0f53d067c81$var$Of], delete b[$a35af0f53d067c81$var$Pf], delete b[$a35af0f53d067c81$var$of], delete b[$a35af0f53d067c81$var$Qf], delete b[$a35af0f53d067c81$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $a35af0f53d067c81$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $a35af0f53d067c81$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $a35af0f53d067c81$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $a35af0f53d067c81$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $a35af0f53d067c81$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($a35af0f53d067c81$var$Vj(a, b, c), a = a.sibling; null !== a;)$a35af0f53d067c81$var$Vj(a, b, c), a = a.sibling;
}
function $a35af0f53d067c81$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($a35af0f53d067c81$var$Wj(a, b, c), a = a.sibling; null !== a;)$a35af0f53d067c81$var$Wj(a, b, c), a = a.sibling;
}
var $a35af0f53d067c81$var$X = null, $a35af0f53d067c81$var$Xj = !1;
function $a35af0f53d067c81$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$a35af0f53d067c81$var$Zj(a, b, c), c = c.sibling;
}
function $a35af0f53d067c81$var$Zj(a, b, c) {
    if ($a35af0f53d067c81$var$lc && "function" === typeof $a35af0f53d067c81$var$lc.onCommitFiberUnmount) try {
        $a35af0f53d067c81$var$lc.onCommitFiberUnmount($a35af0f53d067c81$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $a35af0f53d067c81$var$U || $a35af0f53d067c81$var$Lj(c, b);
        case 6:
            var d = $a35af0f53d067c81$var$X, e = $a35af0f53d067c81$var$Xj;
            $a35af0f53d067c81$var$X = null;
            $a35af0f53d067c81$var$Yj(a, b, c);
            $a35af0f53d067c81$var$X = d;
            $a35af0f53d067c81$var$Xj = e;
            null !== $a35af0f53d067c81$var$X && ($a35af0f53d067c81$var$Xj ? (a = $a35af0f53d067c81$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $a35af0f53d067c81$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $a35af0f53d067c81$var$X && ($a35af0f53d067c81$var$Xj ? (a = $a35af0f53d067c81$var$X, c = c.stateNode, 8 === a.nodeType ? $a35af0f53d067c81$var$Kf(a.parentNode, c) : 1 === a.nodeType && $a35af0f53d067c81$var$Kf(a, c), $a35af0f53d067c81$var$bd(a)) : $a35af0f53d067c81$var$Kf($a35af0f53d067c81$var$X, c.stateNode));
            break;
        case 4:
            d = $a35af0f53d067c81$var$X;
            e = $a35af0f53d067c81$var$Xj;
            $a35af0f53d067c81$var$X = c.stateNode.containerInfo;
            $a35af0f53d067c81$var$Xj = !0;
            $a35af0f53d067c81$var$Yj(a, b, c);
            $a35af0f53d067c81$var$X = d;
            $a35af0f53d067c81$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$a35af0f53d067c81$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $a35af0f53d067c81$var$Mj(c, b, g) : 0 !== (f & 4) && $a35af0f53d067c81$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $a35af0f53d067c81$var$Yj(a, b, c);
            break;
        case 1:
            if (!$a35af0f53d067c81$var$U && ($a35af0f53d067c81$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $a35af0f53d067c81$var$W(c, b, h);
            }
            $a35af0f53d067c81$var$Yj(a, b, c);
            break;
        case 21:
            $a35af0f53d067c81$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($a35af0f53d067c81$var$U = (d = $a35af0f53d067c81$var$U) || null !== c.memoizedState, $a35af0f53d067c81$var$Yj(a, b, c), $a35af0f53d067c81$var$U = d) : $a35af0f53d067c81$var$Yj(a, b, c);
            break;
        default:
            $a35af0f53d067c81$var$Yj(a, b, c);
    }
}
function $a35af0f53d067c81$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $a35af0f53d067c81$var$Kj);
        b.forEach(function(b) {
            var d = $a35af0f53d067c81$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $a35af0f53d067c81$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $a35af0f53d067c81$var$X = h.stateNode;
                        $a35af0f53d067c81$var$Xj = !1;
                        break a;
                    case 3:
                        $a35af0f53d067c81$var$X = h.stateNode.containerInfo;
                        $a35af0f53d067c81$var$Xj = !0;
                        break a;
                    case 4:
                        $a35af0f53d067c81$var$X = h.stateNode.containerInfo;
                        $a35af0f53d067c81$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $a35af0f53d067c81$var$X) throw Error($a35af0f53d067c81$var$p(160));
            $a35af0f53d067c81$var$Zj(f, g, e);
            $a35af0f53d067c81$var$X = null;
            $a35af0f53d067c81$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $a35af0f53d067c81$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$a35af0f53d067c81$var$dk(b, a), b = b.sibling;
}
function $a35af0f53d067c81$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a35af0f53d067c81$var$ck(b, a);
            $a35af0f53d067c81$var$ek(a);
            if (d & 4) {
                try {
                    $a35af0f53d067c81$var$Pj(3, a, a.return), $a35af0f53d067c81$var$Qj(3, a);
                } catch (t) {
                    $a35af0f53d067c81$var$W(a, a.return, t);
                }
                try {
                    $a35af0f53d067c81$var$Pj(5, a, a.return);
                } catch (t) {
                    $a35af0f53d067c81$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $a35af0f53d067c81$var$ck(b, a);
            $a35af0f53d067c81$var$ek(a);
            d & 512 && null !== c && $a35af0f53d067c81$var$Lj(c, c.return);
            break;
        case 5:
            $a35af0f53d067c81$var$ck(b, a);
            $a35af0f53d067c81$var$ek(a);
            d & 512 && null !== c && $a35af0f53d067c81$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $a35af0f53d067c81$var$ob(e, "");
                } catch (t) {
                    $a35af0f53d067c81$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $a35af0f53d067c81$var$ab(e, f);
                    $a35af0f53d067c81$var$vb(h, g);
                    var l = $a35af0f53d067c81$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $a35af0f53d067c81$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $a35af0f53d067c81$var$nb(e, q) : "children" === m ? $a35af0f53d067c81$var$ob(e, q) : $a35af0f53d067c81$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $a35af0f53d067c81$var$bb(e, f);
                            break;
                        case "textarea":
                            $a35af0f53d067c81$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $a35af0f53d067c81$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $a35af0f53d067c81$var$fb(e, !!f.multiple, f.defaultValue, !0) : $a35af0f53d067c81$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$a35af0f53d067c81$var$Pf] = f;
                } catch (t) {
                    $a35af0f53d067c81$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $a35af0f53d067c81$var$ck(b, a);
            $a35af0f53d067c81$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($a35af0f53d067c81$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $a35af0f53d067c81$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $a35af0f53d067c81$var$ck(b, a);
            $a35af0f53d067c81$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $a35af0f53d067c81$var$bd(b.containerInfo);
            } catch (t) {
                $a35af0f53d067c81$var$W(a, a.return, t);
            }
            break;
        case 4:
            $a35af0f53d067c81$var$ck(b, a);
            $a35af0f53d067c81$var$ek(a);
            break;
        case 13:
            $a35af0f53d067c81$var$ck(b, a);
            $a35af0f53d067c81$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($a35af0f53d067c81$var$fk = $a35af0f53d067c81$var$B()));
            d & 4 && $a35af0f53d067c81$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($a35af0f53d067c81$var$U = (l = $a35af0f53d067c81$var$U) || m, $a35af0f53d067c81$var$ck(b, a), $a35af0f53d067c81$var$U = l) : $a35af0f53d067c81$var$ck(b, a);
            $a35af0f53d067c81$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($a35af0f53d067c81$var$V = a, m = a.child; null !== m;){
                    for(q = $a35af0f53d067c81$var$V = m; null !== $a35af0f53d067c81$var$V;){
                        r = $a35af0f53d067c81$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $a35af0f53d067c81$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $a35af0f53d067c81$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $a35af0f53d067c81$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $a35af0f53d067c81$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $a35af0f53d067c81$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $a35af0f53d067c81$var$V = y) : $a35af0f53d067c81$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $a35af0f53d067c81$var$rb("display", g));
                            } catch (t) {
                                $a35af0f53d067c81$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $a35af0f53d067c81$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $a35af0f53d067c81$var$ck(b, a);
            $a35af0f53d067c81$var$ek(a);
            d & 4 && $a35af0f53d067c81$var$ak(a);
            break;
        case 21:
            break;
        default:
            $a35af0f53d067c81$var$ck(b, a), $a35af0f53d067c81$var$ek(a);
    }
}
function $a35af0f53d067c81$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($a35af0f53d067c81$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($a35af0f53d067c81$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($a35af0f53d067c81$var$ob(e, ""), d.flags &= -33);
                    var f = $a35af0f53d067c81$var$Uj(a);
                    $a35af0f53d067c81$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $a35af0f53d067c81$var$Uj(a);
                    $a35af0f53d067c81$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($a35af0f53d067c81$var$p(161));
            }
        } catch (k) {
            $a35af0f53d067c81$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $a35af0f53d067c81$var$hk(a, b, c) {
    $a35af0f53d067c81$var$V = a;
    $a35af0f53d067c81$var$ik(a, b, c);
}
function $a35af0f53d067c81$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $a35af0f53d067c81$var$V;){
        var e = $a35af0f53d067c81$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $a35af0f53d067c81$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $a35af0f53d067c81$var$U;
                h = $a35af0f53d067c81$var$Jj;
                var l = $a35af0f53d067c81$var$U;
                $a35af0f53d067c81$var$Jj = g;
                if (($a35af0f53d067c81$var$U = k) && !l) for($a35af0f53d067c81$var$V = e; null !== $a35af0f53d067c81$var$V;)g = $a35af0f53d067c81$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $a35af0f53d067c81$var$jk(e) : null !== k ? (k.return = g, $a35af0f53d067c81$var$V = k) : $a35af0f53d067c81$var$jk(e);
                for(; null !== f;)$a35af0f53d067c81$var$V = f, $a35af0f53d067c81$var$ik(f, b, c), f = f.sibling;
                $a35af0f53d067c81$var$V = e;
                $a35af0f53d067c81$var$Jj = h;
                $a35af0f53d067c81$var$U = l;
            }
            $a35af0f53d067c81$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $a35af0f53d067c81$var$V = f) : $a35af0f53d067c81$var$kk(a, b, c);
    }
}
function $a35af0f53d067c81$var$kk(a) {
    for(; null !== $a35af0f53d067c81$var$V;){
        var b = $a35af0f53d067c81$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $a35af0f53d067c81$var$U || $a35af0f53d067c81$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$a35af0f53d067c81$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $a35af0f53d067c81$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $a35af0f53d067c81$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $a35af0f53d067c81$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $a35af0f53d067c81$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($a35af0f53d067c81$var$p(163));
                }
                $a35af0f53d067c81$var$U || b.flags & 512 && $a35af0f53d067c81$var$Rj(b);
            } catch (r) {
                $a35af0f53d067c81$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $a35af0f53d067c81$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a35af0f53d067c81$var$V = c;
            break;
        }
        $a35af0f53d067c81$var$V = b.return;
    }
}
function $a35af0f53d067c81$var$gk(a) {
    for(; null !== $a35af0f53d067c81$var$V;){
        var b = $a35af0f53d067c81$var$V;
        if (b === a) {
            $a35af0f53d067c81$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a35af0f53d067c81$var$V = c;
            break;
        }
        $a35af0f53d067c81$var$V = b.return;
    }
}
function $a35af0f53d067c81$var$jk(a) {
    for(; null !== $a35af0f53d067c81$var$V;){
        var b = $a35af0f53d067c81$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $a35af0f53d067c81$var$Qj(4, b);
                    } catch (k) {
                        $a35af0f53d067c81$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $a35af0f53d067c81$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $a35af0f53d067c81$var$Rj(b);
                    } catch (k) {
                        $a35af0f53d067c81$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $a35af0f53d067c81$var$Rj(b);
                    } catch (k) {
                        $a35af0f53d067c81$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $a35af0f53d067c81$var$W(b, b.return, k);
        }
        if (b === a) {
            $a35af0f53d067c81$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $a35af0f53d067c81$var$V = h;
            break;
        }
        $a35af0f53d067c81$var$V = b.return;
    }
}
var $a35af0f53d067c81$var$lk = Math.ceil, $a35af0f53d067c81$var$mk = $a35af0f53d067c81$var$ua.ReactCurrentDispatcher, $a35af0f53d067c81$var$nk = $a35af0f53d067c81$var$ua.ReactCurrentOwner, $a35af0f53d067c81$var$ok = $a35af0f53d067c81$var$ua.ReactCurrentBatchConfig, $a35af0f53d067c81$var$K = 0, $a35af0f53d067c81$var$Q = null, $a35af0f53d067c81$var$Y = null, $a35af0f53d067c81$var$Z = 0, $a35af0f53d067c81$var$fj = 0, $a35af0f53d067c81$var$ej = $a35af0f53d067c81$var$Uf(0), $a35af0f53d067c81$var$T = 0, $a35af0f53d067c81$var$pk = null, $a35af0f53d067c81$var$rh = 0, $a35af0f53d067c81$var$qk = 0, $a35af0f53d067c81$var$rk = 0, $a35af0f53d067c81$var$sk = null, $a35af0f53d067c81$var$tk = null, $a35af0f53d067c81$var$fk = 0, $a35af0f53d067c81$var$Gj = Infinity, $a35af0f53d067c81$var$uk = null, $a35af0f53d067c81$var$Oi = !1, $a35af0f53d067c81$var$Pi = null, $a35af0f53d067c81$var$Ri = null, $a35af0f53d067c81$var$vk = !1, $a35af0f53d067c81$var$wk = null, $a35af0f53d067c81$var$xk = 0, $a35af0f53d067c81$var$yk = 0, $a35af0f53d067c81$var$zk = null, $a35af0f53d067c81$var$Ak = -1, $a35af0f53d067c81$var$Bk = 0;
function $a35af0f53d067c81$var$R() {
    return 0 !== ($a35af0f53d067c81$var$K & 6) ? $a35af0f53d067c81$var$B() : -1 !== $a35af0f53d067c81$var$Ak ? $a35af0f53d067c81$var$Ak : $a35af0f53d067c81$var$Ak = $a35af0f53d067c81$var$B();
}
function $a35af0f53d067c81$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($a35af0f53d067c81$var$K & 2) && 0 !== $a35af0f53d067c81$var$Z) return $a35af0f53d067c81$var$Z & -$a35af0f53d067c81$var$Z;
    if (null !== $a35af0f53d067c81$var$Kg.transition) return 0 === $a35af0f53d067c81$var$Bk && ($a35af0f53d067c81$var$Bk = $a35af0f53d067c81$var$yc()), $a35af0f53d067c81$var$Bk;
    a = $a35af0f53d067c81$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $a35af0f53d067c81$var$jd(a.type);
    return a;
}
function $a35af0f53d067c81$var$gi(a, b, c, d) {
    if (50 < $a35af0f53d067c81$var$yk) throw $a35af0f53d067c81$var$yk = 0, $a35af0f53d067c81$var$zk = null, Error($a35af0f53d067c81$var$p(185));
    $a35af0f53d067c81$var$Ac(a, c, d);
    if (0 === ($a35af0f53d067c81$var$K & 2) || a !== $a35af0f53d067c81$var$Q) a === $a35af0f53d067c81$var$Q && (0 === ($a35af0f53d067c81$var$K & 2) && ($a35af0f53d067c81$var$qk |= c), 4 === $a35af0f53d067c81$var$T && $a35af0f53d067c81$var$Ck(a, $a35af0f53d067c81$var$Z)), $a35af0f53d067c81$var$Dk(a, d), 1 === c && 0 === $a35af0f53d067c81$var$K && 0 === (b.mode & 1) && ($a35af0f53d067c81$var$Gj = $a35af0f53d067c81$var$B() + 500, $a35af0f53d067c81$var$fg && $a35af0f53d067c81$var$jg());
}
function $a35af0f53d067c81$var$Dk(a, b) {
    var c = a.callbackNode;
    $a35af0f53d067c81$var$wc(a, b);
    var d = $a35af0f53d067c81$var$uc(a, a === $a35af0f53d067c81$var$Q ? $a35af0f53d067c81$var$Z : 0);
    if (0 === d) null !== c && $a35af0f53d067c81$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $a35af0f53d067c81$var$bc(c);
        if (1 === b) 0 === a.tag ? $a35af0f53d067c81$var$ig($a35af0f53d067c81$var$Ek.bind(null, a)) : $a35af0f53d067c81$var$hg($a35af0f53d067c81$var$Ek.bind(null, a)), $a35af0f53d067c81$var$Jf(function() {
            0 === ($a35af0f53d067c81$var$K & 6) && $a35af0f53d067c81$var$jg();
        }), c = null;
        else {
            switch($a35af0f53d067c81$var$Dc(d)){
                case 1:
                    c = $a35af0f53d067c81$var$fc;
                    break;
                case 4:
                    c = $a35af0f53d067c81$var$gc;
                    break;
                case 16:
                    c = $a35af0f53d067c81$var$hc;
                    break;
                case 536870912:
                    c = $a35af0f53d067c81$var$jc;
                    break;
                default:
                    c = $a35af0f53d067c81$var$hc;
            }
            c = $a35af0f53d067c81$var$Fk(c, $a35af0f53d067c81$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $a35af0f53d067c81$var$Gk(a, b) {
    $a35af0f53d067c81$var$Ak = -1;
    $a35af0f53d067c81$var$Bk = 0;
    if (0 !== ($a35af0f53d067c81$var$K & 6)) throw Error($a35af0f53d067c81$var$p(327));
    var c = a.callbackNode;
    if ($a35af0f53d067c81$var$Hk() && a.callbackNode !== c) return null;
    var d = $a35af0f53d067c81$var$uc(a, a === $a35af0f53d067c81$var$Q ? $a35af0f53d067c81$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $a35af0f53d067c81$var$Ik(a, d);
    else {
        b = d;
        var e = $a35af0f53d067c81$var$K;
        $a35af0f53d067c81$var$K |= 2;
        var f = $a35af0f53d067c81$var$Jk();
        if ($a35af0f53d067c81$var$Q !== a || $a35af0f53d067c81$var$Z !== b) $a35af0f53d067c81$var$uk = null, $a35af0f53d067c81$var$Gj = $a35af0f53d067c81$var$B() + 500, $a35af0f53d067c81$var$Kk(a, b);
        for(;;)try {
            $a35af0f53d067c81$var$Lk();
            break;
        } catch (h) {
            $a35af0f53d067c81$var$Mk(a, h);
        }
        $a35af0f53d067c81$var$$g();
        $a35af0f53d067c81$var$mk.current = f;
        $a35af0f53d067c81$var$K = e;
        null !== $a35af0f53d067c81$var$Y ? b = 0 : ($a35af0f53d067c81$var$Q = null, $a35af0f53d067c81$var$Z = 0, b = $a35af0f53d067c81$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $a35af0f53d067c81$var$xc(a), 0 !== e && (d = e, b = $a35af0f53d067c81$var$Nk(a, e)));
        if (1 === b) throw c = $a35af0f53d067c81$var$pk, $a35af0f53d067c81$var$Kk(a, 0), $a35af0f53d067c81$var$Ck(a, d), $a35af0f53d067c81$var$Dk(a, $a35af0f53d067c81$var$B()), c;
        if (6 === b) $a35af0f53d067c81$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$a35af0f53d067c81$var$Ok(e) && (b = $a35af0f53d067c81$var$Ik(a, d), 2 === b && (f = $a35af0f53d067c81$var$xc(a), 0 !== f && (d = f, b = $a35af0f53d067c81$var$Nk(a, f))), 1 === b)) throw c = $a35af0f53d067c81$var$pk, $a35af0f53d067c81$var$Kk(a, 0), $a35af0f53d067c81$var$Ck(a, d), $a35af0f53d067c81$var$Dk(a, $a35af0f53d067c81$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($a35af0f53d067c81$var$p(345));
                case 2:
                    $a35af0f53d067c81$var$Pk(a, $a35af0f53d067c81$var$tk, $a35af0f53d067c81$var$uk);
                    break;
                case 3:
                    $a35af0f53d067c81$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $a35af0f53d067c81$var$fk + 500 - $a35af0f53d067c81$var$B(), 10 < b)) {
                        if (0 !== $a35af0f53d067c81$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $a35af0f53d067c81$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $a35af0f53d067c81$var$Ff($a35af0f53d067c81$var$Pk.bind(null, a, $a35af0f53d067c81$var$tk, $a35af0f53d067c81$var$uk), b);
                        break;
                    }
                    $a35af0f53d067c81$var$Pk(a, $a35af0f53d067c81$var$tk, $a35af0f53d067c81$var$uk);
                    break;
                case 4:
                    $a35af0f53d067c81$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $a35af0f53d067c81$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $a35af0f53d067c81$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $a35af0f53d067c81$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $a35af0f53d067c81$var$Ff($a35af0f53d067c81$var$Pk.bind(null, a, $a35af0f53d067c81$var$tk, $a35af0f53d067c81$var$uk), d);
                        break;
                    }
                    $a35af0f53d067c81$var$Pk(a, $a35af0f53d067c81$var$tk, $a35af0f53d067c81$var$uk);
                    break;
                case 5:
                    $a35af0f53d067c81$var$Pk(a, $a35af0f53d067c81$var$tk, $a35af0f53d067c81$var$uk);
                    break;
                default:
                    throw Error($a35af0f53d067c81$var$p(329));
            }
        }
    }
    $a35af0f53d067c81$var$Dk(a, $a35af0f53d067c81$var$B());
    return a.callbackNode === c ? $a35af0f53d067c81$var$Gk.bind(null, a) : null;
}
function $a35af0f53d067c81$var$Nk(a, b) {
    var c = $a35af0f53d067c81$var$sk;
    a.current.memoizedState.isDehydrated && ($a35af0f53d067c81$var$Kk(a, b).flags |= 256);
    a = $a35af0f53d067c81$var$Ik(a, b);
    2 !== a && (b = $a35af0f53d067c81$var$tk, $a35af0f53d067c81$var$tk = c, null !== b && $a35af0f53d067c81$var$Fj(b));
    return a;
}
function $a35af0f53d067c81$var$Fj(a) {
    null === $a35af0f53d067c81$var$tk ? $a35af0f53d067c81$var$tk = a : $a35af0f53d067c81$var$tk.push.apply($a35af0f53d067c81$var$tk, a);
}
function $a35af0f53d067c81$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$a35af0f53d067c81$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $a35af0f53d067c81$var$Ck(a, b) {
    b &= ~$a35af0f53d067c81$var$rk;
    b &= ~$a35af0f53d067c81$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $a35af0f53d067c81$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $a35af0f53d067c81$var$Ek(a) {
    if (0 !== ($a35af0f53d067c81$var$K & 6)) throw Error($a35af0f53d067c81$var$p(327));
    $a35af0f53d067c81$var$Hk();
    var b = $a35af0f53d067c81$var$uc(a, 0);
    if (0 === (b & 1)) return $a35af0f53d067c81$var$Dk(a, $a35af0f53d067c81$var$B()), null;
    var c = $a35af0f53d067c81$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $a35af0f53d067c81$var$xc(a);
        0 !== d && (b = d, c = $a35af0f53d067c81$var$Nk(a, d));
    }
    if (1 === c) throw c = $a35af0f53d067c81$var$pk, $a35af0f53d067c81$var$Kk(a, 0), $a35af0f53d067c81$var$Ck(a, b), $a35af0f53d067c81$var$Dk(a, $a35af0f53d067c81$var$B()), c;
    if (6 === c) throw Error($a35af0f53d067c81$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $a35af0f53d067c81$var$Pk(a, $a35af0f53d067c81$var$tk, $a35af0f53d067c81$var$uk);
    $a35af0f53d067c81$var$Dk(a, $a35af0f53d067c81$var$B());
    return null;
}
function $a35af0f53d067c81$var$Qk(a, b) {
    var c = $a35af0f53d067c81$var$K;
    $a35af0f53d067c81$var$K |= 1;
    try {
        return a(b);
    } finally{
        $a35af0f53d067c81$var$K = c, 0 === $a35af0f53d067c81$var$K && ($a35af0f53d067c81$var$Gj = $a35af0f53d067c81$var$B() + 500, $a35af0f53d067c81$var$fg && $a35af0f53d067c81$var$jg());
    }
}
function $a35af0f53d067c81$var$Rk(a) {
    null !== $a35af0f53d067c81$var$wk && 0 === $a35af0f53d067c81$var$wk.tag && 0 === ($a35af0f53d067c81$var$K & 6) && $a35af0f53d067c81$var$Hk();
    var b = $a35af0f53d067c81$var$K;
    $a35af0f53d067c81$var$K |= 1;
    var c = $a35af0f53d067c81$var$ok.transition, d = $a35af0f53d067c81$var$C;
    try {
        if ($a35af0f53d067c81$var$ok.transition = null, $a35af0f53d067c81$var$C = 1, a) return a();
    } finally{
        $a35af0f53d067c81$var$C = d, $a35af0f53d067c81$var$ok.transition = c, $a35af0f53d067c81$var$K = b, 0 === ($a35af0f53d067c81$var$K & 6) && $a35af0f53d067c81$var$jg();
    }
}
function $a35af0f53d067c81$var$Hj() {
    $a35af0f53d067c81$var$fj = $a35af0f53d067c81$var$ej.current;
    $a35af0f53d067c81$var$E($a35af0f53d067c81$var$ej);
}
function $a35af0f53d067c81$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $a35af0f53d067c81$var$Gf(c));
    if (null !== $a35af0f53d067c81$var$Y) for(c = $a35af0f53d067c81$var$Y.return; null !== c;){
        var d = c;
        $a35af0f53d067c81$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $a35af0f53d067c81$var$$f();
                break;
            case 3:
                $a35af0f53d067c81$var$zh();
                $a35af0f53d067c81$var$E($a35af0f53d067c81$var$Wf);
                $a35af0f53d067c81$var$E($a35af0f53d067c81$var$H);
                $a35af0f53d067c81$var$Eh();
                break;
            case 5:
                $a35af0f53d067c81$var$Bh(d);
                break;
            case 4:
                $a35af0f53d067c81$var$zh();
                break;
            case 13:
                $a35af0f53d067c81$var$E($a35af0f53d067c81$var$L);
                break;
            case 19:
                $a35af0f53d067c81$var$E($a35af0f53d067c81$var$L);
                break;
            case 10:
                $a35af0f53d067c81$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $a35af0f53d067c81$var$Hj();
        }
        c = c.return;
    }
    $a35af0f53d067c81$var$Q = a;
    $a35af0f53d067c81$var$Y = a = $a35af0f53d067c81$var$Pg(a.current, null);
    $a35af0f53d067c81$var$Z = $a35af0f53d067c81$var$fj = b;
    $a35af0f53d067c81$var$T = 0;
    $a35af0f53d067c81$var$pk = null;
    $a35af0f53d067c81$var$rk = $a35af0f53d067c81$var$qk = $a35af0f53d067c81$var$rh = 0;
    $a35af0f53d067c81$var$tk = $a35af0f53d067c81$var$sk = null;
    if (null !== $a35af0f53d067c81$var$fh) {
        for(b = 0; b < $a35af0f53d067c81$var$fh.length; b++)if (c = $a35af0f53d067c81$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $a35af0f53d067c81$var$fh = null;
    }
    return a;
}
function $a35af0f53d067c81$var$Mk(a, b) {
    do {
        var c = $a35af0f53d067c81$var$Y;
        try {
            $a35af0f53d067c81$var$$g();
            $a35af0f53d067c81$var$Fh.current = $a35af0f53d067c81$var$Rh;
            if ($a35af0f53d067c81$var$Ih) {
                for(var d = $a35af0f53d067c81$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $a35af0f53d067c81$var$Ih = !1;
            }
            $a35af0f53d067c81$var$Hh = 0;
            $a35af0f53d067c81$var$O = $a35af0f53d067c81$var$N = $a35af0f53d067c81$var$M = null;
            $a35af0f53d067c81$var$Jh = !1;
            $a35af0f53d067c81$var$Kh = 0;
            $a35af0f53d067c81$var$nk.current = null;
            if (null === c || null === c.return) {
                $a35af0f53d067c81$var$T = 1;
                $a35af0f53d067c81$var$pk = b;
                $a35af0f53d067c81$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $a35af0f53d067c81$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $a35af0f53d067c81$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $a35af0f53d067c81$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $a35af0f53d067c81$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $a35af0f53d067c81$var$Si(f, l, b);
                            $a35af0f53d067c81$var$tj();
                            break a;
                        }
                        k = Error($a35af0f53d067c81$var$p(426));
                    }
                } else if ($a35af0f53d067c81$var$I && h.mode & 1) {
                    var J = $a35af0f53d067c81$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $a35af0f53d067c81$var$Vi(J, g, h, f, b);
                        $a35af0f53d067c81$var$Jg($a35af0f53d067c81$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $a35af0f53d067c81$var$Ji(k, h);
                4 !== $a35af0f53d067c81$var$T && ($a35af0f53d067c81$var$T = 2);
                null === $a35af0f53d067c81$var$sk ? $a35af0f53d067c81$var$sk = [
                    f
                ] : $a35af0f53d067c81$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $a35af0f53d067c81$var$Ni(f, k, b);
                            $a35af0f53d067c81$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $a35af0f53d067c81$var$Ri || !$a35af0f53d067c81$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $a35af0f53d067c81$var$Qi(f, h, b);
                                $a35af0f53d067c81$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $a35af0f53d067c81$var$Sk(c);
        } catch (na) {
            b = na;
            $a35af0f53d067c81$var$Y === c && null !== c && ($a35af0f53d067c81$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $a35af0f53d067c81$var$Jk() {
    var a = $a35af0f53d067c81$var$mk.current;
    $a35af0f53d067c81$var$mk.current = $a35af0f53d067c81$var$Rh;
    return null === a ? $a35af0f53d067c81$var$Rh : a;
}
function $a35af0f53d067c81$var$tj() {
    if (0 === $a35af0f53d067c81$var$T || 3 === $a35af0f53d067c81$var$T || 2 === $a35af0f53d067c81$var$T) $a35af0f53d067c81$var$T = 4;
    null === $a35af0f53d067c81$var$Q || 0 === ($a35af0f53d067c81$var$rh & 268435455) && 0 === ($a35af0f53d067c81$var$qk & 268435455) || $a35af0f53d067c81$var$Ck($a35af0f53d067c81$var$Q, $a35af0f53d067c81$var$Z);
}
function $a35af0f53d067c81$var$Ik(a, b) {
    var c = $a35af0f53d067c81$var$K;
    $a35af0f53d067c81$var$K |= 2;
    var d = $a35af0f53d067c81$var$Jk();
    if ($a35af0f53d067c81$var$Q !== a || $a35af0f53d067c81$var$Z !== b) $a35af0f53d067c81$var$uk = null, $a35af0f53d067c81$var$Kk(a, b);
    for(;;)try {
        $a35af0f53d067c81$var$Tk();
        break;
    } catch (e) {
        $a35af0f53d067c81$var$Mk(a, e);
    }
    $a35af0f53d067c81$var$$g();
    $a35af0f53d067c81$var$K = c;
    $a35af0f53d067c81$var$mk.current = d;
    if (null !== $a35af0f53d067c81$var$Y) throw Error($a35af0f53d067c81$var$p(261));
    $a35af0f53d067c81$var$Q = null;
    $a35af0f53d067c81$var$Z = 0;
    return $a35af0f53d067c81$var$T;
}
function $a35af0f53d067c81$var$Tk() {
    for(; null !== $a35af0f53d067c81$var$Y;)$a35af0f53d067c81$var$Uk($a35af0f53d067c81$var$Y);
}
function $a35af0f53d067c81$var$Lk() {
    for(; null !== $a35af0f53d067c81$var$Y && !$a35af0f53d067c81$var$cc();)$a35af0f53d067c81$var$Uk($a35af0f53d067c81$var$Y);
}
function $a35af0f53d067c81$var$Uk(a) {
    var b = $a35af0f53d067c81$var$Vk(a.alternate, a, $a35af0f53d067c81$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $a35af0f53d067c81$var$Sk(a) : $a35af0f53d067c81$var$Y = b;
    $a35af0f53d067c81$var$nk.current = null;
}
function $a35af0f53d067c81$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $a35af0f53d067c81$var$Ej(c, b, $a35af0f53d067c81$var$fj), null !== c) {
                $a35af0f53d067c81$var$Y = c;
                return;
            }
        } else {
            c = $a35af0f53d067c81$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $a35af0f53d067c81$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $a35af0f53d067c81$var$T = 6;
                $a35af0f53d067c81$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $a35af0f53d067c81$var$Y = b;
            return;
        }
        $a35af0f53d067c81$var$Y = b = a;
    }while (null !== b);
    0 === $a35af0f53d067c81$var$T && ($a35af0f53d067c81$var$T = 5);
}
function $a35af0f53d067c81$var$Pk(a, b, c) {
    var d = $a35af0f53d067c81$var$C, e = $a35af0f53d067c81$var$ok.transition;
    try {
        $a35af0f53d067c81$var$ok.transition = null, $a35af0f53d067c81$var$C = 1, $a35af0f53d067c81$var$Wk(a, b, c, d);
    } finally{
        $a35af0f53d067c81$var$ok.transition = e, $a35af0f53d067c81$var$C = d;
    }
    return null;
}
function $a35af0f53d067c81$var$Wk(a, b, c, d) {
    do $a35af0f53d067c81$var$Hk();
    while (null !== $a35af0f53d067c81$var$wk);
    if (0 !== ($a35af0f53d067c81$var$K & 6)) throw Error($a35af0f53d067c81$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($a35af0f53d067c81$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $a35af0f53d067c81$var$Bc(a, f);
    a === $a35af0f53d067c81$var$Q && ($a35af0f53d067c81$var$Y = $a35af0f53d067c81$var$Q = null, $a35af0f53d067c81$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $a35af0f53d067c81$var$vk || ($a35af0f53d067c81$var$vk = !0, $a35af0f53d067c81$var$Fk($a35af0f53d067c81$var$hc, function() {
        $a35af0f53d067c81$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $a35af0f53d067c81$var$ok.transition;
        $a35af0f53d067c81$var$ok.transition = null;
        var g = $a35af0f53d067c81$var$C;
        $a35af0f53d067c81$var$C = 1;
        var h = $a35af0f53d067c81$var$K;
        $a35af0f53d067c81$var$K |= 4;
        $a35af0f53d067c81$var$nk.current = null;
        $a35af0f53d067c81$var$Oj(a, c);
        $a35af0f53d067c81$var$dk(c, a);
        $a35af0f53d067c81$var$Oe($a35af0f53d067c81$var$Df);
        $a35af0f53d067c81$var$dd = !!$a35af0f53d067c81$var$Cf;
        $a35af0f53d067c81$var$Df = $a35af0f53d067c81$var$Cf = null;
        a.current = c;
        $a35af0f53d067c81$var$hk(c, a, e);
        $a35af0f53d067c81$var$dc();
        $a35af0f53d067c81$var$K = h;
        $a35af0f53d067c81$var$C = g;
        $a35af0f53d067c81$var$ok.transition = f;
    } else a.current = c;
    $a35af0f53d067c81$var$vk && ($a35af0f53d067c81$var$vk = !1, $a35af0f53d067c81$var$wk = a, $a35af0f53d067c81$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($a35af0f53d067c81$var$Ri = null);
    $a35af0f53d067c81$var$mc(c.stateNode, d);
    $a35af0f53d067c81$var$Dk(a, $a35af0f53d067c81$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($a35af0f53d067c81$var$Oi) throw $a35af0f53d067c81$var$Oi = !1, a = $a35af0f53d067c81$var$Pi, $a35af0f53d067c81$var$Pi = null, a;
    0 !== ($a35af0f53d067c81$var$xk & 1) && 0 !== a.tag && $a35af0f53d067c81$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $a35af0f53d067c81$var$zk ? $a35af0f53d067c81$var$yk++ : ($a35af0f53d067c81$var$yk = 0, $a35af0f53d067c81$var$zk = a) : $a35af0f53d067c81$var$yk = 0;
    $a35af0f53d067c81$var$jg();
    return null;
}
function $a35af0f53d067c81$var$Hk() {
    if (null !== $a35af0f53d067c81$var$wk) {
        var a = $a35af0f53d067c81$var$Dc($a35af0f53d067c81$var$xk), b = $a35af0f53d067c81$var$ok.transition, c = $a35af0f53d067c81$var$C;
        try {
            $a35af0f53d067c81$var$ok.transition = null;
            $a35af0f53d067c81$var$C = 16 > a ? 16 : a;
            if (null === $a35af0f53d067c81$var$wk) var d = !1;
            else {
                a = $a35af0f53d067c81$var$wk;
                $a35af0f53d067c81$var$wk = null;
                $a35af0f53d067c81$var$xk = 0;
                if (0 !== ($a35af0f53d067c81$var$K & 6)) throw Error($a35af0f53d067c81$var$p(331));
                var e = $a35af0f53d067c81$var$K;
                $a35af0f53d067c81$var$K |= 4;
                for($a35af0f53d067c81$var$V = a.current; null !== $a35af0f53d067c81$var$V;){
                    var f = $a35af0f53d067c81$var$V, g = f.child;
                    if (0 !== ($a35af0f53d067c81$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($a35af0f53d067c81$var$V = l; null !== $a35af0f53d067c81$var$V;){
                                    var m = $a35af0f53d067c81$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $a35af0f53d067c81$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $a35af0f53d067c81$var$V = q;
                                    else for(; null !== $a35af0f53d067c81$var$V;){
                                        m = $a35af0f53d067c81$var$V;
                                        var r = m.sibling, y = m.return;
                                        $a35af0f53d067c81$var$Sj(m);
                                        if (m === l) {
                                            $a35af0f53d067c81$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $a35af0f53d067c81$var$V = r;
                                            break;
                                        }
                                        $a35af0f53d067c81$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $a35af0f53d067c81$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $a35af0f53d067c81$var$V = g;
                    else b: for(; null !== $a35af0f53d067c81$var$V;){
                        f = $a35af0f53d067c81$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $a35af0f53d067c81$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $a35af0f53d067c81$var$V = x;
                            break b;
                        }
                        $a35af0f53d067c81$var$V = f.return;
                    }
                }
                var w = a.current;
                for($a35af0f53d067c81$var$V = w; null !== $a35af0f53d067c81$var$V;){
                    g = $a35af0f53d067c81$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $a35af0f53d067c81$var$V = u;
                    else b: for(g = w; null !== $a35af0f53d067c81$var$V;){
                        h = $a35af0f53d067c81$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $a35af0f53d067c81$var$Qj(9, h);
                            }
                        } catch (na) {
                            $a35af0f53d067c81$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $a35af0f53d067c81$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $a35af0f53d067c81$var$V = F;
                            break b;
                        }
                        $a35af0f53d067c81$var$V = h.return;
                    }
                }
                $a35af0f53d067c81$var$K = e;
                $a35af0f53d067c81$var$jg();
                if ($a35af0f53d067c81$var$lc && "function" === typeof $a35af0f53d067c81$var$lc.onPostCommitFiberRoot) try {
                    $a35af0f53d067c81$var$lc.onPostCommitFiberRoot($a35af0f53d067c81$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $a35af0f53d067c81$var$C = c, $a35af0f53d067c81$var$ok.transition = b;
        }
    }
    return !1;
}
function $a35af0f53d067c81$var$Xk(a, b, c) {
    b = $a35af0f53d067c81$var$Ji(c, b);
    b = $a35af0f53d067c81$var$Ni(a, b, 1);
    a = $a35af0f53d067c81$var$nh(a, b, 1);
    b = $a35af0f53d067c81$var$R();
    null !== a && ($a35af0f53d067c81$var$Ac(a, 1, b), $a35af0f53d067c81$var$Dk(a, b));
}
function $a35af0f53d067c81$var$W(a, b, c) {
    if (3 === a.tag) $a35af0f53d067c81$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $a35af0f53d067c81$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $a35af0f53d067c81$var$Ri || !$a35af0f53d067c81$var$Ri.has(d))) {
                a = $a35af0f53d067c81$var$Ji(c, a);
                a = $a35af0f53d067c81$var$Qi(b, a, 1);
                b = $a35af0f53d067c81$var$nh(b, a, 1);
                a = $a35af0f53d067c81$var$R();
                null !== b && ($a35af0f53d067c81$var$Ac(b, 1, a), $a35af0f53d067c81$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $a35af0f53d067c81$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $a35af0f53d067c81$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $a35af0f53d067c81$var$Q === a && ($a35af0f53d067c81$var$Z & c) === c && (4 === $a35af0f53d067c81$var$T || 3 === $a35af0f53d067c81$var$T && ($a35af0f53d067c81$var$Z & 130023424) === $a35af0f53d067c81$var$Z && 500 > $a35af0f53d067c81$var$B() - $a35af0f53d067c81$var$fk ? $a35af0f53d067c81$var$Kk(a, 0) : $a35af0f53d067c81$var$rk |= c);
    $a35af0f53d067c81$var$Dk(a, b);
}
function $a35af0f53d067c81$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $a35af0f53d067c81$var$sc, $a35af0f53d067c81$var$sc <<= 1, 0 === ($a35af0f53d067c81$var$sc & 130023424) && ($a35af0f53d067c81$var$sc = 4194304)));
    var c = $a35af0f53d067c81$var$R();
    a = $a35af0f53d067c81$var$ih(a, b);
    null !== a && ($a35af0f53d067c81$var$Ac(a, b, c), $a35af0f53d067c81$var$Dk(a, c));
}
function $a35af0f53d067c81$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $a35af0f53d067c81$var$Yk(a, c);
}
function $a35af0f53d067c81$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($a35af0f53d067c81$var$p(314));
    }
    null !== d && d.delete(b);
    $a35af0f53d067c81$var$Yk(a, c);
}
var $a35af0f53d067c81$var$Vk;
$a35af0f53d067c81$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $a35af0f53d067c81$var$Wf.current) $a35af0f53d067c81$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $a35af0f53d067c81$var$dh = !1, $a35af0f53d067c81$var$yj(a, b, c);
            $a35af0f53d067c81$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $a35af0f53d067c81$var$dh = !1, $a35af0f53d067c81$var$I && 0 !== (b.flags & 1048576) && $a35af0f53d067c81$var$ug(b, $a35af0f53d067c81$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $a35af0f53d067c81$var$ij(a, b);
            a = b.pendingProps;
            var e = $a35af0f53d067c81$var$Yf(b, $a35af0f53d067c81$var$H.current);
            $a35af0f53d067c81$var$ch(b, c);
            e = $a35af0f53d067c81$var$Nh(null, b, d, a, e, c);
            var f = $a35af0f53d067c81$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $a35af0f53d067c81$var$Zf(d) ? (f = !0, $a35af0f53d067c81$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $a35af0f53d067c81$var$kh(b), e.updater = $a35af0f53d067c81$var$Ei, b.stateNode = e, e._reactInternals = b, $a35af0f53d067c81$var$Ii(b, d, a, c), b = $a35af0f53d067c81$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $a35af0f53d067c81$var$I && f && $a35af0f53d067c81$var$vg(b), $a35af0f53d067c81$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $a35af0f53d067c81$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $a35af0f53d067c81$var$Zk(d);
                a = $a35af0f53d067c81$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $a35af0f53d067c81$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $a35af0f53d067c81$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $a35af0f53d067c81$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $a35af0f53d067c81$var$$i(null, b, d, $a35af0f53d067c81$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($a35af0f53d067c81$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a35af0f53d067c81$var$Ci(d, e), $a35af0f53d067c81$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a35af0f53d067c81$var$Ci(d, e), $a35af0f53d067c81$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $a35af0f53d067c81$var$kj(b);
                if (null === a) throw Error($a35af0f53d067c81$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $a35af0f53d067c81$var$lh(a, b);
                $a35af0f53d067c81$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $a35af0f53d067c81$var$Ji(Error($a35af0f53d067c81$var$p(423)), b);
                        b = $a35af0f53d067c81$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $a35af0f53d067c81$var$Ji(Error($a35af0f53d067c81$var$p(424)), b);
                        b = $a35af0f53d067c81$var$lj(a, b, d, c, e);
                        break a;
                    } else for($a35af0f53d067c81$var$yg = $a35af0f53d067c81$var$Lf(b.stateNode.containerInfo.firstChild), $a35af0f53d067c81$var$xg = b, $a35af0f53d067c81$var$I = !0, $a35af0f53d067c81$var$zg = null, c = $a35af0f53d067c81$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $a35af0f53d067c81$var$Ig();
                    if (d === e) {
                        b = $a35af0f53d067c81$var$Zi(a, b, c);
                        break a;
                    }
                    $a35af0f53d067c81$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $a35af0f53d067c81$var$Ah(b), null === a && $a35af0f53d067c81$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $a35af0f53d067c81$var$Ef(d, e) ? g = null : null !== f && $a35af0f53d067c81$var$Ef(d, f) && (b.flags |= 32), $a35af0f53d067c81$var$gj(a, b), $a35af0f53d067c81$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $a35af0f53d067c81$var$Eg(b), null;
        case 13:
            return $a35af0f53d067c81$var$oj(a, b, c);
        case 4:
            return $a35af0f53d067c81$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $a35af0f53d067c81$var$Ug(b, null, d, c) : $a35af0f53d067c81$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a35af0f53d067c81$var$Ci(d, e), $a35af0f53d067c81$var$Yi(a, b, d, e, c);
        case 7:
            return $a35af0f53d067c81$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $a35af0f53d067c81$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $a35af0f53d067c81$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $a35af0f53d067c81$var$G($a35af0f53d067c81$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($a35af0f53d067c81$var$He(f.value, g)) {
                        if (f.children === e.children && !$a35af0f53d067c81$var$Wf.current) {
                            b = $a35af0f53d067c81$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $a35af0f53d067c81$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $a35af0f53d067c81$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($a35af0f53d067c81$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $a35af0f53d067c81$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $a35af0f53d067c81$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $a35af0f53d067c81$var$ch(b, c), e = $a35af0f53d067c81$var$eh(e), d = d(e), b.flags |= 1, $a35af0f53d067c81$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $a35af0f53d067c81$var$Ci(d, b.pendingProps), e = $a35af0f53d067c81$var$Ci(d.type, e), $a35af0f53d067c81$var$$i(a, b, d, e, c);
        case 15:
            return $a35af0f53d067c81$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a35af0f53d067c81$var$Ci(d, e), $a35af0f53d067c81$var$ij(a, b), b.tag = 1, $a35af0f53d067c81$var$Zf(d) ? (a = !0, $a35af0f53d067c81$var$cg(b)) : a = !1, $a35af0f53d067c81$var$ch(b, c), $a35af0f53d067c81$var$Gi(b, d, e), $a35af0f53d067c81$var$Ii(b, d, e, c), $a35af0f53d067c81$var$jj(null, b, d, !0, a, c);
        case 19:
            return $a35af0f53d067c81$var$xj(a, b, c);
        case 22:
            return $a35af0f53d067c81$var$dj(a, b, c);
    }
    throw Error($a35af0f53d067c81$var$p(156, b.tag));
};
function $a35af0f53d067c81$var$Fk(a, b) {
    return $a35af0f53d067c81$var$ac(a, b);
}
function $a35af0f53d067c81$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a35af0f53d067c81$var$Bg(a, b, c, d) {
    return new $a35af0f53d067c81$var$$k(a, b, c, d);
}
function $a35af0f53d067c81$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $a35af0f53d067c81$var$Zk(a) {
    if ("function" === typeof a) return $a35af0f53d067c81$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $a35af0f53d067c81$var$Da) return 11;
        if (a === $a35af0f53d067c81$var$Ga) return 14;
    }
    return 2;
}
function $a35af0f53d067c81$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $a35af0f53d067c81$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $a35af0f53d067c81$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $a35af0f53d067c81$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $a35af0f53d067c81$var$ya:
            return $a35af0f53d067c81$var$Tg(c.children, e, f, b);
        case $a35af0f53d067c81$var$za:
            g = 8;
            e |= 8;
            break;
        case $a35af0f53d067c81$var$Aa:
            return a = $a35af0f53d067c81$var$Bg(12, c, b, e | 2), a.elementType = $a35af0f53d067c81$var$Aa, a.lanes = f, a;
        case $a35af0f53d067c81$var$Ea:
            return a = $a35af0f53d067c81$var$Bg(13, c, b, e), a.elementType = $a35af0f53d067c81$var$Ea, a.lanes = f, a;
        case $a35af0f53d067c81$var$Fa:
            return a = $a35af0f53d067c81$var$Bg(19, c, b, e), a.elementType = $a35af0f53d067c81$var$Fa, a.lanes = f, a;
        case $a35af0f53d067c81$var$Ia:
            return $a35af0f53d067c81$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $a35af0f53d067c81$var$Ba:
                    g = 10;
                    break a;
                case $a35af0f53d067c81$var$Ca:
                    g = 9;
                    break a;
                case $a35af0f53d067c81$var$Da:
                    g = 11;
                    break a;
                case $a35af0f53d067c81$var$Ga:
                    g = 14;
                    break a;
                case $a35af0f53d067c81$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($a35af0f53d067c81$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $a35af0f53d067c81$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $a35af0f53d067c81$var$Tg(a, b, c, d) {
    a = $a35af0f53d067c81$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $a35af0f53d067c81$var$pj(a, b, c, d) {
    a = $a35af0f53d067c81$var$Bg(22, a, d, b);
    a.elementType = $a35af0f53d067c81$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $a35af0f53d067c81$var$Qg(a, b, c) {
    a = $a35af0f53d067c81$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $a35af0f53d067c81$var$Sg(a, b, c) {
    b = $a35af0f53d067c81$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $a35af0f53d067c81$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $a35af0f53d067c81$var$zc(0);
    this.expirationTimes = $a35af0f53d067c81$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a35af0f53d067c81$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $a35af0f53d067c81$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $a35af0f53d067c81$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $a35af0f53d067c81$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $a35af0f53d067c81$var$kh(f);
    return a;
}
function $a35af0f53d067c81$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a35af0f53d067c81$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $a35af0f53d067c81$var$dl(a) {
    if (!a) return $a35af0f53d067c81$var$Vf;
    a = a._reactInternals;
    a: {
        if ($a35af0f53d067c81$var$Vb(a) !== a || 1 !== a.tag) throw Error($a35af0f53d067c81$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($a35af0f53d067c81$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($a35af0f53d067c81$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($a35af0f53d067c81$var$Zf(c)) return $a35af0f53d067c81$var$bg(a, c, b);
    }
    return b;
}
function $a35af0f53d067c81$var$el(a, b, c, d, e, f, g, h, k) {
    a = $a35af0f53d067c81$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $a35af0f53d067c81$var$dl(null);
    c = a.current;
    d = $a35af0f53d067c81$var$R();
    e = $a35af0f53d067c81$var$yi(c);
    f = $a35af0f53d067c81$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $a35af0f53d067c81$var$nh(c, f, e);
    a.current.lanes = e;
    $a35af0f53d067c81$var$Ac(a, e, d);
    $a35af0f53d067c81$var$Dk(a, d);
    return a;
}
function $a35af0f53d067c81$var$fl(a, b, c, d) {
    var e = b.current, f = $a35af0f53d067c81$var$R(), g = $a35af0f53d067c81$var$yi(e);
    c = $a35af0f53d067c81$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $a35af0f53d067c81$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $a35af0f53d067c81$var$nh(e, b, g);
    null !== a && ($a35af0f53d067c81$var$gi(a, e, g, f), $a35af0f53d067c81$var$oh(a, e, g));
    return g;
}
function $a35af0f53d067c81$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $a35af0f53d067c81$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $a35af0f53d067c81$var$il(a, b) {
    $a35af0f53d067c81$var$hl(a, b);
    (a = a.alternate) && $a35af0f53d067c81$var$hl(a, b);
}
function $a35af0f53d067c81$var$jl() {
    return null;
}
var $a35af0f53d067c81$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $a35af0f53d067c81$var$ll(a) {
    this._internalRoot = a;
}
$a35af0f53d067c81$var$ml.prototype.render = $a35af0f53d067c81$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($a35af0f53d067c81$var$p(409));
    $a35af0f53d067c81$var$fl(a, b, null, null);
};
$a35af0f53d067c81$var$ml.prototype.unmount = $a35af0f53d067c81$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $a35af0f53d067c81$var$Rk(function() {
            $a35af0f53d067c81$var$fl(null, a, null, null);
        });
        b[$a35af0f53d067c81$var$uf] = null;
    }
};
function $a35af0f53d067c81$var$ml(a) {
    this._internalRoot = a;
}
$a35af0f53d067c81$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $a35af0f53d067c81$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $a35af0f53d067c81$var$Qc.length && 0 !== b && b < $a35af0f53d067c81$var$Qc[c].priority; c++);
        $a35af0f53d067c81$var$Qc.splice(c, 0, a);
        0 === c && $a35af0f53d067c81$var$Vc(a);
    }
};
function $a35af0f53d067c81$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $a35af0f53d067c81$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $a35af0f53d067c81$var$pl() {}
function $a35af0f53d067c81$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $a35af0f53d067c81$var$gl(g);
                f.call(a);
            };
        }
        var g = $a35af0f53d067c81$var$el(b, d, a, 0, null, !1, !1, "", $a35af0f53d067c81$var$pl);
        a._reactRootContainer = g;
        a[$a35af0f53d067c81$var$uf] = g.current;
        $a35af0f53d067c81$var$sf(8 === a.nodeType ? a.parentNode : a);
        $a35af0f53d067c81$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $a35af0f53d067c81$var$gl(k);
            h.call(a);
        };
    }
    var k = $a35af0f53d067c81$var$bl(a, 0, !1, null, null, !1, !1, "", $a35af0f53d067c81$var$pl);
    a._reactRootContainer = k;
    a[$a35af0f53d067c81$var$uf] = k.current;
    $a35af0f53d067c81$var$sf(8 === a.nodeType ? a.parentNode : a);
    $a35af0f53d067c81$var$Rk(function() {
        $a35af0f53d067c81$var$fl(b, k, c, d);
    });
    return k;
}
function $a35af0f53d067c81$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $a35af0f53d067c81$var$gl(g);
                h.call(a);
            };
        }
        $a35af0f53d067c81$var$fl(b, g, a, e);
    } else g = $a35af0f53d067c81$var$ql(c, b, a, e, d);
    return $a35af0f53d067c81$var$gl(g);
}
$a35af0f53d067c81$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $a35af0f53d067c81$var$tc(b.pendingLanes);
                0 !== c && ($a35af0f53d067c81$var$Cc(b, c | 1), $a35af0f53d067c81$var$Dk(b, $a35af0f53d067c81$var$B()), 0 === ($a35af0f53d067c81$var$K & 6) && ($a35af0f53d067c81$var$Gj = $a35af0f53d067c81$var$B() + 500, $a35af0f53d067c81$var$jg()));
            }
            break;
        case 13:
            $a35af0f53d067c81$var$Rk(function() {
                var b = $a35af0f53d067c81$var$ih(a, 1);
                if (null !== b) {
                    var c = $a35af0f53d067c81$var$R();
                    $a35af0f53d067c81$var$gi(b, a, 1, c);
                }
            }), $a35af0f53d067c81$var$il(a, 1);
    }
};
$a35af0f53d067c81$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $a35af0f53d067c81$var$ih(a, 134217728);
        if (null !== b) {
            var c = $a35af0f53d067c81$var$R();
            $a35af0f53d067c81$var$gi(b, a, 134217728, c);
        }
        $a35af0f53d067c81$var$il(a, 134217728);
    }
};
$a35af0f53d067c81$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $a35af0f53d067c81$var$yi(a), c = $a35af0f53d067c81$var$ih(a, b);
        if (null !== c) {
            var d = $a35af0f53d067c81$var$R();
            $a35af0f53d067c81$var$gi(c, a, b, d);
        }
        $a35af0f53d067c81$var$il(a, b);
    }
};
$a35af0f53d067c81$var$Hc = function() {
    return $a35af0f53d067c81$var$C;
};
$a35af0f53d067c81$var$Ic = function(a, b) {
    var c = $a35af0f53d067c81$var$C;
    try {
        return $a35af0f53d067c81$var$C = a, b();
    } finally{
        $a35af0f53d067c81$var$C = c;
    }
};
$a35af0f53d067c81$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $a35af0f53d067c81$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $a35af0f53d067c81$var$Db(d);
                        if (!e) throw Error($a35af0f53d067c81$var$p(90));
                        $a35af0f53d067c81$var$Wa(d);
                        $a35af0f53d067c81$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $a35af0f53d067c81$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $a35af0f53d067c81$var$fb(a, !!c.multiple, b, !1);
    }
};
$a35af0f53d067c81$var$Gb = $a35af0f53d067c81$var$Qk;
$a35af0f53d067c81$var$Hb = $a35af0f53d067c81$var$Rk;
var $a35af0f53d067c81$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $a35af0f53d067c81$var$Cb,
        $a35af0f53d067c81$var$ue,
        $a35af0f53d067c81$var$Db,
        $a35af0f53d067c81$var$Eb,
        $a35af0f53d067c81$var$Fb,
        $a35af0f53d067c81$var$Qk
    ]
}, $a35af0f53d067c81$var$tl = {
    findFiberByHostInstance: $a35af0f53d067c81$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $a35af0f53d067c81$var$ul = {
    bundleType: $a35af0f53d067c81$var$tl.bundleType,
    version: $a35af0f53d067c81$var$tl.version,
    rendererPackageName: $a35af0f53d067c81$var$tl.rendererPackageName,
    rendererConfig: $a35af0f53d067c81$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $a35af0f53d067c81$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $a35af0f53d067c81$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $a35af0f53d067c81$var$tl.findFiberByHostInstance || $a35af0f53d067c81$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a35af0f53d067c81$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a35af0f53d067c81$var$vl.isDisabled && $a35af0f53d067c81$var$vl.supportsFiber) try {
        $a35af0f53d067c81$var$kc = $a35af0f53d067c81$var$vl.inject($a35af0f53d067c81$var$ul), $a35af0f53d067c81$var$lc = $a35af0f53d067c81$var$vl;
    } catch (a) {}
}
$a35af0f53d067c81$export$ae55be85d98224ed = $a35af0f53d067c81$var$sl;
$a35af0f53d067c81$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$a35af0f53d067c81$var$nl(b)) throw Error($a35af0f53d067c81$var$p(200));
    return $a35af0f53d067c81$var$cl(a, b, null, c);
};
$a35af0f53d067c81$export$882461b6382ed46c = function(a, b) {
    if (!$a35af0f53d067c81$var$nl(a)) throw Error($a35af0f53d067c81$var$p(299));
    var c = !1, d = "", e = $a35af0f53d067c81$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $a35af0f53d067c81$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$a35af0f53d067c81$var$uf] = b.current;
    $a35af0f53d067c81$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $a35af0f53d067c81$var$ll(b);
};
$a35af0f53d067c81$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($a35af0f53d067c81$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($a35af0f53d067c81$var$p(268, a));
    }
    a = $a35af0f53d067c81$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$a35af0f53d067c81$export$cd75ccfd720a3cd4 = function(a) {
    return $a35af0f53d067c81$var$Rk(a);
};
$a35af0f53d067c81$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$a35af0f53d067c81$var$ol(b)) throw Error($a35af0f53d067c81$var$p(200));
    return $a35af0f53d067c81$var$rl(null, a, b, !0, c);
};
$a35af0f53d067c81$export$757ceba2d55c277e = function(a, b, c) {
    if (!$a35af0f53d067c81$var$nl(a)) throw Error($a35af0f53d067c81$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $a35af0f53d067c81$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $a35af0f53d067c81$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$a35af0f53d067c81$var$uf] = b.current;
    $a35af0f53d067c81$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $a35af0f53d067c81$var$ml(b);
};
$a35af0f53d067c81$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$a35af0f53d067c81$var$ol(b)) throw Error($a35af0f53d067c81$var$p(200));
    return $a35af0f53d067c81$var$rl(null, a, b, !1, c);
};
$a35af0f53d067c81$export$502457920280e6be = function(a) {
    if (!$a35af0f53d067c81$var$ol(a)) throw Error($a35af0f53d067c81$var$p(40));
    return a._reactRootContainer ? ($a35af0f53d067c81$var$Rk(function() {
        $a35af0f53d067c81$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$a35af0f53d067c81$var$uf] = null;
        });
    }), !0) : !1;
};
$a35af0f53d067c81$export$c78a37762a8d58e1 = $a35af0f53d067c81$var$Qk;
$a35af0f53d067c81$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$a35af0f53d067c81$var$ol(c)) throw Error($a35af0f53d067c81$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($a35af0f53d067c81$var$p(38));
    return $a35af0f53d067c81$var$rl(a, b, c, !1, d);
};
$a35af0f53d067c81$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fB1dE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gt2Bd"));

});
parcelRegister("gt2Bd", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bfd15ee818ace481$export$c4744153514ff05d, (v) => $bfd15ee818ace481$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bfd15ee818ace481$export$3e506c1ccc9cc1a7, (v) => $bfd15ee818ace481$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bfd15ee818ace481$export$e26fe2ed2fa76875, (v) => $bfd15ee818ace481$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bfd15ee818ace481$export$502329bbf4b505b1, (v) => $bfd15ee818ace481$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bfd15ee818ace481$export$6e3807111c4874c4, (v) => $bfd15ee818ace481$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bfd15ee818ace481$export$c27134553091fb3a, (v) => $bfd15ee818ace481$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bfd15ee818ace481$export$33ee1acdc04fd2a2, (v) => $bfd15ee818ace481$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bfd15ee818ace481$export$b00a404bbd5edef2, (v) => $bfd15ee818ace481$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bfd15ee818ace481$export$8352ce38b91d0c62, (v) => $bfd15ee818ace481$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bfd15ee818ace481$export$d66a1c1c77bd778b, (v) => $bfd15ee818ace481$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bfd15ee818ace481$export$d3dfb8e4810cb555, (v) => $bfd15ee818ace481$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bfd15ee818ace481$export$839f9183b0465a69, (v) => $bfd15ee818ace481$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bfd15ee818ace481$export$72fdf0e06517287b, (v) => $bfd15ee818ace481$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bfd15ee818ace481$export$4b844e58a3e414b4, (v) => $bfd15ee818ace481$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bfd15ee818ace481$export$816d2913ae6b83b1, (v) => $bfd15ee818ace481$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bfd15ee818ace481$export$61bcfe829111a1d0, (v) => $bfd15ee818ace481$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bfd15ee818ace481$export$7ee8c9beb337bc3f, (v) => $bfd15ee818ace481$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bfd15ee818ace481$export$b5836b71941fa3ed, (v) => $bfd15ee818ace481$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bfd15ee818ace481$export$cf845f2c119da08a, (v) => $bfd15ee818ace481$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bfd15ee818ace481$export$c4744153514ff05d;
var $bfd15ee818ace481$export$3e506c1ccc9cc1a7;
var $bfd15ee818ace481$export$e26fe2ed2fa76875;
var $bfd15ee818ace481$export$502329bbf4b505b1;
var $bfd15ee818ace481$export$6e3807111c4874c4;
var $bfd15ee818ace481$export$c27134553091fb3a;
var $bfd15ee818ace481$export$33ee1acdc04fd2a2;
var $bfd15ee818ace481$export$b00a404bbd5edef2;
var $bfd15ee818ace481$export$8352ce38b91d0c62;
var $bfd15ee818ace481$export$d66a1c1c77bd778b;
var $bfd15ee818ace481$export$d3dfb8e4810cb555;
var $bfd15ee818ace481$export$839f9183b0465a69;
var $bfd15ee818ace481$export$72fdf0e06517287b;
var $bfd15ee818ace481$export$4b844e58a3e414b4;
var $bfd15ee818ace481$export$816d2913ae6b83b1;
var $bfd15ee818ace481$export$61bcfe829111a1d0;
var $bfd15ee818ace481$export$7ee8c9beb337bc3f;
var $bfd15ee818ace481$export$b5836b71941fa3ed;
var $bfd15ee818ace481$export$cf845f2c119da08a;
'use strict';
function $bfd15ee818ace481$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bfd15ee818ace481$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bfd15ee818ace481$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bfd15ee818ace481$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bfd15ee818ace481$var$g(C, c)) n < e && 0 > $bfd15ee818ace481$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bfd15ee818ace481$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bfd15ee818ace481$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bfd15ee818ace481$var$l = performance;
    $bfd15ee818ace481$export$c4744153514ff05d = function() {
        return $bfd15ee818ace481$var$l.now();
    };
} else {
    var $bfd15ee818ace481$var$p = Date, $bfd15ee818ace481$var$q = $bfd15ee818ace481$var$p.now();
    $bfd15ee818ace481$export$c4744153514ff05d = function() {
        return $bfd15ee818ace481$var$p.now() - $bfd15ee818ace481$var$q;
    };
}
var $bfd15ee818ace481$var$r = [], $bfd15ee818ace481$var$t = [], $bfd15ee818ace481$var$u = 1, $bfd15ee818ace481$var$v = null, $bfd15ee818ace481$var$y = 3, $bfd15ee818ace481$var$z = !1, $bfd15ee818ace481$var$A = !1, $bfd15ee818ace481$var$B = !1, $bfd15ee818ace481$var$D = "function" === typeof setTimeout ? setTimeout : null, $bfd15ee818ace481$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bfd15ee818ace481$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bfd15ee818ace481$var$G(a) {
    for(var b = $bfd15ee818ace481$var$h($bfd15ee818ace481$var$t); null !== b;){
        if (null === b.callback) $bfd15ee818ace481$var$k($bfd15ee818ace481$var$t);
        else if (b.startTime <= a) $bfd15ee818ace481$var$k($bfd15ee818ace481$var$t), b.sortIndex = b.expirationTime, $bfd15ee818ace481$var$f($bfd15ee818ace481$var$r, b);
        else break;
        b = $bfd15ee818ace481$var$h($bfd15ee818ace481$var$t);
    }
}
function $bfd15ee818ace481$var$H(a) {
    $bfd15ee818ace481$var$B = !1;
    $bfd15ee818ace481$var$G(a);
    if (!$bfd15ee818ace481$var$A) {
        if (null !== $bfd15ee818ace481$var$h($bfd15ee818ace481$var$r)) $bfd15ee818ace481$var$A = !0, $bfd15ee818ace481$var$I($bfd15ee818ace481$var$J);
        else {
            var b = $bfd15ee818ace481$var$h($bfd15ee818ace481$var$t);
            null !== b && $bfd15ee818ace481$var$K($bfd15ee818ace481$var$H, b.startTime - a);
        }
    }
}
function $bfd15ee818ace481$var$J(a, b) {
    $bfd15ee818ace481$var$A = !1;
    $bfd15ee818ace481$var$B && ($bfd15ee818ace481$var$B = !1, $bfd15ee818ace481$var$E($bfd15ee818ace481$var$L), $bfd15ee818ace481$var$L = -1);
    $bfd15ee818ace481$var$z = !0;
    var c = $bfd15ee818ace481$var$y;
    try {
        $bfd15ee818ace481$var$G(b);
        for($bfd15ee818ace481$var$v = $bfd15ee818ace481$var$h($bfd15ee818ace481$var$r); null !== $bfd15ee818ace481$var$v && (!($bfd15ee818ace481$var$v.expirationTime > b) || a && !$bfd15ee818ace481$var$M());){
            var d = $bfd15ee818ace481$var$v.callback;
            if ("function" === typeof d) {
                $bfd15ee818ace481$var$v.callback = null;
                $bfd15ee818ace481$var$y = $bfd15ee818ace481$var$v.priorityLevel;
                var e = d($bfd15ee818ace481$var$v.expirationTime <= b);
                b = $bfd15ee818ace481$export$c4744153514ff05d();
                "function" === typeof e ? $bfd15ee818ace481$var$v.callback = e : $bfd15ee818ace481$var$v === $bfd15ee818ace481$var$h($bfd15ee818ace481$var$r) && $bfd15ee818ace481$var$k($bfd15ee818ace481$var$r);
                $bfd15ee818ace481$var$G(b);
            } else $bfd15ee818ace481$var$k($bfd15ee818ace481$var$r);
            $bfd15ee818ace481$var$v = $bfd15ee818ace481$var$h($bfd15ee818ace481$var$r);
        }
        if (null !== $bfd15ee818ace481$var$v) var w = !0;
        else {
            var m = $bfd15ee818ace481$var$h($bfd15ee818ace481$var$t);
            null !== m && $bfd15ee818ace481$var$K($bfd15ee818ace481$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bfd15ee818ace481$var$v = null, $bfd15ee818ace481$var$y = c, $bfd15ee818ace481$var$z = !1;
    }
}
var $bfd15ee818ace481$var$N = !1, $bfd15ee818ace481$var$O = null, $bfd15ee818ace481$var$L = -1, $bfd15ee818ace481$var$P = 5, $bfd15ee818ace481$var$Q = -1;
function $bfd15ee818ace481$var$M() {
    return $bfd15ee818ace481$export$c4744153514ff05d() - $bfd15ee818ace481$var$Q < $bfd15ee818ace481$var$P ? !1 : !0;
}
function $bfd15ee818ace481$var$R() {
    if (null !== $bfd15ee818ace481$var$O) {
        var a = $bfd15ee818ace481$export$c4744153514ff05d();
        $bfd15ee818ace481$var$Q = a;
        var b = !0;
        try {
            b = $bfd15ee818ace481$var$O(!0, a);
        } finally{
            b ? $bfd15ee818ace481$var$S() : ($bfd15ee818ace481$var$N = !1, $bfd15ee818ace481$var$O = null);
        }
    } else $bfd15ee818ace481$var$N = !1;
}
var $bfd15ee818ace481$var$S;
if ("function" === typeof $bfd15ee818ace481$var$F) $bfd15ee818ace481$var$S = function() {
    $bfd15ee818ace481$var$F($bfd15ee818ace481$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bfd15ee818ace481$var$T = new MessageChannel, $bfd15ee818ace481$var$U = $bfd15ee818ace481$var$T.port2;
    $bfd15ee818ace481$var$T.port1.onmessage = $bfd15ee818ace481$var$R;
    $bfd15ee818ace481$var$S = function() {
        $bfd15ee818ace481$var$U.postMessage(null);
    };
} else $bfd15ee818ace481$var$S = function() {
    $bfd15ee818ace481$var$D($bfd15ee818ace481$var$R, 0);
};
function $bfd15ee818ace481$var$I(a) {
    $bfd15ee818ace481$var$O = a;
    $bfd15ee818ace481$var$N || ($bfd15ee818ace481$var$N = !0, $bfd15ee818ace481$var$S());
}
function $bfd15ee818ace481$var$K(a, b) {
    $bfd15ee818ace481$var$L = $bfd15ee818ace481$var$D(function() {
        a($bfd15ee818ace481$export$c4744153514ff05d());
    }, b);
}
$bfd15ee818ace481$export$3e506c1ccc9cc1a7 = 5;
$bfd15ee818ace481$export$e26fe2ed2fa76875 = 1;
$bfd15ee818ace481$export$502329bbf4b505b1 = 4;
$bfd15ee818ace481$export$6e3807111c4874c4 = 3;
$bfd15ee818ace481$export$c27134553091fb3a = null;
$bfd15ee818ace481$export$33ee1acdc04fd2a2 = 2;
$bfd15ee818ace481$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bfd15ee818ace481$export$8352ce38b91d0c62 = function() {
    $bfd15ee818ace481$var$A || $bfd15ee818ace481$var$z || ($bfd15ee818ace481$var$A = !0, $bfd15ee818ace481$var$I($bfd15ee818ace481$var$J));
};
$bfd15ee818ace481$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bfd15ee818ace481$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bfd15ee818ace481$export$d3dfb8e4810cb555 = function() {
    return $bfd15ee818ace481$var$y;
};
$bfd15ee818ace481$export$839f9183b0465a69 = function() {
    return $bfd15ee818ace481$var$h($bfd15ee818ace481$var$r);
};
$bfd15ee818ace481$export$72fdf0e06517287b = function(a) {
    switch($bfd15ee818ace481$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bfd15ee818ace481$var$y;
    }
    var c = $bfd15ee818ace481$var$y;
    $bfd15ee818ace481$var$y = b;
    try {
        return a();
    } finally{
        $bfd15ee818ace481$var$y = c;
    }
};
$bfd15ee818ace481$export$4b844e58a3e414b4 = function() {};
$bfd15ee818ace481$export$816d2913ae6b83b1 = function() {};
$bfd15ee818ace481$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bfd15ee818ace481$var$y;
    $bfd15ee818ace481$var$y = a;
    try {
        return b();
    } finally{
        $bfd15ee818ace481$var$y = c;
    }
};
$bfd15ee818ace481$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bfd15ee818ace481$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bfd15ee818ace481$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bfd15ee818ace481$var$f($bfd15ee818ace481$var$t, a), null === $bfd15ee818ace481$var$h($bfd15ee818ace481$var$r) && a === $bfd15ee818ace481$var$h($bfd15ee818ace481$var$t) && ($bfd15ee818ace481$var$B ? ($bfd15ee818ace481$var$E($bfd15ee818ace481$var$L), $bfd15ee818ace481$var$L = -1) : $bfd15ee818ace481$var$B = !0, $bfd15ee818ace481$var$K($bfd15ee818ace481$var$H, c - d))) : (a.sortIndex = e, $bfd15ee818ace481$var$f($bfd15ee818ace481$var$r, a), $bfd15ee818ace481$var$A || $bfd15ee818ace481$var$z || ($bfd15ee818ace481$var$A = !0, $bfd15ee818ace481$var$I($bfd15ee818ace481$var$J)));
    return a;
};
$bfd15ee818ace481$export$b5836b71941fa3ed = $bfd15ee818ace481$var$M;
$bfd15ee818ace481$export$cf845f2c119da08a = function(a) {
    var b = $bfd15ee818ace481$var$y;
    return function() {
        var c = $bfd15ee818ace481$var$y;
        $bfd15ee818ace481$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bfd15ee818ace481$var$y = c;
        }
    };
};

});



parcelRegister("idaDz", function(module, exports) {

$parcel$export(module.exports, "hasNesHeader", () => $d421b138724ea63c$export$2998931614055499);
$parcel$export(module.exports, "generateRomHackFile", () => $d421b138724ea63c$export$d9b7a28a42b15b57);

var $l11RQ = parcelRequire("l11RQ");

var $jrGSV = parcelRequire("jrGSV");
// Return true if an arrayBuffer has a NES header.
const $d421b138724ea63c$export$2998931614055499 = (bin)=>{
    const NES_HEADER = new Uint8Array([
        0x4e,
        0x45,
        0x53,
        0x1a
    ]);
    const view = new DataView(bin);
    for(let i = 0; i < NES_HEADER.length; i++){
        if (view.getUint8(i) !== NES_HEADER[i]) return false;
    }
    return true;
};
const $d421b138724ea63c$var$BANK_SIZE = 0x4000;
// Append a NES header to a PRG buffer.
const $d421b138724ea63c$export$ec6c359c204d5a0f = (prg)=>{
    // prettier-ignore
    const NES_HEADER = new Uint8Array([
        0x4e,
        0x45,
        0x53,
        0x1a,
        0x10,
        0x00,
        0x12,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00,
        0x00
    ]);
    const rom = new ArrayBuffer(NES_HEADER.length + prg.byteLength);
    const romView = new DataView(rom);
    const prgView = new DataView(prg);
    for(let i = 0; i < NES_HEADER.length; i++)romView.setUint8(i, NES_HEADER[i]);
    const banksNum = prg.byteLength / $d421b138724ea63c$var$BANK_SIZE;
    romView.setUint16(4, banksNum, true); // Patch the NES header.
    for(let i = NES_HEADER.length; i < rom.byteLength; i++)romView.setUint8(i, prgView.getUint8(i - NES_HEADER.length));
    return rom;
};
// Overwrite part of a ROM with a buffer at a given offset.
// Return true if some data were overwritten.
const $d421b138724ea63c$export$a976684a0efeb93f = (rom, buffer, offset = 0, length = null)=>{
    if (buffer.byteLength === 0) return false;
    if (Number.isInteger(length) && buffer.byteLength > length) console.warn('Injected buffer is larger than allocated space. This may result in malfunctions.');
    const view = new DataView(rom);
    const bufferView = new DataView(buffer);
    let overwrites = false;
    for(let i = 0; i < buffer.byteLength; i++)if (view.getUint8(offset + i) !== bufferView.getUint8(i)) {
        view.setUint8(offset + i, bufferView.getUint8(i));
        overwrites = true;
    }
    if (Number.isInteger(length)) {
        // Pad the rest of the allocated space with 0xff.
        for(let i = buffer.byteLength; i < length; i++)if (view.getUint8(offset + i) !== 0xff) {
            view.setUint8(offset + i, 0xff);
            overwrites = true;
        }
    }
    return overwrites;
};
// Return a string representation of a buffer for debugging purposes.
const $d421b138724ea63c$export$18b882209988aebf = (buffer)=>{
    const view = new DataView(buffer);
    const s = [
        `Length: ${buffer.byteLength} <`
    ];
    for(let i = 0; i < buffer.byteLength; i++)s.push((0, $jrGSV.hex)(view.getUint8(i)));
    if (!buffer.byteLength) s.push('empty buffer');
    s.push(`>`);
    return s.join(' ');
};
// Inject the new content into the PRG and return a NES ROM buffer.
const $d421b138724ea63c$export$d9b7a28a42b15b57 = (prg, resources)=>{
    const screens = [
        ...resources.titles,
        ...resources.rooms
    ];
    // Update screen titles and rooms palette.
    for(let i = 0; i < screens.length; i++){
        const screen = screens[i];
        const { offset: offset, size: size, id: id } = screen.metadata;
        if (!size) continue;
        const { from: from, to: to } = screen.map.find(({ type: type })=>type === 'palette');
        const buffer = (0, $l11RQ.default)(screen.palette);
        const overwrites = $d421b138724ea63c$export$a976684a0efeb93f(prg, buffer, offset + from, to - from);
        if (overwrites) console.log('Injecting screen %i palette', id);
    }
    // Add the iNES header to make it playable on emulators.
    return $d421b138724ea63c$export$ec6c359c204d5a0f(prg);
};

});
parcelRegister("l11RQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4cb23ca50fd35c9$export$2e2bcd8739ae039);

var $4TAJm = parcelRequire("4TAJm");
const $f4cb23ca50fd35c9$var$serialisePalette = (palette = [])=>{
    const serialiser = new (0, $4TAJm.default)();
    for(let i = 0; i < 16; i++)serialiser.setUint8(palette[i]);
    return serialiser.buffer;
};
var $f4cb23ca50fd35c9$export$2e2bcd8739ae039 = $f4cb23ca50fd35c9$var$serialisePalette;

});
parcelRegister("4TAJm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3908ca6e83e2edd5$export$2e2bcd8739ae039);
const $3908ca6e83e2edd5$var$maxByteLength = 16384; // The largest resource is sprdata.
class $3908ca6e83e2edd5$var$Serialiser {
    #view;
    #ptr = 0;
    #characters = {};
    constructor(characters = {}){
        const buffer = new ArrayBuffer(0, {
            maxByteLength: $3908ca6e83e2edd5$var$maxByteLength
        });
        this.#view = new DataView(buffer);
        // Swap keys for values.
        this.#characters = Object.fromEntries(Object.entries(characters).map(([key, value])=>[
                value,
                key
            ]));
    }
    setUint8(value = 0x00) {
        this.#resize(this.#ptr + 1);
        this.#view.setUint8(this.#ptr++, value);
    }
    setUint16(value = 0x00) {
        this.#resize(this.#ptr + 2);
        this.#view.setUint16(this.#ptr, value, true);
        this.#ptr += 2;
    }
    setString(str) {
        // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt#looping_with_codepointat
        for (let codePoint of str){
            if (this.#characters[codePoint] !== undefined) codePoint = this.#characters[codePoint];
            this.setUint8(codePoint.codePointAt(0));
        }
    }
    // Compress an array of data using the RLE compression algorithm.
    compressArray(data) {
        let n = 0;
        while(n < data.length){
            let initialValue = data[n];
            let loop = 0;
            // Look 2 tiles ahead.
            if (data[n] !== data[n + 1] || data[n] !== data[n + 2]) {
                // The next 3 tiles are different. Count how many unique tiles there are.
                // It stops once it encounters 3 identical tiles in a row.
                const initialN = n;
                do {
                    loop++;
                    initialValue = data[++n];
                }while (initialValue !== data[n + 1] || initialValue !== data[n + 2]);
                this.setUint8(loop | 0x80); // Set the type of loop.
                for(let i = initialN; i < n; i++)this.setUint8(data[i]);
            } else {
                // The next 3 tiles are identical. Count how many of them in a row.
                // It stops when it finds a different tile.
                do loop++;
                while (initialValue === data[++n]);
                this.setUint8(loop);
                this.setUint8(initialValue);
            }
        }
    }
    // Firefox doesn't support ArrayBuffer#resize.
    #resize(newByteLength) {
        if (ArrayBuffer.prototype.resize) {
            this.#view.buffer.resize(newByteLength);
            return;
        }
        const newArrayBuffer = new ArrayBuffer(newByteLength);
        const view = new DataView(newArrayBuffer);
        for(let i = 0; i < this.#view.buffer.byteLength; i++)view.setUint8(i, this.#view.getUint8(i));
        this.#view = view;
    }
    get buffer() {
        return this.#view.buffer;
    }
}
var $3908ca6e83e2edd5$export$2e2bcd8739ae039 = $3908ca6e83e2edd5$var$Serialiser;

});


parcelRegister("jrGSV", function(module, exports) {

$parcel$export(module.exports, "zeroPad", () => $e281cdfcb380b3f2$export$3cdc770bf8b2ed3d);
$parcel$export(module.exports, "hex", () => $e281cdfcb380b3f2$export$834dfc94dde4b3d8);
$parcel$export(module.exports, "formatBytes", () => $e281cdfcb380b3f2$export$e1a3971de07c83b5);
$parcel$export(module.exports, "formatPercentage", () => $e281cdfcb380b3f2$export$3e1eee59f5dc52be);
const $e281cdfcb380b3f2$export$3cdc770bf8b2ed3d = (s, len = 2)=>{
    return String(s).padStart(len, '0');
};
const $e281cdfcb380b3f2$export$834dfc94dde4b3d8 = (n, len = null)=>{
    const str = n.toString(16);
    const l = Math.ceil(str.length / 2) * 2; // Even number of 0s.
    return $e281cdfcb380b3f2$export$3cdc770bf8b2ed3d(str, len || l);
};
const $e281cdfcb380b3f2$export$e1a3971de07c83b5 = (bytes, decimals = 2)=>{
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [
        'B',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    if (bytes === 0 || i === 0) return `${bytes} ${sizes[0]}`;
    return `${(bytes / Math.pow(k, i)).toFixed(dm)} ${sizes[i]}`;
};
const $e281cdfcb380b3f2$export$3e1eee59f5dc52be = (percent, decimals = 2)=>{
    const dm = decimals < 0 ? 0 : decimals;
    return `${(percent * 100).toFixed(dm)}%`;
};

});


parcelRegister("4zRRV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $2JGbf = parcelRequire("2JGbf");
function $35543787a990b57e$var$emptyFunction() {}
function $35543787a990b57e$var$emptyFunctionWithReset() {}
$35543787a990b57e$var$emptyFunctionWithReset.resetWarningCache = $35543787a990b57e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $2JGbf) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $35543787a990b57e$var$emptyFunctionWithReset,
        resetWarningCache: $35543787a990b57e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("2JGbf", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $1fe080de587b4188$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $1fe080de587b4188$var$ReactPropTypesSecret;

});


parcelRegister("aBqif", function(module, exports) {

$parcel$export(module.exports, "BASE_ROMS", () => $7b81c15ea8edd071$export$a01e52b0d12e5845);
$parcel$export(module.exports, "isJapaneseVersion", () => $7b81c15ea8edd071$export$2005e1cd5c8f6054);
$parcel$export(module.exports, "getResFromCrc32", () => $7b81c15ea8edd071$export$d6935f7d4e2191c5);
$parcel$export(module.exports, "getResFromBaseRom", () => $7b81c15ea8edd071$export$ad87ed629ba0a9a4);

var $2X0dC = parcelRequire("2X0dC");
const $7b81c15ea8edd071$export$a01e52b0d12e5845 = (0, $2X0dC.default).map(({ metadata: metadata })=>metadata);
$7b81c15ea8edd071$export$a01e52b0d12e5845.sort((a, b)=>a.name.localeCompare(b.name));
const $7b81c15ea8edd071$export$2005e1cd5c8f6054 = (c)=>c === 0x3da2085e || c === 0xf526cea8;
const $7b81c15ea8edd071$export$d6935f7d4e2191c5 = (c)=>(0, $2X0dC.default).find(({ crc32: crc32, crc32Rom: crc32Rom })=>crc32 === c || crc32Rom === c) ?? null;
const $7b81c15ea8edd071$export$ad87ed629ba0a9a4 = (baseRom)=>(0, $2X0dC.default).find(({ metadata: { name: name, alpha2code: alpha2code, alpha3code: alpha3code } })=>{
        baseRom = baseRom.toLowerCase();
        return baseRom === name.toLowerCase() || baseRom === alpha2code.toLowerCase() || baseRom === alpha3code.toLowerCase();
    }) ?? null;

});
parcelRegister("2X0dC", function(module, exports) {

$parcel$export(module.exports, "default", () => $226142e01fd9f3a3$export$2e2bcd8739ae039);
// prettier-ignore
const $226142e01fd9f3a3$var$usa = {
    metadata: {
        name: 'USA',
        alpha2code: 'us',
        alpha3code: 'usa'
    },
    roomgfx: [
        [
            0x04001,
            0x03c9
        ],
        [
            0x043ca,
            0x069e
        ],
        [
            0x04a68,
            0x0327
        ],
        [
            0x04d8f,
            0x053b
        ],
        [
            0x052ca,
            0x06be
        ],
        [
            0x05988,
            0x0682
        ],
        [
            0x0600a,
            0x0778
        ],
        [
            0x06782,
            0x0517
        ],
        [
            0x06c99,
            0x07fb
        ],
        [
            0x07494,
            0x07be
        ],
        [
            0x08001,
            0x07a5
        ],
        [
            0x087a6,
            0x06dd
        ],
        [
            0x08e83,
            0x04ea
        ],
        [
            0x0936d,
            0x0846
        ],
        [
            0x09bb3,
            0x08c8
        ],
        [
            0x0a47b,
            0x0844
        ],
        [
            0x0acbf,
            0x0515
        ],
        [
            0x0b1d4,
            0x0799
        ],
        [
            0x0b96d,
            0x04bb
        ],
        [
            0x07c52,
            0x0319
        ],
        [
            0x0c001,
            0x0464
        ],
        [
            0x0c465,
            0x076d
        ],
        [
            0x0cbd2,
            0x0827
        ],
        [
            0x0d3f9,
            0x0515
        ],
        [
            0x0d90e,
            0x064e
        ],
        [
            0x0df5c,
            0x0775
        ],
        [
            0x0e6d1,
            0x06dd
        ],
        [
            0x0edae,
            0x0376
        ],
        [
            0x0f124,
            0x05f7
        ],
        [
            0x0f71b,
            0x0787
        ],
        [
            0x10001,
            0x02d6
        ],
        [
            0x102d7,
            0x06a3
        ],
        [
            0x1097a,
            0x099f
        ],
        [
            0x11319,
            0x0361
        ],
        [
            0x1167a,
            0x0489
        ],
        [
            0x11b03,
            0x0437
        ],
        [
            0x11f3a,
            0x084d
        ],
        [
            0x0be28,
            0x0199
        ],
        [
            0x12787,
            0x09a7
        ],
        [
            0x1312e,
            0x037a
        ]
    ],
    costumegfx: [
        [
            0x30001,
            0x0eb8
        ],
        [
            0x2f9f1,
            0x0340
        ]
    ],
    rooms: [
        [
            0x00000,
            0x0000
        ],
        [
            0x14001,
            0x0d0c
        ],
        [
            0x134a8,
            0x04b3
        ],
        [
            0x15397,
            0x0849
        ],
        [
            0x15c68,
            0x0685
        ],
        [
            0x16381,
            0x0715
        ],
        [
            0x1395b,
            0x04e7
        ],
        [
            0x16ce8,
            0x0ac0
        ],
        [
            0x18001,
            0x06ba
        ],
        [
            0x17aed,
            0x03cb
        ],
        [
            0x18be7,
            0x0663
        ],
        [
            0x192a6,
            0x0580
        ],
        [
            0x19a44,
            0x0443
        ],
        [
            0x1a106,
            0x0563
        ],
        [
            0x1a669,
            0x0446
        ],
        [
            0x1aaaf,
            0x03a7
        ],
        [
            0x1ae56,
            0x07e3
        ],
        [
            0x1b699,
            0x0692
        ],
        [
            0x1c001,
            0x0b49
        ],
        [
            0x1cd09,
            0x04c6
        ],
        [
            0x1d4c2,
            0x0568
        ],
        [
            0x1df6c,
            0x0514
        ],
        [
            0x1e8fa,
            0x05cc
        ],
        [
            0x1ef83,
            0x0389
        ],
        [
            0x1f5e4,
            0x0723
        ],
        [
            0x20001,
            0x049a
        ],
        [
            0x20511,
            0x04f8
        ],
        [
            0x21666,
            0x05cb
        ],
        [
            0x21dd6,
            0x046b
        ],
        [
            0x222f0,
            0x0460
        ],
        [
            0x227b6,
            0x0909
        ],
        [
            0x24001,
            0x0366
        ],
        [
            0x23bdf,
            0x03ca
        ],
        [
            0x247db,
            0x050d
        ],
        [
            0x25acf,
            0x0346
        ],
        [
            0x1bdbd,
            0x01ca
        ],
        [
            0x25e15,
            0x0457
        ],
        [
            0x2626c,
            0x0547
        ],
        [
            0x267b3,
            0x064a
        ],
        [
            0x1fd72,
            0x024b
        ],
        [
            0x2739a,
            0x01fa
        ],
        [
            0x2766d,
            0x0219
        ],
        [
            0x28001,
            0x02f4
        ],
        [
            0x284d6,
            0x045c
        ],
        [
            0x289a3,
            0x09cf
        ],
        [
            0x293c6,
            0x05a0
        ],
        [
            0x27b65,
            0x0201
        ],
        [
            0x2add1,
            0x0325
        ],
        [
            0x2b339,
            0x01fc
        ],
        [
            0x2b535,
            0x02a9
        ],
        [
            0x2b7de,
            0x02de
        ],
        [
            0x2c001,
            0x03ce
        ],
        [
            0x2bbc0,
            0x0205
        ],
        [
            0x2c53a,
            0x0170
        ],
        [
            0x13e42,
            0x0169
        ]
    ],
    scripts: [
        [
            0x00000,
            0x0000
        ],
        [
            0x29966,
            0x044d
        ],
        [
            0x29db3,
            0x0207
        ],
        [
            0x29fba,
            0x009f
        ],
        [
            0x2a059,
            0x03f4
        ],
        [
            0x2a44d,
            0x01a1
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a5ee,
            0x004a
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a638,
            0x0005
        ],
        [
            0x2c6aa,
            0x000d
        ],
        [
            0x2c6b7,
            0x000d
        ],
        [
            0x186bb,
            0x0040
        ],
        [
            0x186fb,
            0x0016
        ],
        [
            0x1b639,
            0x0046
        ],
        [
            0x1eec6,
            0x00bd
        ],
        [
            0x21c31,
            0x0055
        ],
        [
            0x177a8,
            0x0027
        ],
        [
            0x1fd07,
            0x0027
        ],
        [
            0x1fd2e,
            0x0027
        ],
        [
            0x1bd2b,
            0x0022
        ],
        [
            0x15be0,
            0x0088
        ],
        [
            0x22241,
            0x0020
        ],
        [
            0x22261,
            0x008f
        ],
        [
            0x1924a,
            0x002b
        ],
        [
            0x1cb4a,
            0x0061
        ],
        [
            0x1cbab,
            0x003c
        ],
        [
            0x1cbe7,
            0x0042
        ],
        [
            0x1cc29,
            0x004f
        ],
        [
            0x2049b,
            0x0076
        ],
        [
            0x16a96,
            0x0035
        ],
        [
            0x16acb,
            0x001c
        ],
        [
            0x16ae7,
            0x0014
        ],
        [
            0x16afb,
            0x001c
        ],
        [
            0x16b17,
            0x0027
        ],
        [
            0x16b3e,
            0x01aa
        ],
        [
            0x1d1cf,
            0x0096
        ],
        [
            0x1d265,
            0x010e
        ],
        [
            0x1d373,
            0x001c
        ],
        [
            0x1d38f,
            0x0056
        ],
        [
            0x1d3e5,
            0x0072
        ],
        [
            0x1e480,
            0x0028
        ],
        [
            0x1e4a8,
            0x017d
        ],
        [
            0x1e625,
            0x0229
        ],
        [
            0x28932,
            0x0071
        ],
        [
            0x17eb8,
            0x004d
        ],
        [
            0x162ed,
            0x0039
        ],
        [
            0x18711,
            0x028b
        ],
        [
            0x1899c,
            0x00bb
        ],
        [
            0x18a57,
            0x018b
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x19e87,
            0x00ed
        ],
        [
            0x21c86,
            0x00f6
        ],
        [
            0x1e84e,
            0x009b
        ],
        [
            0x21d7c,
            0x0047
        ],
        [
            0x2c6c4,
            0x004d
        ],
        [
            0x16326,
            0x0024
        ],
        [
            0x14d0d,
            0x0014
        ],
        [
            0x177cf,
            0x0059
        ],
        [
            0x17828,
            0x0109
        ],
        [
            0x17931,
            0x0009
        ],
        [
            0x14d21,
            0x01b6
        ],
        [
            0x2b0f6,
            0x0243
        ],
        [
            0x230bf,
            0x067f
        ],
        [
            0x2c711,
            0x001c
        ],
        [
            0x2c72d,
            0x001a
        ],
        [
            0x2c747,
            0x0021
        ],
        [
            0x2c768,
            0x0024
        ],
        [
            0x2c78c,
            0x0017
        ],
        [
            0x2c7a3,
            0x0017
        ],
        [
            0x2c7ba,
            0x0014
        ],
        [
            0x2c7ce,
            0x0024
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2c7f2,
            0x0011
        ],
        [
            0x1793a,
            0x009d
        ],
        [
            0x22750,
            0x0066
        ],
        [
            0x14ed7,
            0x0075
        ],
        [
            0x1f30c,
            0x0120
        ],
        [
            0x1fd55,
            0x001d
        ],
        [
            0x1f42c,
            0x008f
        ],
        [
            0x1f4bb,
            0x0097
        ],
        [
            0x179d7,
            0x006a
        ],
        [
            0x17a41,
            0x0030
        ],
        [
            0x1f552,
            0x0092
        ],
        [
            0x2c803,
            0x00cc
        ],
        [
            0x2c8cf,
            0x00ba
        ],
        [
            0x2c989,
            0x0088
        ],
        [
            0x20a09,
            0x01b0
        ],
        [
            0x20bb9,
            0x0168
        ],
        [
            0x20d21,
            0x006c
        ],
        [
            0x20d8d,
            0x0037
        ],
        [
            0x20dc4,
            0x00e4
        ],
        [
            0x20ea8,
            0x0045
        ],
        [
            0x20eed,
            0x00e1
        ],
        [
            0x20fce,
            0x00f6
        ],
        [
            0x210c4,
            0x0141
        ],
        [
            0x21205,
            0x0183
        ],
        [
            0x21388,
            0x0034
        ],
        [
            0x213bc,
            0x00a9
        ],
        [
            0x24367,
            0x011b
        ],
        [
            0x1bd4d,
            0x0070
        ],
        [
            0x1cc78,
            0x0091
        ],
        [
            0x29372,
            0x0054
        ],
        [
            0x19f74,
            0x00ce
        ],
        [
            0x1a042,
            0x0077
        ],
        [
            0x14f4c,
            0x0057
        ],
        [
            0x27886,
            0x02df
        ],
        [
            0x1da2a,
            0x0219
        ],
        [
            0x1dc43,
            0x00f9
        ],
        [
            0x1dd3c,
            0x0056
        ],
        [
            0x1dd92,
            0x01c2
        ],
        [
            0x14fa3,
            0x004d
        ],
        [
            0x27594,
            0x00d9
        ],
        [
            0x21dc3,
            0x0013
        ],
        [
            0x2a63d,
            0x00f0
        ],
        [
            0x24482,
            0x00e7
        ],
        [
            0x21465,
            0x00f2
        ],
        [
            0x24569,
            0x002b
        ],
        [
            0x2c3cf,
            0x010f
        ],
        [
            0x24594,
            0x00aa
        ],
        [
            0x24ce8,
            0x0dab
        ],
        [
            0x1b67f,
            0x000d
        ],
        [
            0x1b68c,
            0x000d
        ],
        [
            0x2373e,
            0x017c
        ],
        [
            0x282f5,
            0x01e1
        ],
        [
            0x238ba,
            0x0153
        ],
        [
            0x23a0d,
            0x019c
        ],
        [
            0x23ba9,
            0x0016
        ],
        [
            0x2c4de,
            0x005c
        ],
        [
            0x23bbf,
            0x0020
        ],
        [
            0x27d66,
            0x00a5
        ],
        [
            0x2a72d,
            0x034d
        ],
        [
            0x14ff0,
            0x00e3
        ],
        [
            0x2babc,
            0x005f
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x25a93,
            0x003c
        ],
        [
            0x1e8e9,
            0x0011
        ],
        [
            0x1634a,
            0x0018
        ],
        [
            0x26dfd,
            0x001f
        ],
        [
            0x26e1c,
            0x0054
        ],
        [
            0x26e70,
            0x0149
        ],
        [
            0x26fb9,
            0x004b
        ],
        [
            0x27004,
            0x017d
        ],
        [
            0x27181,
            0x0027
        ],
        [
            0x271a8,
            0x0041
        ],
        [
            0x271e9,
            0x01b1
        ],
        [
            0x16362,
            0x001f
        ],
        [
            0x2463e,
            0x002a
        ],
        [
            0x150d3,
            0x019e
        ],
        [
            0x19275,
            0x0031
        ],
        [
            0x17a71,
            0x007c
        ],
        [
            0x21557,
            0x00dc
        ],
        [
            0x1d457,
            0x0018
        ],
        [
            0x1d46f,
            0x0053
        ],
        [
            0x18be2,
            0x0005
        ],
        [
            0x15271,
            0x011b
        ],
        [
            0x1538c,
            0x000b
        ],
        [
            0x24668,
            0x0138
        ],
        [
            0x247a0,
            0x0014
        ],
        [
            0x1df54,
            0x0018
        ],
        [
            0x247b4,
            0x0027
        ],
        [
            0x1a0b9,
            0x004d
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2bb1b,
            0x00a5
        ],
        [
            0x2aa7a,
            0x00c1
        ],
        [
            0x2ab3b,
            0x0140
        ],
        [
            0x19826,
            0x00bf
        ],
        [
            0x198e5,
            0x014d
        ],
        [
            0x19a32,
            0x0012
        ],
        [
            0x2ac7b,
            0x0005
        ],
        [
            0x2ac80,
            0x0005
        ],
        [
            0x2ac85,
            0x0005
        ],
        [
            0x2ac8a,
            0x0005
        ],
        [
            0x2ac8f,
            0x0005
        ],
        [
            0x21633,
            0x0033
        ],
        [
            0x2ac94,
            0x0005
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2ac99,
            0x009c
        ],
        [
            0x2ad35,
            0x009c
        ]
    ],
    sounds: [
        [
            0x0ffe8,
            0x000a
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x17fca,
            0x0011
        ],
        [
            0x27e0b,
            0x0073
        ],
        [
            0x17fdb,
            0x0011
        ],
        [
            0x17fec,
            0x0011
        ],
        [
            0x27e7e,
            0x0056
        ],
        [
            0x27ed4,
            0x001f
        ],
        [
            0x23fee,
            0x0011
        ],
        [
            0x0fff2,
            0x000a
        ],
        [
            0x27ef3,
            0x000a
        ],
        [
            0x27efd,
            0x0019
        ],
        [
            0x27f16,
            0x004b
        ],
        [
            0x27f61,
            0x000a
        ],
        [
            0x27f6b,
            0x000f
        ],
        [
            0x27f7a,
            0x001d
        ],
        [
            0x27f97,
            0x0045
        ],
        [
            0x27fdc,
            0x000f
        ],
        [
            0x2fd42,
            0x001b
        ],
        [
            0x2fd5d,
            0x0033
        ],
        [
            0x27feb,
            0x0011
        ],
        [
            0x2bfef,
            0x000f
        ],
        [
            0x2fd90,
            0x0075
        ],
        [
            0x2fe05,
            0x0014
        ],
        [
            0x0ffe8,
            0x000a
        ],
        [
            0x2fe19,
            0x00ff
        ],
        [
            0x2ff18,
            0x000f
        ],
        [
            0x2ff27,
            0x000f
        ],
        [
            0x2ff36,
            0x0092
        ],
        [
            0x2ff36,
            0x0092
        ],
        [
            0x2ffc8,
            0x002d
        ],
        [
            0x316fc,
            0x00f8
        ],
        [
            0x317f4,
            0x0016
        ],
        [
            0x3180a,
            0x0011
        ],
        [
            0x3181b,
            0x004b
        ],
        [
            0x31866,
            0x0011
        ],
        [
            0x31877,
            0x003b
        ],
        [
            0x318b2,
            0x008a
        ],
        [
            0x3193c,
            0x0011
        ],
        [
            0x3194d,
            0x000f
        ],
        [
            0x3195c,
            0x00a2
        ],
        [
            0x319fe,
            0x00d3
        ],
        [
            0x31ad1,
            0x0097
        ],
        [
            0x2bfef,
            0x000f
        ],
        [
            0x3195c,
            0x00a2
        ],
        [
            0x31b68,
            0x05d1
        ],
        [
            0x31b68,
            0x05d1
        ],
        [
            0x32139,
            0x0011
        ],
        [
            0x0ffe8,
            0x000a
        ],
        [
            0x2fd90,
            0x0075
        ],
        [
            0x27ed4,
            0x001f
        ],
        [
            0x3214a,
            0x098e
        ],
        [
            0x3181b,
            0x004b
        ],
        [
            0x32ad8,
            0x0011
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x32ae9,
            0x000f
        ],
        [
            0x32af8,
            0x002f
        ],
        [
            0x32b27,
            0x001d
        ],
        [
            0x32b44,
            0x0018
        ],
        [
            0x32b5c,
            0x0016
        ],
        [
            0x32b72,
            0x001b
        ],
        [
            0x32b8d,
            0x0088
        ],
        [
            0x32c15,
            0x0065
        ],
        [
            0x32c7a,
            0x0065
        ],
        [
            0x32cdf,
            0x0073
        ],
        [
            0x32d52,
            0x00f9
        ],
        [
            0x32e4b,
            0x049e
        ],
        [
            0x34001,
            0x0ea8
        ],
        [
            0x332e9,
            0x0b18
        ],
        [
            0x34ea9,
            0x0b9c
        ],
        [
            0x35a45,
            0x0c6b
        ],
        [
            0x366b0,
            0x0e56
        ],
        [
            0x38001,
            0x0c70
        ],
        [
            0x38c71,
            0x0dec
        ],
        [
            0x39a5d,
            0x0b77
        ],
        [
            0x37506,
            0x042f
        ],
        [
            0x3a5d4,
            0x0ac5
        ],
        [
            0x3b099,
            0x0be4
        ]
    ],
    costumes: [
        [
            0x17f05,
            0x0055
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x13fab,
            0x004b
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x17f5a,
            0x0036
        ],
        [
            0x17f90,
            0x003a
        ],
        [
            0x17f90,
            0x003a
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x1bf87,
            0x003b
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x23fa9,
            0x0045
        ],
        [
            0x1ffbd,
            0x0040
        ],
        [
            0x1bfc2,
            0x003c
        ],
        [
            0x17f90,
            0x003a
        ],
        [
            0x17f90,
            0x003a
        ],
        [
            0x17f05,
            0x0055
        ],
        [
            0x13fab,
            0x004b
        ]
    ],
    globdata: [
        [
            0x2ca11,
            0x0307
        ]
    ],
    // sprite palette data
    sprpals: [
        [
            0x0bfc1,
            0x0010
        ],
        [
            0x0bfd1,
            0x0010
        ]
    ],
    // associates costume IDs with sprite sets (indexes into SPRLENS/SPROFFS)
    sprdesc: [
        [
            0x0ffb7,
            0x0031
        ],
        [
            0x0bfe1,
            0x0009
        ]
    ],
    // number of sprites in each set (indicates length within SPRDATA)
    sprlens: [
        [
            0x0fea2,
            0x0115
        ],
        [
            0x07ff5,
            0x0006
        ]
    ],
    // offset of each sprite set (indexes into SPRDATA)
    sproffs: [
        [
            0x2bdc5,
            0x022a
        ],
        [
            0x0bfea,
            0x000c
        ]
    ],
    // sprite data sets (packed NES sprite data)
    sprdata: [
        [
            0x2ce11,
            0x2be0
        ],
        [
            0x07f6b,
            0x008a
        ]
    ],
    charset: [
        [
            0x3f6ee,
            0x0090
        ]
    ],
    preplist: [
        [
            0x3fb5a,
            0x000e
        ]
    ],
    titles: [
        [
            0x2701,
            0x0000
        ],
        [
            0x324d,
            0x0000
        ]
    ],
    characters: {},
    version: 'USA',
    lang: 'en-US',
    crc32: 0x0d9f5bd1,
    crc32Rom: 0x68309d06
};
// prettier-ignore
const $226142e01fd9f3a3$var$eur = {
    metadata: {
        name: 'Europe',
        alpha2code: 'eu',
        alpha3code: 'eur'
    },
    roomgfx: [
        [
            0x04001,
            0x03b9
        ],
        [
            0x043ba,
            0x069e
        ],
        [
            0x04a58,
            0x0327
        ],
        [
            0x04d7f,
            0x053b
        ],
        [
            0x052ba,
            0x06be
        ],
        [
            0x05978,
            0x0682
        ],
        [
            0x05ffa,
            0x0778
        ],
        [
            0x06772,
            0x0517
        ],
        [
            0x06c89,
            0x07fb
        ],
        [
            0x07484,
            0x07be
        ],
        [
            0x08001,
            0x07a5
        ],
        [
            0x087a6,
            0x06dd
        ],
        [
            0x08e83,
            0x04ea
        ],
        [
            0x0936d,
            0x0846
        ],
        [
            0x09bb3,
            0x08c8
        ],
        [
            0x0a47b,
            0x0844
        ],
        [
            0x0acbf,
            0x0515
        ],
        [
            0x0b1d4,
            0x0799
        ],
        [
            0x0b96d,
            0x04bb
        ],
        [
            0x07c42,
            0x0319
        ],
        [
            0x0c001,
            0x0464
        ],
        [
            0x0c465,
            0x076d
        ],
        [
            0x0cbd2,
            0x0827
        ],
        [
            0x0d3f9,
            0x0515
        ],
        [
            0x0d90e,
            0x064e
        ],
        [
            0x0df5c,
            0x0775
        ],
        [
            0x0e6d1,
            0x06dd
        ],
        [
            0x0edae,
            0x0376
        ],
        [
            0x0f124,
            0x05f7
        ],
        [
            0x0f71b,
            0x0787
        ],
        [
            0x10001,
            0x02d6
        ],
        [
            0x102d7,
            0x06a3
        ],
        [
            0x1097a,
            0x099f
        ],
        [
            0x11319,
            0x0361
        ],
        [
            0x1167a,
            0x0489
        ],
        [
            0x11b03,
            0x0437
        ],
        [
            0x11f3a,
            0x084d
        ],
        [
            0x12787,
            0x0199
        ],
        [
            0x12920,
            0x09a7
        ],
        [
            0x132c7,
            0x037a
        ]
    ],
    costumegfx: [
        [
            0x30001,
            0x0eb8
        ],
        [
            0x2f9f1,
            0x0340
        ]
    ],
    rooms: [
        [
            0x00000,
            0x0000
        ],
        [
            0x14001,
            0x0d0c
        ],
        [
            0x13641,
            0x04b3
        ],
        [
            0x15397,
            0x0849
        ],
        [
            0x15c68,
            0x0685
        ],
        [
            0x16381,
            0x0715
        ],
        [
            0x16ce8,
            0x04e7
        ],
        [
            0x18001,
            0x0abf
        ],
        [
            0x171cf,
            0x06ba
        ],
        [
            0x13af4,
            0x03d2
        ],
        [
            0x18e1a,
            0x0663
        ],
        [
            0x194d9,
            0x04a9
        ],
        [
            0x19ba0,
            0x0443
        ],
        [
            0x1a262,
            0x047c
        ],
        [
            0x1a6de,
            0x0446
        ],
        [
            0x1ab24,
            0x03a7
        ],
        [
            0x1aecb,
            0x07e3
        ],
        [
            0x1b70e,
            0x0692
        ],
        [
            0x1c001,
            0x0aca
        ],
        [
            0x1cc8a,
            0x04c6
        ],
        [
            0x1d443,
            0x0568
        ],
        [
            0x1deed,
            0x0514
        ],
        [
            0x1e87b,
            0x05cc
        ],
        [
            0x1ef04,
            0x0389
        ],
        [
            0x1f565,
            0x0723
        ],
        [
            0x20001,
            0x049a
        ],
        [
            0x20511,
            0x04f8
        ],
        [
            0x21666,
            0x05d5
        ],
        [
            0x21de0,
            0x046b
        ],
        [
            0x222fa,
            0x0460
        ],
        [
            0x227c0,
            0x0909
        ],
        [
            0x24001,
            0x0366
        ],
        [
            0x247db,
            0x03ca
        ],
        [
            0x24ba5,
            0x050d
        ],
        [
            0x23be9,
            0x0346
        ],
        [
            0x17db5,
            0x01ca
        ],
        [
            0x25e99,
            0x0457
        ],
        [
            0x262f0,
            0x0547
        ],
        [
            0x26837,
            0x064a
        ],
        [
            0x1fcf3,
            0x024b
        ],
        [
            0x2741e,
            0x01fa
        ],
        [
            0x276f1,
            0x0219
        ],
        [
            0x28001,
            0x02f4
        ],
        [
            0x284d6,
            0x045c
        ],
        [
            0x289a3,
            0x09cf
        ],
        [
            0x293c6,
            0x05a0
        ],
        [
            0x27be9,
            0x0201
        ],
        [
            0x2ade3,
            0x0325
        ],
        [
            0x2b34b,
            0x01fc
        ],
        [
            0x2b547,
            0x02a9
        ],
        [
            0x2b7f0,
            0x02de
        ],
        [
            0x2c001,
            0x03ce
        ],
        [
            0x2bbd2,
            0x0205
        ],
        [
            0x2c53a,
            0x0170
        ],
        [
            0x2bdd7,
            0x0169
        ]
    ],
    scripts: [
        [
            0x00000,
            0x0000
        ],
        [
            0x29966,
            0x044d
        ],
        [
            0x29db3,
            0x0207
        ],
        [
            0x29fba,
            0x009f
        ],
        [
            0x2a059,
            0x03f4
        ],
        [
            0x2a44d,
            0x01a1
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a5ee,
            0x005c
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a64a,
            0x0005
        ],
        [
            0x2c6aa,
            0x000d
        ],
        [
            0x2c6b7,
            0x000d
        ],
        [
            0x17889,
            0x0040
        ],
        [
            0x178c9,
            0x0016
        ],
        [
            0x1b6ae,
            0x0046
        ],
        [
            0x1ee47,
            0x00bd
        ],
        [
            0x21c3b,
            0x0055
        ],
        [
            0x18ac0,
            0x0027
        ],
        [
            0x1fc88,
            0x0027
        ],
        [
            0x1fcaf,
            0x0027
        ],
        [
            0x1bda0,
            0x0022
        ],
        [
            0x15be0,
            0x0088
        ],
        [
            0x2224b,
            0x0020
        ],
        [
            0x2226b,
            0x008f
        ],
        [
            0x1947d,
            0x002b
        ],
        [
            0x1cacb,
            0x0061
        ],
        [
            0x1cb2c,
            0x003c
        ],
        [
            0x1cb68,
            0x0042
        ],
        [
            0x1cbaa,
            0x004f
        ],
        [
            0x2049b,
            0x0076
        ],
        [
            0x16a96,
            0x0035
        ],
        [
            0x16acb,
            0x001c
        ],
        [
            0x16ae7,
            0x0014
        ],
        [
            0x16afb,
            0x001c
        ],
        [
            0x16b17,
            0x0027
        ],
        [
            0x16b3e,
            0x01aa
        ],
        [
            0x1d150,
            0x0096
        ],
        [
            0x1d1e6,
            0x010e
        ],
        [
            0x1d2f4,
            0x001c
        ],
        [
            0x1d310,
            0x0056
        ],
        [
            0x1d366,
            0x0072
        ],
        [
            0x1e401,
            0x0028
        ],
        [
            0x1e429,
            0x017d
        ],
        [
            0x1e5a6,
            0x0229
        ],
        [
            0x28932,
            0x0071
        ],
        [
            0x13ec6,
            0x004d
        ],
        [
            0x162ed,
            0x0039
        ],
        [
            0x178df,
            0x028b
        ],
        [
            0x17b6a,
            0x00bb
        ],
        [
            0x17c25,
            0x018b
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x19fe3,
            0x00ed
        ],
        [
            0x21c90,
            0x00f6
        ],
        [
            0x1e7cf,
            0x009b
        ],
        [
            0x21d86,
            0x0047
        ],
        [
            0x2c6c4,
            0x004d
        ],
        [
            0x16326,
            0x0024
        ],
        [
            0x14d0d,
            0x0014
        ],
        [
            0x18ae7,
            0x0059
        ],
        [
            0x18b40,
            0x011e
        ],
        [
            0x18c5e,
            0x0009
        ],
        [
            0x14d21,
            0x01b6
        ],
        [
            0x2b108,
            0x0243
        ],
        [
            0x230c9,
            0x067f
        ],
        [
            0x2c711,
            0x001c
        ],
        [
            0x2c72d,
            0x001a
        ],
        [
            0x2c747,
            0x0021
        ],
        [
            0x2c768,
            0x0024
        ],
        [
            0x2c78c,
            0x0017
        ],
        [
            0x2c7a3,
            0x0017
        ],
        [
            0x2c7ba,
            0x0014
        ],
        [
            0x2c7ce,
            0x0024
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2c7f2,
            0x0011
        ],
        [
            0x18c67,
            0x009d
        ],
        [
            0x2275a,
            0x0066
        ],
        [
            0x14ed7,
            0x0075
        ],
        [
            0x1f28d,
            0x0120
        ],
        [
            0x1fcd6,
            0x001d
        ],
        [
            0x1f3ad,
            0x008f
        ],
        [
            0x1f43c,
            0x0097
        ],
        [
            0x18d04,
            0x006a
        ],
        [
            0x18d6e,
            0x0030
        ],
        [
            0x1f4d3,
            0x0092
        ],
        [
            0x2c803,
            0x00cc
        ],
        [
            0x2c8cf,
            0x00ba
        ],
        [
            0x2c989,
            0x0088
        ],
        [
            0x20a09,
            0x01b0
        ],
        [
            0x20bb9,
            0x0168
        ],
        [
            0x20d21,
            0x006c
        ],
        [
            0x20d8d,
            0x0037
        ],
        [
            0x20dc4,
            0x00e4
        ],
        [
            0x20ea8,
            0x0045
        ],
        [
            0x20eed,
            0x00e1
        ],
        [
            0x20fce,
            0x00f6
        ],
        [
            0x210c4,
            0x0141
        ],
        [
            0x21205,
            0x0183
        ],
        [
            0x21388,
            0x0034
        ],
        [
            0x213bc,
            0x00a9
        ],
        [
            0x24367,
            0x011b
        ],
        [
            0x1bdc2,
            0x0070
        ],
        [
            0x1cbf9,
            0x0091
        ],
        [
            0x29372,
            0x0054
        ],
        [
            0x1a0d0,
            0x00ce
        ],
        [
            0x1a19e,
            0x0077
        ],
        [
            0x14f4c,
            0x0057
        ],
        [
            0x2790a,
            0x02df
        ],
        [
            0x1d9ab,
            0x0219
        ],
        [
            0x1dbc4,
            0x00f9
        ],
        [
            0x1dcbd,
            0x0056
        ],
        [
            0x1dd13,
            0x01c2
        ],
        [
            0x14fa3,
            0x004d
        ],
        [
            0x27618,
            0x00d9
        ],
        [
            0x21dcd,
            0x0013
        ],
        [
            0x2a64f,
            0x00f0
        ],
        [
            0x24482,
            0x00e7
        ],
        [
            0x21465,
            0x00f2
        ],
        [
            0x24569,
            0x002b
        ],
        [
            0x2c3cf,
            0x010f
        ],
        [
            0x24594,
            0x00aa
        ],
        [
            0x250b2,
            0x0dab
        ],
        [
            0x1b6f4,
            0x000d
        ],
        [
            0x1b701,
            0x000d
        ],
        [
            0x23748,
            0x017c
        ],
        [
            0x282f5,
            0x01e1
        ],
        [
            0x238c4,
            0x0153
        ],
        [
            0x23a17,
            0x019c
        ],
        [
            0x23bb3,
            0x0016
        ],
        [
            0x2c4de,
            0x005c
        ],
        [
            0x23bc9,
            0x0020
        ],
        [
            0x27dea,
            0x00a5
        ],
        [
            0x2a73f,
            0x034d
        ],
        [
            0x14ff0,
            0x00e3
        ],
        [
            0x2bace,
            0x005f
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x25e5d,
            0x003c
        ],
        [
            0x1e86a,
            0x0011
        ],
        [
            0x1634a,
            0x0018
        ],
        [
            0x26e81,
            0x001f
        ],
        [
            0x26ea0,
            0x0054
        ],
        [
            0x26ef4,
            0x0149
        ],
        [
            0x2703d,
            0x004b
        ],
        [
            0x27088,
            0x017d
        ],
        [
            0x27205,
            0x0027
        ],
        [
            0x2722c,
            0x0041
        ],
        [
            0x2726d,
            0x01b1
        ],
        [
            0x16362,
            0x001f
        ],
        [
            0x2463e,
            0x002a
        ],
        [
            0x150d3,
            0x019e
        ],
        [
            0x194a8,
            0x0031
        ],
        [
            0x18d9e,
            0x007c
        ],
        [
            0x21557,
            0x00dc
        ],
        [
            0x1d3d8,
            0x0018
        ],
        [
            0x1d3f0,
            0x0053
        ],
        [
            0x17db0,
            0x0005
        ],
        [
            0x15271,
            0x011b
        ],
        [
            0x1538c,
            0x000b
        ],
        [
            0x24668,
            0x0138
        ],
        [
            0x247a0,
            0x0014
        ],
        [
            0x1ded5,
            0x0018
        ],
        [
            0x247b4,
            0x0027
        ],
        [
            0x1a215,
            0x004d
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2bb2d,
            0x00a5
        ],
        [
            0x2aa8c,
            0x00c1
        ],
        [
            0x2ab4d,
            0x0140
        ],
        [
            0x19982,
            0x00bf
        ],
        [
            0x19a41,
            0x014d
        ],
        [
            0x19b8e,
            0x0012
        ],
        [
            0x2ac8d,
            0x0005
        ],
        [
            0x2ac92,
            0x0005
        ],
        [
            0x2ac97,
            0x0005
        ],
        [
            0x2ac9c,
            0x0005
        ],
        [
            0x2aca1,
            0x0005
        ],
        [
            0x21633,
            0x0033
        ],
        [
            0x2aca6,
            0x0005
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2acab,
            0x009c
        ],
        [
            0x2ad47,
            0x009c
        ]
    ],
    sounds: [
        [
            0x0bf54,
            0x000a
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x0bf5e,
            0x0011
        ],
        [
            0x27ecb,
            0x0073
        ],
        [
            0x0bf6f,
            0x0011
        ],
        [
            0x0ff5d,
            0x0011
        ],
        [
            0x316fc,
            0x0056
        ],
        [
            0x13f4e,
            0x001f
        ],
        [
            0x0ff6e,
            0x0011
        ],
        [
            0x13f6d,
            0x000a
        ],
        [
            0x1bf47,
            0x000a
        ],
        [
            0x1bf51,
            0x0019
        ],
        [
            0x31752,
            0x004b
        ],
        [
            0x1bf6a,
            0x000a
        ],
        [
            0x27f3e,
            0x000f
        ],
        [
            0x27f4d,
            0x001d
        ],
        [
            0x3179d,
            0x0045
        ],
        [
            0x27f6a,
            0x000f
        ],
        [
            0x2bf40,
            0x001b
        ],
        [
            0x317e2,
            0x0033
        ],
        [
            0x2bf5b,
            0x0011
        ],
        [
            0x2bf6c,
            0x000f
        ],
        [
            0x31815,
            0x0075
        ],
        [
            0x2ff6c,
            0x0014
        ],
        [
            0x0bf54,
            0x000a
        ],
        [
            0x3188a,
            0x00ff
        ],
        [
            0x31989,
            0x000f
        ],
        [
            0x31998,
            0x000f
        ],
        [
            0x319a7,
            0x0092
        ],
        [
            0x319a7,
            0x0092
        ],
        [
            0x31a39,
            0x002d
        ],
        [
            0x31a66,
            0x00f8
        ],
        [
            0x31b5e,
            0x0016
        ],
        [
            0x31b74,
            0x0011
        ],
        [
            0x31b85,
            0x004b
        ],
        [
            0x31bd0,
            0x0011
        ],
        [
            0x31be1,
            0x003b
        ],
        [
            0x31c1c,
            0x008a
        ],
        [
            0x31ca6,
            0x0011
        ],
        [
            0x31cb7,
            0x000f
        ],
        [
            0x31cc6,
            0x00a2
        ],
        [
            0x31d68,
            0x00d3
        ],
        [
            0x31e3b,
            0x0097
        ],
        [
            0x2bf6c,
            0x000f
        ],
        [
            0x31cc6,
            0x00a2
        ],
        [
            0x31ed2,
            0x05d1
        ],
        [
            0x31ed2,
            0x05d1
        ],
        [
            0x324a3,
            0x0011
        ],
        [
            0x0bf54,
            0x000a
        ],
        [
            0x31815,
            0x0075
        ],
        [
            0x13f4e,
            0x001f
        ],
        [
            0x324b4,
            0x098e
        ],
        [
            0x31b85,
            0x004b
        ],
        [
            0x32e42,
            0x0011
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x32e53,
            0x000f
        ],
        [
            0x32e62,
            0x002f
        ],
        [
            0x32e91,
            0x001d
        ],
        [
            0x32eae,
            0x0018
        ],
        [
            0x32ec6,
            0x0016
        ],
        [
            0x32edc,
            0x001b
        ],
        [
            0x32ef7,
            0x0088
        ],
        [
            0x32f7f,
            0x0065
        ],
        [
            0x32fe4,
            0x0065
        ],
        [
            0x33049,
            0x0073
        ],
        [
            0x330bc,
            0x00f9
        ],
        [
            0x331b5,
            0x049e
        ],
        [
            0x34001,
            0x0ea8
        ],
        [
            0x34ea9,
            0x0b18
        ],
        [
            0x359c1,
            0x0b9c
        ],
        [
            0x3655d,
            0x0c6b
        ],
        [
            0x38001,
            0x0e56
        ],
        [
            0x371c8,
            0x0c70
        ],
        [
            0x38e57,
            0x0dec
        ],
        [
            0x39c43,
            0x0b77
        ],
        [
            0x33653,
            0x042f
        ],
        [
            0x3a7ba,
            0x0ac5
        ],
        [
            0x3b27f,
            0x0be4
        ]
    ],
    costumes: [
        [
            0x0beff,
            0x0055
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x0fea2,
            0x004b
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x0feed,
            0x0036
        ],
        [
            0x0ff23,
            0x003a
        ],
        [
            0x0ff23,
            0x003a
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x13f13,
            0x003b
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x23f2f,
            0x0045
        ],
        [
            0x1ff3e,
            0x0040
        ],
        [
            0x27e8f,
            0x003c
        ],
        [
            0x0ff23,
            0x003a
        ],
        [
            0x0ff23,
            0x003a
        ],
        [
            0x0beff,
            0x0055
        ],
        [
            0x0fea2,
            0x004b
        ]
    ],
    globdata: [
        [
            0x2ca11,
            0x0307
        ]
    ],
    // sprite palette data
    sprpals: [
        [
            0x07f61,
            0x0010
        ],
        [
            0x0beb2,
            0x0010
        ]
    ],
    // associates costume IDs with sprite sets (indexes into SPRLENS/SPROFFS)
    sprdesc: [
        [
            0x0bec2,
            0x0031
        ],
        [
            0x07f71,
            0x0009
        ]
    ],
    // number of sprites in each set (indicates length within SPRDATA)
    sprlens: [
        [
            0x1be32,
            0x0115
        ],
        [
            0x07f5b,
            0x0006
        ]
    ],
    // offset of each sprite set (indexes into SPRDATA)
    sproffs: [
        [
            0x2fd42,
            0x022a
        ],
        [
            0x0bef3,
            0x000c
        ]
    ],
    // sprite data sets (packed NES sprite data)
    sprdata: [
        [
            0x2ce11,
            0x2be0
        ],
        [
            0x0be28,
            0x008a
        ]
    ],
    charset: [
        [
            0x3f724,
            0x0090
        ]
    ],
    preplist: [
        [
            0x3fb90,
            0x000e
        ]
    ],
    titles: [
        [
            0x2701,
            0x0000
        ],
        [
            0x0320f,
            0x0000
        ]
    ],
    characters: {},
    version: 'Europe',
    lang: 'en-GB',
    crc32: 0xf59cfc3d,
    crc32Rom: 0x90333aea
};
// prettier-ignore
const $226142e01fd9f3a3$var$swe = {
    metadata: {
        name: 'Sweden',
        alpha2code: 'se',
        alpha3code: 'swe'
    },
    roomgfx: [
        [
            0x04001,
            0x03f0
        ],
        [
            0x043f1,
            0x069e
        ],
        [
            0x04a8f,
            0x0327
        ],
        [
            0x04db6,
            0x053b
        ],
        [
            0x052f1,
            0x06be
        ],
        [
            0x059af,
            0x0682
        ],
        [
            0x06031,
            0x0778
        ],
        [
            0x067a9,
            0x0517
        ],
        [
            0x06cc0,
            0x07fb
        ],
        [
            0x074bb,
            0x07be
        ],
        [
            0x08001,
            0x07a5
        ],
        [
            0x087a6,
            0x06dd
        ],
        [
            0x08e83,
            0x04ea
        ],
        [
            0x0936d,
            0x07e2
        ],
        [
            0x09b4f,
            0x0791
        ],
        [
            0x0a2e0,
            0x07b5
        ],
        [
            0x0aa95,
            0x0515
        ],
        [
            0x0afaa,
            0x0799
        ],
        [
            0x0b743,
            0x04bf
        ],
        [
            0x0bc02,
            0x0319
        ],
        [
            0x0c001,
            0x0464
        ],
        [
            0x0c465,
            0x072c
        ],
        [
            0x0cb91,
            0x0827
        ],
        [
            0x0d3b8,
            0x0515
        ],
        [
            0x0d8cd,
            0x064e
        ],
        [
            0x0df1b,
            0x0775
        ],
        [
            0x0e690,
            0x06dd
        ],
        [
            0x0ed6d,
            0x0376
        ],
        [
            0x0f0e3,
            0x05f7
        ],
        [
            0x0f6da,
            0x0791
        ],
        [
            0x07c79,
            0x02d6
        ],
        [
            0x10001,
            0x06a3
        ],
        [
            0x106a4,
            0x0921
        ],
        [
            0x10fc5,
            0x0361
        ],
        [
            0x11326,
            0x0489
        ],
        [
            0x117af,
            0x0437
        ],
        [
            0x11be6,
            0x084f
        ],
        [
            0x12435,
            0x0199
        ],
        [
            0x125ce,
            0x0947
        ],
        [
            0x12f15,
            0x037a
        ]
    ],
    costumegfx: [
        [
            0x2efe1,
            0x0eb8
        ],
        [
            0x30001,
            0x0340
        ]
    ],
    rooms: [
        [
            0x00000,
            0x0000
        ],
        [
            0x14001,
            0x0d12
        ],
        [
            0x1328f,
            0x04b3
        ],
        [
            0x15367,
            0x0859
        ],
        [
            0x13742,
            0x0694
        ],
        [
            0x15c45,
            0x0707
        ],
        [
            0x1658f,
            0x04e0
        ],
        [
            0x16a6f,
            0x0ac8
        ],
        [
            0x18001,
            0x06c7
        ],
        [
            0x1789c,
            0x03ea
        ],
        [
            0x18c09,
            0x0649
        ],
        [
            0x192ae,
            0x04ab
        ],
        [
            0x19982,
            0x0447
        ],
        [
            0x1a04d,
            0x047e
        ],
        [
            0x1a4cb,
            0x0444
        ],
        [
            0x1a90f,
            0x03b9
        ],
        [
            0x1acc8,
            0x07e9
        ],
        [
            0x1b511,
            0x06a4
        ],
        [
            0x1c001,
            0x0b1a
        ],
        [
            0x1ccfd,
            0x0486
        ],
        [
            0x1d482,
            0x0579
        ],
        [
            0x1df61,
            0x051e
        ],
        [
            0x1e8ec,
            0x05cf
        ],
        [
            0x1ef73,
            0x0398
        ],
        [
            0x1f5f0,
            0x071a
        ],
        [
            0x20001,
            0x049c
        ],
        [
            0x2051e,
            0x051e
        ],
        [
            0x21725,
            0x05d5
        ],
        [
            0x21ea5,
            0x047f
        ],
        [
            0x223d1,
            0x0460
        ],
        [
            0x22897,
            0x090d
        ],
        [
            0x24001,
            0x0378
        ],
        [
            0x247c9,
            0x03ca
        ],
        [
            0x24b93,
            0x050d
        ],
        [
            0x25267,
            0x0346
        ],
        [
            0x17cd0,
            0x01ca
        ],
        [
            0x255ad,
            0x0453
        ],
        [
            0x25a00,
            0x053e
        ],
        [
            0x25f3e,
            0x0647
        ],
        [
            0x1bc49,
            0x024b
        ],
        [
            0x26b58,
            0x01fa
        ],
        [
            0x26e27,
            0x0217
        ],
        [
            0x27345,
            0x02f4
        ],
        [
            0x27829,
            0x045c
        ],
        [
            0x28001,
            0x098a
        ],
        [
            0x289df,
            0x05a1
        ],
        [
            0x2a442,
            0x0201
        ],
        [
            0x2a6e9,
            0x0325
        ],
        [
            0x1fd75,
            0x01fc
        ],
        [
            0x2ac64,
            0x02a9
        ],
        [
            0x2af0d,
            0x02d1
        ],
        [
            0x2b2e6,
            0x03cc
        ],
        [
            0x23d61,
            0x0205
        ],
        [
            0x2b818,
            0x0168
        ],
        [
            0x27cf6,
            0x0169
        ]
    ],
    scripts: [
        [
            0x00000,
            0x0000
        ],
        [
            0x28f80,
            0x043b
        ],
        [
            0x293bb,
            0x0209
        ],
        [
            0x295c4,
            0x00ab
        ],
        [
            0x2966f,
            0x03fd
        ],
        [
            0x29a6c,
            0x01a1
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x29c0d,
            0x005c
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x29c69,
            0x0005
        ],
        [
            0x2b980,
            0x000d
        ],
        [
            0x2b98d,
            0x000d
        ],
        [
            0x186c8,
            0x0040
        ],
        [
            0x18708,
            0x0016
        ],
        [
            0x1b4b1,
            0x0046
        ],
        [
            0x1eebb,
            0x00b8
        ],
        [
            0x21cfa,
            0x005c
        ],
        [
            0x17537,
            0x0027
        ],
        [
            0x1fd0a,
            0x0027
        ],
        [
            0x1fd31,
            0x0027
        ],
        [
            0x1bbb5,
            0x0022
        ],
        [
            0x15bc0,
            0x0085
        ],
        [
            0x22324,
            0x001e
        ],
        [
            0x22342,
            0x008f
        ],
        [
            0x19252,
            0x002b
        ],
        [
            0x1cb1b,
            0x006d
        ],
        [
            0x1cb88,
            0x004c
        ],
        [
            0x1cbd4,
            0x0044
        ],
        [
            0x1cc18,
            0x0053
        ],
        [
            0x2049d,
            0x0081
        ],
        [
            0x1634c,
            0x0035
        ],
        [
            0x16381,
            0x001c
        ],
        [
            0x1639d,
            0x0014
        ],
        [
            0x163b1,
            0x001c
        ],
        [
            0x163cd,
            0x0027
        ],
        [
            0x163f4,
            0x019b
        ],
        [
            0x1d183,
            0x0094
        ],
        [
            0x1d217,
            0x0117
        ],
        [
            0x1d32e,
            0x001c
        ],
        [
            0x1d34a,
            0x0056
        ],
        [
            0x1d3a0,
            0x0072
        ],
        [
            0x1e47f,
            0x0028
        ],
        [
            0x1e4a7,
            0x0175
        ],
        [
            0x1e61c,
            0x022b
        ],
        [
            0x27c85,
            0x0071
        ],
        [
            0x17c86,
            0x004a
        ],
        [
            0x13dd6,
            0x0039
        ],
        [
            0x1871e,
            0x0270
        ],
        [
            0x1898e,
            0x00c0
        ],
        [
            0x18a4e,
            0x01b6
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x19dc9,
            0x00ee
        ],
        [
            0x21d56,
            0x00f5
        ],
        [
            0x1e847,
            0x0094
        ],
        [
            0x21e4b,
            0x0047
        ],
        [
            0x2b99a,
            0x004d
        ],
        [
            0x13e0f,
            0x0024
        ],
        [
            0x14d13,
            0x0014
        ],
        [
            0x1755e,
            0x0054
        ],
        [
            0x175b2,
            0x011a
        ],
        [
            0x176cc,
            0x0009
        ],
        [
            0x14d27,
            0x01b9
        ],
        [
            0x2aa0e,
            0x0256
        ],
        [
            0x231a4,
            0x06d2
        ],
        [
            0x2b9e7,
            0x001d
        ],
        [
            0x2ba04,
            0x0016
        ],
        [
            0x2ba1a,
            0x002d
        ],
        [
            0x2ba47,
            0x0027
        ],
        [
            0x2ba6e,
            0x0016
        ],
        [
            0x2ba84,
            0x0014
        ],
        [
            0x2ba98,
            0x0015
        ],
        [
            0x2baad,
            0x0029
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2bad6,
            0x0010
        ],
        [
            0x176d5,
            0x00a2
        ],
        [
            0x22831,
            0x0066
        ],
        [
            0x14ee0,
            0x0077
        ],
        [
            0x1f30b,
            0x011a
        ],
        [
            0x1fd58,
            0x001d
        ],
        [
            0x1f425,
            0x0095
        ],
        [
            0x1f4ba,
            0x009e
        ],
        [
            0x17777,
            0x006f
        ],
        [
            0x177e6,
            0x002f
        ],
        [
            0x1f558,
            0x0098
        ],
        [
            0x2bae6,
            0x00c4
        ],
        [
            0x2bbaa,
            0x00ae
        ],
        [
            0x2bc58,
            0x0088
        ],
        [
            0x20a3c,
            0x01bb
        ],
        [
            0x20bf7,
            0x0197
        ],
        [
            0x20d8e,
            0x006e
        ],
        [
            0x20dfc,
            0x0028
        ],
        [
            0x20e24,
            0x00ea
        ],
        [
            0x20f0e,
            0x0049
        ],
        [
            0x20f57,
            0x00e7
        ],
        [
            0x2103e,
            0x010c
        ],
        [
            0x2114a,
            0x0151
        ],
        [
            0x2129b,
            0x01b0
        ],
        [
            0x2144b,
            0x0034
        ],
        [
            0x2147f,
            0x00a9
        ],
        [
            0x24379,
            0x010e
        ],
        [
            0x1bbd7,
            0x0072
        ],
        [
            0x1cc6b,
            0x0092
        ],
        [
            0x2898b,
            0x0054
        ],
        [
            0x19eb7,
            0x00d3
        ],
        [
            0x19f8a,
            0x0077
        ],
        [
            0x14f57,
            0x0057
        ],
        [
            0x2703e,
            0x0307
        ],
        [
            0x1d9fb,
            0x024f
        ],
        [
            0x1dc4a,
            0x00e4
        ],
        [
            0x1dd2e,
            0x0059
        ],
        [
            0x1dd87,
            0x01c2
        ],
        [
            0x14fae,
            0x004d
        ],
        [
            0x26d52,
            0x00d5
        ],
        [
            0x21e92,
            0x0013
        ],
        [
            0x29c6e,
            0x00f0
        ],
        [
            0x24487,
            0x00e0
        ],
        [
            0x21528,
            0x00f2
        ],
        [
            0x24567,
            0x0023
        ],
        [
            0x2b6b2,
            0x010b
        ],
        [
            0x2458a,
            0x00a1
        ],
        [
            0x250a0,
            0x018b
        ],
        [
            0x1b4f7,
            0x000d
        ],
        [
            0x1b504,
            0x000d
        ],
        [
            0x23876,
            0x018e
        ],
        [
            0x27639,
            0x01f0
        ],
        [
            0x23a04,
            0x017b
        ],
        [
            0x23b7f,
            0x01ac
        ],
        [
            0x23d2b,
            0x0016
        ],
        [
            0x2b7bd,
            0x005b
        ],
        [
            0x23d41,
            0x0020
        ],
        [
            0x2a643,
            0x00a6
        ],
        [
            0x29d5e,
            0x0399
        ],
        [
            0x14ffb,
            0x00d2
        ],
        [
            0x2b1de,
            0x0063
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2522b,
            0x003c
        ],
        [
            0x1e8db,
            0x0011
        ],
        [
            0x13e33,
            0x0018
        ],
        [
            0x26585,
            0x001f
        ],
        [
            0x265a4,
            0x0054
        ],
        [
            0x265f8,
            0x017d
        ],
        [
            0x26775,
            0x004b
        ],
        [
            0x267c0,
            0x0165
        ],
        [
            0x26925,
            0x0027
        ],
        [
            0x2694c,
            0x0041
        ],
        [
            0x2698d,
            0x01cb
        ],
        [
            0x13e4b,
            0x001f
        ],
        [
            0x2462b,
            0x002a
        ],
        [
            0x150cd,
            0x0187
        ],
        [
            0x1927d,
            0x0031
        ],
        [
            0x17815,
            0x0087
        ],
        [
            0x2161a,
            0x00d8
        ],
        [
            0x1d412,
            0x0018
        ],
        [
            0x1d42a,
            0x0058
        ],
        [
            0x18c04,
            0x0005
        ],
        [
            0x15254,
            0x0108
        ],
        [
            0x1535c,
            0x000b
        ],
        [
            0x24655,
            0x0139
        ],
        [
            0x2478e,
            0x0014
        ],
        [
            0x1df49,
            0x0018
        ],
        [
            0x247a2,
            0x0027
        ],
        [
            0x1a001,
            0x004c
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2b241,
            0x00a5
        ],
        [
            0x2a0f7,
            0x00b5
        ],
        [
            0x2a1ac,
            0x0140
        ],
        [
            0x19759,
            0x00ca
        ],
        [
            0x19823,
            0x014d
        ],
        [
            0x19970,
            0x0012
        ],
        [
            0x2a2ec,
            0x0005
        ],
        [
            0x2a2f1,
            0x0005
        ],
        [
            0x2a2f6,
            0x0005
        ],
        [
            0x2a2fb,
            0x0005
        ],
        [
            0x2a300,
            0x0005
        ],
        [
            0x216f2,
            0x0033
        ],
        [
            0x2a305,
            0x0005
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a30a,
            0x009c
        ],
        [
            0x2a3a6,
            0x009c
        ]
    ],
    sounds: [
        [
            0x0bf58,
            0x000a
        ],
        [
            0x30352,
            0x0832
        ],
        [
            0x30352,
            0x0832
        ],
        [
            0x30352,
            0x0832
        ],
        [
            0x30352,
            0x0832
        ],
        [
            0x30352,
            0x0832
        ],
        [
            0x0bf62,
            0x0011
        ],
        [
            0x27e5f,
            0x0073
        ],
        [
            0x17f5a,
            0x0011
        ],
        [
            0x17f6b,
            0x0011
        ],
        [
            0x27ed2,
            0x0056
        ],
        [
            0x1bf55,
            0x001f
        ],
        [
            0x23f66,
            0x0011
        ],
        [
            0x0bf73,
            0x000a
        ],
        [
            0x1bf74,
            0x000a
        ],
        [
            0x27f28,
            0x0019
        ],
        [
            0x2bf0a,
            0x004b
        ],
        [
            0x1ff71,
            0x000a
        ],
        [
            0x27f41,
            0x000f
        ],
        [
            0x27f50,
            0x001d
        ],
        [
            0x2feaa,
            0x0045
        ],
        [
            0x27f6d,
            0x000f
        ],
        [
            0x2bf55,
            0x001b
        ],
        [
            0x2feef,
            0x0033
        ],
        [
            0x2ff22,
            0x0011
        ],
        [
            0x2bf70,
            0x000f
        ],
        [
            0x30b84,
            0x0075
        ],
        [
            0x2ff33,
            0x0014
        ],
        [
            0x0bf58,
            0x000a
        ],
        [
            0x30bf9,
            0x00ff
        ],
        [
            0x2ff47,
            0x000f
        ],
        [
            0x2ff56,
            0x000f
        ],
        [
            0x30cf8,
            0x0092
        ],
        [
            0x30cf8,
            0x0092
        ],
        [
            0x30d8a,
            0x002d
        ],
        [
            0x30db7,
            0x00f8
        ],
        [
            0x2ff65,
            0x0016
        ],
        [
            0x30eaf,
            0x0011
        ],
        [
            0x30ec0,
            0x004b
        ],
        [
            0x30f0b,
            0x0011
        ],
        [
            0x30f1c,
            0x003b
        ],
        [
            0x30f57,
            0x008a
        ],
        [
            0x30fe1,
            0x0011
        ],
        [
            0x30ff2,
            0x000f
        ],
        [
            0x31001,
            0x00a2
        ],
        [
            0x310a3,
            0x00d3
        ],
        [
            0x31176,
            0x0097
        ],
        [
            0x2bf70,
            0x000f
        ],
        [
            0x31001,
            0x00a2
        ],
        [
            0x3120d,
            0x05d1
        ],
        [
            0x3120d,
            0x05d1
        ],
        [
            0x317de,
            0x0011
        ],
        [
            0x0bf58,
            0x000a
        ],
        [
            0x30b84,
            0x0075
        ],
        [
            0x1bf55,
            0x001f
        ],
        [
            0x317ef,
            0x098e
        ],
        [
            0x30ec0,
            0x004b
        ],
        [
            0x3217d,
            0x0011
        ],
        [
            0x30352,
            0x0832
        ],
        [
            0x3218e,
            0x000f
        ],
        [
            0x3219d,
            0x002f
        ],
        [
            0x321cc,
            0x001d
        ],
        [
            0x321e9,
            0x0018
        ],
        [
            0x32201,
            0x0016
        ],
        [
            0x32217,
            0x001b
        ],
        [
            0x32232,
            0x0088
        ],
        [
            0x322ba,
            0x0065
        ],
        [
            0x3231f,
            0x0065
        ],
        [
            0x32384,
            0x0073
        ],
        [
            0x323f7,
            0x00f9
        ],
        [
            0x324f0,
            0x049e
        ],
        [
            0x3298e,
            0x0ea8
        ],
        [
            0x34001,
            0x0b18
        ],
        [
            0x34b19,
            0x0b9c
        ],
        [
            0x356b5,
            0x0c6b
        ],
        [
            0x36320,
            0x0e56
        ],
        [
            0x37176,
            0x0c70
        ],
        [
            0x38001,
            0x0dec
        ],
        [
            0x38ded,
            0x0b77
        ],
        [
            0x33836,
            0x042f
        ],
        [
            0x39964,
            0x0ac5
        ],
        [
            0x3a429,
            0x0be4
        ]
    ],
    costumes: [
        [
            0x0fef5,
            0x0055
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x17e9a,
            0x004b
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x0ff4a,
            0x0036
        ],
        [
            0x17ee5,
            0x003a
        ],
        [
            0x17ee5,
            0x003a
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x17f1f,
            0x003b
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x1be94,
            0x0045
        ],
        [
            0x1bed9,
            0x0040
        ],
        [
            0x1bf19,
            0x003c
        ],
        [
            0x17ee5,
            0x003a
        ],
        [
            0x17ee5,
            0x003a
        ],
        [
            0x0fef5,
            0x0055
        ],
        [
            0x17e9a,
            0x004b
        ]
    ],
    globdata: [
        [
            0x2c001,
            0x0307
        ]
    ],
    sprpals: [
        [
            0x07f55,
            0x0010
        ],
        [
            0x07f65,
            0x0010
        ]
    ],
    sprdesc: [
        [
            0x0bf1b,
            0x0031
        ],
        [
            0x07f75,
            0x0009
        ]
    ],
    sprlens: [
        [
            0x13e6a,
            0x0115
        ],
        [
            0x07f4f,
            0x0006
        ]
    ],
    sproffs: [
        [
            0x2bce0,
            0x022a
        ],
        [
            0x0bf4c,
            0x000c
        ]
    ],
    sprdata: [
        [
            0x2c401,
            0x2be0
        ],
        [
            0x0fe6b,
            0x008a
        ]
    ],
    charset: [
        [
            0x3f739,
            0x0094
        ]
    ],
    preplist: [
        [
            0x3fba9,
            0x000e
        ]
    ],
    titles: [
        [
            0x02701,
            0x0000
        ],
        [
            0x0320f,
            0x0000
        ]
    ],
    characters: {
        '<': "\xe4",
        '[': "\xe9",
        '\\': "\xe5",
        '>': "\xf6"
    },
    version: 'Sweden',
    lang: 'sv',
    crc32: 0x3f2bda65,
    crc32Rom: 0x5a841cb2
};
// prettier-ignore
const $226142e01fd9f3a3$var$fra = {
    metadata: {
        name: 'France',
        alpha2code: 'fr',
        alpha3code: 'fra'
    },
    roomgfx: [
        [
            0x04001,
            0x0426
        ],
        [
            0x04427,
            0x069e
        ],
        [
            0x04ac5,
            0x0327
        ],
        [
            0x04dec,
            0x053b
        ],
        [
            0x05327,
            0x06be
        ],
        [
            0x059e5,
            0x0682
        ],
        [
            0x06067,
            0x0778
        ],
        [
            0x067df,
            0x0517
        ],
        [
            0x06cf6,
            0x07fb
        ],
        [
            0x074f1,
            0x07be
        ],
        [
            0x08001,
            0x07a5
        ],
        [
            0x087a6,
            0x06dd
        ],
        [
            0x08e83,
            0x04ea
        ],
        [
            0x0936d,
            0x07e2
        ],
        [
            0x09b4f,
            0x0791
        ],
        [
            0x0a2e0,
            0x07b5
        ],
        [
            0x0aa95,
            0x0515
        ],
        [
            0x0afaa,
            0x0799
        ],
        [
            0x0b743,
            0x04bb
        ],
        [
            0x0bbfe,
            0x0319
        ],
        [
            0x0c001,
            0x0464
        ],
        [
            0x0c465,
            0x072c
        ],
        [
            0x0cb91,
            0x0827
        ],
        [
            0x0d3b8,
            0x0515
        ],
        [
            0x0d8cd,
            0x064e
        ],
        [
            0x0df1b,
            0x0775
        ],
        [
            0x0e690,
            0x06dd
        ],
        [
            0x0ed6d,
            0x0376
        ],
        [
            0x0f0e3,
            0x05f7
        ],
        [
            0x0f6da,
            0x0787
        ],
        [
            0x10001,
            0x02d6
        ],
        [
            0x102d7,
            0x06a3
        ],
        [
            0x1097a,
            0x0921
        ],
        [
            0x1129b,
            0x0361
        ],
        [
            0x115fc,
            0x0489
        ],
        [
            0x11a85,
            0x0437
        ],
        [
            0x11ebc,
            0x070d
        ],
        [
            0x07caf,
            0x0199
        ],
        [
            0x125c9,
            0x0947
        ],
        [
            0x12f10,
            0x037a
        ]
    ],
    costumegfx: [
        [
            0x30001,
            0x0eb8
        ],
        [
            0x2f608,
            0x0340
        ]
    ],
    rooms: [
        [
            0x00000,
            0x0000
        ],
        [
            0x14001,
            0x0d76
        ],
        [
            0x1328a,
            0x04c6
        ],
        [
            0x15451,
            0x0885
        ],
        [
            0x13750,
            0x0693
        ],
        [
            0x15d68,
            0x0709
        ],
        [
            0x166d4,
            0x0528
        ],
        [
            0x16bfc,
            0x0acc
        ],
        [
            0x18001,
            0x06e2
        ],
        [
            0x17a63,
            0x03e5
        ],
        [
            0x18c3b,
            0x066a
        ],
        [
            0x19301,
            0x049e
        ],
        [
            0x199c8,
            0x044b
        ],
        [
            0x1a0b1,
            0x0478
        ],
        [
            0x1a529,
            0x043f
        ],
        [
            0x1a968,
            0x03c8
        ],
        [
            0x1ad30,
            0x086f
        ],
        [
            0x1b5ff,
            0x069b
        ],
        [
            0x1c001,
            0x0aa9
        ],
        [
            0x1cc97,
            0x049e
        ],
        [
            0x1d42c,
            0x05a8
        ],
        [
            0x1df71,
            0x054e
        ],
        [
            0x1e9d1,
            0x0606
        ],
        [
            0x1f0a2,
            0x039a
        ],
        [
            0x1f74e,
            0x071c
        ],
        [
            0x20001,
            0x04b5
        ],
        [
            0x2052e,
            0x04ff
        ],
        [
            0x2172e,
            0x05db
        ],
        [
            0x21ead,
            0x0489
        ],
        [
            0x223e1,
            0x0465
        ],
        [
            0x228ac,
            0x0957
        ],
        [
            0x24001,
            0x037e
        ],
        [
            0x2481a,
            0x03ca
        ],
        [
            0x24be4,
            0x050d
        ],
        [
            0x252c0,
            0x0346
        ],
        [
            0x1bd30,
            0x01ca
        ],
        [
            0x25606,
            0x046d
        ],
        [
            0x25a73,
            0x055a
        ],
        [
            0x25fcd,
            0x0654
        ],
        [
            0x26c98,
            0x024b
        ],
        [
            0x26ee3,
            0x01fa
        ],
        [
            0x271dd,
            0x0217
        ],
        [
            0x27713,
            0x02f4
        ],
        [
            0x28001,
            0x045c
        ],
        [
            0x284ce,
            0x0975
        ],
        [
            0x28e97,
            0x05e6
        ],
        [
            0x27c3a,
            0x0201
        ],
        [
            0x2a9d6,
            0x0325
        ],
        [
            0x2af88,
            0x01fc
        ],
        [
            0x2b184,
            0x02a9
        ],
        [
            0x2b42d,
            0x02df
        ],
        [
            0x2b818,
            0x03ec
        ],
        [
            0x2bd67,
            0x0209
        ],
        [
            0x2c001,
            0x0168
        ],
        [
            0x2c4bf,
            0x0169
        ]
    ],
    scripts: [
        [
            0x00000,
            0x0000
        ],
        [
            0x2947d,
            0x0480
        ],
        [
            0x298fd,
            0x0226
        ],
        [
            0x29b23,
            0x0092
        ],
        [
            0x29bb5,
            0x040c
        ],
        [
            0x29fc1,
            0x01a1
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a162,
            0x005c
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a1be,
            0x0005
        ],
        [
            0x2c169,
            0x000d
        ],
        [
            0x2c176,
            0x000d
        ],
        [
            0x186e3,
            0x0040
        ],
        [
            0x18723,
            0x0016
        ],
        [
            0x1b59f,
            0x0046
        ],
        [
            0x1efd7,
            0x00cb
        ],
        [
            0x21d09,
            0x0054
        ],
        [
            0x176c8,
            0x0027
        ],
        [
            0x1fe6a,
            0x0027
        ],
        [
            0x1fe91,
            0x0027
        ],
        [
            0x1bc9a,
            0x0022
        ],
        [
            0x15cd6,
            0x0092
        ],
        [
            0x22336,
            0x001c
        ],
        [
            0x22352,
            0x008f
        ],
        [
            0x192a5,
            0x002b
        ],
        [
            0x1caaa,
            0x0069
        ],
        [
            0x1cb13,
            0x0054
        ],
        [
            0x1cb67,
            0x0048
        ],
        [
            0x1cbaf,
            0x0058
        ],
        [
            0x204b6,
            0x0078
        ],
        [
            0x16471,
            0x0035
        ],
        [
            0x164a6,
            0x001c
        ],
        [
            0x164c2,
            0x0014
        ],
        [
            0x164d6,
            0x001c
        ],
        [
            0x164f2,
            0x0027
        ],
        [
            0x16519,
            0x01bb
        ],
        [
            0x1d135,
            0x008d
        ],
        [
            0x1d1c2,
            0x0119
        ],
        [
            0x1d2db,
            0x001c
        ],
        [
            0x1d2f7,
            0x0056
        ],
        [
            0x1d34d,
            0x0072
        ],
        [
            0x1e4bf,
            0x0028
        ],
        [
            0x1e4e7,
            0x01e0
        ],
        [
            0x1e6c7,
            0x0241
        ],
        [
            0x2845d,
            0x0071
        ],
        [
            0x17e48,
            0x004c
        ],
        [
            0x13de3,
            0x0039
        ],
        [
            0x18739,
            0x0296
        ],
        [
            0x189cf,
            0x00c2
        ],
        [
            0x18a91,
            0x01a5
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x19e13,
            0x00f3
        ],
        [
            0x21d5d,
            0x00f6
        ],
        [
            0x1e908,
            0x00b8
        ],
        [
            0x21e53,
            0x0047
        ],
        [
            0x2c183,
            0x004d
        ],
        [
            0x13e1c,
            0x0024
        ],
        [
            0x14d77,
            0x0014
        ],
        [
            0x176ef,
            0x0059
        ],
        [
            0x17748,
            0x013f
        ],
        [
            0x17887,
            0x0009
        ],
        [
            0x14d8b,
            0x01d4
        ],
        [
            0x2acfb,
            0x028d
        ],
        [
            0x23203,
            0x0779
        ],
        [
            0x2c1d0,
            0x001b
        ],
        [
            0x2c1eb,
            0x001f
        ],
        [
            0x2c20a,
            0x0024
        ],
        [
            0x2c22e,
            0x0019
        ],
        [
            0x2c247,
            0x0018
        ],
        [
            0x2c25f,
            0x001d
        ],
        [
            0x2c27c,
            0x0016
        ],
        [
            0x2c292,
            0x0027
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2c2b9,
            0x0011
        ],
        [
            0x17890,
            0x00aa
        ],
        [
            0x22846,
            0x0066
        ],
        [
            0x14f5f,
            0x0083
        ],
        [
            0x1f43c,
            0x013a
        ],
        [
            0x1feb8,
            0x001d
        ],
        [
            0x1f576,
            0x0098
        ],
        [
            0x1f60e,
            0x009b
        ],
        [
            0x1793a,
            0x006e
        ],
        [
            0x179a8,
            0x0033
        ],
        [
            0x1f6a9,
            0x00a5
        ],
        [
            0x2c2ca,
            0x00ba
        ],
        [
            0x2c384,
            0x00ac
        ],
        [
            0x2c430,
            0x008f
        ],
        [
            0x20a2d,
            0x01be
        ],
        [
            0x20beb,
            0x0158
        ],
        [
            0x20d43,
            0x0079
        ],
        [
            0x20dbc,
            0x002b
        ],
        [
            0x20de7,
            0x00e8
        ],
        [
            0x20ecf,
            0x004a
        ],
        [
            0x20f19,
            0x0110
        ],
        [
            0x21029,
            0x0136
        ],
        [
            0x2115f,
            0x0152
        ],
        [
            0x212b1,
            0x01b3
        ],
        [
            0x21464,
            0x0032
        ],
        [
            0x21496,
            0x00a9
        ],
        [
            0x2437f,
            0x0133
        ],
        [
            0x1bcbc,
            0x0074
        ],
        [
            0x1cc07,
            0x0090
        ],
        [
            0x28e43,
            0x0054
        ],
        [
            0x19f06,
            0x00db
        ],
        [
            0x19fe1,
            0x0080
        ],
        [
            0x14fe2,
            0x0057
        ],
        [
            0x273f4,
            0x031f
        ],
        [
            0x1d9d4,
            0x0238
        ],
        [
            0x1dc0c,
            0x00fe
        ],
        [
            0x1dd0a,
            0x005a
        ],
        [
            0x1dd64,
            0x01f5
        ],
        [
            0x15039,
            0x004d
        ],
        [
            0x270dd,
            0x0100
        ],
        [
            0x21e9a,
            0x0013
        ],
        [
            0x2a1c3,
            0x00f0
        ],
        [
            0x244b2,
            0x00e4
        ],
        [
            0x2153f,
            0x00ec
        ],
        [
            0x24596,
            0x0033
        ],
        [
            0x2bc04,
            0x0108
        ],
        [
            0x245c9,
            0x009f
        ],
        [
            0x250f1,
            0x0193
        ],
        [
            0x1b5e5,
            0x000d
        ],
        [
            0x1b5f2,
            0x000d
        ],
        [
            0x2397c,
            0x0199
        ],
        [
            0x27a07,
            0x0233
        ],
        [
            0x23b15,
            0x0171
        ],
        [
            0x23c86,
            0x01bc
        ],
        [
            0x23e42,
            0x0016
        ],
        [
            0x2bd0c,
            0x005b
        ],
        [
            0x23e58,
            0x0020
        ],
        [
            0x27e3b,
            0x00b9
        ],
        [
            0x2a2b3,
            0x03d3
        ],
        [
            0x15086,
            0x00e4
        ],
        [
            0x2b70c,
            0x0067
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x25284,
            0x003c
        ],
        [
            0x1e9c0,
            0x0011
        ],
        [
            0x13e40,
            0x0018
        ],
        [
            0x26621,
            0x001f
        ],
        [
            0x26640,
            0x0054
        ],
        [
            0x26694,
            0x0173
        ],
        [
            0x26807,
            0x004b
        ],
        [
            0x26852,
            0x0190
        ],
        [
            0x269e2,
            0x0027
        ],
        [
            0x26a09,
            0x0041
        ],
        [
            0x26a4a,
            0x024e
        ],
        [
            0x13e58,
            0x001f
        ],
        [
            0x24668,
            0x002a
        ],
        [
            0x1516a,
            0x01c9
        ],
        [
            0x192d0,
            0x0031
        ],
        [
            0x179db,
            0x0088
        ],
        [
            0x2162b,
            0x00d0
        ],
        [
            0x1d3bf,
            0x0018
        ],
        [
            0x1d3d7,
            0x0055
        ],
        [
            0x18c36,
            0x0005
        ],
        [
            0x15333,
            0x0113
        ],
        [
            0x15446,
            0x000b
        ],
        [
            0x24692,
            0x014d
        ],
        [
            0x247df,
            0x0014
        ],
        [
            0x1df59,
            0x0018
        ],
        [
            0x247f3,
            0x0027
        ],
        [
            0x1a061,
            0x0050
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2b773,
            0x00a5
        ],
        [
            0x2a686,
            0x00ba
        ],
        [
            0x2a740,
            0x0140
        ],
        [
            0x1979f,
            0x00ca
        ],
        [
            0x19869,
            0x014d
        ],
        [
            0x199b6,
            0x0012
        ],
        [
            0x2a880,
            0x0005
        ],
        [
            0x2a885,
            0x0005
        ],
        [
            0x2a88a,
            0x0005
        ],
        [
            0x2a88f,
            0x0005
        ],
        [
            0x2a894,
            0x0005
        ],
        [
            0x216fb,
            0x0033
        ],
        [
            0x2a899,
            0x0005
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a89e,
            0x009c
        ],
        [
            0x2a93a,
            0x009c
        ]
    ],
    sounds: [
        [
            0x07f74,
            0x000a
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x0bf6c,
            0x0011
        ],
        [
            0x1befa,
            0x0073
        ],
        [
            0x17f10,
            0x0011
        ],
        [
            0x17f21,
            0x0011
        ],
        [
            0x1fed5,
            0x0056
        ],
        [
            0x17f32,
            0x001f
        ],
        [
            0x17f51,
            0x0011
        ],
        [
            0x0ff76,
            0x000a
        ],
        [
            0x17f62,
            0x000a
        ],
        [
            0x1ff2b,
            0x0019
        ],
        [
            0x23e78,
            0x004b
        ],
        [
            0x17f6c,
            0x000a
        ],
        [
            0x1bf6d,
            0x000f
        ],
        [
            0x1ff44,
            0x001d
        ],
        [
            0x23ec3,
            0x0045
        ],
        [
            0x1ff61,
            0x000f
        ],
        [
            0x23f08,
            0x001b
        ],
        [
            0x23f23,
            0x0033
        ],
        [
            0x23f56,
            0x0011
        ],
        [
            0x1ff70,
            0x000f
        ],
        [
            0x27ef4,
            0x0075
        ],
        [
            0x23f67,
            0x0014
        ],
        [
            0x07f74,
            0x000a
        ],
        [
            0x2fb83,
            0x00ff
        ],
        [
            0x27f69,
            0x000f
        ],
        [
            0x2bf70,
            0x000f
        ],
        [
            0x2fc82,
            0x0092
        ],
        [
            0x2fc82,
            0x0092
        ],
        [
            0x2fd14,
            0x002d
        ],
        [
            0x2fd41,
            0x00f8
        ],
        [
            0x2fe39,
            0x0016
        ],
        [
            0x2fe4f,
            0x0011
        ],
        [
            0x2fe60,
            0x004b
        ],
        [
            0x2feab,
            0x0011
        ],
        [
            0x2febc,
            0x003b
        ],
        [
            0x316fc,
            0x008a
        ],
        [
            0x2fef7,
            0x0011
        ],
        [
            0x2ff08,
            0x000f
        ],
        [
            0x31786,
            0x00a2
        ],
        [
            0x31828,
            0x00d3
        ],
        [
            0x318fb,
            0x0097
        ],
        [
            0x1ff70,
            0x000f
        ],
        [
            0x31786,
            0x00a2
        ],
        [
            0x31992,
            0x05d1
        ],
        [
            0x31992,
            0x05d1
        ],
        [
            0x2ff17,
            0x0011
        ],
        [
            0x07f74,
            0x000a
        ],
        [
            0x27ef4,
            0x0075
        ],
        [
            0x17f32,
            0x001f
        ],
        [
            0x31f63,
            0x098e
        ],
        [
            0x2fe60,
            0x004b
        ],
        [
            0x2ff28,
            0x0011
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x2ff39,
            0x000f
        ],
        [
            0x2ff48,
            0x002f
        ],
        [
            0x328f1,
            0x001d
        ],
        [
            0x3290e,
            0x0018
        ],
        [
            0x32926,
            0x0016
        ],
        [
            0x3293c,
            0x001b
        ],
        [
            0x32957,
            0x0088
        ],
        [
            0x329df,
            0x0065
        ],
        [
            0x32a44,
            0x0065
        ],
        [
            0x32aa9,
            0x0073
        ],
        [
            0x32b1c,
            0x00f9
        ],
        [
            0x32c15,
            0x049e
        ],
        [
            0x330b3,
            0x0ea8
        ],
        [
            0x34001,
            0x0b18
        ],
        [
            0x34b19,
            0x0b9c
        ],
        [
            0x356b5,
            0x0c6b
        ],
        [
            0x36320,
            0x0e56
        ],
        [
            0x37176,
            0x0c70
        ],
        [
            0x38001,
            0x0dec
        ],
        [
            0x38ded,
            0x0b77
        ],
        [
            0x39964,
            0x042f
        ],
        [
            0x39d93,
            0x0ac5
        ],
        [
            0x3a858,
            0x0be4
        ]
    ],
    costumes: [
        [
            0x0bf17,
            0x0055
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x13e77,
            0x004b
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x07f3e,
            0x0036
        ],
        [
            0x13ec2,
            0x003a
        ],
        [
            0x13ec2,
            0x003a
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x13efc,
            0x003b
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x13f37,
            0x0045
        ],
        [
            0x17e94,
            0x0040
        ],
        [
            0x17ed4,
            0x003c
        ],
        [
            0x13ec2,
            0x003a
        ],
        [
            0x13ec2,
            0x003a
        ],
        [
            0x0bf17,
            0x0055
        ],
        [
            0x13e77,
            0x004b
        ]
    ],
    globdata: [
        [
            0x2c628,
            0x0307
        ]
    ],
    sprpals: [
        [
            0x07ed8,
            0x0010
        ],
        [
            0x07ee8,
            0x0010
        ]
    ],
    sprdesc: [
        [
            0x07ef8,
            0x0031
        ],
        [
            0x07f29,
            0x0009
        ]
    ],
    sprlens: [
        [
            0x0fe61,
            0x0115
        ],
        [
            0x07ed2,
            0x0006
        ]
    ],
    sproffs: [
        [
            0x2f959,
            0x022a
        ],
        [
            0x07f32,
            0x000c
        ]
    ],
    sprdata: [
        [
            0x2ca28,
            0x2be0
        ],
        [
            0x07e48,
            0x008a
        ]
    ],
    charset: [
        [
            0x3f739,
            0x009a
        ]
    ],
    preplist: [
        [
            0x3fbaf,
            0x0010
        ]
    ],
    titles: [
        [
            0x02701,
            0x0000
        ],
        [
            0x0320f,
            0x0000
        ]
    ],
    characters: {
        '[': "\xe9",
        '<': "\xe0",
        '\\': "\xe8",
        '>': "\xe7",
        ']': "\xea",
        '|': "\xf4",
        '{': "\xee",
        '=': "\xe2",
        '}': "\xf9",
        '_': "\xfb",
        '&': "\xc7"
    },
    version: 'France',
    lang: 'fr',
    crc32: 0xf4b70bfe,
    crc32Rom: 0x9118cd29
};
// prettier-ignore
const $226142e01fd9f3a3$var$ger = {
    metadata: {
        name: 'Germany',
        alpha2code: 'de',
        alpha3code: 'deu'
    },
    roomgfx: [
        [
            0x04001,
            0x0406
        ],
        [
            0x04407,
            0x069e
        ],
        [
            0x04aa5,
            0x0327
        ],
        [
            0x04dcc,
            0x053b
        ],
        [
            0x05307,
            0x06be
        ],
        [
            0x059c5,
            0x0682
        ],
        [
            0x06047,
            0x0778
        ],
        [
            0x067bf,
            0x0517
        ],
        [
            0x06cd6,
            0x07fb
        ],
        [
            0x074d1,
            0x07be
        ],
        [
            0x08001,
            0x07a5
        ],
        [
            0x087a6,
            0x06dd
        ],
        [
            0x08e83,
            0x04ea
        ],
        [
            0x0936d,
            0x07e2
        ],
        [
            0x09b4f,
            0x0791
        ],
        [
            0x0a2e0,
            0x07b5
        ],
        [
            0x0aa95,
            0x0515
        ],
        [
            0x0afaa,
            0x0799
        ],
        [
            0x0b743,
            0x04bb
        ],
        [
            0x0bbfe,
            0x0319
        ],
        [
            0x0c001,
            0x0464
        ],
        [
            0x0c465,
            0x072c
        ],
        [
            0x0cb91,
            0x0827
        ],
        [
            0x0d3b8,
            0x0515
        ],
        [
            0x0d8cd,
            0x064e
        ],
        [
            0x0df1b,
            0x0775
        ],
        [
            0x0e690,
            0x06dd
        ],
        [
            0x0ed6d,
            0x0376
        ],
        [
            0x0f0e3,
            0x05f7
        ],
        [
            0x0f6da,
            0x0787
        ],
        [
            0x07c8f,
            0x02d6
        ],
        [
            0x10001,
            0x06a3
        ],
        [
            0x106a4,
            0x0921
        ],
        [
            0x10fc5,
            0x0361
        ],
        [
            0x11326,
            0x0489
        ],
        [
            0x117af,
            0x0437
        ],
        [
            0x11be6,
            0x07a0
        ],
        [
            0x12386,
            0x0199
        ],
        [
            0x1251f,
            0x0947
        ],
        [
            0x12e66,
            0x037a
        ]
    ],
    costumegfx: [
        [
            0x30001,
            0x0eb8
        ],
        [
            0x2f4ce,
            0x0340
        ]
    ],
    rooms: [
        [
            0x00000,
            0x0000
        ],
        [
            0x14001,
            0x0d63
        ],
        [
            0x131e0,
            0x04a9
        ],
        [
            0x13689,
            0x086b
        ],
        [
            0x15421,
            0x06a8
        ],
        [
            0x15b5d,
            0x0731
        ],
        [
            0x16507,
            0x0501
        ],
        [
            0x16a08,
            0x0ae9
        ],
        [
            0x18001,
            0x06da
        ],
        [
            0x17880,
            0x03d0
        ],
        [
            0x18c7b,
            0x0651
        ],
        [
            0x19328,
            0x04a7
        ],
        [
            0x199fe,
            0x0447
        ],
        [
            0x1a0f1,
            0x0486
        ],
        [
            0x1a577,
            0x045d
        ],
        [
            0x1a9d4,
            0x03ae
        ],
        [
            0x1ad82,
            0x0840
        ],
        [
            0x1b622,
            0x06c3
        ],
        [
            0x1c001,
            0x0b07
        ],
        [
            0x1cd05,
            0x0494
        ],
        [
            0x1d4a5,
            0x05ac
        ],
        [
            0x1dfd6,
            0x0524
        ],
        [
            0x1e9c0,
            0x05f7
        ],
        [
            0x1f09a,
            0x038e
        ],
        [
            0x1f75f,
            0x0733
        ],
        [
            0x20001,
            0x04a9
        ],
        [
            0x2052a,
            0x052e
        ],
        [
            0x2177c,
            0x0621
        ],
        [
            0x21f57,
            0x0495
        ],
        [
            0x2249a,
            0x045e
        ],
        [
            0x2295e,
            0x0951
        ],
        [
            0x24001,
            0x036e
        ],
        [
            0x247f9,
            0x03ca
        ],
        [
            0x24bc3,
            0x050d
        ],
        [
            0x252a8,
            0x0346
        ],
        [
            0x17ca2,
            0x01ca
        ],
        [
            0x255ee,
            0x046f
        ],
        [
            0x25a5d,
            0x054d
        ],
        [
            0x25faa,
            0x064b
        ],
        [
            0x26be2,
            0x024b
        ],
        [
            0x26e2d,
            0x01fa
        ],
        [
            0x2710f,
            0x0217
        ],
        [
            0x27663,
            0x02f4
        ],
        [
            0x28001,
            0x045c
        ],
        [
            0x284ce,
            0x0a8f
        ],
        [
            0x28fb1,
            0x05ff
        ],
        [
            0x27b69,
            0x0201
        ],
        [
            0x2aaa9,
            0x0325
        ],
        [
            0x1bd7c,
            0x01fc
        ],
        [
            0x2b031,
            0x02a9
        ],
        [
            0x2b2da,
            0x02d8
        ],
        [
            0x2b6d2,
            0x03d2
        ],
        [
            0x2bc0d,
            0x020d
        ],
        [
            0x2c001,
            0x0168
        ],
        [
            0x27e11,
            0x0169
        ]
    ],
    scripts: [
        [
            0x00000,
            0x0000
        ],
        [
            0x295b0,
            0x045a
        ],
        [
            0x29a0a,
            0x0218
        ],
        [
            0x29c22,
            0x00b1
        ],
        [
            0x29cd3,
            0x0408
        ],
        [
            0x2a0db,
            0x01a1
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a27c,
            0x005c
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a2d8,
            0x0005
        ],
        [
            0x2c169,
            0x000d
        ],
        [
            0x2c176,
            0x000d
        ],
        [
            0x186db,
            0x0040
        ],
        [
            0x1871b,
            0x0016
        ],
        [
            0x1b5c2,
            0x0046
        ],
        [
            0x1efb7,
            0x00e3
        ],
        [
            0x21d9d,
            0x0069
        ],
        [
            0x174f1,
            0x0027
        ],
        [
            0x1fe92,
            0x0027
        ],
        [
            0x1feb9,
            0x0027
        ],
        [
            0x1bce5,
            0x0022
        ],
        [
            0x13ef4,
            0x0087
        ],
        [
            0x223ec,
            0x001f
        ],
        [
            0x2240b,
            0x008f
        ],
        [
            0x192cc,
            0x002b
        ],
        [
            0x1cb08,
            0x006e
        ],
        [
            0x1cb76,
            0x004e
        ],
        [
            0x1cbc4,
            0x004d
        ],
        [
            0x1cc11,
            0x0059
        ],
        [
            0x204aa,
            0x0080
        ],
        [
            0x1628e,
            0x0035
        ],
        [
            0x162c3,
            0x001c
        ],
        [
            0x162df,
            0x0014
        ],
        [
            0x162f3,
            0x001c
        ],
        [
            0x1630f,
            0x0027
        ],
        [
            0x16336,
            0x01d1
        ],
        [
            0x1d199,
            0x00a0
        ],
        [
            0x1d239,
            0x011c
        ],
        [
            0x1d355,
            0x001c
        ],
        [
            0x1d371,
            0x0056
        ],
        [
            0x1d3c7,
            0x0072
        ],
        [
            0x1e4fa,
            0x0028
        ],
        [
            0x1e522,
            0x019d
        ],
        [
            0x1e6bf,
            0x023b
        ],
        [
            0x2845d,
            0x0071
        ],
        [
            0x17c50,
            0x0052
        ],
        [
            0x15ac9,
            0x0039
        ],
        [
            0x18731,
            0x02e7
        ],
        [
            0x18a18,
            0x00bc
        ],
        [
            0x18ad4,
            0x01a2
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x19e45,
            0x00f8
        ],
        [
            0x21e06,
            0x00f7
        ],
        [
            0x1e8fa,
            0x00b5
        ],
        [
            0x21efd,
            0x0047
        ],
        [
            0x2c183,
            0x004d
        ],
        [
            0x15b02,
            0x0024
        ],
        [
            0x14d64,
            0x0014
        ],
        [
            0x17518,
            0x005e
        ],
        [
            0x17576,
            0x0125
        ],
        [
            0x1769b,
            0x0009
        ],
        [
            0x14d78,
            0x01c7
        ],
        [
            0x2adce,
            0x0263
        ],
        [
            0x232af,
            0x077f
        ],
        [
            0x2c1d0,
            0x001e
        ],
        [
            0x2c1ee,
            0x0024
        ],
        [
            0x2c212,
            0x002e
        ],
        [
            0x2c240,
            0x0022
        ],
        [
            0x2c262,
            0x0013
        ],
        [
            0x2c275,
            0x001e
        ],
        [
            0x2c293,
            0x0016
        ],
        [
            0x2c2a9,
            0x0027
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2c2d0,
            0x0012
        ],
        [
            0x176a4,
            0x00a4
        ],
        [
            0x228f8,
            0x0066
        ],
        [
            0x14f3f,
            0x007f
        ],
        [
            0x1f428,
            0x013a
        ],
        [
            0x1fee0,
            0x001d
        ],
        [
            0x1f562,
            0x00a0
        ],
        [
            0x1f602,
            0x00a4
        ],
        [
            0x17748,
            0x0076
        ],
        [
            0x177be,
            0x0036
        ],
        [
            0x1f6a6,
            0x00b9
        ],
        [
            0x2c2e2,
            0x00cb
        ],
        [
            0x2c3ad,
            0x00b7
        ],
        [
            0x2c464,
            0x008a
        ],
        [
            0x20a58,
            0x01bd
        ],
        [
            0x20c15,
            0x0181
        ],
        [
            0x20d96,
            0x0078
        ],
        [
            0x20e0e,
            0x003c
        ],
        [
            0x20e4a,
            0x00e9
        ],
        [
            0x20f33,
            0x0046
        ],
        [
            0x20f79,
            0x00f6
        ],
        [
            0x2106f,
            0x0118
        ],
        [
            0x21187,
            0x015b
        ],
        [
            0x212e2,
            0x01ac
        ],
        [
            0x2148e,
            0x003f
        ],
        [
            0x214cd,
            0x00a9
        ],
        [
            0x2436f,
            0x0126
        ],
        [
            0x1bd07,
            0x0075
        ],
        [
            0x1cc6a,
            0x009b
        ],
        [
            0x28f5d,
            0x0054
        ],
        [
            0x19f3d,
            0x00e1
        ],
        [
            0x1a01e,
            0x0086
        ],
        [
            0x14fbe,
            0x0057
        ],
        [
            0x27326,
            0x033d
        ],
        [
            0x1da51,
            0x023b
        ],
        [
            0x1dc8c,
            0x00fb
        ],
        [
            0x1dd87,
            0x0056
        ],
        [
            0x1dddd,
            0x01e1
        ],
        [
            0x15015,
            0x004d
        ],
        [
            0x27027,
            0x00e8
        ],
        [
            0x21f44,
            0x0013
        ],
        [
            0x2a2dd,
            0x00f0
        ],
        [
            0x24495,
            0x00f8
        ],
        [
            0x21576,
            0x00f9
        ],
        [
            0x2458d,
            0x002b
        ],
        [
            0x2baa4,
            0x010f
        ],
        [
            0x245b8,
            0x00a5
        ],
        [
            0x250d0,
            0x019c
        ],
        [
            0x1b608,
            0x000d
        ],
        [
            0x1b615,
            0x000d
        ],
        [
            0x23a2e,
            0x0185
        ],
        [
            0x27957,
            0x0212
        ],
        [
            0x23bb3,
            0x0158
        ],
        [
            0x23d0b,
            0x01c4
        ],
        [
            0x23ecf,
            0x0016
        ],
        [
            0x2bbb3,
            0x005a
        ],
        [
            0x23ee5,
            0x0020
        ],
        [
            0x27d6a,
            0x00a7
        ],
        [
            0x2a3cd,
            0x038c
        ],
        [
            0x15062,
            0x00f6
        ],
        [
            0x2b5b2,
            0x007b
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2526c,
            0x003c
        ],
        [
            0x1e9af,
            0x0011
        ],
        [
            0x15b26,
            0x0018
        ],
        [
            0x265f5,
            0x001f
        ],
        [
            0x26614,
            0x0054
        ],
        [
            0x26668,
            0x018e
        ],
        [
            0x267f6,
            0x004b
        ],
        [
            0x26841,
            0x0196
        ],
        [
            0x269d7,
            0x0027
        ],
        [
            0x269fe,
            0x0041
        ],
        [
            0x26a3f,
            0x01a3
        ],
        [
            0x15b3e,
            0x001f
        ],
        [
            0x2465d,
            0x002a
        ],
        [
            0x15158,
            0x0198
        ],
        [
            0x192f7,
            0x0031
        ],
        [
            0x177f4,
            0x008c
        ],
        [
            0x2166f,
            0x00da
        ],
        [
            0x1d439,
            0x0018
        ],
        [
            0x1d451,
            0x0054
        ],
        [
            0x18c76,
            0x0005
        ],
        [
            0x152f0,
            0x0126
        ],
        [
            0x15416,
            0x000b
        ],
        [
            0x24687,
            0x0137
        ],
        [
            0x247be,
            0x0014
        ],
        [
            0x1dfbe,
            0x0018
        ],
        [
            0x247d2,
            0x0027
        ],
        [
            0x1a0a4,
            0x004d
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2b62d,
            0x00a5
        ],
        [
            0x2a759,
            0x00ba
        ],
        [
            0x2a813,
            0x0140
        ],
        [
            0x197cf,
            0x00d0
        ],
        [
            0x1989f,
            0x014d
        ],
        [
            0x199ec,
            0x0012
        ],
        [
            0x2a953,
            0x0005
        ],
        [
            0x2a958,
            0x0005
        ],
        [
            0x2a95d,
            0x0005
        ],
        [
            0x2a962,
            0x0005
        ],
        [
            0x2a967,
            0x0005
        ],
        [
            0x21749,
            0x0033
        ],
        [
            0x2a96c,
            0x0005
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a971,
            0x009c
        ],
        [
            0x2aa0d,
            0x009c
        ]
    ],
    sounds: [
        [
            0x0bf6d,
            0x000a
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x23f05,
            0x0011
        ],
        [
            0x2fa49,
            0x0073
        ],
        [
            0x23f16,
            0x0011
        ],
        [
            0x23f27,
            0x0011
        ],
        [
            0x2fabc,
            0x0056
        ],
        [
            0x23f38,
            0x001f
        ],
        [
            0x23f57,
            0x0011
        ],
        [
            0x0ff76,
            0x000a
        ],
        [
            0x17f71,
            0x000a
        ],
        [
            0x2bf2f,
            0x0019
        ],
        [
            0x2fb12,
            0x004b
        ],
        [
            0x23f68,
            0x000a
        ],
        [
            0x2bf48,
            0x000f
        ],
        [
            0x2bf57,
            0x001d
        ],
        [
            0x2fb5d,
            0x0045
        ],
        [
            0x2fba2,
            0x000f
        ],
        [
            0x2fbb1,
            0x001b
        ],
        [
            0x2fbcc,
            0x0033
        ],
        [
            0x2fbff,
            0x0011
        ],
        [
            0x2fc10,
            0x000f
        ],
        [
            0x2fc1f,
            0x0075
        ],
        [
            0x2fc94,
            0x0014
        ],
        [
            0x0bf6d,
            0x000a
        ],
        [
            0x2fca8,
            0x00ff
        ],
        [
            0x2fda7,
            0x000f
        ],
        [
            0x2fdb6,
            0x000f
        ],
        [
            0x2fdc5,
            0x0092
        ],
        [
            0x2fdc5,
            0x0092
        ],
        [
            0x2fe57,
            0x002d
        ],
        [
            0x2fe84,
            0x00f8
        ],
        [
            0x316fc,
            0x0016
        ],
        [
            0x31712,
            0x0011
        ],
        [
            0x31723,
            0x004b
        ],
        [
            0x3176e,
            0x0011
        ],
        [
            0x3177f,
            0x003b
        ],
        [
            0x317ba,
            0x008a
        ],
        [
            0x31844,
            0x0011
        ],
        [
            0x31855,
            0x000f
        ],
        [
            0x31864,
            0x00a2
        ],
        [
            0x31906,
            0x00d3
        ],
        [
            0x319d9,
            0x0097
        ],
        [
            0x2fc10,
            0x000f
        ],
        [
            0x31864,
            0x00a2
        ],
        [
            0x31a70,
            0x05d1
        ],
        [
            0x31a70,
            0x05d1
        ],
        [
            0x32041,
            0x0011
        ],
        [
            0x0bf6d,
            0x000a
        ],
        [
            0x2fc1f,
            0x0075
        ],
        [
            0x23f38,
            0x001f
        ],
        [
            0x32052,
            0x098e
        ],
        [
            0x31723,
            0x004b
        ],
        [
            0x329e0,
            0x0011
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x329f1,
            0x000f
        ],
        [
            0x32a00,
            0x002f
        ],
        [
            0x32a2f,
            0x001d
        ],
        [
            0x32a4c,
            0x0018
        ],
        [
            0x32a64,
            0x0016
        ],
        [
            0x32a7a,
            0x001b
        ],
        [
            0x32a95,
            0x0088
        ],
        [
            0x32b1d,
            0x0065
        ],
        [
            0x32b82,
            0x0065
        ],
        [
            0x32be7,
            0x0073
        ],
        [
            0x32c5a,
            0x00f9
        ],
        [
            0x32d53,
            0x049e
        ],
        [
            0x34001,
            0x0ea8
        ],
        [
            0x331f1,
            0x0b18
        ],
        [
            0x34ea9,
            0x0b9c
        ],
        [
            0x35a45,
            0x0c6b
        ],
        [
            0x366b0,
            0x0e56
        ],
        [
            0x38001,
            0x0c70
        ],
        [
            0x38c71,
            0x0dec
        ],
        [
            0x39a5d,
            0x0b77
        ],
        [
            0x37506,
            0x042f
        ],
        [
            0x3a5d4,
            0x0ac5
        ],
        [
            0x3b099,
            0x0be4
        ]
    ],
    costumes: [
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x17e6c,
            0x004b
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0ff40,
            0x0036
        ],
        [
            0x17eb7,
            0x003a
        ],
        [
            0x17eb7,
            0x003a
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x17ef1,
            0x003b
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x17f2c,
            0x0045
        ],
        [
            0x1fefd,
            0x0040
        ],
        [
            0x1ff3d,
            0x003c
        ],
        [
            0x17eb7,
            0x003a
        ],
        [
            0x17eb7,
            0x003a
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x17e6c,
            0x004b
        ]
    ],
    globdata: [
        [
            0x2c4ee,
            0x0307
        ]
    ],
    sprpals: [
        [
            0x07f6b,
            0x0010
        ],
        [
            0x0bf17,
            0x0010
        ]
    ],
    sprdesc: [
        [
            0x0bf27,
            0x0031
        ],
        [
            0x0bf58,
            0x0009
        ]
    ],
    sprlens: [
        [
            0x2be1a,
            0x0115
        ],
        [
            0x07f65,
            0x0006
        ]
    ],
    sproffs: [
        [
            0x2f81f,
            0x022a
        ],
        [
            0x0bf61,
            0x000c
        ]
    ],
    sprdata: [
        [
            0x2c8ee,
            0x2be0
        ],
        [
            0x0fe61,
            0x008a
        ]
    ],
    charset: [
        [
            0x3f739,
            0x0096
        ]
    ],
    preplist: [
        [
            0x3fbab,
            0x000e
        ]
    ],
    titles: [
        [
            0x02701,
            0x0000
        ],
        [
            0x0320f,
            0x0000
        ]
    ],
    characters: {
        '=': "\xdf",
        '\\': "\xe4",
        '{': "\xf6",
        '[': "\xfc",
        '(': '(',
        ')': ')'
    },
    version: 'Germany',
    lang: 'de',
    crc32: 0x60ea98a0,
    crc32Rom: 0x05455e77
};
// prettier-ignore
const $226142e01fd9f3a3$var$esp = {
    metadata: {
        name: 'Spain',
        alpha2code: 'es',
        alpha3code: 'esp'
    },
    roomgfx: [
        [
            0x04001,
            0x041b
        ],
        [
            0x0441c,
            0x069e
        ],
        [
            0x04aba,
            0x0327
        ],
        [
            0x04de1,
            0x053b
        ],
        [
            0x0531c,
            0x06be
        ],
        [
            0x059da,
            0x0682
        ],
        [
            0x0605c,
            0x0778
        ],
        [
            0x067d4,
            0x0517
        ],
        [
            0x06ceb,
            0x07fb
        ],
        [
            0x074e6,
            0x07be
        ],
        [
            0x08001,
            0x07a5
        ],
        [
            0x087a6,
            0x06dd
        ],
        [
            0x08e83,
            0x04ea
        ],
        [
            0x0936d,
            0x07e2
        ],
        [
            0x09b4f,
            0x0791
        ],
        [
            0x0a2e0,
            0x07b5
        ],
        [
            0x0aa95,
            0x0515
        ],
        [
            0x0afaa,
            0x0799
        ],
        [
            0x0b743,
            0x04b9
        ],
        [
            0x0bbfc,
            0x0319
        ],
        [
            0x0c001,
            0x0464
        ],
        [
            0x0c465,
            0x072c
        ],
        [
            0x0cb91,
            0x0827
        ],
        [
            0x0d3b8,
            0x0515
        ],
        [
            0x0d8cd,
            0x064e
        ],
        [
            0x0df1b,
            0x0775
        ],
        [
            0x0e690,
            0x06dd
        ],
        [
            0x0ed6d,
            0x0376
        ],
        [
            0x0f0e3,
            0x05f7
        ],
        [
            0x0f6da,
            0x078d
        ],
        [
            0x07ca4,
            0x02d6
        ],
        [
            0x10001,
            0x06a3
        ],
        [
            0x106a4,
            0x091f
        ],
        [
            0x10fc3,
            0x0361
        ],
        [
            0x11324,
            0x0489
        ],
        [
            0x117ad,
            0x0437
        ],
        [
            0x11be4,
            0x086e
        ],
        [
            0x12452,
            0x0199
        ],
        [
            0x125eb,
            0x0947
        ],
        [
            0x12f32,
            0x037a
        ]
    ],
    costumegfx: [
        [
            0x30001,
            0x0eb8
        ],
        [
            0x2f0f6,
            0x0340
        ]
    ],
    rooms: [
        [
            0x00000,
            0x0000
        ],
        [
            0x14001,
            0x0d05
        ],
        [
            0x132ac,
            0x04b0
        ],
        [
            0x153ab,
            0x087b
        ],
        [
            0x1375c,
            0x06b3
        ],
        [
            0x15cb1,
            0x0729
        ],
        [
            0x16625,
            0x04f0
        ],
        [
            0x16b15,
            0x0ad4
        ],
        [
            0x18001,
            0x06ed
        ],
        [
            0x17936,
            0x03de
        ],
        [
            0x18c3e,
            0x0671
        ],
        [
            0x1930b,
            0x04c4
        ],
        [
            0x199ec,
            0x0452
        ],
        [
            0x1a0da,
            0x048f
        ],
        [
            0x1a569,
            0x0449
        ],
        [
            0x1a9b2,
            0x03a8
        ],
        [
            0x1ad5a,
            0x0846
        ],
        [
            0x1b600,
            0x0686
        ],
        [
            0x1c001,
            0x0b58
        ],
        [
            0x1cd42,
            0x049c
        ],
        [
            0x1d4ed,
            0x0586
        ],
        [
            0x1dfe9,
            0x0526
        ],
        [
            0x1e9c9,
            0x05ce
        ],
        [
            0x1f04b,
            0x0390
        ],
        [
            0x1f6ca,
            0x073c
        ],
        [
            0x20001,
            0x04cb
        ],
        [
            0x20543,
            0x0530
        ],
        [
            0x2171b,
            0x05fc
        ],
        [
            0x21ebe,
            0x0470
        ],
        [
            0x223dc,
            0x045c
        ],
        [
            0x2289e,
            0x0928
        ],
        [
            0x24001,
            0x036c
        ],
        [
            0x247ec,
            0x03ca
        ],
        [
            0x24bb6,
            0x050d
        ],
        [
            0x25283,
            0x0346
        ],
        [
            0x17d60,
            0x01ca
        ],
        [
            0x255c9,
            0x0462
        ],
        [
            0x25a2b,
            0x055c
        ],
        [
            0x25f87,
            0x0659
        ],
        [
            0x1bd19,
            0x024b
        ],
        [
            0x26b8a,
            0x01f7
        ],
        [
            0x26e5d,
            0x0217
        ],
        [
            0x2736a,
            0x02f4
        ],
        [
            0x27845,
            0x045c
        ],
        [
            0x28001,
            0x0969
        ],
        [
            0x289be,
            0x058e
        ],
        [
            0x2a418,
            0x0201
        ],
        [
            0x2a6be,
            0x0325
        ],
        [
            0x23d84,
            0x01fc
        ],
        [
            0x2ac46,
            0x02a9
        ],
        [
            0x2aeef,
            0x02c9
        ],
        [
            0x2b2c0,
            0x03d2
        ],
        [
            0x27d12,
            0x0207
        ],
        [
            0x2b7fc,
            0x0168
        ],
        [
            0x2bd06,
            0x0169
        ]
    ],
    scripts: [
        [
            0x00000,
            0x0000
        ],
        [
            0x28f4c,
            0x0457
        ],
        [
            0x293a3,
            0x0213
        ],
        [
            0x295b6,
            0x009c
        ],
        [
            0x29652,
            0x03fe
        ],
        [
            0x29a50,
            0x01a1
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x29bf1,
            0x005c
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x29c4d,
            0x0005
        ],
        [
            0x2b964,
            0x000d
        ],
        [
            0x2b971,
            0x000d
        ],
        [
            0x186ee,
            0x0040
        ],
        [
            0x1872e,
            0x0016
        ],
        [
            0x1b5a0,
            0x0046
        ],
        [
            0x1ef97,
            0x00b4
        ],
        [
            0x21d17,
            0x0056
        ],
        [
            0x175e9,
            0x0027
        ],
        [
            0x1fe06,
            0x0027
        ],
        [
            0x1fe2d,
            0x0027
        ],
        [
            0x1bc86,
            0x0022
        ],
        [
            0x15c26,
            0x008b
        ],
        [
            0x2232e,
            0x001f
        ],
        [
            0x2234d,
            0x008f
        ],
        [
            0x192af,
            0x002b
        ],
        [
            0x1cb59,
            0x006b
        ],
        [
            0x1cbc4,
            0x0045
        ],
        [
            0x1cc09,
            0x0046
        ],
        [
            0x1cc4f,
            0x005d
        ],
        [
            0x204cc,
            0x0077
        ],
        [
            0x163da,
            0x0035
        ],
        [
            0x1640f,
            0x001c
        ],
        [
            0x1642b,
            0x0014
        ],
        [
            0x1643f,
            0x001c
        ],
        [
            0x1645b,
            0x0027
        ],
        [
            0x16482,
            0x01a3
        ],
        [
            0x1d1de,
            0x009e
        ],
        [
            0x1d27c,
            0x011a
        ],
        [
            0x1d396,
            0x001c
        ],
        [
            0x1d3b2,
            0x0056
        ],
        [
            0x1d408,
            0x0072
        ],
        [
            0x1e50f,
            0x0028
        ],
        [
            0x1e537,
            0x0199
        ],
        [
            0x1e6d0,
            0x0240
        ],
        [
            0x27ca1,
            0x0071
        ],
        [
            0x17d14,
            0x004c
        ],
        [
            0x13e0f,
            0x0039
        ],
        [
            0x18744,
            0x02b9
        ],
        [
            0x189fd,
            0x00b9
        ],
        [
            0x18ab6,
            0x0183
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x19e3e,
            0x00f0
        ],
        [
            0x21d6d,
            0x00f7
        ],
        [
            0x1e910,
            0x00a8
        ],
        [
            0x21e64,
            0x0047
        ],
        [
            0x2b97e,
            0x004d
        ],
        [
            0x13e48,
            0x0024
        ],
        [
            0x14d06,
            0x0014
        ],
        [
            0x17610,
            0x005b
        ],
        [
            0x1766b,
            0x0111
        ],
        [
            0x1777c,
            0x0009
        ],
        [
            0x14d1a,
            0x01c9
        ],
        [
            0x2a9e3,
            0x0263
        ],
        [
            0x231c6,
            0x06d6
        ],
        [
            0x2b9cb,
            0x001c
        ],
        [
            0x2b9e7,
            0x001c
        ],
        [
            0x2ba03,
            0x0025
        ],
        [
            0x2ba28,
            0x0023
        ],
        [
            0x2ba4b,
            0x002a
        ],
        [
            0x2ba75,
            0x0033
        ],
        [
            0x2baa8,
            0x0016
        ],
        [
            0x2babe,
            0x0024
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2bae2,
            0x0011
        ],
        [
            0x17785,
            0x00a2
        ],
        [
            0x22838,
            0x0066
        ],
        [
            0x14ee3,
            0x0079
        ],
        [
            0x1f3db,
            0x010f
        ],
        [
            0x1fe54,
            0x001d
        ],
        [
            0x1f4ea,
            0x00a2
        ],
        [
            0x1f58c,
            0x0097
        ],
        [
            0x17827,
            0x0061
        ],
        [
            0x17888,
            0x0032
        ],
        [
            0x1f623,
            0x00a7
        ],
        [
            0x2baf3,
            0x00cd
        ],
        [
            0x2bbc0,
            0x00bd
        ],
        [
            0x2bc7d,
            0x0089
        ],
        [
            0x20a73,
            0x01c2
        ],
        [
            0x20c35,
            0x016e
        ],
        [
            0x20da3,
            0x006f
        ],
        [
            0x20e12,
            0x0037
        ],
        [
            0x20e49,
            0x00ec
        ],
        [
            0x20f35,
            0x0047
        ],
        [
            0x20f7c,
            0x00f8
        ],
        [
            0x21074,
            0x0102
        ],
        [
            0x21176,
            0x0133
        ],
        [
            0x212a9,
            0x0197
        ],
        [
            0x21440,
            0x002d
        ],
        [
            0x2146d,
            0x00a9
        ],
        [
            0x2436d,
            0x0125
        ],
        [
            0x1bca8,
            0x0071
        ],
        [
            0x1ccac,
            0x0096
        ],
        [
            0x2896a,
            0x0054
        ],
        [
            0x19f2e,
            0x00df
        ],
        [
            0x1a00d,
            0x007f
        ],
        [
            0x14f5c,
            0x0057
        ],
        [
            0x27074,
            0x02f6
        ],
        [
            0x1da73,
            0x023a
        ],
        [
            0x1dcad,
            0x00e8
        ],
        [
            0x1dd95,
            0x0059
        ],
        [
            0x1ddee,
            0x01e3
        ],
        [
            0x14fb3,
            0x004d
        ],
        [
            0x26d81,
            0x00dc
        ],
        [
            0x21eab,
            0x0013
        ],
        [
            0x29c52,
            0x00f0
        ],
        [
            0x24492,
            0x00e4
        ],
        [
            0x21516,
            0x00ee
        ],
        [
            0x24576,
            0x002d
        ],
        [
            0x2b692,
            0x010d
        ],
        [
            0x245a3,
            0x00ac
        ],
        [
            0x250c3,
            0x0184
        ],
        [
            0x1b5e6,
            0x000d
        ],
        [
            0x1b5f3,
            0x000d
        ],
        [
            0x2389c,
            0x0182
        ],
        [
            0x2765e,
            0x01e7
        ],
        [
            0x23a1e,
            0x017a
        ],
        [
            0x23b98,
            0x01b6
        ],
        [
            0x23d4e,
            0x0016
        ],
        [
            0x2b79f,
            0x005d
        ],
        [
            0x23d64,
            0x0020
        ],
        [
            0x2a619,
            0x00a5
        ],
        [
            0x29d42,
            0x038f
        ],
        [
            0x15000,
            0x00ed
        ],
        [
            0x2b1b8,
            0x0063
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x25247,
            0x003c
        ],
        [
            0x1e9b8,
            0x0011
        ],
        [
            0x13e6c,
            0x0018
        ],
        [
            0x265e0,
            0x001f
        ],
        [
            0x265ff,
            0x0054
        ],
        [
            0x26653,
            0x0147
        ],
        [
            0x2679a,
            0x004b
        ],
        [
            0x267e5,
            0x0184
        ],
        [
            0x26969,
            0x0027
        ],
        [
            0x26990,
            0x0041
        ],
        [
            0x269d1,
            0x01b9
        ],
        [
            0x13e84,
            0x001f
        ],
        [
            0x2464f,
            0x002a
        ],
        [
            0x150ed,
            0x01a4
        ],
        [
            0x192da,
            0x0031
        ],
        [
            0x178ba,
            0x007c
        ],
        [
            0x21604,
            0x00e4
        ],
        [
            0x1d47a,
            0x0018
        ],
        [
            0x1d492,
            0x005b
        ],
        [
            0x18c39,
            0x0005
        ],
        [
            0x15291,
            0x010f
        ],
        [
            0x153a0,
            0x000b
        ],
        [
            0x24679,
            0x0138
        ],
        [
            0x247b1,
            0x0014
        ],
        [
            0x1dfd1,
            0x0018
        ],
        [
            0x247c5,
            0x0027
        ],
        [
            0x1a08c,
            0x004e
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2b21b,
            0x00a5
        ],
        [
            0x2a0d1,
            0x00b1
        ],
        [
            0x2a182,
            0x0140
        ],
        [
            0x197cf,
            0x00be
        ],
        [
            0x1988d,
            0x014d
        ],
        [
            0x199da,
            0x0012
        ],
        [
            0x2a2c2,
            0x0005
        ],
        [
            0x2a2c7,
            0x0005
        ],
        [
            0x2a2cc,
            0x0005
        ],
        [
            0x2a2d1,
            0x0005
        ],
        [
            0x2a2d6,
            0x0005
        ],
        [
            0x216e8,
            0x0033
        ],
        [
            0x2a2db,
            0x0005
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a2e0,
            0x009c
        ],
        [
            0x2a37c,
            0x009c
        ]
    ],
    sounds: [
        [
            0x13f63,
            0x000a
        ],
        [
            0x2f671,
            0x0832
        ],
        [
            0x2f671,
            0x0832
        ],
        [
            0x2f671,
            0x0832
        ],
        [
            0x2f671,
            0x0832
        ],
        [
            0x2f671,
            0x0832
        ],
        [
            0x13f6d,
            0x0011
        ],
        [
            0x1feed,
            0x0073
        ],
        [
            0x17f6f,
            0x0011
        ],
        [
            0x1bf64,
            0x0011
        ],
        [
            0x27f19,
            0x0056
        ],
        [
            0x1ff60,
            0x001f
        ],
        [
            0x27f6f,
            0x0011
        ],
        [
            0x1bf75,
            0x000a
        ],
        [
            0x2be6f,
            0x000a
        ],
        [
            0x2be79,
            0x0019
        ],
        [
            0x2be92,
            0x004b
        ],
        [
            0x2bedd,
            0x000a
        ],
        [
            0x2bee7,
            0x000f
        ],
        [
            0x2bef6,
            0x001d
        ],
        [
            0x2bf13,
            0x0045
        ],
        [
            0x2bf58,
            0x000f
        ],
        [
            0x2fea3,
            0x001b
        ],
        [
            0x2febe,
            0x0033
        ],
        [
            0x2bf67,
            0x0011
        ],
        [
            0x2fef1,
            0x000f
        ],
        [
            0x2ff00,
            0x0075
        ],
        [
            0x30eca,
            0x0014
        ],
        [
            0x13f63,
            0x000a
        ],
        [
            0x30ede,
            0x00ff
        ],
        [
            0x30fdd,
            0x000f
        ],
        [
            0x30fec,
            0x000f
        ],
        [
            0x30ffb,
            0x0092
        ],
        [
            0x30ffb,
            0x0092
        ],
        [
            0x3108d,
            0x002d
        ],
        [
            0x310ba,
            0x00f8
        ],
        [
            0x311b2,
            0x0016
        ],
        [
            0x311c8,
            0x0011
        ],
        [
            0x311d9,
            0x004b
        ],
        [
            0x31224,
            0x0011
        ],
        [
            0x31235,
            0x003b
        ],
        [
            0x31270,
            0x008a
        ],
        [
            0x312fa,
            0x0011
        ],
        [
            0x3130b,
            0x000f
        ],
        [
            0x3131a,
            0x00a2
        ],
        [
            0x313bc,
            0x00d3
        ],
        [
            0x3148f,
            0x0097
        ],
        [
            0x2fef1,
            0x000f
        ],
        [
            0x3131a,
            0x00a2
        ],
        [
            0x31526,
            0x05d1
        ],
        [
            0x31526,
            0x05d1
        ],
        [
            0x31af7,
            0x0011
        ],
        [
            0x13f63,
            0x000a
        ],
        [
            0x2ff00,
            0x0075
        ],
        [
            0x1ff60,
            0x001f
        ],
        [
            0x31b08,
            0x098e
        ],
        [
            0x311d9,
            0x004b
        ],
        [
            0x32496,
            0x0011
        ],
        [
            0x2f671,
            0x0832
        ],
        [
            0x324a7,
            0x000f
        ],
        [
            0x324b6,
            0x002f
        ],
        [
            0x324e5,
            0x001d
        ],
        [
            0x32502,
            0x0018
        ],
        [
            0x3251a,
            0x0016
        ],
        [
            0x32530,
            0x001b
        ],
        [
            0x3254b,
            0x0088
        ],
        [
            0x325d3,
            0x0065
        ],
        [
            0x32638,
            0x0065
        ],
        [
            0x3269d,
            0x0073
        ],
        [
            0x32710,
            0x00f9
        ],
        [
            0x32809,
            0x049e
        ],
        [
            0x32ca7,
            0x0ea8
        ],
        [
            0x34001,
            0x0b18
        ],
        [
            0x34b19,
            0x0b9c
        ],
        [
            0x356b5,
            0x0c6b
        ],
        [
            0x36320,
            0x0e56
        ],
        [
            0x37176,
            0x0c70
        ],
        [
            0x38001,
            0x0dec
        ],
        [
            0x38ded,
            0x0b77
        ],
        [
            0x33b4f,
            0x042f
        ],
        [
            0x39964,
            0x0ac5
        ],
        [
            0x3a429,
            0x0be4
        ]
    ],
    costumes: [
        [
            0x0fef1,
            0x0055
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x13ea3,
            0x004b
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x0ff46,
            0x0036
        ],
        [
            0x13eee,
            0x003a
        ],
        [
            0x13eee,
            0x003a
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x13f28,
            0x003b
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x17f2a,
            0x0045
        ],
        [
            0x1fe71,
            0x0040
        ],
        [
            0x1feb1,
            0x003c
        ],
        [
            0x13eee,
            0x003a
        ],
        [
            0x13eee,
            0x003a
        ],
        [
            0x0fef1,
            0x0055
        ],
        [
            0x13ea3,
            0x004b
        ]
    ],
    globdata: [
        [
            0x2c001,
            0x0307
        ]
    ],
    sprpals: [
        [
            0x0bf15,
            0x0010
        ],
        [
            0x0bf25,
            0x0010
        ]
    ],
    sprdesc: [
        [
            0x0bf35,
            0x0031
        ],
        [
            0x0bf66,
            0x0009
        ]
    ],
    sprlens: [
        [
            0x2efe1,
            0x0115
        ],
        [
            0x07f7a,
            0x0006
        ]
    ],
    sproffs: [
        [
            0x2f447,
            0x022a
        ],
        [
            0x0bf6f,
            0x000c
        ]
    ],
    sprdata: [
        [
            0x2c401,
            0x2be0
        ],
        [
            0x0fe67,
            0x008a
        ]
    ],
    charset: [
        [
            0x3f739,
            0x0099
        ]
    ],
    preplist: [
        [
            0x3fbae,
            0x000f
        ]
    ],
    titles: [
        [
            0x02701,
            0x0000
        ],
        [
            0x0320f,
            0x0000
        ]
    ],
    characters: {
        '[': "\xe1",
        '<': "\xe9",
        '|': "\xed",
        '>': "\xf3",
        ']': "\xfa",
        '{': "\xbf",
        '}': "\xa1",
        '=': "\xf1",
        '_': "\xfc"
    },
    version: 'Spain',
    lang: 'es',
    crc32: 0xf5b2afca,
    crc32Rom: 0x901d691d
};
// prettier-ignore
const $226142e01fd9f3a3$var$ita = {
    metadata: {
        name: 'Italy',
        alpha2code: 'it',
        alpha3code: 'ita'
    },
    roomgfx: [
        [
            0x04001,
            0x03ef
        ],
        [
            0x043f0,
            0x069e
        ],
        [
            0x04a8e,
            0x0327
        ],
        [
            0x04db5,
            0x053b
        ],
        [
            0x052f0,
            0x06be
        ],
        [
            0x059ae,
            0x0682
        ],
        [
            0x06030,
            0x0778
        ],
        [
            0x067a8,
            0x0517
        ],
        [
            0x06cbf,
            0x07fb
        ],
        [
            0x074ba,
            0x07be
        ],
        [
            0x08001,
            0x07a5
        ],
        [
            0x087a6,
            0x06dd
        ],
        [
            0x08e83,
            0x04ea
        ],
        [
            0x0936d,
            0x07e2
        ],
        [
            0x09b4f,
            0x0791
        ],
        [
            0x0a2e0,
            0x07b5
        ],
        [
            0x0aa95,
            0x0515
        ],
        [
            0x0afaa,
            0x0799
        ],
        [
            0x0b743,
            0x04bb
        ],
        [
            0x0bbfe,
            0x0319
        ],
        [
            0x0c001,
            0x0464
        ],
        [
            0x0c465,
            0x072c
        ],
        [
            0x0cb91,
            0x0827
        ],
        [
            0x0d3b8,
            0x0515
        ],
        [
            0x0d8cd,
            0x064e
        ],
        [
            0x0df1b,
            0x0775
        ],
        [
            0x0e690,
            0x06dd
        ],
        [
            0x0ed6d,
            0x0376
        ],
        [
            0x0f0e3,
            0x05f7
        ],
        [
            0x0f6da,
            0x0787
        ],
        [
            0x07c78,
            0x02d6
        ],
        [
            0x10001,
            0x06a3
        ],
        [
            0x106a4,
            0x0921
        ],
        [
            0x10fc5,
            0x0361
        ],
        [
            0x11326,
            0x0489
        ],
        [
            0x117af,
            0x0437
        ],
        [
            0x11be6,
            0x0863
        ],
        [
            0x12449,
            0x0199
        ],
        [
            0x125e2,
            0x0947
        ],
        [
            0x12f29,
            0x037a
        ]
    ],
    costumegfx: [
        [
            0x30001,
            0x0eb8
        ],
        [
            0x2f4a0,
            0x0340
        ]
    ],
    rooms: [
        [
            0x00000,
            0x0000
        ],
        [
            0x14001,
            0x0d70
        ],
        [
            0x132a3,
            0x04ea
        ],
        [
            0x15423,
            0x086e
        ],
        [
            0x1378d,
            0x06b1
        ],
        [
            0x15d16,
            0x070f
        ],
        [
            0x16658,
            0x04db
        ],
        [
            0x16b33,
            0x0aef
        ],
        [
            0x18001,
            0x06df
        ],
        [
            0x17991,
            0x03e1
        ],
        [
            0x18c5c,
            0x065e
        ],
        [
            0x19316,
            0x04af
        ],
        [
            0x199ea,
            0x0448
        ],
        [
            0x1a09d,
            0x0479
        ],
        [
            0x1a516,
            0x0445
        ],
        [
            0x1a95b,
            0x03a7
        ],
        [
            0x1ad02,
            0x0826
        ],
        [
            0x1b588,
            0x0693
        ],
        [
            0x1c001,
            0x0b92
        ],
        [
            0x1cd70,
            0x0484
        ],
        [
            0x1d4e3,
            0x0598
        ],
        [
            0x1dfcb,
            0x0538
        ],
        [
            0x1e9c9,
            0x05d1
        ],
        [
            0x1f052,
            0x0394
        ],
        [
            0x1f70d,
            0x0741
        ],
        [
            0x20001,
            0x04c2
        ],
        [
            0x2053f,
            0x0528
        ],
        [
            0x21718,
            0x05f6
        ],
        [
            0x21eb5,
            0x0486
        ],
        [
            0x223e8,
            0x048c
        ],
        [
            0x228da,
            0x093a
        ],
        [
            0x24001,
            0x037a
        ],
        [
            0x247ee,
            0x03ca
        ],
        [
            0x24bb8,
            0x050d
        ],
        [
            0x25289,
            0x0346
        ],
        [
            0x1bcac,
            0x01ca
        ],
        [
            0x255cf,
            0x045f
        ],
        [
            0x25a2e,
            0x0552
        ],
        [
            0x25f80,
            0x0651
        ],
        [
            0x26b93,
            0x024b
        ],
        [
            0x26dde,
            0x01fa
        ],
        [
            0x270d6,
            0x0217
        ],
        [
            0x275e4,
            0x02f4
        ],
        [
            0x28001,
            0x045c
        ],
        [
            0x284ce,
            0x08bd
        ],
        [
            0x28ddf,
            0x05df
        ],
        [
            0x27ac9,
            0x0201
        ],
        [
            0x2a8a3,
            0x0325
        ],
        [
            0x27d6f,
            0x01fc
        ],
        [
            0x2ae66,
            0x02a9
        ],
        [
            0x2b10f,
            0x02e7
        ],
        [
            0x2b4f9,
            0x03de
        ],
        [
            0x2ba31,
            0x0206
        ],
        [
            0x2c001,
            0x0168
        ],
        [
            0x17dc0,
            0x0169
        ]
    ],
    scripts: [
        [
            0x00000,
            0x0000
        ],
        [
            0x293be,
            0x046b
        ],
        [
            0x29829,
            0x020c
        ],
        [
            0x29a35,
            0x00aa
        ],
        [
            0x29adf,
            0x03fd
        ],
        [
            0x29edc,
            0x01a1
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a07d,
            0x005c
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a0d9,
            0x0005
        ],
        [
            0x2c169,
            0x000d
        ],
        [
            0x2c176,
            0x000d
        ],
        [
            0x186e0,
            0x0040
        ],
        [
            0x18720,
            0x0016
        ],
        [
            0x1b528,
            0x0046
        ],
        [
            0x1ef9a,
            0x00b8
        ],
        [
            0x21d0e,
            0x0056
        ],
        [
            0x17622,
            0x0027
        ],
        [
            0x1fe4e,
            0x0027
        ],
        [
            0x1fe75,
            0x0027
        ],
        [
            0x1bc1b,
            0x0022
        ],
        [
            0x15c91,
            0x0085
        ],
        [
            0x2233b,
            0x001e
        ],
        [
            0x22359,
            0x008f
        ],
        [
            0x192ba,
            0x002b
        ],
        [
            0x1cb93,
            0x0065
        ],
        [
            0x1cbf8,
            0x003f
        ],
        [
            0x1cc37,
            0x004e
        ],
        [
            0x1cc85,
            0x0055
        ],
        [
            0x204c3,
            0x007c
        ],
        [
            0x16425,
            0x0035
        ],
        [
            0x1645a,
            0x001c
        ],
        [
            0x16476,
            0x0014
        ],
        [
            0x1648a,
            0x001c
        ],
        [
            0x164a6,
            0x0027
        ],
        [
            0x164cd,
            0x018b
        ],
        [
            0x1d1f4,
            0x009b
        ],
        [
            0x1d28f,
            0x010a
        ],
        [
            0x1d399,
            0x001c
        ],
        [
            0x1d3b5,
            0x0056
        ],
        [
            0x1d40b,
            0x0072
        ],
        [
            0x1e503,
            0x0028
        ],
        [
            0x1e52b,
            0x01aa
        ],
        [
            0x1e6d5,
            0x0233
        ],
        [
            0x2845d,
            0x0071
        ],
        [
            0x17d72,
            0x004e
        ],
        [
            0x13e3e,
            0x0039
        ],
        [
            0x18736,
            0x02c8
        ],
        [
            0x189fe,
            0x00bb
        ],
        [
            0x18ab9,
            0x019e
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x19e32,
            0x00f8
        ],
        [
            0x21d64,
            0x00f7
        ],
        [
            0x1e908,
            0x00b0
        ],
        [
            0x21e5b,
            0x0047
        ],
        [
            0x2c183,
            0x004d
        ],
        [
            0x13e77,
            0x0024
        ],
        [
            0x14d71,
            0x0014
        ],
        [
            0x17649,
            0x0058
        ],
        [
            0x176a1,
            0x010a
        ],
        [
            0x177ab,
            0x0009
        ],
        [
            0x14d85,
            0x01b7
        ],
        [
            0x2abc8,
            0x029e
        ],
        [
            0x23214,
            0x070b
        ],
        [
            0x2c1d0,
            0x001a
        ],
        [
            0x2c1ea,
            0x0021
        ],
        [
            0x2c20b,
            0x0022
        ],
        [
            0x2c22d,
            0x0023
        ],
        [
            0x2c250,
            0x0016
        ],
        [
            0x2c266,
            0x001e
        ],
        [
            0x2c284,
            0x0016
        ],
        [
            0x2c29a,
            0x0027
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2c2c1,
            0x000e
        ],
        [
            0x177b4,
            0x00aa
        ],
        [
            0x22874,
            0x0066
        ],
        [
            0x14f3c,
            0x007b
        ],
        [
            0x1f3e6,
            0x0126
        ],
        [
            0x1fe9c,
            0x001d
        ],
        [
            0x1f50c,
            0x00b4
        ],
        [
            0x1f5c0,
            0x00aa
        ],
        [
            0x1785e,
            0x006d
        ],
        [
            0x178cb,
            0x003f
        ],
        [
            0x1f66a,
            0x00a3
        ],
        [
            0x2c2cf,
            0x00af
        ],
        [
            0x2c37e,
            0x00bd
        ],
        [
            0x2c43b,
            0x0085
        ],
        [
            0x20a67,
            0x01aa
        ],
        [
            0x20c11,
            0x016a
        ],
        [
            0x20d7b,
            0x0073
        ],
        [
            0x20dee,
            0x003b
        ],
        [
            0x20e29,
            0x00f0
        ],
        [
            0x20f19,
            0x0047
        ],
        [
            0x20f60,
            0x00fd
        ],
        [
            0x2105d,
            0x00ff
        ],
        [
            0x2115c,
            0x0157
        ],
        [
            0x212b3,
            0x0195
        ],
        [
            0x21448,
            0x002e
        ],
        [
            0x21476,
            0x00a9
        ],
        [
            0x2437b,
            0x011f
        ],
        [
            0x1bc3d,
            0x006f
        ],
        [
            0x1ccda,
            0x0096
        ],
        [
            0x28d8b,
            0x0054
        ],
        [
            0x19f2a,
            0x00b8
        ],
        [
            0x19fe2,
            0x0071
        ],
        [
            0x14fb7,
            0x0057
        ],
        [
            0x272ed,
            0x02f7
        ],
        [
            0x1da7b,
            0x021c
        ],
        [
            0x1dc97,
            0x00fa
        ],
        [
            0x1dd91,
            0x0053
        ],
        [
            0x1dde4,
            0x01cf
        ],
        [
            0x1500e,
            0x004d
        ],
        [
            0x26fd8,
            0x00fe
        ],
        [
            0x21ea2,
            0x0013
        ],
        [
            0x2a0de,
            0x00f0
        ],
        [
            0x2449a,
            0x00dc
        ],
        [
            0x2151f,
            0x00e7
        ],
        [
            0x24576,
            0x0022
        ],
        [
            0x2b8d7,
            0x00fe
        ],
        [
            0x24598,
            0x00bb
        ],
        [
            0x250c5,
            0x0188
        ],
        [
            0x1b56e,
            0x000d
        ],
        [
            0x1b57b,
            0x000d
        ],
        [
            0x2391f,
            0x0182
        ],
        [
            0x278d8,
            0x01f1
        ],
        [
            0x23aa1,
            0x0150
        ],
        [
            0x23bf1,
            0x01c2
        ],
        [
            0x23db3,
            0x0016
        ],
        [
            0x2b9d5,
            0x005c
        ],
        [
            0x23dc9,
            0x0020
        ],
        [
            0x27cca,
            0x00a5
        ],
        [
            0x2a1ce,
            0x0384
        ],
        [
            0x1505b,
            0x00fa
        ],
        [
            0x2b3f6,
            0x005e
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2524d,
            0x003c
        ],
        [
            0x1e9b8,
            0x0011
        ],
        [
            0x13e9b,
            0x0018
        ],
        [
            0x265d1,
            0x001f
        ],
        [
            0x265f0,
            0x0054
        ],
        [
            0x26644,
            0x0155
        ],
        [
            0x26799,
            0x004b
        ],
        [
            0x267e4,
            0x017c
        ],
        [
            0x26960,
            0x0027
        ],
        [
            0x26987,
            0x0041
        ],
        [
            0x269c8,
            0x01cb
        ],
        [
            0x13eb3,
            0x001f
        ],
        [
            0x24653,
            0x002a
        ],
        [
            0x15155,
            0x01a4
        ],
        [
            0x192e5,
            0x0031
        ],
        [
            0x1790a,
            0x0087
        ],
        [
            0x21606,
            0x00df
        ],
        [
            0x1d47d,
            0x0018
        ],
        [
            0x1d495,
            0x004e
        ],
        [
            0x18c57,
            0x0005
        ],
        [
            0x152f9,
            0x011f
        ],
        [
            0x15418,
            0x000b
        ],
        [
            0x2467d,
            0x0136
        ],
        [
            0x247b3,
            0x0014
        ],
        [
            0x1dfb3,
            0x0018
        ],
        [
            0x247c7,
            0x0027
        ],
        [
            0x1a053,
            0x004a
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2b454,
            0x00a5
        ],
        [
            0x2a552,
            0x00bb
        ],
        [
            0x2a60d,
            0x0140
        ],
        [
            0x197c5,
            0x00c6
        ],
        [
            0x1988b,
            0x014d
        ],
        [
            0x199d8,
            0x0012
        ],
        [
            0x2a74d,
            0x0005
        ],
        [
            0x2a752,
            0x0005
        ],
        [
            0x2a757,
            0x0005
        ],
        [
            0x2a75c,
            0x0005
        ],
        [
            0x2a761,
            0x0005
        ],
        [
            0x216e5,
            0x0033
        ],
        [
            0x2a766,
            0x0005
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a76b,
            0x009c
        ],
        [
            0x2a807,
            0x009c
        ]
    ],
    sounds: [
        [
            0x0bf54,
            0x000a
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x0bf5e,
            0x0011
        ],
        [
            0x1feb9,
            0x0073
        ],
        [
            0x0bf6f,
            0x0011
        ],
        [
            0x13f57,
            0x0011
        ],
        [
            0x23efe,
            0x0056
        ],
        [
            0x1bf37,
            0x001f
        ],
        [
            0x13f68,
            0x0011
        ],
        [
            0x0ff76,
            0x000a
        ],
        [
            0x17f64,
            0x000a
        ],
        [
            0x1bf56,
            0x0019
        ],
        [
            0x1ff2c,
            0x004b
        ],
        [
            0x17f6e,
            0x000a
        ],
        [
            0x1bf6f,
            0x000f
        ],
        [
            0x23f54,
            0x001d
        ],
        [
            0x2be61,
            0x0045
        ],
        [
            0x23f71,
            0x000f
        ],
        [
            0x2bea6,
            0x001b
        ],
        [
            0x2bec1,
            0x0033
        ],
        [
            0x27f6b,
            0x0011
        ],
        [
            0x2bef4,
            0x000f
        ],
        [
            0x2bf03,
            0x0075
        ],
        [
            0x2f7f1,
            0x0014
        ],
        [
            0x0bf54,
            0x000a
        ],
        [
            0x2f805,
            0x00ff
        ],
        [
            0x2f904,
            0x000f
        ],
        [
            0x2f913,
            0x000f
        ],
        [
            0x2f922,
            0x0092
        ],
        [
            0x2f922,
            0x0092
        ],
        [
            0x2f9b4,
            0x002d
        ],
        [
            0x2f9e1,
            0x00f8
        ],
        [
            0x2fad9,
            0x0016
        ],
        [
            0x2faef,
            0x0011
        ],
        [
            0x2fb00,
            0x004b
        ],
        [
            0x2fb4b,
            0x0011
        ],
        [
            0x2fb5c,
            0x003b
        ],
        [
            0x2fb97,
            0x008a
        ],
        [
            0x2fc21,
            0x0011
        ],
        [
            0x2fc32,
            0x000f
        ],
        [
            0x2fc41,
            0x00a2
        ],
        [
            0x2fce3,
            0x00d3
        ],
        [
            0x2fdb6,
            0x0097
        ],
        [
            0x2bef4,
            0x000f
        ],
        [
            0x2fc41,
            0x00a2
        ],
        [
            0x316fc,
            0x05d1
        ],
        [
            0x316fc,
            0x05d1
        ],
        [
            0x2fe4d,
            0x0011
        ],
        [
            0x0bf54,
            0x000a
        ],
        [
            0x2bf03,
            0x0075
        ],
        [
            0x1bf37,
            0x001f
        ],
        [
            0x31ccd,
            0x098e
        ],
        [
            0x2fb00,
            0x004b
        ],
        [
            0x2fe5e,
            0x0011
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x2fe6f,
            0x000f
        ],
        [
            0x2fe7e,
            0x002f
        ],
        [
            0x2fead,
            0x001d
        ],
        [
            0x2feca,
            0x0018
        ],
        [
            0x2fee2,
            0x0016
        ],
        [
            0x2fef8,
            0x001b
        ],
        [
            0x3265b,
            0x0088
        ],
        [
            0x2ff13,
            0x0065
        ],
        [
            0x326e3,
            0x0065
        ],
        [
            0x32748,
            0x0073
        ],
        [
            0x327bb,
            0x00f9
        ],
        [
            0x328b4,
            0x049e
        ],
        [
            0x32d52,
            0x0ea8
        ],
        [
            0x34001,
            0x0b18
        ],
        [
            0x34b19,
            0x0b9c
        ],
        [
            0x356b5,
            0x0c6b
        ],
        [
            0x36320,
            0x0e56
        ],
        [
            0x37176,
            0x0c70
        ],
        [
            0x38001,
            0x0dec
        ],
        [
            0x38ded,
            0x0b77
        ],
        [
            0x39964,
            0x042f
        ],
        [
            0x39d93,
            0x0ac5
        ],
        [
            0x3a858,
            0x0be4
        ]
    ],
    costumes: [
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x13ed2,
            0x004b
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x0ff40,
            0x0036
        ],
        [
            0x13f1d,
            0x003a
        ],
        [
            0x13f1d,
            0x003a
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x17f29,
            0x003b
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x1be76,
            0x0045
        ],
        [
            0x1bebb,
            0x0040
        ],
        [
            0x1befb,
            0x003c
        ],
        [
            0x13f1d,
            0x003a
        ],
        [
            0x13f1d,
            0x003a
        ],
        [
            0x0feeb,
            0x0055
        ],
        [
            0x13ed2,
            0x004b
        ]
    ],
    globdata: [
        [
            0x2c4c0,
            0x0307
        ]
    ],
    sprpals: [
        [
            0x07f54,
            0x0010
        ],
        [
            0x07f64,
            0x0010
        ]
    ],
    sprdesc: [
        [
            0x0bf17,
            0x0031
        ],
        [
            0x07f74,
            0x0009
        ]
    ],
    sprlens: [
        [
            0x23de9,
            0x0115
        ],
        [
            0x07f4e,
            0x0006
        ]
    ],
    sproffs: [
        [
            0x2bc37,
            0x022a
        ],
        [
            0x0bf48,
            0x000c
        ]
    ],
    sprdata: [
        [
            0x2c8c0,
            0x2be0
        ],
        [
            0x0fe61,
            0x008a
        ]
    ],
    charset: [
        [
            0x3f739,
            0x0095
        ]
    ],
    preplist: [
        [
            0x3fbaa,
            0x0010
        ]
    ],
    titles: [
        [
            0x02701,
            0x0000
        ],
        [
            0x0320f,
            0x0000
        ]
    ],
    characters: {
        '<': "\xe0",
        '\\': "\xe8",
        '>': "\xec",
        '|': "\xf2",
        '}': "\xf9"
    },
    version: 'Italy',
    lang: 'it',
    crc32: 0xdc529482,
    crc32Rom: 0xb9fd5255
};
// prettier-ignore
const $226142e01fd9f3a3$var$proto = {
    metadata: {
        name: 'Prototype',
        alpha2code: 'proto',
        alpha3code: 'proto'
    },
    roomgfx: [
        [
            0x04001,
            0x03c9
        ],
        [
            0x043ca,
            0x069e
        ],
        [
            0x04a68,
            0x0327
        ],
        [
            0x04d8f,
            0x053b
        ],
        [
            0x052ca,
            0x06be
        ],
        [
            0x05988,
            0x0682
        ],
        [
            0x0600a,
            0x0778
        ],
        [
            0x06782,
            0x0517
        ],
        [
            0x06c99,
            0x07fb
        ],
        [
            0x07494,
            0x07be
        ],
        [
            0x08001,
            0x07a5
        ],
        [
            0x087a6,
            0x06dd
        ],
        [
            0x08e83,
            0x04ea
        ],
        [
            0x0936d,
            0x0846
        ],
        [
            0x09bb3,
            0x08c8
        ],
        [
            0x0a47b,
            0x0844
        ],
        [
            0x0acbf,
            0x0515
        ],
        [
            0x0b1d4,
            0x0799
        ],
        [
            0x0b96d,
            0x04b8
        ],
        [
            0x07c52,
            0x0319
        ],
        [
            0x0c001,
            0x0464
        ],
        [
            0x0c465,
            0x076d
        ],
        [
            0x0cbd2,
            0x0827
        ],
        [
            0x0d3f9,
            0x0515
        ],
        [
            0x0d90e,
            0x064e
        ],
        [
            0x0df5c,
            0x0775
        ],
        [
            0x0e6d1,
            0x06dd
        ],
        [
            0x0edae,
            0x0376
        ],
        [
            0x0f124,
            0x05f7
        ],
        [
            0x0f71b,
            0x0787
        ],
        [
            0x10001,
            0x02d6
        ],
        [
            0x102d7,
            0x06a3
        ],
        [
            0x1097a,
            0x099f
        ],
        [
            0x11319,
            0x0361
        ],
        [
            0x1167a,
            0x0489
        ],
        [
            0x11b03,
            0x0437
        ],
        [
            0x11f3a,
            0x084d
        ],
        [
            0x0be25,
            0x0199
        ],
        [
            0x12787,
            0x09a7
        ],
        [
            0x1312e,
            0x037a
        ]
    ],
    costumegfx: [
        [
            0x30001,
            0x0eb8
        ],
        [
            0x2f9f1,
            0x0340
        ]
    ],
    rooms: [
        [
            0x00000,
            0x0000
        ],
        [
            0x14001,
            0x0d11
        ],
        [
            0x134a8,
            0x04b3
        ],
        [
            0x1539e,
            0x0849
        ],
        [
            0x15c6f,
            0x0685
        ],
        [
            0x16388,
            0x0715
        ],
        [
            0x1395b,
            0x04e7
        ],
        [
            0x16cc7,
            0x0ac0
        ],
        [
            0x18001,
            0x06e4
        ],
        [
            0x17acc,
            0x03cb
        ],
        [
            0x18c11,
            0x0663
        ],
        [
            0x192d0,
            0x0580
        ],
        [
            0x19a6e,
            0x0443
        ],
        [
            0x1a130,
            0x056f
        ],
        [
            0x1a69f,
            0x0446
        ],
        [
            0x1aae5,
            0x03a7
        ],
        [
            0x1ae8c,
            0x07e3
        ],
        [
            0x1b6cf,
            0x0692
        ],
        [
            0x1c001,
            0x0b49
        ],
        [
            0x1cd09,
            0x04c6
        ],
        [
            0x1d4a1,
            0x05ad
        ],
        [
            0x1df90,
            0x0514
        ],
        [
            0x1e911,
            0x05d1
        ],
        [
            0x1ef9f,
            0x0389
        ],
        [
            0x1f600,
            0x0726
        ],
        [
            0x20001,
            0x04ac
        ],
        [
            0x20523,
            0x04f8
        ],
        [
            0x21678,
            0x05cb
        ],
        [
            0x21de8,
            0x046b
        ],
        [
            0x22302,
            0x0460
        ],
        [
            0x227c8,
            0x0909
        ],
        [
            0x24001,
            0x0366
        ],
        [
            0x23bf8,
            0x03d0
        ],
        [
            0x247db,
            0x050d
        ],
        [
            0x25acf,
            0x0346
        ],
        [
            0x1bdf3,
            0x01ca
        ],
        [
            0x25e15,
            0x0457
        ],
        [
            0x2626c,
            0x0547
        ],
        [
            0x267b3,
            0x064a
        ],
        [
            0x1fd91,
            0x024b
        ],
        [
            0x2739a,
            0x01fa
        ],
        [
            0x2766d,
            0x0219
        ],
        [
            0x28001,
            0x02f4
        ],
        [
            0x284d6,
            0x045c
        ],
        [
            0x289a3,
            0x09cf
        ],
        [
            0x293c6,
            0x05a0
        ],
        [
            0x27b65,
            0x0201
        ],
        [
            0x2add1,
            0x0325
        ],
        [
            0x2b339,
            0x01fc
        ],
        [
            0x2b535,
            0x02a9
        ],
        [
            0x2b7de,
            0x02de
        ],
        [
            0x2c001,
            0x03ce
        ],
        [
            0x2bbc0,
            0x0205
        ],
        [
            0x2c53a,
            0x0170
        ],
        [
            0x13e42,
            0x0169
        ]
    ],
    scripts: [
        [
            0x00000,
            0x0000
        ],
        [
            0x29966,
            0x044d
        ],
        [
            0x29db3,
            0x0207
        ],
        [
            0x29fba,
            0x009f
        ],
        [
            0x2a059,
            0x03f4
        ],
        [
            0x2a44d,
            0x01a1
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a5ee,
            0x004a
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2a638,
            0x0005
        ],
        [
            0x2c6aa,
            0x000d
        ],
        [
            0x2c6b7,
            0x000d
        ],
        [
            0x186e5,
            0x0040
        ],
        [
            0x18725,
            0x0016
        ],
        [
            0x1b66f,
            0x0046
        ],
        [
            0x1eee2,
            0x00bd
        ],
        [
            0x21c43,
            0x0055
        ],
        [
            0x17787,
            0x0027
        ],
        [
            0x1fd26,
            0x0027
        ],
        [
            0x1fd4d,
            0x0027
        ],
        [
            0x1bd61,
            0x0022
        ],
        [
            0x15be7,
            0x0088
        ],
        [
            0x22253,
            0x0020
        ],
        [
            0x22273,
            0x008f
        ],
        [
            0x19274,
            0x002b
        ],
        [
            0x1cb4a,
            0x0061
        ],
        [
            0x1cbab,
            0x003c
        ],
        [
            0x1cbe7,
            0x0042
        ],
        [
            0x1cc29,
            0x004f
        ],
        [
            0x204ad,
            0x0076
        ],
        [
            0x16a9d,
            0x0035
        ],
        [
            0x16ad2,
            0x001c
        ],
        [
            0x16aee,
            0x0014
        ],
        [
            0x16b02,
            0x001c
        ],
        [
            0x16b1e,
            0x0027
        ],
        [
            0x16b45,
            0x0182
        ],
        [
            0x1d1cf,
            0x0096
        ],
        [
            0x1d265,
            0x00ed
        ],
        [
            0x1d352,
            0x001c
        ],
        [
            0x1d36e,
            0x0056
        ],
        [
            0x1d3c4,
            0x0072
        ],
        [
            0x1e4a4,
            0x0028
        ],
        [
            0x1e4cc,
            0x0170
        ],
        [
            0x1e63c,
            0x0229
        ],
        [
            0x28932,
            0x0071
        ],
        [
            0x17e97,
            0x004d
        ],
        [
            0x162f4,
            0x0039
        ],
        [
            0x1873b,
            0x028b
        ],
        [
            0x189c6,
            0x00bb
        ],
        [
            0x18a81,
            0x018b
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x19eb1,
            0x00ed
        ],
        [
            0x21c98,
            0x00f6
        ],
        [
            0x1e865,
            0x009b
        ],
        [
            0x21d8e,
            0x0047
        ],
        [
            0x2c6c4,
            0x004d
        ],
        [
            0x1632d,
            0x0024
        ],
        [
            0x14d12,
            0x0014
        ],
        [
            0x177ae,
            0x0059
        ],
        [
            0x17807,
            0x0109
        ],
        [
            0x17910,
            0x0009
        ],
        [
            0x14d26,
            0x01b6
        ],
        [
            0x2b0f6,
            0x0243
        ],
        [
            0x230d1,
            0x0686
        ],
        [
            0x2c711,
            0x001c
        ],
        [
            0x2c72d,
            0x001a
        ],
        [
            0x2c747,
            0x0021
        ],
        [
            0x2c768,
            0x0024
        ],
        [
            0x2c78c,
            0x0017
        ],
        [
            0x2c7a3,
            0x0017
        ],
        [
            0x2c7ba,
            0x0014
        ],
        [
            0x2c7ce,
            0x0024
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2c7f2,
            0x0011
        ],
        [
            0x17919,
            0x009d
        ],
        [
            0x22762,
            0x0066
        ],
        [
            0x14edc,
            0x0075
        ],
        [
            0x1f328,
            0x0120
        ],
        [
            0x1fd74,
            0x001d
        ],
        [
            0x1f448,
            0x008f
        ],
        [
            0x1f4d7,
            0x0097
        ],
        [
            0x179b6,
            0x006a
        ],
        [
            0x17a20,
            0x0030
        ],
        [
            0x1f56e,
            0x0092
        ],
        [
            0x2c803,
            0x00cc
        ],
        [
            0x2c8cf,
            0x00ba
        ],
        [
            0x2c989,
            0x0088
        ],
        [
            0x20a1b,
            0x01b0
        ],
        [
            0x20bcb,
            0x0168
        ],
        [
            0x20d33,
            0x006c
        ],
        [
            0x20d9f,
            0x0037
        ],
        [
            0x20dd6,
            0x00e4
        ],
        [
            0x20eba,
            0x0045
        ],
        [
            0x20eff,
            0x00e1
        ],
        [
            0x20fe0,
            0x00f6
        ],
        [
            0x210d6,
            0x0141
        ],
        [
            0x21217,
            0x0183
        ],
        [
            0x2139a,
            0x0034
        ],
        [
            0x213ce,
            0x00a9
        ],
        [
            0x24367,
            0x011b
        ],
        [
            0x1bd83,
            0x0070
        ],
        [
            0x1cc78,
            0x0091
        ],
        [
            0x29372,
            0x0054
        ],
        [
            0x19f9e,
            0x00ce
        ],
        [
            0x1a06c,
            0x0077
        ],
        [
            0x14f51,
            0x0057
        ],
        [
            0x27886,
            0x02df
        ],
        [
            0x1da4e,
            0x0219
        ],
        [
            0x1dc67,
            0x00f9
        ],
        [
            0x1dd60,
            0x0056
        ],
        [
            0x1ddb6,
            0x01c2
        ],
        [
            0x14fa8,
            0x004d
        ],
        [
            0x27594,
            0x00d9
        ],
        [
            0x21dd5,
            0x0013
        ],
        [
            0x2a63d,
            0x00f0
        ],
        [
            0x24482,
            0x00e7
        ],
        [
            0x21477,
            0x00f2
        ],
        [
            0x24569,
            0x002b
        ],
        [
            0x2c3cf,
            0x010f
        ],
        [
            0x24594,
            0x00aa
        ],
        [
            0x24ce8,
            0x0dab
        ],
        [
            0x1b6b5,
            0x000d
        ],
        [
            0x1b6c2,
            0x000d
        ],
        [
            0x23757,
            0x017c
        ],
        [
            0x282f5,
            0x01e1
        ],
        [
            0x238d3,
            0x0153
        ],
        [
            0x23a26,
            0x019c
        ],
        [
            0x23bc2,
            0x0016
        ],
        [
            0x2c4de,
            0x005c
        ],
        [
            0x23bd8,
            0x0020
        ],
        [
            0x27d66,
            0x00a5
        ],
        [
            0x2a72d,
            0x034d
        ],
        [
            0x14ff5,
            0x00e3
        ],
        [
            0x2babc,
            0x005f
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x25a93,
            0x003c
        ],
        [
            0x1e900,
            0x0011
        ],
        [
            0x16351,
            0x0018
        ],
        [
            0x26dfd,
            0x001f
        ],
        [
            0x26e1c,
            0x0054
        ],
        [
            0x26e70,
            0x0149
        ],
        [
            0x26fb9,
            0x004b
        ],
        [
            0x27004,
            0x017d
        ],
        [
            0x27181,
            0x0027
        ],
        [
            0x271a8,
            0x0041
        ],
        [
            0x271e9,
            0x01b1
        ],
        [
            0x16369,
            0x001f
        ],
        [
            0x2463e,
            0x002a
        ],
        [
            0x150d8,
            0x01a0
        ],
        [
            0x1929f,
            0x0031
        ],
        [
            0x17a50,
            0x007c
        ],
        [
            0x21569,
            0x00dc
        ],
        [
            0x1d436,
            0x0018
        ],
        [
            0x1d44e,
            0x0053
        ],
        [
            0x18c0c,
            0x0005
        ],
        [
            0x15278,
            0x011b
        ],
        [
            0x15393,
            0x000b
        ],
        [
            0x24668,
            0x0138
        ],
        [
            0x247a0,
            0x0014
        ],
        [
            0x1df78,
            0x0018
        ],
        [
            0x247b4,
            0x0027
        ],
        [
            0x1a0e3,
            0x004d
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2bb1b,
            0x00a5
        ],
        [
            0x2aa7a,
            0x00c1
        ],
        [
            0x2ab3b,
            0x0140
        ],
        [
            0x19850,
            0x00bf
        ],
        [
            0x1990f,
            0x014d
        ],
        [
            0x19a5c,
            0x0012
        ],
        [
            0x2ac7b,
            0x0005
        ],
        [
            0x2ac80,
            0x0005
        ],
        [
            0x2ac85,
            0x0005
        ],
        [
            0x2ac8a,
            0x0005
        ],
        [
            0x2ac8f,
            0x0005
        ],
        [
            0x21645,
            0x0033
        ],
        [
            0x2ac94,
            0x0005
        ],
        [
            0x00000,
            0x0000
        ],
        [
            0x2ac99,
            0x009c
        ],
        [
            0x2ad35,
            0x009c
        ]
    ],
    sounds: [
        [
            0x0ffe8,
            0x0011
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x0ffe8,
            0x0011
        ],
        [
            0x27e8c,
            0x0073
        ],
        [
            0x17fe4,
            0x0011
        ],
        [
            0x1ffdc,
            0x0011
        ],
        [
            0x27eff,
            0x0056
        ],
        [
            0x23fc8,
            0x001f
        ],
        [
            0x1ffed,
            0x0011
        ],
        [
            0x17ff5,
            0x000a
        ],
        [
            0x23fe7,
            0x000a
        ],
        [
            0x27f55,
            0x0019
        ],
        [
            0x27f6e,
            0x004b
        ],
        [
            0x23ff1,
            0x000a
        ],
        [
            0x27fb9,
            0x000f
        ],
        [
            0x27fc8,
            0x001d
        ],
        [
            0x2fd42,
            0x0045
        ],
        [
            0x27fe5,
            0x000f
        ],
        [
            0x2fd42,
            0x0045
        ],
        [
            0x2fda2,
            0x0033
        ],
        [
            0x2fdd5,
            0x0011
        ],
        [
            0x2bfef,
            0x000f
        ],
        [
            0x2fde6,
            0x0075
        ],
        [
            0x2fe5b,
            0x0014
        ],
        [
            0x0ffe8,
            0x0011
        ],
        [
            0x2fe6f,
            0x00ff
        ],
        [
            0x2ff6e,
            0x000f
        ],
        [
            0x2ff7d,
            0x000f
        ],
        [
            0x316fc,
            0x0092
        ],
        [
            0x316fc,
            0x0092
        ],
        [
            0x2ff8c,
            0x002d
        ],
        [
            0x316fc,
            0x0092
        ],
        [
            0x2ffb9,
            0x0016
        ],
        [
            0x2ffcf,
            0x0011
        ],
        [
            0x31886,
            0x004b
        ],
        [
            0x2ffe0,
            0x0011
        ],
        [
            0x318d1,
            0x003b
        ],
        [
            0x3190c,
            0x008a
        ],
        [
            0x31996,
            0x0011
        ],
        [
            0x319a7,
            0x000f
        ],
        [
            0x319b6,
            0x00a2
        ],
        [
            0x31a58,
            0x00d3
        ],
        [
            0x31b2b,
            0x0097
        ],
        [
            0x2bfef,
            0x000f
        ],
        [
            0x319b6,
            0x00a2
        ],
        [
            0x31bc2,
            0x05d1
        ],
        [
            0x31bc2,
            0x05d1
        ],
        [
            0x32193,
            0x0011
        ],
        [
            0x0ffe8,
            0x0011
        ],
        [
            0x2fde6,
            0x0075
        ],
        [
            0x23fc8,
            0x001f
        ],
        [
            0x321a4,
            0x098e
        ],
        [
            0x31886,
            0x004b
        ],
        [
            0x32b32,
            0x0011
        ],
        [
            0x30eca,
            0x0832
        ],
        [
            0x32b43,
            0x000f
        ],
        [
            0x32b52,
            0x002f
        ],
        [
            0x32b81,
            0x001d
        ],
        [
            0x32b9e,
            0x0018
        ],
        [
            0x32bb6,
            0x0016
        ],
        [
            0x32bcc,
            0x001b
        ],
        [
            0x32be7,
            0x0088
        ],
        [
            0x32cd4,
            0x0065
        ],
        [
            0x32c6f,
            0x0065
        ],
        [
            0x32d39,
            0x0073
        ],
        [
            0x32dac,
            0x00f9
        ],
        [
            0x32ea5,
            0x049e
        ],
        [
            0x34001,
            0x0ea8
        ],
        [
            0x33343,
            0x0b18
        ],
        [
            0x34ea9,
            0x0b9c
        ],
        [
            0x35a45,
            0x0c6b
        ],
        [
            0x366b0,
            0x0e56
        ],
        [
            0x38001,
            0x0c70
        ],
        [
            0x38c71,
            0x0dec
        ],
        [
            0x39a5d,
            0x0b77
        ],
        [
            0x37506,
            0x042f
        ],
        [
            0x3a5d4,
            0x0ac5
        ],
        [
            0x3b099,
            0x0be4
        ]
    ],
    costumes: [
        [
            0x17ee4,
            0x0055
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x13fab,
            0x004b
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x17f39,
            0x0036
        ],
        [
            0x17f6f,
            0x003a
        ],
        [
            0x17f6f,
            0x003a
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x17fa9,
            0x003b
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x27e0b,
            0x0045
        ],
        [
            0x1bfbd,
            0x0040
        ],
        [
            0x27e50,
            0x003c
        ],
        [
            0x17f6f,
            0x003a
        ],
        [
            0x17f6f,
            0x003a
        ],
        [
            0x17ee4,
            0x0055
        ],
        [
            0x13fab,
            0x004b
        ]
    ],
    globdata: [
        [
            0x2ca11,
            0x0307
        ]
    ],
    // sprite palette data
    sprpals: [
        [
            0x0bfbe,
            0x0010
        ],
        [
            0x0bfce,
            0x0010
        ]
    ],
    // associates costume IDs with sprite sets (indexes into SPRLENS/SPROFFS)
    sprdesc: [
        [
            0x0ffb7,
            0x0031
        ],
        [
            0x0bfde,
            0x0009
        ]
    ],
    // number of sprites in each set (indicates length within SPRDATA)
    sprlens: [
        [
            0x0fea2,
            0x0115
        ],
        [
            0x07ff5,
            0x0006
        ]
    ],
    // offset of each sprite set (indexes into SPRDATA)
    sproffs: [
        [
            0x2bdc5,
            0x022a
        ],
        [
            0x0bfe7,
            0x000c
        ]
    ],
    // sprite data sets (packed NES sprite data)
    sprdata: [
        [
            0x2ce11,
            0x2be0
        ],
        [
            0x07f6b,
            0x008a
        ]
    ],
    charset: [
        [
            0x3f6ee,
            0x0090
        ]
    ],
    preplist: [
        [
            0x3fb5a,
            0x000e
        ]
    ],
    titles: [
        [
            0x2701,
            0x0000
        ],
        [
            0x325b,
            0x0000
        ]
    ],
    characters: {},
    version: 'prototype',
    lang: 'en-US',
    crc32: 0xde0c29a9,
    crc32Rom: 0xbba3ef7e
};
const $226142e01fd9f3a3$var$resources = [
    $226142e01fd9f3a3$var$usa,
    $226142e01fd9f3a3$var$eur,
    $226142e01fd9f3a3$var$swe,
    $226142e01fd9f3a3$var$fra,
    $226142e01fd9f3a3$var$ger,
    $226142e01fd9f3a3$var$esp,
    $226142e01fd9f3a3$var$ita,
    $226142e01fd9f3a3$var$proto
];
var $226142e01fd9f3a3$export$2e2bcd8739ae039 = $226142e01fd9f3a3$var$resources;

});


parcelRegister("k3R1Q", function(module, exports) {

var $1fOnA = parcelRequire("1fOnA");
module.exports = $1fOnA("hjOOQ").then(()=>parcelRequire('1XfVq'));

});
parcelRegister("1fOnA", function(module, exports) {
"use strict";

function $0e9e457099c7f91c$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("hlXCZ")).resolve(id));
}
module.exports = $0e9e457099c7f91c$var$load;

});


var $1a4f1ac5afe523a6$exports = {};

(parcelRequire("hlXCZ")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"5s0iO\",\"index.1cc0b294.js\",\"b51wv\",\"meteor.84d2c398.png\",\"hjOOQ\",\"crc32.a7844b4f.js\",\"f5ByT\",\"digital-prime-fbx.85b71734.png\",\"l2Mgn\",\"greyscale.0d398306.png\",\"9TWfZ\",\"dmg.ae4f1a79.png\"]"));

var $97bca11ad51d3992$exports = {};
'use strict';

$97bca11ad51d3992$exports = (parcelRequire("bHSF9"));



var $l7WPE = parcelRequire("l7WPE");

var $l7WPE = parcelRequire("l7WPE");
'use client';
const $7414ea9a2692b0f5$export$b16d9fb1a22de840 = (0, $l7WPE.createContext)(null);
const $7414ea9a2692b0f5$var$initialState = {
    didCatch: false,
    error: null
};
class $7414ea9a2692b0f5$export$e926676385687eaf extends (0, $l7WPE.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $7414ea9a2692b0f5$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($7414ea9a2692b0f5$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $7414ea9a2692b0f5$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($7414ea9a2692b0f5$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $l7WPE.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $l7WPE.createElement)($7414ea9a2692b0f5$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $7414ea9a2692b0f5$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $7414ea9a2692b0f5$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $7414ea9a2692b0f5$export$c052f6604b7d51fe() {
    const context = (0, $l7WPE.useContext)($7414ea9a2692b0f5$export$b16d9fb1a22de840);
    $7414ea9a2692b0f5$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $l7WPE.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $l7WPE.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $7414ea9a2692b0f5$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $l7WPE.forwardRef)((props, ref)=>(0, $l7WPE.createElement)($7414ea9a2692b0f5$export$e926676385687eaf, errorBoundaryProps, (0, $l7WPE.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}


var $de39b070b9788eff$export$882461b6382ed46c;
var $de39b070b9788eff$export$757ceba2d55c277e;
'use strict';
var $b1e9cc0cc5ead376$exports = {};
'use strict';
function $b1e9cc0cc5ead376$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b1e9cc0cc5ead376$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b1e9cc0cc5ead376$var$checkDCE();

$b1e9cc0cc5ead376$exports = (parcelRequire("e1xeM"));


var $de39b070b9788eff$var$i;
$de39b070b9788eff$export$882461b6382ed46c = $b1e9cc0cc5ead376$exports.createRoot;
$de39b070b9788eff$export$757ceba2d55c277e = $b1e9cc0cc5ead376$exports.hydrateRoot;


/**
 * React Router DOM v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $l7WPE = parcelRequire("l7WPE");

/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $953e819bf2999f7c$var$_extends() {
    $953e819bf2999f7c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $953e819bf2999f7c$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $953e819bf2999f7c$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($953e819bf2999f7c$export$e19cd5f9376f8cee || ($953e819bf2999f7c$export$e19cd5f9376f8cee = {}));
const $953e819bf2999f7c$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $953e819bf2999f7c$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $953e819bf2999f7c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $953e819bf2999f7c$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $953e819bf2999f7c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $953e819bf2999f7c$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $953e819bf2999f7c$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $953e819bf2999f7c$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $953e819bf2999f7c$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $953e819bf2999f7c$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $953e819bf2999f7c$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $953e819bf2999f7c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $953e819bf2999f7c$export$fe53371bee54353d(to);
    }
    return $953e819bf2999f7c$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $953e819bf2999f7c$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $953e819bf2999f7c$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $953e819bf2999f7c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $953e819bf2999f7c$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $953e819bf2999f7c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $953e819bf2999f7c$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $953e819bf2999f7c$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $953e819bf2999f7c$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $953e819bf2999f7c$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $953e819bf2999f7c$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $953e819bf2999f7c$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $953e819bf2999f7c$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $953e819bf2999f7c$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $953e819bf2999f7c$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $953e819bf2999f7c$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $953e819bf2999f7c$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $953e819bf2999f7c$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $953e819bf2999f7c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($953e819bf2999f7c$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $953e819bf2999f7c$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $953e819bf2999f7c$export$e19cd5f9376f8cee.Push;
        let location = $953e819bf2999f7c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $953e819bf2999f7c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $953e819bf2999f7c$export$e19cd5f9376f8cee.Replace;
        let location = $953e819bf2999f7c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $953e819bf2999f7c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $953e819bf2999f7c$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $953e819bf2999f7c$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($953e819bf2999f7c$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($953e819bf2999f7c$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $953e819bf2999f7c$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($953e819bf2999f7c$var$ResultType || ($953e819bf2999f7c$var$ResultType = {}));
const $953e819bf2999f7c$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $953e819bf2999f7c$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $953e819bf2999f7c$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $953e819bf2999f7c$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $953e819bf2999f7c$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($953e819bf2999f7c$var$isIndexRoute(route)) {
            let indexRoute = $953e819bf2999f7c$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $953e819bf2999f7c$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $953e819bf2999f7c$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $953e819bf2999f7c$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $953e819bf2999f7c$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $953e819bf2999f7c$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $953e819bf2999f7c$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $953e819bf2999f7c$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $953e819bf2999f7c$var$flattenRoutes(routes);
    $953e819bf2999f7c$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $953e819bf2999f7c$export$30d21fd6d7295f52(pathname);
        matches = $953e819bf2999f7c$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $953e819bf2999f7c$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $953e819bf2999f7c$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $953e819bf2999f7c$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $953e819bf2999f7c$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $953e819bf2999f7c$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $953e819bf2999f7c$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $953e819bf2999f7c$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $953e819bf2999f7c$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $953e819bf2999f7c$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $953e819bf2999f7c$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $953e819bf2999f7c$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $953e819bf2999f7c$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $953e819bf2999f7c$var$paramRe = /^:[\w-]+$/;
const $953e819bf2999f7c$var$dynamicSegmentValue = 3;
const $953e819bf2999f7c$var$indexRouteValue = 2;
const $953e819bf2999f7c$var$emptySegmentValue = 1;
const $953e819bf2999f7c$var$staticSegmentValue = 10;
const $953e819bf2999f7c$var$splatPenalty = -2;
const $953e819bf2999f7c$var$isSplat = (s)=>s === "*";
function $953e819bf2999f7c$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($953e819bf2999f7c$var$isSplat)) initialScore += $953e819bf2999f7c$var$splatPenalty;
    if (index) initialScore += $953e819bf2999f7c$var$indexRouteValue;
    return segments.filter((s)=>!$953e819bf2999f7c$var$isSplat(s)).reduce((score, segment)=>score + ($953e819bf2999f7c$var$paramRe.test(segment) ? $953e819bf2999f7c$var$dynamicSegmentValue : segment === "" ? $953e819bf2999f7c$var$emptySegmentValue : $953e819bf2999f7c$var$staticSegmentValue), initialScore);
}
function $953e819bf2999f7c$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $953e819bf2999f7c$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $953e819bf2999f7c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $953e819bf2999f7c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $953e819bf2999f7c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $953e819bf2999f7c$export$a5c6d149b50c1d86($953e819bf2999f7c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $953e819bf2999f7c$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $953e819bf2999f7c$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $953e819bf2999f7c$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $953e819bf2999f7c$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $953e819bf2999f7c$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $953e819bf2999f7c$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $953e819bf2999f7c$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $953e819bf2999f7c$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $953e819bf2999f7c$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $953e819bf2999f7c$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $953e819bf2999f7c$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $953e819bf2999f7c$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $953e819bf2999f7c$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $953e819bf2999f7c$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $953e819bf2999f7c$var$normalizeSearch(search),
        hash: $953e819bf2999f7c$var$normalizeHash(hash)
    };
}
function $953e819bf2999f7c$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $953e819bf2999f7c$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $953e819bf2999f7c$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $953e819bf2999f7c$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $953e819bf2999f7c$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $953e819bf2999f7c$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $953e819bf2999f7c$export$8ccf933b0513f8d0(toArg);
    else {
        to = $953e819bf2999f7c$var$_extends({}, toArg);
        $953e819bf2999f7c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $953e819bf2999f7c$var$getInvalidPathError("?", "pathname", "search", to));
        $953e819bf2999f7c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $953e819bf2999f7c$var$getInvalidPathError("#", "pathname", "hash", to));
        $953e819bf2999f7c$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $953e819bf2999f7c$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $953e819bf2999f7c$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $953e819bf2999f7c$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $953e819bf2999f7c$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $953e819bf2999f7c$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $953e819bf2999f7c$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $953e819bf2999f7c$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $953e819bf2999f7c$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $953e819bf2999f7c$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $953e819bf2999f7c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $953e819bf2999f7c$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $953e819bf2999f7c$export$4051a07651545597(data, init) {
    return new $953e819bf2999f7c$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $953e819bf2999f7c$export$42a99a7a4bc0e76a extends Error {
}
class $953e819bf2999f7c$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $953e819bf2999f7c$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $953e819bf2999f7c$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $953e819bf2999f7c$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $953e819bf2999f7c$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $953e819bf2999f7c$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $953e819bf2999f7c$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $953e819bf2999f7c$var$unwrapTrackedPromise(value) {
    if (!$953e819bf2999f7c$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $953e819bf2999f7c$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $953e819bf2999f7c$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $953e819bf2999f7c$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $953e819bf2999f7c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $953e819bf2999f7c$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $953e819bf2999f7c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $953e819bf2999f7c$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $953e819bf2999f7c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $953e819bf2999f7c$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $953e819bf2999f7c$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $953e819bf2999f7c$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $953e819bf2999f7c$var$validMutationMethods = new Set($953e819bf2999f7c$var$validMutationMethodsArr);
const $953e819bf2999f7c$var$validRequestMethodsArr = [
    "get",
    ...$953e819bf2999f7c$var$validMutationMethodsArr
];
const $953e819bf2999f7c$var$validRequestMethods = new Set($953e819bf2999f7c$var$validRequestMethodsArr);
const $953e819bf2999f7c$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $953e819bf2999f7c$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $953e819bf2999f7c$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $953e819bf2999f7c$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $953e819bf2999f7c$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $953e819bf2999f7c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $953e819bf2999f7c$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $953e819bf2999f7c$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $953e819bf2999f7c$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $953e819bf2999f7c$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $953e819bf2999f7c$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $953e819bf2999f7c$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $953e819bf2999f7c$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $953e819bf2999f7c$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $953e819bf2999f7c$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $953e819bf2999f7c$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $953e819bf2999f7c$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$953e819bf2999f7c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$953e819bf2999f7c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $953e819bf2999f7c$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $953e819bf2999f7c$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $953e819bf2999f7c$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $953e819bf2999f7c$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $953e819bf2999f7c$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$953e819bf2999f7c$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($953e819bf2999f7c$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $953e819bf2999f7c$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $953e819bf2999f7c$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $953e819bf2999f7c$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $953e819bf2999f7c$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $953e819bf2999f7c$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $953e819bf2999f7c$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $953e819bf2999f7c$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $953e819bf2999f7c$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $953e819bf2999f7c$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($953e819bf2999f7c$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $953e819bf2999f7c$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $953e819bf2999f7c$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $953e819bf2999f7c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $953e819bf2999f7c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $953e819bf2999f7c$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $953e819bf2999f7c$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $953e819bf2999f7c$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $953e819bf2999f7c$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $953e819bf2999f7c$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $953e819bf2999f7c$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $953e819bf2999f7c$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $953e819bf2999f7c$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $953e819bf2999f7c$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $953e819bf2999f7c$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $953e819bf2999f7c$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $953e819bf2999f7c$var$findNearestBoundary(matches).route.id,
            {
                type: $953e819bf2999f7c$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $953e819bf2999f7c$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($953e819bf2999f7c$var$isErrorResult(result) && $953e819bf2999f7c$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $953e819bf2999f7c$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $953e819bf2999f7c$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $953e819bf2999f7c$var$_extends({
            matches: updatedMatches || matches
        }, $953e819bf2999f7c$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $953e819bf2999f7c$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $953e819bf2999f7c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $953e819bf2999f7c$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $953e819bf2999f7c$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $953e819bf2999f7c$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $953e819bf2999f7c$var$ResultType.error,
            error: $953e819bf2999f7c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($953e819bf2999f7c$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $953e819bf2999f7c$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($953e819bf2999f7c$var$isDeferredResult(result)) throw $953e819bf2999f7c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($953e819bf2999f7c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $953e819bf2999f7c$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $953e819bf2999f7c$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $953e819bf2999f7c$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $953e819bf2999f7c$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($953e819bf2999f7c$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $953e819bf2999f7c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $953e819bf2999f7c$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $953e819bf2999f7c$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $953e819bf2999f7c$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $953e819bf2999f7c$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $953e819bf2999f7c$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $953e819bf2999f7c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $953e819bf2999f7c$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $953e819bf2999f7c$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $953e819bf2999f7c$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$953e819bf2999f7c$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $953e819bf2999f7c$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $953e819bf2999f7c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $953e819bf2999f7c$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $953e819bf2999f7c$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $953e819bf2999f7c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $953e819bf2999f7c$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $953e819bf2999f7c$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $953e819bf2999f7c$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $953e819bf2999f7c$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $953e819bf2999f7c$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $953e819bf2999f7c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $953e819bf2999f7c$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($953e819bf2999f7c$var$isRedirectResult(actionResult) || $953e819bf2999f7c$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $953e819bf2999f7c$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($953e819bf2999f7c$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $953e819bf2999f7c$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $953e819bf2999f7c$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($953e819bf2999f7c$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($953e819bf2999f7c$var$isDeferredResult(actionResult)) throw $953e819bf2999f7c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $953e819bf2999f7c$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $953e819bf2999f7c$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $953e819bf2999f7c$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $953e819bf2999f7c$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $953e819bf2999f7c$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $953e819bf2999f7c$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $953e819bf2999f7c$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $953e819bf2999f7c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $953e819bf2999f7c$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $953e819bf2999f7c$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $953e819bf2999f7c$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $953e819bf2999f7c$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $953e819bf2999f7c$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $953e819bf2999f7c$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $953e819bf2999f7c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $953e819bf2999f7c$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($953e819bf2999f7c$var$isDeferredResult(result)) result = await $953e819bf2999f7c$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $953e819bf2999f7c$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($953e819bf2999f7c$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $953e819bf2999f7c$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($953e819bf2999f7c$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $953e819bf2999f7c$export$3e9cee6b33872309(!$953e819bf2999f7c$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $953e819bf2999f7c$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $953e819bf2999f7c$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $953e819bf2999f7c$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $953e819bf2999f7c$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($953e819bf2999f7c$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $953e819bf2999f7c$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $953e819bf2999f7c$export$e19cd5f9376f8cee.Replace : $953e819bf2999f7c$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $953e819bf2999f7c$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($953e819bf2999f7c$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $953e819bf2999f7c$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $953e819bf2999f7c$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $953e819bf2999f7c$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $953e819bf2999f7c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $953e819bf2999f7c$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($953e819bf2999f7c$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $953e819bf2999f7c$var$ResultType.redirect,
                response: $953e819bf2999f7c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $953e819bf2999f7c$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $953e819bf2999f7c$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $953e819bf2999f7c$var$ResultType.error,
                    error: $953e819bf2999f7c$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $953e819bf2999f7c$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $953e819bf2999f7c$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $953e819bf2999f7c$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $953e819bf2999f7c$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $953e819bf2999f7c$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $953e819bf2999f7c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $953e819bf2999f7c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $953e819bf2999f7c$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $953e819bf2999f7c$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $953e819bf2999f7c$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $953e819bf2999f7c$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $953e819bf2999f7c$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $953e819bf2999f7c$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $953e819bf2999f7c$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$953e819bf2999f7c$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $953e819bf2999f7c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $953e819bf2999f7c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $953e819bf2999f7c$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $953e819bf2999f7c$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $953e819bf2999f7c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $953e819bf2999f7c$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $953e819bf2999f7c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $953e819bf2999f7c$export$4d0306f8f6a4585b = Symbol("deferred");
function $953e819bf2999f7c$export$3336b097a6fbc59a(routes, opts) {
    $953e819bf2999f7c$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $953e819bf2999f7c$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $953e819bf2999f7c$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $953e819bf2999f7c$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $953e819bf2999f7c$var$createLocation("", $953e819bf2999f7c$export$fe53371bee54353d(url), null, "default");
        let matches = $953e819bf2999f7c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$953e819bf2999f7c$var$isValidMethod(method) && method !== "HEAD") {
            let error = $953e819bf2999f7c$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $953e819bf2999f7c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $953e819bf2999f7c$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $953e819bf2999f7c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($953e819bf2999f7c$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $953e819bf2999f7c$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $953e819bf2999f7c$var$createLocation("", $953e819bf2999f7c$export$fe53371bee54353d(url), null, "default");
        let matches = $953e819bf2999f7c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$953e819bf2999f7c$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $953e819bf2999f7c$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $953e819bf2999f7c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $953e819bf2999f7c$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $953e819bf2999f7c$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $953e819bf2999f7c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($953e819bf2999f7c$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$953e819bf2999f7c$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $953e819bf2999f7c$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($953e819bf2999f7c$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $953e819bf2999f7c$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $953e819bf2999f7c$var$isResponse(result) ? result : $953e819bf2999f7c$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($953e819bf2999f7c$var$isDataStrategyResult(e) && $953e819bf2999f7c$var$isResponse(e.result)) {
                if (e.type === $953e819bf2999f7c$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($953e819bf2999f7c$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $953e819bf2999f7c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $953e819bf2999f7c$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $953e819bf2999f7c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($953e819bf2999f7c$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($953e819bf2999f7c$var$isDeferredResult(result)) {
            let error = $953e819bf2999f7c$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $953e819bf2999f7c$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($953e819bf2999f7c$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($953e819bf2999f7c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $953e819bf2999f7c$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $953e819bf2999f7c$var$_extends({}, context, {
                statusCode: $953e819bf2999f7c$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $953e819bf2999f7c$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $953e819bf2999f7c$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $953e819bf2999f7c$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $953e819bf2999f7c$var$isErrorResult(pendingActionResult[1]) ? $953e819bf2999f7c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $953e819bf2999f7c$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $953e819bf2999f7c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $953e819bf2999f7c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $953e819bf2999f7c$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $953e819bf2999f7c$var$callDataStrategyImpl(dataStrategy || $953e819bf2999f7c$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($953e819bf2999f7c$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $953e819bf2999f7c$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($953e819bf2999f7c$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $953e819bf2999f7c$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $953e819bf2999f7c$export$fec11da027c70692(routes, context, error) {
    let newContext = $953e819bf2999f7c$var$_extends({}, context, {
        statusCode: $953e819bf2999f7c$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $953e819bf2999f7c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $953e819bf2999f7c$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $953e819bf2999f7c$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $953e819bf2999f7c$export$cae722b0cc860f13(to ? to : ".", $953e819bf2999f7c$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $953e819bf2999f7c$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $953e819bf2999f7c$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $953e819bf2999f7c$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $953e819bf2999f7c$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $953e819bf2999f7c$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$953e819bf2999f7c$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$953e819bf2999f7c$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $953e819bf2999f7c$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $953e819bf2999f7c$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $953e819bf2999f7c$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$953e819bf2999f7c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$953e819bf2999f7c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $953e819bf2999f7c$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $953e819bf2999f7c$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $953e819bf2999f7c$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $953e819bf2999f7c$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $953e819bf2999f7c$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($953e819bf2999f7c$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $953e819bf2999f7c$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $953e819bf2999f7c$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $953e819bf2999f7c$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $953e819bf2999f7c$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $953e819bf2999f7c$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $953e819bf2999f7c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $953e819bf2999f7c$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $953e819bf2999f7c$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $953e819bf2999f7c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $953e819bf2999f7c$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($953e819bf2999f7c$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $953e819bf2999f7c$var$shouldRevalidateLoader(match, $953e819bf2999f7c$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $953e819bf2999f7c$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $953e819bf2999f7c$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $953e819bf2999f7c$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $953e819bf2999f7c$var$shouldRevalidateLoader(fetcherMatch, $953e819bf2999f7c$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $953e819bf2999f7c$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $953e819bf2999f7c$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $953e819bf2999f7c$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $953e819bf2999f7c$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $953e819bf2999f7c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $953e819bf2999f7c$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$953e819bf2999f7c$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $953e819bf2999f7c$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $953e819bf2999f7c$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$953e819bf2999f7c$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $953e819bf2999f7c$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $953e819bf2999f7c$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $953e819bf2999f7c$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$953e819bf2999f7c$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $953e819bf2999f7c$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $953e819bf2999f7c$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $953e819bf2999f7c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $953e819bf2999f7c$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $953e819bf2999f7c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $953e819bf2999f7c$var$ResultType.data,
                result: undefined
            });
        };
        return $953e819bf2999f7c$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $953e819bf2999f7c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $953e819bf2999f7c$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $953e819bf2999f7c$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $953e819bf2999f7c$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $953e819bf2999f7c$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $953e819bf2999f7c$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $953e819bf2999f7c$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($953e819bf2999f7c$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $953e819bf2999f7c$var$ResultType.error,
                error: e
            };
        }
        if (type === $953e819bf2999f7c$var$ResultType.error) return {
            type: $953e819bf2999f7c$var$ResultType.error,
            error: new $953e819bf2999f7c$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $953e819bf2999f7c$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $953e819bf2999f7c$var$ResultType.error) {
        if ($953e819bf2999f7c$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $953e819bf2999f7c$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $953e819bf2999f7c$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $953e819bf2999f7c$var$ResultType.error,
            error: result,
            statusCode: $953e819bf2999f7c$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($953e819bf2999f7c$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $953e819bf2999f7c$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($953e819bf2999f7c$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $953e819bf2999f7c$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $953e819bf2999f7c$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $953e819bf2999f7c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $953e819bf2999f7c$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$953e819bf2999f7c$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $953e819bf2999f7c$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $953e819bf2999f7c$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($953e819bf2999f7c$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $953e819bf2999f7c$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $953e819bf2999f7c$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($953e819bf2999f7c$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $953e819bf2999f7c$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $953e819bf2999f7c$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $953e819bf2999f7c$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $953e819bf2999f7c$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $953e819bf2999f7c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $953e819bf2999f7c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $953e819bf2999f7c$export$3e9cee6b33872309(!$953e819bf2999f7c$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($953e819bf2999f7c$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $953e819bf2999f7c$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $953e819bf2999f7c$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($953e819bf2999f7c$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $953e819bf2999f7c$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $953e819bf2999f7c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $953e819bf2999f7c$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($953e819bf2999f7c$var$isErrorResult(result)) {
            let boundaryMatch = $953e819bf2999f7c$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $953e819bf2999f7c$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($953e819bf2999f7c$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $953e819bf2999f7c$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($953e819bf2999f7c$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $953e819bf2999f7c$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $953e819bf2999f7c$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $953e819bf2999f7c$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $953e819bf2999f7c$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $953e819bf2999f7c$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $953e819bf2999f7c$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $953e819bf2999f7c$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $953e819bf2999f7c$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $953e819bf2999f7c$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $953e819bf2999f7c$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $953e819bf2999f7c$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($953e819bf2999f7c$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $953e819bf2999f7c$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $953e819bf2999f7c$export$8ccf933b0513f8d0(path) : path;
    return $953e819bf2999f7c$export$fe53371bee54353d($953e819bf2999f7c$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $953e819bf2999f7c$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $953e819bf2999f7c$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $953e819bf2999f7c$var$ResultType.data || result.type === $953e819bf2999f7c$var$ResultType.error);
}
function $953e819bf2999f7c$var$isRedirectDataStrategyResultResult(result) {
    return $953e819bf2999f7c$var$isResponse(result.result) && $953e819bf2999f7c$var$redirectStatusCodes.has(result.result.status);
}
function $953e819bf2999f7c$var$isDeferredResult(result) {
    return result.type === $953e819bf2999f7c$var$ResultType.deferred;
}
function $953e819bf2999f7c$var$isErrorResult(result) {
    return result.type === $953e819bf2999f7c$var$ResultType.error;
}
function $953e819bf2999f7c$var$isRedirectResult(result) {
    return (result && result.type) === $953e819bf2999f7c$var$ResultType.redirect;
}
function $953e819bf2999f7c$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $953e819bf2999f7c$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $953e819bf2999f7c$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $953e819bf2999f7c$var$isRedirectResponse(result) {
    if (!$953e819bf2999f7c$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $953e819bf2999f7c$var$isValidMethod(method) {
    return $953e819bf2999f7c$var$validRequestMethods.has(method.toLowerCase());
}
function $953e819bf2999f7c$var$isMutationMethod(method) {
    return $953e819bf2999f7c$var$validMutationMethods.has(method.toLowerCase());
}
async function $953e819bf2999f7c$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$953e819bf2999f7c$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($953e819bf2999f7c$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $953e819bf2999f7c$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $953e819bf2999f7c$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($953e819bf2999f7c$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $953e819bf2999f7c$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $953e819bf2999f7c$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $953e819bf2999f7c$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $953e819bf2999f7c$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $953e819bf2999f7c$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $953e819bf2999f7c$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $953e819bf2999f7c$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $953e819bf2999f7c$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $953e819bf2999f7c$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $953e819bf2999f7c$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $953e819bf2999f7c$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $953e819bf2999f7c$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $953e819bf2999f7c$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $953e819bf2999f7c$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $953e819bf2999f7c$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $953e819bf2999f7c$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $953e819bf2999f7c$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $953e819bf2999f7c$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($953e819bf2999f7c$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $953e819bf2999f7c$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($953e819bf2999f7c$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $953e819bf2999f7c$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $l7WPE = parcelRequire("l7WPE");

function $e8d0e236465e8031$var$_extends() {
    $e8d0e236465e8031$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8d0e236465e8031$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $e8d0e236465e8031$export$3add0d5dce533e2e = /*#__PURE__*/ $l7WPE.createContext(null);
const $e8d0e236465e8031$export$145dfa71566a64dc = /*#__PURE__*/ $l7WPE.createContext(null);
const $e8d0e236465e8031$var$AwaitContext = /*#__PURE__*/ $l7WPE.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $e8d0e236465e8031$export$26749e8557646306 = /*#__PURE__*/ $l7WPE.createContext(null);
const $e8d0e236465e8031$export$c7914228fb69b0f5 = /*#__PURE__*/ $l7WPE.createContext(null);
const $e8d0e236465e8031$export$9072aa6dd1f93057 = /*#__PURE__*/ $l7WPE.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $e8d0e236465e8031$var$RouteErrorContext = /*#__PURE__*/ $l7WPE.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $e8d0e236465e8031$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$e8d0e236465e8031$export$9c954a9d03d32f4a() && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $l7WPE.useContext($e8d0e236465e8031$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $e8d0e236465e8031$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $953e819bf2999f7c$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $e8d0e236465e8031$export$9c954a9d03d32f4a() {
    return $l7WPE.useContext($e8d0e236465e8031$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $e8d0e236465e8031$export$45d76561a5302f2b() {
    !$e8d0e236465e8031$export$9c954a9d03d32f4a() && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    return $l7WPE.useContext($e8d0e236465e8031$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $e8d0e236465e8031$export$1b3f31771c5d07c() {
    return $l7WPE.useContext($e8d0e236465e8031$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $e8d0e236465e8031$export$6c330e8992e8a295(pattern) {
    !$e8d0e236465e8031$export$9c954a9d03d32f4a() && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $e8d0e236465e8031$export$45d76561a5302f2b();
    return $l7WPE.useMemo(()=>(0, $953e819bf2999f7c$export$81336c211d5ff295)(pattern, (0, $953e819bf2999f7c$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $e8d0e236465e8031$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $e8d0e236465e8031$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $l7WPE.useContext($e8d0e236465e8031$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $l7WPE.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $e8d0e236465e8031$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $l7WPE.useContext($e8d0e236465e8031$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $e8d0e236465e8031$var$useNavigateStable() : $e8d0e236465e8031$var$useNavigateUnstable();
}
function $e8d0e236465e8031$var$useNavigateUnstable() {
    !$e8d0e236465e8031$export$9c954a9d03d32f4a() && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    let dataRouterContext = $l7WPE.useContext($e8d0e236465e8031$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $l7WPE.useContext($e8d0e236465e8031$export$26749e8557646306);
    let { matches: matches } = $l7WPE.useContext($e8d0e236465e8031$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $e8d0e236465e8031$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $953e819bf2999f7c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $l7WPE.useRef(false);
    $e8d0e236465e8031$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $l7WPE.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $953e819bf2999f7c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $953e819bf2999f7c$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $e8d0e236465e8031$var$OutletContext = /*#__PURE__*/ $l7WPE.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $e8d0e236465e8031$export$4138103a3ae699cc() {
    return $l7WPE.useContext($e8d0e236465e8031$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $e8d0e236465e8031$export$a3be3530d8e40d0b(context) {
    let outlet = $l7WPE.useContext($e8d0e236465e8031$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $e8d0e236465e8031$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $l7WPE.useContext($e8d0e236465e8031$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $e8d0e236465e8031$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $l7WPE.useContext($e8d0e236465e8031$export$26749e8557646306);
    let { matches: matches } = $l7WPE.useContext($e8d0e236465e8031$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $e8d0e236465e8031$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $953e819bf2999f7c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $l7WPE.useMemo(()=>(0, $953e819bf2999f7c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $e8d0e236465e8031$export$5d3fca4a98652595(routes, locationArg) {
    return $e8d0e236465e8031$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $e8d0e236465e8031$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$e8d0e236465e8031$export$9c954a9d03d32f4a() && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $l7WPE.useContext($e8d0e236465e8031$export$26749e8557646306);
    let { matches: parentMatches } = $l7WPE.useContext($e8d0e236465e8031$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $e8d0e236465e8031$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $953e819bf2999f7c$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $953e819bf2999f7c$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $e8d0e236465e8031$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $953e819bf2999f7c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $953e819bf2999f7c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $e8d0e236465e8031$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $953e819bf2999f7c$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $e8d0e236465e8031$var$DefaultErrorComponent() {
    let error = $e8d0e236465e8031$export$ed527bf60f6e05f2();
    let message = (0, $953e819bf2999f7c$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $l7WPE.createElement($l7WPE.Fragment, null, /*#__PURE__*/ $l7WPE.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $l7WPE.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $l7WPE.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $e8d0e236465e8031$var$defaultErrorElement = /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$var$DefaultErrorComponent, null);
class $e8d0e236465e8031$var$RenderErrorBoundary extends $l7WPE.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $e8d0e236465e8031$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $l7WPE.useContext($e8d0e236465e8031$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $e8d0e236465e8031$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $e8d0e236465e8031$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $e8d0e236465e8031$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $l7WPE.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $e8d0e236465e8031$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($e8d0e236465e8031$var$DataRouterHook || {});
var $e8d0e236465e8031$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($e8d0e236465e8031$var$DataRouterStateHook || {});
function $e8d0e236465e8031$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $e8d0e236465e8031$var$useDataRouterContext(hookName) {
    let ctx = $l7WPE.useContext($e8d0e236465e8031$export$3add0d5dce533e2e);
    !ctx && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $e8d0e236465e8031$var$useDataRouterState(hookName) {
    let state = $l7WPE.useContext($e8d0e236465e8031$export$145dfa71566a64dc);
    !state && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    return state;
}
function $e8d0e236465e8031$var$useRouteContext(hookName) {
    let route = $l7WPE.useContext($e8d0e236465e8031$export$9072aa6dd1f93057);
    !route && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $e8d0e236465e8031$var$useCurrentRouteId(hookName) {
    let route = $e8d0e236465e8031$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $e8d0e236465e8031$export$5fc8298006ad9e58() {
    return $e8d0e236465e8031$var$useCurrentRouteId($e8d0e236465e8031$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $e8d0e236465e8031$export$d0fd4b7106de2769() {
    let state = $e8d0e236465e8031$var$useDataRouterState($e8d0e236465e8031$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $e8d0e236465e8031$export$600dc272ed516c15() {
    let dataRouterContext = $e8d0e236465e8031$var$useDataRouterContext($e8d0e236465e8031$var$DataRouterHook.UseRevalidator);
    let state = $e8d0e236465e8031$var$useDataRouterState($e8d0e236465e8031$var$DataRouterStateHook.UseRevalidator);
    return $l7WPE.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $e8d0e236465e8031$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $e8d0e236465e8031$var$useDataRouterState($e8d0e236465e8031$var$DataRouterStateHook.UseMatches);
    return $l7WPE.useMemo(()=>matches.map((m)=>(0, $953e819bf2999f7c$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $e8d0e236465e8031$export$1448a5050d252c4d() {
    let state = $e8d0e236465e8031$var$useDataRouterState($e8d0e236465e8031$var$DataRouterStateHook.UseLoaderData);
    let routeId = $e8d0e236465e8031$var$useCurrentRouteId($e8d0e236465e8031$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $e8d0e236465e8031$export$fd5d37484eab868d(routeId) {
    let state = $e8d0e236465e8031$var$useDataRouterState($e8d0e236465e8031$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $e8d0e236465e8031$export$fdc00f3f26066d5e() {
    let state = $e8d0e236465e8031$var$useDataRouterState($e8d0e236465e8031$var$DataRouterStateHook.UseActionData);
    let routeId = $e8d0e236465e8031$var$useCurrentRouteId($e8d0e236465e8031$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $e8d0e236465e8031$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $l7WPE.useContext($e8d0e236465e8031$var$RouteErrorContext);
    let state = $e8d0e236465e8031$var$useDataRouterState($e8d0e236465e8031$var$DataRouterStateHook.UseRouteError);
    let routeId = $e8d0e236465e8031$var$useCurrentRouteId($e8d0e236465e8031$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $e8d0e236465e8031$export$78a72ddb39bdd145() {
    let value = $l7WPE.useContext($e8d0e236465e8031$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $e8d0e236465e8031$export$17f53340677d5831() {
    let value = $l7WPE.useContext($e8d0e236465e8031$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $e8d0e236465e8031$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $e8d0e236465e8031$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $e8d0e236465e8031$var$useDataRouterContext($e8d0e236465e8031$var$DataRouterHook.UseBlocker);
    let state = $e8d0e236465e8031$var$useDataRouterState($e8d0e236465e8031$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $l7WPE.useState("");
    let blockerFunction = $l7WPE.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $e8d0e236465e8031$var$_extends({}, currentLocation, {
                pathname: (0, $953e819bf2999f7c$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $e8d0e236465e8031$var$_extends({}, nextLocation, {
                pathname: (0, $953e819bf2999f7c$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $l7WPE.useEffect(()=>{
        let key = String(++$e8d0e236465e8031$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $l7WPE.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $953e819bf2999f7c$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $e8d0e236465e8031$var$useNavigateStable() {
    let { router: router } = $e8d0e236465e8031$var$useDataRouterContext($e8d0e236465e8031$var$DataRouterHook.UseNavigateStable);
    let id = $e8d0e236465e8031$var$useCurrentRouteId($e8d0e236465e8031$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $l7WPE.useRef(false);
    $e8d0e236465e8031$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $l7WPE.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $e8d0e236465e8031$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $e8d0e236465e8031$var$alreadyWarned$1 = {};
function $e8d0e236465e8031$var$warningOnce(key, cond, message) {
    if (!cond && !$e8d0e236465e8031$var$alreadyWarned$1[key]) $e8d0e236465e8031$var$alreadyWarned$1[key] = true;
}
const $e8d0e236465e8031$var$alreadyWarned = {};
function $e8d0e236465e8031$var$warnOnce(key, message) {
    if (!$e8d0e236465e8031$var$alreadyWarned[message]) {
        $e8d0e236465e8031$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $e8d0e236465e8031$var$logDeprecation = (flag, msg, link)=>$e8d0e236465e8031$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $e8d0e236465e8031$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $e8d0e236465e8031$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $e8d0e236465e8031$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $e8d0e236465e8031$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $e8d0e236465e8031$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $e8d0e236465e8031$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $e8d0e236465e8031$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $e8d0e236465e8031$var$START_TRANSITION = "startTransition";
const $e8d0e236465e8031$var$startTransitionImpl = $l7WPE[$e8d0e236465e8031$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $e8d0e236465e8031$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $l7WPE.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $l7WPE.useCallback((newState)=>{
        if (v7_startTransition && $e8d0e236465e8031$var$startTransitionImpl) $e8d0e236465e8031$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $l7WPE.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $l7WPE.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $l7WPE.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $l7WPE.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $l7WPE.useEffect(()=>$e8d0e236465e8031$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $l7WPE.createElement($l7WPE.Fragment, null, /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $e8d0e236465e8031$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $e8d0e236465e8031$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $e8d0e236465e8031$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $l7WPE.useRef();
    if (historyRef.current == null) historyRef.current = (0, $953e819bf2999f7c$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $l7WPE.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $l7WPE.useCallback((newState)=>{
        v7_startTransition && $e8d0e236465e8031$var$startTransitionImpl ? $e8d0e236465e8031$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $l7WPE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $l7WPE.useEffect(()=>$e8d0e236465e8031$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $e8d0e236465e8031$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$e8d0e236465e8031$export$9c954a9d03d32f4a() && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $l7WPE.useContext($e8d0e236465e8031$export$26749e8557646306);
    let { matches: matches } = $l7WPE.useContext($e8d0e236465e8031$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $e8d0e236465e8031$export$45d76561a5302f2b();
    let navigate = $e8d0e236465e8031$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $953e819bf2999f7c$export$cae722b0cc860f13)(to, (0, $953e819bf2999f7c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $l7WPE.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $e8d0e236465e8031$export$910ae8079b2c2852(props) {
    return $e8d0e236465e8031$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $e8d0e236465e8031$export$e7b0ac011bb776c6(_props) {
    (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $e8d0e236465e8031$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $953e819bf2999f7c$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$e8d0e236465e8031$export$9c954a9d03d32f4a() && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $l7WPE.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $e8d0e236465e8031$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $953e819bf2999f7c$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $l7WPE.useMemo(()=>{
        let trailingPathname = (0, $953e819bf2999f7c$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $e8d0e236465e8031$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $e8d0e236465e8031$export$5d3fca4a98652595($e8d0e236465e8031$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $e8d0e236465e8031$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$var$ResolveAwait, null, children));
}
var $e8d0e236465e8031$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($e8d0e236465e8031$var$AwaitRenderStatus || {});
const $e8d0e236465e8031$var$neverSettledPromise = new Promise(()=>{});
class $e8d0e236465e8031$var$AwaitErrorBoundary extends $l7WPE.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $e8d0e236465e8031$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $e8d0e236465e8031$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $e8d0e236465e8031$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $e8d0e236465e8031$var$AwaitRenderStatus.error : "_data" in promise ? $e8d0e236465e8031$var$AwaitRenderStatus.success : $e8d0e236465e8031$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $e8d0e236465e8031$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $e8d0e236465e8031$var$AwaitRenderStatus.error && promise._error instanceof (0, $953e819bf2999f7c$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $e8d0e236465e8031$var$neverSettledPromise;
        if (status === $e8d0e236465e8031$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $e8d0e236465e8031$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $e8d0e236465e8031$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $l7WPE.createElement($e8d0e236465e8031$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $e8d0e236465e8031$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $e8d0e236465e8031$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $l7WPE.createElement($l7WPE.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $e8d0e236465e8031$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $l7WPE.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $l7WPE.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $l7WPE.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $e8d0e236465e8031$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $e8d0e236465e8031$export$e7b0ac011bb776c6) && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $e8d0e236465e8031$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $e8d0e236465e8031$export$daf73786167a7f72(matches) {
    return $e8d0e236465e8031$var$_renderMatches(matches);
}
function $e8d0e236465e8031$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $l7WPE.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $l7WPE.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $l7WPE.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $e8d0e236465e8031$export$f30f7e456d254e83(routes, opts) {
    return (0, $953e819bf2999f7c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e8d0e236465e8031$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $953e819bf2999f7c$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $e8d0e236465e8031$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $90539c90c270aca5$var$_extends() {
    $90539c90c270aca5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $90539c90c270aca5$var$_extends.apply(this, arguments);
}
function $90539c90c270aca5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $90539c90c270aca5$var$defaultMethod = "get";
const $90539c90c270aca5$var$defaultEncType = "application/x-www-form-urlencoded";
function $90539c90c270aca5$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $90539c90c270aca5$var$isButtonElement(object) {
    return $90539c90c270aca5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $90539c90c270aca5$var$isFormElement(object) {
    return $90539c90c270aca5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $90539c90c270aca5$var$isInputElement(object) {
    return $90539c90c270aca5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $90539c90c270aca5$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $90539c90c270aca5$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$90539c90c270aca5$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $90539c90c270aca5$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $90539c90c270aca5$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $90539c90c270aca5$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $90539c90c270aca5$var$_formDataSupportsSubmitter = null;
function $90539c90c270aca5$var$isFormDataSubmitterSupported() {
    if ($90539c90c270aca5$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $90539c90c270aca5$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $90539c90c270aca5$var$_formDataSupportsSubmitter = true;
    }
    return $90539c90c270aca5$var$_formDataSupportsSubmitter;
}
const $90539c90c270aca5$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $90539c90c270aca5$var$getFormEncType(encType) {
    if (encType != null && !$90539c90c270aca5$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $90539c90c270aca5$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($90539c90c270aca5$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $953e819bf2999f7c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $90539c90c270aca5$var$defaultMethod;
        encType = $90539c90c270aca5$var$getFormEncType(target.getAttribute("enctype")) || $90539c90c270aca5$var$defaultEncType;
        formData = new FormData(target);
    } else if ($90539c90c270aca5$var$isButtonElement(target) || $90539c90c270aca5$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $953e819bf2999f7c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $90539c90c270aca5$var$defaultMethod;
        encType = $90539c90c270aca5$var$getFormEncType(target.getAttribute("formenctype")) || $90539c90c270aca5$var$getFormEncType(form.getAttribute("enctype")) || $90539c90c270aca5$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$90539c90c270aca5$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($90539c90c270aca5$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $90539c90c270aca5$var$defaultMethod;
        action = null;
        encType = $90539c90c270aca5$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $90539c90c270aca5$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $90539c90c270aca5$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $90539c90c270aca5$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $90539c90c270aca5$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $90539c90c270aca5$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $90539c90c270aca5$export$1f3f55432a00e06d(routes, opts) {
    return (0, $953e819bf2999f7c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $90539c90c270aca5$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $953e819bf2999f7c$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $90539c90c270aca5$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $e8d0e236465e8031$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $90539c90c270aca5$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $953e819bf2999f7c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $90539c90c270aca5$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $953e819bf2999f7c$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $90539c90c270aca5$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $e8d0e236465e8031$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $90539c90c270aca5$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $90539c90c270aca5$var$_extends({}, state, {
        errors: $90539c90c270aca5$var$deserializeErrors(state.errors)
    });
    return state;
}
function $90539c90c270aca5$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $953e819bf2999f7c$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $90539c90c270aca5$export$7ad602f0e94e62d1 = /*#__PURE__*/ $l7WPE.createContext({
    isTransitioning: false
});
const $90539c90c270aca5$export$148fd98d095596d4 = /*#__PURE__*/ $l7WPE.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $90539c90c270aca5$var$START_TRANSITION = "startTransition";
const $90539c90c270aca5$var$startTransitionImpl = $l7WPE[$90539c90c270aca5$var$START_TRANSITION];
const $90539c90c270aca5$var$FLUSH_SYNC = "flushSync";
const $90539c90c270aca5$var$flushSyncImpl = $b1e9cc0cc5ead376$exports[$90539c90c270aca5$var$FLUSH_SYNC];
const $90539c90c270aca5$var$USE_ID = "useId";
const $90539c90c270aca5$var$useIdImpl = $l7WPE[$90539c90c270aca5$var$USE_ID];
function $90539c90c270aca5$var$startTransitionSafe(cb) {
    if ($90539c90c270aca5$var$startTransitionImpl) $90539c90c270aca5$var$startTransitionImpl(cb);
    else cb();
}
function $90539c90c270aca5$var$flushSyncSafe(cb) {
    if ($90539c90c270aca5$var$flushSyncImpl) $90539c90c270aca5$var$flushSyncImpl(cb);
    else cb();
}
class $90539c90c270aca5$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $90539c90c270aca5$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $l7WPE.useState(router.state);
    let [pendingState, setPendingState] = $l7WPE.useState();
    let [vtContext, setVtContext] = $l7WPE.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $l7WPE.useState();
    let [transition, setTransition] = $l7WPE.useState();
    let [interruption, setInterruption] = $l7WPE.useState();
    let fetcherData = $l7WPE.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $l7WPE.useCallback((cb)=>{
        if (v7_startTransition) $90539c90c270aca5$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $l7WPE.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $90539c90c270aca5$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $90539c90c270aca5$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $90539c90c270aca5$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $90539c90c270aca5$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $90539c90c270aca5$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $l7WPE.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $l7WPE.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $90539c90c270aca5$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $l7WPE.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $l7WPE.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $l7WPE.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $l7WPE.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $l7WPE.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $l7WPE.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $l7WPE.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $l7WPE.useEffect(()=>(0, $e8d0e236465e8031$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $l7WPE.createElement($l7WPE.Fragment, null, /*#__PURE__*/ $l7WPE.createElement((0, $e8d0e236465e8031$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $l7WPE.createElement((0, $e8d0e236465e8031$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $l7WPE.createElement($90539c90c270aca5$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $l7WPE.createElement($90539c90c270aca5$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $l7WPE.createElement((0, $e8d0e236465e8031$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $l7WPE.createElement($90539c90c270aca5$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $90539c90c270aca5$var$MemoizedDataRoutes = /*#__PURE__*/ $l7WPE.memo($90539c90c270aca5$var$DataRoutes);
function $90539c90c270aca5$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $e8d0e236465e8031$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $90539c90c270aca5$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $l7WPE.useRef();
    if (historyRef.current == null) historyRef.current = (0, $953e819bf2999f7c$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $l7WPE.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $l7WPE.useCallback((newState)=>{
        v7_startTransition && $90539c90c270aca5$var$startTransitionImpl ? $90539c90c270aca5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $l7WPE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $l7WPE.useEffect(()=>(0, $e8d0e236465e8031$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $l7WPE.createElement((0, $e8d0e236465e8031$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $90539c90c270aca5$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $l7WPE.useRef();
    if (historyRef.current == null) historyRef.current = (0, $953e819bf2999f7c$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $l7WPE.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $l7WPE.useCallback((newState)=>{
        v7_startTransition && $90539c90c270aca5$var$startTransitionImpl ? $90539c90c270aca5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $l7WPE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $l7WPE.useEffect(()=>(0, $e8d0e236465e8031$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $l7WPE.createElement((0, $e8d0e236465e8031$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $90539c90c270aca5$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $l7WPE.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $l7WPE.useCallback((newState)=>{
        v7_startTransition && $90539c90c270aca5$var$startTransitionImpl ? $90539c90c270aca5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $l7WPE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $l7WPE.useEffect(()=>(0, $e8d0e236465e8031$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $l7WPE.createElement((0, $e8d0e236465e8031$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $90539c90c270aca5$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $90539c90c270aca5$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $90539c90c270aca5$export$a6c7ac8248d6e38a = /*#__PURE__*/ $l7WPE.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $90539c90c270aca5$var$_objectWithoutPropertiesLoose(_ref7, $90539c90c270aca5$var$_excluded);
    let { basename: basename } = $l7WPE.useContext((0, $e8d0e236465e8031$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $90539c90c270aca5$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($90539c90c270aca5$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $953e819bf2999f7c$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $e8d0e236465e8031$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $90539c90c270aca5$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $l7WPE.createElement("a", $90539c90c270aca5$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $90539c90c270aca5$export$b0d92dbee9b5b60d = /*#__PURE__*/ $l7WPE.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $90539c90c270aca5$var$_objectWithoutPropertiesLoose(_ref8, $90539c90c270aca5$var$_excluded2);
    let path = (0, $e8d0e236465e8031$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $e8d0e236465e8031$export$45d76561a5302f2b)();
    let routerState = $l7WPE.useContext((0, $e8d0e236465e8031$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $l7WPE.useContext((0, $e8d0e236465e8031$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $90539c90c270aca5$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $953e819bf2999f7c$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $l7WPE.createElement($90539c90c270aca5$export$a6c7ac8248d6e38a, $90539c90c270aca5$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $90539c90c270aca5$export$a7fed597f4b8afd8 = /*#__PURE__*/ $l7WPE.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $90539c90c270aca5$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $90539c90c270aca5$var$_objectWithoutPropertiesLoose(_ref9, $90539c90c270aca5$var$_excluded3);
    let submit = $90539c90c270aca5$export$47c85c6e3a081d3();
    let formAction = $90539c90c270aca5$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $l7WPE.createElement("form", $90539c90c270aca5$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $90539c90c270aca5$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $90539c90c270aca5$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $90539c90c270aca5$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($90539c90c270aca5$var$DataRouterHook || ($90539c90c270aca5$var$DataRouterHook = {}));
var $90539c90c270aca5$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($90539c90c270aca5$var$DataRouterStateHook || ($90539c90c270aca5$var$DataRouterStateHook = {}));
// Internal hooks
function $90539c90c270aca5$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $90539c90c270aca5$var$useDataRouterContext(hookName) {
    let ctx = $l7WPE.useContext((0, $e8d0e236465e8031$export$3add0d5dce533e2e));
    !ctx && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $90539c90c270aca5$var$useDataRouterState(hookName) {
    let state = $l7WPE.useContext((0, $e8d0e236465e8031$export$145dfa71566a64dc));
    !state && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $90539c90c270aca5$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $e8d0e236465e8031$export$9770f232ac06a008)();
    let location = (0, $e8d0e236465e8031$export$45d76561a5302f2b)();
    let path = (0, $e8d0e236465e8031$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $l7WPE.useCallback((event)=>{
        if ($90539c90c270aca5$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $953e819bf2999f7c$export$fe53371bee54353d)(location) === (0, $953e819bf2999f7c$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $90539c90c270aca5$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $l7WPE.useRef($90539c90c270aca5$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $l7WPE.useRef(false);
    let location = (0, $e8d0e236465e8031$export$45d76561a5302f2b)();
    let searchParams = $l7WPE.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $90539c90c270aca5$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $e8d0e236465e8031$export$9770f232ac06a008)();
    let setSearchParams = $l7WPE.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $90539c90c270aca5$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $90539c90c270aca5$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $90539c90c270aca5$var$fetcherId = 0;
let $90539c90c270aca5$var$getUniqueFetcherId = ()=>"__" + String(++$90539c90c270aca5$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $90539c90c270aca5$export$47c85c6e3a081d3() {
    let { router: router } = $90539c90c270aca5$var$useDataRouterContext($90539c90c270aca5$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $l7WPE.useContext((0, $e8d0e236465e8031$export$26749e8557646306));
    let currentRouteId = (0, $e8d0e236465e8031$export$5fc8298006ad9e58)();
    return $l7WPE.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $90539c90c270aca5$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $90539c90c270aca5$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $90539c90c270aca5$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $90539c90c270aca5$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $l7WPE.useContext((0, $e8d0e236465e8031$export$26749e8557646306));
    let routeContext = $l7WPE.useContext((0, $e8d0e236465e8031$export$9072aa6dd1f93057));
    !routeContext && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $90539c90c270aca5$var$_extends({}, (0, $e8d0e236465e8031$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $e8d0e236465e8031$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $953e819bf2999f7c$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $953e819bf2999f7c$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $90539c90c270aca5$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $90539c90c270aca5$var$useDataRouterContext($90539c90c270aca5$var$DataRouterHook.UseFetcher);
    let state = $90539c90c270aca5$var$useDataRouterState($90539c90c270aca5$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $l7WPE.useContext($90539c90c270aca5$export$148fd98d095596d4);
    let route = $l7WPE.useContext((0, $e8d0e236465e8031$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    !route && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $90539c90c270aca5$var$useIdImpl ? $90539c90c270aca5$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $l7WPE.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($90539c90c270aca5$var$getUniqueFetcherId());
    // Registration/cleanup
    $l7WPE.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $l7WPE.useCallback((href, opts)=>{
        !routeId && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $90539c90c270aca5$export$47c85c6e3a081d3();
    let submit = $l7WPE.useCallback((target, opts)=>{
        submitImpl(target, $90539c90c270aca5$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $l7WPE.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $l7WPE.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $l7WPE.createElement($90539c90c270aca5$export$a7fed597f4b8afd8, $90539c90c270aca5$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $953e819bf2999f7c$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $l7WPE.useMemo(()=>$90539c90c270aca5$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $90539c90c270aca5$export$fa996778a3a31087() {
    let state = $90539c90c270aca5$var$useDataRouterState($90539c90c270aca5$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $90539c90c270aca5$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $90539c90c270aca5$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $90539c90c270aca5$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $90539c90c270aca5$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $90539c90c270aca5$var$useDataRouterContext($90539c90c270aca5$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $90539c90c270aca5$var$useDataRouterState($90539c90c270aca5$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $l7WPE.useContext((0, $e8d0e236465e8031$export$26749e8557646306));
    let location = (0, $e8d0e236465e8031$export$45d76561a5302f2b)();
    let matches = (0, $e8d0e236465e8031$export$2378eb7f5ff86053)();
    let navigation = (0, $e8d0e236465e8031$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $l7WPE.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $90539c90c270aca5$var$usePageHide($l7WPE.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $90539c90c270aca5$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $90539c90c270aca5$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($90539c90c270aca5$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $l7WPE.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $90539c90c270aca5$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $90539c90c270aca5$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $l7WPE.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($90539c90c270aca5$var$_extends({}, location, {
                    pathname: (0, $953e819bf2999f7c$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($90539c90c270aca5$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $l7WPE.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $90539c90c270aca5$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $l7WPE.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $90539c90c270aca5$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $l7WPE.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $90539c90c270aca5$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $e8d0e236465e8031$export$b273b3273281a049)(when);
    $l7WPE.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $l7WPE.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $90539c90c270aca5$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $l7WPE.useContext($90539c90c270aca5$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $953e819bf2999f7c$export$3e9cee6b33872309)(false);
    let { basename: basename } = $90539c90c270aca5$var$useDataRouterContext($90539c90c270aca5$var$DataRouterHook.useViewTransitionState);
    let path = (0, $e8d0e236465e8031$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $953e819bf2999f7c$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $953e819bf2999f7c$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $953e819bf2999f7c$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $953e819bf2999f7c$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $l7WPE = parcelRequire("l7WPE");
const $289dddd4090929de$var$RomContext = /*#__PURE__*/ (0, $l7WPE.createContext)({
    prg: null,
    res: null,
    resources: null
});
const $289dddd4090929de$var$RomDispatchContext = /*#__PURE__*/ (0, $l7WPE.createContext)(null);
const $289dddd4090929de$var$romReducer = (rom, action)=>{
    switch(action.type){
        case 'initialised':
            return action.rom;
        case 'changed-palette':
            {
                const newRom = structuredClone(rom);
                if (action.screenType === 'room') newRom.resources.rooms[action.id].palette = action.palette;
                else if (action.screenType === 'title') newRom.resources.titles[action.id].palette = action.palette;
                else throw Error('Unknown screen type: ' + action.screenType);
                return newRom;
            }
        default:
            throw Error('Unknown action: ' + action.type);
    }
};
const $289dddd4090929de$export$d6fd23419d7c6b4f = ({ children: children })=>{
    const [rom, dispatch] = (0, $l7WPE.useReducer)($289dddd4090929de$var$romReducer, {
        prg: null,
        res: null,
        resources: null
    });
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)($289dddd4090929de$var$RomContext.Provider, {
        value: rom,
        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)($289dddd4090929de$var$RomDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
const $289dddd4090929de$export$70ea12b4fef8b763 = ()=>(0, $l7WPE.useContext)($289dddd4090929de$var$RomContext);
const $289dddd4090929de$export$181baa7312ee9507 = ()=>(0, $l7WPE.useContext)($289dddd4090929de$var$RomDispatchContext);







var $l7WPE = parcelRequire("l7WPE");



var $l7WPE = parcelRequire("l7WPE");


var $idaDz = parcelRequire("idaDz");
const $ee9a5f11321bdeba$var$type = 'application/x-nes-rom';
const $ee9a5f11321bdeba$var$fileName = 'mm-hack.nes';
const $ee9a5f11321bdeba$var$DownloadRom = ({ children: children })=>{
    const { prg: prg, resources: resources } = (0, $289dddd4090929de$export$70ea12b4fef8b763)();
    const [aHref, setAHref] = (0, $l7WPE.useState)(null);
    const aRef = (0, $l7WPE.useRef)(null);
    if (prg === null) return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("button", {
        className: "text-slate-500 opacity-50",
        disabled: true,
        children: children
    });
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("button", {
                className: "text-slate-500 transition hover:text-slate-800 hover:dark:text-slate-200",
                onClick: ()=>{
                    const rom = (0, $idaDz.generateRomHackFile)(prg, resources);
                    setAHref(window.URL.createObjectURL(new Blob([
                        rom
                    ], {
                        type: $ee9a5f11321bdeba$var$type
                    })));
                    // Needs to render first.
                    setTimeout(()=>{
                        // Trigger the download by simulating a click.
                        aRef.current.click();
                        window.URL.revokeObjectURL(aHref);
                    });
                },
                children: children
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("a", {
                className: "hidden",
                href: aHref,
                download: $ee9a5f11321bdeba$var$fileName,
                ref: aRef
            })
        ]
    });
};
var $ee9a5f11321bdeba$export$2e2bcd8739ae039 = $ee9a5f11321bdeba$var$DownloadRom;



var $l7WPE = parcelRequire("l7WPE");
var $612f52da01364eb3$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($612f52da01364eb3$export$4b0075e5ea5e1f26 || {});



var $l7WPE = parcelRequire("l7WPE");

var $l7WPE = parcelRequire("l7WPE");

var $l7WPE = parcelRequire("l7WPE");
var $4881b9345355c80e$var$i = Object.defineProperty;
var $4881b9345355c80e$var$d = (t, e, n)=>e in t ? $4881b9345355c80e$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $4881b9345355c80e$var$r = (t, e, n)=>($4881b9345355c80e$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $4881b9345355c80e$var$o {
    constructor(){
        $4881b9345355c80e$var$r(this, "current", this.detect());
        $4881b9345355c80e$var$r(this, "handoffState", "pending");
        $4881b9345355c80e$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $4881b9345355c80e$export$a7b6bc01c63cdfc3 = new $4881b9345355c80e$var$o;


let $3bbdb114024fc011$export$ce5ed857c741fd71 = (e, t)=>{
    (0, $4881b9345355c80e$export$a7b6bc01c63cdfc3).isServer ? (0, $l7WPE.useEffect)(e, t) : (0, $l7WPE.useLayoutEffect)(e, t);
};


function $7395d73fc6971264$export$86c4283a11f23f95(e) {
    let r = (0, $l7WPE.useRef)(e);
    return (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}


function $7730fda268ff0e1a$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $7395d73fc6971264$export$86c4283a11f23f95)(a);
    (0, $l7WPE.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}



var $l7WPE = parcelRequire("l7WPE");
class $4fa8e0c1af181975$export$674cd7dcb504ac5c extends Map {
    constructor(t){
        super();
        this.factory = t;
    }
    get(t) {
        let e = super.get(t);
        return e === void 0 && (e = this.factory(t), this.set(t, e)), e;
    }
}


function $c40f05fc31343437$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}




var $l7WPE = parcelRequire("l7WPE");
function $b8c696774ae56105$export$6ccbb43953eebf8(t) {
    return (0, $l7WPE.useSyncExternalStore)(t.subscribe, t.getSnapshot, t.getSnapshot);
}


let $08b6a5272e281a85$var$p = new (0, $4fa8e0c1af181975$export$674cd7dcb504ac5c)(()=>(0, $c40f05fc31343437$export$f51a9068ac82ea43)(()=>[], {
        ADD (r) {
            return this.includes(r) ? this : [
                ...this,
                r
            ];
        },
        REMOVE (r) {
            let e = this.indexOf(r);
            if (e === -1) return this;
            let t = this.slice();
            return t.splice(e, 1), t;
        }
    }));
function $08b6a5272e281a85$export$5f5dd115998e0b80(r, e) {
    let t = $08b6a5272e281a85$var$p.get(e), i = (0, $l7WPE.useId)(), h = (0, $b8c696774ae56105$export$6ccbb43953eebf8)(t);
    if ((0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        if (r) return t.dispatch("ADD", i), ()=>t.dispatch("REMOVE", i);
    }, [
        t,
        r
    ]), !r) return !1;
    let s = h.indexOf(i), o = h.length;
    return s === -1 && (s = o, o += 1), s === o - 1;
}


function $bb9433d1ef59b14d$export$3875fddb67014c13(o, r = typeof document != "undefined" ? document.defaultView : null, t) {
    let n = (0, $08b6a5272e281a85$export$5f5dd115998e0b80)(o, "escape");
    (0, $7730fda268ff0e1a$export$7080b3e976bc91ab)(r, "keydown", (e)=>{
        n && (e.defaultPrevented || e.key === (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Escape && t(e));
    });
}



var $l7WPE = parcelRequire("l7WPE");

let $0d74b41fc1905bf3$export$90fc3a17d93f704c = function(t) {
    let e = (0, $7395d73fc6971264$export$86c4283a11f23f95)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};



var $l7WPE = parcelRequire("l7WPE");
function $db35e04d4d40d6d6$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}


function $270a47a058bb084f$export$12b26c28a05aa001() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $db35e04d4d40d6d6$export$a5ff0d6a738703ca)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = $270a47a058bb084f$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.includes(e) || n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}



function $be0aa046e776f98a$export$b204af158042fbac(r) {
    return (0, $4881b9345355c80e$export$a7b6bc01c63cdfc3).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}




let $23d1b4b809d79c7a$var$f = new Map, $23d1b4b809d79c7a$var$u = new Map;
function $23d1b4b809d79c7a$var$h(t) {
    var e;
    let r = (e = $23d1b4b809d79c7a$var$u.get(t)) != null ? e : 0;
    return $23d1b4b809d79c7a$var$u.set(t, r + 1), r !== 0 ? ()=>$23d1b4b809d79c7a$var$m(t) : ($23d1b4b809d79c7a$var$f.set(t, {
        "aria-hidden": t.getAttribute("aria-hidden"),
        inert: t.inert
    }), t.setAttribute("aria-hidden", "true"), t.inert = !0, ()=>$23d1b4b809d79c7a$var$m(t));
}
function $23d1b4b809d79c7a$var$m(t) {
    var i;
    let r = (i = $23d1b4b809d79c7a$var$u.get(t)) != null ? i : 1;
    if (r === 1 ? $23d1b4b809d79c7a$var$u.delete(t) : $23d1b4b809d79c7a$var$u.set(t, r - 1), r !== 1) return;
    let e = $23d1b4b809d79c7a$var$f.get(t);
    e && (e["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", e["aria-hidden"]), t.inert = e.inert, $23d1b4b809d79c7a$var$f.delete(t));
}
function $23d1b4b809d79c7a$export$af489fa7e5283cc3(t, { allowed: r, disallowed: e } = {}) {
    let i = (0, $08b6a5272e281a85$export$5f5dd115998e0b80)(t, "inert-others");
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        var d, c;
        if (!i) return;
        let a = (0, $270a47a058bb084f$export$12b26c28a05aa001)();
        for (let n of (d = e == null ? void 0 : e()) != null ? d : [])n && a.add($23d1b4b809d79c7a$var$h(n));
        let s = (c = r == null ? void 0 : r()) != null ? c : [];
        for (let n of s){
            if (!n) continue;
            let l = (0, $be0aa046e776f98a$export$b204af158042fbac)(n);
            if (!l) continue;
            let o = n.parentElement;
            for(; o && o !== l.body;){
                for (let p of o.children)s.some((E)=>p.contains(E)) || a.add($23d1b4b809d79c7a$var$h(p));
                o = o.parentElement;
            }
        }
        return a.dispose;
    }, [
        i,
        r,
        e
    ]);
}



var $l7WPE = parcelRequire("l7WPE");

function $7ab3580046286dcb$export$2706b359107dd58d() {
    var t;
    let [e] = (0, $l7WPE.useState)(()=>typeof window != "undefined" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [o, c] = (0, $l7WPE.useState)((t = e == null ? void 0 : e.matches) != null ? t : !1);
    return (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        if (!e) return;
        function n(r) {
            c(r.matches);
        }
        return e.addEventListener("change", n), ()=>e.removeEventListener("change", n);
    }, [
        e
    ]), o;
}



var $l7WPE = parcelRequire("l7WPE");


function $f05d8d85c884fb07$export$b41b9097915aa006(s, n, l) {
    let i = (0, $7395d73fc6971264$export$86c4283a11f23f95)((t)=>{
        let e = t.getBoundingClientRect();
        e.x === 0 && e.y === 0 && e.width === 0 && e.height === 0 && l();
    });
    (0, $l7WPE.useEffect)(()=>{
        if (!s) return;
        let t = n === null ? null : n instanceof HTMLElement ? n : n.current;
        if (!t) return;
        let e = (0, $270a47a058bb084f$export$12b26c28a05aa001)();
        if (typeof ResizeObserver != "undefined") {
            let r = new ResizeObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        if (typeof IntersectionObserver != "undefined") {
            let r = new IntersectionObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        return ()=>e.dispose();
    }, [
        n,
        i,
        s
    ]);
}



var $l7WPE = parcelRequire("l7WPE");

function $f191f2ad0684b169$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $f191f2ad0684b169$export$4659b591c19bdf3d), t;
}



let $c87ce7fcb4198fc6$export$acea64b1933eb668 = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(","), $c87ce7fcb4198fc6$var$p = [
    "[data-autofocus]"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $c87ce7fcb4198fc6$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n[n.AutoFocus = 64] = "AutoFocus", n))($c87ce7fcb4198fc6$export$807a7eae502106e7 || {}), $c87ce7fcb4198fc6$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($c87ce7fcb4198fc6$export$abf286375dfa6dbd || {}), $c87ce7fcb4198fc6$var$y = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($c87ce7fcb4198fc6$var$y || {});
function $c87ce7fcb4198fc6$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($c87ce7fcb4198fc6$export$acea64b1933eb668)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function $c87ce7fcb4198fc6$export$89622d0e8d475962(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($c87ce7fcb4198fc6$var$p)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $c87ce7fcb4198fc6$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($c87ce7fcb4198fc6$export$27112a34f2f8402d || {});
function $c87ce7fcb4198fc6$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $be0aa046e776f98a$export$b204af158042fbac)(e)) == null ? void 0 : t.body) ? !1 : (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(r, {
        [0] () {
            return e.matches($c87ce7fcb4198fc6$export$acea64b1933eb668);
        },
        [1] () {
            let u = e;
            for(; u !== null;){
                if (u.matches($c87ce7fcb4198fc6$export$acea64b1933eb668)) return !0;
                u = u.parentElement;
            }
            return !1;
        }
    });
}
function $c87ce7fcb4198fc6$export$46388676ec35ab85(e) {
    let r = (0, $be0aa046e776f98a$export$b204af158042fbac)(e);
    (0, $270a47a058bb084f$export$12b26c28a05aa001)().nextFrame(()=>{
        r && !$c87ce7fcb4198fc6$export$ff1ec1c740b3c8d5(r.activeElement, 0) && $c87ce7fcb4198fc6$export$5fed9cc43865dc7e(e);
    });
}
var $c87ce7fcb4198fc6$var$H = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($c87ce7fcb4198fc6$var$H || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $c87ce7fcb4198fc6$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $c87ce7fcb4198fc6$var$w = [
    "textarea",
    "input"
].join(",");
function $c87ce7fcb4198fc6$var$O(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $c87ce7fcb4198fc6$var$w)) != null ? t : !1;
}
function $c87ce7fcb4198fc6$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, u)=>{
        let o = r(t), c = r(u);
        if (o === null || c === null) return 0;
        let l = o.compareDocumentPosition(c);
        return l & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : l & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $c87ce7fcb4198fc6$export$7fb6c844b485e870(e, r) {
    return $c87ce7fcb4198fc6$export$82e1f4f412218a1d($c87ce7fcb4198fc6$export$433aaa1f216cf32d(), r, {
        relativeTo: e
    });
}
function $c87ce7fcb4198fc6$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: u = null, skipElements: o = [] } = {}) {
    let c = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, l = Array.isArray(e) ? t ? $c87ce7fcb4198fc6$export$20305e96f91bf103(e) : e : r & 64 ? $c87ce7fcb4198fc6$export$89622d0e8d475962(e) : $c87ce7fcb4198fc6$export$433aaa1f216cf32d(e);
    o.length > 0 && l.length > 1 && (l = l.filter((s)=>!o.some((a)=>a != null && "current" in a ? (a == null ? void 0 : a.current) === s : a === s))), u = u != null ? u : c.activeElement;
    let n = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, l.indexOf(u)) - 1;
        if (r & 4) return Math.max(0, l.indexOf(u)) + 1;
        if (r & 8) return l.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), M = r & 32 ? {
        preventScroll: !0
    } : {}, m = 0, d = l.length, i;
    do {
        if (m >= d || m + d <= 0) return 0;
        let s = x + m;
        if (r & 16) s = (s + d) % d;
        else {
            if (s < 0) return 3;
            if (s >= d) return 1;
        }
        i = l[s], i == null || i.focus(M), m += n;
    }while (i !== c.activeElement);
    return r & 6 && $c87ce7fcb4198fc6$var$O(i) && i.select(), 2;
}


function $aec25c8825b8a7a3$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $aec25c8825b8a7a3$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $aec25c8825b8a7a3$export$d0a8044dce8ff2fc() {
    return $aec25c8825b8a7a3$export$fedb369cb70207f1() || $aec25c8825b8a7a3$export$a11b0059900ceec8();
}



var $l7WPE = parcelRequire("l7WPE");

function $7729eb4b1da389ec$export$55d2b5df396a097b(t, e, o, n) {
    let u = (0, $7395d73fc6971264$export$86c4283a11f23f95)(o);
    (0, $l7WPE.useEffect)(()=>{
        if (!t) return;
        function r(m) {
            u.current(m);
        }
        return document.addEventListener(e, r, n), ()=>document.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}





var $l7WPE = parcelRequire("l7WPE");

function $a059a3f89f6d822b$export$ee579bb285b8d4aa(t, e, o, n) {
    let i = (0, $7395d73fc6971264$export$86c4283a11f23f95)(o);
    (0, $l7WPE.useEffect)(()=>{
        if (!t) return;
        function r(d) {
            i.current(d);
        }
        return window.addEventListener(e, r, n), ()=>window.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}


const $70b1014c8d12aa21$var$E = 30;
function $70b1014c8d12aa21$export$71b2224f1ce5e08e(p, f, C) {
    let u = (0, $08b6a5272e281a85$export$5f5dd115998e0b80)(p, "outside-click"), m = (0, $7395d73fc6971264$export$86c4283a11f23f95)(C), s = (0, $l7WPE.useCallback)(function(e, n) {
        if (e.defaultPrevented) return;
        let r = n(e);
        if (r === null || !r.getRootNode().contains(r) || !r.isConnected) return;
        let h = function l(o) {
            return typeof o == "function" ? l(o()) : Array.isArray(o) || o instanceof Set ? o : [
                o
            ];
        }(f);
        for (let l of h)if (l !== null && (l.contains(r) || e.composed && e.composedPath().includes(l))) return;
        return !(0, $c87ce7fcb4198fc6$export$ff1ec1c740b3c8d5)(r, (0, $c87ce7fcb4198fc6$export$27112a34f2f8402d).Loose) && r.tabIndex !== -1 && e.preventDefault(), m.current(e, r);
    }, [
        m,
        f
    ]), i = (0, $l7WPE.useRef)(null);
    (0, $7729eb4b1da389ec$export$55d2b5df396a097b)(u, "pointerdown", (t)=>{
        var e, n;
        i.current = ((n = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n[0]) || t.target;
    }, !0), (0, $7729eb4b1da389ec$export$55d2b5df396a097b)(u, "mousedown", (t)=>{
        var e, n;
        i.current = ((n = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n[0]) || t.target;
    }, !0), (0, $7729eb4b1da389ec$export$55d2b5df396a097b)(u, "click", (t)=>{
        (0, $aec25c8825b8a7a3$export$d0a8044dce8ff2fc)() || i.current && (s(t, ()=>i.current), i.current = null);
    }, !0);
    let a = (0, $l7WPE.useRef)({
        x: 0,
        y: 0
    });
    (0, $7729eb4b1da389ec$export$55d2b5df396a097b)(u, "touchstart", (t)=>{
        a.current.x = t.touches[0].clientX, a.current.y = t.touches[0].clientY;
    }, !0), (0, $7729eb4b1da389ec$export$55d2b5df396a097b)(u, "touchend", (t)=>{
        let e = {
            x: t.changedTouches[0].clientX,
            y: t.changedTouches[0].clientY
        };
        if (!(Math.abs(e.x - a.current.x) >= $70b1014c8d12aa21$var$E || Math.abs(e.y - a.current.y) >= $70b1014c8d12aa21$var$E)) return s(t, ()=>t.target instanceof HTMLElement ? t.target : null);
    }, !0), (0, $a059a3f89f6d822b$export$ee579bb285b8d4aa)(u, "blur", (t)=>s(t, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}



var $l7WPE = parcelRequire("l7WPE");

function $6761cdc5f43c39c6$export$dd9fbcea3de0ae36(...e) {
    return (0, $l7WPE.useMemo)(()=>(0, $be0aa046e776f98a$export$b204af158042fbac)(...e), [
        ...e
    ]);
}



var $l7WPE = parcelRequire("l7WPE");

var $l7WPE = parcelRequire("l7WPE");
function $15d75602336686c5$export$ce4ab0c55987d1ff(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}



var $30c8a076c23acfb8$export$ba0ea3f20e7bf777 = ((a)=>(a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))($30c8a076c23acfb8$export$ba0ea3f20e7bf777 || {}), $30c8a076c23acfb8$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($30c8a076c23acfb8$export$80c0a745e59f7989 || {});
function $30c8a076c23acfb8$export$e25bb1e5b53cbdff() {
    let n = $30c8a076c23acfb8$var$U();
    return (0, $l7WPE.useCallback)((r)=>$30c8a076c23acfb8$var$C({
            mergeRefs: n,
            ...r
        }), [
        n
    ]);
}
function $30c8a076c23acfb8$var$C({ ourProps: n, theirProps: r, slot: e, defaultTag: a, features: s, visible: t = !0, name: l, mergeRefs: i }) {
    i = i != null ? i : $30c8a076c23acfb8$var$$;
    let o = $30c8a076c23acfb8$var$P(r, n);
    if (t) return $30c8a076c23acfb8$var$F(o, e, a, l, i);
    let y = s != null ? s : 0;
    if (y & 2) {
        let { static: f = !1, ...u } = o;
        if (f) return $30c8a076c23acfb8$var$F(u, e, a, l, i);
    }
    if (y & 1) {
        let { unmount: f = !0, ...u } = o;
        return (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(f ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $30c8a076c23acfb8$var$F({
                    ...u,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, a, l, i);
            }
        });
    }
    return $30c8a076c23acfb8$var$F(o, e, a, l, i);
}
function $30c8a076c23acfb8$var$F(n, r = {}, e, a, s) {
    let { as: t = e, children: l, refName: i = "ref", ...o } = $30c8a076c23acfb8$var$h(n, [
        "unmount",
        "static"
    ]), y = n.ref !== void 0 ? {
        [i]: n.ref
    } : {}, f = typeof l == "function" ? l(r) : l;
    "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(r)), o["aria-labelledby"] && o["aria-labelledby"] === o.id && (o["aria-labelledby"] = void 0);
    let u = {};
    if (r) {
        let d = !1, p = [];
        for (let [c, T] of Object.entries(r))typeof T == "boolean" && (d = !0), T === !0 && p.push(c.replace(/([A-Z])/g, (g)=>`-${g.toLowerCase()}`));
        if (d) {
            u["data-headlessui-state"] = p.join(" ");
            for (let c of p)u[`data-${c}`] = "";
        }
    }
    if (t === (0, $l7WPE.Fragment) && (Object.keys($30c8a076c23acfb8$export$8e16b83750b44988(o)).length > 0 || Object.keys($30c8a076c23acfb8$export$8e16b83750b44988(u)).length > 0)) {
        if (!(0, $l7WPE.isValidElement)(f) || Array.isArray(f) && f.length > 1) {
            if (Object.keys($30c8a076c23acfb8$export$8e16b83750b44988(o)).length > 0) throw new Error([
                'Passing props on "Fragment"!',
                "",
                `The current component <${a} /> is rendering a "Fragment".`,
                "However we need to passthrough the following props:",
                Object.keys($30c8a076c23acfb8$export$8e16b83750b44988(o)).concat(Object.keys($30c8a076c23acfb8$export$8e16b83750b44988(u))).map((d)=>`  - ${d}`).join(`
`),
                "",
                "You can apply a few solutions:",
                [
                    'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                    "Render a single element as the child so that we can forward the props onto that element."
                ].map((d)=>`  - ${d}`).join(`
`)
            ].join(`
`));
        } else {
            let d = f.props, p = d == null ? void 0 : d.className, c = typeof p == "function" ? (...R)=>(0, $15d75602336686c5$export$ce4ab0c55987d1ff)(p(...R), o.className) : (0, $15d75602336686c5$export$ce4ab0c55987d1ff)(p, o.className), T = c ? {
                className: c
            } : {}, g = $30c8a076c23acfb8$var$P(f.props, $30c8a076c23acfb8$export$8e16b83750b44988($30c8a076c23acfb8$var$h(o, [
                "ref"
            ])));
            for(let R in u)R in g && delete u[R];
            return (0, $l7WPE.cloneElement)(f, Object.assign({}, g, u, y, {
                ref: s($30c8a076c23acfb8$var$H(f), y.ref)
            }, T));
        }
    }
    return (0, $l7WPE.createElement)(t, Object.assign({}, $30c8a076c23acfb8$var$h(o, [
        "ref"
    ]), t !== (0, $l7WPE.Fragment) && y, t !== (0, $l7WPE.Fragment) && u), f);
}
function $30c8a076c23acfb8$var$U() {
    let n = (0, $l7WPE.useRef)([]), r = (0, $l7WPE.useCallback)((e)=>{
        for (let a of n.current)a != null && (typeof a == "function" ? a(e) : a.current = e);
    }, []);
    return (...e)=>{
        if (!e.every((a)=>a == null)) return n.current = e, r;
    };
}
function $30c8a076c23acfb8$var$$(...n) {
    return n.every((r)=>r == null) ? void 0 : (r)=>{
        for (let e of n)e != null && (typeof e == "function" ? e(r) : e.current = r);
    };
}
function $30c8a076c23acfb8$var$P(...n) {
    var a;
    if (n.length === 0) return {};
    if (n.length === 1) return n[0];
    let r = {}, e = {};
    for (let s of n)for(let t in s)t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : r[t] = s[t];
    if (r.disabled || r["aria-disabled"]) for(let s in e)/^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(s) && (e[s] = [
        (t)=>{
            var l;
            return (l = t == null ? void 0 : t.preventDefault) == null ? void 0 : l.call(t);
        }
    ]);
    for(let s in e)Object.assign(r, {
        [s] (t, ...l) {
            let i = e[s];
            for (let o of i){
                if ((t instanceof Event || (t == null ? void 0 : t.nativeEvent) instanceof Event) && t.defaultPrevented) return;
                o(t, ...l);
            }
        }
    });
    return r;
}
function $30c8a076c23acfb8$export$9d1611c77c2fe928(...n) {
    var a;
    if (n.length === 0) return {};
    if (n.length === 1) return n[0];
    let r = {}, e = {};
    for (let s of n)for(let t in s)t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : r[t] = s[t];
    for(let s in e)Object.assign(r, {
        [s] (...t) {
            let l = e[s];
            for (let i of l)i == null || i(...t);
        }
    });
    return r;
}
function $30c8a076c23acfb8$export$e43f39796049410c(n) {
    var r;
    return Object.assign((0, $l7WPE.forwardRef)(n), {
        displayName: (r = n.displayName) != null ? r : n.name
    });
}
function $30c8a076c23acfb8$export$8e16b83750b44988(n) {
    let r = Object.assign({}, n);
    for(let e in r)r[e] === void 0 && delete r[e];
    return r;
}
function $30c8a076c23acfb8$var$h(n, r = []) {
    let e = Object.assign({}, n);
    for (let a of r)a in e && delete e[a];
    return e;
}
function $30c8a076c23acfb8$var$H(n) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).version.split(".")[0] >= "19" ? n.props.ref : n.ref;
}


let $51071f2ec6b67d06$var$a = "span";
var $51071f2ec6b67d06$export$4e7f8864c6a16d8a = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($51071f2ec6b67d06$export$4e7f8864c6a16d8a || {});
function $51071f2ec6b67d06$var$l(t, r) {
    var n;
    let { features: d = 1, ...e } = t, o = {
        ref: r,
        "aria-hidden": (d & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
        hidden: (d & 4) === 4 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(d & 4) === 4 && (d & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)()({
        ourProps: o,
        theirProps: e,
        slot: {},
        defaultTag: $51071f2ec6b67d06$var$a,
        name: "Hidden"
    });
}
let $51071f2ec6b67d06$export$8dc98ba7eadeaa56 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($51071f2ec6b67d06$var$l);





function $6ed700a93f481555$export$445f2d1a3d9b1b9f({ defaultContainers: l = [], portals: n, mainTreeNode: o } = {}) {
    let r = (0, $6761cdc5f43c39c6$export$dd9fbcea3de0ae36)(o), u = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        var i, c;
        let t = [];
        for (let e of l)e !== null && (e instanceof HTMLElement ? t.push(e) : "current" in e && e.current instanceof HTMLElement && t.push(e.current));
        if (n != null && n.current) for (let e of n.current)t.push(e);
        for (let e of (i = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? i : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (o && (e.contains(o) || e.contains((c = o == null ? void 0 : o.getRootNode()) == null ? void 0 : c.host)) || t.some((m)=>e.contains(m)) || t.push(e));
        return t;
    });
    return {
        resolveContainers: u,
        contains: (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((t)=>u().some((i)=>i.contains(t)))
    };
}
let $6ed700a93f481555$var$a = (0, $l7WPE.createContext)(null);
function $6ed700a93f481555$export$61c2c570df73dc80({ children: l, node: n }) {
    let [o, r] = (0, $l7WPE.useState)(null), u = $6ed700a93f481555$export$64db24433d7f4942(n != null ? n : o);
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($6ed700a93f481555$var$a.Provider, {
        value: u
    }, l, u === null && (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $51071f2ec6b67d06$export$8dc98ba7eadeaa56), {
        features: (0, $51071f2ec6b67d06$export$4e7f8864c6a16d8a).Hidden,
        ref: (t)=>{
            var i, c;
            if (t) {
                for (let e of (c = (i = (0, $be0aa046e776f98a$export$b204af158042fbac)(t)) == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? c : [])if (e !== document.body && e !== document.head && e instanceof HTMLElement && e != null && e.contains(t)) {
                    r(e);
                    break;
                }
            }
        }
    }));
}
function $6ed700a93f481555$export$64db24433d7f4942(l = null) {
    var n;
    return (n = (0, $l7WPE.useContext)($6ed700a93f481555$var$a)) != null ? n : l;
}






function $59117f4d8bbc9888$export$110627fb35ef9205() {
    let r;
    return {
        before ({ doc: e }) {
            var l;
            let o = e.documentElement, t = (l = e.defaultView) != null ? l : window;
            r = Math.max(0, t.innerWidth - o.clientWidth);
        },
        after ({ doc: e, d: o }) {
            let t = e.documentElement, l = Math.max(0, t.clientWidth - t.offsetWidth), n = Math.max(0, r - l);
            o.style(t, "paddingRight", `${n}px`);
        }
    };
}




function $c2d70658da81ac9e$export$e3a523dfabf27286() {
    return (0, $aec25c8825b8a7a3$export$fedb369cb70207f1)() ? {
        before ({ doc: r, d: n, meta: c }) {
            function o(a) {
                return c.containers.flatMap((l)=>l()).some((l)=>l.contains(a));
            }
            n.microTask(()=>{
                var s;
                if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
                    let t = (0, $270a47a058bb084f$export$12b26c28a05aa001)();
                    t.style(r.documentElement, "scrollBehavior", "auto"), n.add(()=>n.microTask(()=>t.dispose()));
                }
                let a = (s = window.scrollY) != null ? s : window.pageYOffset, l = null;
                n.addEventListener(r, "click", (t)=>{
                    if (t.target instanceof HTMLElement) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: f } = new URL(e.href), i = r.querySelector(f);
                        i && !o(i) && (l = i);
                    } catch  {}
                }, !0), n.addEventListener(r, "touchstart", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && o(e.parentElement);)e = e.parentElement;
                            n.style(e, "overscrollBehavior", "contain");
                        } else n.style(t.target, "touchAction", "none");
                    }
                }), n.addEventListener(r, "touchmove", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (t.target.tagName === "INPUT") return;
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), n.add(()=>{
                    var e;
                    let t = (e = window.scrollY) != null ? e : window.pageYOffset;
                    a !== t && window.scrollTo(0, a), l && l.isConnected && (l.scrollIntoView({
                        block: "nearest"
                    }), l = null);
                });
            });
        }
    } : {};
}


function $e4c5b1ea1c0961d2$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}


function $74ddc1df3e16fc55$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $74ddc1df3e16fc55$export$a4161f418919b5aa = (0, $c40f05fc31343437$export$f51a9068ac82ea43)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $270a47a058bb084f$export$12b26c28a05aa001)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $74ddc1df3e16fc55$var$m(t)
        }, c = [
            (0, $c2d70658da81ac9e$export$e3a523dfabf27286)(),
            (0, $59117f4d8bbc9888$export$110627fb35ef9205)(),
            (0, $e4c5b1ea1c0961d2$export$d8b6ff28805e84e9)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$74ddc1df3e16fc55$export$a4161f418919b5aa.subscribe(()=>{
    let e = $74ddc1df3e16fc55$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $74ddc1df3e16fc55$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $74ddc1df3e16fc55$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});


function $846a8143411cd954$export$bb0ae4a42bcd9e0(r, e, n = ()=>({
        containers: []
    })) {
    let f = (0, $b8c696774ae56105$export$6ccbb43953eebf8)((0, $74ddc1df3e16fc55$export$a4161f418919b5aa)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        if (!(!e || !r)) return (0, $74ddc1df3e16fc55$export$a4161f418919b5aa).dispatch("PUSH", e, n), ()=>(0, $74ddc1df3e16fc55$export$a4161f418919b5aa).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}



function $0723ad8e5f506aa0$export$e47ba1b900da5d3b(e, c, n = ()=>[
        document.body
    ]) {
    let r = (0, $08b6a5272e281a85$export$5f5dd115998e0b80)(e, "scroll-lock");
    (0, $846a8143411cd954$export$bb0ae4a42bcd9e0)(r, c, (t)=>{
        var o;
        return {
            containers: [
                ...(o = t.containers) != null ? o : [],
                n
            ]
        };
    });
}



var $l7WPE = parcelRequire("l7WPE");

function $a42f1d694a04d7ce$var$s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in $l7WPE ? ((o)=>o.useSyncExternalStore)($l7WPE)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function $a42f1d694a04d7ce$export$44ab2b9f2d09b0fa() {
    let r = $a42f1d694a04d7ce$var$s(), [e, n] = $l7WPE.useState((0, $4881b9345355c80e$export$a7b6bc01c63cdfc3).isHandoffComplete);
    return e && (0, $4881b9345355c80e$export$a7b6bc01c63cdfc3).isHandoffComplete === !1 && n(!1), $l7WPE.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), $l7WPE.useEffect(()=>(0, $4881b9345355c80e$export$a7b6bc01c63cdfc3).handoff(), []), r ? !1 : e;
}



var $l7WPE = parcelRequire("l7WPE");

let $0da5c6e87036e5c9$var$u = Symbol();
function $0da5c6e87036e5c9$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$0da5c6e87036e5c9$var$u]: n
    });
}
function $0da5c6e87036e5c9$export$f6a25a78204acc7e(...t) {
    let n = (0, $l7WPE.useRef)(t);
    (0, $l7WPE.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$0da5c6e87036e5c9$var$u])) ? void 0 : c;
}



var $l7WPE = parcelRequire("l7WPE");
"use client";
let $5376cec2aa696fce$var$e = (0, $l7WPE.createContext)(()=>{});
function $5376cec2aa696fce$export$4e99330e6f37bca2() {
    return (0, $l7WPE.useContext)($5376cec2aa696fce$var$e);
}
function $5376cec2aa696fce$export$dd2a80b78bebbe1d({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($5376cec2aa696fce$var$e.Provider, {
        value: t
    }, o);
}



var $l7WPE = parcelRequire("l7WPE");
let $6612489ddb1f013a$var$n = (0, $l7WPE.createContext)(null);
$6612489ddb1f013a$var$n.displayName = "OpenClosedContext";
var $6612489ddb1f013a$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($6612489ddb1f013a$export$7254cc27399e90bd || {});
function $6612489ddb1f013a$export$fc6fdf0ecf360e() {
    return (0, $l7WPE.useContext)($6612489ddb1f013a$var$n);
}
function $6612489ddb1f013a$export$2a0ed818b175f558({ value: o, children: t }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($6612489ddb1f013a$var$n.Provider, {
        value: o
    }, t);
}
function $6612489ddb1f013a$export$6748feed729c7cf3({ children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($6612489ddb1f013a$var$n.Provider, {
        value: null
    }, o);
}



var $l7WPE = parcelRequire("l7WPE");
let $ce31fc7abceb55fa$var$e = (0, $l7WPE.createContext)(!1);
function $ce31fc7abceb55fa$export$6ecd3efa4eebe261() {
    return (0, $l7WPE.useContext)($ce31fc7abceb55fa$var$e);
}
function $ce31fc7abceb55fa$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($ce31fc7abceb55fa$var$e.Provider, {
        value: o.force
    }, o.children);
}





var $l7WPE = parcelRequire("l7WPE");


var $l7WPE = parcelRequire("l7WPE");



var $l7WPE = parcelRequire("l7WPE");
let $3ffab61d59a88c3c$var$e = (0, $l7WPE.createContext)(void 0);
function $3ffab61d59a88c3c$export$c763bb7a184a0f11() {
    return (0, $l7WPE.useContext)($3ffab61d59a88c3c$var$e);
}
function $3ffab61d59a88c3c$export$a4d3bd77f4efe5ad({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($3ffab61d59a88c3c$var$e.Provider, {
        value: t
    }, o);
}



"use client";
let $892a159bd3b0d0c5$var$a = (0, $l7WPE.createContext)(null);
$892a159bd3b0d0c5$var$a.displayName = "DescriptionContext";
function $892a159bd3b0d0c5$var$f() {
    let r = (0, $l7WPE.useContext)($892a159bd3b0d0c5$var$a);
    if (r === null) {
        let e = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(e, $892a159bd3b0d0c5$var$f), e;
    }
    return r;
}
function $892a159bd3b0d0c5$export$899851af1363628() {
    var r, e;
    return (e = (r = (0, $l7WPE.useContext)($892a159bd3b0d0c5$var$a)) == null ? void 0 : r.value) != null ? e : void 0;
}
function $892a159bd3b0d0c5$export$babde88292020af7() {
    let [r, e] = (0, $l7WPE.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $l7WPE.useMemo)(()=>function(t) {
                let i = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((n)=>(e((s)=>[
                            ...s,
                            n
                        ]), ()=>e((s)=>{
                            let o = s.slice(), p = o.indexOf(n);
                            return p !== -1 && o.splice(p, 1), o;
                        }))), l = (0, $l7WPE.useMemo)(()=>({
                        register: i,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    i,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($892a159bd3b0d0c5$var$a.Provider, {
                    value: l
                }, t.children);
            }, [
            e
        ])
    ];
}
let $892a159bd3b0d0c5$var$S = "p";
function $892a159bd3b0d0c5$var$C(r, e) {
    let d = (0, $l7WPE.useId)(), t = (0, $3ffab61d59a88c3c$export$c763bb7a184a0f11)(), { id: i = `headlessui-description-${d}`, ...l } = r, n = $892a159bd3b0d0c5$var$f(), s = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(e);
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>n.register(i), [
        i,
        n.register
    ]);
    let o = t || !1, p = (0, $l7WPE.useMemo)(()=>({
            ...n.slot,
            disabled: o
        }), [
        n.slot,
        o
    ]), D = {
        ref: s,
        ...n.props,
        id: i
    };
    return (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)()({
        ourProps: D,
        theirProps: l,
        slot: p,
        defaultTag: $892a159bd3b0d0c5$var$S,
        name: n.name || "Description"
    });
}
let $892a159bd3b0d0c5$var$_ = (0, $30c8a076c23acfb8$export$e43f39796049410c)($892a159bd3b0d0c5$var$C), $892a159bd3b0d0c5$export$393edc798c47379d = Object.assign($892a159bd3b0d0c5$var$_, {});



var $l7WPE = parcelRequire("l7WPE");

var $l7WPE = parcelRequire("l7WPE");

function $03ea8ceff1795700$export$fd183955ff4b45d9() {
    let [e] = (0, $l7WPE.useState)((0, $270a47a058bb084f$export$12b26c28a05aa001));
    return (0, $l7WPE.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}





var $l7WPE = parcelRequire("l7WPE");

function $599b16300ed7bab7$export$80c2a3957bcb42ea() {
    let e = (0, $l7WPE.useRef)(!1);
    return (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}




var $l7WPE = parcelRequire("l7WPE");


function $266ee7a9e498b7a3$export$cd059ee7fd0e9f3d(t) {
    let r = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(t), e = (0, $l7WPE.useRef)(!1);
    (0, $l7WPE.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, $db35e04d4d40d6d6$export$a5ff0d6a738703ca)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}






var $l7WPE = parcelRequire("l7WPE");

var $038dc6ab11a58732$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($038dc6ab11a58732$export$cacd6541cfeeb6c1 || {});
function $038dc6ab11a58732$export$19b797546aece48f() {
    let e = (0, $l7WPE.useRef)(0);
    return (0, $a059a3f89f6d822b$export$ee579bb285b8d4aa)(!0, "keydown", (r)=>{
        r.key === "Tab" && (e.current = r.shiftKey ? 1 : 0);
    }, !0), e;
}



var $l7WPE = parcelRequire("l7WPE");

function $eddb1ce9d2e7610b$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $l7WPE.useRef)([]), r = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(u);
    (0, $l7WPE.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [a, l] of t.entries())if (e.current[a] !== l) {
            let n = r(t, o);
            return e.current = t, n;
        }
    }, [
        r,
        ...t
    ]);
}



function $20833cac172bf178$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}



let $39e79fcd6f3b626d$export$55abd4691b317664 = [];
(0, $20833cac172bf178$export$a6a2315df743a26b)(()=>{
    function e(t) {
        if (!(t.target instanceof HTMLElement) || t.target === document.body || $39e79fcd6f3b626d$export$55abd4691b317664[0] === t.target) return;
        let n = t.target;
        n = n.closest((0, $c87ce7fcb4198fc6$export$acea64b1933eb668)), $39e79fcd6f3b626d$export$55abd4691b317664.unshift(n != null ? n : t.target), $39e79fcd6f3b626d$export$55abd4691b317664 = $39e79fcd6f3b626d$export$55abd4691b317664.filter((o)=>o != null && o.isConnected), $39e79fcd6f3b626d$export$55abd4691b317664.splice(10);
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});






"use client";
function $d36df2d8dd892836$var$U(o) {
    if (!o) return new Set;
    if (typeof o == "function") return new Set(o());
    let e = new Set;
    for (let t of o.current)t.current instanceof HTMLElement && e.add(t.current);
    return e;
}
let $d36df2d8dd892836$var$Z = "div";
var $d36df2d8dd892836$export$a5e9a012c73650bd = ((n)=>(n[n.None = 0] = "None", n[n.InitialFocus = 1] = "InitialFocus", n[n.TabLock = 2] = "TabLock", n[n.FocusLock = 4] = "FocusLock", n[n.RestoreFocus = 8] = "RestoreFocus", n[n.AutoFocus = 16] = "AutoFocus", n))($d36df2d8dd892836$export$a5e9a012c73650bd || {});
function $d36df2d8dd892836$var$$(o, e) {
    let t = (0, $l7WPE.useRef)(null), r = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(t, e), { initialFocus: s, initialFocusFallback: a, containers: n, features: u = 15, ...f } = o;
    (0, $a42f1d694a04d7ce$export$44ab2b9f2d09b0fa)() || (u = 0);
    let l = (0, $6761cdc5f43c39c6$export$dd9fbcea3de0ae36)(t);
    $d36df2d8dd892836$var$ee(u, {
        ownerDocument: l
    });
    let i = $d36df2d8dd892836$var$te(u, {
        ownerDocument: l,
        container: t,
        initialFocus: s,
        initialFocusFallback: a
    });
    $d36df2d8dd892836$var$re(u, {
        ownerDocument: l,
        container: t,
        containers: n,
        previousActiveElement: i
    });
    let R = (0, $038dc6ab11a58732$export$19b797546aece48f)(), g = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((c)=>{
        let m = t.current;
        if (!m) return;
        ((G)=>G())(()=>{
            (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(R.current, {
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    (0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(m, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).First, {
                        skipElements: [
                            c.relatedTarget,
                            a
                        ]
                    });
                },
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    (0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(m, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).Last, {
                        skipElements: [
                            c.relatedTarget,
                            a
                        ]
                    });
                }
            });
        });
    }), v = (0, $08b6a5272e281a85$export$5f5dd115998e0b80)(!!(u & 2), "focus-trap#tab-lock"), N = (0, $03ea8ceff1795700$export$fd183955ff4b45d9)(), F = (0, $l7WPE.useRef)(!1), k = {
        ref: r,
        onKeyDown (c) {
            c.key == "Tab" && (F.current = !0, N.requestAnimationFrame(()=>{
                F.current = !1;
            }));
        },
        onBlur (c) {
            if (!(u & 4)) return;
            let m = $d36df2d8dd892836$var$U(n);
            t.current instanceof HTMLElement && m.add(t.current);
            let d = c.relatedTarget;
            d instanceof HTMLElement && d.dataset.headlessuiFocusGuard !== "true" && ($d36df2d8dd892836$var$I(m, d) || (F.current ? (0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(t.current, (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(R.current, {
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $c87ce7fcb4198fc6$export$807a7eae502106e7).Next,
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $c87ce7fcb4198fc6$export$807a7eae502106e7).Previous
            }) | (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).WrapAround, {
                relativeTo: c.target
            }) : c.target instanceof HTMLElement && (0, $c87ce7fcb4198fc6$export$5fed9cc43865dc7e)(c.target)));
        }
    }, B = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).Fragment, null, v && (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $51071f2ec6b67d06$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: g,
        features: (0, $51071f2ec6b67d06$export$4e7f8864c6a16d8a).Focusable
    }), B({
        ourProps: k,
        theirProps: f,
        defaultTag: $d36df2d8dd892836$var$Z,
        name: "FocusTrap"
    }), v && (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $51071f2ec6b67d06$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: g,
        features: (0, $51071f2ec6b67d06$export$4e7f8864c6a16d8a).Focusable
    }));
}
let $d36df2d8dd892836$var$D = (0, $30c8a076c23acfb8$export$e43f39796049410c)($d36df2d8dd892836$var$$), $d36df2d8dd892836$export$34eba2437817a67b = Object.assign($d36df2d8dd892836$var$D, {
    features: $d36df2d8dd892836$export$a5e9a012c73650bd
});
function $d36df2d8dd892836$var$w(o = !0) {
    let e = (0, $l7WPE.useRef)((0, $39e79fcd6f3b626d$export$55abd4691b317664).slice());
    return (0, $eddb1ce9d2e7610b$export$3c773aa2b84f29e0)(([t], [r])=>{
        r === !0 && t === !1 && (0, $db35e04d4d40d6d6$export$a5ff0d6a738703ca)(()=>{
            e.current.splice(0);
        }), r === !1 && t === !0 && (e.current = (0, $39e79fcd6f3b626d$export$55abd4691b317664).slice());
    }, [
        o,
        (0, $39e79fcd6f3b626d$export$55abd4691b317664),
        e
    ]), (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        var t;
        return (t = e.current.find((r)=>r != null && r.isConnected)) != null ? t : null;
    });
}
function $d36df2d8dd892836$var$ee(o, { ownerDocument: e }) {
    let t = !!(o & 8), r = $d36df2d8dd892836$var$w(t);
    (0, $eddb1ce9d2e7610b$export$3c773aa2b84f29e0)(()=>{
        t || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && (0, $c87ce7fcb4198fc6$export$5fed9cc43865dc7e)(r());
    }, [
        t
    ]), (0, $266ee7a9e498b7a3$export$cd059ee7fd0e9f3d)(()=>{
        t && (0, $c87ce7fcb4198fc6$export$5fed9cc43865dc7e)(r());
    });
}
function $d36df2d8dd892836$var$te(o, { ownerDocument: e, container: t, initialFocus: r, initialFocusFallback: s }) {
    let a = (0, $l7WPE.useRef)(null), n = (0, $08b6a5272e281a85$export$5f5dd115998e0b80)(!!(o & 1), "focus-trap#initial-focus"), u = (0, $599b16300ed7bab7$export$80c2a3957bcb42ea)();
    return (0, $eddb1ce9d2e7610b$export$3c773aa2b84f29e0)(()=>{
        if (o === 0) return;
        if (!n) {
            s != null && s.current && (0, $c87ce7fcb4198fc6$export$5fed9cc43865dc7e)(s.current);
            return;
        }
        let f = t.current;
        f && (0, $db35e04d4d40d6d6$export$a5ff0d6a738703ca)(()=>{
            if (!u.current) return;
            let l = e == null ? void 0 : e.activeElement;
            if (r != null && r.current) {
                if ((r == null ? void 0 : r.current) === l) {
                    a.current = l;
                    return;
                }
            } else if (f.contains(l)) {
                a.current = l;
                return;
            }
            if (r != null && r.current) (0, $c87ce7fcb4198fc6$export$5fed9cc43865dc7e)(r.current);
            else {
                if (o & 16) {
                    if ((0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(f, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).First | (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).AutoFocus) !== (0, $c87ce7fcb4198fc6$export$abf286375dfa6dbd).Error) return;
                } else if ((0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(f, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).First) !== (0, $c87ce7fcb4198fc6$export$abf286375dfa6dbd).Error) return;
                if (s != null && s.current && ((0, $c87ce7fcb4198fc6$export$5fed9cc43865dc7e)(s.current), (e == null ? void 0 : e.activeElement) === s.current)) return;
                console.warn("There are no focusable elements inside the <FocusTrap />");
            }
            a.current = e == null ? void 0 : e.activeElement;
        });
    }, [
        s,
        n,
        o
    ]), a;
}
function $d36df2d8dd892836$var$re(o, { ownerDocument: e, container: t, containers: r, previousActiveElement: s }) {
    let a = (0, $599b16300ed7bab7$export$80c2a3957bcb42ea)(), n = !!(o & 4);
    (0, $7730fda268ff0e1a$export$7080b3e976bc91ab)(e == null ? void 0 : e.defaultView, "focus", (u)=>{
        if (!n || !a.current) return;
        let f = $d36df2d8dd892836$var$U(r);
        t.current instanceof HTMLElement && f.add(t.current);
        let l = s.current;
        if (!l) return;
        let i = u.target;
        i && i instanceof HTMLElement ? $d36df2d8dd892836$var$I(f, i) ? (s.current = i, (0, $c87ce7fcb4198fc6$export$5fed9cc43865dc7e)(i)) : (u.preventDefault(), u.stopPropagation(), (0, $c87ce7fcb4198fc6$export$5fed9cc43865dc7e)(l)) : (0, $c87ce7fcb4198fc6$export$5fed9cc43865dc7e)(s.current);
    }, !0);
}
function $d36df2d8dd892836$var$I(o, e) {
    for (let t of o)if (t.contains(e)) return !0;
    return !1;
}



var $l7WPE = parcelRequire("l7WPE");










"use client";
function $b96399f10495e180$var$N(u) {
    let r = (0, $ce31fc7abceb55fa$export$6ecd3efa4eebe261)(), n = (0, $l7WPE.useContext)($b96399f10495e180$var$v), e = (0, $6761cdc5f43c39c6$export$dd9fbcea3de0ae36)(u), [o, l] = (0, $l7WPE.useState)(()=>{
        var t;
        if (!r && n !== null) return (t = n.current) != null ? t : null;
        if ((0, $4881b9345355c80e$export$a7b6bc01c63cdfc3).isServer) return null;
        let p = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (p) return p;
        if (e === null) return null;
        let a = e.createElement("div");
        return a.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(a);
    });
    return (0, $l7WPE.useEffect)(()=>{
        o !== null && (e != null && e.body.contains(o) || e == null || e.body.appendChild(o));
    }, [
        o,
        e
    ]), (0, $l7WPE.useEffect)(()=>{
        r || n !== null && l(n.current);
    }, [
        n,
        l,
        r
    ]), o;
}
let $b96399f10495e180$var$M = (0, $l7WPE.Fragment), $b96399f10495e180$var$S = (0, $30c8a076c23acfb8$export$e43f39796049410c)(function(r, n) {
    let e = r, o = (0, $l7WPE.useRef)(null), l = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)((0, $0da5c6e87036e5c9$export$7029785b750eb74)((i)=>{
        o.current = i;
    }), n), p = (0, $6761cdc5f43c39c6$export$dd9fbcea3de0ae36)(o), a = $b96399f10495e180$var$N(o), [t] = (0, $l7WPE.useState)(()=>{
        var i;
        return (0, $4881b9345355c80e$export$a7b6bc01c63cdfc3).isServer ? null : (i = p == null ? void 0 : p.createElement("div")) != null ? i : null;
    }), s = (0, $l7WPE.useContext)($b96399f10495e180$var$y), b = (0, $a42f1d694a04d7ce$export$44ab2b9f2d09b0fa)();
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        !a || !t || a.contains(t) || (t.setAttribute("data-headlessui-portal", ""), a.appendChild(t));
    }, [
        a,
        t
    ]), (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        if (t && s) return s.register(t);
    }, [
        s,
        t
    ]), (0, $266ee7a9e498b7a3$export$cd059ee7fd0e9f3d)(()=>{
        var i;
        !a || !t || (t instanceof Node && a.contains(t) && a.removeChild(t), a.childNodes.length <= 0 && ((i = a.parentElement) == null || i.removeChild(a)));
    });
    let H = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return b ? !a || !t ? null : (0, $b1e9cc0cc5ead376$exports.createPortal)(H({
        ourProps: {
            ref: l
        },
        theirProps: e,
        slot: {},
        defaultTag: $b96399f10495e180$var$M,
        name: "Portal"
    }), t) : null;
});
function $b96399f10495e180$var$j(u, r) {
    let n = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(r), { enabled: e = !0, ...o } = u, l = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return e ? (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($b96399f10495e180$var$S, {
        ...o,
        ref: n
    }) : l({
        ourProps: {
            ref: n
        },
        theirProps: o,
        slot: {},
        defaultTag: $b96399f10495e180$var$M,
        name: "Portal"
    });
}
let $b96399f10495e180$var$W = (0, $l7WPE.Fragment), $b96399f10495e180$var$v = (0, $l7WPE.createContext)(null);
function $b96399f10495e180$var$I(u, r) {
    let { target: n, ...e } = u, l = {
        ref: (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(r)
    }, p = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($b96399f10495e180$var$v.Provider, {
        value: n
    }, p({
        ourProps: l,
        theirProps: e,
        defaultTag: $b96399f10495e180$var$W,
        name: "Popover.Group"
    }));
}
let $b96399f10495e180$var$y = (0, $l7WPE.createContext)(null);
function $b96399f10495e180$export$26b8c35244a70b37() {
    let u = (0, $l7WPE.useContext)($b96399f10495e180$var$y), r = (0, $l7WPE.useRef)([]), n = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((l)=>(r.current.push(l), u && u.register(l), ()=>e(l))), e = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((l)=>{
        let p = r.current.indexOf(l);
        p !== -1 && r.current.splice(p, 1), u && u.unregister(l);
    }), o = (0, $l7WPE.useMemo)(()=>({
            register: n,
            unregister: e,
            portals: r
        }), [
        n,
        e,
        r
    ]);
    return [
        r,
        (0, $l7WPE.useMemo)(()=>function({ children: p }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($b96399f10495e180$var$y.Provider, {
                    value: o
                }, p);
            }, [
            o
        ])
    ];
}
let $b96399f10495e180$var$J = (0, $30c8a076c23acfb8$export$e43f39796049410c)($b96399f10495e180$var$j), $b96399f10495e180$export$84c667e5e4409848 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($b96399f10495e180$var$I), $b96399f10495e180$export$602eac185826482c = Object.assign($b96399f10495e180$var$J, {
    Group: $b96399f10495e180$export$84c667e5e4409848
});



var $l7WPE = parcelRequire("l7WPE");








var $l7WPE = parcelRequire("l7WPE");



var $l7WPE = parcelRequire("l7WPE");
function $3c4de1abe83a87aa$export$2879604e6aec4ab(u = 0) {
    let [t, l] = (0, $l7WPE.useState)(u), g = (0, $l7WPE.useCallback)((e)=>l(e), [
        t
    ]), s = (0, $l7WPE.useCallback)((e)=>l((a)=>a | e), [
        t
    ]), m = (0, $l7WPE.useCallback)((e)=>(t & e) === e, [
        t
    ]), n = (0, $l7WPE.useCallback)((e)=>l((a)=>a & ~e), [
        l
    ]), F = (0, $l7WPE.useCallback)((e)=>l((a)=>a ^ e), [
        l
    ]);
    return {
        flags: t,
        setFlag: g,
        addFlag: s,
        hasFlag: m,
        removeFlag: n,
        toggleFlag: F
    };
}



var $54aaf6e950946986$exports = {};
// shim for using process in browser
var $54aaf6e950946986$var$process = $54aaf6e950946986$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $54aaf6e950946986$var$cachedSetTimeout;
var $54aaf6e950946986$var$cachedClearTimeout;
function $54aaf6e950946986$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $54aaf6e950946986$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $54aaf6e950946986$var$cachedSetTimeout = setTimeout;
        else $54aaf6e950946986$var$cachedSetTimeout = $54aaf6e950946986$var$defaultSetTimout;
    } catch (e) {
        $54aaf6e950946986$var$cachedSetTimeout = $54aaf6e950946986$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $54aaf6e950946986$var$cachedClearTimeout = clearTimeout;
        else $54aaf6e950946986$var$cachedClearTimeout = $54aaf6e950946986$var$defaultClearTimeout;
    } catch (e) {
        $54aaf6e950946986$var$cachedClearTimeout = $54aaf6e950946986$var$defaultClearTimeout;
    }
})();
function $54aaf6e950946986$var$runTimeout(fun) {
    if ($54aaf6e950946986$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($54aaf6e950946986$var$cachedSetTimeout === $54aaf6e950946986$var$defaultSetTimout || !$54aaf6e950946986$var$cachedSetTimeout) && setTimeout) {
        $54aaf6e950946986$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $54aaf6e950946986$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $54aaf6e950946986$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $54aaf6e950946986$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $54aaf6e950946986$var$runClearTimeout(marker) {
    if ($54aaf6e950946986$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($54aaf6e950946986$var$cachedClearTimeout === $54aaf6e950946986$var$defaultClearTimeout || !$54aaf6e950946986$var$cachedClearTimeout) && clearTimeout) {
        $54aaf6e950946986$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $54aaf6e950946986$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $54aaf6e950946986$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $54aaf6e950946986$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $54aaf6e950946986$var$queue = [];
var $54aaf6e950946986$var$draining = false;
var $54aaf6e950946986$var$currentQueue;
var $54aaf6e950946986$var$queueIndex = -1;
function $54aaf6e950946986$var$cleanUpNextTick() {
    if (!$54aaf6e950946986$var$draining || !$54aaf6e950946986$var$currentQueue) return;
    $54aaf6e950946986$var$draining = false;
    if ($54aaf6e950946986$var$currentQueue.length) $54aaf6e950946986$var$queue = $54aaf6e950946986$var$currentQueue.concat($54aaf6e950946986$var$queue);
    else $54aaf6e950946986$var$queueIndex = -1;
    if ($54aaf6e950946986$var$queue.length) $54aaf6e950946986$var$drainQueue();
}
function $54aaf6e950946986$var$drainQueue() {
    if ($54aaf6e950946986$var$draining) return;
    var timeout = $54aaf6e950946986$var$runTimeout($54aaf6e950946986$var$cleanUpNextTick);
    $54aaf6e950946986$var$draining = true;
    var len = $54aaf6e950946986$var$queue.length;
    while(len){
        $54aaf6e950946986$var$currentQueue = $54aaf6e950946986$var$queue;
        $54aaf6e950946986$var$queue = [];
        while(++$54aaf6e950946986$var$queueIndex < len)if ($54aaf6e950946986$var$currentQueue) $54aaf6e950946986$var$currentQueue[$54aaf6e950946986$var$queueIndex].run();
        $54aaf6e950946986$var$queueIndex = -1;
        len = $54aaf6e950946986$var$queue.length;
    }
    $54aaf6e950946986$var$currentQueue = null;
    $54aaf6e950946986$var$draining = false;
    $54aaf6e950946986$var$runClearTimeout(timeout);
}
$54aaf6e950946986$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $54aaf6e950946986$var$queue.push(new $54aaf6e950946986$var$Item(fun, args));
    if ($54aaf6e950946986$var$queue.length === 1 && !$54aaf6e950946986$var$draining) $54aaf6e950946986$var$runTimeout($54aaf6e950946986$var$drainQueue);
};
// v8 likes predictible objects
function $54aaf6e950946986$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$54aaf6e950946986$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$54aaf6e950946986$var$process.title = 'browser';
$54aaf6e950946986$var$process.browser = true;
$54aaf6e950946986$var$process.env = {};
$54aaf6e950946986$var$process.argv = [];
$54aaf6e950946986$var$process.version = ''; // empty string to avoid regexp issues
$54aaf6e950946986$var$process.versions = {};
function $54aaf6e950946986$var$noop() {}
$54aaf6e950946986$var$process.on = $54aaf6e950946986$var$noop;
$54aaf6e950946986$var$process.addListener = $54aaf6e950946986$var$noop;
$54aaf6e950946986$var$process.once = $54aaf6e950946986$var$noop;
$54aaf6e950946986$var$process.off = $54aaf6e950946986$var$noop;
$54aaf6e950946986$var$process.removeListener = $54aaf6e950946986$var$noop;
$54aaf6e950946986$var$process.removeAllListeners = $54aaf6e950946986$var$noop;
$54aaf6e950946986$var$process.emit = $54aaf6e950946986$var$noop;
$54aaf6e950946986$var$process.prependListener = $54aaf6e950946986$var$noop;
$54aaf6e950946986$var$process.prependOnceListener = $54aaf6e950946986$var$noop;
$54aaf6e950946986$var$process.listeners = function(name) {
    return [];
};
$54aaf6e950946986$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$54aaf6e950946986$var$process.cwd = function() {
    return '/';
};
$54aaf6e950946986$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$54aaf6e950946986$var$process.umask = function() {
    return 0;
};


var $e7ac80ae06735674$var$T, $e7ac80ae06735674$var$b;
typeof $54aaf6e950946986$exports != "undefined" && typeof globalThis != "undefined" && typeof Element != "undefined" && (($e7ac80ae06735674$var$T = $54aaf6e950946986$exports == null ? void 0 : $54aaf6e950946986$exports.env) == null ? void 0 : $e7ac80ae06735674$var$T["NODE_ENV"]) === "test" && typeof (($e7ac80ae06735674$var$b = Element == null ? void 0 : Element.prototype) == null ? void 0 : $e7ac80ae06735674$var$b.getAnimations) == "undefined" && (Element.prototype.getAnimations = function() {
    return console.warn([
        "Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.",
        "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.",
        "",
        "Example usage:",
        "```js",
        "import { mockAnimationsApi } from 'jsdom-testing-mocks'",
        "mockAnimationsApi()",
        "```"
    ].join(`
`)), [];
});
var $e7ac80ae06735674$var$L = ((r)=>(r[r.None = 0] = "None", r[r.Closed = 1] = "Closed", r[r.Enter = 2] = "Enter", r[r.Leave = 4] = "Leave", r))($e7ac80ae06735674$var$L || {});
function $e7ac80ae06735674$export$c291d481c40a2fc3(t) {
    let n = {};
    for(let e in t)t[e] === !0 && (n[`data-${e}`] = "");
    return n;
}
function $e7ac80ae06735674$export$7b286972b8d8ccbf(t, n, e, i) {
    let [r, o] = (0, $l7WPE.useState)(e), { hasFlag: s, addFlag: a, removeFlag: l } = (0, $3c4de1abe83a87aa$export$2879604e6aec4ab)(t && r ? 3 : 0), u = (0, $l7WPE.useRef)(!1), f = (0, $l7WPE.useRef)(!1), E = (0, $03ea8ceff1795700$export$fd183955ff4b45d9)();
    return (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        var d;
        if (t) {
            if (e && o(!0), !n) {
                e && a(3);
                return;
            }
            return (d = i == null ? void 0 : i.start) == null || d.call(i, e), $e7ac80ae06735674$var$C(n, {
                inFlight: u,
                prepare () {
                    f.current ? f.current = !1 : f.current = u.current, u.current = !0, !f.current && (e ? (a(3), l(4)) : (a(4), l(2)));
                },
                run () {
                    f.current ? e ? (l(3), a(4)) : (l(4), a(3)) : e ? l(1) : a(1);
                },
                done () {
                    var p;
                    f.current && typeof n.getAnimations == "function" && n.getAnimations().length > 0 || (u.current = !1, l(7), e || o(!1), (p = i == null ? void 0 : i.end) == null || p.call(i, e));
                }
            });
        }
    }, [
        t,
        e,
        n,
        E
    ]), t ? [
        r,
        {
            closed: s(1),
            enter: s(2),
            leave: s(4),
            transition: s(2) || s(4)
        }
    ] : [
        e,
        {
            closed: void 0,
            enter: void 0,
            leave: void 0,
            transition: void 0
        }
    ];
}
function $e7ac80ae06735674$var$C(t, { prepare: n, run: e, done: i, inFlight: r }) {
    let o = (0, $270a47a058bb084f$export$12b26c28a05aa001)();
    return $e7ac80ae06735674$var$j(t, {
        prepare: n,
        inFlight: r
    }), o.nextFrame(()=>{
        e(), o.requestAnimationFrame(()=>{
            o.add($e7ac80ae06735674$var$M(t, i));
        });
    }), o.dispose;
}
function $e7ac80ae06735674$var$M(t, n) {
    var o, s;
    let e = (0, $270a47a058bb084f$export$12b26c28a05aa001)();
    if (!t) return e.dispose;
    let i = !1;
    e.add(()=>{
        i = !0;
    });
    let r = (s = (o = t.getAnimations) == null ? void 0 : o.call(t).filter((a)=>a instanceof CSSTransition)) != null ? s : [];
    return r.length === 0 ? (n(), e.dispose) : (Promise.allSettled(r.map((a)=>a.finished)).then(()=>{
        i || n();
    }), e.dispose);
}
function $e7ac80ae06735674$var$j(t, { inFlight: n, prepare: e }) {
    if (n != null && n.current) {
        e();
        return;
    }
    let i = t.style.transition;
    t.style.transition = "none", e(), t.offsetHeight, t.style.transition = i;
}






"use client";
function $c80c1e31473e381f$var$ue(e) {
    var t;
    return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || ((t = e.as) != null ? t : $c80c1e31473e381f$var$de) !== (0, $l7WPE.Fragment) || (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).Children.count(e.children) === 1;
}
let $c80c1e31473e381f$var$w = (0, $l7WPE.createContext)(null);
$c80c1e31473e381f$var$w.displayName = "TransitionContext";
var $c80c1e31473e381f$var$_e = ((n)=>(n.Visible = "visible", n.Hidden = "hidden", n))($c80c1e31473e381f$var$_e || {});
function $c80c1e31473e381f$var$De() {
    let e = (0, $l7WPE.useContext)($c80c1e31473e381f$var$w);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
function $c80c1e31473e381f$var$He() {
    let e = (0, $l7WPE.useContext)($c80c1e31473e381f$var$M);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
let $c80c1e31473e381f$var$M = (0, $l7WPE.createContext)(null);
$c80c1e31473e381f$var$M.displayName = "NestingContext";
function $c80c1e31473e381f$var$U(e) {
    return "children" in e ? $c80c1e31473e381f$var$U(e.children) : e.current.filter(({ el: t })=>t.current !== null).filter(({ state: t })=>t === "visible").length > 0;
}
function $c80c1e31473e381f$var$Te(e, t) {
    let n = (0, $7395d73fc6971264$export$86c4283a11f23f95)(e), l = (0, $l7WPE.useRef)([]), S = (0, $599b16300ed7bab7$export$80c2a3957bcb42ea)(), R = (0, $03ea8ceff1795700$export$fd183955ff4b45d9)(), d = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((o, i = (0, $30c8a076c23acfb8$export$80c0a745e59f7989).Hidden)=>{
        let a = l.current.findIndex(({ el: s })=>s === o);
        a !== -1 && ((0, $f191f2ad0684b169$export$4659b591c19bdf3d)(i, {
            [(0, $30c8a076c23acfb8$export$80c0a745e59f7989).Unmount] () {
                l.current.splice(a, 1);
            },
            [(0, $30c8a076c23acfb8$export$80c0a745e59f7989).Hidden] () {
                l.current[a].state = "hidden";
            }
        }), R.microTask(()=>{
            var s;
            !$c80c1e31473e381f$var$U(l) && S.current && ((s = n.current) == null || s.call(n));
        }));
    }), y = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((o)=>{
        let i = l.current.find(({ el: a })=>a === o);
        return i ? i.state !== "visible" && (i.state = "visible") : l.current.push({
            el: o,
            state: "visible"
        }), ()=>d(o, (0, $30c8a076c23acfb8$export$80c0a745e59f7989).Unmount);
    }), p = (0, $l7WPE.useRef)([]), c = (0, $l7WPE.useRef)(Promise.resolve()), C = (0, $l7WPE.useRef)({
        enter: [],
        leave: []
    }), h = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((o, i, a)=>{
        p.current.splice(0), t && (t.chains.current[i] = t.chains.current[i].filter(([s])=>s !== o)), t == null || t.chains.current[i].push([
            o,
            new Promise((s)=>{
                p.current.push(s);
            })
        ]), t == null || t.chains.current[i].push([
            o,
            new Promise((s)=>{
                Promise.all(C.current[i].map(([r, f])=>f)).then(()=>s());
            })
        ]), i === "enter" ? c.current = c.current.then(()=>t == null ? void 0 : t.wait.current).then(()=>a(i)) : a(i);
    }), g = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((o, i, a)=>{
        Promise.all(C.current[i].splice(0).map(([s, r])=>r)).then(()=>{
            var s;
            (s = p.current.shift()) == null || s();
        }).then(()=>a(i));
    });
    return (0, $l7WPE.useMemo)(()=>({
            children: l,
            register: y,
            unregister: d,
            onStart: h,
            onStop: g,
            wait: c,
            chains: C
        }), [
        y,
        d,
        l,
        h,
        g,
        C,
        c
    ]);
}
let $c80c1e31473e381f$var$de = (0, $l7WPE.Fragment), $c80c1e31473e381f$var$fe = (0, $30c8a076c23acfb8$export$ba0ea3f20e7bf777).RenderStrategy;
function $c80c1e31473e381f$var$Ae(e, t) {
    var ee, te;
    let { transition: n = !0, beforeEnter: l, afterEnter: S, beforeLeave: R, afterLeave: d, enter: y, enterFrom: p, enterTo: c, entered: C, leave: h, leaveFrom: g, leaveTo: o, ...i } = e, [a, s] = (0, $l7WPE.useState)(null), r = (0, $l7WPE.useRef)(null), f = $c80c1e31473e381f$var$ue(e), j = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(...f ? [
        r,
        t,
        s
    ] : t === null ? [] : [
        t
    ]), H = (ee = i.unmount) == null || ee ? (0, $30c8a076c23acfb8$export$80c0a745e59f7989).Unmount : (0, $30c8a076c23acfb8$export$80c0a745e59f7989).Hidden, { show: u, appear: z, initial: K } = $c80c1e31473e381f$var$De(), [v, G] = (0, $l7WPE.useState)(u ? "visible" : "hidden"), Q = $c80c1e31473e381f$var$He(), { register: A, unregister: I } = Q;
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>A(r), [
        A,
        r
    ]), (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        if (H === (0, $30c8a076c23acfb8$export$80c0a745e59f7989).Hidden && r.current) {
            if (u && v !== "visible") {
                G("visible");
                return;
            }
            return (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(v, {
                ["hidden"]: ()=>I(r),
                ["visible"]: ()=>A(r)
            });
        }
    }, [
        v,
        r,
        A,
        I,
        u,
        H
    ]);
    let B = (0, $a42f1d694a04d7ce$export$44ab2b9f2d09b0fa)();
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        if (f && B && v === "visible" && r.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        r,
        v,
        B,
        f
    ]);
    let ce = K && !z, Y = z && u && K, W = (0, $l7WPE.useRef)(!1), L = $c80c1e31473e381f$var$Te(()=>{
        W.current || (G("hidden"), I(r));
    }, Q), Z = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((k)=>{
        W.current = !0;
        let F = k ? "enter" : "leave";
        L.onStart(r, F, (_)=>{
            _ === "enter" ? l == null || l() : _ === "leave" && (R == null || R());
        });
    }), $ = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((k)=>{
        let F = k ? "enter" : "leave";
        W.current = !1, L.onStop(r, F, (_)=>{
            _ === "enter" ? S == null || S() : _ === "leave" && (d == null || d());
        }), F === "leave" && !$c80c1e31473e381f$var$U(L) && (G("hidden"), I(r));
    });
    (0, $l7WPE.useEffect)(()=>{
        f && n || (Z(u), $(u));
    }, [
        u,
        f,
        n
    ]);
    let pe = (()=>!(!n || !f || !B || ce))(), [, T] = (0, $e7ac80ae06735674$export$7b286972b8d8ccbf)(pe, a, u, {
        start: Z,
        end: $
    }), Ce = (0, $30c8a076c23acfb8$export$8e16b83750b44988)({
        ref: j,
        className: ((te = (0, $15d75602336686c5$export$ce4ab0c55987d1ff)(i.className, Y && y, Y && p, T.enter && y, T.enter && T.closed && p, T.enter && !T.closed && c, T.leave && h, T.leave && !T.closed && g, T.leave && T.closed && o, !T.transition && u && C)) == null ? void 0 : te.trim()) || void 0,
        ...(0, $e7ac80ae06735674$export$c291d481c40a2fc3)(T)
    }), N = 0;
    v === "visible" && (N |= (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open), v === "hidden" && (N |= (0, $6612489ddb1f013a$export$7254cc27399e90bd).Closed), T.enter && (N |= (0, $6612489ddb1f013a$export$7254cc27399e90bd).Opening), T.leave && (N |= (0, $6612489ddb1f013a$export$7254cc27399e90bd).Closing);
    let he = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($c80c1e31473e381f$var$M.Provider, {
        value: L
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $6612489ddb1f013a$export$2a0ed818b175f558), {
        value: N
    }, he({
        ourProps: Ce,
        theirProps: i,
        defaultTag: $c80c1e31473e381f$var$de,
        features: $c80c1e31473e381f$var$fe,
        visible: v === "visible",
        name: "Transition.Child"
    })));
}
function $c80c1e31473e381f$var$Ie(e, t) {
    let { show: n, appear: l = !1, unmount: S = !0, ...R } = e, d = (0, $l7WPE.useRef)(null), y = $c80c1e31473e381f$var$ue(e), p = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(...y ? [
        d,
        t
    ] : t === null ? [] : [
        t
    ]);
    (0, $a42f1d694a04d7ce$export$44ab2b9f2d09b0fa)();
    let c = (0, $6612489ddb1f013a$export$fc6fdf0ecf360e)();
    if (n === void 0 && c !== null && (n = (c & (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open) === (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open), n === void 0) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [C, h] = (0, $l7WPE.useState)(n ? "visible" : "hidden"), g = $c80c1e31473e381f$var$Te(()=>{
        n || h("hidden");
    }), [o, i] = (0, $l7WPE.useState)(!0), a = (0, $l7WPE.useRef)([
        n
    ]);
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        o !== !1 && a.current[a.current.length - 1] !== n && (a.current.push(n), i(!1));
    }, [
        a,
        n
    ]);
    let s = (0, $l7WPE.useMemo)(()=>({
            show: n,
            appear: l,
            initial: o
        }), [
        n,
        l,
        o
    ]);
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        n ? h("visible") : !$c80c1e31473e381f$var$U(g) && d.current !== null && h("hidden");
    }, [
        n,
        g
    ]);
    let r = {
        unmount: S
    }, f = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        var u;
        o && i(!1), (u = e.beforeEnter) == null || u.call(e);
    }), j = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        var u;
        o && i(!1), (u = e.beforeLeave) == null || u.call(e);
    }), H = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($c80c1e31473e381f$var$M.Provider, {
        value: g
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($c80c1e31473e381f$var$w.Provider, {
        value: s
    }, H({
        ourProps: {
            ...r,
            as: (0, $l7WPE.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($c80c1e31473e381f$var$me, {
                ref: p,
                ...r,
                ...R,
                beforeEnter: f,
                beforeLeave: j
            })
        },
        theirProps: {},
        defaultTag: (0, $l7WPE.Fragment),
        features: $c80c1e31473e381f$var$fe,
        visible: C === "visible",
        name: "Transition"
    })));
}
function $c80c1e31473e381f$var$Le(e, t) {
    let n = (0, $l7WPE.useContext)($c80c1e31473e381f$var$w) !== null, l = (0, $6612489ddb1f013a$export$fc6fdf0ecf360e)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).Fragment, null, !n && l ? (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($c80c1e31473e381f$var$X, {
        ref: t,
        ...e
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($c80c1e31473e381f$var$me, {
        ref: t,
        ...e
    }));
}
let $c80c1e31473e381f$var$X = (0, $30c8a076c23acfb8$export$e43f39796049410c)($c80c1e31473e381f$var$Ie), $c80c1e31473e381f$var$me = (0, $30c8a076c23acfb8$export$e43f39796049410c)($c80c1e31473e381f$var$Ae), $c80c1e31473e381f$export$b8acc0f6b9e8ca5d = (0, $30c8a076c23acfb8$export$e43f39796049410c)($c80c1e31473e381f$var$Le), $c80c1e31473e381f$export$be58926105124dd4 = Object.assign($c80c1e31473e381f$var$X, {
    Child: $c80c1e31473e381f$export$b8acc0f6b9e8ca5d,
    Root: $c80c1e31473e381f$var$X
});


"use client";
var $abb936996b9e17de$var$Oe = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($abb936996b9e17de$var$Oe || {}), $abb936996b9e17de$var$he = ((t)=>(t[t.SetTitleId = 0] = "SetTitleId", t))($abb936996b9e17de$var$he || {});
let $abb936996b9e17de$var$Se = {
    [0] (e, t) {
        return e.titleId === t.id ? e : {
            ...e,
            titleId: t.id
        };
    }
}, $abb936996b9e17de$var$k = (0, $l7WPE.createContext)(null);
$abb936996b9e17de$var$k.displayName = "DialogContext";
function $abb936996b9e17de$var$O(e) {
    let t = (0, $l7WPE.useContext)($abb936996b9e17de$var$k);
    if (t === null) {
        let o = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $abb936996b9e17de$var$O), o;
    }
    return t;
}
function $abb936996b9e17de$var$Ie(e, t) {
    return (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(t.type, $abb936996b9e17de$var$Se, e, t);
}
let $abb936996b9e17de$var$V = (0, $30c8a076c23acfb8$export$e43f39796049410c)(function(t, o) {
    let a = (0, $l7WPE.useId)(), { id: l = `headlessui-dialog-${a}`, open: i, onClose: p, initialFocus: d, role: s = "dialog", autoFocus: f = !0, __demoMode: u = !1, unmount: P = !1, ...h } = t, R = (0, $l7WPE.useRef)(!1);
    s = function() {
        return s === "dialog" || s === "alertdialog" ? s : (R.current || (R.current = !0, console.warn(`Invalid role [${s}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
    }();
    let c = (0, $6612489ddb1f013a$export$fc6fdf0ecf360e)();
    i === void 0 && c !== null && (i = (c & (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open) === (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open);
    let T = (0, $l7WPE.useRef)(null), S = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(T, o), F = (0, $6761cdc5f43c39c6$export$dd9fbcea3de0ae36)(T), g = i ? 0 : 1, [b, q] = (0, $l7WPE.useReducer)($abb936996b9e17de$var$Ie, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $l7WPE.createRef)()
    }), m = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>p(!1)), w = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((r)=>q({
            type: 0,
            id: r
        })), D = (0, $a42f1d694a04d7ce$export$44ab2b9f2d09b0fa)() ? g === 0 : !1, [z, Q] = (0, $b96399f10495e180$export$26b8c35244a70b37)(), Z = {
        get current () {
            var r;
            return (r = b.panelRef.current) != null ? r : T.current;
        }
    }, v = (0, $6ed700a93f481555$export$64db24433d7f4942)(), { resolveContainers: I } = (0, $6ed700a93f481555$export$445f2d1a3d9b1b9f)({
        mainTreeNode: v,
        portals: z,
        defaultContainers: [
            Z
        ]
    }), B = c !== null ? (c & (0, $6612489ddb1f013a$export$7254cc27399e90bd).Closing) === (0, $6612489ddb1f013a$export$7254cc27399e90bd).Closing : !1;
    (0, $23d1b4b809d79c7a$export$af489fa7e5283cc3)(u || B ? !1 : D, {
        allowed: (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
            var r, H;
            return [
                (H = (r = T.current) == null ? void 0 : r.closest("[data-headlessui-portal]")) != null ? H : null
            ];
        }),
        disallowed: (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
            var r;
            return [
                (r = v == null ? void 0 : v.closest("body > *:not(#headlessui-portal-root)")) != null ? r : null
            ];
        })
    }), (0, $70b1014c8d12aa21$export$71b2224f1ce5e08e)(D, I, (r)=>{
        r.preventDefault(), m();
    }), (0, $bb9433d1ef59b14d$export$3875fddb67014c13)(D, F == null ? void 0 : F.defaultView, (r)=>{
        r.preventDefault(), r.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), m();
    }), (0, $0723ad8e5f506aa0$export$e47ba1b900da5d3b)(u || B ? !1 : D, F, I), (0, $f05d8d85c884fb07$export$b41b9097915aa006)(D, T, m);
    let [ee, te] = (0, $892a159bd3b0d0c5$export$babde88292020af7)(), oe = (0, $l7WPE.useMemo)(()=>[
            {
                dialogState: g,
                close: m,
                setTitleId: w,
                unmount: P
            },
            b
        ], [
        g,
        b,
        m,
        w,
        P
    ]), U = (0, $l7WPE.useMemo)(()=>({
            open: g === 0
        }), [
        g
    ]), ne = {
        ref: S,
        id: l,
        role: s,
        tabIndex: -1,
        "aria-modal": u ? void 0 : g === 0 ? !0 : void 0,
        "aria-labelledby": b.titleId,
        "aria-describedby": ee,
        unmount: P
    }, re = !(0, $7ab3580046286dcb$export$2706b359107dd58d)(), y = (0, $d36df2d8dd892836$export$a5e9a012c73650bd).None;
    D && !u && (y |= (0, $d36df2d8dd892836$export$a5e9a012c73650bd).RestoreFocus, y |= (0, $d36df2d8dd892836$export$a5e9a012c73650bd).TabLock, f && (y |= (0, $d36df2d8dd892836$export$a5e9a012c73650bd).AutoFocus), re && (y |= (0, $d36df2d8dd892836$export$a5e9a012c73650bd).InitialFocus));
    let le = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $6612489ddb1f013a$export$6748feed729c7cf3), null, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $ce31fc7abceb55fa$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $b96399f10495e180$export$602eac185826482c), null, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($abb936996b9e17de$var$k.Provider, {
        value: oe
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $b96399f10495e180$export$84c667e5e4409848), {
        target: T
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $ce31fc7abceb55fa$export$8f2af6644e3a3c93), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(te, {
        slot: U
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(Q, null, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $d36df2d8dd892836$export$34eba2437817a67b), {
        initialFocus: d,
        initialFocusFallback: T,
        containers: I,
        features: y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $5376cec2aa696fce$export$dd2a80b78bebbe1d), {
        value: m
    }, le({
        ourProps: ne,
        theirProps: h,
        slot: U,
        defaultTag: $abb936996b9e17de$var$Me,
        features: $abb936996b9e17de$var$Ge,
        visible: g === 0,
        name: "Dialog"
    })))))))))));
}), $abb936996b9e17de$var$Me = "div", $abb936996b9e17de$var$Ge = (0, $30c8a076c23acfb8$export$ba0ea3f20e7bf777).RenderStrategy | (0, $30c8a076c23acfb8$export$ba0ea3f20e7bf777).Static;
function $abb936996b9e17de$var$ke(e, t) {
    let { transition: o = !1, open: a, ...l } = e, i = (0, $6612489ddb1f013a$export$fc6fdf0ecf360e)(), p = e.hasOwnProperty("open") || i !== null, d = e.hasOwnProperty("onClose");
    if (!p && !d) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!p) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!d) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (!i && typeof e.open != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${e.open}`);
    if (typeof e.onClose != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${e.onClose}`);
    return (a !== void 0 || o) && !l.static ? (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $6ed700a93f481555$export$61c2c570df73dc80), null, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $c80c1e31473e381f$export$be58926105124dd4), {
        show: a,
        transition: o,
        unmount: l.unmount
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($abb936996b9e17de$var$V, {
        ref: t,
        ...l
    }))) : (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $6ed700a93f481555$export$61c2c570df73dc80), null, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($abb936996b9e17de$var$V, {
        ref: t,
        open: a,
        ...l
    }));
}
let $abb936996b9e17de$var$we = "div";
function $abb936996b9e17de$var$Be(e, t) {
    let o = (0, $l7WPE.useId)(), { id: a = `headlessui-dialog-panel-${o}`, transition: l = !1, ...i } = e, [{ dialogState: p, unmount: d }, s] = $abb936996b9e17de$var$O("Dialog.Panel"), f = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(t, s.panelRef), u = (0, $l7WPE.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), P = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((S)=>{
        S.stopPropagation();
    }), h = {
        ref: f,
        id: a,
        onClick: P
    }, R = l ? (0, $c80c1e31473e381f$export$b8acc0f6b9e8ca5d) : (0, $l7WPE.Fragment), c = l ? {
        unmount: d
    } : {}, T = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(R, {
        ...c
    }, T({
        ourProps: h,
        theirProps: i,
        slot: u,
        defaultTag: $abb936996b9e17de$var$we,
        name: "Dialog.Panel"
    }));
}
let $abb936996b9e17de$var$Ue = "div";
function $abb936996b9e17de$var$He(e, t) {
    let { transition: o = !1, ...a } = e, [{ dialogState: l, unmount: i }] = $abb936996b9e17de$var$O("Dialog.Backdrop"), p = (0, $l7WPE.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), d = {
        ref: t,
        "aria-hidden": !0
    }, s = o ? (0, $c80c1e31473e381f$export$b8acc0f6b9e8ca5d) : (0, $l7WPE.Fragment), f = o ? {
        unmount: i
    } : {}, u = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(s, {
        ...f
    }, u({
        ourProps: d,
        theirProps: a,
        slot: p,
        defaultTag: $abb936996b9e17de$var$Ue,
        name: "Dialog.Backdrop"
    }));
}
let $abb936996b9e17de$var$Ne = "h2";
function $abb936996b9e17de$var$We(e, t) {
    let o = (0, $l7WPE.useId)(), { id: a = `headlessui-dialog-title-${o}`, ...l } = e, [{ dialogState: i, setTitleId: p }] = $abb936996b9e17de$var$O("Dialog.Title"), d = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(t);
    (0, $l7WPE.useEffect)(()=>(p(a), ()=>p(null)), [
        a,
        p
    ]);
    let s = (0, $l7WPE.useMemo)(()=>({
            open: i === 0
        }), [
        i
    ]), f = {
        ref: d,
        id: a
    };
    return (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)()({
        ourProps: f,
        theirProps: l,
        slot: s,
        defaultTag: $abb936996b9e17de$var$Ne,
        name: "Dialog.Title"
    });
}
let $abb936996b9e17de$var$$e = (0, $30c8a076c23acfb8$export$e43f39796049410c)($abb936996b9e17de$var$ke), $abb936996b9e17de$export$46512663428d955a = (0, $30c8a076c23acfb8$export$e43f39796049410c)($abb936996b9e17de$var$Be), $abb936996b9e17de$export$91fffd879a9415f4 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($abb936996b9e17de$var$He), $abb936996b9e17de$export$16f7638e4a34b909 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($abb936996b9e17de$var$We), $abb936996b9e17de$export$94e94c2ec2c954d5 = (0, $892a159bd3b0d0c5$export$393edc798c47379d), $abb936996b9e17de$export$3ddf2d174ce01153 = Object.assign($abb936996b9e17de$var$$e, {
    Panel: $abb936996b9e17de$export$46512663428d955a,
    Title: $abb936996b9e17de$export$16f7638e4a34b909,
    Description: (0, $892a159bd3b0d0c5$export$393edc798c47379d)
});



var $l7WPE = parcelRequire("l7WPE");
function $7b3ddec5fac855db$var$ArrowDownTrayIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $l7WPE.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $l7WPE.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $l7WPE.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
    }));
}
const $7b3ddec5fac855db$var$ForwardRef = /*#__PURE__*/ $l7WPE.forwardRef($7b3ddec5fac855db$var$ArrowDownTrayIcon);
var $7b3ddec5fac855db$export$2e2bcd8739ae039 = $7b3ddec5fac855db$var$ForwardRef;


var $l7WPE = parcelRequire("l7WPE");
function $47f940c358775017$var$Bars3Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $l7WPE.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $l7WPE.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $l7WPE.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    }));
}
const $47f940c358775017$var$ForwardRef = /*#__PURE__*/ $l7WPE.forwardRef($47f940c358775017$var$Bars3Icon);
var $47f940c358775017$export$2e2bcd8739ae039 = $47f940c358775017$var$ForwardRef;


var $l7WPE = parcelRequire("l7WPE");
function $2be506040d4d25f1$var$Cog8ToothIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $l7WPE.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $l7WPE.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $l7WPE.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z"
    }), /*#__PURE__*/ $l7WPE.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    }));
}
const $2be506040d4d25f1$var$ForwardRef = /*#__PURE__*/ $l7WPE.forwardRef($2be506040d4d25f1$var$Cog8ToothIcon);
var $2be506040d4d25f1$export$2e2bcd8739ae039 = $2be506040d4d25f1$var$ForwardRef;


var $l7WPE = parcelRequire("l7WPE");
function $f048fc0dd4eec75d$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $l7WPE.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $l7WPE.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $l7WPE.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18 18 6M6 6l12 12"
    }));
}
const $f048fc0dd4eec75d$var$ForwardRef = /*#__PURE__*/ $l7WPE.forwardRef($f048fc0dd4eec75d$var$XMarkIcon);
var $f048fc0dd4eec75d$export$2e2bcd8739ae039 = $f048fc0dd4eec75d$var$ForwardRef;


var $f3cc411f66696453$exports = {};
$f3cc411f66696453$exports = new URL("meteor.84d2c398.png", import.meta.url).toString();


const $63887d0911334be4$var$navigation = [
    {
        name: 'Screens',
        href: '/rooms/1'
    },
    {
        name: 'Costumes',
        href: '/costumes/0/0'
    },
    {
        name: 'Gfx',
        href: '/roomgfx/0'
    },
    {
        name: 'Scripts',
        href: '/scripts/1'
    },
    {
        name: 'Prepositions',
        href: '/preps'
    },
    {
        name: 'ROM map',
        href: '/rom-map'
    },
    {
        name: 'Settings',
        href: '/settings',
        sideBarOnly: true
    }
];
const $63887d0911334be4$var$Header = ()=>{
    const [mobileMenuOpen, setMobileMenuOpen] = (0, $l7WPE.useState)(false);
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("header", {
        className: "bg-slate-200 dark:bg-black",
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("nav", {
                className: "mx-auto flex max-w-7xl items-center justify-between px-3 py-2 md:px-4",
                "aria-label": "Global",
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                        className: "flex md:flex-1",
                        children: [
                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                className: "sr-only",
                                children: "SCUMM-NES"
                            }),
                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("img", {
                                className: "h-6 w-auto",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f3cc411f66696453$exports))),
                                alt: "Maniac Mansion meteor"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                        className: "flex md:hidden",
                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("button", {
                            type: "button",
                            className: "-m-2 inline-flex items-center justify-center rounded-md p-2 text-slate-500 hover:text-slate-800 hover:dark:text-slate-200",
                            onClick: ()=>setMobileMenuOpen(true),
                            children: [
                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Open main menu"
                                }),
                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $47f940c358775017$export$2e2bcd8739ae039), {
                                    strokeWidth: "2",
                                    className: "size-6",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                        className: "hidden md:flex md:gap-x-12",
                        children: $63887d0911334be4$var$navigation.filter(({ sideBarOnly: sideBarOnly })=>!sideBarOnly).map((item)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                                to: item.href,
                                className: "text-sm font-semibold leading-6 text-slate-700 dark:text-slate-300",
                                children: item.name
                            }, item.name))
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                        className: "hidden gap-x-4 md:flex md:flex-1 md:justify-end",
                        children: [
                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $ee9a5f11321bdeba$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $7b3ddec5fac855db$export$2e2bcd8739ae039), {
                                    strokeWidth: "1.5",
                                    className: "size-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                                to: "/settings",
                                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $2be506040d4d25f1$export$2e2bcd8739ae039), {
                                    strokeWidth: "1.5",
                                    className: "size-6 text-slate-500 transition hover:text-slate-800 hover:dark:text-slate-200"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $c80c1e31473e381f$export$be58926105124dd4), {
                show: mobileMenuOpen,
                as: (0, $l7WPE.Fragment),
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $abb936996b9e17de$export$3ddf2d174ce01153), {
                    as: "div",
                    className: "md:hidden",
                    onClose: setMobileMenuOpen,
                    children: [
                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $c80c1e31473e381f$export$b8acc0f6b9e8ca5d), {
                            as: (0, $l7WPE.Fragment),
                            enter: "transition-opacity ease-linear duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "transition-opacity ease-linear duration-300",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                                className: "fixed inset-0 z-10 bg-slate-100/75 dark:bg-slate-900/75"
                            })
                        }),
                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $c80c1e31473e381f$export$b8acc0f6b9e8ca5d), {
                            as: (0, $l7WPE.Fragment),
                            enter: "transition ease-in-out duration-300 transform",
                            enterFrom: "translate-x-full",
                            enterTo: "translate-x-0",
                            leave: "transition ease-in-out duration-300 transform",
                            leaveFrom: "translate-x-0",
                            leaveTo: "translate-x-full",
                            children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $abb936996b9e17de$export$46512663428d955a), {
                                className: "fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-slate-100 px-3 py-2 pl-6 sm:max-w-sm dark:bg-slate-900",
                                children: [
                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "SCUMM-NES"
                                            }),
                                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("img", {
                                                className: "h-6 w-auto",
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f3cc411f66696453$exports))),
                                                alt: "Maniac Mansion meteor"
                                            }),
                                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("button", {
                                                type: "button",
                                                className: "-m-2 rounded-md p-2 text-slate-500 hover:text-slate-800 hover:dark:text-slate-200",
                                                onClick: ()=>setMobileMenuOpen(false),
                                                children: [
                                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Close menu"
                                                    }),
                                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $f048fc0dd4eec75d$export$2e2bcd8739ae039), {
                                                        strokeWidth: "2",
                                                        className: "size-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                                        className: "mt-6 flow-root",
                                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                                            className: "-my-6 divide-y divide-slate-500/25",
                                            children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                                                className: "space-y-2 py-6",
                                                children: [
                                                    $63887d0911334be4$var$navigation.map((item)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                                                            to: item.href,
                                                            className: "-mx-3 block rounded px-3 py-2 text-base font-semibold leading-7 text-slate-700 hover:bg-slate-200 dark:text-slate-300 hover:dark:bg-slate-800",
                                                            onClick: ()=>setMobileMenuOpen(false),
                                                            children: item.name
                                                        }, item.name)),
                                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $ee9a5f11321bdeba$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                                            className: "-mx-3 block rounded px-3 py-2 text-base font-semibold leading-7 text-slate-700 hover:bg-slate-200 dark:text-slate-300 hover:dark:bg-slate-800",
                                                            children: "Download modified ROM"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $63887d0911334be4$export$2e2bcd8739ae039 = $63887d0911334be4$var$Header;


// eslint-disable-next-line no-undef

var $5a2a6178ded5025d$exports = {};
$5a2a6178ded5025d$exports = JSON.parse("{\"name\":\"scumm-nes\",\"version\":\"0.2.2\",\"description\":\"An app to explore and modify the game Maniac Mansion on NES.\",\"author\":\"edo999@gmail.com\",\"license\":\"BlueOak-1.0.0\",\"keywords\":[\"video game\",\"adventure game\",\"scumm\",\"hacks\"],\"homepage\":\"https://gmarty.github.io/scumm-nes\",\"repository\":\"git+https://github.com/gmarty/scumm-nes.git\",\"bugs\":{\"url\":\"https://github.com/gmarty/scumm-nes/issues\"},\"type\":\"module\",\"source\":\"src/index.html\",\"staticFiles\":{\"staticPath\":\"public\"},\"bin\":{\"scumm-nes\":\"index.js\"},\"engines\":{\"node\":\">=20\"},\"scripts\":{\"test\":\"node --test\",\"coverage\":\"node --experimental-test-coverage --test\",\"dev\":\"rm -rf dist .parcel-cache && parcel\",\"start\":\"rm -rf dist .parcel-cache && parcel\",\"build\":\"parcel build --public-url /scumm-nes\"},\"dependencies\":{\"@headlessui/react\":\"^2.2.0\",\"@heroicons/react\":\"^2.1.5\",\"clsx\":\"^2.1.1\",\"react\":\"^18.3.1\",\"react-dom\":\"^18.3.1\",\"react-dropzone\":\"^14.3.5\",\"react-error-boundary\":\"^4.1.2\",\"react-router-dom\":\"^6.28.0\"},\"devDependencies\":{\"@babel/plugin-proposal-private-property-in-object\":\"^7.21.11\",\"@tailwindcss/forms\":\"^0.5.9\",\"autoprefixer\":\"^10.4.20\",\"eslint\":\"^8.57.1\",\"eslint-config-react-app\":\"^7.0.1\",\"parcel\":\"^2.13.0\",\"parcel-reporter-static-files-copy\":\"^1.5.3\",\"postcss\":\"^8.4.49\",\"prettier\":\"^3.3.3\",\"prettier-plugin-tailwindcss\":\"^0.6.8\",\"process\":\"^0.11.10\",\"tailwindcss\":\"^3.4.14\"},\"optionalDependencies\":{\"@parcel/watcher-linux-x64-glibc\":\"^2.5.0\"},\"prettier\":{\"bracketSameLine\":true,\"singleQuote\":true,\"singleAttributePerLine\":true,\"plugins\":[\"prettier-plugin-tailwindcss\"]},\"browserslist\":\"last 2 Chrome versions, last 2 Firefox versions, Firefox ESR, last 1 Safari versions\"}");


const $f00d9190a900263b$var$navigation = [
    {
        name: 'Open an issue',
        href: (0, (/*@__PURE__*/$parcel$interopDefault($5a2a6178ded5025d$exports))).bugs.url,
        icon: (props)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("svg", {
                viewBox: "0 0 24 24",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                ...props,
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("path", {
                    d: "M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
                })
            })
    },
    {
        name: 'GitHub',
        href: 'https://github.com/gmarty/scumm-nes',
        icon: (props)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("path", {
                        d: "M16 22.0268V19.1568C16.0375 18.68 15.9731 18.2006 15.811 17.7506C15.6489 17.3006 15.3929 16.8902 15.06 16.5468C18.2 16.1968 21.5 15.0068 21.5 9.54679C21.4997 8.15062 20.9627 6.80799 20 5.79679C20.4558 4.5753 20.4236 3.22514 19.91 2.02679C19.91 2.02679 18.73 1.67679 16 3.50679C13.708 2.88561 11.292 2.88561 8.99999 3.50679C6.26999 1.67679 5.08999 2.02679 5.08999 2.02679C4.57636 3.22514 4.54413 4.5753 4.99999 5.79679C4.03011 6.81549 3.49251 8.17026 3.49999 9.57679C3.49999 14.9968 6.79998 16.1868 9.93998 16.5768C9.61098 16.9168 9.35725 17.3222 9.19529 17.7667C9.03334 18.2112 8.96679 18.6849 8.99999 19.1568V22.0268"
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("path", {
                        d: "M9 20.0267C6 20.9999 3.5 20.0267 2 17.0267"
                    })
                ]
            })
    },
    {
        name: 'Mastodon',
        href: 'https://mastodon.social/@edo999',
        icon: (props)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("svg", {
                viewBox: "0 0 24 24",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("path", {
                        d: "M7.99993 17C15.5 18 20.9999 17 20.9999 13L21 9C21.0003 3.5 17.0003 2.5 15 2.5H9C5.99989 2.5 2.93261 3.5 3.13687 9C3.21079 10.987 3.17311 13.3851 3.5 16C4.50007 24 14 21.5 15.5 21V19.5C15.5 19.5 7.5 21 7.99993 17Z"
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("path", {
                        d: "M7 13.5C7 13.5 7 10.7574 7 9C7 5.99998 12 6 12 9C12 10.1716 12 12 12 12"
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("path", {
                        d: "M17 13.5C17 13.5 17 10.7574 17 9C17 5.99998 12 6 12 9C12 10.1716 12 12 12 12"
                    })
                ]
            })
    }
];
const $f00d9190a900263b$var$Footer = ()=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("footer", {
        className: "bg-slate-200 dark:bg-black",
        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
            className: "mx-auto flex max-w-7xl items-center justify-between gap-x-2 px-3 py-2 md:px-4",
            children: [
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("p", {
                    className: "text-balance text-center font-geohumanist text-xs text-slate-500",
                    children: "\xa9 2024 SCUMM-NES"
                }),
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                    className: "flex gap-x-2 sm:gap-x-4 md:gap-x-6",
                    children: [
                        $f00d9190a900263b$var$navigation.map((item)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("a", {
                                href: item.href,
                                className: "fill-transparent stroke-slate-500 transition-all hover:stroke-slate-800 hover:dark:stroke-slate-200",
                                rel: "me",
                                children: [
                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                        className: "sr-only",
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)(item.icon, {
                                        className: "size-6",
                                        strokeWidth: "1.5",
                                        "aria-hidden": "true"
                                    })
                                ]
                            }, item.name)),
                        false
                    ]
                })
            ]
        })
    });
var $f00d9190a900263b$export$2e2bcd8739ae039 = $f00d9190a900263b$var$Footer;


const $29df82a1c17cc86b$var$Layout = ({ children: children })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
        className: "flex h-dvh flex-col",
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $63887d0911334be4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                className: "mx-auto flex w-full max-w-7xl grow items-stretch divide-x divide-slate-500 overflow-y-auto",
                children: children
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $f00d9190a900263b$export$2e2bcd8739ae039), {})
        ]
    });
var $29df82a1c17cc86b$export$2e2bcd8739ae039 = $29df82a1c17cc86b$var$Layout;




var $l7WPE = parcelRequire("l7WPE");

var $l7WPE = parcelRequire("l7WPE");
var $68945e6541b034d4$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68945e6541b034d4$var$ReactIs, $68945e6541b034d4$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$68945e6541b034d4$exports = (parcelRequire("4zRRV"))();


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $6cfdc3b10104f1f6$var$extendStatics = function(d, b) {
    $6cfdc3b10104f1f6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $6cfdc3b10104f1f6$var$extendStatics(d, b);
};
function $6cfdc3b10104f1f6$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $6cfdc3b10104f1f6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6cfdc3b10104f1f6$export$18ce0697a983be9b = function() {
    $6cfdc3b10104f1f6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6cfdc3b10104f1f6$export$18ce0697a983be9b.apply(this, arguments);
};
function $6cfdc3b10104f1f6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6cfdc3b10104f1f6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6cfdc3b10104f1f6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6cfdc3b10104f1f6$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $6cfdc3b10104f1f6$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $6cfdc3b10104f1f6$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $6cfdc3b10104f1f6$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $6cfdc3b10104f1f6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6cfdc3b10104f1f6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6cfdc3b10104f1f6$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $6cfdc3b10104f1f6$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $6cfdc3b10104f1f6$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $6cfdc3b10104f1f6$export$45d3717a4c69092e(o, m, p);
}
function $6cfdc3b10104f1f6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6cfdc3b10104f1f6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6cfdc3b10104f1f6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6cfdc3b10104f1f6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6cfdc3b10104f1f6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6cfdc3b10104f1f6$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $6cfdc3b10104f1f6$export$10c90e4f7922046c(v) {
    return this instanceof $6cfdc3b10104f1f6$export$10c90e4f7922046c ? (this.v = v, this) : new $6cfdc3b10104f1f6$export$10c90e4f7922046c(v);
}
function $6cfdc3b10104f1f6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6cfdc3b10104f1f6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6cfdc3b10104f1f6$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6cfdc3b10104f1f6$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $6cfdc3b10104f1f6$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6cfdc3b10104f1f6$export$19a8beecd37a4c45 === "function" ? $6cfdc3b10104f1f6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6cfdc3b10104f1f6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $6cfdc3b10104f1f6$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $6cfdc3b10104f1f6$var$ownKeys = function(o) {
    $6cfdc3b10104f1f6$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $6cfdc3b10104f1f6$var$ownKeys(o);
};
function $6cfdc3b10104f1f6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $6cfdc3b10104f1f6$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $6cfdc3b10104f1f6$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $6cfdc3b10104f1f6$var$__setModuleDefault(result, mod);
    return result;
}
function $6cfdc3b10104f1f6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6cfdc3b10104f1f6$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6cfdc3b10104f1f6$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $6cfdc3b10104f1f6$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $6cfdc3b10104f1f6$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $6cfdc3b10104f1f6$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $6cfdc3b10104f1f6$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $6cfdc3b10104f1f6$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $6cfdc3b10104f1f6$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $6cfdc3b10104f1f6$export$2e2bcd8739ae039 = {
    __extends: $6cfdc3b10104f1f6$export$a8ba968b8961cb8a,
    __assign: $6cfdc3b10104f1f6$export$18ce0697a983be9b,
    __rest: $6cfdc3b10104f1f6$export$3c9a16f847548506,
    __decorate: $6cfdc3b10104f1f6$export$29e00dfd3077644b,
    __param: $6cfdc3b10104f1f6$export$d5ad3fd78186038f,
    __esDecorate: $6cfdc3b10104f1f6$export$3a84e1ae4e97e9b0,
    __runInitializers: $6cfdc3b10104f1f6$export$d831c04e792af3d,
    __propKey: $6cfdc3b10104f1f6$export$6a2a36740a146cb8,
    __setFunctionName: $6cfdc3b10104f1f6$export$d1a06452d3489bc7,
    __metadata: $6cfdc3b10104f1f6$export$f1db080c865becb9,
    __awaiter: $6cfdc3b10104f1f6$export$1050f835b63b671e,
    __generator: $6cfdc3b10104f1f6$export$67ebef60e6f28a6,
    __createBinding: $6cfdc3b10104f1f6$export$45d3717a4c69092e,
    __exportStar: $6cfdc3b10104f1f6$export$f33643c0debef087,
    __values: $6cfdc3b10104f1f6$export$19a8beecd37a4c45,
    __read: $6cfdc3b10104f1f6$export$8d051b38c9118094,
    __spread: $6cfdc3b10104f1f6$export$afc72e2116322959,
    __spreadArrays: $6cfdc3b10104f1f6$export$6388937ca91ccae8,
    __spreadArray: $6cfdc3b10104f1f6$export$1216008129fb82ed,
    __await: $6cfdc3b10104f1f6$export$10c90e4f7922046c,
    __asyncGenerator: $6cfdc3b10104f1f6$export$e427f37a30a4de9b,
    __asyncDelegator: $6cfdc3b10104f1f6$export$bbd80228419bb833,
    __asyncValues: $6cfdc3b10104f1f6$export$e3b29a3d6162315f,
    __makeTemplateObject: $6cfdc3b10104f1f6$export$4fb47efe1390b86f,
    __importStar: $6cfdc3b10104f1f6$export$c21735bcef00d192,
    __importDefault: $6cfdc3b10104f1f6$export$da59b14a69baef04,
    __classPrivateFieldGet: $6cfdc3b10104f1f6$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $6cfdc3b10104f1f6$export$d40a35129aaff81f,
    __classPrivateFieldIn: $6cfdc3b10104f1f6$export$81fdc39f203e4e04,
    __addDisposableResource: $6cfdc3b10104f1f6$export$88ac25d8e944e405,
    __disposeResources: $6cfdc3b10104f1f6$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $6cfdc3b10104f1f6$export$889dfb5d17574b0b
};


const $e9a9fcd6657705fd$export$db0345794bfc14ed = new Map([
    // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
    [
        '1km',
        'application/vnd.1000minds.decision-model+xml'
    ],
    [
        '3dml',
        'text/vnd.in3d.3dml'
    ],
    [
        '3ds',
        'image/x-3ds'
    ],
    [
        '3g2',
        'video/3gpp2'
    ],
    [
        '3gp',
        'video/3gp'
    ],
    [
        '3gpp',
        'video/3gpp'
    ],
    [
        '3mf',
        'model/3mf'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    [
        '7zip',
        'application/x-7z-compressed'
    ],
    [
        '123',
        'application/vnd.lotus-1-2-3'
    ],
    [
        'aab',
        'application/x-authorware-bin'
    ],
    [
        'aac',
        'audio/x-acc'
    ],
    [
        'aam',
        'application/x-authorware-map'
    ],
    [
        'aas',
        'application/x-authorware-seg'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'ac',
        'application/vnd.nokia.n-gage.ac+xml'
    ],
    [
        'ac3',
        'audio/ac3'
    ],
    [
        'acc',
        'application/vnd.americandynamics.acc'
    ],
    [
        'ace',
        'application/x-ace-compressed'
    ],
    [
        'acu',
        'application/vnd.acucobol'
    ],
    [
        'acutc',
        'application/vnd.acucorp'
    ],
    [
        'adp',
        'audio/adpcm'
    ],
    [
        'aep',
        'application/vnd.audiograph'
    ],
    [
        'afm',
        'application/x-font-type1'
    ],
    [
        'afp',
        'application/vnd.ibm.modcap'
    ],
    [
        'ahead',
        'application/vnd.ahead.space'
    ],
    [
        'ai',
        'application/pdf'
    ],
    [
        'aif',
        'audio/x-aiff'
    ],
    [
        'aifc',
        'audio/x-aiff'
    ],
    [
        'aiff',
        'audio/x-aiff'
    ],
    [
        'air',
        'application/vnd.adobe.air-application-installer-package+zip'
    ],
    [
        'ait',
        'application/vnd.dvb.ait'
    ],
    [
        'ami',
        'application/vnd.amiga.ami'
    ],
    [
        'amr',
        'audio/amr'
    ],
    [
        'apk',
        'application/vnd.android.package-archive'
    ],
    [
        'apng',
        'image/apng'
    ],
    [
        'appcache',
        'text/cache-manifest'
    ],
    [
        'application',
        'application/x-ms-application'
    ],
    [
        'apr',
        'application/vnd.lotus-approach'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'arj',
        'application/x-arj'
    ],
    [
        'asc',
        'application/pgp-signature'
    ],
    [
        'asf',
        'video/x-ms-asf'
    ],
    [
        'asm',
        'text/x-asm'
    ],
    [
        'aso',
        'application/vnd.accpac.simply.aso'
    ],
    [
        'asx',
        'video/x-ms-asf'
    ],
    [
        'atc',
        'application/vnd.acucorp'
    ],
    [
        'atom',
        'application/atom+xml'
    ],
    [
        'atomcat',
        'application/atomcat+xml'
    ],
    [
        'atomdeleted',
        'application/atomdeleted+xml'
    ],
    [
        'atomsvc',
        'application/atomsvc+xml'
    ],
    [
        'atx',
        'application/vnd.antix.game-component'
    ],
    [
        'au',
        'audio/x-au'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'aw',
        'application/applixware'
    ],
    [
        'azf',
        'application/vnd.airzip.filesecure.azf'
    ],
    [
        'azs',
        'application/vnd.airzip.filesecure.azs'
    ],
    [
        'azv',
        'image/vnd.airzip.accelerator.azv'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'b16',
        'image/vnd.pco.b16'
    ],
    [
        'bat',
        'application/x-msdownload'
    ],
    [
        'bcpio',
        'application/x-bcpio'
    ],
    [
        'bdf',
        'application/x-font-bdf'
    ],
    [
        'bdm',
        'application/vnd.syncml.dm+wbxml'
    ],
    [
        'bdoc',
        'application/x-bdoc'
    ],
    [
        'bed',
        'application/vnd.realvnc.bed'
    ],
    [
        'bh2',
        'application/vnd.fujitsu.oasysprs'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'blb',
        'application/x-blorb'
    ],
    [
        'blorb',
        'application/x-blorb'
    ],
    [
        'bmi',
        'application/vnd.bmi'
    ],
    [
        'bmml',
        'application/vnd.balsamiq.bmml+xml'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'book',
        'application/vnd.framemaker'
    ],
    [
        'box',
        'application/vnd.previewsystems.box'
    ],
    [
        'boz',
        'application/x-bzip2'
    ],
    [
        'bpk',
        'application/octet-stream'
    ],
    [
        'bpmn',
        'application/octet-stream'
    ],
    [
        'bsp',
        'model/vnd.valve.source.compiled-map'
    ],
    [
        'btif',
        'image/prs.btif'
    ],
    [
        'buffer',
        'application/octet-stream'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'c',
        'text/x-c'
    ],
    [
        'c4d',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4f',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4g',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4p',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4u',
        'application/vnd.clonk.c4group'
    ],
    [
        'c11amc',
        'application/vnd.cluetrust.cartomobile-config'
    ],
    [
        'c11amz',
        'application/vnd.cluetrust.cartomobile-config-pkg'
    ],
    [
        'cab',
        'application/vnd.ms-cab-compressed'
    ],
    [
        'caf',
        'audio/x-caf'
    ],
    [
        'cap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'car',
        'application/vnd.curl.car'
    ],
    [
        'cat',
        'application/vnd.ms-pki.seccat'
    ],
    [
        'cb7',
        'application/x-cbr'
    ],
    [
        'cba',
        'application/x-cbr'
    ],
    [
        'cbr',
        'application/x-cbr'
    ],
    [
        'cbt',
        'application/x-cbr'
    ],
    [
        'cbz',
        'application/x-cbr'
    ],
    [
        'cc',
        'text/x-c'
    ],
    [
        'cco',
        'application/x-cocoa'
    ],
    [
        'cct',
        'application/x-director'
    ],
    [
        'ccxml',
        'application/ccxml+xml'
    ],
    [
        'cdbcmsg',
        'application/vnd.contact.cmsg'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'cdf',
        'application/x-netcdf'
    ],
    [
        'cdfx',
        'application/cdfx+xml'
    ],
    [
        'cdkey',
        'application/vnd.mediastation.cdkey'
    ],
    [
        'cdmia',
        'application/cdmi-capability'
    ],
    [
        'cdmic',
        'application/cdmi-container'
    ],
    [
        'cdmid',
        'application/cdmi-domain'
    ],
    [
        'cdmio',
        'application/cdmi-object'
    ],
    [
        'cdmiq',
        'application/cdmi-queue'
    ],
    [
        'cdr',
        'application/cdr'
    ],
    [
        'cdx',
        'chemical/x-cdx'
    ],
    [
        'cdxml',
        'application/vnd.chemdraw+xml'
    ],
    [
        'cdy',
        'application/vnd.cinderella'
    ],
    [
        'cer',
        'application/pkix-cert'
    ],
    [
        'cfs',
        'application/x-cfs-compressed'
    ],
    [
        'cgm',
        'image/cgm'
    ],
    [
        'chat',
        'application/x-chat'
    ],
    [
        'chm',
        'application/vnd.ms-htmlhelp'
    ],
    [
        'chrt',
        'application/vnd.kde.kchart'
    ],
    [
        'cif',
        'chemical/x-cif'
    ],
    [
        'cii',
        'application/vnd.anser-web-certificate-issue-initiation'
    ],
    [
        'cil',
        'application/vnd.ms-artgalry'
    ],
    [
        'cjs',
        'application/node'
    ],
    [
        'cla',
        'application/vnd.claymore'
    ],
    [
        'class',
        'application/octet-stream'
    ],
    [
        'clkk',
        'application/vnd.crick.clicker.keyboard'
    ],
    [
        'clkp',
        'application/vnd.crick.clicker.palette'
    ],
    [
        'clkt',
        'application/vnd.crick.clicker.template'
    ],
    [
        'clkw',
        'application/vnd.crick.clicker.wordbank'
    ],
    [
        'clkx',
        'application/vnd.crick.clicker'
    ],
    [
        'clp',
        'application/x-msclip'
    ],
    [
        'cmc',
        'application/vnd.cosmocaller'
    ],
    [
        'cmdf',
        'chemical/x-cmdf'
    ],
    [
        'cml',
        'chemical/x-cml'
    ],
    [
        'cmp',
        'application/vnd.yellowriver-custom-menu'
    ],
    [
        'cmx',
        'image/x-cmx'
    ],
    [
        'cod',
        'application/vnd.rim.cod'
    ],
    [
        'coffee',
        'text/coffeescript'
    ],
    [
        'com',
        'application/x-msdownload'
    ],
    [
        'conf',
        'text/plain'
    ],
    [
        'cpio',
        'application/x-cpio'
    ],
    [
        'cpp',
        'text/x-c'
    ],
    [
        'cpt',
        'application/mac-compactpro'
    ],
    [
        'crd',
        'application/x-mscardfile'
    ],
    [
        'crl',
        'application/pkix-crl'
    ],
    [
        'crt',
        'application/x-x509-ca-cert'
    ],
    [
        'crx',
        'application/x-chrome-extension'
    ],
    [
        'cryptonote',
        'application/vnd.rig.cryptonote'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'csl',
        'application/vnd.citationstyles.style+xml'
    ],
    [
        'csml',
        'chemical/x-csml'
    ],
    [
        'csp',
        'application/vnd.commonspace'
    ],
    [
        'csr',
        'application/octet-stream'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'cst',
        'application/x-director'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'cu',
        'application/cu-seeme'
    ],
    [
        'curl',
        'text/vnd.curl'
    ],
    [
        'cww',
        'application/prs.cww'
    ],
    [
        'cxt',
        'application/x-director'
    ],
    [
        'cxx',
        'text/x-c'
    ],
    [
        'dae',
        'model/vnd.collada+xml'
    ],
    [
        'daf',
        'application/vnd.mobius.daf'
    ],
    [
        'dart',
        'application/vnd.dart'
    ],
    [
        'dataless',
        'application/vnd.fdsn.seed'
    ],
    [
        'davmount',
        'application/davmount+xml'
    ],
    [
        'dbf',
        'application/vnd.dbf'
    ],
    [
        'dbk',
        'application/docbook+xml'
    ],
    [
        'dcr',
        'application/x-director'
    ],
    [
        'dcurl',
        'text/vnd.curl.dcurl'
    ],
    [
        'dd2',
        'application/vnd.oma.dd2+xml'
    ],
    [
        'ddd',
        'application/vnd.fujixerox.ddd'
    ],
    [
        'ddf',
        'application/vnd.syncml.dmddf+xml'
    ],
    [
        'dds',
        'image/vnd.ms-dds'
    ],
    [
        'deb',
        'application/x-debian-package'
    ],
    [
        'def',
        'text/plain'
    ],
    [
        'deploy',
        'application/octet-stream'
    ],
    [
        'der',
        'application/x-x509-ca-cert'
    ],
    [
        'dfac',
        'application/vnd.dreamfactory'
    ],
    [
        'dgc',
        'application/x-dgc-compressed'
    ],
    [
        'dic',
        'text/x-c'
    ],
    [
        'dir',
        'application/x-director'
    ],
    [
        'dis',
        'application/vnd.mobius.dis'
    ],
    [
        'disposition-notification',
        'message/disposition-notification'
    ],
    [
        'dist',
        'application/octet-stream'
    ],
    [
        'distz',
        'application/octet-stream'
    ],
    [
        'djv',
        'image/vnd.djvu'
    ],
    [
        'djvu',
        'image/vnd.djvu'
    ],
    [
        'dll',
        'application/octet-stream'
    ],
    [
        'dmg',
        'application/x-apple-diskimage'
    ],
    [
        'dmn',
        'application/octet-stream'
    ],
    [
        'dmp',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'dms',
        'application/octet-stream'
    ],
    [
        'dna',
        'application/vnd.dna'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'dot',
        'application/msword'
    ],
    [
        'dotm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'dotx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
    ],
    [
        'dp',
        'application/vnd.osgi.dp'
    ],
    [
        'dpg',
        'application/vnd.dpgraph'
    ],
    [
        'dra',
        'audio/vnd.dra'
    ],
    [
        'drle',
        'image/dicom-rle'
    ],
    [
        'dsc',
        'text/prs.lines.tag'
    ],
    [
        'dssc',
        'application/dssc+der'
    ],
    [
        'dtb',
        'application/x-dtbook+xml'
    ],
    [
        'dtd',
        'application/xml-dtd'
    ],
    [
        'dts',
        'audio/vnd.dts'
    ],
    [
        'dtshd',
        'audio/vnd.dts.hd'
    ],
    [
        'dump',
        'application/octet-stream'
    ],
    [
        'dvb',
        'video/vnd.dvb.file'
    ],
    [
        'dvi',
        'application/x-dvi'
    ],
    [
        'dwd',
        'application/atsc-dwd+xml'
    ],
    [
        'dwf',
        'model/vnd.dwf'
    ],
    [
        'dwg',
        'image/vnd.dwg'
    ],
    [
        'dxf',
        'image/vnd.dxf'
    ],
    [
        'dxp',
        'application/vnd.spotfire.dxp'
    ],
    [
        'dxr',
        'application/x-director'
    ],
    [
        'ear',
        'application/java-archive'
    ],
    [
        'ecelp4800',
        'audio/vnd.nuera.ecelp4800'
    ],
    [
        'ecelp7470',
        'audio/vnd.nuera.ecelp7470'
    ],
    [
        'ecelp9600',
        'audio/vnd.nuera.ecelp9600'
    ],
    [
        'ecma',
        'application/ecmascript'
    ],
    [
        'edm',
        'application/vnd.novadigm.edm'
    ],
    [
        'edx',
        'application/vnd.novadigm.edx'
    ],
    [
        'efif',
        'application/vnd.picsel'
    ],
    [
        'ei6',
        'application/vnd.pg.osasli'
    ],
    [
        'elc',
        'application/octet-stream'
    ],
    [
        'emf',
        'image/emf'
    ],
    [
        'eml',
        'message/rfc822'
    ],
    [
        'emma',
        'application/emma+xml'
    ],
    [
        'emotionml',
        'application/emotionml+xml'
    ],
    [
        'emz',
        'application/x-msmetafile'
    ],
    [
        'eol',
        'audio/vnd.digital-winds'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'eps',
        'application/postscript'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'es',
        'application/ecmascript'
    ],
    [
        'es3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'esa',
        'application/vnd.osgi.subsystem'
    ],
    [
        'esf',
        'application/vnd.epson.esf'
    ],
    [
        'et3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'etx',
        'text/x-setext'
    ],
    [
        'eva',
        'application/x-eva'
    ],
    [
        'evy',
        'application/x-envoy'
    ],
    [
        'exe',
        'application/octet-stream'
    ],
    [
        'exi',
        'application/exi'
    ],
    [
        'exp',
        'application/express'
    ],
    [
        'exr',
        'image/aces'
    ],
    [
        'ext',
        'application/vnd.novadigm.ext'
    ],
    [
        'ez',
        'application/andrew-inset'
    ],
    [
        'ez2',
        'application/vnd.ezpix-album'
    ],
    [
        'ez3',
        'application/vnd.ezpix-package'
    ],
    [
        'f',
        'text/x-fortran'
    ],
    [
        'f4v',
        'video/mp4'
    ],
    [
        'f77',
        'text/x-fortran'
    ],
    [
        'f90',
        'text/x-fortran'
    ],
    [
        'fbs',
        'image/vnd.fastbidsheet'
    ],
    [
        'fcdt',
        'application/vnd.adobe.formscentral.fcdt'
    ],
    [
        'fcs',
        'application/vnd.isac.fcs'
    ],
    [
        'fdf',
        'application/vnd.fdf'
    ],
    [
        'fdt',
        'application/fdt+xml'
    ],
    [
        'fe_launch',
        'application/vnd.denovo.fcselayout-link'
    ],
    [
        'fg5',
        'application/vnd.fujitsu.oasysgp'
    ],
    [
        'fgd',
        'application/x-director'
    ],
    [
        'fh',
        'image/x-freehand'
    ],
    [
        'fh4',
        'image/x-freehand'
    ],
    [
        'fh5',
        'image/x-freehand'
    ],
    [
        'fh7',
        'image/x-freehand'
    ],
    [
        'fhc',
        'image/x-freehand'
    ],
    [
        'fig',
        'application/x-xfig'
    ],
    [
        'fits',
        'image/fits'
    ],
    [
        'flac',
        'audio/x-flac'
    ],
    [
        'fli',
        'video/x-fli'
    ],
    [
        'flo',
        'application/vnd.micrografx.flo'
    ],
    [
        'flv',
        'video/x-flv'
    ],
    [
        'flw',
        'application/vnd.kde.kivio'
    ],
    [
        'flx',
        'text/vnd.fmi.flexstor'
    ],
    [
        'fly',
        'text/vnd.fly'
    ],
    [
        'fm',
        'application/vnd.framemaker'
    ],
    [
        'fnc',
        'application/vnd.frogans.fnc'
    ],
    [
        'fo',
        'application/vnd.software602.filler.form+xml'
    ],
    [
        'for',
        'text/x-fortran'
    ],
    [
        'fpx',
        'image/vnd.fpx'
    ],
    [
        'frame',
        'application/vnd.framemaker'
    ],
    [
        'fsc',
        'application/vnd.fsc.weblaunch'
    ],
    [
        'fst',
        'image/vnd.fst'
    ],
    [
        'ftc',
        'application/vnd.fluxtime.clip'
    ],
    [
        'fti',
        'application/vnd.anser-web-funds-transfer-initiation'
    ],
    [
        'fvt',
        'video/vnd.fvt'
    ],
    [
        'fxp',
        'application/vnd.adobe.fxp'
    ],
    [
        'fxpl',
        'application/vnd.adobe.fxp'
    ],
    [
        'fzs',
        'application/vnd.fuzzysheet'
    ],
    [
        'g2w',
        'application/vnd.geoplan'
    ],
    [
        'g3',
        'image/g3fax'
    ],
    [
        'g3w',
        'application/vnd.geospace'
    ],
    [
        'gac',
        'application/vnd.groove-account'
    ],
    [
        'gam',
        'application/x-tads'
    ],
    [
        'gbr',
        'application/rpki-ghostbusters'
    ],
    [
        'gca',
        'application/x-gca-compressed'
    ],
    [
        'gdl',
        'model/vnd.gdl'
    ],
    [
        'gdoc',
        'application/vnd.google-apps.document'
    ],
    [
        'geo',
        'application/vnd.dynageo'
    ],
    [
        'geojson',
        'application/geo+json'
    ],
    [
        'gex',
        'application/vnd.geometry-explorer'
    ],
    [
        'ggb',
        'application/vnd.geogebra.file'
    ],
    [
        'ggt',
        'application/vnd.geogebra.tool'
    ],
    [
        'ghf',
        'application/vnd.groove-help'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'gim',
        'application/vnd.groove-identity-message'
    ],
    [
        'glb',
        'model/gltf-binary'
    ],
    [
        'gltf',
        'model/gltf+json'
    ],
    [
        'gml',
        'application/gml+xml'
    ],
    [
        'gmx',
        'application/vnd.gmx'
    ],
    [
        'gnumeric',
        'application/x-gnumeric'
    ],
    [
        'gpg',
        'application/gpg-keys'
    ],
    [
        'gph',
        'application/vnd.flographit'
    ],
    [
        'gpx',
        'application/gpx+xml'
    ],
    [
        'gqf',
        'application/vnd.grafeq'
    ],
    [
        'gqs',
        'application/vnd.grafeq'
    ],
    [
        'gram',
        'application/srgs'
    ],
    [
        'gramps',
        'application/x-gramps-xml'
    ],
    [
        'gre',
        'application/vnd.geometry-explorer'
    ],
    [
        'grv',
        'application/vnd.groove-injector'
    ],
    [
        'grxml',
        'application/srgs+xml'
    ],
    [
        'gsf',
        'application/x-font-ghostscript'
    ],
    [
        'gsheet',
        'application/vnd.google-apps.spreadsheet'
    ],
    [
        'gslides',
        'application/vnd.google-apps.presentation'
    ],
    [
        'gtar',
        'application/x-gtar'
    ],
    [
        'gtm',
        'application/vnd.groove-tool-message'
    ],
    [
        'gtw',
        'model/vnd.gtw'
    ],
    [
        'gv',
        'text/vnd.graphviz'
    ],
    [
        'gxf',
        'application/gxf'
    ],
    [
        'gxt',
        'application/vnd.geonext'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gzip',
        'application/gzip'
    ],
    [
        'h',
        'text/x-c'
    ],
    [
        'h261',
        'video/h261'
    ],
    [
        'h263',
        'video/h263'
    ],
    [
        'h264',
        'video/h264'
    ],
    [
        'hal',
        'application/vnd.hal+xml'
    ],
    [
        'hbci',
        'application/vnd.hbci'
    ],
    [
        'hbs',
        'text/x-handlebars-template'
    ],
    [
        'hdd',
        'application/x-virtualbox-hdd'
    ],
    [
        'hdf',
        'application/x-hdf'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heics',
        'image/heic-sequence'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'heifs',
        'image/heif-sequence'
    ],
    [
        'hej2',
        'image/hej2k'
    ],
    [
        'held',
        'application/atsc-held+xml'
    ],
    [
        'hh',
        'text/x-c'
    ],
    [
        'hjson',
        'application/hjson'
    ],
    [
        'hlp',
        'application/winhlp'
    ],
    [
        'hpgl',
        'application/vnd.hp-hpgl'
    ],
    [
        'hpid',
        'application/vnd.hp-hpid'
    ],
    [
        'hps',
        'application/vnd.hp-hps'
    ],
    [
        'hqx',
        'application/mac-binhex40'
    ],
    [
        'hsj2',
        'image/hsj2'
    ],
    [
        'htc',
        'text/x-component'
    ],
    [
        'htke',
        'application/vnd.kenameaapp'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'hvd',
        'application/vnd.yamaha.hv-dic'
    ],
    [
        'hvp',
        'application/vnd.yamaha.hv-voice'
    ],
    [
        'hvs',
        'application/vnd.yamaha.hv-script'
    ],
    [
        'i2g',
        'application/vnd.intergeo'
    ],
    [
        'icc',
        'application/vnd.iccprofile'
    ],
    [
        'ice',
        'x-conference/x-cooltalk'
    ],
    [
        'icm',
        'application/vnd.iccprofile'
    ],
    [
        'ico',
        'image/x-icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'ief',
        'image/ief'
    ],
    [
        'ifb',
        'text/calendar'
    ],
    [
        'ifm',
        'application/vnd.shana.informed.formdata'
    ],
    [
        'iges',
        'model/iges'
    ],
    [
        'igl',
        'application/vnd.igloader'
    ],
    [
        'igm',
        'application/vnd.insors.igm'
    ],
    [
        'igs',
        'model/iges'
    ],
    [
        'igx',
        'application/vnd.micrografx.igx'
    ],
    [
        'iif',
        'application/vnd.shana.informed.interchange'
    ],
    [
        'img',
        'application/octet-stream'
    ],
    [
        'imp',
        'application/vnd.accpac.simply.imp'
    ],
    [
        'ims',
        'application/vnd.ms-ims'
    ],
    [
        'in',
        'text/plain'
    ],
    [
        'ini',
        'text/plain'
    ],
    [
        'ink',
        'application/inkml+xml'
    ],
    [
        'inkml',
        'application/inkml+xml'
    ],
    [
        'install',
        'application/x-install-instructions'
    ],
    [
        'iota',
        'application/vnd.astraea-software.iota'
    ],
    [
        'ipfix',
        'application/ipfix'
    ],
    [
        'ipk',
        'application/vnd.shana.informed.package'
    ],
    [
        'irm',
        'application/vnd.ibm.rights-management'
    ],
    [
        'irp',
        'application/vnd.irepository.package+xml'
    ],
    [
        'iso',
        'application/x-iso9660-image'
    ],
    [
        'itp',
        'application/vnd.shana.informed.formtemplate'
    ],
    [
        'its',
        'application/its+xml'
    ],
    [
        'ivp',
        'application/vnd.immervision-ivp'
    ],
    [
        'ivu',
        'application/vnd.immervision-ivu'
    ],
    [
        'jad',
        'text/vnd.sun.j2me.app-descriptor'
    ],
    [
        'jade',
        'text/jade'
    ],
    [
        'jam',
        'application/vnd.jam'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jardiff',
        'application/x-java-archive-diff'
    ],
    [
        'java',
        'text/x-java-source'
    ],
    [
        'jhc',
        'image/jphc'
    ],
    [
        'jisp',
        'application/vnd.jisp'
    ],
    [
        'jls',
        'image/jls'
    ],
    [
        'jlt',
        'application/vnd.hp-jlyt'
    ],
    [
        'jng',
        'image/x-jng'
    ],
    [
        'jnlp',
        'application/x-java-jnlp-file'
    ],
    [
        'joda',
        'application/vnd.joost.joda-archive'
    ],
    [
        'jp2',
        'image/jp2'
    ],
    [
        'jpe',
        'image/jpeg'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpf',
        'image/jpx'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'jpg2',
        'image/jp2'
    ],
    [
        'jpgm',
        'video/jpm'
    ],
    [
        'jpgv',
        'video/jpeg'
    ],
    [
        'jph',
        'image/jph'
    ],
    [
        'jpm',
        'video/jpm'
    ],
    [
        'jpx',
        'image/jpx'
    ],
    [
        'js',
        'application/javascript'
    ],
    [
        'json',
        'application/json'
    ],
    [
        'json5',
        'application/json5'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    // https://jsonlines.org/
    [
        'jsonl',
        'application/jsonl'
    ],
    [
        'jsonml',
        'application/jsonml+json'
    ],
    [
        'jsx',
        'text/jsx'
    ],
    [
        'jxr',
        'image/jxr'
    ],
    [
        'jxra',
        'image/jxra'
    ],
    [
        'jxrs',
        'image/jxrs'
    ],
    [
        'jxs',
        'image/jxs'
    ],
    [
        'jxsc',
        'image/jxsc'
    ],
    [
        'jxsi',
        'image/jxsi'
    ],
    [
        'jxss',
        'image/jxss'
    ],
    [
        'kar',
        'audio/midi'
    ],
    [
        'karbon',
        'application/vnd.kde.karbon'
    ],
    [
        'kdb',
        'application/octet-stream'
    ],
    [
        'kdbx',
        'application/x-keepass2'
    ],
    [
        'key',
        'application/x-iwork-keynote-sffkey'
    ],
    [
        'kfo',
        'application/vnd.kde.kformula'
    ],
    [
        'kia',
        'application/vnd.kidspiration'
    ],
    [
        'kml',
        'application/vnd.google-earth.kml+xml'
    ],
    [
        'kmz',
        'application/vnd.google-earth.kmz'
    ],
    [
        'kne',
        'application/vnd.kinar'
    ],
    [
        'knp',
        'application/vnd.kinar'
    ],
    [
        'kon',
        'application/vnd.kde.kontour'
    ],
    [
        'kpr',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpt',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpxx',
        'application/vnd.ds-keypoint'
    ],
    [
        'ksp',
        'application/vnd.kde.kspread'
    ],
    [
        'ktr',
        'application/vnd.kahootz'
    ],
    [
        'ktx',
        'image/ktx'
    ],
    [
        'ktx2',
        'image/ktx2'
    ],
    [
        'ktz',
        'application/vnd.kahootz'
    ],
    [
        'kwd',
        'application/vnd.kde.kword'
    ],
    [
        'kwt',
        'application/vnd.kde.kword'
    ],
    [
        'lasxml',
        'application/vnd.las.las+xml'
    ],
    [
        'latex',
        'application/x-latex'
    ],
    [
        'lbd',
        'application/vnd.llamagraphics.life-balance.desktop'
    ],
    [
        'lbe',
        'application/vnd.llamagraphics.life-balance.exchange+xml'
    ],
    [
        'les',
        'application/vnd.hhe.lesson-player'
    ],
    [
        'less',
        'text/less'
    ],
    [
        'lgr',
        'application/lgr+xml'
    ],
    [
        'lha',
        'application/octet-stream'
    ],
    [
        'link66',
        'application/vnd.route66.link66+xml'
    ],
    [
        'list',
        'text/plain'
    ],
    [
        'list3820',
        'application/vnd.ibm.modcap'
    ],
    [
        'listafp',
        'application/vnd.ibm.modcap'
    ],
    [
        'litcoffee',
        'text/coffeescript'
    ],
    [
        'lnk',
        'application/x-ms-shortcut'
    ],
    [
        'log',
        'text/plain'
    ],
    [
        'lostxml',
        'application/lost+xml'
    ],
    [
        'lrf',
        'application/octet-stream'
    ],
    [
        'lrm',
        'application/vnd.ms-lrm'
    ],
    [
        'ltf',
        'application/vnd.frogans.ltf'
    ],
    [
        'lua',
        'text/x-lua'
    ],
    [
        'luac',
        'application/x-lua-bytecode'
    ],
    [
        'lvp',
        'audio/vnd.lucent.voice'
    ],
    [
        'lwp',
        'application/vnd.lotus-wordpro'
    ],
    [
        'lzh',
        'application/octet-stream'
    ],
    [
        'm1v',
        'video/mpeg'
    ],
    [
        'm2a',
        'audio/mpeg'
    ],
    [
        'm2v',
        'video/mpeg'
    ],
    [
        'm3a',
        'audio/mpeg'
    ],
    [
        'm3u',
        'text/plain'
    ],
    [
        'm3u8',
        'application/vnd.apple.mpegurl'
    ],
    [
        'm4a',
        'audio/x-m4a'
    ],
    [
        'm4p',
        'application/mp4'
    ],
    [
        'm4s',
        'video/iso.segment'
    ],
    [
        'm4u',
        'application/vnd.mpegurl'
    ],
    [
        'm4v',
        'video/x-m4v'
    ],
    [
        'm13',
        'application/x-msmediaview'
    ],
    [
        'm14',
        'application/x-msmediaview'
    ],
    [
        'm21',
        'application/mp21'
    ],
    [
        'ma',
        'application/mathematica'
    ],
    [
        'mads',
        'application/mads+xml'
    ],
    [
        'maei',
        'application/mmt-aei+xml'
    ],
    [
        'mag',
        'application/vnd.ecowin.chart'
    ],
    [
        'maker',
        'application/vnd.framemaker'
    ],
    [
        'man',
        'text/troff'
    ],
    [
        'manifest',
        'text/cache-manifest'
    ],
    [
        'map',
        'application/json'
    ],
    [
        'mar',
        'application/octet-stream'
    ],
    [
        'markdown',
        'text/markdown'
    ],
    [
        'mathml',
        'application/mathml+xml'
    ],
    [
        'mb',
        'application/mathematica'
    ],
    [
        'mbk',
        'application/vnd.mobius.mbk'
    ],
    [
        'mbox',
        'application/mbox'
    ],
    [
        'mc1',
        'application/vnd.medcalcdata'
    ],
    [
        'mcd',
        'application/vnd.mcd'
    ],
    [
        'mcurl',
        'text/vnd.curl.mcurl'
    ],
    [
        'md',
        'text/markdown'
    ],
    [
        'mdb',
        'application/x-msaccess'
    ],
    [
        'mdi',
        'image/vnd.ms-modi'
    ],
    [
        'mdx',
        'text/mdx'
    ],
    [
        'me',
        'text/troff'
    ],
    [
        'mesh',
        'model/mesh'
    ],
    [
        'meta4',
        'application/metalink4+xml'
    ],
    [
        'metalink',
        'application/metalink+xml'
    ],
    [
        'mets',
        'application/mets+xml'
    ],
    [
        'mfm',
        'application/vnd.mfmp'
    ],
    [
        'mft',
        'application/rpki-manifest'
    ],
    [
        'mgp',
        'application/vnd.osgeo.mapguide.package'
    ],
    [
        'mgz',
        'application/vnd.proteus.magazine'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mie',
        'application/x-mie'
    ],
    [
        'mif',
        'application/vnd.mif'
    ],
    [
        'mime',
        'message/rfc822'
    ],
    [
        'mj2',
        'video/mj2'
    ],
    [
        'mjp2',
        'video/mj2'
    ],
    [
        'mjs',
        'application/javascript'
    ],
    [
        'mk3d',
        'video/x-matroska'
    ],
    [
        'mka',
        'audio/x-matroska'
    ],
    [
        'mkd',
        'text/x-markdown'
    ],
    [
        'mks',
        'video/x-matroska'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mlp',
        'application/vnd.dolby.mlp'
    ],
    [
        'mmd',
        'application/vnd.chipnuts.karaoke-mmd'
    ],
    [
        'mmf',
        'application/vnd.smaf'
    ],
    [
        'mml',
        'text/mathml'
    ],
    [
        'mmr',
        'image/vnd.fujixerox.edmics-mmr'
    ],
    [
        'mng',
        'video/x-mng'
    ],
    [
        'mny',
        'application/x-msmoney'
    ],
    [
        'mobi',
        'application/x-mobipocket-ebook'
    ],
    [
        'mods',
        'application/mods+xml'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'movie',
        'video/x-sgi-movie'
    ],
    [
        'mp2',
        'audio/mpeg'
    ],
    [
        'mp2a',
        'audio/mpeg'
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mp4a',
        'audio/mp4'
    ],
    [
        'mp4s',
        'application/mp4'
    ],
    [
        'mp4v',
        'video/mp4'
    ],
    [
        'mp21',
        'application/mp21'
    ],
    [
        'mpc',
        'application/vnd.mophun.certificate'
    ],
    [
        'mpd',
        'application/dash+xml'
    ],
    [
        'mpe',
        'video/mpeg'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpg',
        'video/mpeg'
    ],
    [
        'mpg4',
        'video/mp4'
    ],
    [
        'mpga',
        'audio/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'mpm',
        'application/vnd.blueice.multipass'
    ],
    [
        'mpn',
        'application/vnd.mophun.application'
    ],
    [
        'mpp',
        'application/vnd.ms-project'
    ],
    [
        'mpt',
        'application/vnd.ms-project'
    ],
    [
        'mpy',
        'application/vnd.ibm.minipay'
    ],
    [
        'mqy',
        'application/vnd.mobius.mqy'
    ],
    [
        'mrc',
        'application/marc'
    ],
    [
        'mrcx',
        'application/marcxml+xml'
    ],
    [
        'ms',
        'text/troff'
    ],
    [
        'mscml',
        'application/mediaservercontrol+xml'
    ],
    [
        'mseed',
        'application/vnd.fdsn.mseed'
    ],
    [
        'mseq',
        'application/vnd.mseq'
    ],
    [
        'msf',
        'application/vnd.epson.msf'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ],
    [
        'msh',
        'model/mesh'
    ],
    [
        'msi',
        'application/x-msdownload'
    ],
    [
        'msl',
        'application/vnd.mobius.msl'
    ],
    [
        'msm',
        'application/octet-stream'
    ],
    [
        'msp',
        'application/octet-stream'
    ],
    [
        'msty',
        'application/vnd.muvee.style'
    ],
    [
        'mtl',
        'model/mtl'
    ],
    [
        'mts',
        'model/vnd.mts'
    ],
    [
        'mus',
        'application/vnd.musician'
    ],
    [
        'musd',
        'application/mmt-usd+xml'
    ],
    [
        'musicxml',
        'application/vnd.recordare.musicxml+xml'
    ],
    [
        'mvb',
        'application/x-msmediaview'
    ],
    [
        'mvt',
        'application/vnd.mapbox-vector-tile'
    ],
    [
        'mwf',
        'application/vnd.mfer'
    ],
    [
        'mxf',
        'application/mxf'
    ],
    [
        'mxl',
        'application/vnd.recordare.musicxml'
    ],
    [
        'mxmf',
        'audio/mobile-xmf'
    ],
    [
        'mxml',
        'application/xv+xml'
    ],
    [
        'mxs',
        'application/vnd.triscape.mxs'
    ],
    [
        'mxu',
        'video/vnd.mpegurl'
    ],
    [
        'n-gage',
        'application/vnd.nokia.n-gage.symbian.install'
    ],
    [
        'n3',
        'text/n3'
    ],
    [
        'nb',
        'application/mathematica'
    ],
    [
        'nbp',
        'application/vnd.wolfram.player'
    ],
    [
        'nc',
        'application/x-netcdf'
    ],
    [
        'ncx',
        'application/x-dtbncx+xml'
    ],
    [
        'nfo',
        'text/x-nfo'
    ],
    [
        'ngdat',
        'application/vnd.nokia.n-gage.data'
    ],
    [
        'nitf',
        'application/vnd.nitf'
    ],
    [
        'nlu',
        'application/vnd.neurolanguage.nlu'
    ],
    [
        'nml',
        'application/vnd.enliven'
    ],
    [
        'nnd',
        'application/vnd.noblenet-directory'
    ],
    [
        'nns',
        'application/vnd.noblenet-sealer'
    ],
    [
        'nnw',
        'application/vnd.noblenet-web'
    ],
    [
        'npx',
        'image/vnd.net-fpx'
    ],
    [
        'nq',
        'application/n-quads'
    ],
    [
        'nsc',
        'application/x-conference'
    ],
    [
        'nsf',
        'application/vnd.lotus-notes'
    ],
    [
        'nt',
        'application/n-triples'
    ],
    [
        'ntf',
        'application/vnd.nitf'
    ],
    [
        'numbers',
        'application/x-iwork-numbers-sffnumbers'
    ],
    [
        'nzb',
        'application/x-nzb'
    ],
    [
        'oa2',
        'application/vnd.fujitsu.oasys2'
    ],
    [
        'oa3',
        'application/vnd.fujitsu.oasys3'
    ],
    [
        'oas',
        'application/vnd.fujitsu.oasys'
    ],
    [
        'obd',
        'application/x-msbinder'
    ],
    [
        'obgx',
        'application/vnd.openblox.game+xml'
    ],
    [
        'obj',
        'model/obj'
    ],
    [
        'oda',
        'application/oda'
    ],
    [
        'odb',
        'application/vnd.oasis.opendocument.database'
    ],
    [
        'odc',
        'application/vnd.oasis.opendocument.chart'
    ],
    [
        'odf',
        'application/vnd.oasis.opendocument.formula'
    ],
    [
        'odft',
        'application/vnd.oasis.opendocument.formula-template'
    ],
    [
        'odg',
        'application/vnd.oasis.opendocument.graphics'
    ],
    [
        'odi',
        'application/vnd.oasis.opendocument.image'
    ],
    [
        'odm',
        'application/vnd.oasis.opendocument.text-master'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogex',
        'model/vnd.opengex'
    ],
    [
        'ogg',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'omdoc',
        'application/omdoc+xml'
    ],
    [
        'onepkg',
        'application/onenote'
    ],
    [
        'onetmp',
        'application/onenote'
    ],
    [
        'onetoc',
        'application/onenote'
    ],
    [
        'onetoc2',
        'application/onenote'
    ],
    [
        'opf',
        'application/oebps-package+xml'
    ],
    [
        'opml',
        'text/x-opml'
    ],
    [
        'oprc',
        'application/vnd.palm'
    ],
    [
        'opus',
        'audio/ogg'
    ],
    [
        'org',
        'text/x-org'
    ],
    [
        'osf',
        'application/vnd.yamaha.openscoreformat'
    ],
    [
        'osfpvg',
        'application/vnd.yamaha.openscoreformat.osfpvg+xml'
    ],
    [
        'osm',
        'application/vnd.openstreetmap.data+xml'
    ],
    [
        'otc',
        'application/vnd.oasis.opendocument.chart-template'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'otg',
        'application/vnd.oasis.opendocument.graphics-template'
    ],
    [
        'oth',
        'application/vnd.oasis.opendocument.text-web'
    ],
    [
        'oti',
        'application/vnd.oasis.opendocument.image-template'
    ],
    [
        'otp',
        'application/vnd.oasis.opendocument.presentation-template'
    ],
    [
        'ots',
        'application/vnd.oasis.opendocument.spreadsheet-template'
    ],
    [
        'ott',
        'application/vnd.oasis.opendocument.text-template'
    ],
    [
        'ova',
        'application/x-virtualbox-ova'
    ],
    [
        'ovf',
        'application/x-virtualbox-ovf'
    ],
    [
        'owl',
        'application/rdf+xml'
    ],
    [
        'oxps',
        'application/oxps'
    ],
    [
        'oxt',
        'application/vnd.openofficeorg.extension'
    ],
    [
        'p',
        'text/x-pascal'
    ],
    [
        'p7a',
        'application/x-pkcs7-signature'
    ],
    [
        'p7b',
        'application/x-pkcs7-certificates'
    ],
    [
        'p7c',
        'application/pkcs7-mime'
    ],
    [
        'p7m',
        'application/pkcs7-mime'
    ],
    [
        'p7r',
        'application/x-pkcs7-certreqresp'
    ],
    [
        'p7s',
        'application/pkcs7-signature'
    ],
    [
        'p8',
        'application/pkcs8'
    ],
    [
        'p10',
        'application/x-pkcs10'
    ],
    [
        'p12',
        'application/x-pkcs12'
    ],
    [
        'pac',
        'application/x-ns-proxy-autoconfig'
    ],
    [
        'pages',
        'application/x-iwork-pages-sffpages'
    ],
    [
        'pas',
        'text/x-pascal'
    ],
    [
        'paw',
        'application/vnd.pawaafile'
    ],
    [
        'pbd',
        'application/vnd.powerbuilder6'
    ],
    [
        'pbm',
        'image/x-portable-bitmap'
    ],
    [
        'pcap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'pcf',
        'application/x-font-pcf'
    ],
    [
        'pcl',
        'application/vnd.hp-pcl'
    ],
    [
        'pclxl',
        'application/vnd.hp-pclxl'
    ],
    [
        'pct',
        'image/x-pict'
    ],
    [
        'pcurl',
        'application/vnd.curl.pcurl'
    ],
    [
        'pcx',
        'image/x-pcx'
    ],
    [
        'pdb',
        'application/x-pilot'
    ],
    [
        'pde',
        'text/x-processing'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'pem',
        'application/x-x509-user-cert'
    ],
    [
        'pfa',
        'application/x-font-type1'
    ],
    [
        'pfb',
        'application/x-font-type1'
    ],
    [
        'pfm',
        'application/x-font-type1'
    ],
    [
        'pfr',
        'application/font-tdpfr'
    ],
    [
        'pfx',
        'application/x-pkcs12'
    ],
    [
        'pgm',
        'image/x-portable-graymap'
    ],
    [
        'pgn',
        'application/x-chess-pgn'
    ],
    [
        'pgp',
        'application/pgp'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'php3',
        'application/x-httpd-php'
    ],
    [
        'php4',
        'application/x-httpd-php'
    ],
    [
        'phps',
        'application/x-httpd-php-source'
    ],
    [
        'phtml',
        'application/x-httpd-php'
    ],
    [
        'pic',
        'image/x-pict'
    ],
    [
        'pkg',
        'application/octet-stream'
    ],
    [
        'pki',
        'application/pkixcmp'
    ],
    [
        'pkipath',
        'application/pkix-pkipath'
    ],
    [
        'pkpass',
        'application/vnd.apple.pkpass'
    ],
    [
        'pl',
        'application/x-perl'
    ],
    [
        'plb',
        'application/vnd.3gpp.pic-bw-large'
    ],
    [
        'plc',
        'application/vnd.mobius.plc'
    ],
    [
        'plf',
        'application/vnd.pocketlearn'
    ],
    [
        'pls',
        'application/pls+xml'
    ],
    [
        'pm',
        'application/x-perl'
    ],
    [
        'pml',
        'application/vnd.ctc-posml'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pnm',
        'image/x-portable-anymap'
    ],
    [
        'portpkg',
        'application/vnd.macports.portpkg'
    ],
    [
        'pot',
        'application/vnd.ms-powerpoint'
    ],
    [
        'potm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'potx',
        'application/vnd.openxmlformats-officedocument.presentationml.template'
    ],
    [
        'ppa',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppam',
        'application/vnd.ms-powerpoint.addin.macroEnabled.12'
    ],
    [
        'ppd',
        'application/vnd.cups-ppd'
    ],
    [
        'ppm',
        'image/x-portable-pixmap'
    ],
    [
        'pps',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppsm',
        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
    ],
    [
        'ppsx',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow'
    ],
    [
        'ppt',
        'application/powerpoint'
    ],
    [
        'pptm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'pqa',
        'application/vnd.palm'
    ],
    [
        'prc',
        'application/x-pilot'
    ],
    [
        'pre',
        'application/vnd.lotus-freelance'
    ],
    [
        'prf',
        'application/pics-rules'
    ],
    [
        'provx',
        'application/provenance+xml'
    ],
    [
        'ps',
        'application/postscript'
    ],
    [
        'psb',
        'application/vnd.3gpp.pic-bw-small'
    ],
    [
        'psd',
        'application/x-photoshop'
    ],
    [
        'psf',
        'application/x-font-linux-psf'
    ],
    [
        'pskcxml',
        'application/pskc+xml'
    ],
    [
        'pti',
        'image/prs.pti'
    ],
    [
        'ptid',
        'application/vnd.pvi.ptid1'
    ],
    [
        'pub',
        'application/x-mspublisher'
    ],
    [
        'pvb',
        'application/vnd.3gpp.pic-bw-var'
    ],
    [
        'pwn',
        'application/vnd.3m.post-it-notes'
    ],
    [
        'pya',
        'audio/vnd.ms-playready.media.pya'
    ],
    [
        'pyv',
        'video/vnd.ms-playready.media.pyv'
    ],
    [
        'qam',
        'application/vnd.epson.quickanime'
    ],
    [
        'qbo',
        'application/vnd.intu.qbo'
    ],
    [
        'qfx',
        'application/vnd.intu.qfx'
    ],
    [
        'qps',
        'application/vnd.publishare-delta-tree'
    ],
    [
        'qt',
        'video/quicktime'
    ],
    [
        'qwd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qwt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxb',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxl',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'ra',
        'audio/x-realaudio'
    ],
    [
        'ram',
        'audio/x-pn-realaudio'
    ],
    [
        'raml',
        'application/raml+yaml'
    ],
    [
        'rapd',
        'application/route-apd+xml'
    ],
    [
        'rar',
        'application/x-rar'
    ],
    [
        'ras',
        'image/x-cmu-raster'
    ],
    [
        'rcprofile',
        'application/vnd.ipunplugged.rcprofile'
    ],
    [
        'rdf',
        'application/rdf+xml'
    ],
    [
        'rdz',
        'application/vnd.data-vision.rdz'
    ],
    [
        'relo',
        'application/p2p-overlay+xml'
    ],
    [
        'rep',
        'application/vnd.businessobjects'
    ],
    [
        'res',
        'application/x-dtbresource+xml'
    ],
    [
        'rgb',
        'image/x-rgb'
    ],
    [
        'rif',
        'application/reginfo+xml'
    ],
    [
        'rip',
        'audio/vnd.rip'
    ],
    [
        'ris',
        'application/x-research-info-systems'
    ],
    [
        'rl',
        'application/resource-lists+xml'
    ],
    [
        'rlc',
        'image/vnd.fujixerox.edmics-rlc'
    ],
    [
        'rld',
        'application/resource-lists-diff+xml'
    ],
    [
        'rm',
        'audio/x-pn-realaudio'
    ],
    [
        'rmi',
        'audio/midi'
    ],
    [
        'rmp',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rms',
        'application/vnd.jcp.javame.midlet-rms'
    ],
    [
        'rmvb',
        'application/vnd.rn-realmedia-vbr'
    ],
    [
        'rnc',
        'application/relax-ng-compact-syntax'
    ],
    [
        'rng',
        'application/xml'
    ],
    [
        'roa',
        'application/rpki-roa'
    ],
    [
        'roff',
        'text/troff'
    ],
    [
        'rp9',
        'application/vnd.cloanto.rp9'
    ],
    [
        'rpm',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rpss',
        'application/vnd.nokia.radio-presets'
    ],
    [
        'rpst',
        'application/vnd.nokia.radio-preset'
    ],
    [
        'rq',
        'application/sparql-query'
    ],
    [
        'rs',
        'application/rls-services+xml'
    ],
    [
        'rsa',
        'application/x-pkcs7'
    ],
    [
        'rsat',
        'application/atsc-rsat+xml'
    ],
    [
        'rsd',
        'application/rsd+xml'
    ],
    [
        'rsheet',
        'application/urc-ressheet+xml'
    ],
    [
        'rss',
        'application/rss+xml'
    ],
    [
        'rtf',
        'text/rtf'
    ],
    [
        'rtx',
        'text/richtext'
    ],
    [
        'run',
        'application/x-makeself'
    ],
    [
        'rusd',
        'application/route-usd+xml'
    ],
    [
        'rv',
        'video/vnd.rn-realvideo'
    ],
    [
        's',
        'text/x-asm'
    ],
    [
        's3m',
        'audio/s3m'
    ],
    [
        'saf',
        'application/vnd.yamaha.smaf-audio'
    ],
    [
        'sass',
        'text/x-sass'
    ],
    [
        'sbml',
        'application/sbml+xml'
    ],
    [
        'sc',
        'application/vnd.ibm.secure-container'
    ],
    [
        'scd',
        'application/x-msschedule'
    ],
    [
        'scm',
        'application/vnd.lotus-screencam'
    ],
    [
        'scq',
        'application/scvp-cv-request'
    ],
    [
        'scs',
        'application/scvp-cv-response'
    ],
    [
        'scss',
        'text/x-scss'
    ],
    [
        'scurl',
        'text/vnd.curl.scurl'
    ],
    [
        'sda',
        'application/vnd.stardivision.draw'
    ],
    [
        'sdc',
        'application/vnd.stardivision.calc'
    ],
    [
        'sdd',
        'application/vnd.stardivision.impress'
    ],
    [
        'sdkd',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdkm',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdp',
        'application/sdp'
    ],
    [
        'sdw',
        'application/vnd.stardivision.writer'
    ],
    [
        'sea',
        'application/octet-stream'
    ],
    [
        'see',
        'application/vnd.seemail'
    ],
    [
        'seed',
        'application/vnd.fdsn.seed'
    ],
    [
        'sema',
        'application/vnd.sema'
    ],
    [
        'semd',
        'application/vnd.semd'
    ],
    [
        'semf',
        'application/vnd.semf'
    ],
    [
        'senmlx',
        'application/senml+xml'
    ],
    [
        'sensmlx',
        'application/sensml+xml'
    ],
    [
        'ser',
        'application/java-serialized-object'
    ],
    [
        'setpay',
        'application/set-payment-initiation'
    ],
    [
        'setreg',
        'application/set-registration-initiation'
    ],
    [
        'sfd-hdstx',
        'application/vnd.hydrostatix.sof-data'
    ],
    [
        'sfs',
        'application/vnd.spotfire.sfs'
    ],
    [
        'sfv',
        'text/x-sfv'
    ],
    [
        'sgi',
        'image/sgi'
    ],
    [
        'sgl',
        'application/vnd.stardivision.writer-global'
    ],
    [
        'sgm',
        'text/sgml'
    ],
    [
        'sgml',
        'text/sgml'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'shar',
        'application/x-shar'
    ],
    [
        'shex',
        'text/shex'
    ],
    [
        'shf',
        'application/shf+xml'
    ],
    [
        'shtml',
        'text/html'
    ],
    [
        'sid',
        'image/x-mrsid-image'
    ],
    [
        'sieve',
        'application/sieve'
    ],
    [
        'sig',
        'application/pgp-signature'
    ],
    [
        'sil',
        'audio/silk'
    ],
    [
        'silo',
        'model/mesh'
    ],
    [
        'sis',
        'application/vnd.symbian.install'
    ],
    [
        'sisx',
        'application/vnd.symbian.install'
    ],
    [
        'sit',
        'application/x-stuffit'
    ],
    [
        'sitx',
        'application/x-stuffitx'
    ],
    [
        'siv',
        'application/sieve'
    ],
    [
        'skd',
        'application/vnd.koan'
    ],
    [
        'skm',
        'application/vnd.koan'
    ],
    [
        'skp',
        'application/vnd.koan'
    ],
    [
        'skt',
        'application/vnd.koan'
    ],
    [
        'sldm',
        'application/vnd.ms-powerpoint.slide.macroenabled.12'
    ],
    [
        'sldx',
        'application/vnd.openxmlformats-officedocument.presentationml.slide'
    ],
    [
        'slim',
        'text/slim'
    ],
    [
        'slm',
        'text/slim'
    ],
    [
        'sls',
        'application/route-s-tsid+xml'
    ],
    [
        'slt',
        'application/vnd.epson.salt'
    ],
    [
        'sm',
        'application/vnd.stepmania.stepchart'
    ],
    [
        'smf',
        'application/vnd.stardivision.math'
    ],
    [
        'smi',
        'application/smil'
    ],
    [
        'smil',
        'application/smil'
    ],
    [
        'smv',
        'video/x-smv'
    ],
    [
        'smzip',
        'application/vnd.stepmania.package'
    ],
    [
        'snd',
        'audio/basic'
    ],
    [
        'snf',
        'application/x-font-snf'
    ],
    [
        'so',
        'application/octet-stream'
    ],
    [
        'spc',
        'application/x-pkcs7-certificates'
    ],
    [
        'spdx',
        'text/spdx'
    ],
    [
        'spf',
        'application/vnd.yamaha.smaf-phrase'
    ],
    [
        'spl',
        'application/x-futuresplash'
    ],
    [
        'spot',
        'text/vnd.in3d.spot'
    ],
    [
        'spp',
        'application/scvp-vp-response'
    ],
    [
        'spq',
        'application/scvp-vp-request'
    ],
    [
        'spx',
        'audio/ogg'
    ],
    [
        'sql',
        'application/x-sql'
    ],
    [
        'src',
        'application/x-wais-source'
    ],
    [
        'srt',
        'application/x-subrip'
    ],
    [
        'sru',
        'application/sru+xml'
    ],
    [
        'srx',
        'application/sparql-results+xml'
    ],
    [
        'ssdl',
        'application/ssdl+xml'
    ],
    [
        'sse',
        'application/vnd.kodak-descriptor'
    ],
    [
        'ssf',
        'application/vnd.epson.ssf'
    ],
    [
        'ssml',
        'application/ssml+xml'
    ],
    [
        'sst',
        'application/octet-stream'
    ],
    [
        'st',
        'application/vnd.sailingtracker.track'
    ],
    [
        'stc',
        'application/vnd.sun.xml.calc.template'
    ],
    [
        'std',
        'application/vnd.sun.xml.draw.template'
    ],
    [
        'stf',
        'application/vnd.wt.stf'
    ],
    [
        'sti',
        'application/vnd.sun.xml.impress.template'
    ],
    [
        'stk',
        'application/hyperstudio'
    ],
    [
        'stl',
        'model/stl'
    ],
    [
        'stpx',
        'model/step+xml'
    ],
    [
        'stpxz',
        'model/step-xml+zip'
    ],
    [
        'stpz',
        'model/step+zip'
    ],
    [
        'str',
        'application/vnd.pg.format'
    ],
    [
        'stw',
        'application/vnd.sun.xml.writer.template'
    ],
    [
        'styl',
        'text/stylus'
    ],
    [
        'stylus',
        'text/stylus'
    ],
    [
        'sub',
        'text/vnd.dvb.subtitle'
    ],
    [
        'sus',
        'application/vnd.sus-calendar'
    ],
    [
        'susp',
        'application/vnd.sus-calendar'
    ],
    [
        'sv4cpio',
        'application/x-sv4cpio'
    ],
    [
        'sv4crc',
        'application/x-sv4crc'
    ],
    [
        'svc',
        'application/vnd.dvb.service'
    ],
    [
        'svd',
        'application/vnd.svd'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'svgz',
        'image/svg+xml'
    ],
    [
        'swa',
        'application/x-director'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'swi',
        'application/vnd.aristanetworks.swi'
    ],
    [
        'swidtag',
        'application/swid+xml'
    ],
    [
        'sxc',
        'application/vnd.sun.xml.calc'
    ],
    [
        'sxd',
        'application/vnd.sun.xml.draw'
    ],
    [
        'sxg',
        'application/vnd.sun.xml.writer.global'
    ],
    [
        'sxi',
        'application/vnd.sun.xml.impress'
    ],
    [
        'sxm',
        'application/vnd.sun.xml.math'
    ],
    [
        'sxw',
        'application/vnd.sun.xml.writer'
    ],
    [
        't',
        'text/troff'
    ],
    [
        't3',
        'application/x-t3vm-image'
    ],
    [
        't38',
        'image/t38'
    ],
    [
        'taglet',
        'application/vnd.mynfc'
    ],
    [
        'tao',
        'application/vnd.tao.intent-module-archive'
    ],
    [
        'tap',
        'image/vnd.tencent.tap'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tcap',
        'application/vnd.3gpp2.tcap'
    ],
    [
        'tcl',
        'application/x-tcl'
    ],
    [
        'td',
        'application/urc-targetdesc+xml'
    ],
    [
        'teacher',
        'application/vnd.smart.teacher'
    ],
    [
        'tei',
        'application/tei+xml'
    ],
    [
        'teicorpus',
        'application/tei+xml'
    ],
    [
        'tex',
        'application/x-tex'
    ],
    [
        'texi',
        'application/x-texinfo'
    ],
    [
        'texinfo',
        'application/x-texinfo'
    ],
    [
        'text',
        'text/plain'
    ],
    [
        'tfi',
        'application/thraud+xml'
    ],
    [
        'tfm',
        'application/x-tex-tfm'
    ],
    [
        'tfx',
        'image/tiff-fx'
    ],
    [
        'tga',
        'image/x-tga'
    ],
    [
        'tgz',
        'application/x-tar'
    ],
    [
        'thmx',
        'application/vnd.ms-officetheme'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'tk',
        'application/x-tcl'
    ],
    [
        'tmo',
        'application/vnd.tmobile-livetv'
    ],
    [
        'toml',
        'application/toml'
    ],
    [
        'torrent',
        'application/x-bittorrent'
    ],
    [
        'tpl',
        'application/vnd.groove-tool-template'
    ],
    [
        'tpt',
        'application/vnd.trid.tpt'
    ],
    [
        'tr',
        'text/troff'
    ],
    [
        'tra',
        'application/vnd.trueapp'
    ],
    [
        'trig',
        'application/trig'
    ],
    [
        'trm',
        'application/x-msterminal'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'tsd',
        'application/timestamped-data'
    ],
    [
        'tsv',
        'text/tab-separated-values'
    ],
    [
        'ttc',
        'font/collection'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'ttl',
        'text/turtle'
    ],
    [
        'ttml',
        'application/ttml+xml'
    ],
    [
        'twd',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'twds',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'txd',
        'application/vnd.genomatix.tuxedo'
    ],
    [
        'txf',
        'application/vnd.mobius.txf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'u8dsn',
        'message/global-delivery-status'
    ],
    [
        'u8hdr',
        'message/global-headers'
    ],
    [
        'u8mdn',
        'message/global-disposition-notification'
    ],
    [
        'u8msg',
        'message/global'
    ],
    [
        'u32',
        'application/x-authorware-bin'
    ],
    [
        'ubj',
        'application/ubjson'
    ],
    [
        'udeb',
        'application/x-debian-package'
    ],
    [
        'ufd',
        'application/vnd.ufdl'
    ],
    [
        'ufdl',
        'application/vnd.ufdl'
    ],
    [
        'ulx',
        'application/x-glulx'
    ],
    [
        'umj',
        'application/vnd.umajin'
    ],
    [
        'unityweb',
        'application/vnd.unity'
    ],
    [
        'uoml',
        'application/vnd.uoml+xml'
    ],
    [
        'uri',
        'text/uri-list'
    ],
    [
        'uris',
        'text/uri-list'
    ],
    [
        'urls',
        'text/uri-list'
    ],
    [
        'usdz',
        'model/vnd.usdz+zip'
    ],
    [
        'ustar',
        'application/x-ustar'
    ],
    [
        'utz',
        'application/vnd.uiq.theme'
    ],
    [
        'uu',
        'text/x-uuencode'
    ],
    [
        'uva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvd',
        'application/vnd.dece.data'
    ],
    [
        'uvf',
        'application/vnd.dece.data'
    ],
    [
        'uvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvv',
        'video/vnd.dece.video'
    ],
    [
        'uvva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvvd',
        'application/vnd.dece.data'
    ],
    [
        'uvvf',
        'application/vnd.dece.data'
    ],
    [
        'uvvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvvv',
        'video/vnd.dece.video'
    ],
    [
        'uvvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvvz',
        'application/vnd.dece.zip'
    ],
    [
        'uvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvz',
        'application/vnd.dece.zip'
    ],
    [
        'vbox',
        'application/x-virtualbox-vbox'
    ],
    [
        'vbox-extpack',
        'application/x-virtualbox-vbox-extpack'
    ],
    [
        'vcard',
        'text/vcard'
    ],
    [
        'vcd',
        'application/x-cdlink'
    ],
    [
        'vcf',
        'text/x-vcard'
    ],
    [
        'vcg',
        'application/vnd.groove-vcard'
    ],
    [
        'vcs',
        'text/x-vcalendar'
    ],
    [
        'vcx',
        'application/vnd.vcx'
    ],
    [
        'vdi',
        'application/x-virtualbox-vdi'
    ],
    [
        'vds',
        'model/vnd.sap.vds'
    ],
    [
        'vhd',
        'application/x-virtualbox-vhd'
    ],
    [
        'vis',
        'application/vnd.visionary'
    ],
    [
        'viv',
        'video/vnd.vivo'
    ],
    [
        'vlc',
        'application/videolan'
    ],
    [
        'vmdk',
        'application/x-virtualbox-vmdk'
    ],
    [
        'vob',
        'video/x-ms-vob'
    ],
    [
        'vor',
        'application/vnd.stardivision.writer'
    ],
    [
        'vox',
        'application/x-authorware-bin'
    ],
    [
        'vrml',
        'model/vrml'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'vsf',
        'application/vnd.vsf'
    ],
    [
        'vss',
        'application/vnd.visio'
    ],
    [
        'vst',
        'application/vnd.visio'
    ],
    [
        'vsw',
        'application/vnd.visio'
    ],
    [
        'vtf',
        'image/vnd.valve.source.texture'
    ],
    [
        'vtt',
        'text/vtt'
    ],
    [
        'vtu',
        'model/vnd.vtu'
    ],
    [
        'vxml',
        'application/voicexml+xml'
    ],
    [
        'w3d',
        'application/x-director'
    ],
    [
        'wad',
        'application/x-doom'
    ],
    [
        'wadl',
        'application/vnd.sun.wadl+xml'
    ],
    [
        'war',
        'application/java-archive'
    ],
    [
        'wasm',
        'application/wasm'
    ],
    [
        'wav',
        'audio/x-wav'
    ],
    [
        'wax',
        'audio/x-ms-wax'
    ],
    [
        'wbmp',
        'image/vnd.wap.wbmp'
    ],
    [
        'wbs',
        'application/vnd.criticaltools.wbs+xml'
    ],
    [
        'wbxml',
        'application/wbxml'
    ],
    [
        'wcm',
        'application/vnd.ms-works'
    ],
    [
        'wdb',
        'application/vnd.ms-works'
    ],
    [
        'wdp',
        'image/vnd.ms-photo'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webapp',
        'application/x-web-app-manifest+json'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webmanifest',
        'application/manifest+json'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'wg',
        'application/vnd.pmi.widget'
    ],
    [
        'wgt',
        'application/widget'
    ],
    [
        'wks',
        'application/vnd.ms-works'
    ],
    [
        'wm',
        'video/x-ms-wm'
    ],
    [
        'wma',
        'audio/x-ms-wma'
    ],
    [
        'wmd',
        'application/x-ms-wmd'
    ],
    [
        'wmf',
        'image/wmf'
    ],
    [
        'wml',
        'text/vnd.wap.wml'
    ],
    [
        'wmlc',
        'application/wmlc'
    ],
    [
        'wmls',
        'text/vnd.wap.wmlscript'
    ],
    [
        'wmlsc',
        'application/vnd.wap.wmlscriptc'
    ],
    [
        'wmv',
        'video/x-ms-wmv'
    ],
    [
        'wmx',
        'video/x-ms-wmx'
    ],
    [
        'wmz',
        'application/x-msmetafile'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'word',
        'application/msword'
    ],
    [
        'wpd',
        'application/vnd.wordperfect'
    ],
    [
        'wpl',
        'application/vnd.ms-wpl'
    ],
    [
        'wps',
        'application/vnd.ms-works'
    ],
    [
        'wqd',
        'application/vnd.wqd'
    ],
    [
        'wri',
        'application/x-mswrite'
    ],
    [
        'wrl',
        'model/vrml'
    ],
    [
        'wsc',
        'message/vnd.wfa.wsc'
    ],
    [
        'wsdl',
        'application/wsdl+xml'
    ],
    [
        'wspolicy',
        'application/wspolicy+xml'
    ],
    [
        'wtb',
        'application/vnd.webturbo'
    ],
    [
        'wvx',
        'video/x-ms-wvx'
    ],
    [
        'x3d',
        'model/x3d+xml'
    ],
    [
        'x3db',
        'model/x3d+fastinfoset'
    ],
    [
        'x3dbz',
        'model/x3d+binary'
    ],
    [
        'x3dv',
        'model/x3d-vrml'
    ],
    [
        'x3dvz',
        'model/x3d+vrml'
    ],
    [
        'x3dz',
        'model/x3d+xml'
    ],
    [
        'x32',
        'application/x-authorware-bin'
    ],
    [
        'x_b',
        'model/vnd.parasolid.transmit.binary'
    ],
    [
        'x_t',
        'model/vnd.parasolid.transmit.text'
    ],
    [
        'xaml',
        'application/xaml+xml'
    ],
    [
        'xap',
        'application/x-silverlight-app'
    ],
    [
        'xar',
        'application/vnd.xara'
    ],
    [
        'xav',
        'application/xcap-att+xml'
    ],
    [
        'xbap',
        'application/x-ms-xbap'
    ],
    [
        'xbd',
        'application/vnd.fujixerox.docuworks.binder'
    ],
    [
        'xbm',
        'image/x-xbitmap'
    ],
    [
        'xca',
        'application/xcap-caps+xml'
    ],
    [
        'xcs',
        'application/calendar+xml'
    ],
    [
        'xdf',
        'application/xcap-diff+xml'
    ],
    [
        'xdm',
        'application/vnd.syncml.dm+xml'
    ],
    [
        'xdp',
        'application/vnd.adobe.xdp+xml'
    ],
    [
        'xdssc',
        'application/dssc+xml'
    ],
    [
        'xdw',
        'application/vnd.fujixerox.docuworks'
    ],
    [
        'xel',
        'application/xcap-el+xml'
    ],
    [
        'xenc',
        'application/xenc+xml'
    ],
    [
        'xer',
        'application/patch-ops-error+xml'
    ],
    [
        'xfdf',
        'application/vnd.adobe.xfdf'
    ],
    [
        'xfdl',
        'application/vnd.xfdl'
    ],
    [
        'xht',
        'application/xhtml+xml'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xhvml',
        'application/xv+xml'
    ],
    [
        'xif',
        'image/vnd.xiff'
    ],
    [
        'xl',
        'application/excel'
    ],
    [
        'xla',
        'application/vnd.ms-excel'
    ],
    [
        'xlam',
        'application/vnd.ms-excel.addin.macroEnabled.12'
    ],
    [
        'xlc',
        'application/vnd.ms-excel'
    ],
    [
        'xlf',
        'application/xliff+xml'
    ],
    [
        'xlm',
        'application/vnd.ms-excel'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsb',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    ],
    [
        'xlsm',
        'application/vnd.ms-excel.sheet.macroEnabled.12'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xlt',
        'application/vnd.ms-excel'
    ],
    [
        'xltm',
        'application/vnd.ms-excel.template.macroEnabled.12'
    ],
    [
        'xltx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
    ],
    [
        'xlw',
        'application/vnd.ms-excel'
    ],
    [
        'xm',
        'audio/xm'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xns',
        'application/xcap-ns+xml'
    ],
    [
        'xo',
        'application/vnd.olpc-sugar'
    ],
    [
        'xop',
        'application/xop+xml'
    ],
    [
        'xpi',
        'application/x-xpinstall'
    ],
    [
        'xpl',
        'application/xproc+xml'
    ],
    [
        'xpm',
        'image/x-xpixmap'
    ],
    [
        'xpr',
        'application/vnd.is-xpr'
    ],
    [
        'xps',
        'application/vnd.ms-xpsdocument'
    ],
    [
        'xpw',
        'application/vnd.intercon.formnet'
    ],
    [
        'xpx',
        'application/vnd.intercon.formnet'
    ],
    [
        'xsd',
        'application/xml'
    ],
    [
        'xsl',
        'application/xml'
    ],
    [
        'xslt',
        'application/xslt+xml'
    ],
    [
        'xsm',
        'application/vnd.syncml+xml'
    ],
    [
        'xspf',
        'application/xspf+xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'xvm',
        'application/xv+xml'
    ],
    [
        'xvml',
        'application/xv+xml'
    ],
    [
        'xwd',
        'image/x-xwindowdump'
    ],
    [
        'xyz',
        'chemical/x-xyz'
    ],
    [
        'xz',
        'application/x-xz'
    ],
    [
        'yaml',
        'text/yaml'
    ],
    [
        'yang',
        'application/yang'
    ],
    [
        'yin',
        'application/yin+xml'
    ],
    [
        'yml',
        'text/yaml'
    ],
    [
        'ymp',
        'text/x-suse-ymp'
    ],
    [
        'z',
        'application/x-compress'
    ],
    [
        'z1',
        'application/x-zmachine'
    ],
    [
        'z2',
        'application/x-zmachine'
    ],
    [
        'z3',
        'application/x-zmachine'
    ],
    [
        'z4',
        'application/x-zmachine'
    ],
    [
        'z5',
        'application/x-zmachine'
    ],
    [
        'z6',
        'application/x-zmachine'
    ],
    [
        'z7',
        'application/x-zmachine'
    ],
    [
        'z8',
        'application/x-zmachine'
    ],
    [
        'zaz',
        'application/vnd.zzazz.deck+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        'zir',
        'application/vnd.zul'
    ],
    [
        'zirz',
        'application/vnd.zul'
    ],
    [
        'zmm',
        'application/vnd.handheld-entertainment+xml'
    ],
    [
        'zsh',
        'text/x-scriptzsh'
    ]
]);
function $e9a9fcd6657705fd$export$8cc09085015f0dc7(file, path, h) {
    const f = $e9a9fcd6657705fd$var$withMimeType(file);
    const { webkitRelativePath: webkitRelativePath } = file;
    const p = typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
    if (typeof f.path !== 'string') $e9a9fcd6657705fd$var$setObjProp(f, 'path', p);
    if (h !== undefined) Object.defineProperty(f, 'handle', {
        value: h,
        writable: false,
        configurable: false,
        enumerable: true
    });
    // Always populate a relative path so that even electron apps have access to a relativePath value
    $e9a9fcd6657705fd$var$setObjProp(f, 'relativePath', p);
    return f;
}
function $e9a9fcd6657705fd$var$withMimeType(file) {
    const { name: name } = file;
    const hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        const ext = name.split('.').pop().toLowerCase();
        const type = $e9a9fcd6657705fd$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}
function $e9a9fcd6657705fd$var$setObjProp(f, key, value) {
    Object.defineProperty(f, key, {
        value: value,
        writable: false,
        configurable: false,
        enumerable: true
    });
}


const $4b31b39b82fbd152$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $4b31b39b82fbd152$export$a36e16046ae8f1bb(evt) {
    return (0, $6cfdc3b10104f1f6$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        if ($4b31b39b82fbd152$var$isObject(evt) && $4b31b39b82fbd152$var$isDataTransfer(evt.dataTransfer)) return $4b31b39b82fbd152$var$getDataTransferFiles(evt.dataTransfer, evt.type);
        else if ($4b31b39b82fbd152$var$isChangeEvt(evt)) return $4b31b39b82fbd152$var$getInputFiles(evt);
        else if (Array.isArray(evt) && evt.every((item)=>'getFile' in item && typeof item.getFile === 'function')) return $4b31b39b82fbd152$var$getFsHandleFiles(evt);
        return [];
    });
}
function $4b31b39b82fbd152$var$isDataTransfer(value) {
    return $4b31b39b82fbd152$var$isObject(value);
}
function $4b31b39b82fbd152$var$isChangeEvt(value) {
    return $4b31b39b82fbd152$var$isObject(value) && $4b31b39b82fbd152$var$isObject(value.target);
}
function $4b31b39b82fbd152$var$isObject(v) {
    return typeof v === 'object' && v !== null;
}
function $4b31b39b82fbd152$var$getInputFiles(evt) {
    return $4b31b39b82fbd152$var$fromList(evt.target.files).map((file)=>(0, $e9a9fcd6657705fd$export$8cc09085015f0dc7)(file));
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $4b31b39b82fbd152$var$getFsHandleFiles(handles) {
    return (0, $6cfdc3b10104f1f6$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        const files = yield Promise.all(handles.map((h)=>h.getFile()));
        return files.map((file)=>(0, $e9a9fcd6657705fd$export$8cc09085015f0dc7)(file));
    });
}
function $4b31b39b82fbd152$var$getDataTransferFiles(dt, type) {
    return (0, $6cfdc3b10104f1f6$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        // IE11 does not support dataTransfer.items
        // See https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/items#Browser_compatibility
        if (dt.items) {
            const items = $4b31b39b82fbd152$var$fromList(dt.items).filter((item)=>item.kind === 'file');
            // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
            // only 'dragstart' and 'drop' has access to the data (source node)
            if (type !== 'drop') return items;
            const files = yield Promise.all(items.map($4b31b39b82fbd152$var$toFilePromises));
            return $4b31b39b82fbd152$var$noIgnoredFiles($4b31b39b82fbd152$var$flatten(files));
        }
        return $4b31b39b82fbd152$var$noIgnoredFiles($4b31b39b82fbd152$var$fromList(dt.files).map((file)=>(0, $e9a9fcd6657705fd$export$8cc09085015f0dc7)(file)));
    });
}
function $4b31b39b82fbd152$var$noIgnoredFiles(files) {
    return files.filter((file)=>$4b31b39b82fbd152$var$FILES_TO_IGNORE.indexOf(file.name) === -1);
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $4b31b39b82fbd152$var$fromList(items) {
    if (items === null) return [];
    const files = [];
    // tslint:disable: prefer-for-of
    for(let i = 0; i < items.length; i++){
        const file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $4b31b39b82fbd152$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $4b31b39b82fbd152$var$fromDataTransferItem(item);
    const entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $4b31b39b82fbd152$var$fromDirEntry(entry);
    return $4b31b39b82fbd152$var$fromDataTransferItem(item, entry);
}
function $4b31b39b82fbd152$var$flatten(items) {
    return items.reduce((acc, files)=>[
            ...acc,
            ...Array.isArray(files) ? $4b31b39b82fbd152$var$flatten(files) : [
                files
            ]
        ], []);
}
function $4b31b39b82fbd152$var$fromDataTransferItem(item, entry) {
    var _a;
    if (typeof item.getAsFileSystemHandle === 'function') return item.getAsFileSystemHandle().then((h)=>(0, $6cfdc3b10104f1f6$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const file = yield h.getFile();
            file.handle = h;
            return (0, $e9a9fcd6657705fd$export$8cc09085015f0dc7)(file);
        }));
    const file = item.getAsFile();
    if (!file) return Promise.reject(`${item} is not a File`);
    const fwp = (0, $e9a9fcd6657705fd$export$8cc09085015f0dc7)(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : undefined);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $4b31b39b82fbd152$var$fromEntry(entry) {
    return (0, $6cfdc3b10104f1f6$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return entry.isDirectory ? $4b31b39b82fbd152$var$fromDirEntry(entry) : $4b31b39b82fbd152$var$fromFileEntry(entry);
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $4b31b39b82fbd152$var$fromDirEntry(entry) {
    const reader = entry.createReader();
    return new Promise((resolve, reject)=>{
        const entries = [];
        function readEntries() {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries((batch)=>(0, $6cfdc3b10104f1f6$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    if (!batch.length) // Done reading directory
                    try {
                        const files = yield Promise.all(entries);
                        resolve(files);
                    } catch (err) {
                        reject(err);
                    }
                    else {
                        const items = Promise.all(batch.map($4b31b39b82fbd152$var$fromEntry));
                        entries.push(items);
                        // Continue reading
                        readEntries();
                    }
                }), (err)=>{
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $4b31b39b82fbd152$var$fromFileEntry(entry) {
    return (0, $6cfdc3b10104f1f6$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            entry.file((file)=>{
                const fwp = (0, $e9a9fcd6657705fd$export$8cc09085015f0dc7)(file, entry.fullPath);
                resolve(fwp);
            }, (err)=>{
                reject(err);
            });
        });
    });
}




var $76de1e2649b50922$export$1e511d4a378977f5;
var $76de1e2649b50922$export$2e2bcd8739ae039;
"use strict";
$76de1e2649b50922$export$1e511d4a378977f5 = true;
$76de1e2649b50922$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};


function $be591601fb91e577$var$_toConsumableArray(arr) {
    return $be591601fb91e577$var$_arrayWithoutHoles(arr) || $be591601fb91e577$var$_iterableToArray(arr) || $be591601fb91e577$var$_unsupportedIterableToArray(arr) || $be591601fb91e577$var$_nonIterableSpread();
}
function $be591601fb91e577$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $be591601fb91e577$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $be591601fb91e577$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $be591601fb91e577$var$_arrayLikeToArray(arr);
}
function $be591601fb91e577$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $be591601fb91e577$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $be591601fb91e577$var$ownKeys(Object(source), !0).forEach(function(key) {
            $be591601fb91e577$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $be591601fb91e577$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $be591601fb91e577$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $be591601fb91e577$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $be591601fb91e577$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $be591601fb91e577$var$_typeof(obj);
}
function $be591601fb91e577$var$_slicedToArray(arr, i) {
    return $be591601fb91e577$var$_arrayWithHoles(arr) || $be591601fb91e577$var$_iterableToArrayLimit(arr, i) || $be591601fb91e577$var$_unsupportedIterableToArray(arr, i) || $be591601fb91e577$var$_nonIterableRest();
}
function $be591601fb91e577$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $be591601fb91e577$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $be591601fb91e577$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $be591601fb91e577$var$_arrayLikeToArray(o, minLen);
}
function $be591601fb91e577$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $be591601fb91e577$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $be591601fb91e577$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $be591601fb91e577$var$accepts = typeof (0, $76de1e2649b50922$export$2e2bcd8739ae039) === "function" ? (0, $76de1e2649b50922$export$2e2bcd8739ae039) : (0, $76de1e2649b50922$export$2e2bcd8739ae039).default; // Error codes
var $be591601fb91e577$export$d2c35cc369247232 = "file-invalid-type";
var $be591601fb91e577$export$d7bd1185abe1e87c = "file-too-large";
var $be591601fb91e577$export$8bd5ec6ed990dc9 = "file-too-small";
var $be591601fb91e577$export$3271ef1d2dd155f9 = "too-many-files";
var $be591601fb91e577$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $be591601fb91e577$export$d2c35cc369247232,
    FileTooLarge: $be591601fb91e577$export$d7bd1185abe1e87c,
    FileTooSmall: $be591601fb91e577$export$8bd5ec6ed990dc9,
    TooManyFiles: $be591601fb91e577$export$3271ef1d2dd155f9
};
var $be591601fb91e577$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr() {
    var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var acceptArr = accept.split(",");
    var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
    return {
        code: $be591601fb91e577$export$d2c35cc369247232,
        message: "File type must be ".concat(msg)
    };
};
var $be591601fb91e577$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $be591601fb91e577$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $be591601fb91e577$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $be591601fb91e577$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $be591601fb91e577$export$1e1e1b6120329fe = {
    code: $be591601fb91e577$export$3271ef1d2dd155f9,
    message: "Too many files"
};
function $be591601fb91e577$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || $be591601fb91e577$var$accepts(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $be591601fb91e577$export$bc0bbda045f09b5a(accept)
    ];
}
function $be591601fb91e577$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($be591601fb91e577$var$isDefined(file.size)) {
        if ($be591601fb91e577$var$isDefined(minSize) && $be591601fb91e577$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $be591601fb91e577$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $be591601fb91e577$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($be591601fb91e577$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $be591601fb91e577$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($be591601fb91e577$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $be591601fb91e577$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $be591601fb91e577$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $be591601fb91e577$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $be591601fb91e577$export$b511db3632effe58(file, accept), _fileAccepted2 = $be591601fb91e577$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $be591601fb91e577$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $be591601fb91e577$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $be591601fb91e577$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $be591601fb91e577$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $be591601fb91e577$export$f9006bf02b243736(item) {
    return $be591601fb91e577$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $be591601fb91e577$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $be591601fb91e577$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $be591601fb91e577$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $be591601fb91e577$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $be591601fb91e577$var$isIe(userAgent) || $be591601fb91e577$var$isEdge(userAgent);
}
function $be591601fb91e577$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$be591601fb91e577$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $be591601fb91e577$export$8d6d6472146de265(event);
        });
    };
}
function $be591601fb91e577$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $be591601fb91e577$export$8ce4bd13c494743e(accept) {
    if ($be591601fb91e577$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $be591601fb91e577$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$be591601fb91e577$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($be591601fb91e577$export$42c2be5a6d408120)) {
                console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $be591601fb91e577$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $be591601fb91e577$var$_objectSpread($be591601fb91e577$var$_objectSpread({}, agg), {}, $be591601fb91e577$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $be591601fb91e577$export$1278288bcefb97b9(accept) {
    if ($be591601fb91e577$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $be591601fb91e577$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($be591601fb91e577$var$_toConsumableArray(a), [
            mimeType
        ], $be591601fb91e577$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $be591601fb91e577$export$69c8ec3250e1cfbf(v) || $be591601fb91e577$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $be591601fb91e577$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $be591601fb91e577$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $be591601fb91e577$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $be591601fb91e577$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 



var $2b0e4d8a59340d66$var$_excluded = [
    "children"
], $2b0e4d8a59340d66$var$_excluded2 = [
    "open"
], $2b0e4d8a59340d66$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $2b0e4d8a59340d66$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $2b0e4d8a59340d66$var$_toConsumableArray(arr) {
    return $2b0e4d8a59340d66$var$_arrayWithoutHoles(arr) || $2b0e4d8a59340d66$var$_iterableToArray(arr) || $2b0e4d8a59340d66$var$_unsupportedIterableToArray(arr) || $2b0e4d8a59340d66$var$_nonIterableSpread();
}
function $2b0e4d8a59340d66$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2b0e4d8a59340d66$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $2b0e4d8a59340d66$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2b0e4d8a59340d66$var$_arrayLikeToArray(arr);
}
function $2b0e4d8a59340d66$var$_slicedToArray(arr, i) {
    return $2b0e4d8a59340d66$var$_arrayWithHoles(arr) || $2b0e4d8a59340d66$var$_iterableToArrayLimit(arr, i) || $2b0e4d8a59340d66$var$_unsupportedIterableToArray(arr, i) || $2b0e4d8a59340d66$var$_nonIterableRest();
}
function $2b0e4d8a59340d66$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2b0e4d8a59340d66$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2b0e4d8a59340d66$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2b0e4d8a59340d66$var$_arrayLikeToArray(o, minLen);
}
function $2b0e4d8a59340d66$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2b0e4d8a59340d66$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2b0e4d8a59340d66$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2b0e4d8a59340d66$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2b0e4d8a59340d66$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2b0e4d8a59340d66$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2b0e4d8a59340d66$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2b0e4d8a59340d66$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2b0e4d8a59340d66$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2b0e4d8a59340d66$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2b0e4d8a59340d66$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2b0e4d8a59340d66$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $2b0e4d8a59340d66$var$Dropzone = /*#__PURE__*/ (0, $l7WPE.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $2b0e4d8a59340d66$var$_objectWithoutProperties(_ref, $2b0e4d8a59340d66$var$_excluded);
    var _useDropzone = $2b0e4d8a59340d66$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $2b0e4d8a59340d66$var$_objectWithoutProperties(_useDropzone, $2b0e4d8a59340d66$var$_excluded2);
    (0, $l7WPE.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $l7WPE.Fragment), null, children($2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$2b0e4d8a59340d66$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $2b0e4d8a59340d66$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $4b31b39b82fbd152$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: false,
    autoFocus: false
};
$2b0e4d8a59340d66$var$Dropzone.defaultProps = $2b0e4d8a59340d66$var$defaultProps;
$2b0e4d8a59340d66$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($68945e6541b034d4$exports))).func
};
var $2b0e4d8a59340d66$export$2e2bcd8739ae039 = $2b0e4d8a59340d66$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $2b0e4d8a59340d66$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $2b0e4d8a59340d66$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_objectSpread({}, $2b0e4d8a59340d66$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $l7WPE.useMemo)(function() {
        return (0, $be591601fb91e577$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $l7WPE.useMemo)(function() {
        return (0, $be591601fb91e577$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $l7WPE.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $2b0e4d8a59340d66$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $l7WPE.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $2b0e4d8a59340d66$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $l7WPE.useRef)(null);
    var inputRef = (0, $l7WPE.useRef)(null);
    var _useReducer = (0, $l7WPE.useReducer)($2b0e4d8a59340d66$var$reducer, $2b0e4d8a59340d66$var$initialState), _useReducer2 = $2b0e4d8a59340d66$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $l7WPE.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $be591601fb91e577$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $l7WPE.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $l7WPE.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $l7WPE.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $be591601fb91e577$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $be591601fb91e577$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $l7WPE.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $l7WPE.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $l7WPE.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($2b0e4d8a59340d66$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $be591601fb91e577$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $be591601fb91e577$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $be591601fb91e577$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $l7WPE.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $be591601fb91e577$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $l7WPE.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $be591601fb91e577$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $l7WPE.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $be591601fb91e577$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $2b0e4d8a59340d66$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $be591601fb91e577$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $2b0e4d8a59340d66$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $be591601fb91e577$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            isDragReject: fileRejections.length > 0,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $l7WPE.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $be591601fb91e577$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $be591601fb91e577$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $l7WPE.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $be591601fb91e577$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $be591601fb91e577$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $l7WPE.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $l7WPE.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $l7WPE.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $l7WPE.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $be591601fb91e577$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $l7WPE.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $2b0e4d8a59340d66$var$_objectWithoutProperties(_ref2, $2b0e4d8a59340d66$var$_excluded3);
            return $2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $be591601fb91e577$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $be591601fb91e577$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $be591601fb91e577$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $be591601fb91e577$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $be591601fb91e577$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $be591601fb91e577$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $be591601fb91e577$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $be591601fb91e577$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $l7WPE.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $l7WPE.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $2b0e4d8a59340d66$var$_objectWithoutProperties(_ref3, $2b0e4d8a59340d66$var$_excluded4);
            var inputProps = $2b0e4d8a59340d66$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    border: 0,
                    clip: "rect(0, 0, 0, 0)",
                    clipPath: "inset(50%)",
                    height: "1px",
                    margin: "0 -1px -1px 0",
                    overflow: "hidden",
                    padding: 0,
                    position: "absolute",
                    width: "1px",
                    whiteSpace: "nowrap"
                },
                onChange: composeHandler((0, $be591601fb91e577$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $be591601fb91e577$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $2b0e4d8a59340d66$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_objectSpread({}, $2b0e4d8a59340d66$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $2b0e4d8a59340d66$var$_objectSpread($2b0e4d8a59340d66$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections,
                isDragReject: action.isDragReject
            });
        case "reset":
            return $2b0e4d8a59340d66$var$_objectSpread({}, $2b0e4d8a59340d66$var$initialState);
        default:
            return state;
    }
}
function $2b0e4d8a59340d66$var$noop() {}




class $e4cecf2d6be4f96f$var$Parser {
    #view;
    #ptr = 0;
    #characters = {};
    constructor(buffer, characters = {}){
        this.#view = new DataView(buffer);
        this.#characters = characters;
    }
    getUint8() {
        return this.#view.getUint8(this.#ptr++);
    }
    getInt8() {
        return this.#view.getInt8(this.#ptr++);
    }
    getUint16() {
        const val = this.#view.getUint16(this.#ptr, true);
        this.#ptr += 2;
        return val;
    }
    getChar() {
        const charCode = this.getUint8();
        if (charCode === 0x00) return 0x00;
        const char = String.fromCodePoint(charCode);
        if (typeof this.#characters[char] !== 'undefined') return this.#characters[char];
        return char;
    }
    getString() {
        let str = '';
        let charCode;
        do {
            charCode = this.getUint8();
            if (charCode === 0x00) break;
            const flag = (charCode & 0x80) !== 0;
            charCode &= 0x7f;
            if (charCode < 8) {
                switch(charCode){
                    case 1:
                        // Line break
                        str += '<01>\n';
                        break;
                    case 2:
                        // Do not clear the text with the next `printEgo` call?
                        str += '<02>';
                        break;
                    case 3:
                        // New line
                        str += '<03>\n';
                        break;
                    case 4:
                        // Used only in the address sign.
                        str += `<Var[${this.getUint8()}]>`;
                        break;
                    case 0:
                    case 5:
                    case 6:
                    case 7:
                        throw new Error(`Unknown escape code ${charCode}.`);
                    default:
                        break;
                }
                continue;
            }
            let char = String.fromCodePoint(charCode);
            if (typeof this.#characters[char] === 'string') char = this.#characters[char];
            str += char;
            if (flag) str += ' ';
        }while (true);
        return str;
    }
    peekUint8() {
        return this.#view.getUint8(this.#ptr);
    }
    // Return the position of the next byte to read.
    get pointer() {
        return this.#ptr;
    }
    get length() {
        return this.#view.byteLength;
    }
}
var $e4cecf2d6be4f96f$export$2e2bcd8739ae039 = $e4cecf2d6be4f96f$var$Parser;



const $8a3ab9fe2b34fb09$var$assert = console.assert;
const $8a3ab9fe2b34fb09$var$parseRoomHeader = (arrayBuffer)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const chunkSize = parser.getUint16(); // Room res size
    const unk1 = parser.getUint8();
    const unk2 = parser.getUint8();
    $8a3ab9fe2b34fb09$var$assert(unk1 === 0, 'Unknown 1 is not 0.');
    const width = parser.getUint16(); // Room width
    const height = parser.getUint16(); // Room height
    $8a3ab9fe2b34fb09$var$assert(width === 28 || width === 60, 'Room width is not 28 or 60.');
    $8a3ab9fe2b34fb09$var$assert(height === 16, 'Room height is not 16.');
    const unk3 = parser.getUint16(); // Number objects in room (unused?)
    $8a3ab9fe2b34fb09$var$assert(unk3 === 0, 'Unknown 3 is not 0.');
    const nametableOffs = parser.getUint16(); // Gfx background tileset offset
    const attrOffs = parser.getUint16(); // Gfx background attr offset
    const maskOffs = parser.getUint16(); // Gfx mask offset
    const unk4 = parser.getUint16(); // charMap offset
    const unk5 = parser.getUint16(); // picMap offset
    $8a3ab9fe2b34fb09$var$assert(unk4 === unk5, 'The values of unknown 4 and 5 do not match.');
    const objectsNum = parser.getUint8();
    $8a3ab9fe2b34fb09$var$assert(objectsNum < 57, 'There are more than 56 objects in room.');
    const boxOffs = parser.getUint8();
    const soundsNum = parser.getUint8();
    $8a3ab9fe2b34fb09$var$assert(soundsNum === 0, 'The number of sounds is not 0.');
    const scriptsNum = parser.getUint8();
    const excdOffs = parser.getUint16(); // Exit script (EXCD) offset
    const encdOffs = parser.getUint16(); // Entry script (ENCD) offset
    const headerMap = {
        type: 'header',
        from: 0x00,
        to: 0x1c
    };
    const header = {
        chunkSize: chunkSize,
        unk1: unk1,
        unk2: unk2,
        width: width,
        height: height,
        unk3: unk3,
        nametableOffs: nametableOffs,
        attrOffs: attrOffs,
        maskOffs: maskOffs,
        unk4: unk4,
        unk5: unk5,
        objectsNum: objectsNum,
        boxOffs: boxOffs,
        soundsNum: soundsNum,
        scriptsNum: scriptsNum,
        excdOffs: excdOffs,
        encdOffs: encdOffs
    };
    return {
        headerMap: headerMap,
        header: header
    };
};
var $8a3ab9fe2b34fb09$export$2e2bcd8739ae039 = $8a3ab9fe2b34fb09$var$parseRoomHeader;



const $ea82b3f13f18c748$var$assert = console.assert;
const $ea82b3f13f18c748$var$parseRoomNametable = (arrayBuffer, offset = 0, width = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const nametable = Array(16);
    for(let i = 0; i < nametable.length; i++){
        nametable[i] = Array(64).fill(0);
        nametable[i][0] = 0;
        nametable[i][1] = 0;
        $ea82b3f13f18c748$var$assert(nametable[i][0] === 0, 'Gfx nametable strip does not start with 0x00 0x00.');
        $ea82b3f13f18c748$var$assert(nametable[i][1] === 0, 'Gfx nametable strip does not start with 0x00 0x00.');
        let n = 0;
        while(n < width){
            const loop = parser.getUint8();
            if (loop & 0x80) for(let j = 0; j < (loop & 0x7f); j++)nametable[i][2 + n++] = parser.getUint8();
            else {
                const data = parser.getUint8();
                for(let j = 0; j < (loop & 0x7f); j++)nametable[i][2 + n++] = data;
            }
        }
        $ea82b3f13f18c748$var$assert(nametable[i][62] === 0, 'Gfx nametable strip does not end with 0x00 0x00.');
        $ea82b3f13f18c748$var$assert(nametable[i][63] === 0, 'Gfx nametable strip does not end with 0x00 0x00.');
    }
    const nametableMap = {
        type: 'nametable',
        from: offset,
        to: offset + parser.pointer
    };
    return {
        nametable: nametable,
        nametableMap: nametableMap
    };
};
var $ea82b3f13f18c748$export$2e2bcd8739ae039 = $ea82b3f13f18c748$var$parseRoomNametable;



// Generic palette parser used in rooms and title screens.
const $4c0af675549ba9d7$var$parsePalette = (arrayBuffer, offset = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const palette = Array(16);
    for(let i = 0; i < 16; i++)palette[i] = parser.getUint8();
    const paletteMap = {
        type: 'palette',
        from: offset,
        to: offset + 16
    };
    return {
        palette: palette,
        paletteMap: paletteMap
    };
};
var $4c0af675549ba9d7$export$2e2bcd8739ae039 = $4c0af675549ba9d7$var$parsePalette;



const $c647a9503426e6d0$var$parseRoomAttributes = (arrayBuffer, offset = 0, width = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const attributes = Array(64).fill(0);
    let n = 0;
    while(n < 64){
        const loop = parser.getUint8();
        if (loop & 0x80) for(let j = 0; j < (loop & 0x7f); j++)attributes[n++] = parser.getUint8();
        else {
            const data = parser.getUint8();
            for(let j = 0; j < (loop & 0x7f); j++)attributes[n++] = data;
        }
        if (!(n & 7) && width === 28) n += 8;
    }
    const attributesMap = {
        type: 'attributes',
        from: offset,
        to: offset + parser.pointer
    };
    return {
        attributes: attributes,
        attributesMap: attributesMap
    };
};
var $c647a9503426e6d0$export$2e2bcd8739ae039 = $c647a9503426e6d0$var$parseRoomAttributes;



const $882bcb13a6442293$var$assert = console.assert;
const $882bcb13a6442293$var$parseRoomBoxes = (arrayBuffer, offset = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const boxNum = parser.getUint8();
    const boxes = [];
    for(let i = 0; i < boxNum; i++){
        const uy = parser.getUint8();
        const ly = parser.getUint8();
        const ulx = parser.getUint8();
        const urx = parser.getUint8();
        const llx = parser.getUint8();
        const lrx = parser.getUint8();
        const mask = parser.getUint8();
        const flags = parser.getUint8();
        $882bcb13a6442293$var$assert(ly >= uy, 'Y box bounds are out of order.');
        $882bcb13a6442293$var$assert(mask === 0 || mask === 1, 'Box mask is neither 0 nor 1.');
        $882bcb13a6442293$var$assert(flags === 0 || flags === 5, 'Box flag is neither 0 nor 5.');
        boxes.push({
            uy: uy,
            ly: ly,
            ulx: ulx,
            urx: urx,
            llx: llx,
            lrx: lrx,
            mask: mask,
            flags: flags
        });
    }
    $882bcb13a6442293$var$assert(boxes.length > 0, 'Room has no boxes.');
    const boxesMap = {
        type: 'boxes',
        from: offset,
        to: offset + parser.pointer
    };
    return {
        boxes: boxes,
        boxesMap: boxesMap
    };
};
var $882bcb13a6442293$export$2e2bcd8739ae039 = $882bcb13a6442293$var$parseRoomBoxes;



const $0198eeb8e9a60880$var$assert = console.assert;
const $0198eeb8e9a60880$var$parseRoomMatrix = (arrayBuffer, offset = 0, boxNum = 1)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const matrixUnks = [];
    for(let i = 0; i < boxNum; i++){
        const unk = parser.getUint8();
        $0198eeb8e9a60880$var$assert(unk === i * boxNum, 'The matrix does not have the expected values.');
        matrixUnks.push(unk);
    }
    const matrix = [];
    for(let i = 0; i < boxNum; i++)for(let j = 0; j < boxNum; j++){
        const box = parser.getUint8();
        $0198eeb8e9a60880$var$assert(box >= 0, 'The matrix has an out of bound value.'); // Always true since it's a uint8.
        // box should be strictly less than boxNum, but this fails in some cases.
        $0198eeb8e9a60880$var$assert(box <= boxNum, 'The matrix has an out of bound value.');
        matrix.push(box);
    }
    const matrixMap = {
        type: 'matrix',
        from: offset,
        to: offset + parser.pointer
    };
    return {
        matrixUnks: matrixUnks,
        matrix: matrix,
        matrixMap: matrixMap
    };
};
var $0198eeb8e9a60880$export$2e2bcd8739ae039 = $0198eeb8e9a60880$var$parseRoomMatrix;


/* eslint-disable no-fallthrough */ const $ca37204db6270d43$export$410015072f37b241 = {
    0x00: {
        name: 'stopObjectCode'
    },
    0x01: {
        name: 'putActor'
    },
    0x02: {
        name: 'startMusic'
    },
    0x03: {
        name: 'getActorRoom'
    },
    /* 04 */ 0x04: {
        name: 'isGreaterEqual'
    },
    0x05: {
        name: 'drawObject'
    },
    0x06: {
        name: 'getActorElevation'
    },
    0x07: {
        name: 'setState08'
    },
    /* 08 */ 0x08: {
        name: 'isNotEqual'
    },
    0x09: {
        name: 'faceActor'
    },
    0x0a: {
        name: 'assignVarWordIndirect'
    },
    0x0b: {
        name: 'setObjPreposition'
    },
    /* 0C */ 0x0c: {
        name: 'resourceRoutines'
    },
    0x0d: {
        name: 'walkActorToActor'
    },
    0x0e: {
        name: 'putActorAtObject'
    },
    0x0f: {
        name: 'ifNotState08'
    },
    /* 10 */ 0x10: {
        name: 'getObjectOwner'
    },
    0x11: {
        name: 'animateActor'
    },
    0x12: {
        name: 'panCameraTo'
    },
    0x13: {
        name: 'actorOps'
    },
    /* 14 */ 0x14: {
        name: 'print'
    },
    0x15: {
        name: 'actorFromPos'
    },
    0x16: {
        name: 'getRandomNr'
    },
    0x17: {
        name: 'clearState02'
    },
    /* 18 */ 0x18: {
        name: 'goTo'
    },
    0x19: {
        name: 'doSentence'
    },
    0x1a: {
        name: 'move'
    },
    0x1b: {
        name: 'setBitVar'
    },
    /* 1C */ 0x1c: {
        name: 'startSound'
    },
    0x1d: {
        name: 'ifClassOfIs'
    },
    0x1e: {
        name: 'walkActorTo'
    },
    0x1f: {
        name: 'ifState02'
    },
    /* 20 */ 0x20: {
        name: 'stopMusic'
    },
    0x21: {
        name: 'putActor'
    },
    0x22: {
        name: 'saveLoadGame'
    },
    0x23: {
        name: 'getActorY'
    },
    /* 24 */ 0x24: {
        name: 'loadRoomWithEgo'
    },
    0x25: {
        name: 'drawObject'
    },
    0x26: {
        name: 'setVarRange'
    },
    0x27: {
        name: 'setState04'
    },
    /* 28 */ 0x28: {
        name: 'equalZero'
    },
    0x29: {
        name: 'setOwnerOf'
    },
    0x2a: {
        name: 'addIndirect'
    },
    0x2b: {
        name: 'delayVariable'
    },
    /* 2C */ 0x2c: {
        name: 'assignVarByte'
    },
    0x2d: {
        name: 'putActorInRoom'
    },
    0x2e: {
        name: 'delay'
    },
    0x2f: {
        name: 'ifNotState04'
    },
    /* 30 */ 0x30: {
        name: 'setBoxFlags'
    },
    0x31: {
        name: 'getBitVar'
    },
    0x32: {
        name: 'setCameraAt'
    },
    0x33: {
        name: 'roomOps'
    },
    /* 34 */ 0x34: {
        name: 'getDist'
    },
    0x35: {
        name: 'findObject'
    },
    0x36: {
        name: 'walkActorToObject'
    },
    0x37: {
        name: 'setState01'
    },
    /* 38 */ 0x38: {
        name: 'isLessEqual'
    },
    0x39: {
        name: 'doSentence'
    },
    0x3a: {
        name: 'subtract'
    },
    0x3b: {
        name: 'waitForActor'
    },
    /* 3C */ 0x3c: {
        name: 'stopSound'
    },
    0x3d: {
        name: 'setActorElevation'
    },
    0x3e: {
        name: 'walkActorTo'
    },
    0x3f: {
        name: 'ifNotState01'
    },
    /* 40 */ 0x40: {
        name: 'cutscene'
    },
    0x41: {
        name: 'putActor'
    },
    0x42: {
        name: 'startScript'
    },
    0x43: {
        name: 'getActorX'
    },
    /* 44 */ 0x44: {
        name: 'isLess'
    },
    0x45: {
        name: 'drawObject'
    },
    0x46: {
        name: 'increment'
    },
    0x47: {
        name: 'clearState08'
    },
    /* 48 */ 0x48: {
        name: 'isEqual'
    },
    0x49: {
        name: 'faceActor'
    },
    0x4a: {
        name: 'chainScript'
    },
    0x4b: {
        name: 'setObjPreposition'
    },
    /* 4C */ 0x4c: {
        name: 'waitForSentence'
    },
    0x4d: {
        name: 'walkActorToActor'
    },
    0x4e: {
        name: 'putActorAtObject'
    },
    0x4f: {
        name: 'ifState08'
    },
    /* 50 */ 0x50: {
        name: 'pickupObject'
    },
    0x51: {
        name: 'animateActor'
    },
    0x52: {
        name: 'actorFollowCamera'
    },
    0x53: {
        name: 'actorOps'
    },
    /* 54 */ 0x54: {
        name: 'setObjectName'
    },
    0x55: {
        name: 'actorFromPos'
    },
    0x56: {
        name: 'getActorMoving'
    },
    0x57: {
        name: 'setState02'
    },
    /* 58 */ 0x58: {
        name: 'beginOverride'
    },
    0x59: {
        name: 'doSentence'
    },
    0x5a: {
        name: 'add'
    },
    0x5b: {
        name: 'setBitVar'
    },
    /* 5C */ 0x5c: {
        name: 'dummy'
    },
    0x5d: {
        name: 'ifClassOfIs'
    },
    0x5e: {
        name: 'walkActorTo'
    },
    0x5f: {
        name: 'ifNotState02'
    },
    /* 60 */ 0x60: {
        name: 'cursorCommand'
    },
    0x61: {
        name: 'putActor'
    },
    0x62: {
        name: 'stopScript'
    },
    0x63: {
        name: 'getActorFacing'
    },
    /* 64 */ 0x64: {
        name: 'loadRoomWithEgo'
    },
    0x65: {
        name: 'drawObject'
    },
    0x66: {
        name: 'getClosestObjActor'
    },
    0x67: {
        name: 'clearState04'
    },
    /* 68 */ 0x68: {
        name: 'isScriptRunning'
    },
    0x69: {
        name: 'setOwnerOf'
    },
    0x6a: {
        name: 'subIndirect'
    },
    0x6b: {
        name: 'dummy'
    },
    /* 6C */ 0x6c: {
        name: 'getObjPreposition'
    },
    0x6d: {
        name: 'putActorInRoom'
    },
    0x6e: {
        name: 'dummy'
    },
    0x6f: {
        name: 'ifState04'
    },
    /* 70 */ 0x70: {
        name: 'lights'
    },
    0x71: {
        name: 'getActorCostume'
    },
    0x72: {
        name: 'loadRoom'
    },
    0x73: {
        name: 'roomOps'
    },
    /* 74 */ 0x74: {
        name: 'getDist'
    },
    0x75: {
        name: 'findObject'
    },
    0x76: {
        name: 'walkActorToObject'
    },
    0x77: {
        name: 'clearState01'
    },
    /* 78 */ 0x78: {
        name: 'isGreater'
    },
    0x79: {
        name: 'doSentence'
    },
    0x7a: {
        name: 'verbOps'
    },
    0x7b: {
        name: 'getActorWalkBox'
    },
    /* 7C */ 0x7c: {
        name: 'isSoundRunning'
    },
    0x7d: {
        name: 'setActorElevation'
    },
    0x7e: {
        name: 'walkActorTo'
    },
    0x7f: {
        name: 'ifState01'
    },
    /* 80 */ 0x80: {
        name: 'breakHere'
    },
    0x81: {
        name: 'putActor'
    },
    0x82: {
        name: 'startMusic'
    },
    0x83: {
        name: 'getActorRoom'
    },
    /* 84 */ 0x84: {
        name: 'isGreaterEqual'
    },
    0x85: {
        name: 'drawObject'
    },
    0x86: {
        name: 'getActorElevation'
    },
    0x87: {
        name: 'setState08'
    },
    /* 88 */ 0x88: {
        name: 'isNotEqual'
    },
    0x89: {
        name: 'faceActor'
    },
    0x8a: {
        name: 'assignVarWordIndirect'
    },
    0x8b: {
        name: 'setObjPreposition'
    },
    /* 8C */ 0x8c: {
        name: 'resourceRoutines'
    },
    0x8d: {
        name: 'walkActorToActor'
    },
    0x8e: {
        name: 'putActorAtObject'
    },
    0x8f: {
        name: 'ifNotState08'
    },
    /* 90 */ 0x90: {
        name: 'getObjectOwner'
    },
    0x91: {
        name: 'animateActor'
    },
    0x92: {
        name: 'panCameraTo'
    },
    0x93: {
        name: 'actorOps'
    },
    /* 94 */ 0x94: {
        name: 'print'
    },
    0x95: {
        name: 'actorFromPos'
    },
    0x96: {
        name: 'getRandomNr'
    },
    0x97: {
        name: 'clearState02'
    },
    /* 98 */ 0x98: {
        name: 'restart'
    },
    0x99: {
        name: 'doSentence'
    },
    0x9a: {
        name: 'move'
    },
    0x9b: {
        name: 'setBitVar'
    },
    /* 9C */ 0x9c: {
        name: 'startSound'
    },
    0x9d: {
        name: 'ifClassOfIs'
    },
    0x9e: {
        name: 'walkActorTo'
    },
    0x9f: {
        name: 'ifState02'
    },
    /* A0 */ 0xa0: {
        name: 'stopObjectCode'
    },
    0xa1: {
        name: 'putActor'
    },
    0xa2: {
        name: 'saveLoadGame'
    },
    0xa3: {
        name: 'getActorY'
    },
    /* A4 */ 0xa4: {
        name: 'loadRoomWithEgo'
    },
    0xa5: {
        name: 'drawObject'
    },
    0xa6: {
        name: 'setVarRange'
    },
    0xa7: {
        name: 'setState04'
    },
    /* A8 */ 0xa8: {
        name: 'notEqualZero'
    },
    0xa9: {
        name: 'setOwnerOf'
    },
    0xaa: {
        name: 'addIndirect'
    },
    0xab: {
        name: 'switchCostumeSet'
    },
    /* AC */ 0xac: {
        name: 'drawSentence'
    },
    0xad: {
        name: 'putActorInRoom'
    },
    0xae: {
        name: 'waitForMessage'
    },
    0xaf: {
        name: 'ifNotState04'
    },
    /* B0 */ 0xb0: {
        name: 'setBoxFlags'
    },
    0xb1: {
        name: 'getBitVar'
    },
    0xb2: {
        name: 'setCameraAt'
    },
    0xb3: {
        name: 'roomOps'
    },
    /* B4 */ 0xb4: {
        name: 'getDist'
    },
    0xb5: {
        name: 'findObject'
    },
    0xb6: {
        name: 'walkActorToObject'
    },
    0xb7: {
        name: 'setState01'
    },
    /* B8 */ 0xb8: {
        name: 'isLessEqual'
    },
    0xb9: {
        name: 'doSentence'
    },
    0xba: {
        name: 'subtract'
    },
    0xbb: {
        name: 'waitForActor'
    },
    /* BC */ 0xbc: {
        name: 'stopSound'
    },
    0xbd: {
        name: 'setActorElevation'
    },
    0xbe: {
        name: 'walkActorTo'
    },
    0xbf: {
        name: 'ifNotState01'
    },
    /* C0 */ 0xc0: {
        name: 'endCutscene'
    },
    0xc1: {
        name: 'putActor'
    },
    0xc2: {
        name: 'startScript'
    },
    0xc3: {
        name: 'getActorX'
    },
    /* C4 */ 0xc4: {
        name: 'isLess'
    },
    0xc5: {
        name: 'drawObject'
    },
    0xc6: {
        name: 'decrement'
    },
    0xc7: {
        name: 'clearState08'
    },
    /* C8 */ 0xc8: {
        name: 'isEqual'
    },
    0xc9: {
        name: 'faceActor'
    },
    0xca: {
        name: 'chainScript'
    },
    0xcb: {
        name: 'setObjPreposition'
    },
    /* CC */ 0xcc: {
        name: 'pseudoRoom'
    },
    0xcd: {
        name: 'walkActorToActor'
    },
    0xce: {
        name: 'putActorAtObject'
    },
    0xcf: {
        name: 'ifState08'
    },
    /* D0 */ 0xd0: {
        name: 'pickupObject'
    },
    0xd1: {
        name: 'animateActor'
    },
    0xd2: {
        name: 'actorFollowCamera'
    },
    0xd3: {
        name: 'actorOps'
    },
    /* D4 */ 0xd4: {
        name: 'setObjectName'
    },
    0xd5: {
        name: 'actorFromPos'
    },
    0xd6: {
        name: 'getActorMoving'
    },
    0xd7: {
        name: 'setState02'
    },
    /* D8 */ 0xd8: {
        name: 'printEgo'
    },
    0xd9: {
        name: 'doSentence'
    },
    0xda: {
        name: 'add'
    },
    0xdb: {
        name: 'setBitVar'
    },
    /* DC */ 0xdc: {
        name: 'dummy'
    },
    0xdd: {
        name: 'ifClassOfIs'
    },
    0xde: {
        name: 'walkActorTo'
    },
    0xdf: {
        name: 'ifNotState02'
    },
    /* E0 */ 0xe0: {
        name: 'cursorCommand'
    },
    0xe1: {
        name: 'putActor'
    },
    0xe2: {
        name: 'stopScript'
    },
    0xe3: {
        name: 'getActorFacing'
    },
    /* E4 */ 0xe4: {
        name: 'loadRoomWithEgo'
    },
    0xe5: {
        name: 'drawObject'
    },
    0xe6: {
        name: 'getClosestObjActor'
    },
    0xe7: {
        name: 'clearState04'
    },
    /* E8 */ 0xe8: {
        name: 'isScriptRunning'
    },
    0xe9: {
        name: 'setOwnerOf'
    },
    0xea: {
        name: 'subIndirect'
    },
    0xeb: {
        name: 'dummy'
    },
    /* EC */ 0xec: {
        name: 'getObjPreposition'
    },
    0xed: {
        name: 'putActorInRoom'
    },
    0xee: {
        name: 'dummy'
    },
    0xef: {
        name: 'ifState04'
    },
    /* F0 */ 0xf0: {
        name: 'lights'
    },
    0xf1: {
        name: 'getActorCostume'
    },
    0xf2: {
        name: 'loadRoom'
    },
    0xf3: {
        name: 'roomOps'
    },
    /* F4 */ 0xf4: {
        name: 'getDist'
    },
    0xf5: {
        name: 'findObject'
    },
    0xf6: {
        name: 'walkActorToObject'
    },
    0xf7: {
        name: 'clearState01'
    },
    /* F8 */ 0xf8: {
        name: 'isGreater'
    },
    0xf9: {
        name: 'doSentence'
    },
    0xfa: {
        name: 'verbOps'
    },
    0xfb: {
        name: 'getActorWalkBox'
    },
    /* FC */ 0xfc: {
        name: 'isSoundRunning'
    },
    0xfd: {
        name: 'setActorElevation'
    },
    0xfe: {
        name: 'walkActorTo'
    },
    0xff: {
        name: 'ifState01'
    }
};
const $ca37204db6270d43$export$11ccf90e7d69d47d = [
    /* 0 */ 'VAR_EGO',
    'VAR_RESULT',
    'VAR_CAMERA_POS_X',
    'VAR_HAVE_MSG',
    /* 4 */ 'VAR_ROOM',
    'VAR_OVERRIDE',
    'VAR_MACHINE_SPEED',
    'VAR_CHARCOUNT',
    /* 8 */ 'VAR_ACTIVE_VERB',
    'VAR_ACTIVE_OBJECT1',
    'VAR_ACTIVE_OBJECT2',
    'VAR_NUM_ACTOR',
    /* 12 */ 'VAR_CURRENT_LIGHTS',
    'VAR_CURRENTDRIVE',
    null,
    null,
    /* 16 */ null,
    'VAR_MUSIC_TIMER',
    'VAR_VERB_ALLOWED',
    'VAR_ACTOR_RANGE_MIN',
    /* 20 */ 'VAR_ACTOR_RANGE_MAX',
    null,
    null,
    'VAR_CAMERA_MIN_X',
    /* 24 */ 'VAR_CAMERA_MAX_X',
    'VAR_TIMER_NEXT',
    'VAR_SENTENCE_VERB',
    'VAR_SENTENCE_OBJECT1',
    /* 28 */ 'VAR_SENTENCE_OBJECT2',
    'VAR_SENTENCE_PREPOSITION',
    'VAR_VIRT_MOUSE_X',
    'VAR_VIRT_MOUSE_Y',
    /* 32 */ 'VAR_CLICK_AREA',
    'VAR_CLICK_VERB',
    null,
    'VAR_CLICK_OBJECT',
    /* 36 */ 'VAR_ROOM_RESOURCE',
    'VAR_LAST_SOUND',
    'VAR_BACKUP_VERB',
    'VAR_KEYPRESS',
    /* 40 */ 'VAR_CUTSCENEEXIT_KEY',
    'VAR_TALK_ACTOR',
    null,
    null
];
const $ca37204db6270d43$export$95c304d9ad46d333 = {
    0x01: 'Open',
    0x02: 'Close',
    0x03: 'Give',
    0x04: 'Turn On',
    0x05: 'Turn Off',
    0x06: 'Fix',
    0x07: 'New Kid',
    0x08: undefined,
    0x09: 'Push',
    0x0a: 'Pull',
    0x0b: 'Use',
    0x0c: 'Read',
    0x0d: 'Go To',
    0x0e: 'Get',
    0x0f: undefined,
    0xff: 'Any verb'
};



var $jrGSV = parcelRequire("jrGSV");
const $7a318e840412d11b$var$getVariable = (parser)=>{
    const i = parser.getUint8();
    if (i & 0x2000) // Not implemented
    console.error('Not implemented');
    if (i < (0, $ca37204db6270d43$export$11ccf90e7d69d47d).length && (0, $ca37204db6270d43$export$11ccf90e7d69d47d)[i]) return (0, $ca37204db6270d43$export$11ccf90e7d69d47d)[i];
    else if (i & 0x8000) return `Var[${(i & 0x0fff) >> 4} Bit ${i & 0x000f}]`;
    else {
        const varIndex = i & 0xfff;
        const s = varIndex >= 0x320 ? '??Var??' : 'Var';
        return `${s}[${varIndex}]`;
    }
};
const $7a318e840412d11b$var$getVariableOrByte = (parser, condition)=>{
    if (condition) return $7a318e840412d11b$var$getVariable(parser);
    else return parser.getUint8();
};
const $7a318e840412d11b$var$getVariableOrWord = (parser, condition)=>{
    if (condition) return $7a318e840412d11b$var$getVariable(parser);
    else return parser.getUint16();
};
const $7a318e840412d11b$var$getOffset = (parser, startAddress)=>{
    const offset = parser.getUint16();
    const currentRow = parser.pointer - startAddress;
    return (0, $jrGSV.hex)((currentRow + offset) % 0x10000, 4);
};
const $7a318e840412d11b$var$parseScriptCode = (parser, startAddress, parentOffset = 0)=>{
    const script = [];
    let stop = false;
    do {
        const scriptRow = [];
        const rowAddress = parser.pointer - startAddress;
        const opCode = parser.getUint8();
        scriptRow.push(opCode);
        scriptRow.push(`${(0, $ca37204db6270d43$export$410015072f37b241)[opCode].name ?? opCode}`);
        switch(opCode){
            // stopObjectCode
            case 0x00:
            case 0xa0:
                stop = true;
                break;
            // putActor
            case 0x01:
            case 0x21:
            case 0x41:
            case 0x61:
            case 0x81:
            case 0xa1:
            case 0xc1:
            case 0xe1:
                // Actor Id
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                // X
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                // Y
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x20));
                break;
            // startMusic
            case 0x02:
            case 0x82:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // getActorRoom
            case 0x03:
            case 0x83:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // drawObject
            case 0x05:
            case 0x25:
            case 0x45:
            case 0x65:
            case 0x85:
            case 0xa5:
            case 0xc5:
            case 0xe5:
                // ObjectId
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x20));
                break;
            // faceActor
            case 0x09:
            case 0x49:
            case 0x89:
            case 0xc9:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                break;
            // setObjPreposition
            case 0x0b:
            case 0x4b:
            case 0x8b:
            case 0xcb:
                // ObjectId
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                // Preposition Id
                scriptRow.push(parser.getUint8());
                break;
            // resourceRoutines
            case 0x0c:
            case 0x8c:
                {
                    const resTypes = [
                        null,
                        null,
                        'Costume',
                        'Room',
                        null,
                        'Script',
                        'Sound'
                    ];
                    const resId = $7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80);
                    const subOp = parser.getUint8();
                    let routine;
                    if ((subOp & 0x0f) === 0 || (subOp & 0x0f) === 1) {
                        if (subOp & 1) routine = 'load';
                        else routine = 'nuke';
                    } else if (subOp & 1) routine = 'lock';
                    else routine = 'unlock';
                    const type = resTypes[subOp >> 4];
                    if (!type) console.error(`Resource Routines: Invalid type ${type}`);
                    scriptRow.push(`${routine}${type}`);
                    scriptRow.push(resId);
                    break;
                }
            // putActorAtObject
            case 0x0e:
            case 0x4e:
            case 0x8e:
            case 0xce:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x40));
                break;
            // walkActorToActor
            case 0x0d:
            case 0x4d:
            case 0x8d:
            case 0xcd:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                scriptRow.push(parser.getUint8());
                break;
            // getObjectOwner
            case 0x10:
            case 0x90:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                break;
            // animateActor
            case 0x11:
            case 0x51:
            case 0x91:
            case 0xd1:
                // Actor Id
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                // Animation
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                break;
            // panCameraTo
            case 0x12:
            case 0x92:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // actorOps
            case 0x13:
            case 0x53:
            case 0x93:
            case 0xd3:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                const subOpArg = $7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40);
                const subOp = parser.getUint8();
                switch(subOp){
                    case 0x01:
                        scriptRow.push(`Sound`);
                        scriptRow.push(subOpArg);
                        break;
                    case 0x02:
                        const value = parser.getUint8();
                        scriptRow.push(`Color`);
                        scriptRow.push(subOpArg);
                        scriptRow.push(value);
                        break;
                    case 0x03:
                        const name = parser.getString();
                        scriptRow.push(`Name`);
                        scriptRow.push(name);
                        break;
                    case 0x04:
                        scriptRow.push(`Costume`);
                        scriptRow.push(subOpArg);
                        break;
                    case 0x05:
                        scriptRow.push(`TalkColor`);
                        scriptRow.push(subOpArg);
                        break;
                    default:
                        scriptRow.push(`// Unknown subop: 0x${(0, $jrGSV.hex)(subOp, 2)}`);
                }
                break;
            // print
            case 0x14:
            case 0x94:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                scriptRow.push(`"${parser.getString()}"`);
                break;
            // actorFromPos
            case 0x15:
            case 0x55:
            case 0x95:
            case 0xd5:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                break;
            // getRandomNr
            case 0x16:
            case 0x96:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // goto
            case 0x18:
                {
                    const offset = parser.getUint16();
                    const currentRow = parser.pointer - startAddress;
                    scriptRow.push((0, $jrGSV.hex)((currentRow + offset) % 0x10000, 4));
                }
                break;
            // doSentence
            case 0x19:
            case 0x39:
            case 0x59:
            case 0x79:
            case 0x99:
            case 0xb9:
            case 0xd9:
            case 0xf9:
                const tmpValue = parser.peekUint8();
                if (!(opCode & 0x80) && tmpValue === 0xfc) {
                    scriptRow.push('STOP');
                    parser.getUint8();
                } else if (!(opCode & 0x80) && tmpValue === 0xfb) {
                    scriptRow.push('RESET');
                    parser.getUint8();
                } else {
                    scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                    scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x40));
                    scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x20));
                    scriptRow.push(parser.getUint8());
                }
                break;
            // setBitVar
            case 0x1b:
            case 0x5b:
            case 0x9b:
            case 0xdb:
                scriptRow.push(parser.getUint16());
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                break;
            // startSound
            case 0x1c:
            case 0x9c:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // walkActorTo
            case 0x1e:
            case 0x3e:
            case 0x5e:
            case 0x7e:
            case 0x9e:
            case 0xbe:
            case 0xde:
            case 0xfe:
                // Actor id
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                // x
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                // y
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x20));
                break;
            // stopMusic
            case 0x20:
                break;
            // saveLoadGame
            case 0x22:
            case 0xa2:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x20));
                break;
            // loadRoomWithEgo
            case 0x24:
            case 0x64:
            case 0xa4:
            case 0xe4:
                // Object Id
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                // Room Id
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                // x
                scriptRow.push(parser.getUint8());
                // y
                scriptRow.push(parser.getUint8());
                break;
            // setVarRange
            case 0x26:
            case 0xa6:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                let length = parser.getUint8();
                scriptRow.push(length);
                const values = [];
                while(length > 0){
                    if (opCode & 0x80) values.push(parser.getUint16());
                    else values.push(parser.getUint8());
                    length--;
                }
                scriptRow.push(`[${values}]`);
                break;
            // setOwnerOf
            case 0x29:
            case 0x69:
            case 0xa9:
            case 0xe9:
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                break;
            // addIndirect
            case 0x2a:
            case 0xaa:
            // subtract
            case 0x3a:
            case 0xba:
            // subIndirect
            case 0x6a:
            case 0xea:
            // assignVarWordIndirect
            case 0x0a:
            case 0x8a:
            // move
            case 0x1a:
            case 0x9a:
            // add
            case 0xda:
            case 0x5a:
            // increment/decrement
            case 0x46:
            case 0xc6:
                if ((opCode & 0x7f) === 0x0a || (opCode & 0x7f) === 0x2a || (opCode & 0x7f) === 0x6a) {
                    // Assign to a variable defined by the value of another variable
                    const i = parser.getUint8();
                    scriptRow.push(`Var[Var[${i}]]`);
                } else // Assign to a variable
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                if ((opCode & 0x7f) === 0x2c) scriptRow.push(parser.getUint8());
                else if ((opCode & 0x7f) !== 0x46) scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                break;
            // delayVariable
            case 0x2b:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                break;
            // delay
            case 0x2e:
                let d = parser.getUint8();
                d |= parser.getUint8() << 8;
                d |= parser.getUint8() << 16;
                d = 0xffffff - d;
                scriptRow.push(d);
                break;
            // putActorInRoom
            case 0x2d:
            case 0x6d:
            case 0xad:
            case 0xed:
                // Actor Id
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                // Room
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                break;
            // setBoxFlags
            case 0x30:
            case 0xb0:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                scriptRow.push(parser.getUint8());
                break;
            // getBitVar
            case 0x31:
            case 0xb1:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push(parser.getUint16());
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // setCameraAt
            case 0x32:
            case 0xb2:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // roomOps
            case 0x33:
            case 0x73:
            case 0xb3:
            case 0xf3:
                {
                    const valueA = $7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80);
                    const valueB = $7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40);
                    const subOp = parser.getUint8();
                    console.log(`Room Ops: ${(subOp & 0x1f).toString(16, 2)}, ${valueA} ${valueB}`);
                    switch(subOp & 0x1f){
                        case 0x01:
                            scriptRow.push(`RoomScroll`);
                            scriptRow.push(valueA);
                            scriptRow.push(valueB);
                            break;
                        case 0x02:
                            // Not used on NES
                            console.error(`RoomOps invalid Op ${subOp & 0x1f}`);
                            break;
                        case 0x03:
                            scriptRow.push(`SetScreen`);
                            scriptRow.push(valueA);
                            scriptRow.push(valueB);
                            break;
                        case 0x04:
                            scriptRow.push(`SetPalColor`);
                            scriptRow.push(valueA);
                            scriptRow.push(valueB);
                            break;
                        case 0x05:
                            scriptRow.push(`ShakeOn`);
                            break;
                        case 0x06:
                            scriptRow.push(`ShakeOff`);
                            break;
                        default:
                            scriptRow.push(`[[unknown subop ${(subOp & 0x1f).toString(16, 2)}]]`);
                            console.error(`Room Ops: unknown subop ${(subOp & 0x1f).toString(16, 2)}`);
                    }
                    break;
                }
            // getDist
            case 0x34:
            case 0x74:
            case 0xb4:
            case 0xf4:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x40));
                break;
            // findObject
            case 0x35:
            case 0x75:
            case 0xb5:
            case 0xf5:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                break;
            // walkActorToObject
            case 0x36:
            case 0x76:
            case 0xb6:
            case 0xf6:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x40));
                break;
            // setState01 to value
            case 0x37:
            case 0xb7:
            // setState02 to value
            case 0x57:
            case 0xd7:
            // setState04 to value
            case 0x27:
            case 0xa7:
            // setState08 to value
            case 0x07:
            case 0x87:
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                break;
            // waitForActor
            case 0x3b:
            case 0xbb:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // stopSound
            case 0x3c:
            case 0xbc:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // setActorElevation
            case 0x3d:
            case 0x7d:
            case 0xbd:
            case 0xfd:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x40));
                break;
            // ifNotState01
            case 0x3f:
            case 0xbf:
            // ifNotState02
            case 0x5f:
            case 0xdf:
            // ifNotState04
            case 0x2f:
            case 0xaf:
            // ifNotState08
            case 0x0f:
            case 0x8f:
            // ifState01
            case 0x7f:
            case 0xff:
            // ifState02
            case 0x1f:
            case 0x9f:
            // ifState04
            case 0x6f:
            case 0xef:
            // ifState08
            case 0x4f:
            case 0xcf:
                // Object Id
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getOffset(parser, startAddress));
                break;
            // cutscene
            case 0x40:
                break;
            // startScript
            case 0x42:
            case 0xc2:
            // stopScript
            case 0x62:
            case 0xe2:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // getActorX
            case 0x43:
            case 0xc3:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // getActorY
            case 0x23:
            case 0xa3:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // chainScript
            case 0x4a:
            case 0xca:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // waitForSentence
            case 0x4c:
                break;
            // isEqual
            case 0x48:
            case 0xc8:
            // isGreater
            case 0x78:
            case 0xf8:
            // isGreaterEqual
            case 0x04:
            case 0x84:
            // isLess
            case 0x44:
            case 0xc4:
            // isNotEqual
            case 0x08:
            case 0x88:
            // lessOrEqual
            case 0x38:
            case 0xb8:
            // equalZero
            case 0x28:
            // notEqualZero
            case 0xa8:
                // Variable to compare
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                // For opCode different than equalZero and notEqualZero
                if (opCode !== 0x28 && opCode !== 0xa8) scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                scriptRow.push($7a318e840412d11b$var$getOffset(parser, startAddress));
                break;
            // pickupObject
            case 0x50:
            case 0xd0:
                // Object Id
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                break;
            // actorFollowCamera
            case 0x52:
            case 0xd2:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // setObjectName
            case 0x54:
            case 0xd4:
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                const name1 = parser.getString();
                scriptRow.push(`"${name1}"`);
                break;
            // getActorMoving
            case 0x56:
            case 0xd6:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // beginOverride
            case 0x58:
                break;
            case 0x5c:
            case 0x6b:
            case 0x6e:
            case 0xab:
            case 0xdc:
            case 0xeb:
            case 0xee:
                break;
            // cursorCommand
            case 0x60:
            case 0xe0:
                if (opCode & 0x80) {
                    const variable = $7a318e840412d11b$var$getVariable(parser);
                    scriptRow.push(`Hi(${variable})`);
                    scriptRow.push(`Lo(${variable})`);
                } else {
                    const value = parser.getUint16();
                    scriptRow.push(value >> 8 & 0xff);
                    scriptRow.push(value & 0xff);
                }
                break;
            // getClosestObjActor
            case 0x66:
            case 0xe6:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                break;
            // isScriptRunning
            case 0x68:
            case 0xe8:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // getObjPreposition
            case 0x6c:
            case 0xec:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                break;
            // lights
            case 0x70:
            case 0xf0:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                scriptRow.push(parser.getUint8());
                scriptRow.push(parser.getUint8());
                break;
            // loadRoom
            case 0x72:
            case 0xf2:
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // clearState01
            case 0x77:
            case 0xf7:
            // clearState02
            case 0x17:
            case 0x97:
            // clearState04
            case 0x67:
            case 0xe7:
            // clearState08
            case 0x47:
            case 0xc7:
                scriptRow.push($7a318e840412d11b$var$getVariableOrWord(parser, opCode & 0x80));
                break;
            // verbOps
            case 0x7a:
            case 0xfa:
                {
                    const subOp = parser.getUint8();
                    switch(subOp){
                        case 0:
                            scriptRow.push(`Delete`);
                            scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                            break;
                        case 0xff:
                            break;
                        default:
                            scriptRow.push(`New-${subOp}`);
                            scriptRow.push(parser.getUint8());
                            scriptRow.push(parser.getUint8());
                            scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                            scriptRow.push(parser.getUint8());
                            scriptRow.push(`"${parser.getString()}"`);
                    }
                    break;
                }
            // isSoundRunning
            case 0x7c:
            case 0xfc:
                scriptRow.push($7a318e840412d11b$var$getVariable(parser));
                scriptRow.push($7a318e840412d11b$var$getVariableOrByte(parser, opCode & 0x80));
                break;
            // breakHere
            case 0x80:
                break;
            // restart
            case 0x98:
                break;
            // drawSentence
            case 0xac:
                break;
            // waitForMessage
            case 0xae:
                break;
            // endCutscene
            case 0xc0:
                break;
            case 0xd8:
                const str = parser.getString();
                scriptRow.push(`"${str}"`);
                break;
            default:
                scriptRow.push(`NOT IMPLEMENTED (${(0, $jrGSV.hex)(opCode)}) ${(0, $ca37204db6270d43$export$410015072f37b241)[opCode].name ?? opCode}`);
                console.error(`NOT IMPLEMENTED (${(0, $jrGSV.hex)(opCode)}) ${(0, $ca37204db6270d43$export$410015072f37b241)[opCode].name ?? opCode}`);
                stop = true;
                break;
        }
        script.push([
            rowAddress,
            scriptRow
        ]);
    }while (!stop);
    return script;
};
var $7a318e840412d11b$export$2e2bcd8739ae039 = $7a318e840412d11b$var$parseScriptCode;



const $b2ad64656ebcc268$var$assert = console.assert;
const $b2ad64656ebcc268$var$parseRooms = (arrayBuffer, i = 0, offset = 0, characters = {})=>{
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength
    };
    const map = [];
    if (arrayBuffer.byteLength === 0) return {
        metadata: metadata,
        map: map
    };
    const { headerMap: headerMap, header: header } = (0, $8a3ab9fe2b34fb09$export$2e2bcd8739ae039)(arrayBuffer.slice(0, 0x1c));
    $b2ad64656ebcc268$var$assert(header.chunkSize === arrayBuffer.byteLength, 'Room res size flag does not match chunk size.');
    map.push(headerMap);
    const { chunkSize: chunkSize, width: width, nametableOffs: nametableOffs, attrOffs: attrOffs, maskOffs: maskOffs, objectsNum: objectsNum, boxOffs: boxOffs, excdOffs: excdOffs, encdOffs: encdOffs } = header;
    const objectImages = [];
    const objects = [];
    // These 2 are optional.
    if (excdOffs > 0) map.push({
        type: 'excdOffs',
        from: excdOffs,
        to: encdOffs
    });
    if (encdOffs > 0) map.push({
        type: 'encdOffs',
        from: encdOffs,
        to: chunkSize
    });
    // Parse the tileset id.
    const tilesetParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(nametableOffs, nametableOffs + 1));
    const tileset = tilesetParser.getUint8();
    map.push({
        type: 'tileset',
        from: nametableOffs,
        to: nametableOffs
    });
    // Parse the palette.
    const { palette: palette, paletteMap: paletteMap } = (0, $4c0af675549ba9d7$export$2e2bcd8739ae039)(arrayBuffer.slice(nametableOffs + 1, nametableOffs + 17), nametableOffs + 1);
    map.push(paletteMap);
    // Parse gfx nametable.
    const { nametable: nametable, nametableMap: nametableMap } = (0, $ea82b3f13f18c748$export$2e2bcd8739ae039)(arrayBuffer.slice(nametableOffs + 17, attrOffs), nametableOffs + 17, width);
    map.push(nametableMap);
    $b2ad64656ebcc268$var$assert(nametableMap.to === attrOffs, 'Gfx nametable overlaps on attributes table.');
    // Parse gfx attrtable.
    const { attributes: attributes, attributesMap: attributesMap } = (0, $c647a9503426e6d0$export$2e2bcd8739ae039)(arrayBuffer.slice(attrOffs, maskOffs), attrOffs, width);
    map.push(attributesMap);
    $b2ad64656ebcc268$var$assert(attributesMap.to === maskOffs, 'Gfx attributes table overlaps on gfx mask table.');
    // Parse gfx masktable.
    const masktableParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(maskOffs));
    const hasMask = masktableParser.getUint8();
    $b2ad64656ebcc268$var$assert(hasMask === 0 || hasMask === 1, 'hasMask is neither 0 nor 1.');
    const masktable = {
        hasMask: !!hasMask
    };
    if (hasMask === 1) {
        let masktableObj = Array(16).fill([]);
        let mwidth = masktableParser.getUint8();
        for(i = 0; i < 16; i++){
            masktableObj[i] = Array(8).fill(0);
            let n = 0;
            while(n < mwidth){
                const loop = masktableParser.getUint8();
                if (loop & 0x80) for(let j = 0; j < (loop & 0x7f); j++)masktableObj[i][n++] = masktableParser.getUint8();
                else {
                    const data = masktableParser.getUint8();
                    for(let j = 0; j < (loop & 0x7f); j++)masktableObj[i][n++] = data;
                }
            }
        }
        masktable.masktableObj = masktableObj;
        map.push({
            type: 'masktable',
            from: maskOffs,
            to: maskOffs + masktableParser.pointer
        });
    } else map.push({
        type: 'masktable',
        from: maskOffs,
        to: maskOffs
    });
    // @todo Add a check to verify that the mask table doesn't overlap on object images.
    // @todo Check what happens when objectsNum is 0.
    if (objectsNum > 0) map.push({
        type: 'objectImagesOffs',
        from: 0x1c,
        to: 0x1c + objectsNum * 2
    }, {
        type: 'objectsOffs',
        from: 0x1c + objectsNum * 2,
        to: 0x1c + objectsNum * 4
    });
    const objectImagesOffs = [];
    const objectsOffs = [];
    // @todo Set the end of the ArrayBuffer slice.
    const objectImageOffsParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(0x1c));
    const objectOffsParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(0x1c + objectsNum * 2));
    for(let j = 0; j < objectsNum; j++){
        objectImagesOffs.push(objectImageOffsParser.getUint16());
        objectsOffs.push(objectOffsParser.getUint16());
    }
    // Calculate the earliest object offset. Used to discard empty object images.
    const objectImagesStart = Math.min(...objectImagesOffs);
    const objectsStart = Math.min(...objectsOffs);
    // End range values will be set later.
    const objectImageMap = {
        type: 'objectImages',
        from: objectImagesStart,
        to: 0
    };
    const objectCodeMap = {
        type: 'objects',
        from: objectsStart,
        to: 0
    };
    for(let j = 0; j < objectsNum; j++){
        const objectImageOffs = objectImagesOffs[j];
        const objectOffs = objectsOffs[j];
        // @todo Set the end of the ArrayBuffer slice.
        const objectsParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(objectOffs));
        // @todo Set the end of the ArrayBuffer slice.
        const objectImagesParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(objectImageOffs));
        // Object content
        const objectSize = objectsParser.getUint16();
        const objUnk1 = objectsParser.getUint8();
        const objUnk2 = objectsParser.getUint8();
        $b2ad64656ebcc268$var$assert(objUnk1 === 0, 'Unknown 1 is not 0.');
        $b2ad64656ebcc268$var$assert(objUnk2 === 0, 'Unknown 2 is not 0.');
        const id = objectsParser.getUint16();
        const objUnk3 = objectsParser.getUint8();
        $b2ad64656ebcc268$var$assert(objUnk3 === 0, 'Unknown 3 is not 0.');
        const objX = objectsParser.getUint8();
        const byte1 = objectsParser.getUint8();
        const objY = byte1 & 0x7f;
        // assert(objX < width, 'Object is outside of room width.');
        // assert(objY < height, 'Object is outside of room height.');
        const objParentState = (byte1 & 0x80 ? 1 : 0) * 8;
        const objWidth = objectsParser.getUint8();
        const objParent = objectsParser.getUint8();
        const objWalkToX = objectsParser.getUint8();
        const objWalkToY = objectsParser.getUint8() & 0x1f;
        const byte2 = objectsParser.getUint8();
        const objActorDir = byte2 & 0x07;
        const objHeight = (byte2 & 0xf8) / 8;
        const objNameOffs = objectsParser.getUint8();
        $b2ad64656ebcc268$var$assert(!(objNameOffs % 2), 'Object name offset is an odd number.');
        $b2ad64656ebcc268$var$assert(objNameOffs >= 16, 'Object name offset is less than 16.');
        $b2ad64656ebcc268$var$assert(objNameOffs < 255, 'Object name offset is more than 255.');
        // Parse object name.
        const objectNameParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(objectOffs + objNameOffs, objectOffs + objectSize), characters);
        let objName = '';
        let char = '';
        for(let i = 0; i < objectNameParser.length; i++){
            char = objectNameParser.getChar();
            if (char === 0x00) break;
            objName += char;
        }
        // Parse object script offsets.
        const objectScriptOffsParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(objectOffs + 0x0f, objectOffs + objectSize));
        const scripts = [];
        while(objectScriptOffsParser.pointer < objectSize){
            const verbId = objectScriptOffsParser.getUint8();
            if (verbId === 0) break;
            const objectScriptStart = objectScriptOffsParser.getUint8();
            const scriptOffsParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(objectOffs + objectScriptStart, objectOffs + objectScriptStart + objectSize), characters);
            const script = (0, $7a318e840412d11b$export$2e2bcd8739ae039)(scriptOffsParser, 0, 0);
            scripts.push([
                (0, $ca37204db6270d43$export$95c304d9ad46d333)[verbId] ?? `(${verbId})`,
                script
            ]);
        }
        // Parse object images.
        let tiles;
        if (objectImageOffs === objectsStart) tiles = null;
        else {
            tiles = new Array(objHeight);
            for(let i = 0; i < objHeight; i++){
                tiles[i] = [];
                let n = 0;
                while(n < objWidth){
                    const loop = objectImagesParser.getUint8();
                    if (loop & 0x80) for(let j = 0; j < (loop & 0x7f); j++)tiles[i][n++] = objectImagesParser.getUint8();
                    else {
                        const data = objectImagesParser.getUint8();
                        for(let j = 0; j < (loop & 0x7f); j++)tiles[i][n++] = data;
                    }
                }
            }
        }
        // Parse object attrtable override.
        const attributes = [];
        if (tiles?.length) // Is that this length number of bytes to parse?
        for(let i = 0; i < (objWidth >> 1) * (objHeight >> 1); i++)attributes.push(objectImagesParser.getUint8());
        const objectImage = {
            tiles: tiles,
            attributes: attributes
        };
        objectImages.push(objectImage);
        // @todo Implement mask tables for object images.
        // @fixme This does not account for object scripts.
        if (objectCodeMap.to < objectOffs + objectImagesParser.pointer) objectCodeMap.to = objectOffs + objectImagesParser.pointer;
        // Calculate the number of object script given the value of object name offset.
        const calculatedObjScriptNum = (objNameOffs - 16) / 2;
        $b2ad64656ebcc268$var$assert(calculatedObjScriptNum === scripts.length, 'Unknown data before object name offset.');
        objects.push({
            id: j,
            size: objectSize,
            objUnk1: objUnk1,
            objUnk2: objUnk2,
            num: id,
            objUnk3: objUnk3,
            x: objX,
            y: objY,
            parent: objParent,
            parentState: objParentState,
            width: objWidth,
            height: objHeight,
            walkToX: objWalkToX,
            walkToY: objWalkToY,
            actorDir: objActorDir,
            nameOffs: objNameOffs,
            name: objName,
            scripts: scripts
        });
    }
    $b2ad64656ebcc268$var$assert(objectImages.length === objects.length, 'Length of object images and objects do not match.');
    // This is a hack.
    objectImageMap.to = objectCodeMap.from - 1;
    if (objectsNum > 0) map.push(objectCodeMap, objectImageMap);
    // Parse boxes.
    const { boxes: boxes, boxesMap: boxesMap } = (0, $882bcb13a6442293$export$2e2bcd8739ae039)(// @todo Set the end of the ArrayBuffer slice.
    arrayBuffer.slice(boxOffs), boxOffs);
    map.push(boxesMap);
    // Parse matrix.
    const { matrixUnks: matrixUnks, matrix: matrix, matrixMap: matrixMap } = (0, $0198eeb8e9a60880$export$2e2bcd8739ae039)(arrayBuffer.slice(boxesMap.to, boxesMap.to + boxes.length * (boxes.length + 1)), boxesMap.to, boxes.length);
    map.push(matrixMap);
    let excdScript;
    if (excdOffs !== 0) {
        const excdScriptParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(excdOffs), characters);
        excdScript = (0, $7a318e840412d11b$export$2e2bcd8739ae039)(excdScriptParser, 0);
    }
    let encdScript;
    if (encdOffs !== 0) {
        const encdScriptParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(encdOffs), characters);
        encdScript = (0, $7a318e840412d11b$export$2e2bcd8739ae039)(encdScriptParser, 0);
    }
    // Order ROM map by starting offset.
    map.sort((a, b)=>a.from - b.from);
    return {
        metadata: metadata,
        header: header,
        objectImagesOffs: objectImagesOffs,
        objectsOffs: objectsOffs,
        boxes: boxes,
        matrixUnks: matrixUnks,
        matrix: matrix,
        tileset: tileset,
        palette: palette,
        nametable: nametable,
        attributes: attributes,
        masktable: masktable,
        objectImages: objectImages,
        objects: objects,
        hasMask: hasMask,
        excdScript: excdScript,
        encdScript: encdScript,
        map: map
    };
};
var $b2ad64656ebcc268$export$2e2bcd8739ae039 = $b2ad64656ebcc268$var$parseRooms;



const $670e2fe52bba705e$var$assert = console.assert;
const $670e2fe52bba705e$var$parseRoomGfx = (arrayBuffer, i = 0, offset = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength,
        decompressedSize: 0
    };
    const numberOfTiles = parser.getUint8();
    const gfx = [];
    while(parser.pointer < arrayBuffer.byteLength){
        const loop = parser.getUint8();
        if (loop & 0x80) for(let j = 0; j < (loop & 0x7f); j++)gfx.push(parser.getUint8());
        else {
            const data = parser.getUint8();
            for(let j = 0; j < (loop & 0x7f); j++)gfx.push(data);
        }
    }
    $670e2fe52bba705e$var$assert(numberOfTiles === gfx.length / 8 / 2, 'Number of tiles byte does not match number of tiles decoded.');
    metadata.decompressedSize = gfx.length;
    return {
        metadata: metadata,
        numberOfTiles: numberOfTiles,
        gfx: gfx
    };
};
var $670e2fe52bba705e$export$2e2bcd8739ae039 = $670e2fe52bba705e$var$parseRoomGfx;



const $9a433a62f11b6d5d$var$parseGlobdata = (arrayBuffer, i = 0, offset = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength
    };
    const globdata = [];
    for(let i = 0; i < parser.length; i++)globdata.push(parser.getUint8());
    return {
        metadata: metadata,
        globdata: globdata
    };
};
var $9a433a62f11b6d5d$export$2e2bcd8739ae039 = $9a433a62f11b6d5d$var$parseGlobdata;




const $0d4f91a3615021da$var$assert = console.assert;
const $0d4f91a3615021da$var$parseScript = (arrayBuffer, i, offset = 0, characters = {})=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer, characters);
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength
    };
    if (arrayBuffer.byteLength === 0) return {
        metadata: metadata,
        header: {},
        code: []
    };
    const chunkSize = parser.getUint16();
    const unk1 = parser.getUint8();
    const unk2 = parser.getUint8();
    $0d4f91a3615021da$var$assert(chunkSize === arrayBuffer.byteLength, 'Script res size flag does not match chunk size.');
    $0d4f91a3615021da$var$assert(unk1 === 0, 'Unknown 1 is not 0.');
    const header = {
        chunkSize: chunkSize,
        unk1: unk1,
        unk2: unk2
    };
    // Skip script 59 and 90 as they seem to be corrupted
    if (i === 0x3b || i === 0x5a) return {
        metadata: metadata,
        header: header,
        code: []
    };
    const code = (0, $7a318e840412d11b$export$2e2bcd8739ae039)(parser, 0x0004);
    return {
        metadata: metadata,
        header: header,
        code: code
    };
};
var $0d4f91a3615021da$export$2e2bcd8739ae039 = $0d4f91a3615021da$var$parseScript;



const $37c164d27b076548$var$assert = console.assert;
const $37c164d27b076548$var$parseCostumeGfx = (arrayBuffer, i = 0, offset = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength,
        decompressedSize: 0
    };
    const numberOfTiles = parser.getUint8();
    const gfx = [];
    while(parser.pointer < arrayBuffer.byteLength){
        const loop = parser.getUint8();
        if (loop & 0x80) for(let j = 0; j < (loop & 0x7f); j++)gfx.push(parser.getUint8());
        else {
            const data = parser.getUint8();
            for(let j = 0; j < (loop & 0x7f); j++)gfx.push(data);
        }
    }
    $37c164d27b076548$var$assert(numberOfTiles === gfx.length / 8 / 2, 'Number of tiles byte does not match number of tiles decoded.');
    metadata.decompressedSize = gfx.length;
    return {
        metadata: metadata,
        numberOfTiles: numberOfTiles,
        gfx: gfx
    };
};
var $37c164d27b076548$export$2e2bcd8739ae039 = $37c164d27b076548$var$parseCostumeGfx;



const $9ddbd0ded642bef6$var$parseCostumes = (arrayBuffer, i = 0, offset = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength
    };
    const costumes = [];
    let to = 0;
    for(let i = 0; i < 24; i++){
        const offset = parser.getUint8();
        const length = parser.getUint8();
        const costumeParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(offset, offset + length));
        to = Math.max(to, offset + length);
        const costume = [];
        for(let j = 0; j < length; j++)costume.push(costumeParser.getUint8());
        costumes.push(costume);
    }
    const map = {
        type: 'costumes',
        from: offset,
        to: offset + to
    };
    return {
        metadata: metadata,
        costumes: costumes,
        map: map
    };
};
var $9ddbd0ded642bef6$export$2e2bcd8739ae039 = $9ddbd0ded642bef6$var$parseCostumes;



const $33a49c5ea0c407c9$var$parseSprpals = (arrayBuffer, i = 0, offset = 0)=>{
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength
    };
    const map = [];
    const { palette: palette, paletteMap: paletteMap } = (0, $4c0af675549ba9d7$export$2e2bcd8739ae039)(arrayBuffer, offset);
    map.push(paletteMap);
    return {
        metadata: metadata,
        palette: palette,
        map: map
    };
};
var $33a49c5ea0c407c9$export$2e2bcd8739ae039 = $33a49c5ea0c407c9$var$parseSprpals;



const $47cbfffa6362a3fa$var$parseSprdesc = (arrayBuffer, i = 0, offset = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength
    };
    const sprdesc = [];
    for(let i = 0; i < arrayBuffer.byteLength - 1; i += 2)sprdesc.push(parser.getUint16());
    // For some reason, the last element is an unused Uint8.
    parser.getUint8();
    const map = {
        type: 'sprdesc',
        from: offset,
        to: offset + parser.pointer
    };
    return {
        metadata: metadata,
        sprdesc: sprdesc,
        map: map
    };
};
var $47cbfffa6362a3fa$export$2e2bcd8739ae039 = $47cbfffa6362a3fa$var$parseSprdesc;



const $93333585778b0ac4$var$parseSprlens = (arrayBuffer, i = 0, offset = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength
    };
    const sprlens = [];
    for(let i = 0; i < arrayBuffer.byteLength; i++)sprlens.push(parser.getUint8() + 1);
    const map = {
        type: 'sprlens',
        from: offset,
        to: offset + parser.pointer
    };
    return {
        metadata: metadata,
        sprlens: sprlens,
        map: map
    };
};
var $93333585778b0ac4$export$2e2bcd8739ae039 = $93333585778b0ac4$var$parseSprlens;



const $7466991a11144594$var$parseSproffs = (arrayBuffer, i = 0, offset = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength
    };
    const sproffs = [];
    for(let i = 0; i < arrayBuffer.byteLength; i += 2)sproffs.push(parser.getUint16());
    const map = {
        type: 'sproffs',
        from: offset,
        to: offset + parser.pointer
    };
    return {
        metadata: metadata,
        sproffs: sproffs,
        map: map
    };
};
var $7466991a11144594$export$2e2bcd8739ae039 = $7466991a11144594$var$parseSproffs;



const $c6a14128feecae28$var$parseSprdata = (arrayBuffer, i = 0, offset = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength,
        decompressedSize: 0
    };
    const sprdata = [];
    for(let i = 0; i < arrayBuffer.byteLength; i += 3){
        const sprdata0 = parser.getInt8();
        const tile = parser.getUint8();
        const sprdata2 = parser.getInt8();
        const x = sprdata2 >> 2;
        const y = sprdata0 & 0x7f;
        const flip = sprdata0 & 0x80 ? true : false;
        const paletteId = (sprdata2 & 0x03) << 2;
        sprdata.push({
            x: x,
            y: y,
            tile: tile,
            flip: flip,
            paletteId: paletteId
        });
    }
    metadata.decompressedSize = sprdata.length;
    const map = {
        type: 'sprdata',
        from: offset,
        to: offset + parser.pointer
    };
    return {
        metadata: metadata,
        sprdata: sprdata,
        map: map
    };
};
var $c6a14128feecae28$export$2e2bcd8739ae039 = $c6a14128feecae28$var$parseSprdata;



const $b58a8f89894fae3e$var$assert = console.assert;
const $b58a8f89894fae3e$var$parsePreps = (arrayBuffer, i = 0, offset = 0, characters = {})=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer, characters);
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength
    };
    const preps = [];
    let char;
    let prep = '';
    for(let i = 0; i < parser.length; i++){
        char = parser.getChar();
        if (char === 0x00) {
            preps.push(prep);
            prep = '';
            continue;
        }
        prep += char;
    }
    $b58a8f89894fae3e$var$assert(char === 0x00, 'The final character is not 0x00.');
    return {
        metadata: metadata,
        preps: preps
    };
};
var $b58a8f89894fae3e$export$2e2bcd8739ae039 = $b58a8f89894fae3e$var$parsePreps;




const $25daed1151a7a3b7$var$assert = console.assert;
const $25daed1151a7a3b7$var$parseTitles = (arrayBuffer, i = 0, offset = 0)=>{
    const parser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer);
    const metadata = {
        id: i,
        offset: offset,
        size: arrayBuffer.byteLength
    };
    const map = [];
    const unk1 = parser.getUint16(); // Probably the chunk length unused in titles.
    const unk2 = parser.getUint16();
    $25daed1151a7a3b7$var$assert(unk1 === 0, 'Unknown 1 is not 0.');
    $25daed1151a7a3b7$var$assert(unk2 === 0x0f10, 'Unknown 2 is not 0x0f10.');
    // Parse tileset.
    const numberOfTiles = parser.getUint8() + 1;
    const gfx = [];
    let n = 0;
    while(n < numberOfTiles * 16){
        const loop = parser.getUint8();
        if (loop & 0x80) for(let j = 0; j < (loop & 0x7f); j++)gfx[n++] = parser.getUint8();
        else {
            const data = parser.getUint8();
            for(let j = 0; j < (loop & 0x7f); j++)gfx[n++] = data;
        }
    }
    $25daed1151a7a3b7$var$assert(numberOfTiles === gfx.length / 8 / 2, 'Number of tiles byte does not match number of tiles decoded.');
    // Parse gfx nametable.
    const unk3 = parser.getUint16();
    const unk4 = parser.getUint8();
    const width = parser.getUint8() + 1;
    const height = parser.getUint8() + 1;
    $25daed1151a7a3b7$var$assert(unk3 === 1, 'Unknown 3 is not 1.');
    $25daed1151a7a3b7$var$assert(width === 32, 'Title width is not 32.');
    $25daed1151a7a3b7$var$assert(height === 30, 'Title height is not 30.');
    const nametableTmp = Array(width * height);
    n = 0;
    while(n < nametableTmp.length){
        const loop = parser.getUint8();
        if (loop & 0x80) for(let j = 0; j < (loop & 0x7f); j++)nametableTmp[n++] = parser.getUint8();
        else {
            const data = parser.getUint8();
            for(let j = 0; j < (loop & 0x7f); j++)nametableTmp[n++] = data;
        }
    }
    // Slice the nametable so it is formatted like rooms'.
    const nametable = new Array(height);
    for(let i = 0; i < height; i++)nametable[i] = nametableTmp.slice(i * width, (i + 1) * width);
    // Parse gfx attrtable.
    const unk5 = parser.getUint16();
    const unk6 = parser.getUint8();
    const attrWidth = parser.getUint8() + 1;
    const attrHeight = parser.getUint8() + 1;
    $25daed1151a7a3b7$var$assert(unk5 === 0xc002, 'Unknown 5 is not 1.');
    $25daed1151a7a3b7$var$assert(unk6 === 0x23, 'Unknown 6 is not 0x23.');
    $25daed1151a7a3b7$var$assert(attrWidth === 8, 'attrWidth is not 8.');
    $25daed1151a7a3b7$var$assert(attrHeight === 8, 'attrHeight is not 8.');
    const attributes = Array(attrWidth * attrHeight).fill(0);
    n = 0;
    while(n < attributes.length){
        const loop = parser.getUint8();
        if (loop & 0x80) for(let j = 0; j < (loop & 0x7f); j++)attributes[n++] = parser.getUint8();
        else {
            const data = parser.getUint8();
            for(let j = 0; j < (loop & 0x7f); j++)attributes[n++] = data;
        }
    }
    const stepNum = parser.getUint8();
    $25daed1151a7a3b7$var$assert(stepNum === 3, 'stepNum is not 3.');
    // Parse the palette.
    const { palette: palette, paletteMap: paletteMap } = (0, $4c0af675549ba9d7$export$2e2bcd8739ae039)(arrayBuffer.slice(parser.pointer, parser.pointer + 16), parser.pointer);
    map.push(paletteMap);
    const endOfDataParser = new (0, $e4cecf2d6be4f96f$export$2e2bcd8739ae039)(arrayBuffer.slice(parser.pointer + 16, parser.pointer + 17));
    const endOfData = endOfDataParser.getUint8();
    $25daed1151a7a3b7$var$assert(endOfData === 0xff, 'endOfData is not 0xff.');
    // metadata.decompressedSize = gfx.length;
    metadata.size = parser.pointer;
    return {
        metadata: metadata,
        numberOfTiles: numberOfTiles,
        gfx: gfx,
        width: width,
        height: height,
        nametable: nametable,
        attrWidth: attrWidth,
        attrHeight: attrHeight,
        attributes: attributes,
        stepNum: stepNum,
        palette: palette,
        endOfData: endOfData,
        unk1: unk1,
        unk2: unk2,
        unk3: unk3,
        unk4: unk4,
        unk5: unk5,
        unk6: unk6,
        map: map
    };
};
var $25daed1151a7a3b7$export$2e2bcd8739ae039 = $25daed1151a7a3b7$var$parseTitles;


const $41a6b1b6b788224e$var$parseRom = (arrayBuffer, res)=>{
    const rooms = [];
    const roomgfx = [];
    const globdata = [];
    const scripts = [];
    const costumegfx = [];
    const costumes = [];
    const sprpals = [];
    const sprdesc = [];
    const sproffs = [];
    const sprlens = [];
    const sprdata = [];
    const preps = [];
    const titles = [];
    for(let i = 0; i < res?.rooms?.length; i++){
        const [offset, length] = res.rooms[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $b2ad64656ebcc268$export$2e2bcd8739ae039)(buffer, i, offset, res.characters);
        item.buffer = buffer;
        rooms.push(item);
    }
    for(let i = 0; i < res?.roomgfx?.length; i++){
        const [offset, length] = res.roomgfx[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $670e2fe52bba705e$export$2e2bcd8739ae039)(buffer, i, offset);
        item.buffer = buffer;
        roomgfx.push(item);
    }
    for(let i = 0; i < res?.globdata?.length; i++){
        const [offset, length] = res.globdata[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $9a433a62f11b6d5d$export$2e2bcd8739ae039)(buffer, i, offset);
        item.buffer = buffer;
        globdata.push(item);
    }
    for(let i = 0; i < res.scripts.length; i++){
        const [offset, length] = res.scripts[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $0d4f91a3615021da$export$2e2bcd8739ae039)(buffer, i, offset, res.characters);
        item.buffer = buffer;
        scripts.push(item);
    }
    for(let i = 0; i < res.costumegfx.length; i++){
        const [offset, length] = res.costumegfx[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $37c164d27b076548$export$2e2bcd8739ae039)(buffer, i, offset);
        item.buffer = buffer;
        costumegfx.push(item);
    }
    for(let i = 0; i < res.costumes.length; i++){
        const [offset, length] = res.costumes[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $9ddbd0ded642bef6$export$2e2bcd8739ae039)(buffer, i, offset);
        item.buffer = buffer;
        costumes.push(item);
    }
    for(let i = 0; i < res.sprpals.length; i++){
        const [offset, length] = res.sprpals[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $33a49c5ea0c407c9$export$2e2bcd8739ae039)(buffer, i, offset);
        item.buffer = buffer;
        sprpals.push(item);
    }
    for(let i = 0; i < res.sprdesc.length; i++){
        const [offset, length] = res.sprdesc[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $47cbfffa6362a3fa$export$2e2bcd8739ae039)(buffer, i, offset);
        item.buffer = buffer;
        sprdesc.push(item);
    }
    for(let i = 0; i < res.sproffs.length; i++){
        const [offset, length] = res.sproffs[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $7466991a11144594$export$2e2bcd8739ae039)(buffer, i, offset);
        item.buffer = buffer;
        sproffs.push(item);
    }
    for(let i = 0; i < res.sprlens.length; i++){
        const [offset, length] = res.sprlens[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $93333585778b0ac4$export$2e2bcd8739ae039)(buffer, i, offset);
        item.buffer = buffer;
        sprlens.push(item);
    }
    // @todo Assert that the highest value of sprdesc is within sprlens and sproffs.
    // @todo Assert that sprlens and sproffs have the same length.
    for(let i = 0; i < res.sprdata.length; i++){
        const [offset, length] = res.sprdata[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $c6a14128feecae28$export$2e2bcd8739ae039)(buffer, i, offset);
        item.buffer = buffer;
        sprdata.push(item);
    }
    // @todo Assert that the highest value of sproffs is within sprdata.
    for(let i = 0; i < res?.preplist?.length; i++){
        const [offset, length] = res.preplist[i];
        const buffer = arrayBuffer.slice(offset, offset + length);
        const item = (0, $b58a8f89894fae3e$export$2e2bcd8739ae039)(buffer, i, offset, res.characters);
        item.buffer = buffer;
        preps.push(item);
    }
    // The title screens are stored outside of SCUMM.
    for(let i = 0; i < res?.titles?.length; i++){
        const [offset] = res.titles[i];
        // @todo Figure out the length of the title chunks.
        const buffer = arrayBuffer.slice(offset); //, offset + length);
        const item = (0, $25daed1151a7a3b7$export$2e2bcd8739ae039)(buffer, i, offset);
        item.buffer = buffer;
        titles.push(item);
    }
    return {
        rooms: rooms,
        roomgfx: roomgfx,
        globdata: globdata,
        scripts: scripts,
        costumegfx: costumegfx,
        costumes: costumes,
        sprpals: sprpals,
        sprdesc: sprdesc,
        sproffs: sproffs,
        sprlens: sprlens,
        sprdata: sprdata,
        preps: preps,
        titles: titles
    };
};
var $41a6b1b6b788224e$export$2e2bcd8739ae039 = $41a6b1b6b788224e$var$parseRom;



const $77f5f4efaf83b50c$var$Main = ({ children: children })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("main", {
        className: "grow space-y-4 overflow-y-auto p-4 md:space-y-5 md:p-5 xl:space-y-6 xl:p-6",
        children: children
    });
var $77f5f4efaf83b50c$export$2e2bcd8739ae039 = $77f5f4efaf83b50c$var$Main;



function $ffbe6821f5cb54f6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ffbe6821f5cb54f6$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ffbe6821f5cb54f6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ffbe6821f5cb54f6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ffbe6821f5cb54f6$export$2e2bcd8739ae039 = $ffbe6821f5cb54f6$export$4f5d2d50c9deca37;



const $0ec0c869b245a9a3$var$DropZone = ({ children: children, isDragActive: isDragActive, isDragReject: isDragReject, errorCode: errorCode })=>{
    let label = 'Drag a PRG or a ROM file here.';
    let className = 'text-slate-600 bg-slate-300 dark:text-slate-400 dark:bg-slate-700 outline-slate-400 outline-offset-[-.75rem]';
    if (isDragActive) {
        label = 'Drop it here!';
        className = 'text-blue-600 bg-blue-200 dark:text-blue-400 dark:bg-blue-800 outline-blue-400 outline-offset-[-1.5rem]';
    }
    if (isDragReject) {
        label = 'Only one file please!';
        className = 'text-rose-600 bg-rose-200 dark:text-red-400 dark:bg-red-800 outline-rose-400 outline-offset-[-1.5rem]';
    }
    let errorMsg = null;
    switch(errorCode){
        case 'too-many-files':
            errorMsg = 'Multiple files are not allowed.';
            break;
        case 'wrong-extension':
            errorMsg = 'Only PRG and NES files are accepted.';
            break;
        case 'japanese-rom-unsupported':
            errorMsg = 'The Japanese Famicom version is not supported.';
            break;
        case 'invalid-rom-file':
            errorMsg = 'The ROM was not recognised as one of Maniac Mansion on NES.';
            break;
        case 'reading-file-failed':
            errorMsg = 'File reading has failed. Please try again.';
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('relative flex h-full w-full flex-col items-center justify-center gap-2 rounded-xl p-10 outline-dashed outline-4 transition-all', className),
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $7b3ddec5fac855db$export$2e2bcd8739ae039), {
                className: "absolute z-0 size-1/2 opacity-10"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                className: "mx-6 text-balance text-center text-3xl",
                children: label
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                className: "mx-6 text-balance text-center text-sm opacity-75",
                children: "A PRG file is a NES ROM file without the headers."
            }),
            errorMsg && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                className: "z-10 mt-6 rounded-xl bg-rose-200 p-4 text-xl text-rose-700",
                children: errorMsg
            }),
            children
        ]
    });
};
var $0ec0c869b245a9a3$export$2e2bcd8739ae039 = $0ec0c869b245a9a3$var$DropZone;




var $l7WPE = parcelRequire("l7WPE");


var $l7WPE = parcelRequire("l7WPE");
function $a7c14ba5e042b5af$var$QuestionMarkCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $l7WPE.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $l7WPE.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $l7WPE.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
    }));
}
const $a7c14ba5e042b5af$var$ForwardRef = /*#__PURE__*/ $l7WPE.forwardRef($a7c14ba5e042b5af$var$QuestionMarkCircleIcon);
var $a7c14ba5e042b5af$export$2e2bcd8739ae039 = $a7c14ba5e042b5af$var$ForwardRef;



var $aBqif = parcelRequire("aBqif");
const $bf6ade995f21ad39$var$defaultValue = 'USA'; // The USA version is the most commonly used base ROM.
const $bf6ade995f21ad39$var$BaseRomDialog = ({ open: open, setOpen: setOpen, setBaseRom: setBaseRom })=>{
    const [baseRom, setInternalBaseRom] = (0, $l7WPE.useState)($bf6ade995f21ad39$var$defaultValue);
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $c80c1e31473e381f$export$be58926105124dd4), {
        show: open,
        as: (0, $l7WPE.Fragment),
        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $abb936996b9e17de$export$3ddf2d174ce01153), {
            className: "relative z-10",
            onClose: ()=>{},
            children: [
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $c80c1e31473e381f$export$b8acc0f6b9e8ca5d), {
                    as: (0, $l7WPE.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                        className: "fixed inset-0 bg-slate-100/75 opacity-100 dark:bg-slate-900/75"
                    })
                }),
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                    className: "fixed inset-0 z-10 w-screen overflow-y-auto",
                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $c80c1e31473e381f$export$b8acc0f6b9e8ca5d), {
                            as: (0, $l7WPE.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $abb936996b9e17de$export$46512663428d955a), {
                                className: "relative transform overflow-hidden rounded-md bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6",
                                children: [
                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                                                className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-100",
                                                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $a7c14ba5e042b5af$export$2e2bcd8739ae039), {
                                                    className: "size-6 text-primary-600",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                                                className: "mt-3 sm:mt-5",
                                                children: [
                                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $abb936996b9e17de$export$16f7638e4a34b909), {
                                                        as: "h3",
                                                        className: "text-center text-base font-semibold leading-6 text-gray-900",
                                                        children: "Unrecognised ROM"
                                                    }),
                                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                                                        className: "my-2",
                                                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("p", {
                                                            className: "text-sm text-gray-500",
                                                            children: "The ROM you selected could not be identified. If it's a ROM hack, select the version used as its base."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)($bf6ade995f21ad39$var$BaseRomSelector, {
                                                        setBaseRom: setInternalBaseRom
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                                        className: "mt-5 sm:mt-6",
                                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("button", {
                                            type: "button",
                                            className: "inline-flex w-full justify-center rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600",
                                            onClick: ()=>{
                                                setOpen(false);
                                                setBaseRom(baseRom);
                                            },
                                            children: "Select base ROM version"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
const $bf6ade995f21ad39$var$BaseRomSelector = ({ setBaseRom: setBaseRom })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("label", {
                htmlFor: "base-rom",
                className: "block text-sm font-medium leading-6 text-gray-900",
                children: "Base ROM version"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("select", {
                id: "base-rom",
                name: "base-rom",
                className: "mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary-600 sm:text-sm sm:leading-6",
                defaultValue: $bf6ade995f21ad39$var$defaultValue,
                onChange: ({ target: target })=>setBaseRom(target.value),
                children: (0, $aBqif.BASE_ROMS).map(({ name: name })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("option", {
                        children: name
                    }, name))
            })
        ]
    });
};
var $bf6ade995f21ad39$export$2e2bcd8739ae039 = $bf6ade995f21ad39$var$BaseRomDialog;






const $0bb29f963430fcbe$var$DropZoneContainer = ()=>{
    const validator = (file)=>{
        setErrorCode(null);
        setPrg(null);
        setRes(null);
        if (!file.name) return null;
        // Verify the file extension.
        if (!file.name.endsWith('.prg') && !file.name.endsWith('.nes')) return {
            code: 'wrong-extension',
            message: `Only PRG and NES files are accepted.`
        };
        // Check that it is one of the supported rom files.
        const reader = new FileReader();
        reader.onerror = ()=>{
            setErrorCode('reading-file-failed');
        };
        reader.onload = async ()=>{
            const { hasNesHeader: hasNesHeader } = await Promise.resolve((parcelRequire("idaDz")));
            const { default: crc32 } = await (parcelRequire("k3R1Q"));
            const { isJapaneseVersion: isJapaneseVersion, getResFromCrc32: getResFromCrc32 } = await Promise.resolve((parcelRequire("aBqif")));
            let arrayBuffer = reader.result;
            if (file.name.endsWith('.nes') || hasNesHeader(arrayBuffer)) arrayBuffer = arrayBuffer.slice(16);
            const dataView = new DataView(arrayBuffer);
            const c = crc32(dataView);
            if (isJapaneseVersion(c)) {
                setErrorCode('japanese-rom-unsupported');
                return;
            }
            const res = getResFromCrc32(c);
            setPrg(arrayBuffer);
            if (!res) {
                setBaseRomDialogOpened(true);
                return;
            }
            setRes(res);
        };
        reader.readAsArrayBuffer(file);
        return null;
    };
    const dispatch = (0, $289dddd4090929de$export$181baa7312ee9507)();
    const [errorCode, setErrorCode] = (0, $l7WPE.useState)(null);
    const [baseRomDialogOpened, setBaseRomDialogOpened] = (0, $l7WPE.useState)(false);
    const [baseRom, setBaseRom] = (0, $l7WPE.useState)(null);
    const [prg, setPrg] = (0, $l7WPE.useState)(null);
    const [res, setRes] = (0, $l7WPE.useState)(null);
    const { getRootProps: getRootProps, getInputProps: getInputProps, acceptedFiles: acceptedFiles, fileRejections: fileRejections, isDragActive: isDragActive, isDragReject: isDragReject } = (0, $2b0e4d8a59340d66$export$cd49c0ecc5be9f36)({
        maxFiles: 1,
        multiple: false,
        validator: validator
    });
    const navigate = (0, $e8d0e236465e8031$export$9770f232ac06a008)();
    if (baseRom) (async ()=>{
        const { getResFromBaseRom: getResFromBaseRom } = await Promise.resolve((parcelRequire("aBqif")));
        const res = getResFromBaseRom(baseRom);
        try {
            (0, $41a6b1b6b788224e$export$2e2bcd8739ae039)(prg, res);
            setRes(res);
        } catch (err) {
            setErrorCode('invalid-rom-file');
        }
    })();
    if (fileRejections[0] && fileRejections[0]?.errors[0]?.code && !errorCode) setErrorCode(fileRejections[0].errors[0].code);
    (0, $l7WPE.useEffect)(()=>{
        if (acceptedFiles.length === 1 && prg && res) {
            const resources = (0, $41a6b1b6b788224e$export$2e2bcd8739ae039)(prg, res);
            dispatch({
                type: 'initialised',
                rom: {
                    prg: prg,
                    res: res,
                    resources: resources
                }
            });
            // Redirect to the first room.
            navigate('/rooms/1');
        }
    }, [
        acceptedFiles,
        prg,
        res,
        dispatch,
        navigate
    ]);
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $77f5f4efaf83b50c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $bf6ade995f21ad39$export$2e2bcd8739ae039), {
                open: baseRomDialogOpened,
                setOpen: setBaseRomDialogOpened,
                setBaseRom: setBaseRom
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                className: "h-full w-full p-4",
                ...getRootProps(),
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $0ec0c869b245a9a3$export$2e2bcd8739ae039), {
                        isDragActive: isDragActive,
                        isDragReject: isDragReject,
                        errorCode: errorCode
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("input", {
                        ...getInputProps()
                    })
                ]
            })
        ]
    });
};
var $0bb29f963430fcbe$export$2e2bcd8739ae039 = $0bb29f963430fcbe$var$DropZoneContainer;







var $l7WPE = parcelRequire("l7WPE");



var $jrGSV = parcelRequire("jrGSV");
const $5b4f9380c818b26a$var$titleNames = [
    'Main title',
    'Logo title'
];
const $5b4f9380c818b26a$var$roomNames = [
    'Crash',
    'Front yard',
    'Bottom of pool',
    'Living room',
    'Dungeon',
    'Library',
    'Swimming pool',
    'Kitchen',
    'Basement',
    'Attic 1 (safe room)',
    'Main entry way',
    'Hallway 1 (entry way)',
    'Entryway 2 (to darkroom)',
    '2nd floor hallway',
    'Painting room',
    'Attic 2 (wires)',
    'Garage',
    'Music room',
    'Arcade',
    "Edna's room",
    "Tentacle's room",
    "Fred's room",
    "Fred's office",
    'Darkroom',
    "Ted's bathroom",
    "Ted's room",
    "Weird Ed's room",
    'Den',
    'Observatory',
    'Under house',
    'Ready room',
    'Laboratory',
    '911 cutscene',
    'Intro cutscene',
    "Safe's password",
    'Telescope alien cutscene',
    'Pantry',
    'Dining room',
    'Top hallway',
    'Arcade high score',
    'Inside television',
    'Television network room',
    'Talk show',
    'Phone numbers',
    'Driveway',
    'Character selection',
    'Car fly cutscene',
    'Bad ending cutscene',
    'Car in space ending cutscene',
    'Title screen',
    'Pause menu',
    'Meteor room',
    'Garage destroyed',
    'Beta character selection',
    'Telescope cutscene outside',
    'Grey',
    'Crash'
];
const $5b4f9380c818b26a$var$getScreenLabel = (screenType = 'room', id, long = false)=>{
    switch(localStorage.getItem('screen-name')){
        default:
        case 'mm':
            if (screenType === 'title') {
                if (long) return `Title screen ${id} - ${$5b4f9380c818b26a$var$titleNames[id]}`;
                return `${id} ${$5b4f9380c818b26a$var$titleNames[id]}`;
            }
            if (screenType === 'room') {
                if (long) return `Room ${(0, $jrGSV.zeroPad)(id)} - ${$5b4f9380c818b26a$var$roomNames[id]}`;
                return `${id} ${$5b4f9380c818b26a$var$roomNames[id]}`;
            }
            throw new Error(`Unknown screen type ${screenType}`);
        case 'numbers':
            if (screenType === 'title') return `Title screen ${id}`;
            if (screenType === 'room') {
                if (long) return `Room ${(0, $jrGSV.zeroPad)(id)}`;
                return `Room ${id}`;
            }
            throw new Error(`Unknown screen type ${screenType}`);
    }
};
var $5b4f9380c818b26a$export$2e2bcd8739ae039 = $5b4f9380c818b26a$var$getScreenLabel;



const $307bcb5ed139e868$var$PrimaryColumn = ({ children: children })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("nav", {
        className: "w-44 shrink-0 overflow-y-auto text-nowrap bg-slate-700 text-xs text-slate-200 sm:w-48 md:w-56 md:text-sm lg:w-60",
        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("ol", {
            children: children
        })
    });
var $307bcb5ed139e868$export$2e2bcd8739ae039 = $307bcb5ed139e868$var$PrimaryColumn;






var $l7WPE = parcelRequire("l7WPE");


var $l7WPE = parcelRequire("l7WPE");




var $l7WPE = parcelRequire("l7WPE");
let $5055a520bd3df962$var$e = (0, $l7WPE.createContext)(void 0);
function $5055a520bd3df962$export$6ba3910d268310db() {
    return (0, $l7WPE.useContext)($5055a520bd3df962$var$e);
}
function $5055a520bd3df962$export$6be90bcb437e928f({ id: t, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($5055a520bd3df962$var$e.Provider, {
        value: t
    }, r);
}



"use client";
let $cc31415baf6a16fd$var$c = (0, $l7WPE.createContext)(null);
$cc31415baf6a16fd$var$c.displayName = "LabelContext";
function $cc31415baf6a16fd$export$feddbbf47baabdb9() {
    let r = (0, $l7WPE.useContext)($cc31415baf6a16fd$var$c);
    if (r === null) {
        let l = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(l, $cc31415baf6a16fd$export$feddbbf47baabdb9), l;
    }
    return r;
}
function $cc31415baf6a16fd$export$1f86aee6764cddb2(r) {
    var a, e, o;
    let l = (e = (a = (0, $l7WPE.useContext)($cc31415baf6a16fd$var$c)) == null ? void 0 : a.value) != null ? e : void 0;
    return ((o = r == null ? void 0 : r.length) != null ? o : 0) > 0 ? [
        l,
        ...r
    ].filter(Boolean).join(" ") : l;
}
function $cc31415baf6a16fd$export$d6875122194c7b44({ inherit: r = !1 } = {}) {
    let l = $cc31415baf6a16fd$export$1f86aee6764cddb2(), [a, e] = (0, $l7WPE.useState)([]), o = r ? [
        l,
        ...a
    ].filter(Boolean) : a;
    return [
        o.length > 0 ? o.join(" ") : void 0,
        (0, $l7WPE.useMemo)(()=>function(t) {
                let s = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((i)=>(e((p)=>[
                            ...p,
                            i
                        ]), ()=>e((p)=>{
                            let u = p.slice(), d = u.indexOf(i);
                            return d !== -1 && u.splice(d, 1), u;
                        }))), m = (0, $l7WPE.useMemo)(()=>({
                        register: s,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    s,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($cc31415baf6a16fd$var$c.Provider, {
                    value: m
                }, t.children);
            }, [
            e
        ])
    ];
}
let $cc31415baf6a16fd$var$N = "label";
function $cc31415baf6a16fd$var$G(r, l) {
    var y;
    let a = (0, $l7WPE.useId)(), e = $cc31415baf6a16fd$export$feddbbf47baabdb9(), o = (0, $5055a520bd3df962$export$6ba3910d268310db)(), g = (0, $3ffab61d59a88c3c$export$c763bb7a184a0f11)(), { id: t = `headlessui-label-${a}`, htmlFor: s = o != null ? o : (y = e.props) == null ? void 0 : y.htmlFor, passive: m = !1, ...i } = r, p = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(l);
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>e.register(t), [
        t,
        e.register
    ]);
    let u = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((L)=>{
        let b = L.currentTarget;
        if (b instanceof HTMLLabelElement && L.preventDefault(), e.props && "onClick" in e.props && typeof e.props.onClick == "function" && e.props.onClick(L), b instanceof HTMLLabelElement) {
            let n = document.getElementById(b.htmlFor);
            if (n) {
                let E = n.getAttribute("disabled");
                if (E === "true" || E === "") return;
                let x = n.getAttribute("aria-disabled");
                if (x === "true" || x === "") return;
                (n instanceof HTMLInputElement && (n.type === "radio" || n.type === "checkbox") || n.role === "radio" || n.role === "checkbox" || n.role === "switch") && n.click(), n.focus({
                    preventScroll: !0
                });
            }
        }
    }), d = g || !1, C = (0, $l7WPE.useMemo)(()=>({
            ...e.slot,
            disabled: d
        }), [
        e.slot,
        d
    ]), f = {
        ref: p,
        ...e.props,
        id: t,
        htmlFor: s,
        onClick: u
    };
    return m && ("onClick" in f && (delete f.htmlFor, delete f.onClick), "onClick" in i && delete i.onClick), (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)()({
        ourProps: f,
        theirProps: i,
        slot: C,
        defaultTag: s ? $cc31415baf6a16fd$var$N : "div",
        name: e.name || "Label"
    });
}
let $cc31415baf6a16fd$var$U = (0, $30c8a076c23acfb8$export$e43f39796049410c)($cc31415baf6a16fd$var$G), $cc31415baf6a16fd$export$b04be29aa201d4f5 = Object.assign($cc31415baf6a16fd$var$U, {});

const $a38c1f8ad019ba28$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $a38c1f8ad019ba28$export$f21a1ffae260145a = (el)=>{
    if (el && 'window' in el && el.window === el) return el;
    const doc = $a38c1f8ad019ba28$export$b204af158042fbac(el);
    return doc.defaultView || window;
};

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fb9eb789782d533e$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === 'undefined' || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $fb9eb789782d533e$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $fb9eb789782d533e$var$$c87311424ea30a05$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $fb9eb789782d533e$export$9ac100e40613ea10 = $fb9eb789782d533e$var$$c87311424ea30a05$var$cached(function() {
    return $fb9eb789782d533e$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $fb9eb789782d533e$export$186c6964ca17d99 = $fb9eb789782d533e$var$$c87311424ea30a05$var$cached(function() {
    return $fb9eb789782d533e$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $fb9eb789782d533e$export$7bef049ce92e4224 = $fb9eb789782d533e$var$$c87311424ea30a05$var$cached(function() {
    return $fb9eb789782d533e$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $fb9eb789782d533e$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $fb9eb789782d533e$export$fedb369cb70207f1 = $fb9eb789782d533e$var$$c87311424ea30a05$var$cached(function() {
    return $fb9eb789782d533e$export$186c6964ca17d99() || $fb9eb789782d533e$export$7bef049ce92e4224();
});
const $fb9eb789782d533e$export$e1865c3bedcd822b = $fb9eb789782d533e$var$$c87311424ea30a05$var$cached(function() {
    return $fb9eb789782d533e$export$9ac100e40613ea10() || $fb9eb789782d533e$export$fedb369cb70207f1();
});
const $fb9eb789782d533e$export$78551043582a6a98 = $fb9eb789782d533e$var$$c87311424ea30a05$var$cached(function() {
    return $fb9eb789782d533e$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$fb9eb789782d533e$export$6446a186d09e379e();
});
const $fb9eb789782d533e$export$6446a186d09e379e = $fb9eb789782d533e$var$$c87311424ea30a05$var$cached(function() {
    return $fb9eb789782d533e$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $fb9eb789782d533e$export$a11b0059900ceec8 = $fb9eb789782d533e$var$$c87311424ea30a05$var$cached(function() {
    return $fb9eb789782d533e$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
});
const $fb9eb789782d533e$export$b7d78993b74f766d = $fb9eb789782d533e$var$$c87311424ea30a05$var$cached(function() {
    return $fb9eb789782d533e$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
});


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fcb992949b5ea8c9$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $fb9eb789782d533e$export$a11b0059900ceec8)() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $fcb992949b5ea8c9$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $fb9eb789782d533e$export$a11b0059900ceec8)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse';
}



var $l7WPE = parcelRequire("l7WPE");

var $l7WPE = parcelRequire("l7WPE");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createContext($b18cef6e7d8e081c$var$$b5e257d569688ac6$var$defaultContext);
const $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createContext(false);
// This is only used in React < 18.
function $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $l7WPE.useContext)($b18cef6e7d8e081c$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$useCounter(cur === $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $l7WPE.useState)(true);
    let value = (0, $l7WPE.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $l7WPE.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($b18cef6e7d8e081c$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($b18cef6e7d8e081c$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $b18cef6e7d8e081c$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE)))['useId'] === 'function') {
        if (!$b18cef6e7d8e081c$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn('In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.');
            $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($b18cef6e7d8e081c$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $l7WPE.useContext)($b18cef6e7d8e081c$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $l7WPE.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $l7WPE.useContext)($b18cef6e7d8e081c$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$defaultContext && !$b18cef6e7d8e081c$var$$b5e257d569688ac6$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    let counter = $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).useId();
    let [didSSR] = (0, $l7WPE.useState)($b18cef6e7d8e081c$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$b18cef6e7d8e081c$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $b18cef6e7d8e081c$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE)))['useId'] === 'function' ? $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$useModernSSRSafeId : $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $b18cef6e7d8e081c$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE)))['useSyncExternalStore']($b18cef6e7d8e081c$var$$b5e257d569688ac6$var$subscribe, $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$getSnapshot, $b18cef6e7d8e081c$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $l7WPE.useContext)($b18cef6e7d8e081c$var$$b5e257d569688ac6$var$IsSSRContext);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $eda66275e26830eb$var$$507fabe10e71c6fb$var$currentModality = null;
let $eda66275e26830eb$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $eda66275e26830eb$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $eda66275e26830eb$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $eda66275e26830eb$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $eda66275e26830eb$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $eda66275e26830eb$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $eda66275e26830eb$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $eda66275e26830eb$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $fb9eb789782d533e$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $eda66275e26830eb$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($eda66275e26830eb$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$currentModality = 'keyboard';
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$triggerChangeHandlers('keyboard', e);
    }
}
function $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $eda66275e26830eb$var$$507fabe10e71c6fb$var$currentModality = 'pointer';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$triggerChangeHandlers('pointer', e);
    }
}
function $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $fcb992949b5ea8c9$export$60278871457622de)(e)) {
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
    }
}
function $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$eda66275e26830eb$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$eda66275e26830eb$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$triggerChangeHandlers('virtual', e);
    }
    $eda66275e26830eb$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $eda66275e26830eb$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $eda66275e26830eb$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $eda66275e26830eb$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $eda66275e26830eb$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === 'undefined' || $eda66275e26830eb$export$d90243b58daecda7.get((0, $a38c1f8ad019ba28$export$f21a1ffae260145a)(element))) return;
    const windowObject = (0, $a38c1f8ad019ba28$export$f21a1ffae260145a)(element);
    const documentObject = (0, $a38c1f8ad019ba28$export$b204af158042fbac)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener('keydown', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('keyup', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('click', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener('focus', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener('blur', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.addEventListener('pointerdown', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointermove', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointerup', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener('mousedown', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('mousemove', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('mouseup', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener('beforeunload', ()=>{
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $eda66275e26830eb$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $eda66275e26830eb$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $a38c1f8ad019ba28$export$f21a1ffae260145a)(element);
    const documentObject = (0, $a38c1f8ad019ba28$export$b204af158042fbac)(element);
    if (loadListener) documentObject.removeEventListener('DOMContentLoaded', loadListener);
    if (!$eda66275e26830eb$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $eda66275e26830eb$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener('keydown', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('keyup', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('click', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener('focus', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener('blur', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.removeEventListener('pointerdown', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointermove', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointerup', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener('mousedown', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('mousemove', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('mouseup', $eda66275e26830eb$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $eda66275e26830eb$export$d90243b58daecda7.delete(windowObject);
};
function $eda66275e26830eb$export$2f1888112f558a7d(element) {
    const documentObject = (0, $a38c1f8ad019ba28$export$b204af158042fbac)(element);
    let loadListener;
    if (documentObject.readyState !== 'loading') $eda66275e26830eb$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $eda66275e26830eb$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener('DOMContentLoaded', loadListener);
    }
    return ()=>$eda66275e26830eb$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== 'undefined') $eda66275e26830eb$export$2f1888112f558a7d();
function $eda66275e26830eb$export$b9b3dfddab17db27() {
    return $eda66275e26830eb$var$$507fabe10e71c6fb$var$currentModality !== 'pointer';
}
function $eda66275e26830eb$export$630ff653c5ada6a9() {
    return $eda66275e26830eb$var$$507fabe10e71c6fb$var$currentModality;
}
function $eda66275e26830eb$export$8397ddfc504fdb9a(modality) {
    $eda66275e26830eb$var$$507fabe10e71c6fb$var$currentModality = modality;
    $eda66275e26830eb$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $eda66275e26830eb$export$98e20ec92f614cfe() {
    $eda66275e26830eb$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $l7WPE.useState)($eda66275e26830eb$var$$507fabe10e71c6fb$var$currentModality);
    (0, $l7WPE.useEffect)(()=>{
        let handler = ()=>{
            setModality($eda66275e26830eb$var$$507fabe10e71c6fb$var$currentModality);
        };
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $eda66275e26830eb$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $b18cef6e7d8e081c$export$535bd6ca7f90a273)() ? null : modality;
}
const $eda66275e26830eb$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $eda66275e26830eb$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== 'undefined' ? (0, $a38c1f8ad019ba28$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== 'undefined' ? (0, $a38c1f8ad019ba28$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== 'undefined' ? (0, $a38c1f8ad019ba28$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== 'undefined' ? (0, $a38c1f8ad019ba28$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$eda66275e26830eb$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === 'keyboard' && e instanceof IKeyboardEvent && !$eda66275e26830eb$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $eda66275e26830eb$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $l7WPE.useState)(autoFocus || $eda66275e26830eb$export$b9b3dfddab17db27());
    $eda66275e26830eb$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $eda66275e26830eb$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $eda66275e26830eb$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $l7WPE.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$eda66275e26830eb$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($eda66275e26830eb$export$b9b3dfddab17db27());
        };
        $eda66275e26830eb$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $eda66275e26830eb$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}


var $l7WPE = parcelRequire("l7WPE");

var $l7WPE = parcelRequire("l7WPE");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2b849691d172a50a$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).useLayoutEffect : ()=>{};



var $l7WPE = parcelRequire("l7WPE");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $af83ad8bb8afcaa7$export$7f54fc3180508a52(fn) {
    const ref = (0, $l7WPE.useRef)(null);
    (0, $2b849691d172a50a$export$e5c5a5f917a5871c)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $l7WPE.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $12ecaac049170c79$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $12ecaac049170c79$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $l7WPE.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $2b849691d172a50a$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $af83ad8bb8afcaa7$export$7f54fc3180508a52)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $l7WPE.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $12ecaac049170c79$export$905e7fc544a71f36('blur', e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener('focusout', onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent('blur', {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent('focusout', {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    'disabled'
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}



var $l7WPE = parcelRequire("l7WPE");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $19adc9e001428458$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $l7WPE.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $12ecaac049170c79$export$715c682d09d639cc)(onBlur);
    const onFocus = (0, $l7WPE.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $a38c1f8ad019ba28$export$b204af158042fbac)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}



var $l7WPE = parcelRequire("l7WPE");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $890cfc66d57b4228$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $l7WPE.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $l7WPE.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $12ecaac049170c79$export$715c682d09d639cc)(onBlur);
    let onFocus = (0, $l7WPE.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}



var $l7WPE = parcelRequire("l7WPE");
function $445bbf4beaf356d1$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $l7WPE.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $eda66275e26830eb$export$b9b3dfddab17db27)()
    });
    let [isFocused, setFocused] = (0, $l7WPE.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $l7WPE.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $l7WPE.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $l7WPE.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $eda66275e26830eb$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $19adc9e001428458$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $890cfc66d57b4228$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}



var $l7WPE = parcelRequire("l7WPE");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $7c7777069b2743a0$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $7c7777069b2743a0$var$$6179b936705e76d3$var$hoverCount = 0;
function $7c7777069b2743a0$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $7c7777069b2743a0$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $7c7777069b2743a0$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $7c7777069b2743a0$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === 'touch') $7c7777069b2743a0$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $7c7777069b2743a0$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === 'undefined') return;
    if (typeof PointerEvent !== 'undefined') document.addEventListener('pointerup', $7c7777069b2743a0$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener('touchend', $7c7777069b2743a0$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $7c7777069b2743a0$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $7c7777069b2743a0$var$$6179b936705e76d3$var$hoverCount--;
        if ($7c7777069b2743a0$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== 'undefined') document.removeEventListener('pointerup', $7c7777069b2743a0$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener('touchend', $7c7777069b2743a0$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $7c7777069b2743a0$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $l7WPE.useState)(false);
    let state = (0, $l7WPE.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: '',
        target: null
    }).current;
    (0, $l7WPE.useEffect)($7c7777069b2743a0$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $l7WPE.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === 'touch' || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: 'hoverstart',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = '';
            state.target = null;
            if (pointerType === 'touch' || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: 'hoverend',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== 'undefined') {
            hoverProps.onPointerEnter = (e)=>{
                if ($7c7777069b2743a0$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$7c7777069b2743a0$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, 'mouse');
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, 'mouse');
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $l7WPE.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}



var $l7WPE = parcelRequire("l7WPE");


var $l7WPE = parcelRequire("l7WPE");



function $156b190393638fd9$var$E(e) {
    let t = e.width / 2, n = e.height / 2;
    return {
        top: e.clientY - n,
        right: e.clientX + t,
        bottom: e.clientY + n,
        left: e.clientX - t
    };
}
function $156b190393638fd9$var$P(e, t) {
    return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function $156b190393638fd9$export$73224eeef4bbe873({ disabled: e = !1 } = {}) {
    let t = (0, $l7WPE.useRef)(null), [n, l] = (0, $l7WPE.useState)(!1), r = (0, $03ea8ceff1795700$export$fd183955ff4b45d9)(), o = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        t.current = null, l(!1), r.dispose();
    }), f = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((s)=>{
        if (r.dispose(), t.current === null) {
            t.current = s.currentTarget, l(!0);
            {
                let i = (0, $be0aa046e776f98a$export$b204af158042fbac)(s.currentTarget);
                r.addEventListener(i, "pointerup", o, !1), r.addEventListener(i, "pointermove", (c)=>{
                    if (t.current) {
                        let p = $156b190393638fd9$var$E(c);
                        l($156b190393638fd9$var$P(p, t.current.getBoundingClientRect()));
                    }
                }, !1), r.addEventListener(i, "pointercancel", o, !1);
            }
        }
    });
    return {
        pressed: n,
        pressProps: e ? {} : {
            onPointerDown: f,
            onPointerUp: o,
            onClick: o
        }
    };
}



var $l7WPE = parcelRequire("l7WPE");
function $23dae15276e93483$var$l(e, r) {
    return e !== null && r !== null && typeof e == "object" && typeof r == "object" && "id" in e && "id" in r ? e.id === r.id : e === r;
}
function $23dae15276e93483$export$988f0cf1b37580ae(e = $23dae15276e93483$var$l) {
    return (0, $l7WPE.useCallback)((r, t)=>{
        if (typeof e == "string") {
            let o = e;
            return (r == null ? void 0 : r[o]) === (t == null ? void 0 : t[o]);
        }
        return e(r, t);
    }, [
        e
    ]);
}



var $l7WPE = parcelRequire("l7WPE");

function $288b02513317d536$export$454217e89aea72b(l, r, c) {
    let [i, s] = (0, $l7WPE.useState)(c), e = l !== void 0, t = (0, $l7WPE.useRef)(e), u = (0, $l7WPE.useRef)(!1), d = (0, $l7WPE.useRef)(!1);
    return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? l : i,
        (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((n)=>(e || s(n), r == null ? void 0 : r(n)))
    ];
}



var $l7WPE = parcelRequire("l7WPE");
function $3140c01a3fe83286$export$8a91ee242b6d0fe3(e) {
    let [t] = (0, $l7WPE.useState)(e);
    return t;
}



var $l7WPE = parcelRequire("l7WPE");

function $fef4c2ffbde74102$export$d0b9dbca977c73d5(n, t) {
    let e = (0, $l7WPE.useRef)({
        left: 0,
        top: 0
    });
    if ((0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        if (!t) return;
        let r = t.getBoundingClientRect();
        r && (e.current = r);
    }, [
        n,
        t
    ]), t == null || !n || t === document.activeElement) return !1;
    let o = t.getBoundingClientRect();
    return o.top !== e.current.top || o.left !== e.current.left;
}




var $l7WPE = parcelRequire("l7WPE");

function $75fd44aa0be2e2ce$var$f(e) {
    if (e === null) return {
        width: 0,
        height: 0
    };
    let { width: t, height: r } = e.getBoundingClientRect();
    return {
        width: t,
        height: r
    };
}
function $75fd44aa0be2e2ce$export$2b86bedf890eab8(e, t = !1) {
    let [r, u] = (0, $l7WPE.useReducer)(()=>({}), {}), i = (0, $l7WPE.useMemo)(()=>$75fd44aa0be2e2ce$var$f(e), [
        e,
        r
    ]);
    return (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        if (!e) return;
        let n = new ResizeObserver(u);
        return n.observe(e), ()=>{
            n.disconnect();
        };
    }, [
        e
    ]), t ? {
        width: `${i.width}px`,
        height: `${i.height}px`
    } : i;
}




var $l7WPE = parcelRequire("l7WPE");







var $l7WPE = parcelRequire("l7WPE");
function $8538aa82d598df10$export$53652b2b272efe9c(t, u) {
    return (0, $l7WPE.useMemo)(()=>{
        var n;
        if (t.type) return t.type;
        let r = (n = t.as) != null ? n : "button";
        if (typeof r == "string" && r.toLowerCase() === "button" || (u == null ? void 0 : u.tagName) === "BUTTON" && !u.hasAttribute("type")) return "button";
    }, [
        t.type,
        t.as,
        u
    ]);
}





var $l7WPE = parcelRequire("l7WPE");
let $0b8dfe6b4cdf923b$var$a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $0b8dfe6b4cdf923b$var$o(e) {
    var r, i;
    let n = (r = e.innerText) != null ? r : "", t = e.cloneNode(!0);
    if (!(t instanceof HTMLElement)) return n;
    let u = !1;
    for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(), u = !0;
    let l = u ? (i = t.innerText) != null ? i : "" : n;
    return $0b8dfe6b4cdf923b$var$a.test(l) && (l = l.replace($0b8dfe6b4cdf923b$var$a, "")), l;
}
function $0b8dfe6b4cdf923b$export$6ca03cb7b75bfa13(e) {
    let n = e.getAttribute("aria-label");
    if (typeof n == "string") return n.trim();
    let t = e.getAttribute("aria-labelledby");
    if (t) {
        let u = t.split(" ").map((l)=>{
            let r = document.getElementById(l);
            if (r) {
                let i = r.getAttribute("aria-label");
                return typeof i == "string" ? i.trim() : $0b8dfe6b4cdf923b$var$o(r).trim();
            }
            return null;
        }).filter(Boolean);
        if (u.length > 0) return u.join(", ");
    }
    return $0b8dfe6b4cdf923b$var$o(e).trim();
}



function $be953e450ea69759$export$f6862afd851a1cf4(c) {
    let t = (0, $l7WPE.useRef)(""), r = (0, $l7WPE.useRef)("");
    return (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        let e = c.current;
        if (!e) return "";
        let u = e.innerText;
        if (t.current === u) return r.current;
        let n = (0, $0b8dfe6b4cdf923b$export$6ca03cb7b75bfa13)(e).trim().toLowerCase();
        return t.current = u, r.current = n, n;
    });
}



var $l7WPE = parcelRequire("l7WPE");
function $d4637e875bc56c65$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $d4637e875bc56c65$export$24ebee078bde85c3() {
    let e = (0, $l7WPE.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $d4637e875bc56c65$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $d4637e875bc56c65$var$t(r);
        }
    };
}




/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $beda2ab0df91b78f$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $beda2ab0df91b78f$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $beda2ab0df91b78f$export$803cd8101b6c182b = /*#__PURE__*/ $beda2ab0df91b78f$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $beda2ab0df91b78f$export$27b07d8a310ed8b5[0], side + "-" + $beda2ab0df91b78f$export$27b07d8a310ed8b5[1]), []);
const $beda2ab0df91b78f$export$96ec731ed4dcb222 = Math.min;
const $beda2ab0df91b78f$export$8960430cfd85939f = Math.max;
const $beda2ab0df91b78f$export$2077e0241d6afd3c = Math.round;
const $beda2ab0df91b78f$export$a3fe094919f356fd = Math.floor;
const $beda2ab0df91b78f$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $beda2ab0df91b78f$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $beda2ab0df91b78f$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $beda2ab0df91b78f$export$7d15b64cf5a3a4c4(start, value, end) {
    return $beda2ab0df91b78f$export$8960430cfd85939f(start, $beda2ab0df91b78f$export$96ec731ed4dcb222(value, end));
}
function $beda2ab0df91b78f$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $beda2ab0df91b78f$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $beda2ab0df91b78f$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $beda2ab0df91b78f$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $beda2ab0df91b78f$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $beda2ab0df91b78f$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($beda2ab0df91b78f$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $beda2ab0df91b78f$export$2b57e0052a6d6d4c(placement) {
    return $beda2ab0df91b78f$export$8a000a963141ac32($beda2ab0df91b78f$export$f28e8f882010718a(placement));
}
function $beda2ab0df91b78f$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $beda2ab0df91b78f$export$f0989780f32bfcda(placement);
    const alignmentAxis = $beda2ab0df91b78f$export$2b57e0052a6d6d4c(placement);
    const length = $beda2ab0df91b78f$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $beda2ab0df91b78f$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $beda2ab0df91b78f$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $beda2ab0df91b78f$export$496432a3699e50b1(placement) {
    const oppositePlacement = $beda2ab0df91b78f$export$9c5e28bad23365fa(placement);
    return [
        $beda2ab0df91b78f$export$2b182c584985588b(placement),
        oppositePlacement,
        $beda2ab0df91b78f$export$2b182c584985588b(oppositePlacement)
    ];
}
function $beda2ab0df91b78f$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$beda2ab0df91b78f$var$oppositeAlignmentMap[alignment]);
}
function $beda2ab0df91b78f$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $beda2ab0df91b78f$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $beda2ab0df91b78f$export$f0989780f32bfcda(placement);
    let list = $beda2ab0df91b78f$var$getSideList($beda2ab0df91b78f$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($beda2ab0df91b78f$export$2b182c584985588b));
    }
    return list;
}
function $beda2ab0df91b78f$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$beda2ab0df91b78f$var$oppositeSideMap[side]);
}
function $beda2ab0df91b78f$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $beda2ab0df91b78f$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $beda2ab0df91b78f$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $beda2ab0df91b78f$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $1cc2ddbd2cd67978$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $beda2ab0df91b78f$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $beda2ab0df91b78f$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $beda2ab0df91b78f$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $beda2ab0df91b78f$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $beda2ab0df91b78f$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $1cc2ddbd2cd67978$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $1cc2ddbd2cd67978$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $1cc2ddbd2cd67978$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $1cc2ddbd2cd67978$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $beda2ab0df91b78f$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $beda2ab0df91b78f$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $beda2ab0df91b78f$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $1cc2ddbd2cd67978$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $beda2ab0df91b78f$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $beda2ab0df91b78f$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $beda2ab0df91b78f$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $beda2ab0df91b78f$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $beda2ab0df91b78f$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $beda2ab0df91b78f$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $beda2ab0df91b78f$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $1cc2ddbd2cd67978$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $beda2ab0df91b78f$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $beda2ab0df91b78f$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $beda2ab0df91b78f$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $beda2ab0df91b78f$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $beda2ab0df91b78f$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $1cc2ddbd2cd67978$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $beda2ab0df91b78f$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $beda2ab0df91b78f$export$803cd8101b6c182b) ? $1cc2ddbd2cd67978$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $1cc2ddbd2cd67978$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $beda2ab0df91b78f$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $beda2ab0df91b78f$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $beda2ab0df91b78f$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $beda2ab0df91b78f$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $1cc2ddbd2cd67978$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $beda2ab0df91b78f$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $beda2ab0df91b78f$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $beda2ab0df91b78f$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $beda2ab0df91b78f$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $beda2ab0df91b78f$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $beda2ab0df91b78f$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $1cc2ddbd2cd67978$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $beda2ab0df91b78f$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $beda2ab0df91b78f$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $1cc2ddbd2cd67978$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $1cc2ddbd2cd67978$var$isAnySideFullyClipped(overflow) {
    return (0, $beda2ab0df91b78f$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $1cc2ddbd2cd67978$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $1cc2ddbd2cd67978$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $1cc2ddbd2cd67978$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $1cc2ddbd2cd67978$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $1cc2ddbd2cd67978$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $1cc2ddbd2cd67978$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $1cc2ddbd2cd67978$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $1cc2ddbd2cd67978$var$getBoundingRect(rects) {
    const minX = (0, $beda2ab0df91b78f$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $beda2ab0df91b78f$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $1cc2ddbd2cd67978$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $beda2ab0df91b78f$export$ee05aea0aeecbad4)($1cc2ddbd2cd67978$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $1cc2ddbd2cd67978$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $1cc2ddbd2cd67978$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $beda2ab0df91b78f$export$ee05aea0aeecbad4)($1cc2ddbd2cd67978$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $beda2ab0df91b78f$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $beda2ab0df91b78f$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $beda2ab0df91b78f$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $beda2ab0df91b78f$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $beda2ab0df91b78f$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $1cc2ddbd2cd67978$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $beda2ab0df91b78f$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $beda2ab0df91b78f$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $beda2ab0df91b78f$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $1cc2ddbd2cd67978$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $1cc2ddbd2cd67978$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $1cc2ddbd2cd67978$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $1cc2ddbd2cd67978$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $beda2ab0df91b78f$export$f28e8f882010718a)((0, $beda2ab0df91b78f$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $beda2ab0df91b78f$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $beda2ab0df91b78f$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $beda2ab0df91b78f$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $1cc2ddbd2cd67978$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $beda2ab0df91b78f$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $beda2ab0df91b78f$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $beda2ab0df91b78f$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $1cc2ddbd2cd67978$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(options, state);
            const overflow = await $1cc2ddbd2cd67978$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $beda2ab0df91b78f$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $beda2ab0df91b78f$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $beda2ab0df91b78f$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $beda2ab0df91b78f$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $beda2ab0df91b78f$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $beda2ab0df91b78f$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $beda2ab0df91b78f$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $d25e3c6c6a66249a$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $d25e3c6c6a66249a$export$651544f548703224(node) {
    if ($d25e3c6c6a66249a$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $d25e3c6c6a66249a$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $d25e3c6c6a66249a$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($d25e3c6c6a66249a$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $d25e3c6c6a66249a$export$8ee0fc9ee280b4ee(value) {
    if (!$d25e3c6c6a66249a$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $d25e3c6c6a66249a$export$38b2d434cce3ea22(value).Node;
}
function $d25e3c6c6a66249a$export$45a5e7f76e0caa8d(value) {
    if (!$d25e3c6c6a66249a$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $d25e3c6c6a66249a$export$38b2d434cce3ea22(value).Element;
}
function $d25e3c6c6a66249a$export$1b3bfaa9684536aa(value) {
    if (!$d25e3c6c6a66249a$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $d25e3c6c6a66249a$export$38b2d434cce3ea22(value).HTMLElement;
}
function $d25e3c6c6a66249a$export$af51f0f06c0f328a(value) {
    if (!$d25e3c6c6a66249a$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $d25e3c6c6a66249a$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $d25e3c6c6a66249a$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $d25e3c6c6a66249a$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $d25e3c6c6a66249a$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($d25e3c6c6a66249a$export$651544f548703224(element));
}
function $d25e3c6c6a66249a$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $d25e3c6c6a66249a$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $d25e3c6c6a66249a$export$78551043582a6a98();
    const css = $d25e3c6c6a66249a$export$45a5e7f76e0caa8d(elementOrCss) ? $d25e3c6c6a66249a$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $d25e3c6c6a66249a$export$940d8225183e1404(element) {
    let currentNode = $d25e3c6c6a66249a$export$4e12058fc4d51d56(element);
    while($d25e3c6c6a66249a$export$1b3bfaa9684536aa(currentNode) && !$d25e3c6c6a66249a$export$d1162fb0b6d4cd51(currentNode)){
        if ($d25e3c6c6a66249a$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($d25e3c6c6a66249a$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $d25e3c6c6a66249a$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $d25e3c6c6a66249a$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $d25e3c6c6a66249a$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($d25e3c6c6a66249a$export$651544f548703224(node));
}
function $d25e3c6c6a66249a$export$3735103072e4a80(element) {
    return $d25e3c6c6a66249a$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $d25e3c6c6a66249a$export$dc8fc79fa2800137(element) {
    if ($d25e3c6c6a66249a$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $d25e3c6c6a66249a$export$4e12058fc4d51d56(node) {
    if ($d25e3c6c6a66249a$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $d25e3c6c6a66249a$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $d25e3c6c6a66249a$export$e495491855dc5418(node);
    return $d25e3c6c6a66249a$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $d25e3c6c6a66249a$export$7cd01a57c8ca906c(node) {
    const parentNode = $d25e3c6c6a66249a$export$4e12058fc4d51d56(node);
    if ($d25e3c6c6a66249a$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($d25e3c6c6a66249a$export$1b3bfaa9684536aa(parentNode) && $d25e3c6c6a66249a$export$989e911fa9af580a(parentNode)) return parentNode;
    return $d25e3c6c6a66249a$export$7cd01a57c8ca906c(parentNode);
}
function $d25e3c6c6a66249a$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $d25e3c6c6a66249a$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $d25e3c6c6a66249a$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $d25e3c6c6a66249a$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $d25e3c6c6a66249a$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $d25e3c6c6a66249a$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $d25e3c6c6a66249a$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $d25e3c6c6a66249a$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $3cdf5176520d44af$var$getCssDimensions(element) {
    const css = (0, $d25e3c6c6a66249a$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $beda2ab0df91b78f$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $beda2ab0df91b78f$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $3cdf5176520d44af$var$unwrapElement(element) {
    return !(0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $3cdf5176520d44af$var$getScale(element) {
    const domElement = $3cdf5176520d44af$var$unwrapElement(element);
    if (!(0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(domElement)) return (0, $beda2ab0df91b78f$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $3cdf5176520d44af$var$getCssDimensions(domElement);
    let x = ($ ? (0, $beda2ab0df91b78f$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $beda2ab0df91b78f$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $3cdf5176520d44af$var$noOffsets = /*#__PURE__*/ (0, $beda2ab0df91b78f$export$a397704b5e280835)(0);
function $3cdf5176520d44af$var$getVisualOffsets(element) {
    const win = (0, $d25e3c6c6a66249a$export$38b2d434cce3ea22)(element);
    if (!(0, $d25e3c6c6a66249a$export$78551043582a6a98)() || !win.visualViewport) return $3cdf5176520d44af$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $3cdf5176520d44af$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $d25e3c6c6a66249a$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $3cdf5176520d44af$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $3cdf5176520d44af$var$unwrapElement(element);
    let scale = (0, $beda2ab0df91b78f$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(offsetParent)) scale = $3cdf5176520d44af$var$getScale(offsetParent);
        } else scale = $3cdf5176520d44af$var$getScale(element);
    }
    const visualOffsets = $3cdf5176520d44af$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $3cdf5176520d44af$var$getVisualOffsets(domElement) : (0, $beda2ab0df91b78f$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $d25e3c6c6a66249a$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $d25e3c6c6a66249a$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $d25e3c6c6a66249a$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $3cdf5176520d44af$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $d25e3c6c6a66249a$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $d25e3c6c6a66249a$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $d25e3c6c6a66249a$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $beda2ab0df91b78f$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $3cdf5176520d44af$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $d25e3c6c6a66249a$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $d25e3c6c6a66249a$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $beda2ab0df91b78f$export$a397704b5e280835)(1);
    const offsets = (0, $beda2ab0df91b78f$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d25e3c6c6a66249a$export$651544f548703224)(offsetParent) !== 'body' || (0, $d25e3c6c6a66249a$export$989e911fa9af580a)(documentElement)) scroll = (0, $d25e3c6c6a66249a$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $3cdf5176520d44af$var$getBoundingClientRect(offsetParent);
            scale = $3cdf5176520d44af$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $3cdf5176520d44af$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $3cdf5176520d44af$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $d25e3c6c6a66249a$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $3cdf5176520d44af$var$getBoundingClientRect((0, $d25e3c6c6a66249a$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $3cdf5176520d44af$var$getDocumentRect(element) {
    const html = (0, $d25e3c6c6a66249a$export$e495491855dc5418)(element);
    const scroll = (0, $d25e3c6c6a66249a$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $3cdf5176520d44af$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $d25e3c6c6a66249a$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $beda2ab0df91b78f$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $3cdf5176520d44af$var$getViewportRect(element, strategy) {
    const win = (0, $d25e3c6c6a66249a$export$38b2d434cce3ea22)(element);
    const html = (0, $d25e3c6c6a66249a$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $d25e3c6c6a66249a$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $3cdf5176520d44af$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $3cdf5176520d44af$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(element) ? $3cdf5176520d44af$var$getScale(element) : (0, $beda2ab0df91b78f$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $3cdf5176520d44af$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $3cdf5176520d44af$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $3cdf5176520d44af$var$getDocumentRect((0, $d25e3c6c6a66249a$export$e495491855dc5418)(element));
    else if ((0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $3cdf5176520d44af$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $3cdf5176520d44af$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $beda2ab0df91b78f$export$ee05aea0aeecbad4)(rect);
}
function $3cdf5176520d44af$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $d25e3c6c6a66249a$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(parentNode) || (0, $d25e3c6c6a66249a$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $d25e3c6c6a66249a$export$3735103072e4a80)(parentNode).position === 'fixed' || $3cdf5176520d44af$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $3cdf5176520d44af$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $d25e3c6c6a66249a$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(el) && (0, $d25e3c6c6a66249a$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $d25e3c6c6a66249a$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $d25e3c6c6a66249a$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(currentNode) && !(0, $d25e3c6c6a66249a$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $d25e3c6c6a66249a$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $d25e3c6c6a66249a$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $d25e3c6c6a66249a$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $3cdf5176520d44af$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $d25e3c6c6a66249a$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $3cdf5176520d44af$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $d25e3c6c6a66249a$export$89e651af02346cd4)(element) ? [] : $3cdf5176520d44af$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $3cdf5176520d44af$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $beda2ab0df91b78f$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $beda2ab0df91b78f$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $3cdf5176520d44af$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $3cdf5176520d44af$var$getDimensions(element) {
    const { width: width, height: height } = $3cdf5176520d44af$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $3cdf5176520d44af$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $d25e3c6c6a66249a$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $3cdf5176520d44af$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $beda2ab0df91b78f$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d25e3c6c6a66249a$export$651544f548703224)(offsetParent) !== 'body' || (0, $d25e3c6c6a66249a$export$989e911fa9af580a)(documentElement)) scroll = (0, $d25e3c6c6a66249a$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $3cdf5176520d44af$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $3cdf5176520d44af$var$getWindowScrollBarX(documentElement);
    }
    let htmlX = 0;
    let htmlY = 0;
    if (documentElement && !isOffsetParentAnElement && !isFixed) {
        const htmlRect = documentElement.getBoundingClientRect();
        htmlY = htmlRect.top + scroll.scrollTop;
        htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
        $3cdf5176520d44af$var$getWindowScrollBarX(documentElement, htmlRect);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $3cdf5176520d44af$var$isStaticPositioned(element) {
    return (0, $d25e3c6c6a66249a$export$3735103072e4a80)(element).position === 'static';
}
function $3cdf5176520d44af$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(element) || (0, $d25e3c6c6a66249a$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $d25e3c6c6a66249a$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $3cdf5176520d44af$var$getOffsetParent(element, polyfill) {
    const win = (0, $d25e3c6c6a66249a$export$38b2d434cce3ea22)(element);
    if ((0, $d25e3c6c6a66249a$export$89e651af02346cd4)(element)) return win;
    if (!(0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $d25e3c6c6a66249a$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $d25e3c6c6a66249a$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$3cdf5176520d44af$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $d25e3c6c6a66249a$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $3cdf5176520d44af$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $d25e3c6c6a66249a$export$71535ffaa902797f)(offsetParent) && $3cdf5176520d44af$var$isStaticPositioned(offsetParent))offsetParent = $3cdf5176520d44af$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $d25e3c6c6a66249a$export$d1162fb0b6d4cd51)(offsetParent) && $3cdf5176520d44af$var$isStaticPositioned(offsetParent) && !(0, $d25e3c6c6a66249a$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $d25e3c6c6a66249a$export$940d8225183e1404)(element) || win;
}
const $3cdf5176520d44af$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $3cdf5176520d44af$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $3cdf5176520d44af$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $3cdf5176520d44af$var$isRTL(element) {
    return (0, $d25e3c6c6a66249a$export$3735103072e4a80)(element).direction === 'rtl';
}
const $3cdf5176520d44af$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $3cdf5176520d44af$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $d25e3c6c6a66249a$export$e495491855dc5418,
    getClippingRect: $3cdf5176520d44af$var$getClippingRect,
    getOffsetParent: $3cdf5176520d44af$var$getOffsetParent,
    getElementRects: $3cdf5176520d44af$var$getElementRects,
    getClientRects: $3cdf5176520d44af$var$getClientRects,
    getDimensions: $3cdf5176520d44af$var$getDimensions,
    getScale: $3cdf5176520d44af$var$getScale,
    isElement: $d25e3c6c6a66249a$export$45a5e7f76e0caa8d,
    isRTL: $3cdf5176520d44af$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $3cdf5176520d44af$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $d25e3c6c6a66249a$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $beda2ab0df91b78f$export$a3fe094919f356fd)(top);
        const insetRight = (0, $beda2ab0df91b78f$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $beda2ab0df91b78f$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $beda2ab0df91b78f$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $beda2ab0df91b78f$export$8960430cfd85939f)(0, (0, $beda2ab0df91b78f$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $3cdf5176520d44af$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $3cdf5176520d44af$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $d25e3c6c6a66249a$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $d25e3c6c6a66249a$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $3cdf5176520d44af$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $3cdf5176520d44af$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $3cdf5176520d44af$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $3cdf5176520d44af$export$37b6bde19b108ecc = (0, $1cc2ddbd2cd67978$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $3cdf5176520d44af$export$cc800923e997bb8 = (0, $1cc2ddbd2cd67978$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $3cdf5176520d44af$export$91fb6ecbd551914 = (0, $1cc2ddbd2cd67978$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $3cdf5176520d44af$export$fba63a578e423eb = (0, $1cc2ddbd2cd67978$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $3cdf5176520d44af$export$8a83211c878a3f1f = (0, $1cc2ddbd2cd67978$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $3cdf5176520d44af$export$346677f925de839c = (0, $1cc2ddbd2cd67978$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $3cdf5176520d44af$export$fe8985bb6374093c = (0, $1cc2ddbd2cd67978$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3cdf5176520d44af$export$f2120bbfa5450bd2 = (0, $1cc2ddbd2cd67978$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $3cdf5176520d44af$export$18c8ad048e32c7d5 = (0, $1cc2ddbd2cd67978$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $3cdf5176520d44af$export$7bf07e38f3dc4b69 = (0, $1cc2ddbd2cd67978$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $3cdf5176520d44af$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $3cdf5176520d44af$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $1cc2ddbd2cd67978$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $l7WPE = parcelRequire("l7WPE");

var $29c4e8bd243bb5e5$var$index = typeof document !== 'undefined' ? (0, $l7WPE.useLayoutEffect) : (0, $l7WPE.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $29c4e8bd243bb5e5$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$29c4e8bd243bb5e5$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$29c4e8bd243bb5e5$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $29c4e8bd243bb5e5$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $29c4e8bd243bb5e5$var$roundByDPR(element, value) {
    const dpr = $29c4e8bd243bb5e5$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $29c4e8bd243bb5e5$var$useLatestRef(value) {
    const ref = $l7WPE.useRef(value);
    $29c4e8bd243bb5e5$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $29c4e8bd243bb5e5$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $l7WPE.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $l7WPE.useState(middleware);
    if (!$29c4e8bd243bb5e5$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $l7WPE.useState(null);
    const [_floating, _setFloating] = $l7WPE.useState(null);
    const setReference = $l7WPE.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $l7WPE.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $l7WPE.useRef(null);
    const floatingRef = $l7WPE.useRef(null);
    const dataRef = $l7WPE.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $29c4e8bd243bb5e5$var$useLatestRef(whileElementsMounted);
    const platformRef = $29c4e8bd243bb5e5$var$useLatestRef(platform);
    const openRef = $29c4e8bd243bb5e5$var$useLatestRef(open);
    const update = $l7WPE.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $3cdf5176520d44af$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$29c4e8bd243bb5e5$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $b1e9cc0cc5ead376$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $29c4e8bd243bb5e5$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $l7WPE.useRef(false);
    $29c4e8bd243bb5e5$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $29c4e8bd243bb5e5$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $l7WPE.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $l7WPE.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $l7WPE.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $29c4e8bd243bb5e5$var$roundByDPR(elements.floating, data.x);
        const y = $29c4e8bd243bb5e5$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$29c4e8bd243bb5e5$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $l7WPE.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $29c4e8bd243bb5e5$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $3cdf5176520d44af$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $3cdf5176520d44af$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $29c4e8bd243bb5e5$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $3cdf5176520d44af$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $29c4e8bd243bb5e5$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $3cdf5176520d44af$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $29c4e8bd243bb5e5$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $3cdf5176520d44af$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $29c4e8bd243bb5e5$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $3cdf5176520d44af$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $29c4e8bd243bb5e5$export$346677f925de839c = (options, deps)=>({
        ...(0, $3cdf5176520d44af$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $29c4e8bd243bb5e5$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $3cdf5176520d44af$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $29c4e8bd243bb5e5$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $3cdf5176520d44af$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $29c4e8bd243bb5e5$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $3cdf5176520d44af$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $29c4e8bd243bb5e5$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$29c4e8bd243bb5e5$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });


var $l7WPE = parcelRequire("l7WPE");

function $488951ee4fe5406a$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $488951ee4fe5406a$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $d25e3c6c6a66249a$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $488951ee4fe5406a$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $488951ee4fe5406a$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $488951ee4fe5406a$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($488951ee4fe5406a$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $488951ee4fe5406a$export$29bf1b5f2c56cf63(event) {
    if ($488951ee4fe5406a$export$c8f880a2d81914c4()) return false;
    return !$488951ee4fe5406a$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $488951ee4fe5406a$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $488951ee4fe5406a$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $488951ee4fe5406a$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($488951ee4fe5406a$export$867a782338812cb4()) || re.test($488951ee4fe5406a$export$7935961ef7719cb0());
}
function $488951ee4fe5406a$export$9ac100e40613ea10() {
    return $488951ee4fe5406a$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $488951ee4fe5406a$export$c8f880a2d81914c4() {
    return $488951ee4fe5406a$export$7935961ef7719cb0().includes('jsdom/');
}
function $488951ee4fe5406a$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
function $488951ee4fe5406a$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
function $488951ee4fe5406a$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $488951ee4fe5406a$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $488951ee4fe5406a$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $488951ee4fe5406a$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $488951ee4fe5406a$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $488951ee4fe5406a$export$42ad131c32f0fb8d(element) {
    return (0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(element) && element.matches($488951ee4fe5406a$export$78b3d091ff376bc);
}
function $488951ee4fe5406a$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $488951ee4fe5406a$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $488951ee4fe5406a$export$42ad131c32f0fb8d(element);
}




/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $d9dec83ffc2ff238$var$candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var $d9dec83ffc2ff238$var$candidateSelector = /* #__PURE__ */ $d9dec83ffc2ff238$var$candidateSelectors.join(',');
var $d9dec83ffc2ff238$var$NoElement = typeof Element === 'undefined';
var $d9dec83ffc2ff238$var$matches = $d9dec83ffc2ff238$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $d9dec83ffc2ff238$var$getRootNode = !$d9dec83ffc2ff238$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $d9dec83ffc2ff238$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $d9dec83ffc2ff238$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $d9dec83ffc2ff238$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($d9dec83ffc2ff238$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($d9dec83ffc2ff238$var$candidateSelector));
    if (includeContainer && $d9dec83ffc2ff238$var$matches.call(el, $d9dec83ffc2ff238$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $d9dec83ffc2ff238$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($d9dec83ffc2ff238$var$isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $d9dec83ffc2ff238$var$matches.call(element, $d9dec83ffc2ff238$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$d9dec83ffc2ff238$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $d9dec83ffc2ff238$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $d9dec83ffc2ff238$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $d9dec83ffc2ff238$var$isContentEditable(node)) && !$d9dec83ffc2ff238$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $d9dec83ffc2ff238$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $d9dec83ffc2ff238$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$d9dec83ffc2ff238$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $d9dec83ffc2ff238$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $d9dec83ffc2ff238$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $d9dec83ffc2ff238$var$isHiddenInput = function isHiddenInput(node) {
    return $d9dec83ffc2ff238$var$isInput(node) && node.type === 'hidden';
};
var $d9dec83ffc2ff238$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $d9dec83ffc2ff238$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $d9dec83ffc2ff238$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $d9dec83ffc2ff238$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $d9dec83ffc2ff238$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $d9dec83ffc2ff238$var$isRadio = function isRadio(node) {
    return $d9dec83ffc2ff238$var$isInput(node) && node.type === 'radio';
};
var $d9dec83ffc2ff238$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $d9dec83ffc2ff238$var$isRadio(node) && !$d9dec83ffc2ff238$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $d9dec83ffc2ff238$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $d9dec83ffc2ff238$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $d9dec83ffc2ff238$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $d9dec83ffc2ff238$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $d9dec83ffc2ff238$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $d9dec83ffc2ff238$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($d9dec83ffc2ff238$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $d9dec83ffc2ff238$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $d9dec83ffc2ff238$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($d9dec83ffc2ff238$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $d9dec83ffc2ff238$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $d9dec83ffc2ff238$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $d9dec83ffc2ff238$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $d9dec83ffc2ff238$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $d9dec83ffc2ff238$var$isInert(node) || $d9dec83ffc2ff238$var$isHiddenInput(node) || $d9dec83ffc2ff238$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $d9dec83ffc2ff238$var$isDetailsWithSummary(node) || $d9dec83ffc2ff238$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $d9dec83ffc2ff238$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($d9dec83ffc2ff238$var$isNonTabbableRadio(node) || $d9dec83ffc2ff238$export$a4672efddb4181b8(node) < 0 || !$d9dec83ffc2ff238$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $d9dec83ffc2ff238$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $d9dec83ffc2ff238$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $d9dec83ffc2ff238$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($d9dec83ffc2ff238$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $d9dec83ffc2ff238$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $d9dec83ffc2ff238$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $d9dec83ffc2ff238$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $d9dec83ffc2ff238$var$isValidShadowRootTabbable
    });
    else candidates = $d9dec83ffc2ff238$var$getCandidates(container, options.includeContainer, $d9dec83ffc2ff238$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $d9dec83ffc2ff238$var$sortByOrder(candidates);
};
var $d9dec83ffc2ff238$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $d9dec83ffc2ff238$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $d9dec83ffc2ff238$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $d9dec83ffc2ff238$var$getCandidates(container, options.includeContainer, $d9dec83ffc2ff238$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $d9dec83ffc2ff238$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($d9dec83ffc2ff238$var$matches.call(node, $d9dec83ffc2ff238$var$candidateSelector) === false) return false;
    return $d9dec83ffc2ff238$var$isNodeMatchingSelectorTabbable(options, node);
};
var $d9dec83ffc2ff238$var$focusableCandidateSelector = /* #__PURE__ */ $d9dec83ffc2ff238$var$candidateSelectors.concat('iframe').join(',');
var $d9dec83ffc2ff238$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($d9dec83ffc2ff238$var$matches.call(node, $d9dec83ffc2ff238$var$focusableCandidateSelector) === false) return false;
    return $d9dec83ffc2ff238$var$isNodeMatchingSelectorFocusable(options, node);
};




/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $d061bf5fc13d4ac1$export$74665b213cb5c4cf(refs) {
    return $l7WPE.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $d061bf5fc13d4ac1$var$SafeReact = {
    ...$l7WPE
};
const $d061bf5fc13d4ac1$var$useInsertionEffect = $d061bf5fc13d4ac1$var$SafeReact.useInsertionEffect;
const $d061bf5fc13d4ac1$var$useSafeInsertionEffect = $d061bf5fc13d4ac1$var$useInsertionEffect || ((fn)=>fn());
function $d061bf5fc13d4ac1$var$useEffectEvent(callback) {
    const ref = $l7WPE.useRef(()=>{});
    $d061bf5fc13d4ac1$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $l7WPE.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $d061bf5fc13d4ac1$var$ARROW_UP = 'ArrowUp';
const $d061bf5fc13d4ac1$var$ARROW_DOWN = 'ArrowDown';
const $d061bf5fc13d4ac1$var$ARROW_LEFT = 'ArrowLeft';
const $d061bf5fc13d4ac1$var$ARROW_RIGHT = 'ArrowRight';
function $d061bf5fc13d4ac1$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $d061bf5fc13d4ac1$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $d061bf5fc13d4ac1$var$getMinIndex(listRef, disabledIndices) {
    return $d061bf5fc13d4ac1$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $d061bf5fc13d4ac1$var$getMaxIndex(listRef, disabledIndices) {
    return $d061bf5fc13d4ac1$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $d061bf5fc13d4ac1$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $d061bf5fc13d4ac1$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $d061bf5fc13d4ac1$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $d061bf5fc13d4ac1$var$ARROW_UP) {
        stop && (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $d061bf5fc13d4ac1$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($d061bf5fc13d4ac1$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $d061bf5fc13d4ac1$var$ARROW_DOWN) {
        stop && (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $d061bf5fc13d4ac1$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $d061bf5fc13d4ac1$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($d061bf5fc13d4ac1$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $beda2ab0df91b78f$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === $d061bf5fc13d4ac1$var$ARROW_RIGHT) {
            stop && (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $d061bf5fc13d4ac1$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $d061bf5fc13d4ac1$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $d061bf5fc13d4ac1$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $d061bf5fc13d4ac1$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($d061bf5fc13d4ac1$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === $d061bf5fc13d4ac1$var$ARROW_LEFT) {
            stop && (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $d061bf5fc13d4ac1$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $d061bf5fc13d4ac1$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $d061bf5fc13d4ac1$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $d061bf5fc13d4ac1$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($d061bf5fc13d4ac1$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $beda2ab0df91b78f$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($d061bf5fc13d4ac1$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === $d061bf5fc13d4ac1$var$ARROW_LEFT ? maxIndex : $d061bf5fc13d4ac1$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $d061bf5fc13d4ac1$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $d061bf5fc13d4ac1$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $d061bf5fc13d4ac1$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $d061bf5fc13d4ac1$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
let $d061bf5fc13d4ac1$var$rafId = 0;
function $d061bf5fc13d4ac1$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($d061bf5fc13d4ac1$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $d061bf5fc13d4ac1$var$rafId = requestAnimationFrame(exec);
}
var $d061bf5fc13d4ac1$var$index = typeof document !== 'undefined' ? (0, $l7WPE.useLayoutEffect) : (0, $l7WPE.useEffect);
function $d061bf5fc13d4ac1$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $d061bf5fc13d4ac1$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $d061bf5fc13d4ac1$var$FloatingListContext = /*#__PURE__*/ $l7WPE.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $d061bf5fc13d4ac1$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $l7WPE.useState(()=>new Map());
    const register = $l7WPE.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $l7WPE.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $d061bf5fc13d4ac1$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($d061bf5fc13d4ac1$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$d061bf5fc13d4ac1$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$var$FloatingListContext.Provider, {
        value: $l7WPE.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $d061bf5fc13d4ac1$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $l7WPE.useContext($d061bf5fc13d4ac1$var$FloatingListContext);
    const [index$1, setIndex] = $l7WPE.useState(null);
    const componentRef = $l7WPE.useRef(null);
    const ref = $l7WPE.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $l7WPE.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $d061bf5fc13d4ac1$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $l7WPE.cloneElement(render, computedProps);
    return /*#__PURE__*/ $l7WPE.createElement("div", computedProps);
}
const $d061bf5fc13d4ac1$var$CompositeContext = /*#__PURE__*/ $l7WPE.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $d061bf5fc13d4ac1$var$horizontalKeys = [
    $d061bf5fc13d4ac1$var$ARROW_LEFT,
    $d061bf5fc13d4ac1$var$ARROW_RIGHT
];
const $d061bf5fc13d4ac1$var$verticalKeys = [
    $d061bf5fc13d4ac1$var$ARROW_UP,
    $d061bf5fc13d4ac1$var$ARROW_DOWN
];
const $d061bf5fc13d4ac1$var$allKeys = [
    ...$d061bf5fc13d4ac1$var$horizontalKeys,
    ...$d061bf5fc13d4ac1$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $d061bf5fc13d4ac1$export$43586241d9db0c6d = /*#__PURE__*/ $l7WPE.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $l7WPE.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $d061bf5fc13d4ac1$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $l7WPE.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $l7WPE.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$d061bf5fc13d4ac1$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $d061bf5fc13d4ac1$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $d061bf5fc13d4ac1$var$getMaxIndex(elementsRef, disabledIndices);
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $d061bf5fc13d4ac1$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$d061bf5fc13d4ac1$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$d061bf5fc13d4ac1$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$d061bf5fc13d4ac1$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $d061bf5fc13d4ac1$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$d061bf5fc13d4ac1$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $d061bf5fc13d4ac1$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $d061bf5fc13d4ac1$var$ARROW_DOWN ? 'bl' : event.key === $d061bf5fc13d4ac1$var$ARROW_RIGHT ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                $d061bf5fc13d4ac1$var$ARROW_RIGHT
            ],
            vertical: [
                $d061bf5fc13d4ac1$var$ARROW_DOWN
            ],
            both: [
                $d061bf5fc13d4ac1$var$ARROW_RIGHT,
                $d061bf5fc13d4ac1$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                $d061bf5fc13d4ac1$var$ARROW_LEFT
            ],
            vertical: [
                $d061bf5fc13d4ac1$var$ARROW_UP
            ],
            both: [
                $d061bf5fc13d4ac1$var$ARROW_LEFT,
                $d061bf5fc13d4ac1$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $d061bf5fc13d4ac1$var$allKeys : ({
            horizontal: $d061bf5fc13d4ac1$var$horizontalKeys,
            vertical: $d061bf5fc13d4ac1$var$verticalKeys,
            both: $d061bf5fc13d4ac1$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $d061bf5fc13d4ac1$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$d061bf5fc13d4ac1$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            // Wait for FocusManager `returnFocus` to execute.
            queueMicrotask(()=>{
                $d061bf5fc13d4ac1$var$enqueueFocus(elementsRef.current[nextIndex]);
            });
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $d061bf5fc13d4ac1$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $d061bf5fc13d4ac1$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $l7WPE.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $l7WPE.useContext($d061bf5fc13d4ac1$var$CompositeContext);
    const { ref: ref, index: index } = $d061bf5fc13d4ac1$export$dcdc7ff5149f7d1a();
    const mergedRef = $d061bf5fc13d4ac1$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $d061bf5fc13d4ac1$var$renderJsx(render, computedProps);
});
function $d061bf5fc13d4ac1$var$_extends() {
    $d061bf5fc13d4ac1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d061bf5fc13d4ac1$var$_extends.apply(this, arguments);
}
let $d061bf5fc13d4ac1$var$serverHandoffComplete = false;
let $d061bf5fc13d4ac1$var$count = 0;
const $d061bf5fc13d4ac1$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $d061bf5fc13d4ac1$var$count++;
function $d061bf5fc13d4ac1$var$useFloatingId() {
    const [id, setId] = $l7WPE.useState(()=>$d061bf5fc13d4ac1$var$serverHandoffComplete ? $d061bf5fc13d4ac1$var$genId() : undefined);
    $d061bf5fc13d4ac1$var$index(()=>{
        if (id == null) setId($d061bf5fc13d4ac1$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $l7WPE.useEffect(()=>{
        $d061bf5fc13d4ac1$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $d061bf5fc13d4ac1$var$useReactId = $d061bf5fc13d4ac1$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $d061bf5fc13d4ac1$export$f680877a34711e37 = $d061bf5fc13d4ac1$var$useReactId || $d061bf5fc13d4ac1$var$useFloatingId;
let $d061bf5fc13d4ac1$var$devMessageSet;
function $d061bf5fc13d4ac1$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $d061bf5fc13d4ac1$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $d061bf5fc13d4ac1$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $d061bf5fc13d4ac1$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $d061bf5fc13d4ac1$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $d061bf5fc13d4ac1$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $d061bf5fc13d4ac1$export$33511391554732bc = /*#__PURE__*/ $l7WPE.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $d061bf5fc13d4ac1$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $l7WPE.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $d061bf5fc13d4ac1$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $d25e3c6c6a66249a$export$3735103072e4a80)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ $l7WPE.createElement("svg", $d061bf5fc13d4ac1$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $l7WPE.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $l7WPE.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : 'none',
        d: dValue
    }), /*#__PURE__*/ $l7WPE.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $l7WPE.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $d061bf5fc13d4ac1$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $d061bf5fc13d4ac1$var$FloatingNodeContext = /*#__PURE__*/ $l7WPE.createContext(null);
const $d061bf5fc13d4ac1$var$FloatingTreeContext = /*#__PURE__*/ $l7WPE.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $d061bf5fc13d4ac1$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $l7WPE.useContext($d061bf5fc13d4ac1$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $d061bf5fc13d4ac1$export$db0c2a7c7a2a4f69 = ()=>$l7WPE.useContext($d061bf5fc13d4ac1$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $d061bf5fc13d4ac1$export$9b136e0e758a42f4(customParentId) {
    const id = $d061bf5fc13d4ac1$export$f680877a34711e37();
    const tree = $d061bf5fc13d4ac1$export$db0c2a7c7a2a4f69();
    const reactParentId = $d061bf5fc13d4ac1$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $d061bf5fc13d4ac1$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $d061bf5fc13d4ac1$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $d061bf5fc13d4ac1$export$165209eae06d3488();
    return /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$var$FloatingNodeContext.Provider, {
        value: $l7WPE.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $d061bf5fc13d4ac1$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $l7WPE.useRef([]);
    const addNode = $l7WPE.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $l7WPE.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $l7WPE.useState(()=>$d061bf5fc13d4ac1$var$createPubSub())[0];
    return /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$var$FloatingTreeContext.Provider, {
        value: $l7WPE.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $d061bf5fc13d4ac1$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $d061bf5fc13d4ac1$var$useLatestRef(value) {
    const ref = (0, $l7WPE.useRef)(value);
    $d061bf5fc13d4ac1$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $d061bf5fc13d4ac1$var$safePolygonIdentifier = /*#__PURE__*/ $d061bf5fc13d4ac1$var$createAttribute('safe-polygon');
function $d061bf5fc13d4ac1$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $488951ee4fe5406a$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $d061bf5fc13d4ac1$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $d061bf5fc13d4ac1$export$db0c2a7c7a2a4f69();
    const parentId = $d061bf5fc13d4ac1$export$165209eae06d3488();
    const handleCloseRef = $d061bf5fc13d4ac1$var$useLatestRef(handleClose);
    const delayRef = $d061bf5fc13d4ac1$var$useLatestRef(delay);
    const openRef = $d061bf5fc13d4ac1$var$useLatestRef(open);
    const pointerTypeRef = $l7WPE.useRef();
    const timeoutRef = $l7WPE.useRef(-1);
    const handlerRef = $l7WPE.useRef();
    const restTimeoutRef = $l7WPE.useRef(-1);
    const blockMouseMoveRef = $l7WPE.useRef(true);
    const performedPointerEventsMutationRef = $l7WPE.useRef(false);
    const unbindMouseMoveRef = $l7WPE.useRef(()=>{});
    const isHoverOpen = $l7WPE.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $l7WPE.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $l7WPE.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $488951ee4fe5406a$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $l7WPE.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $d061bf5fc13d4ac1$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $d061bf5fc13d4ac1$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $d061bf5fc13d4ac1$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $488951ee4fe5406a$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($d061bf5fc13d4ac1$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $l7WPE.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                'click',
                'mousedown'
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $488951ee4fe5406a$export$81cf264172d31e51)(pointerTypeRef.current) || restMs > 0 && !$d061bf5fc13d4ac1$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $d061bf5fc13d4ac1$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else onOpenChange(true, event, 'hover');
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $488951ee4fe5406a$export$f65ca476c09acec0)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $488951ee4fe5406a$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener('mouseleave', onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener('mouseleave', onScrollMouseLeave);
            move && ref.addEventListener('mousemove', onMouseEnter, {
                once: true
            });
            ref.addEventListener('mouseenter', onMouseEnter);
            ref.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener('mouseleave', onScrollMouseLeave);
                move && ref.removeEventListener('mousemove', onMouseEnter);
                ref.removeEventListener('mouseenter', onMouseEnter);
                ref.removeEventListener('mouseleave', onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $d061bf5fc13d4ac1$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $488951ee4fe5406a$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($d061bf5fc13d4ac1$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $l7WPE.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $l7WPE.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $488951ee4fe5406a$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $l7WPE.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay
    ]);
    return $l7WPE.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $d061bf5fc13d4ac1$var$NOOP = ()=>{};
const $d061bf5fc13d4ac1$var$FloatingDelayGroupContext = /*#__PURE__*/ $l7WPE.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $d061bf5fc13d4ac1$var$NOOP,
    setState: $d061bf5fc13d4ac1$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $d061bf5fc13d4ac1$export$e2411914b150383d = ()=>$l7WPE.useContext($d061bf5fc13d4ac1$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $d061bf5fc13d4ac1$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $l7WPE.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $l7WPE.useRef(null);
    const setCurrentId = $l7WPE.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $d061bf5fc13d4ac1$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$var$FloatingDelayGroupContext.Provider, {
        value: $l7WPE.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $d061bf5fc13d4ac1$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $d061bf5fc13d4ac1$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $d061bf5fc13d4ac1$var$index(()=>{
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $d061bf5fc13d4ac1$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        if (setCurrentId === $d061bf5fc13d4ac1$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
function $d061bf5fc13d4ac1$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $d061bf5fc13d4ac1$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $d061bf5fc13d4ac1$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $d061bf5fc13d4ac1$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $d061bf5fc13d4ac1$var$counterMap = /*#__PURE__*/ new WeakMap();
let $d061bf5fc13d4ac1$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $d061bf5fc13d4ac1$var$markerMap = {};
let $d061bf5fc13d4ac1$var$lockCount$1 = 0;
const $d061bf5fc13d4ac1$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const $d061bf5fc13d4ac1$var$unwrapHost = (node)=>node && (node.host || $d061bf5fc13d4ac1$var$unwrapHost(node.parentNode));
const $d061bf5fc13d4ac1$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $d061bf5fc13d4ac1$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $d061bf5fc13d4ac1$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $d061bf5fc13d4ac1$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$d061bf5fc13d4ac1$var$markerMap[markerName]) $d061bf5fc13d4ac1$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $d061bf5fc13d4ac1$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $d25e3c6c6a66249a$export$651544f548703224)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterValue = ($d061bf5fc13d4ac1$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $d061bf5fc13d4ac1$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $d061bf5fc13d4ac1$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, 'true');
            }
        });
    }
    $d061bf5fc13d4ac1$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($d061bf5fc13d4ac1$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $d061bf5fc13d4ac1$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$d061bf5fc13d4ac1$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $d061bf5fc13d4ac1$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $d061bf5fc13d4ac1$var$lockCount$1--;
        if (!$d061bf5fc13d4ac1$var$lockCount$1) {
            $d061bf5fc13d4ac1$var$counterMap = new WeakMap();
            $d061bf5fc13d4ac1$var$counterMap = new WeakMap();
            $d061bf5fc13d4ac1$var$uncontrolledElementsSet = new WeakSet();
            $d061bf5fc13d4ac1$var$markerMap = {};
        }
    };
}
function $d061bf5fc13d4ac1$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $488951ee4fe5406a$export$f65ca476c09acec0)(avoidElements[0]).body;
    return $d061bf5fc13d4ac1$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}
const $d061bf5fc13d4ac1$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $d061bf5fc13d4ac1$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $d9dec83ffc2ff238$export$17100aea90429aa7)(container, $d061bf5fc13d4ac1$var$getTabbableOptions());
    if (direction === 'prev') allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $488951ee4fe5406a$export$da980962bd2147a4)((0, $488951ee4fe5406a$export$f65ca476c09acec0)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $d061bf5fc13d4ac1$var$getNextTabbable() {
    return $d061bf5fc13d4ac1$var$getTabbableIn(document.body, 'next');
}
function $d061bf5fc13d4ac1$var$getPreviousTabbable() {
    return $d061bf5fc13d4ac1$var$getTabbableIn(document.body, 'prev');
}
function $d061bf5fc13d4ac1$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $488951ee4fe5406a$export$2344b14b097df817)(containerElement, relatedTarget);
}
function $d061bf5fc13d4ac1$var$disableFocusInside(container) {
    const tabbableElements = (0, $d9dec83ffc2ff238$export$17100aea90429aa7)(container, $d061bf5fc13d4ac1$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $d061bf5fc13d4ac1$var$enableFocusInside(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $d061bf5fc13d4ac1$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
let $d061bf5fc13d4ac1$var$timeoutId;
function $d061bf5fc13d4ac1$var$setActiveElementOnTab(event) {
    if (event.key === 'Tab') {
        event.target;
        clearTimeout($d061bf5fc13d4ac1$var$timeoutId);
    }
}
const $d061bf5fc13d4ac1$var$FocusGuard = /*#__PURE__*/ $l7WPE.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $l7WPE.useState();
    $d061bf5fc13d4ac1$var$index(()=>{
        if ((0, $488951ee4fe5406a$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
        document.addEventListener('keydown', $d061bf5fc13d4ac1$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener('keydown', $d061bf5fc13d4ac1$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$d061bf5fc13d4ac1$var$createAttribute('focus-guard')]: '',
        style: $d061bf5fc13d4ac1$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $l7WPE.createElement("span", $d061bf5fc13d4ac1$var$_extends({}, props, restProps));
});
const $d061bf5fc13d4ac1$var$PortalContext = /*#__PURE__*/ $l7WPE.createContext(null);
const $d061bf5fc13d4ac1$var$attr = /*#__PURE__*/ $d061bf5fc13d4ac1$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $d061bf5fc13d4ac1$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $d061bf5fc13d4ac1$export$f680877a34711e37();
    const portalContext = $d061bf5fc13d4ac1$var$usePortalContext();
    const [portalNode, setPortalNode] = $l7WPE.useState(null);
    const portalNodeRef = $l7WPE.useRef(null);
    $d061bf5fc13d4ac1$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($d061bf5fc13d4ac1$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($d061bf5fc13d4ac1$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $d061bf5fc13d4ac1$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root = null, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $d061bf5fc13d4ac1$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $l7WPE.useState(null);
    const beforeOutsideRef = $l7WPE.useRef(null);
    const afterOutsideRef = $l7WPE.useRef(null);
    const beforeInsideRef = $l7WPE.useRef(null);
    const afterInsideRef = $l7WPE.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $l7WPE.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $d061bf5fc13d4ac1$var$isOutsideEvent(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? $d061bf5fc13d4ac1$var$enableFocusInside : $d061bf5fc13d4ac1$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $l7WPE.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $d061bf5fc13d4ac1$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$var$PortalContext.Provider, {
        value: $l7WPE.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($d061bf5fc13d4ac1$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $d061bf5fc13d4ac1$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $l7WPE.createElement("span", {
        "aria-owns": portalNode.id,
        style: $d061bf5fc13d4ac1$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $b1e9cc0cc5ead376$exports.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($d061bf5fc13d4ac1$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $d061bf5fc13d4ac1$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
            }
        }
    }));
}
const $d061bf5fc13d4ac1$var$usePortalContext = ()=>$l7WPE.useContext($d061bf5fc13d4ac1$var$PortalContext);
const $d061bf5fc13d4ac1$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
function $d061bf5fc13d4ac1$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($d061bf5fc13d4ac1$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $d061bf5fc13d4ac1$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $d061bf5fc13d4ac1$var$LIST_LIMIT = 20;
let $d061bf5fc13d4ac1$var$previouslyFocusedElements = [];
function $d061bf5fc13d4ac1$var$addPreviouslyFocusedElement(element) {
    $d061bf5fc13d4ac1$var$previouslyFocusedElements = $d061bf5fc13d4ac1$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $d25e3c6c6a66249a$export$651544f548703224)(tabbableEl) === 'body') return;
    if (!(0, $d9dec83ffc2ff238$export$bebd5a1431fec25d)(tabbableEl, $d061bf5fc13d4ac1$var$getTabbableOptions())) {
        const tabbableChild = (0, $d9dec83ffc2ff238$export$17100aea90429aa7)(tabbableEl, $d061bf5fc13d4ac1$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $d061bf5fc13d4ac1$var$previouslyFocusedElements.push(tabbableEl);
    if ($d061bf5fc13d4ac1$var$previouslyFocusedElements.length > $d061bf5fc13d4ac1$var$LIST_LIMIT) $d061bf5fc13d4ac1$var$previouslyFocusedElements = $d061bf5fc13d4ac1$var$previouslyFocusedElements.slice(-$d061bf5fc13d4ac1$var$LIST_LIMIT);
}
function $d061bf5fc13d4ac1$var$getPreviouslyFocusedElement() {
    return $d061bf5fc13d4ac1$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $d061bf5fc13d4ac1$var$VisuallyHiddenDismiss = /*#__PURE__*/ $l7WPE.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $l7WPE.createElement("button", $d061bf5fc13d4ac1$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $d061bf5fc13d4ac1$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $d061bf5fc13d4ac1$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $488951ee4fe5406a$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $d061bf5fc13d4ac1$var$supportsInert() ? _guards : true;
    const orderRef = $d061bf5fc13d4ac1$var$useLatestRef(order);
    const initialFocusRef = $d061bf5fc13d4ac1$var$useLatestRef(initialFocus);
    const returnFocusRef = $d061bf5fc13d4ac1$var$useLatestRef(returnFocus);
    const tree = $d061bf5fc13d4ac1$export$db0c2a7c7a2a4f69();
    const portalContext = $d061bf5fc13d4ac1$var$usePortalContext();
    const startDismissButtonRef = $l7WPE.useRef(null);
    const endDismissButtonRef = $l7WPE.useRef(null);
    const preventReturnFocusRef = $l7WPE.useRef(false);
    const isPointerDownRef = $l7WPE.useRef(false);
    const tabbableIndexRef = $l7WPE.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $d061bf5fc13d4ac1$var$getFloatingFocusElement(floating);
    const getTabbableContent = $d061bf5fc13d4ac1$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $d9dec83ffc2ff238$export$17100aea90429aa7)(container, $d061bf5fc13d4ac1$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $d061bf5fc13d4ac1$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $l7WPE.useEffect(()=>{
        preventReturnFocusRef.current = false;
    }, [
        disabled
    ]);
    $l7WPE.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $488951ee4fe5406a$export$2344b14b097df817)(floatingFocusElement, (0, $488951ee4fe5406a$export$da980962bd2147a4)((0, $488951ee4fe5406a$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $488951ee4fe5406a$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $d061bf5fc13d4ac1$var$enqueueFocus(els[els.length - 1]);
                    else $d061bf5fc13d4ac1$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
                    $d061bf5fc13d4ac1$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $488951ee4fe5406a$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $l7WPE.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $488951ee4fe5406a$export$c22522a4dfa48e9c)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $l7WPE.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $488951ee4fe5406a$export$2344b14b097df817)(domReference, relatedTarget) || (0, $488951ee4fe5406a$export$2344b14b097df817)(floating, relatedTarget) || (0, $488951ee4fe5406a$export$2344b14b097df817)(relatedTarget, floating) || (0, $488951ee4fe5406a$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($d061bf5fc13d4ac1$var$createAttribute('focus-guard')) || tree && ($d061bf5fc13d4ac1$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $488951ee4fe5406a$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $488951ee4fe5406a$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $d061bf5fc13d4ac1$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $488951ee4fe5406a$export$da980962bd2147a4)((0, $488951ee4fe5406a$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $488951ee4fe5406a$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $d061bf5fc13d4ac1$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        if (floating && (0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $l7WPE.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $d061bf5fc13d4ac1$var$createAttribute('portal') + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $d061bf5fc13d4ac1$var$markOthers(insideElements, guards, !guards) : $d061bf5fc13d4ac1$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        if (disabled || !(0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        const doc = (0, $488951ee4fe5406a$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $488951ee4fe5406a$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $488951ee4fe5406a$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $d061bf5fc13d4ac1$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $488951ee4fe5406a$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $488951ee4fe5406a$export$da980962bd2147a4)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $d061bf5fc13d4ac1$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === 'escape-key' && refs.domReference.current) $d061bf5fc13d4ac1$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === 'hover' && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $488951ee4fe5406a$export$60278871457622de)(event) || (0, $488951ee4fe5406a$export$29bf1b5f2c56cf63)(event));
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $d061bf5fc13d4ac1$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $488951ee4fe5406a$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $488951ee4fe5406a$export$2344b14b097df817)(floating, activeEl) || tree && $d061bf5fc13d4ac1$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $488951ee4fe5406a$export$2344b14b097df817)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                'click',
                'mousedown'
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $d061bf5fc13d4ac1$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = $d061bf5fc13d4ac1$var$getPreviouslyFocusedElement() || fallbackEl;
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $d061bf5fc13d4ac1$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== 'function') return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute('tabindex');
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $488951ee4fe5406a$export$da980962bd2147a4)((0, $488951ee4fe5406a$export$f65ca476c09acec0)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes('floating') || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
            } else if (tabIndex !== '-1') floatingFocusElement.setAttribute('tabindex', '-1');
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $l7WPE.createElement($l7WPE.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $d061bf5fc13d4ac1$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($d061bf5fc13d4ac1$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $d061bf5fc13d4ac1$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/ $l7WPE.createElement($d061bf5fc13d4ac1$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $d061bf5fc13d4ac1$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($d061bf5fc13d4ac1$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $d061bf5fc13d4ac1$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $d061bf5fc13d4ac1$var$lockCount = 0;
function $d061bf5fc13d4ac1$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $488951ee4fe5406a$export$867a782338812cb4)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $d061bf5fc13d4ac1$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $d061bf5fc13d4ac1$export$a35954495955337b = /*#__PURE__*/ $l7WPE.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $d061bf5fc13d4ac1$var$index(()=>{
        if (!lockScroll) return;
        $d061bf5fc13d4ac1$var$lockCount++;
        if ($d061bf5fc13d4ac1$var$lockCount === 1) $d061bf5fc13d4ac1$var$cleanup = $d061bf5fc13d4ac1$var$enableScrollLock();
        return ()=>{
            $d061bf5fc13d4ac1$var$lockCount--;
            if ($d061bf5fc13d4ac1$var$lockCount === 0) $d061bf5fc13d4ac1$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $l7WPE.createElement("div", $d061bf5fc13d4ac1$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $d061bf5fc13d4ac1$var$isButtonTarget(event) {
    return (0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'BUTTON';
}
function $d061bf5fc13d4ac1$var$isSpaceIgnored(element) {
    return (0, $488951ee4fe5406a$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $d061bf5fc13d4ac1$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = props;
    const pointerTypeRef = $l7WPE.useRef();
    const didKeyDownRef = $l7WPE.useRef(false);
    const reference = $l7WPE.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $488951ee4fe5406a$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $488951ee4fe5406a$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $d061bf5fc13d4ac1$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$d061bf5fc13d4ac1$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $d061bf5fc13d4ac1$var$isButtonTarget(event) || $d061bf5fc13d4ac1$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        toggle
    ]);
    return $l7WPE.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $d061bf5fc13d4ac1$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $d061bf5fc13d4ac1$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $d061bf5fc13d4ac1$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $l7WPE.useRef(false);
    const cleanupListenerRef = $l7WPE.useRef(null);
    const [pointerType, setPointerType] = $l7WPE.useState();
    const [reactive, setReactive] = $l7WPE.useState([]);
    const setReference = $d061bf5fc13d4ac1$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$d061bf5fc13d4ac1$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($d061bf5fc13d4ac1$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $d061bf5fc13d4ac1$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $488951ee4fe5406a$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $l7WPE.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $d25e3c6c6a66249a$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const target = (0, $488951ee4fe5406a$export$c22522a4dfa48e9c)(event);
            if (!(0, $488951ee4fe5406a$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $d061bf5fc13d4ac1$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $l7WPE.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $l7WPE.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $l7WPE.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $l7WPE.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $l7WPE.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $d061bf5fc13d4ac1$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $d061bf5fc13d4ac1$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $d061bf5fc13d4ac1$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $d061bf5fc13d4ac1$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $d061bf5fc13d4ac1$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $d061bf5fc13d4ac1$var$useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $l7WPE.useRef(false);
    const endedOrStartedInsideRef = $l7WPE.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $d061bf5fc13d4ac1$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $d061bf5fc13d4ac1$var$normalizeProp(capture);
    const closeOnEscapeKeyDown = $d061bf5fc13d4ac1$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $d061bf5fc13d4ac1$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $488951ee4fe5406a$export$94781ce41a161222)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = $d061bf5fc13d4ac1$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $488951ee4fe5406a$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $488951ee4fe5406a$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = $d061bf5fc13d4ac1$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $488951ee4fe5406a$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $d061bf5fc13d4ac1$var$createAttribute('inert') + "]";
        const markers = (0, $488951ee4fe5406a$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $d25e3c6c6a66249a$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $d25e3c6c6a66249a$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $d25e3c6c6a66249a$export$d1162fb0b6d4cd51)(nextParent) || !(0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(target) && !(0, $488951ee4fe5406a$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $488951ee4fe5406a$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $488951ee4fe5406a$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $d25e3c6c6a66249a$export$3735103072e4a80)(target).direction === 'rtl';
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $d061bf5fc13d4ac1$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $488951ee4fe5406a$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $488951ee4fe5406a$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $488951ee4fe5406a$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $d061bf5fc13d4ac1$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = $d061bf5fc13d4ac1$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $488951ee4fe5406a$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $488951ee4fe5406a$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $l7WPE.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        const doc = (0, $488951ee4fe5406a$export$f65ca476c09acec0)(elements.floating);
        escapeKey && doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $d25e3c6c6a66249a$export$3b57c1601291186b)(elements.domReference);
            if ((0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $d25e3c6c6a66249a$export$3b57c1601291186b)(elements.floating));
            if (!(0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $d25e3c6c6a66249a$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            escapeKey && doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $l7WPE.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $l7WPE.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$d061bf5fc13d4ac1$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, 'reference-press');
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $l7WPE.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$d061bf5fc13d4ac1$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $l7WPE.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $d061bf5fc13d4ac1$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $d061bf5fc13d4ac1$export$f680877a34711e37();
    const dataRef = $l7WPE.useRef({});
    const [events] = $l7WPE.useState(()=>$d061bf5fc13d4ac1$var$createPubSub());
    const nested = $d061bf5fc13d4ac1$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $l7WPE.useState(elementsProp.reference);
    const onOpenChange = $d061bf5fc13d4ac1$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $l7WPE.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $l7WPE.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $l7WPE.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $d061bf5fc13d4ac1$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $d061bf5fc13d4ac1$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $l7WPE.useState(null);
    const [positionReference, _setPositionReference] = $l7WPE.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.reference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $l7WPE.useRef(null);
    const tree = $d061bf5fc13d4ac1$export$db0c2a7c7a2a4f69();
    $d061bf5fc13d4ac1$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $29c4e8bd243bb5e5$export$4e02a5c1d08bac65)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $l7WPE.useCallback((node)=>{
        const computedPositionReference = (0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $l7WPE.useCallback((node)=>{
        if ((0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $l7WPE.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $l7WPE.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $l7WPE.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $l7WPE.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $d061bf5fc13d4ac1$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $l7WPE.useRef(false);
    const timeoutRef = $l7WPE.useRef();
    const keyboardModalityRef = $l7WPE.useRef(true);
    $l7WPE.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $d25e3c6c6a66249a$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $488951ee4fe5406a$export$da980962bd2147a4)((0, $488951ee4fe5406a$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener('blur', onBlur);
        win.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            win.removeEventListener('blur', onBlur);
            win.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $l7WPE.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $l7WPE.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $l7WPE.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $488951ee4fe5406a$export$29bf1b5f2c56cf63)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $488951ee4fe5406a$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $488951ee4fe5406a$export$95df08bae54cb4df)() && (0, $488951ee4fe5406a$export$9ac100e40613ea10)()) throw Error();
                    if (!target.matches(':focus-visible')) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $488951ee4fe5406a$export$42ad131c32f0fb8d)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($d061bf5fc13d4ac1$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $488951ee4fe5406a$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $488951ee4fe5406a$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $488951ee4fe5406a$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $l7WPE.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $d061bf5fc13d4ac1$var$ACTIVE_KEY = 'active';
const $d061bf5fc13d4ac1$var$SELECTED_KEY = 'selected';
function $d061bf5fc13d4ac1$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$d061bf5fc13d4ac1$var$ACTIVE_KEY]: _, [$d061bf5fc13d4ac1$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$d061bf5fc13d4ac1$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $d061bf5fc13d4ac1$var$ACTIVE_KEY,
                    $d061bf5fc13d4ac1$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $d061bf5fc13d4ac1$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $l7WPE.useCallback((userProps)=>$d061bf5fc13d4ac1$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $l7WPE.useCallback((userProps)=>$d061bf5fc13d4ac1$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $l7WPE.useCallback((userProps)=>$d061bf5fc13d4ac1$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $l7WPE.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $d061bf5fc13d4ac1$var$isPreventScrollSupported = false;
function $d061bf5fc13d4ac1$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $d061bf5fc13d4ac1$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $d061bf5fc13d4ac1$var$ARROW_UP || key === $d061bf5fc13d4ac1$var$ARROW_DOWN;
    const horizontal = key === $d061bf5fc13d4ac1$var$ARROW_LEFT || key === $d061bf5fc13d4ac1$var$ARROW_RIGHT;
    return $d061bf5fc13d4ac1$var$doSwitch(orientation, vertical, horizontal);
}
function $d061bf5fc13d4ac1$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $d061bf5fc13d4ac1$var$ARROW_DOWN;
    const horizontal = rtl ? key === $d061bf5fc13d4ac1$var$ARROW_LEFT : key === $d061bf5fc13d4ac1$var$ARROW_RIGHT;
    return $d061bf5fc13d4ac1$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $d061bf5fc13d4ac1$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $d061bf5fc13d4ac1$var$ARROW_LEFT : key === $d061bf5fc13d4ac1$var$ARROW_RIGHT;
    const horizontal = key === $d061bf5fc13d4ac1$var$ARROW_DOWN;
    return $d061bf5fc13d4ac1$var$doSwitch(orientation, vertical, horizontal);
}
function $d061bf5fc13d4ac1$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $d061bf5fc13d4ac1$var$ARROW_RIGHT : key === $d061bf5fc13d4ac1$var$ARROW_LEFT;
    const horizontal = key === $d061bf5fc13d4ac1$var$ARROW_UP;
    return $d061bf5fc13d4ac1$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $d061bf5fc13d4ac1$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $d061bf5fc13d4ac1$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $d061bf5fc13d4ac1$var$useLatestRef(floatingFocusElement);
    const parentId = $d061bf5fc13d4ac1$export$165209eae06d3488();
    const tree = $d061bf5fc13d4ac1$export$db0c2a7c7a2a4f69();
    const onNavigate = $d061bf5fc13d4ac1$var$useEffectEvent(unstable_onNavigate);
    const focusItemOnOpenRef = $l7WPE.useRef(focusItemOnOpen);
    const indexRef = $l7WPE.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $l7WPE.useRef(null);
    const isPointerModalityRef = $l7WPE.useRef(true);
    const previousOnNavigateRef = $l7WPE.useRef(onNavigate);
    const previousMountedRef = $l7WPE.useRef(!!elements.floating);
    const previousOpenRef = $l7WPE.useRef(open);
    const forceSyncFocus = $l7WPE.useRef(false);
    const forceScrollIntoViewRef = $l7WPE.useRef(false);
    const disabledIndicesRef = $d061bf5fc13d4ac1$var$useLatestRef(disabledIndices);
    const latestOpenRef = $d061bf5fc13d4ac1$var$useLatestRef(open);
    const scrollItemIntoViewRef = $d061bf5fc13d4ac1$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $d061bf5fc13d4ac1$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $l7WPE.useState();
    const [virtualId, setVirtualId] = $l7WPE.useState();
    const focusItem = $d061bf5fc13d4ac1$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $d061bf5fc13d4ac1$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $488951ee4fe5406a$export$9ac100e40613ea10)() && (0, $488951ee4fe5406a$export$95df08bae54cb4df)() ? $d061bf5fc13d4ac1$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    $d061bf5fc13d4ac1$var$index(()=>{
        document.createElement('div').focus({
            get preventScroll () {
                $d061bf5fc13d4ac1$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $d061bf5fc13d4ac1$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $d061bf5fc13d4ac1$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $d061bf5fc13d4ac1$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $d061bf5fc13d4ac1$var$getMinIndex(listRef, disabledIndicesRef.current) : $d061bf5fc13d4ac1$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$d061bf5fc13d4ac1$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $d061bf5fc13d4ac1$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $488951ee4fe5406a$export$da980962bd2147a4)((0, $488951ee4fe5406a$export$f65ca476c09acec0)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $488951ee4fe5406a$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $d061bf5fc13d4ac1$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $l7WPE.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === 'touch') return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $d061bf5fc13d4ac1$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $d061bf5fc13d4ac1$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $d061bf5fc13d4ac1$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $d25e3c6c6a66249a$export$1b3bfaa9684536aa)(elements.domReference) && !virtual) elements.domReference.focus();
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $d061bf5fc13d4ac1$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $d061bf5fc13d4ac1$var$getMaxIndex(listRef, disabledIndices);
        if (event.key === 'Home') {
            (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
            indexRef.current = minIndex;
            onNavigate(indexRef.current);
        }
        if (event.key === 'End') {
            (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
            indexRef.current = maxIndex;
            onNavigate(indexRef.current);
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $d061bf5fc13d4ac1$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$d061bf5fc13d4ac1$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$d061bf5fc13d4ac1$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$d061bf5fc13d4ac1$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $d061bf5fc13d4ac1$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$d061bf5fc13d4ac1$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $d061bf5fc13d4ac1$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $d061bf5fc13d4ac1$var$ARROW_DOWN ? 'bl' : event.key === $d061bf5fc13d4ac1$var$ARROW_RIGHT ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === 'both') return;
        }
        if ($d061bf5fc13d4ac1$var$isMainOrientationKey(event.key, orientation)) {
            (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $488951ee4fe5406a$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $d061bf5fc13d4ac1$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($d061bf5fc13d4ac1$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $d061bf5fc13d4ac1$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $d061bf5fc13d4ac1$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $d061bf5fc13d4ac1$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $d061bf5fc13d4ac1$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($d061bf5fc13d4ac1$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $l7WPE.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $l7WPE.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!(0, $488951ee4fe5406a$export$259ba5ae38188551)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $l7WPE.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $488951ee4fe5406a$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $488951ee4fe5406a$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.indexOf('Arrow') === 0;
                const isCrossOpenKey = $d061bf5fc13d4ac1$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $d061bf5fc13d4ac1$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $d061bf5fc13d4ac1$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $d061bf5fc13d4ac1$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isArrowKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if (isMainKey && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = $d061bf5fc13d4ac1$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $l7WPE.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $d061bf5fc13d4ac1$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $d061bf5fc13d4ac1$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const ariaRole = (_componentRoleToAriaR = $d061bf5fc13d4ac1$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $d061bf5fc13d4ac1$export$f680877a34711e37();
    const parentId = $d061bf5fc13d4ac1$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $l7WPE.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $l7WPE.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $l7WPE.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
                return {
                    ...commonProps,
                    'aria-selected': active && selected
                };
            case 'combobox':
                return {
                    ...commonProps,
                    ...active && {
                        'aria-selected': true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $l7WPE.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $d061bf5fc13d4ac1$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $d061bf5fc13d4ac1$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $d061bf5fc13d4ac1$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $l7WPE.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $l7WPE.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $d061bf5fc13d4ac1$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $l7WPE.useState('unmounted');
    const isMounted = $d061bf5fc13d4ac1$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    $d061bf5fc13d4ac1$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                setStatus('open');
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $d061bf5fc13d4ac1$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $l7WPE.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $l7WPE.useState(()=>({
            ...$d061bf5fc13d4ac1$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$d061bf5fc13d4ac1$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $d061bf5fc13d4ac1$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $d061bf5fc13d4ac1$var$useLatestRef(unstable_initial);
    const openRef = $d061bf5fc13d4ac1$var$useLatestRef(unstable_open);
    const closeRef = $d061bf5fc13d4ac1$var$useLatestRef(unstable_close);
    const commonRef = $d061bf5fc13d4ac1$var$useLatestRef(unstable_common);
    $d061bf5fc13d4ac1$var$index(()=>{
        const initialStyles = $d061bf5fc13d4ac1$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $d061bf5fc13d4ac1$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $d061bf5fc13d4ac1$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $d061bf5fc13d4ac1$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($d061bf5fc13d4ac1$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($d061bf5fc13d4ac1$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $d061bf5fc13d4ac1$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $l7WPE.useRef();
    const stringRef = $l7WPE.useRef('');
    const prevIndexRef = $l7WPE.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $l7WPE.useRef(null);
    const onMatch = $d061bf5fc13d4ac1$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $d061bf5fc13d4ac1$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $d061bf5fc13d4ac1$var$useLatestRef(findMatch);
    const ignoreKeysRef = $d061bf5fc13d4ac1$var$useLatestRef(ignoreKeys);
    $d061bf5fc13d4ac1$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    $d061bf5fc13d4ac1$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $d061bf5fc13d4ac1$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $d061bf5fc13d4ac1$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $488951ee4fe5406a$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $l7WPE.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $l7WPE.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $l7WPE.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $d061bf5fc13d4ac1$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $d061bf5fc13d4ac1$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $beda2ab0df91b78f$export$fef61f332f2c0afc)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $29c4e8bd243bb5e5$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $3cdf5176520d44af$export$37b6bde19b108ecc)($d061bf5fc13d4ac1$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $3cdf5176520d44af$export$37b6bde19b108ecc)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $beda2ab0df91b78f$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const maxHeight = (0, $beda2ab0df91b78f$export$2077e0241d6afd3c)((0, $beda2ab0df91b78f$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $beda2ab0df91b78f$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.scrollHeight > scrollEl.offsetHeight && scrollEl.offsetHeight < item.offsetHeight * minItemsVisible - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $b1e9cc0cc5ead376$exports.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $3cdf5176520d44af$export$37b6bde19b108ecc)($d061bf5fc13d4ac1$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $d061bf5fc13d4ac1$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $d061bf5fc13d4ac1$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $l7WPE.useRef(false);
    const prevScrollTopRef = $l7WPE.useRef(null);
    const initialOverflowRef = $l7WPE.useRef(null);
    $l7WPE.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $b1e9cc0cc5ead376$exports.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $488951ee4fe5406a$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $l7WPE.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $b1e9cc0cc5ead376$exports.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $l7WPE.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $d061bf5fc13d4ac1$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $d061bf5fc13d4ac1$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $d061bf5fc13d4ac1$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $488951ee4fe5406a$export$c22522a4dfa48e9c)(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = (0, $488951ee4fe5406a$export$2344b14b097df817)(elements.floating, target);
            const isOverReferenceEl = (0, $488951ee4fe5406a$export$2344b14b097df817)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $d061bf5fc13d4ac1$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $d25e3c6c6a66249a$export$45a5e7f76e0caa8d)(event.relatedTarget) && (0, $488951ee4fe5406a$export$2344b14b097df817)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $d061bf5fc13d4ac1$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($d061bf5fc13d4ac1$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$d061bf5fc13d4ac1$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



var $l7WPE = parcelRequire("l7WPE");



let $9d5a69901036af68$var$y = (0, $l7WPE.createContext)({
    styles: void 0,
    setReference: ()=>{},
    setFloating: ()=>{},
    getReferenceProps: ()=>({}),
    getFloatingProps: ()=>({}),
    slot: {}
});
$9d5a69901036af68$var$y.displayName = "FloatingContext";
let $9d5a69901036af68$var$H = (0, $l7WPE.createContext)(null);
$9d5a69901036af68$var$H.displayName = "PlacementContext";
function $9d5a69901036af68$export$ee5342e485f0bdb0(e) {
    return (0, $l7WPE.useMemo)(()=>e ? typeof e == "string" ? {
            to: e
        } : e : null, [
        e
    ]);
}
function $9d5a69901036af68$export$916a28f343467e85() {
    return (0, $l7WPE.useContext)($9d5a69901036af68$var$y).setReference;
}
function $9d5a69901036af68$export$c7931d5027a8ead4() {
    return (0, $l7WPE.useContext)($9d5a69901036af68$var$y).getReferenceProps;
}
function $9d5a69901036af68$export$106e71f938eae412() {
    let { getFloatingProps: e, slot: t } = (0, $l7WPE.useContext)($9d5a69901036af68$var$y);
    return (0, $l7WPE.useCallback)((...n)=>Object.assign({}, e(...n), {
            "data-anchor": t.anchor
        }), [
        e,
        t
    ]);
}
function $9d5a69901036af68$export$aff4be9ef2a28e43(e = null) {
    e === !1 && (e = null), typeof e == "string" && (e = {
        to: e
    });
    let t = (0, $l7WPE.useContext)($9d5a69901036af68$var$H), n = (0, $l7WPE.useMemo)(()=>e, [
        JSON.stringify(e, (r, o)=>{
            var u;
            return (u = o == null ? void 0 : o.outerHTML) != null ? u : o;
        })
    ]);
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        t == null || t(n != null ? n : null);
    }, [
        t,
        n
    ]);
    let l = (0, $l7WPE.useContext)($9d5a69901036af68$var$y);
    return (0, $l7WPE.useMemo)(()=>[
            l.setFloating,
            e ? l.styles : {}
        ], [
        l.setFloating,
        e,
        l.styles
    ]);
}
let $9d5a69901036af68$var$q = 4;
function $9d5a69901036af68$export$e473aa84737d3250({ children: e, enabled: t = !0 }) {
    let [n, l] = (0, $l7WPE.useState)(null), [r, o] = (0, $l7WPE.useState)(0), u = (0, $l7WPE.useRef)(null), [f, s] = (0, $l7WPE.useState)(null);
    $9d5a69901036af68$var$pe(f);
    let i = t && n !== null && f !== null, { to: F = "bottom", gap: E = 0, offset: v = 0, padding: c = 0, inner: P } = $9d5a69901036af68$var$ce(n, f), [a, p = "center"] = F.split(" ");
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        i && o(0);
    }, [
        i
    ]);
    let { refs: b, floatingStyles: w, context: g } = (0, $d061bf5fc13d4ac1$export$4e02a5c1d08bac65)({
        open: i,
        placement: a === "selection" ? p === "center" ? "bottom" : `bottom-${p}` : p === "center" ? `${a}` : `${a}-${p}`,
        strategy: "absolute",
        transform: !1,
        middleware: [
            (0, $29c4e8bd243bb5e5$export$cc800923e997bb8)({
                mainAxis: a === "selection" ? 0 : E,
                crossAxis: v
            }),
            (0, $29c4e8bd243bb5e5$export$fba63a578e423eb)({
                padding: c
            }),
            a !== "selection" && (0, $29c4e8bd243bb5e5$export$8a83211c878a3f1f)({
                padding: c
            }),
            a === "selection" && P ? (0, $d061bf5fc13d4ac1$export$4ae363f1d88fb658)({
                ...P,
                padding: c,
                overflowRef: u,
                offset: r,
                minItemsVisible: $9d5a69901036af68$var$q,
                referenceOverflowThreshold: c,
                onFallbackChange (h) {
                    var O, W;
                    if (!h) return;
                    let d = g.elements.floating;
                    if (!d) return;
                    let T = parseFloat(getComputedStyle(d).scrollPaddingBottom) || 0, $ = Math.min($9d5a69901036af68$var$q, d.childElementCount), L = 0, N = 0;
                    for (let m of (W = (O = g.elements.floating) == null ? void 0 : O.childNodes) != null ? W : [])if (m instanceof HTMLElement) {
                        let x = m.offsetTop, k = x + m.clientHeight + T, S = d.scrollTop, U = S + d.clientHeight;
                        if (x >= S && k <= U) $--;
                        else {
                            N = Math.max(0, Math.min(k, U) - Math.max(x, S)), L = m.clientHeight;
                            break;
                        }
                    }
                    $ >= 1 && o((m)=>{
                        let x = L * $ - N + T;
                        return m >= x ? m : x;
                    });
                }
            }) : null,
            (0, $29c4e8bd243bb5e5$export$346677f925de839c)({
                padding: c,
                apply ({ availableWidth: h, availableHeight: d, elements: T }) {
                    Object.assign(T.floating.style, {
                        overflow: "auto",
                        maxWidth: `${h}px`,
                        maxHeight: `min(var(--anchor-max-height, 100vh), ${d}px)`
                    });
                }
            })
        ].filter(Boolean),
        whileElementsMounted: (0, $3cdf5176520d44af$export$deee3a793edee05f)
    }), [I = a, B = p] = g.placement.split("-");
    a === "selection" && (I = "selection");
    let G = (0, $l7WPE.useMemo)(()=>({
            anchor: [
                I,
                B
            ].filter(Boolean).join(" ")
        }), [
        I,
        B
    ]), K = (0, $d061bf5fc13d4ac1$export$3d74b0dda7cc82ff)(g, {
        overflowRef: u,
        onChange: o
    }), { getReferenceProps: Q, getFloatingProps: X } = (0, $d061bf5fc13d4ac1$export$a519f7794e446ddd)([
        K
    ]), Y = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((h)=>{
        s(h), b.setFloating(h);
    });
    return $l7WPE.createElement($9d5a69901036af68$var$H.Provider, {
        value: l
    }, $l7WPE.createElement($9d5a69901036af68$var$y.Provider, {
        value: {
            setFloating: Y,
            setReference: b.setReference,
            styles: w,
            getReferenceProps: Q,
            getFloatingProps: X,
            slot: G
        }
    }, e));
}
function $9d5a69901036af68$var$pe(e) {
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        if (!e) return;
        let t = new MutationObserver(()=>{
            let n = window.getComputedStyle(e).maxHeight, l = parseFloat(n);
            if (isNaN(l)) return;
            let r = parseInt(n);
            isNaN(r) || l !== r && (e.style.maxHeight = `${Math.ceil(l)}px`);
        });
        return t.observe(e, {
            attributes: !0,
            attributeFilter: [
                "style"
            ]
        }), ()=>{
            t.disconnect();
        };
    }, [
        e
    ]);
}
function $9d5a69901036af68$var$ce(e, t) {
    var o, u, f;
    let n = $9d5a69901036af68$var$V((o = e == null ? void 0 : e.gap) != null ? o : "var(--anchor-gap, 0)", t), l = $9d5a69901036af68$var$V((u = e == null ? void 0 : e.offset) != null ? u : "var(--anchor-offset, 0)", t), r = $9d5a69901036af68$var$V((f = e == null ? void 0 : e.padding) != null ? f : "var(--anchor-padding, 0)", t);
    return {
        ...e,
        gap: n,
        offset: l,
        padding: r
    };
}
function $9d5a69901036af68$var$V(e, t, n) {
    let l = (0, $03ea8ceff1795700$export$fd183955ff4b45d9)(), r = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((s, i)=>{
        if (s == null) return [
            n,
            null
        ];
        if (typeof s == "number") return [
            s,
            null
        ];
        if (typeof s == "string") {
            if (!i) return [
                n,
                null
            ];
            let F = $9d5a69901036af68$var$J(s, i);
            return [
                F,
                (E)=>{
                    let v = $9d5a69901036af68$var$D(s);
                    {
                        let c = v.map((P)=>window.getComputedStyle(i).getPropertyValue(P));
                        l.requestAnimationFrame(function P() {
                            l.nextFrame(P);
                            let a = !1;
                            for (let [b, w] of v.entries()){
                                let g = window.getComputedStyle(i).getPropertyValue(w);
                                if (c[b] !== g) {
                                    c[b] = g, a = !0;
                                    break;
                                }
                            }
                            if (!a) return;
                            let p = $9d5a69901036af68$var$J(s, i);
                            F !== p && (E(p), F = p);
                        });
                    }
                    return l.dispose;
                }
            ];
        }
        return [
            n,
            null
        ];
    }), o = (0, $l7WPE.useMemo)(()=>r(e, t)[0], [
        e,
        t
    ]), [u = o, f] = (0, $l7WPE.useState)();
    return (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        let [s, i] = r(e, t);
        if (f(s), !!i) return i(f);
    }, [
        e,
        t
    ]), u;
}
function $9d5a69901036af68$var$D(e) {
    let t = /var\((.*)\)/.exec(e);
    if (t) {
        let n = t[1].indexOf(",");
        if (n === -1) return [
            t[1]
        ];
        let l = t[1].slice(0, n).trim(), r = t[1].slice(n + 1).trim();
        return r ? [
            l,
            ...$9d5a69901036af68$var$D(r)
        ] : [
            l
        ];
    }
    return [];
}
function $9d5a69901036af68$var$J(e, t) {
    let n = document.createElement("div");
    t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
    let l = parseFloat(window.getComputedStyle(n).marginTop) || 0;
    return t.removeChild(n), l;
}



var $l7WPE = parcelRequire("l7WPE");


function $db207137356ac424$export$bc22b3e852574dab(i = {}, s = null, t = []) {
    for (let [r, n] of Object.entries(i))$db207137356ac424$var$o(t, $db207137356ac424$var$f(s, r), n);
    return t;
}
function $db207137356ac424$var$f(i, s) {
    return i ? i + "[" + s + "]" : s;
}
function $db207137356ac424$var$o(i, s, t) {
    if (Array.isArray(t)) for (let [r, n] of t.entries())$db207137356ac424$var$o(i, $db207137356ac424$var$f(s, r.toString()), n);
    else t instanceof Date ? i.push([
        s,
        t.toISOString()
    ]) : typeof t == "boolean" ? i.push([
        s,
        t ? "1" : "0"
    ]) : typeof t == "string" ? i.push([
        s,
        t
    ]) : typeof t == "number" ? i.push([
        s,
        `${t}`
    ]) : t == null ? i.push([
        s,
        ""
    ]) : $db207137356ac424$export$bc22b3e852574dab(t, s, i);
}
function $db207137356ac424$export$ee02894bdc79dd36(i) {
    var t, r;
    let s = (t = i == null ? void 0 : i.form) != null ? t : i.closest("form");
    if (s) {
        for (let n of s.elements)if (n !== i && (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image")) {
            n.click();
            return;
        }
        (r = s.requestSubmit) == null || r.call(s);
    }
}




let $bdaef70e9c6257b4$var$f = (0, $l7WPE.createContext)(null);
function $bdaef70e9c6257b4$export$172bce5caea3d96f(t) {
    let [e, r] = (0, $l7WPE.useState)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($bdaef70e9c6257b4$var$f.Provider, {
        value: {
            target: e
        }
    }, t.children, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $51071f2ec6b67d06$export$8dc98ba7eadeaa56), {
        features: (0, $51071f2ec6b67d06$export$4e7f8864c6a16d8a).Hidden,
        ref: r
    }));
}
function $bdaef70e9c6257b4$export$ddeacde93f925346({ children: t }) {
    let e = (0, $l7WPE.useContext)($bdaef70e9c6257b4$var$f);
    if (!e) return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).Fragment, null, t);
    let { target: r } = e;
    return r ? (0, $b1e9cc0cc5ead376$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).Fragment, null, t), r) : null;
}
function $bdaef70e9c6257b4$export$125d0b248abd3e88({ data: t, form: e, disabled: r, onReset: n, overrides: F }) {
    let [i, a] = (0, $l7WPE.useState)(null), p = (0, $03ea8ceff1795700$export$fd183955ff4b45d9)();
    return (0, $l7WPE.useEffect)(()=>{
        if (n && i) return p.addEventListener(i, "reset", n);
    }, [
        i,
        e,
        n
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($bdaef70e9c6257b4$export$ddeacde93f925346, null, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($bdaef70e9c6257b4$var$C, {
        setForm: a,
        formId: e
    }), (0, $db207137356ac424$export$bc22b3e852574dab)(t).map(([s, v])=>(0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $51071f2ec6b67d06$export$8dc98ba7eadeaa56), {
            features: (0, $51071f2ec6b67d06$export$4e7f8864c6a16d8a).Hidden,
            ...(0, $30c8a076c23acfb8$export$8e16b83750b44988)({
                key: s,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                form: e,
                disabled: r,
                name: s,
                value: v,
                ...F
            })
        })));
}
function $bdaef70e9c6257b4$var$C({ setForm: t, formId: e }) {
    return (0, $l7WPE.useEffect)(()=>{
        if (e) {
            let r = document.getElementById(e);
            r && t(r);
        }
    }, [
        t,
        e
    ]), e ? null : (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $51071f2ec6b67d06$export$8dc98ba7eadeaa56), {
        features: (0, $51071f2ec6b67d06$export$4e7f8864c6a16d8a).Hidden,
        as: "input",
        type: "hidden",
        hidden: !0,
        readOnly: !0,
        ref: (r)=>{
            if (!r) return;
            let n = r.closest("form");
            n && t(n);
        }
    });
}



var $l7WPE = parcelRequire("l7WPE");
function $fc7b615601a071a5$export$824932a86c309819({ children: o, freeze: e }) {
    let n = $fc7b615601a071a5$export$1a771eb6e04a3c48(e, o);
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).Fragment, null, n);
}
function $fc7b615601a071a5$export$1a771eb6e04a3c48(o, e) {
    let [n, t] = (0, $l7WPE.useState)(e);
    return !o && n !== e && t(e), o ? n : e;
}




function $b3d8f67cd937a9d4$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $b3d8f67cd937a9d4$var$i(l) ? !1 : t;
}
function $b3d8f67cd937a9d4$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}


function $ec287b464336d1f1$var$u(l) {
    throw new Error("Unexpected object: " + l);
}
var $ec287b464336d1f1$export$807a7eae502106e7 = ((i)=>(i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))($ec287b464336d1f1$export$807a7eae502106e7 || {});
function $ec287b464336d1f1$export$c6b4626b54936d5e(l, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let r = n.resolveActiveIndex(), s = r != null ? r : -1;
    switch(l.focus){
        case 0:
            for(let e = 0; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 1:
            s === -1 && (s = t.length);
            for(let e = s - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 2:
            for(let e = s + 1; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 3:
            for(let e = t.length - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 4:
            for(let e = 0; e < t.length; ++e)if (n.resolveId(t[e], e, t) === l.id) return e;
            return r;
        case 5:
            return null;
        default:
            $ec287b464336d1f1$var$u(l);
    }
}












"use client";
var $9a32ae7006fff1f4$var$gt = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($9a32ae7006fff1f4$var$gt || {}), $9a32ae7006fff1f4$var$Lt = ((o)=>(o[o.Single = 0] = "Single", o[o.Multi = 1] = "Multi", o))($9a32ae7006fff1f4$var$Lt || {}), $9a32ae7006fff1f4$var$St = ((o)=>(o[o.Pointer = 0] = "Pointer", o[o.Other = 1] = "Other", o))($9a32ae7006fff1f4$var$St || {}), $9a32ae7006fff1f4$var$Et = ((n)=>(n[n.OpenListbox = 0] = "OpenListbox", n[n.CloseListbox = 1] = "CloseListbox", n[n.GoToOption = 2] = "GoToOption", n[n.Search = 3] = "Search", n[n.ClearSearch = 4] = "ClearSearch", n[n.RegisterOption = 5] = "RegisterOption", n[n.UnregisterOption = 6] = "UnregisterOption", n[n.SetButtonElement = 7] = "SetButtonElement", n[n.SetOptionsElement = 8] = "SetOptionsElement", n))($9a32ae7006fff1f4$var$Et || {});
function $9a32ae7006fff1f4$var$be(e, i = (o)=>o) {
    let o = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = (0, $c87ce7fcb4198fc6$export$20305e96f91bf103)(i(e.options.slice()), (m)=>m.dataRef.current.domRef.current), a = o ? r.indexOf(o) : null;
    return a === -1 && (a = null), {
        options: r,
        activeOptionIndex: a
    };
}
let $9a32ae7006fff1f4$var$Pt = {
    [1] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 ? e : {
            ...e,
            activeOptionIndex: null,
            listboxState: 1,
            __demoMode: !1
        };
    },
    [0] (e) {
        if (e.dataRef.current.disabled || e.listboxState === 0) return e;
        let i = e.activeOptionIndex, { isSelected: o } = e.dataRef.current, r = e.options.findIndex((a)=>o(a.dataRef.current.value));
        return r !== -1 && (i = r), {
            ...e,
            listboxState: 0,
            activeOptionIndex: i,
            __demoMode: !1
        };
    },
    [2] (e, i) {
        var m, x, d, p, n;
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let o = {
            ...e,
            searchQuery: "",
            activationTrigger: (m = i.trigger) != null ? m : 1,
            __demoMode: !1
        };
        if (i.focus === (0, $ec287b464336d1f1$export$807a7eae502106e7).Nothing) return {
            ...o,
            activeOptionIndex: null
        };
        if (i.focus === (0, $ec287b464336d1f1$export$807a7eae502106e7).Specific) return {
            ...o,
            activeOptionIndex: e.options.findIndex((u)=>u.id === i.id)
        };
        if (i.focus === (0, $ec287b464336d1f1$export$807a7eae502106e7).Previous) {
            let u = e.activeOptionIndex;
            if (u !== null) {
                let P = e.options[u].dataRef.current.domRef, t = (0, $ec287b464336d1f1$export$c6b4626b54936d5e)(i, {
                    resolveItems: ()=>e.options,
                    resolveActiveIndex: ()=>e.activeOptionIndex,
                    resolveId: (s)=>s.id,
                    resolveDisabled: (s)=>s.dataRef.current.disabled
                });
                if (t !== null) {
                    let s = e.options[t].dataRef.current.domRef;
                    if (((x = P.current) == null ? void 0 : x.previousElementSibling) === s.current || ((d = s.current) == null ? void 0 : d.previousElementSibling) === null) return {
                        ...o,
                        activeOptionIndex: t
                    };
                }
            }
        } else if (i.focus === (0, $ec287b464336d1f1$export$807a7eae502106e7).Next) {
            let u = e.activeOptionIndex;
            if (u !== null) {
                let P = e.options[u].dataRef.current.domRef, t = (0, $ec287b464336d1f1$export$c6b4626b54936d5e)(i, {
                    resolveItems: ()=>e.options,
                    resolveActiveIndex: ()=>e.activeOptionIndex,
                    resolveId: (s)=>s.id,
                    resolveDisabled: (s)=>s.dataRef.current.disabled
                });
                if (t !== null) {
                    let s = e.options[t].dataRef.current.domRef;
                    if (((p = P.current) == null ? void 0 : p.nextElementSibling) === s.current || ((n = s.current) == null ? void 0 : n.nextElementSibling) === null) return {
                        ...o,
                        activeOptionIndex: t
                    };
                }
            }
        }
        let r = $9a32ae7006fff1f4$var$be(e), a = (0, $ec287b464336d1f1$export$c6b4626b54936d5e)(i, {
            resolveItems: ()=>r.options,
            resolveActiveIndex: ()=>r.activeOptionIndex,
            resolveId: (u)=>u.id,
            resolveDisabled: (u)=>u.dataRef.current.disabled
        });
        return {
            ...o,
            ...r,
            activeOptionIndex: a
        };
    },
    [3]: (e, i)=>{
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let r = e.searchQuery !== "" ? 0 : 1, a = e.searchQuery + i.value.toLowerCase(), x = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find((p)=>{
            var n;
            return !p.dataRef.current.disabled && ((n = p.dataRef.current.textValue) == null ? void 0 : n.startsWith(a));
        }), d = x ? e.options.indexOf(x) : -1;
        return d === -1 || d === e.activeOptionIndex ? {
            ...e,
            searchQuery: a
        } : {
            ...e,
            searchQuery: a,
            activeOptionIndex: d,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : {
            ...e,
            searchQuery: ""
        };
    },
    [5]: (e, i)=>{
        let o = {
            id: i.id,
            dataRef: i.dataRef
        }, r = $9a32ae7006fff1f4$var$be(e, (a)=>[
                ...a,
                o
            ]);
        return e.activeOptionIndex === null && e.dataRef.current.isSelected(i.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(o)), {
            ...e,
            ...r
        };
    },
    [6]: (e, i)=>{
        let o = $9a32ae7006fff1f4$var$be(e, (r)=>{
            let a = r.findIndex((m)=>m.id === i.id);
            return a !== -1 && r.splice(a, 1), r;
        });
        return {
            ...e,
            ...o,
            activationTrigger: 1
        };
    },
    [7]: (e, i)=>e.buttonElement === i.element ? e : {
            ...e,
            buttonElement: i.element
        },
    [8]: (e, i)=>e.optionsElement === i.element ? e : {
            ...e,
            optionsElement: i.element
        }
}, $9a32ae7006fff1f4$var$Te = (0, $l7WPE.createContext)(null);
$9a32ae7006fff1f4$var$Te.displayName = "ListboxActionsContext";
function $9a32ae7006fff1f4$var$Z(e) {
    let i = (0, $l7WPE.useContext)($9a32ae7006fff1f4$var$Te);
    if (i === null) {
        let o = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $9a32ae7006fff1f4$var$Z), o;
    }
    return i;
}
let $9a32ae7006fff1f4$var$ee = (0, $l7WPE.createContext)(null);
$9a32ae7006fff1f4$var$ee.displayName = "ListboxDataContext";
function $9a32ae7006fff1f4$var$Q(e) {
    let i = (0, $l7WPE.useContext)($9a32ae7006fff1f4$var$ee);
    if (i === null) {
        let o = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $9a32ae7006fff1f4$var$Q), o;
    }
    return i;
}
function $9a32ae7006fff1f4$var$Rt(e, i) {
    return (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(i.type, $9a32ae7006fff1f4$var$Pt, e, i);
}
let $9a32ae7006fff1f4$var$At = (0, $l7WPE.Fragment);
function $9a32ae7006fff1f4$var$ht(e, i) {
    var me;
    let o = (0, $3ffab61d59a88c3c$export$c763bb7a184a0f11)(), { value: r, defaultValue: a, form: m, name: x, onChange: d, by: p, invalid: n = !1, disabled: u = o || !1, horizontal: P = !1, multiple: t = !1, __demoMode: s = !1, ...F } = e;
    const M = P ? "horizontal" : "vertical";
    let h = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(i), D = (0, $3140c01a3fe83286$export$8a91ee242b6d0fe3)(a), [O = t ? [] : void 0, g] = (0, $288b02513317d536$export$454217e89aea72b)(r, d, D), [R, y] = (0, $l7WPE.useReducer)($9a32ae7006fff1f4$var$Rt, {
        dataRef: (0, $l7WPE.createRef)(),
        listboxState: s ? 0 : 1,
        options: [],
        searchQuery: "",
        activeOptionIndex: null,
        activationTrigger: 1,
        optionsVisible: !1,
        buttonElement: null,
        optionsElement: null,
        __demoMode: s
    }), B = (0, $l7WPE.useRef)({
        static: !1,
        hold: !1
    }), w = (0, $l7WPE.useRef)(new Map), _ = (0, $23dae15276e93483$export$988f0cf1b37580ae)(p), b = (0, $l7WPE.useCallback)((f)=>(0, $f191f2ad0684b169$export$4659b591c19bdf3d)(c.mode, {
            [1]: ()=>O.some((S)=>_(S, f)),
            [0]: ()=>_(O, f)
        }), [
        O
    ]), c = (0, $l7WPE.useMemo)(()=>({
            ...R,
            value: O,
            disabled: u,
            invalid: n,
            mode: t ? 1 : 0,
            orientation: M,
            compare: _,
            isSelected: b,
            optionsPropsRef: B,
            listRef: w
        }), [
        O,
        u,
        n,
        t,
        R,
        w
    ]);
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        R.dataRef.current = c;
    }, [
        c
    ]);
    let N = c.listboxState === 0;
    (0, $70b1014c8d12aa21$export$71b2224f1ce5e08e)(N, [
        c.buttonElement,
        c.optionsElement
    ], (f, S)=>{
        var C;
        y({
            type: 1
        }), (0, $c87ce7fcb4198fc6$export$ff1ec1c740b3c8d5)(S, (0, $c87ce7fcb4198fc6$export$27112a34f2f8402d).Loose) || (f.preventDefault(), (C = c.buttonElement) == null || C.focus());
    });
    let L = (0, $l7WPE.useMemo)(()=>({
            open: c.listboxState === 0,
            disabled: u,
            invalid: n,
            value: O
        }), [
        c,
        u,
        O,
        n
    ]), H = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((f)=>{
        let S = c.options.find((C)=>C.id === f);
        S && K(S.dataRef.current.value);
    }), te = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        if (c.activeOptionIndex !== null) {
            let { dataRef: f, id: S } = c.options[c.activeOptionIndex];
            K(f.current.value), y({
                type: 2,
                focus: (0, $ec287b464336d1f1$export$807a7eae502106e7).Specific,
                id: S
            });
        }
    }), oe = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>y({
            type: 0
        })), X = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>y({
            type: 1
        })), J = (0, $03ea8ceff1795700$export$fd183955ff4b45d9)(), ne = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((f, S, C)=>{
        J.dispose(), J.microTask(()=>f === (0, $ec287b464336d1f1$export$807a7eae502106e7).Specific ? y({
                type: 2,
                focus: (0, $ec287b464336d1f1$export$807a7eae502106e7).Specific,
                id: S,
                trigger: C
            }) : y({
                type: 2,
                focus: f,
                trigger: C
            }));
    }), ie = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((f, S)=>(y({
            type: 5,
            id: f,
            dataRef: S
        }), ()=>y({
                type: 6,
                id: f
            }))), K = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((f)=>(0, $f191f2ad0684b169$export$4659b591c19bdf3d)(c.mode, {
            [0] () {
                return g == null ? void 0 : g(f);
            },
            [1] () {
                let S = c.value.slice(), C = S.findIndex((Re)=>_(Re, f));
                return C === -1 ? S.push(f) : S.splice(C, 1), g == null ? void 0 : g(S);
            }
        })), re = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((f)=>y({
            type: 3,
            value: f
        })), $ = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>y({
            type: 4
        })), q = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((f)=>{
        y({
            type: 7,
            element: f
        });
    }), l = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((f)=>{
        y({
            type: 8,
            element: f
        });
    }), I = (0, $l7WPE.useMemo)(()=>({
            onChange: K,
            registerOption: ie,
            goToOption: ne,
            closeListbox: X,
            openListbox: oe,
            selectActiveOption: te,
            selectOption: H,
            search: re,
            clearSearch: $,
            setButtonElement: q,
            setOptionsElement: l
        }), []), [G, le] = (0, $cc31415baf6a16fd$export$d6875122194c7b44)({
        inherit: !0
    }), Se = {
        ref: h
    }, Ee = (0, $l7WPE.useCallback)(()=>{
        if (D !== void 0) return g == null ? void 0 : g(D);
    }, [
        g,
        D
    ]), Pe = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(le, {
        value: G,
        props: {
            htmlFor: (me = c.buttonElement) == null ? void 0 : me.id
        },
        slot: {
            open: c.listboxState === 0,
            disabled: u
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $9d5a69901036af68$export$e473aa84737d3250), null, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($9a32ae7006fff1f4$var$Te.Provider, {
        value: I
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($9a32ae7006fff1f4$var$ee.Provider, {
        value: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $6612489ddb1f013a$export$2a0ed818b175f558), {
        value: (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(c.listboxState, {
            [0]: (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open,
            [1]: (0, $6612489ddb1f013a$export$7254cc27399e90bd).Closed
        })
    }, x != null && O != null && (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $bdaef70e9c6257b4$export$125d0b248abd3e88), {
        disabled: u,
        data: {
            [x]: O
        },
        form: m,
        onReset: Ee
    }), Pe({
        ourProps: Se,
        theirProps: F,
        slot: L,
        defaultTag: $9a32ae7006fff1f4$var$At,
        name: "Listbox"
    }))))));
}
let $9a32ae7006fff1f4$var$Dt = "button";
function $9a32ae7006fff1f4$var$_t(e, i) {
    var N;
    let o = $9a32ae7006fff1f4$var$Q("Listbox.Button"), r = $9a32ae7006fff1f4$var$Z("Listbox.Button"), a = (0, $l7WPE.useId)(), m = (0, $5055a520bd3df962$export$6ba3910d268310db)(), { id: x = m || `headlessui-listbox-button-${a}`, disabled: d = o.disabled || !1, autoFocus: p = !1, ...n } = e, u = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(i, (0, $9d5a69901036af68$export$916a28f343467e85)(), r.setButtonElement), P = (0, $9d5a69901036af68$export$c7931d5027a8ead4)(), t = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((L)=>{
        switch(L.key){
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Enter:
                (0, $db207137356ac424$export$ee02894bdc79dd36)(L.currentTarget);
                break;
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Space:
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).ArrowDown:
                L.preventDefault(), (0, $b1e9cc0cc5ead376$exports.flushSync)(()=>r.openListbox()), o.value || r.goToOption((0, $ec287b464336d1f1$export$807a7eae502106e7).First);
                break;
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).ArrowUp:
                L.preventDefault(), (0, $b1e9cc0cc5ead376$exports.flushSync)(()=>r.openListbox()), o.value || r.goToOption((0, $ec287b464336d1f1$export$807a7eae502106e7).Last);
                break;
        }
    }), s = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((L)=>{
        switch(L.key){
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Space:
                L.preventDefault();
                break;
        }
    }), F = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((L)=>{
        var H;
        if ((0, $b3d8f67cd937a9d4$export$db61f031a278447c)(L.currentTarget)) return L.preventDefault();
        o.listboxState === 0 ? ((0, $b1e9cc0cc5ead376$exports.flushSync)(()=>r.closeListbox()), (H = o.buttonElement) == null || H.focus({
            preventScroll: !0
        })) : (L.preventDefault(), r.openListbox());
    }), M = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((L)=>L.preventDefault()), h = (0, $cc31415baf6a16fd$export$1f86aee6764cddb2)([
        x
    ]), D = (0, $892a159bd3b0d0c5$export$899851af1363628)(), { isFocusVisible: O, focusProps: g } = (0, $445bbf4beaf356d1$export$4e328f61c538687f)({
        autoFocus: p
    }), { isHovered: R, hoverProps: y } = (0, $7c7777069b2743a0$export$ae780daf29e6d456)({
        isDisabled: d
    }), { pressed: B, pressProps: w } = (0, $156b190393638fd9$export$73224eeef4bbe873)({
        disabled: d
    }), _ = (0, $l7WPE.useMemo)(()=>({
            open: o.listboxState === 0,
            active: B || o.listboxState === 0,
            disabled: d,
            invalid: o.invalid,
            value: o.value,
            hover: R,
            focus: O,
            autofocus: p
        }), [
        o.listboxState,
        o.value,
        d,
        R,
        O,
        B,
        o.invalid,
        p
    ]), b = (0, $30c8a076c23acfb8$export$9d1611c77c2fe928)(P(), {
        ref: u,
        id: x,
        type: (0, $8538aa82d598df10$export$53652b2b272efe9c)(e, o.buttonElement),
        "aria-haspopup": "listbox",
        "aria-controls": (N = o.optionsElement) == null ? void 0 : N.id,
        "aria-expanded": o.listboxState === 0,
        "aria-labelledby": h,
        "aria-describedby": D,
        disabled: d || void 0,
        autoFocus: p,
        onKeyDown: t,
        onKeyUp: s,
        onKeyPress: M,
        onClick: F
    }, g, y, w);
    return (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)()({
        ourProps: b,
        theirProps: n,
        slot: _,
        defaultTag: $9a32ae7006fff1f4$var$Dt,
        name: "Listbox.Button"
    });
}
let $9a32ae7006fff1f4$var$Le = (0, $l7WPE.createContext)(!1), $9a32ae7006fff1f4$var$It = "div", $9a32ae7006fff1f4$var$Ct = (0, $30c8a076c23acfb8$export$ba0ea3f20e7bf777).RenderStrategy | (0, $30c8a076c23acfb8$export$ba0ea3f20e7bf777).Static;
function $9a32ae7006fff1f4$var$Ft(e, i) {
    var $, q;
    let o = (0, $l7WPE.useId)(), { id: r = `headlessui-listbox-options-${o}`, anchor: a, portal: m = !1, modal: x = !0, transition: d = !1, ...p } = e, n = (0, $9d5a69901036af68$export$ee5342e485f0bdb0)(a), [u, P] = (0, $l7WPE.useState)(null);
    n && (m = !0);
    let t = $9a32ae7006fff1f4$var$Q("Listbox.Options"), s = $9a32ae7006fff1f4$var$Z("Listbox.Options"), F = (0, $6761cdc5f43c39c6$export$dd9fbcea3de0ae36)(t.optionsElement), M = (0, $6612489ddb1f013a$export$fc6fdf0ecf360e)(), [h, D] = (0, $e7ac80ae06735674$export$7b286972b8d8ccbf)(d, u, M !== null ? (M & (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open) === (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open : t.listboxState === 0);
    (0, $f05d8d85c884fb07$export$b41b9097915aa006)(h, t.buttonElement, s.closeListbox);
    let O = t.__demoMode ? !1 : x && t.listboxState === 0;
    (0, $0723ad8e5f506aa0$export$e47ba1b900da5d3b)(O, F);
    let g = t.__demoMode ? !1 : x && t.listboxState === 0;
    (0, $23d1b4b809d79c7a$export$af489fa7e5283cc3)(g, {
        allowed: (0, $l7WPE.useCallback)(()=>[
                t.buttonElement,
                t.optionsElement
            ], [
            t.buttonElement,
            t.optionsElement
        ])
    });
    let R = t.listboxState !== 0, B = (0, $fef4c2ffbde74102$export$d0b9dbca977c73d5)(R, t.buttonElement) ? !1 : h, w = h && t.listboxState === 1, _ = (0, $fc7b615601a071a5$export$1a771eb6e04a3c48)(w, t.value), b = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((l)=>t.compare(_, l)), c = (0, $l7WPE.useMemo)(()=>{
        var I;
        if (n == null || !((I = n == null ? void 0 : n.to) != null && I.includes("selection"))) return null;
        let l = t.options.findIndex((G)=>b(G.dataRef.current.value));
        return l === -1 && (l = 0), l;
    }, [
        n,
        t.options
    ]), N = (()=>{
        if (n == null) return;
        if (c === null) return {
            ...n,
            inner: void 0
        };
        let l = Array.from(t.listRef.current.values());
        return {
            ...n,
            inner: {
                listRef: {
                    current: l
                },
                index: c
            }
        };
    })(), [L, H] = (0, $9d5a69901036af68$export$aff4be9ef2a28e43)(N), te = (0, $9d5a69901036af68$export$106e71f938eae412)(), oe = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(i, n ? L : null, s.setOptionsElement, P), X = (0, $03ea8ceff1795700$export$fd183955ff4b45d9)();
    (0, $l7WPE.useEffect)(()=>{
        var I;
        let l = t.optionsElement;
        l && t.listboxState === 0 && l !== ((I = (0, $be0aa046e776f98a$export$b204af158042fbac)(l)) == null ? void 0 : I.activeElement) && (l == null || l.focus({
            preventScroll: !0
        }));
    }, [
        t.listboxState,
        t.optionsElement
    ]);
    let J = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((l)=>{
        var I, G;
        switch(X.dispose(), l.key){
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Space:
                if (t.searchQuery !== "") return l.preventDefault(), l.stopPropagation(), s.search(l.key);
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Enter:
                if (l.preventDefault(), l.stopPropagation(), t.activeOptionIndex !== null) {
                    let { dataRef: le } = t.options[t.activeOptionIndex];
                    s.onChange(le.current.value);
                }
                t.mode === 0 && ((0, $b1e9cc0cc5ead376$exports.flushSync)(()=>s.closeListbox()), (I = t.buttonElement) == null || I.focus({
                    preventScroll: !0
                }));
                break;
            case (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(t.orientation, {
                vertical: (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).ArrowDown,
                horizontal: (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).ArrowRight
            }):
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $ec287b464336d1f1$export$807a7eae502106e7).Next);
            case (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(t.orientation, {
                vertical: (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).ArrowUp,
                horizontal: (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).ArrowLeft
            }):
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $ec287b464336d1f1$export$807a7eae502106e7).Previous);
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Home:
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).PageUp:
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $ec287b464336d1f1$export$807a7eae502106e7).First);
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).End:
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).PageDown:
                return l.preventDefault(), l.stopPropagation(), s.goToOption((0, $ec287b464336d1f1$export$807a7eae502106e7).Last);
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Escape:
                l.preventDefault(), l.stopPropagation(), (0, $b1e9cc0cc5ead376$exports.flushSync)(()=>s.closeListbox()), (G = t.buttonElement) == null || G.focus({
                    preventScroll: !0
                });
                return;
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Tab:
                l.preventDefault(), l.stopPropagation(), (0, $b1e9cc0cc5ead376$exports.flushSync)(()=>s.closeListbox()), (0, $c87ce7fcb4198fc6$export$7fb6c844b485e870)(t.buttonElement, l.shiftKey ? (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).Previous : (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).Next);
                break;
            default:
                l.key.length === 1 && (s.search(l.key), X.setTimeout(()=>s.clearSearch(), 350));
                break;
        }
    }), ne = ($ = t.buttonElement) == null ? void 0 : $.id, ie = (0, $l7WPE.useMemo)(()=>({
            open: t.listboxState === 0
        }), [
        t.listboxState
    ]), K = (0, $30c8a076c23acfb8$export$9d1611c77c2fe928)(n ? te() : {}, {
        id: r,
        ref: oe,
        "aria-activedescendant": t.activeOptionIndex === null || (q = t.options[t.activeOptionIndex]) == null ? void 0 : q.id,
        "aria-multiselectable": t.mode === 1 ? !0 : void 0,
        "aria-labelledby": ne,
        "aria-orientation": t.orientation,
        onKeyDown: J,
        role: "listbox",
        tabIndex: t.listboxState === 0 ? 0 : void 0,
        style: {
            ...p.style,
            ...H,
            "--button-width": (0, $75fd44aa0be2e2ce$export$2b86bedf890eab8)(t.buttonElement, !0).width
        },
        ...(0, $e7ac80ae06735674$export$c291d481c40a2fc3)(D)
    }), re = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $b96399f10495e180$export$602eac185826482c), {
        enabled: m ? e.static || h : !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($9a32ae7006fff1f4$var$ee.Provider, {
        value: t.mode === 1 ? t : {
            ...t,
            isSelected: b
        }
    }, re({
        ourProps: K,
        theirProps: p,
        slot: ie,
        defaultTag: $9a32ae7006fff1f4$var$It,
        features: $9a32ae7006fff1f4$var$Ct,
        visible: B,
        name: "Listbox.Options"
    })));
}
let $9a32ae7006fff1f4$var$Mt = "div";
function $9a32ae7006fff1f4$var$Bt(e, i) {
    let o = (0, $l7WPE.useId)(), { id: r = `headlessui-listbox-option-${o}`, disabled: a = !1, value: m, ...x } = e, d = (0, $l7WPE.useContext)($9a32ae7006fff1f4$var$Le) === !0, p = $9a32ae7006fff1f4$var$Q("Listbox.Option"), n = $9a32ae7006fff1f4$var$Z("Listbox.Option"), u = p.activeOptionIndex !== null ? p.options[p.activeOptionIndex].id === r : !1, P = p.isSelected(m), t = (0, $l7WPE.useRef)(null), s = (0, $be953e450ea69759$export$f6862afd851a1cf4)(t), F = (0, $7395d73fc6971264$export$86c4283a11f23f95)({
        disabled: a,
        value: m,
        domRef: t,
        get textValue () {
            return s();
        }
    }), M = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(i, t, (b)=>{
        b ? p.listRef.current.set(r, b) : p.listRef.current.delete(r);
    });
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        if (!p.__demoMode && p.listboxState === 0 && u && p.activationTrigger !== 0) return (0, $270a47a058bb084f$export$12b26c28a05aa001)().requestAnimationFrame(()=>{
            var b, c;
            (c = (b = t.current) == null ? void 0 : b.scrollIntoView) == null || c.call(b, {
                block: "nearest"
            });
        });
    }, [
        t,
        u,
        p.__demoMode,
        p.listboxState,
        p.activationTrigger,
        p.activeOptionIndex
    ]), (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>{
        if (!d) return n.registerOption(r, F);
    }, [
        F,
        r,
        d
    ]);
    let h = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((b)=>{
        var c;
        if (a) return b.preventDefault();
        n.onChange(m), p.mode === 0 && ((0, $b1e9cc0cc5ead376$exports.flushSync)(()=>n.closeListbox()), (c = p.buttonElement) == null || c.focus({
            preventScroll: !0
        }));
    }), D = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        if (a) return n.goToOption((0, $ec287b464336d1f1$export$807a7eae502106e7).Nothing);
        n.goToOption((0, $ec287b464336d1f1$export$807a7eae502106e7).Specific, r);
    }), O = (0, $d4637e875bc56c65$export$24ebee078bde85c3)(), g = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((b)=>{
        O.update(b), !a && (u || n.goToOption((0, $ec287b464336d1f1$export$807a7eae502106e7).Specific, r, 0));
    }), R = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((b)=>{
        O.wasMoved(b) && (a || u || n.goToOption((0, $ec287b464336d1f1$export$807a7eae502106e7).Specific, r, 0));
    }), y = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((b)=>{
        O.wasMoved(b) && (a || u && n.goToOption((0, $ec287b464336d1f1$export$807a7eae502106e7).Nothing));
    }), B = (0, $l7WPE.useMemo)(()=>({
            active: u,
            focus: u,
            selected: P,
            disabled: a,
            selectedOption: P && d
        }), [
        u,
        P,
        a,
        d
    ]), w = d ? {} : {
        id: r,
        ref: M,
        role: "option",
        tabIndex: a === !0 ? void 0 : -1,
        "aria-disabled": a === !0 ? !0 : void 0,
        "aria-selected": P,
        disabled: void 0,
        onClick: h,
        onFocus: D,
        onPointerEnter: g,
        onMouseEnter: g,
        onPointerMove: R,
        onMouseMove: R,
        onPointerLeave: y,
        onMouseLeave: y
    }, _ = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return !P && d ? null : _({
        ourProps: w,
        theirProps: x,
        slot: B,
        defaultTag: $9a32ae7006fff1f4$var$Mt,
        name: "Listbox.Option"
    });
}
let $9a32ae7006fff1f4$var$wt = (0, $l7WPE.Fragment);
function $9a32ae7006fff1f4$var$kt(e, i) {
    let { options: o, placeholder: r, ...a } = e, x = {
        ref: (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(i)
    }, d = $9a32ae7006fff1f4$var$Q("ListboxSelectedOption"), p = (0, $l7WPE.useMemo)(()=>({}), []), n = d.value === void 0 || d.value === null || d.mode === 1 && Array.isArray(d.value) && d.value.length === 0, u = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($9a32ae7006fff1f4$var$Le.Provider, {
        value: !0
    }, u({
        ourProps: x,
        theirProps: {
            ...a,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).Fragment, null, r && n ? r : o)
        },
        slot: p,
        defaultTag: $9a32ae7006fff1f4$var$wt,
        name: "ListboxSelectedOption"
    }));
}
let $9a32ae7006fff1f4$var$Ut = (0, $30c8a076c23acfb8$export$e43f39796049410c)($9a32ae7006fff1f4$var$ht), $9a32ae7006fff1f4$export$1e1e59bb4b882447 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($9a32ae7006fff1f4$var$_t), $9a32ae7006fff1f4$export$3b435d19b0be2a59 = (0, $cc31415baf6a16fd$export$b04be29aa201d4f5), $9a32ae7006fff1f4$export$ea8d88fc73d4fb81 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($9a32ae7006fff1f4$var$Ft), $9a32ae7006fff1f4$export$68e891bae1a5b917 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($9a32ae7006fff1f4$var$Bt), $9a32ae7006fff1f4$export$867366afc1aaaf63 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($9a32ae7006fff1f4$var$kt), $9a32ae7006fff1f4$export$8bad31ff872c7659 = Object.assign($9a32ae7006fff1f4$var$Ut, {
    Button: $9a32ae7006fff1f4$export$1e1e59bb4b882447,
    Label: $9a32ae7006fff1f4$export$3b435d19b0be2a59,
    Options: $9a32ae7006fff1f4$export$ea8d88fc73d4fb81,
    Option: $9a32ae7006fff1f4$export$68e891bae1a5b917,
    SelectedOption: $9a32ae7006fff1f4$export$867366afc1aaaf63
});



var $l7WPE = parcelRequire("l7WPE");
function $660389bc2dcd5527$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $l7WPE.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $l7WPE.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $l7WPE.createElement("path", {
        fillRule: "evenodd",
        d: "M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z",
        clipRule: "evenodd"
    }));
}
const $660389bc2dcd5527$var$ForwardRef = /*#__PURE__*/ $l7WPE.forwardRef($660389bc2dcd5527$var$CheckIcon);
var $660389bc2dcd5527$export$2e2bcd8739ae039 = $660389bc2dcd5527$var$ForwardRef;


var $l7WPE = parcelRequire("l7WPE");
function $2c657284a8e352e4$var$ChevronUpDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $l7WPE.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $l7WPE.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $l7WPE.createElement("path", {
        fillRule: "evenodd",
        d: "M10.53 3.47a.75.75 0 0 0-1.06 0L6.22 6.72a.75.75 0 0 0 1.06 1.06L10 5.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-3.25-3.25Zm-4.31 9.81 3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 1 0-1.06-1.06L10 14.94l-2.72-2.72a.75.75 0 0 0-1.06 1.06Z",
        clipRule: "evenodd"
    }));
}
const $2c657284a8e352e4$var$ForwardRef = /*#__PURE__*/ $l7WPE.forwardRef($2c657284a8e352e4$var$ChevronUpDownIcon);
var $2c657284a8e352e4$export$2e2bcd8739ae039 = $2c657284a8e352e4$var$ForwardRef;




const $8984ea72c3681412$var$getScreenNameFromPathname = (pathname)=>{
    const id = pathname.split('/').pop();
    const screenType = pathname.startsWith('/rooms/') ? 'room' : 'title';
    return (0, $5b4f9380c818b26a$export$2e2bcd8739ae039)(screenType, id);
};
const $8984ea72c3681412$var$ScreenSelector = ({ rooms: rooms, titles: titles })=>{
    const { pathname: pathname } = (0, $e8d0e236465e8031$export$45d76561a5302f2b)();
    const navigate = (0, $e8d0e236465e8031$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $9a32ae7006fff1f4$export$8bad31ff872c7659), {
        value: pathname,
        onChange: (pathname)=>navigate(pathname),
        className: "sticky top-0 bg-slate-900/60 py-1",
        as: "div",
        children: ({ open: open })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                className: "relative mx-1",
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $cc31415baf6a16fd$export$b04be29aa201d4f5), {
                        className: "block px-1 font-medium leading-6 text-slate-100 sm:px-2 md:px-3 lg:px-4",
                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h2", {
                            children: "Screen selector"
                        })
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $9a32ae7006fff1f4$export$1e1e59bb4b882447), {
                        className: "relative w-full cursor-default rounded bg-slate-100 py-1.5 pl-3 pr-10 text-left text-slate-900 shadow-sm ring-1 ring-inset ring-slate-300 focus:outline-none focus:ring-2 focus:ring-primary-600 dark:bg-slate-900 dark:text-slate-100 dark:ring-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                className: "block truncate",
                                children: $8984ea72c3681412$var$getScreenNameFromPathname(pathname)
                            }),
                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $2c657284a8e352e4$export$2e2bcd8739ae039), {
                                    className: "size-5 text-slate-400",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $c80c1e31473e381f$export$be58926105124dd4), {
                        show: open,
                        leave: "transition ease-in duration-100",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $9a32ae7006fff1f4$export$ea8d88fc73d4fb81), {
                            className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                            children: [
                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $9a32ae7006fff1f4$export$68e891bae1a5b917), {
                                    disabled: true,
                                    className: "relative block cursor-default select-none truncate py-2 pl-3 pr-9 font-semibold text-slate-900",
                                    children: "Title screens"
                                }),
                                titles.map(({ metadata: metadata })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $9a32ae7006fff1f4$export$68e891bae1a5b917), {
                                        className: ({ focus: focus })=>(0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(focus ? 'bg-primary-600 text-white' : '', !focus ? 'text-slate-900' : '', 'relative cursor-default select-none py-2 pl-6 pr-9'),
                                        value: `/titles/${metadata.id}`,
                                        children: ({ selected: selected, focus: focus })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                                        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(selected ? 'font-semibold' : 'font-normal', 'block truncate'),
                                                        children: (0, $5b4f9380c818b26a$export$2e2bcd8739ae039)('title', metadata.id)
                                                    }),
                                                    selected ? /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                                        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(focus ? 'text-white' : 'text-primary-600', 'absolute inset-y-0 right-0 flex items-center pr-4'),
                                                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $660389bc2dcd5527$export$2e2bcd8739ae039), {
                                                            className: "size-5",
                                                            "aria-hidden": "true"
                                                        })
                                                    }) : null
                                                ]
                                            })
                                    }, metadata.id)),
                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $9a32ae7006fff1f4$export$68e891bae1a5b917), {
                                    disabled: true,
                                    className: "relative block cursor-default select-none truncate py-2 pl-3 pr-9 font-semibold text-slate-900",
                                    children: "Rooms"
                                }),
                                rooms.filter(({ header: header })=>header) // Some rooms are empty.
                                .map(({ metadata: metadata })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $9a32ae7006fff1f4$export$68e891bae1a5b917), {
                                        className: ({ focus: focus })=>(0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(focus ? 'bg-primary-600 text-white' : '', !focus ? 'text-slate-900' : '', 'relative cursor-default select-none py-2 pl-6 pr-9'),
                                        value: `/rooms/${metadata.id}`,
                                        children: ({ selected: selected, focus: focus })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                                        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(selected ? 'font-semibold' : 'font-normal', 'block truncate'),
                                                        children: (0, $5b4f9380c818b26a$export$2e2bcd8739ae039)('room', metadata.id)
                                                    }),
                                                    selected ? /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                                        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(focus ? 'text-white' : 'text-primary-600', 'absolute inset-y-0 right-0 flex items-center pr-4'),
                                                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $660389bc2dcd5527$export$2e2bcd8739ae039), {
                                                            className: "size-5",
                                                            "aria-hidden": "true"
                                                        })
                                                    }) : null
                                                ]
                                            })
                                    }, metadata.id))
                            ]
                        })
                    })
                ]
            })
    });
};
var $8984ea72c3681412$export$2e2bcd8739ae039 = $8984ea72c3681412$var$ScreenSelector;






const $0f62127f10c56af6$var$ColumnListHeader = ({ className: className, children: children, ...props })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("li", {
        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('bg-slate-500/60 px-1 py-1 text-slate-100 sm:px-2 md:px-3 lg:px-4', className),
        ...props,
        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h2", {
            children: children
        })
    });
};
var $0f62127f10c56af6$export$2e2bcd8739ae039 = $0f62127f10c56af6$var$ColumnListHeader;





const $544d1fbe23ef0f14$var$ColumnListItem = ({ path: path, selected: selected, className: className, children: children, ...props })=>{
    return !path ? /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("li", {
        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('bg-slate-200 px-1 py-1 text-slate-700 sm:px-2 md:px-3 lg:px-4', className),
        ...props,
        children: children
    }) : /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("li", {
        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('py-1 hover:bg-slate-600 hover:text-slate-100', className),
        ...props,
        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
            className: "px-1 py-1 sm:px-2 md:px-3 lg:px-4",
            to: path,
            children: children
        })
    });
};
var $544d1fbe23ef0f14$export$2e2bcd8739ae039 = $544d1fbe23ef0f14$var$ColumnListItem;



var $l7WPE = parcelRequire("l7WPE");
function $9c3b43b907c600db$var$MagnifyingGlassCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $l7WPE.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $l7WPE.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $l7WPE.createElement("path", {
        d: "M5.94 8.06a1.5 1.5 0 1 1 2.12-2.12 1.5 1.5 0 0 1-2.12 2.12Z"
    }), /*#__PURE__*/ $l7WPE.createElement("path", {
        fillRule: "evenodd",
        d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM4.879 4.879a3 3 0 0 0 3.645 4.706L9.72 10.78a.75.75 0 0 0 1.061-1.06L9.585 8.524A3.001 3.001 0 0 0 4.879 4.88Z",
        clipRule: "evenodd"
    }));
}
const $9c3b43b907c600db$var$ForwardRef = /*#__PURE__*/ $l7WPE.forwardRef($9c3b43b907c600db$var$MagnifyingGlassCircleIcon);
var $9c3b43b907c600db$export$2e2bcd8739ae039 = $9c3b43b907c600db$var$ForwardRef;


const $d0f5bf674d89138e$var$RoomsObjectList = ({ objects: objects, objectImages: objectImages, hoveredObject: hoveredObject, setHoveredObject: setHoveredObject, selectedObjects: selectedObjects, setSelectedObjectState: setSelectedObjectState, inspectedObject: inspectedObject, setInspectedObject: setInspectedObject })=>{
    // Objects can be deeply nested (3 levels in room 9).
    // This rendering function is recursive.
    const renderRoomObjects = (parentObjects)=>{
        return parentObjects.map((object)=>{
            const childObjects = objects.filter(({ parent: parent })=>parent === object.id + 1);
            return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)($d0f5bf674d89138e$var$RoomObject, {
                        object: object,
                        objectImage: objectImages[object.id],
                        isHoveredObject: hoveredObject === object.id,
                        setHoveredObject: setHoveredObject,
                        isSelectedObject: selectedObjects[object.id],
                        setSelectedObjectState: setSelectedObjectState,
                        isInspected: inspectedObject === object.id,
                        setInspectedObject: setInspectedObject
                    }),
                    childObjects && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("ol", {
                        className: "bg-slate-200 pl-6",
                        children: renderRoomObjects(childObjects)
                    })
                ]
            }, object.id);
        });
    };
    const parentObjects = objects.filter(({ parent: parent })=>parent === 0);
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $0f62127f10c56af6$export$2e2bcd8739ae039), {
                children: "Objects"
            }),
            renderRoomObjects(parentObjects)
        ]
    });
};
const $d0f5bf674d89138e$var$RoomObject = ({ object: object, objectImage: objectImage, isHoveredObject: isHoveredObject, setHoveredObject: setHoveredObject, isSelectedObject: isSelectedObject, setSelectedObjectState: setSelectedObjectState, isInspected: isInspected, setInspectedObject: setInspectedObject })=>{
    // Trim the final @.
    const name = object.name.replace(/@+$/, '') || 'Unnamed object';
    const namedClass = object.name ? 'first-letter:capitalize' : 'italic';
    const InspectorButton = ()=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
            className: "text-slate-400",
            children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $9c3b43b907c600db$export$2e2bcd8739ae039), {
                strokeWidth: "1.5",
                className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(isInspected ? 'text-primary-600' : 'opacity-0 hover:text-slate-600 group-hover:opacity-100', 'size-4 cursor-pointer transition'),
                onClick: ()=>setInspectedObject(object.id)
            })
        });
    if (!objectImage?.tiles) return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $544d1fbe23ef0f14$export$2e2bcd8739ae039), {
        onMouseOver: ()=>setHoveredObject(object.id),
        onMouseLeave: ()=>setHoveredObject(null),
        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('group flex justify-between whitespace-nowrap pl-6 leading-4 sm:pl-8 md:pl-9 lg:pl-10 xl:pl-11', isHoveredObject && 'bg-slate-300'),
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                className: namedClass,
                children: name
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)(InspectorButton, {})
        ]
    });
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $544d1fbe23ef0f14$export$2e2bcd8739ae039), {
        onMouseOver: ()=>setHoveredObject(object.id),
        onMouseLeave: ()=>setHoveredObject(null),
        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('group flex justify-between gap-1 whitespace-nowrap leading-4 sm:gap-2', isHoveredObject && 'bg-slate-300'),
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("label", {
                className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('flex cursor-pointer gap-1 sm:gap-2', namedClass),
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("input", {
                        type: "checkbox",
                        checked: isSelectedObject,
                        onChange: ({ target: target })=>setSelectedObjectState(object.id, target.checked),
                        className: "size-4 cursor-pointer rounded border-slate-300 text-primary-600 focus:ring-primary-600"
                    }),
                    name
                ]
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)(InspectorButton, {})
        ]
    });
};
var $d0f5bf674d89138e$export$2e2bcd8739ae039 = $d0f5bf674d89138e$var$RoomsObjectList;




parcelRequire("l7WPE");


parcelRequire("l7WPE");


var $jrGSV = parcelRequire("jrGSV");
const $5b5d6fff0954b155$var$prettifyArguments = (operation)=>{
    const opCode = operation[0];
    let args = operation.slice(2);
    switch(opCode){
        // resourceRoutines
        case 0x0c:
        case 0x8c:
            if (args[0].endsWith('Costume')) // Note: The link goes to costume set 0. The actual costume set used can't be determined statically.
            args = [
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `/costumes/0/${args[1]}`,
                    children: [
                        args[0],
                        "(",
                        args[1],
                        ")"
                    ]
                })
            ];
            else if (args[0].endsWith('Room')) args = [
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `/rooms/${args[1]}`,
                    children: [
                        args[0],
                        "(",
                        args[1],
                        ")"
                    ]
                })
            ];
            else if (args[0].endsWith('Script')) args = [
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `/scripts/${args[1]}`,
                    children: [
                        args[0],
                        "(",
                        args[1],
                        ")"
                    ]
                })
            ];
            break;
        // actorOps
        case 0x13:
        case 0x53:
        case 0x93:
        case 0xd3:
            if (args[1] === 'Color') args = [
                args[0],
                `${args[1]}(${args[3]}, ${args[2]})`
            ];
            else if (args[1] === 'Name') args = [
                args[0],
                `${args[1]}("${args[2]}")`
            ];
            else if (args[1] === 'Costume') // Note: The link goes to costume set 0. The actual costume set used can't be determined statically.
            args = [
                args[0],
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `/costumes/0/${args[2]}`,
                    children: [
                        args[1],
                        "(",
                        args[2],
                        ")"
                    ]
                })
            ];
            else args = [
                args[0],
                `${args[1]}(${args[2]})`
            ];
            break;
        case 0x18:
            args = [
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `#L${args[0]}`,
                    children: [
                        "0x",
                        args[0]
                    ]
                })
            ];
            break;
        // loadRoomWithEgo
        case 0x24:
        case 0x64:
        case 0xa4:
        case 0xe4:
            args = [
                args[0],
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `/rooms/${args[1]}`,
                    children: args[1]
                }),
                args[2],
                args[3]
            ];
            break;
        // loadRoom
        case 0x72:
        case 0xf2:
            args = [
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `/rooms/${args[0]}`,
                    children: args[0]
                })
            ];
            break;
        // putActorInRoom
        case 0x2d:
        case 0x6d:
        case 0xad:
        case 0xed:
            args = [
                args[0],
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `/rooms/${args[1]}`,
                    children: args[1]
                })
            ];
            break;
        case 0x42:
        case 0xc2:
        case 0x62:
        case 0xe2:
        case 0x4a:
        case 0xca:
            args = [
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `/scripts/${args[0]}`,
                    children: args[0]
                })
            ];
            break;
        case 0x48:
        case 0xc8:
        case 0x78:
        case 0xf8:
        case 0x04:
        case 0x84:
        case 0x44:
        case 0xc4:
        case 0x08:
        case 0x88:
        case 0x38:
        case 0xb8:
            args = [
                args[0],
                args[1],
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `#L${args[2]}`,
                    children: [
                        "0x",
                        args[2]
                    ]
                })
            ];
            break;
        case 0x28:
        case 0xa8:
            args = [
                args[0],
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `#L${args[1]}`,
                    children: [
                        "0x",
                        args[1]
                    ]
                })
            ];
            break;
        case 0x3f:
        case 0x5f:
        case 0x2f:
        case 0x0f:
        case 0x7f:
        case 0x1f:
        case 0x6f:
        case 0x4f:
            args = [
                args[0],
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                    className: "underline",
                    to: `#L${args[1]}`,
                    children: [
                        "0x",
                        args[1]
                    ]
                })
            ];
            break;
        default:
            break;
    }
    return args;
};
const $5b5d6fff0954b155$var$ScriptCodeInstruction = ({ command: command })=>{
    const opCode = (0, $jrGSV.hex)(command[0], 2);
    const instruction = command[1];
    const args = $5b5d6fff0954b155$var$prettifyArguments(command);
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("pre", {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("span", {
                className: "text-primary-600 dark:text-primary-300",
                children: [
                    "($",
                    opCode,
                    ") ",
                    instruction
                ]
            }),
            ' ',
            args.map((arg, i)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("span", {
                    children: [
                        arg,
                        i < args.length - 1 ? /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                            className: 'opacity-50',
                            children: ", "
                        }) : ''
                    ]
                }, `${i}`))
        ]
    });
};
var $5b5d6fff0954b155$export$2e2bcd8739ae039 = $5b5d6fff0954b155$var$ScriptCodeInstruction;



var $jrGSV = parcelRequire("jrGSV");
const $b0a497209e720e02$var$ScriptCode = ({ code: code })=>{
    if (!code) return null;
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
        className: "text-xs",
        children: code.map(({ 0: address, 1: command })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                id: `L${(0, $jrGSV.hex)(address, 4)}`,
                className: "flex gap-4 px-2 font-monocode",
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                        className: "font-thin opacity-50",
                        to: `#L${(0, $jrGSV.hex)(address, 4)}`,
                        children: [
                            "0x",
                            (0, $jrGSV.hex)(address, 4)
                        ]
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $5b5d6fff0954b155$export$2e2bcd8739ae039), {
                        command: command
                    })
                ]
            }, (0, $jrGSV.hex)(address, 4)))
    });
};
var $b0a497209e720e02$export$2e2bcd8739ae039 = $b0a497209e720e02$var$ScriptCode;


const $2af0afd349f9be9f$var$RoomObjectProperties = ({ object: object })=>{
    if (!object) return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
        className: "text-xs",
        children: "Click the inspect icon next to an object."
    });
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
        className: "text-xs",
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h2", {
                className: "text-sm",
                children: "Properties"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                        children: "ID: "
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                        children: object.id
                    })
                ]
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                        children: "Position: "
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("span", {
                        children: [
                            object.x,
                            ", ",
                            object.y
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                        children: "Dimension: "
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("span", {
                        children: [
                            object.width,
                            " x ",
                            object.height
                        ]
                    })
                ]
            }),
            object?.scripts?.length > 0 && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h2", {
                className: "pt-4 text-sm",
                children: "Scripts"
            }),
            object?.scripts?.map(([verb, code])=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h3", {
                            children: verb
                        }),
                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b0a497209e720e02$export$2e2bcd8739ae039), {
                            code: code
                        })
                    ]
                }, verb))
        ]
    });
};
var $2af0afd349f9be9f$export$2e2bcd8739ae039 = $2af0afd349f9be9f$var$RoomObjectProperties;





const $44d1c528da8bddf4$var$RoomsBoxList = ({ boxes: boxes, setHoveredBox: setHoveredBox })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $0f62127f10c56af6$export$2e2bcd8739ae039), {
                children: "Boxes"
            }),
            boxes.map((box, i)=>{
                return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $544d1fbe23ef0f14$export$2e2bcd8739ae039), {
                    onMouseOver: ()=>setHoveredBox(i),
                    onMouseLeave: ()=>setHoveredBox(null),
                    className: "whitespace-nowrap pl-6 leading-4 hover:bg-slate-300 sm:pl-8 md:pl-9 lg:pl-10 xl:pl-11",
                    children: [
                        "Box ",
                        i + 1
                    ]
                }, i);
            })
        ]
    });
};
var $44d1c528da8bddf4$export$2e2bcd8739ae039 = $44d1c528da8bddf4$var$RoomsBoxList;





var $l7WPE = parcelRequire("l7WPE");

// prettier-ignore
// See http://www.firebrandx.com/nespalettes.html
const $96a96c55effa2343$export$276f5054ae9adf17 = [
    '#696969',
    '#00148f',
    '#1e029b',
    '#3f008a',
    '#600060',
    '#660017',
    '#570d00',
    '#451b00',
    '#243400',
    '#004200',
    '#004500',
    '#003c1f',
    '#00315c',
    '#000000',
    '#000000',
    '#000000',
    '#afafaf',
    '#0f51dd',
    '#442ff3',
    '#7220e2',
    '#a319b3',
    '#ae1c51',
    '#a43400',
    '#884d00',
    '#676d00',
    '#208000',
    '#008b00',
    '#007f42',
    '#006c97',
    '#010101',
    '#000000',
    '#000000',
    '#ffffff',
    '#65aaff',
    '#8c96ff',
    '#b983ff',
    '#dd6fff',
    '#ea6fbd',
    '#eb8466',
    '#dca21f',
    '#bab403',
    '#7ecb07',
    '#54d33e',
    '#3cd284',
    '#3ec7cc',
    '#4b4b4b',
    '#000000',
    '#000000',
    '#ffffff',
    '#bde2ff',
    '#cecfff',
    '#e6c2ff',
    '#f6bcff',
    '#f9c2ed',
    '#facfc6',
    '#f8deac',
    '#eee9a1',
    '#d0f59f',
    '#bbf5af',
    '#b3f5cd',
    '#b9edf0',
    '#b9b9b9',
    '#000000',
    '#000000'
];
const $96a96c55effa2343$export$110ff079fbee6374 = [
    '#000',
    '#555',
    '#aaa',
    '#fff'
];
const $96a96c55effa2343$export$2ceab8b142cfb8e4 = [
    '#071821',
    '#306850',
    '#86c06c',
    '#e0f8cf'
];


const $81be0fdaa3a8023c$export$747ccad006a63299 = (palette = [], forceColour = false)=>{
    palette = palette.map((p)=>(0, $96a96c55effa2343$export$276f5054ae9adf17)[p]);
    if (forceColour) return palette;
    switch(localStorage.getItem('palette')){
        default:
        case 'fbx':
            return palette;
        case 'grey':
            return 0, $96a96c55effa2343$export$110ff079fbee6374;
        case 'dmg':
            // Method 1: maps the palette to DMG's based on each colour luminosity.
            // The result may lack some DMG colours.
            // Looks closer to the NES, but some colours are lost.
            return palette.map((p)=>{
                const luminosity = $81be0fdaa3a8023c$export$6cad8993cdb9e5a6(p);
                if (luminosity > 205) return (0, $96a96c55effa2343$export$2ceab8b142cfb8e4)[3];
                else if (luminosity > 130) return (0, $96a96c55effa2343$export$2ceab8b142cfb8e4)[2];
                else if (luminosity > 65) return (0, $96a96c55effa2343$export$2ceab8b142cfb8e4)[1];
                else return (0, $96a96c55effa2343$export$2ceab8b142cfb8e4)[0];
            });
        case 'dmg-alt':
            // Method 2: Sort the colours by brightness and maps to DMG's palette.
            // May result in the same colour being mapped to 2 different DMG colour on different palettes.
            // The colours looks harsher and there are some artefacts.
            palette = palette.map((p, order)=>({
                    order: order,
                    luminosity: $81be0fdaa3a8023c$export$6cad8993cdb9e5a6(p)
                }));
            palette.sort((a, b)=>a.luminosity - b.luminosity);
            palette = palette.map((p, i)=>({
                    ...p,
                    dmg: (0, $96a96c55effa2343$export$2ceab8b142cfb8e4)[i]
                }));
            palette.sort((a, b)=>a.order - b.order);
            palette = palette.map(({ dmg: dmg })=>dmg);
            return palette;
    }
};
// See https://gist.github.com/w3core/e3d9b5b6d69a3ba8671cc84714cca8a4
const $81be0fdaa3a8023c$export$6cad8993cdb9e5a6 = (color = '')=>{
    const m = color.substring(1).match(/\S{2}/g).map((c)=>parseInt(c, 16));
    return m[0] * 0.299 + m[1] * 0.587 + m[2] * 0.114;
};


// Display a screen on a canvas. Used by rooms and title screens.
const $1caa0bc32675e0e4$var$ScreenCanvasContainer = ({ screen: screen, baseTiles: baseTiles, gfc: gfc, selectedObjects: selectedObjects, hoveredBox: hoveredBox, crop: crop = true, zoom: zoom = 1 })=>{
    const canvasRef = (0, $l7WPE.useRef)(null);
    const [isComputing, setIsComputing] = (0, $l7WPE.useState)(true);
    const { width: width, height: height } = screen.header;
    // Aspect ratio of 5:4 for all possible screen sizes.
    const ratio = width === 28 ? 'aspect-[4.375/2.133333333333333]' : width === 60 ? 'aspect-[9.375/2.133333333333333]' : 'aspect-[5/4]';
    (0, $l7WPE.useEffect)(()=>{
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        setTimeout(()=>{
            $1caa0bc32675e0e4$var$draw(ctx, screen, baseTiles, gfc, selectedObjects, crop);
            $1caa0bc32675e0e4$var$drawBoxes(ctx, screen.boxes, hoveredBox);
            setIsComputing(false);
        });
    }, [
        screen,
        selectedObjects,
        hoveredBox,
        crop,
        baseTiles,
        gfc
    ]);
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("canvas", {
        ref: canvasRef,
        width: width * 8,
        height: height * 8,
        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(ratio, 'w-full rounded', isComputing ? 'opacity-0' : 'opacity-100 transition-opacity'),
        style: {
            maxWidth: width * 8 * zoom
        }
    });
};
const $1caa0bc32675e0e4$var$draw = (ctx, room, baseTiles = {
    gfx: []
}, roomgfc, selectedObjects = [], crop)=>{
    const { width: width, height: height } = room.header;
    const { palette: palette } = room;
    const baseTilesNum = baseTiles?.gfx?.length / 8 / 2;
    const nametable = structuredClone(room.nametable);
    const attributes = structuredClone(room.attributes);
    // Overwrite tiles and palette with selected object.
    // Start with highest id as it is the way it is implemented with overlapping object images.
    for(let i = selectedObjects.length - 1; i >= 0; i--){
        const object = room?.objects[i];
        const objectImage = room?.objectImages[i];
        const x = object?.x; // Can be 0?
        const y = object?.y; // Can be 0?
        const width = object?.width;
        const height = object?.height;
        if (!selectedObjects[i] || !objectImage || !objectImage?.tiles || !x || !y) continue;
        for(let j = 0; j < objectImage.tiles.length; j++)for(let i = 0; i < objectImage.tiles[j].length; i++)nametable[y + j][x + i + 2] = objectImage.tiles[j][i];
        // Port of https://github.com/scummvm/scummvm/blob/master/engines/scumm/gfx.cpp#L3103-L3134
        let j = height >> 1;
        let ay = y;
        let ptr = 0;
        while(j){
            let ax = x + 2;
            let i = 0;
            let adata = 0;
            while(i < width >> 1){
                if (!(i & 3)) adata = objectImage.attributes[ptr++];
                let aand = 3;
                let aor = adata & 3;
                if (ay & 0x02) {
                    aand <<= 4;
                    aor <<= 4;
                }
                if (ax & 0x02) {
                    aand <<= 2;
                    aor <<= 2;
                }
                const attr = attributes[ay << 2 & 0x30 | ax >> 2 & 0xf];
                attributes[ay << 2 & 0x30 | ax >> 2 & 0xf] = ~aand & attr | aor;
                adata >>= 2;
                ax += 2;
                i++;
            }
            ay += 2;
            j--;
        }
    }
    // Now generate the image of the room.
    for(let sprY = 0; sprY < height; sprY++)for(let sprX = 0; sprX < 62; sprX++){
        let tile = nametable[sprY][sprX];
        let gfx = baseTiles?.gfx;
        if (tile >= baseTilesNum) {
            tile -= baseTilesNum;
            gfx = roomgfc.gfx;
        }
        let paletteId;
        if (width === 32) // Title screen.
        paletteId = attributes[((sprY & 0xfffc) << 1) + (sprX >> 2)] >> ((sprY & 2) << 1 | sprX & 2) & 0x3;
        else // SCUMM room.
        paletteId = attributes[sprY << 2 & 0x30 | sprX >> 2 & 0xf] >> ((sprY & 2) << 1 | sprX & 2) & 0x3;
        const pal = (0, $81be0fdaa3a8023c$export$747ccad006a63299)([
            palette[paletteId * 4],
            palette[paletteId * 4 + 1],
            palette[paletteId * 4 + 2],
            palette[paletteId * 4 + 3]
        ]);
        for(let j = 0; j < 8; j++){
            const n1 = gfx[tile * 16 + j];
            const n2 = gfx[(tile * 2 + 1) * 8 + j];
            for(let k = 0; k < 8; k++){
                const mask = 1 << k;
                const val = (n1 & mask ? 1 : 0) | (n2 & mask ? 1 : 0) << 1;
                ctx.fillStyle = pal[val];
                if (crop) ctx.fillRect((sprX - 2) * 8 + 7 - k, sprY * 8 + j, 1, 1);
                else ctx.fillRect(sprX * 8 + 7 - k, sprY * 8 + j, 1, 1);
            }
        }
    }
};
const $1caa0bc32675e0e4$var$drawBoxes = (ctx, boxes = null, hoveredBox)=>{
    if (boxes === null || hoveredBox === null) return;
    // Draw the outlines of all the other boxes.
    ctx.strokeStyle = 'rgb(2,132,199,.8)'; // bg-primary-600/80
    boxes.filter((box, i)=>i !== hoveredBox).forEach((box)=>{
        $1caa0bc32675e0e4$var$drawBox(ctx, box);
        ctx.stroke();
    });
    // Fill in the currently hovered box.
    ctx.fillStyle = 'rgb(2,132,199,.5)'; // bg-primary-600/50
    $1caa0bc32675e0e4$var$drawBox(ctx, boxes[hoveredBox]);
    ctx.fill();
};
const $1caa0bc32675e0e4$var$drawBox = (ctx, { uy: uy, ly: ly, ulx: ulx, urx: urx, llx: llx, lrx: lrx })=>{
    ctx.beginPath();
    ctx.moveTo((ulx - 1) * 8, (uy - 1) * 2);
    ctx.lineTo((urx + 1) * 8, (uy - 1) * 2);
    ctx.lineTo((lrx + 1) * 8, (ly + 1) * 2);
    ctx.lineTo((llx - 1) * 8, (ly + 1) * 2);
    ctx.lineTo((ulx - 1) * 8, (uy - 1) * 2);
};
var $1caa0bc32675e0e4$export$2e2bcd8739ae039 = $1caa0bc32675e0e4$var$ScreenCanvasContainer;




const $6c1a3913b803ddb1$var$HoveredObjects = ({ width: width, height: height, objects: objects, hoveredObject: hoveredObject, setHoveredObject: setHoveredObject, toggleObjectState: toggleObjectState })=>{
    return objects.map((object, i)=>{
        const objWidth = object.width * 100 / width;
        const objHeight = object.height * 100 / height;
        const left = object.x * 100 / width;
        const top = object.y * 100 / height;
        return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
            onMouseOver: ()=>setHoveredObject(i),
            onMouseLeave: ()=>setHoveredObject(null),
            onClick: ()=>toggleObjectState(i),
            className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('absolute cursor-pointer', hoveredObject === i && 'bg-primary-600/50'),
            style: {
                width: `${objWidth}%`,
                height: `${objHeight}%`,
                left: `${left}%`,
                top: `${top}%`
            }
        }, i);
    });
};
var $6c1a3913b803ddb1$export$2e2bcd8739ae039 = $6c1a3913b803ddb1$var$HoveredObjects;


const $c7510f4a3a8a189b$var$Room = ({ room: room, baseTiles: baseTiles, roomgfc: roomgfc, hoveredObject: hoveredObject, setHoveredObject: setHoveredObject, selectedObjects: selectedObjects, toggleObjectState: toggleObjectState, hoveredBox: hoveredBox })=>{
    const { width: width } = room.header;
    const zoom = 2;
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $97bca11ad51d3992$exports.Fragment), {
        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
            className: "relative overflow-hidden",
            style: {
                maxWidth: width * 8 * zoom
            },
            children: [
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $1caa0bc32675e0e4$export$2e2bcd8739ae039), {
                    screen: room,
                    baseTiles: baseTiles,
                    gfc: roomgfc,
                    selectedObjects: selectedObjects,
                    hoveredBox: hoveredBox,
                    zoom: zoom
                }),
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $6c1a3913b803ddb1$export$2e2bcd8739ae039), {
                    width: room.header.width,
                    height: room.header.height,
                    objects: room.objects,
                    hoveredObject: hoveredObject,
                    setHoveredObject: setHoveredObject,
                    toggleObjectState: toggleObjectState
                })
            ]
        })
    });
};
var $c7510f4a3a8a189b$export$2e2bcd8739ae039 = $c7510f4a3a8a189b$var$Room;




const $292490abf81ee043$var$RoomTabs = ({ currentTab: currentTab, setCurrentTab: setCurrentTab, allowList: allowList = [
    'Palettes',
    'Tilesets',
    'Scripts',
    'Object properties'
] })=>{
    const tabs = [
        {
            name: 'Palettes',
            current: currentTab === 'Palettes'
        },
        {
            name: 'Tilesets',
            current: currentTab === 'Tilesets'
        },
        {
            name: 'Scripts',
            current: currentTab === 'Scripts'
        },
        {
            name: 'Object properties',
            current: currentTab === 'Object properties'
        }
    ].filter(({ name: name })=>allowList.includes(name));
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                className: "sm:hidden",
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("label", {
                        htmlFor: "tabs",
                        className: "sr-only",
                        children: "Select a tab"
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("select", {
                        id: "tabs",
                        name: "tabs",
                        value: tabs.find((tab)=>tab.current).name,
                        onChange: ({ target: target })=>setCurrentTab(target.value),
                        className: "block w-full rounded border-slate-300 focus:border-primary-500 focus:ring-primary-500",
                        children: tabs.map((tab)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("option", {
                                children: tab.name
                            }, tab.name))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                className: "hidden sm:block",
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("nav", {
                    className: "flex gap-x-4 md:gap-5 xl:gap-6",
                    "aria-label": "Tabs",
                    children: tabs.map((tab)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("button", {
                            onClick: ()=>setCurrentTab(tab.name),
                            className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(tab.current ? 'bg-slate-200 text-slate-700 dark:bg-slate-800 dark:text-slate-300' : 'text-slate-500 hover:text-slate-700 hover:dark:text-slate-300', 'rounded px-3 py-2 text-sm font-medium'),
                            "aria-current": tab.current ? 'page' : undefined,
                            children: tab.name
                        }, tab.name))
                })
            })
        ]
    });
};
var $292490abf81ee043$export$2e2bcd8739ae039 = $292490abf81ee043$var$RoomTabs;





var $l7WPE = parcelRequire("l7WPE");

var $l7WPE = parcelRequire("l7WPE");





var $l7WPE = parcelRequire("l7WPE");



"use client";
let $7609e7b1c52df9cb$var$R = "button";
function $7609e7b1c52df9cb$var$v(a, u) {
    var p;
    let l = (0, $3ffab61d59a88c3c$export$c763bb7a184a0f11)(), { disabled: e = l || !1, autoFocus: t = !1, ...o } = a, { isFocusVisible: r, focusProps: i } = (0, $445bbf4beaf356d1$export$4e328f61c538687f)({
        autoFocus: t
    }), { isHovered: s, hoverProps: T } = (0, $7c7777069b2743a0$export$ae780daf29e6d456)({
        isDisabled: e
    }), { pressed: n, pressProps: d } = (0, $156b190393638fd9$export$73224eeef4bbe873)({
        disabled: e
    }), f = (0, $30c8a076c23acfb8$export$9d1611c77c2fe928)({
        ref: u,
        type: (p = o.type) != null ? p : "button",
        disabled: e || void 0,
        autoFocus: t
    }, i, T, d), m = (0, $l7WPE.useMemo)(()=>({
            disabled: e,
            hover: s,
            focus: r,
            active: n,
            autofocus: t
        }), [
        e,
        s,
        r,
        n,
        t
    ]);
    return (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)()({
        ourProps: f,
        theirProps: o,
        slot: m,
        defaultTag: $7609e7b1c52df9cb$var$R,
        name: "Button"
    });
}
let $7609e7b1c52df9cb$export$353f5b6fc5456de1 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($7609e7b1c52df9cb$var$v);


"use client";
let $b147478660981f6b$var$i = "button";
function $b147478660981f6b$var$l(t, e) {
    let o = (0, $5376cec2aa696fce$export$4e99330e6f37bca2)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $7609e7b1c52df9cb$export$353f5b6fc5456de1), {
        ref: e,
        ...(0, $30c8a076c23acfb8$export$9d1611c77c2fe928)({
            onClick: o
        }, t)
    });
}
let $b147478660981f6b$export$de65de8213222d10 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($b147478660981f6b$var$l);




var $l7WPE = parcelRequire("l7WPE");





var $l7WPE = parcelRequire("l7WPE");























"use client";
var $7ee33b891112b565$var$lt = ((f)=>(f[f.Open = 0] = "Open", f[f.Closed = 1] = "Closed", f))($7ee33b891112b565$var$lt || {}), $7ee33b891112b565$var$at = ((p)=>(p[p.TogglePopover = 0] = "TogglePopover", p[p.ClosePopover = 1] = "ClosePopover", p[p.SetButton = 2] = "SetButton", p[p.SetButtonId = 3] = "SetButtonId", p[p.SetPanel = 4] = "SetPanel", p[p.SetPanelId = 5] = "SetPanelId", p))($7ee33b891112b565$var$at || {});
let $7ee33b891112b565$var$pt = {
    [0]: (o)=>({
            ...o,
            popoverState: (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(o.popoverState, {
                [0]: 1,
                [1]: 0
            }),
            __demoMode: !1
        }),
    [1] (o) {
        return o.popoverState === 1 ? o : {
            ...o,
            popoverState: 1,
            __demoMode: !1
        };
    },
    [2] (o, a) {
        return o.button === a.button ? o : {
            ...o,
            button: a.button
        };
    },
    [3] (o, a) {
        return o.buttonId === a.buttonId ? o : {
            ...o,
            buttonId: a.buttonId
        };
    },
    [4] (o, a) {
        return o.panel === a.panel ? o : {
            ...o,
            panel: a.panel
        };
    },
    [5] (o, a) {
        return o.panelId === a.panelId ? o : {
            ...o,
            panelId: a.panelId
        };
    }
}, $7ee33b891112b565$var$Ee = (0, $l7WPE.createContext)(null);
$7ee33b891112b565$var$Ee.displayName = "PopoverContext";
function $7ee33b891112b565$var$se(o) {
    let a = (0, $l7WPE.useContext)($7ee33b891112b565$var$Ee);
    if (a === null) {
        let f = new Error(`<${o} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(f, $7ee33b891112b565$var$se), f;
    }
    return a;
}
let $7ee33b891112b565$var$ue = (0, $l7WPE.createContext)(null);
$7ee33b891112b565$var$ue.displayName = "PopoverAPIContext";
function $7ee33b891112b565$var$be(o) {
    let a = (0, $l7WPE.useContext)($7ee33b891112b565$var$ue);
    if (a === null) {
        let f = new Error(`<${o} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(f, $7ee33b891112b565$var$be), f;
    }
    return a;
}
let $7ee33b891112b565$var$ge = (0, $l7WPE.createContext)(null);
$7ee33b891112b565$var$ge.displayName = "PopoverGroupContext";
function $7ee33b891112b565$var$Me() {
    return (0, $l7WPE.useContext)($7ee33b891112b565$var$ge);
}
let $7ee33b891112b565$var$ie = (0, $l7WPE.createContext)(null);
$7ee33b891112b565$var$ie.displayName = "PopoverPanelContext";
function $7ee33b891112b565$var$st() {
    return (0, $l7WPE.useContext)($7ee33b891112b565$var$ie);
}
function $7ee33b891112b565$var$ut(o, a) {
    return (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(a.type, $7ee33b891112b565$var$pt, o, a);
}
let $7ee33b891112b565$var$it = "div";
function $7ee33b891112b565$var$dt(o, a) {
    var J;
    let { __demoMode: f = !1, ...C } = o, T = (0, $l7WPE.useRef)(null), S = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(a, (0, $0da5c6e87036e5c9$export$7029785b750eb74)((t)=>{
        T.current = t;
    })), p = (0, $l7WPE.useRef)([]), l = (0, $l7WPE.useReducer)($7ee33b891112b565$var$ut, {
        __demoMode: f,
        popoverState: f ? 0 : 1,
        buttons: p,
        button: null,
        buttonId: null,
        panel: null,
        panelId: null,
        beforePanelSentinel: (0, $l7WPE.createRef)(),
        afterPanelSentinel: (0, $l7WPE.createRef)(),
        afterButtonSentinel: (0, $l7WPE.createRef)()
    }), [{ popoverState: c, button: d, buttonId: r, panel: s, panelId: R, beforePanelSentinel: m, afterPanelSentinel: h, afterButtonSentinel: P }, n] = l, v = (0, $6761cdc5f43c39c6$export$dd9fbcea3de0ae36)((J = T.current) != null ? J : d), g = (0, $l7WPE.useMemo)(()=>{
        if (!d || !s) return !1;
        for (let E of document.querySelectorAll("body > *"))if (Number(E == null ? void 0 : E.contains(d)) ^ Number(E == null ? void 0 : E.contains(s))) return !0;
        let t = (0, $c87ce7fcb4198fc6$export$433aaa1f216cf32d)(), e = t.indexOf(d), u = (e + t.length - 1) % t.length, i = (e + 1) % t.length, A = t[u], x = t[i];
        return !s.contains(A) && !s.contains(x);
    }, [
        d,
        s
    ]), _ = (0, $7395d73fc6971264$export$86c4283a11f23f95)(r), L = (0, $7395d73fc6971264$export$86c4283a11f23f95)(R), I = (0, $l7WPE.useMemo)(()=>({
            buttonId: _,
            panelId: L,
            close: ()=>n({
                    type: 1
                })
        }), [
        _,
        L,
        n
    ]), M = $7ee33b891112b565$var$Me(), k = M == null ? void 0 : M.registerPopover, B = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        var t;
        return (t = M == null ? void 0 : M.isFocusWithinPopoverGroup()) != null ? t : (v == null ? void 0 : v.activeElement) && ((d == null ? void 0 : d.contains(v.activeElement)) || (s == null ? void 0 : s.contains(v.activeElement)));
    });
    (0, $l7WPE.useEffect)(()=>k == null ? void 0 : k(I), [
        k,
        I
    ]);
    let [U, O] = (0, $b96399f10495e180$export$26b8c35244a70b37)(), N = (0, $6ed700a93f481555$export$64db24433d7f4942)(d), w = (0, $6ed700a93f481555$export$445f2d1a3d9b1b9f)({
        mainTreeNode: N,
        portals: U,
        defaultContainers: [
            d,
            s
        ]
    });
    (0, $7730fda268ff0e1a$export$7080b3e976bc91ab)(v == null ? void 0 : v.defaultView, "focus", (t)=>{
        var e, u, i, A, x, E;
        t.target !== window && t.target instanceof HTMLElement && c === 0 && (B() || d && s && (w.contains(t.target) || (u = (e = m.current) == null ? void 0 : e.contains) != null && u.call(e, t.target) || (A = (i = h.current) == null ? void 0 : i.contains) != null && A.call(i, t.target) || (E = (x = P.current) == null ? void 0 : x.contains) != null && E.call(x, t.target) || n({
            type: 1
        })));
    }, !0), (0, $70b1014c8d12aa21$export$71b2224f1ce5e08e)(c === 0, w.resolveContainers, (t, e)=>{
        n({
            type: 1
        }), (0, $c87ce7fcb4198fc6$export$ff1ec1c740b3c8d5)(e, (0, $c87ce7fcb4198fc6$export$27112a34f2f8402d).Loose) || (t.preventDefault(), d == null || d.focus());
    });
    let F = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((t)=>{
        n({
            type: 1
        });
        let e = (()=>t ? t instanceof HTMLElement ? t : "current" in t && t.current instanceof HTMLElement ? t.current : d : d)();
        e == null || e.focus();
    }), Q = (0, $l7WPE.useMemo)(()=>({
            close: F,
            isPortalled: g
        }), [
        F,
        g
    ]), K = (0, $l7WPE.useMemo)(()=>({
            open: c === 0,
            close: F
        }), [
        c,
        F
    ]), Z = {
        ref: S
    }, $ = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $6ed700a93f481555$export$61c2c570df73dc80), {
        node: N
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $9d5a69901036af68$export$e473aa84737d3250), null, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($7ee33b891112b565$var$ie.Provider, {
        value: null
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($7ee33b891112b565$var$Ee.Provider, {
        value: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($7ee33b891112b565$var$ue.Provider, {
        value: Q
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $5376cec2aa696fce$export$dd2a80b78bebbe1d), {
        value: F
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $6612489ddb1f013a$export$2a0ed818b175f558), {
        value: (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(c, {
            [0]: (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open,
            [1]: (0, $6612489ddb1f013a$export$7254cc27399e90bd).Closed
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(O, null, $({
        ourProps: Z,
        theirProps: C,
        slot: K,
        defaultTag: $7ee33b891112b565$var$it,
        name: "Popover"
    })))))))));
}
let $7ee33b891112b565$var$Pt = "button";
function $7ee33b891112b565$var$ft(o, a) {
    let f = (0, $l7WPE.useId)(), { id: C = `headlessui-popover-button-${f}`, disabled: T = !1, autoFocus: S = !1, ...p } = o, [l, c] = $7ee33b891112b565$var$se("Popover.Button"), { isPortalled: d } = $7ee33b891112b565$var$be("Popover.Button"), r = (0, $l7WPE.useRef)(null), s = `headlessui-focus-sentinel-${(0, $l7WPE.useId)()}`, R = $7ee33b891112b565$var$Me(), m = R == null ? void 0 : R.closeOthers, P = $7ee33b891112b565$var$st() !== null;
    (0, $l7WPE.useEffect)(()=>{
        if (!P) return c({
            type: 3,
            buttonId: C
        }), ()=>{
            c({
                type: 3,
                buttonId: null
            });
        };
    }, [
        P,
        C,
        c
    ]);
    let [n] = (0, $l7WPE.useState)(()=>Symbol()), v = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(r, a, (0, $9d5a69901036af68$export$916a28f343467e85)(), (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((e)=>{
        if (!P) {
            if (e) l.buttons.current.push(n);
            else {
                let u = l.buttons.current.indexOf(n);
                u !== -1 && l.buttons.current.splice(u, 1);
            }
            l.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), e && c({
                type: 2,
                button: e
            });
        }
    })), g = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(r, a), _ = (0, $6761cdc5f43c39c6$export$dd9fbcea3de0ae36)(r), L = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((e)=>{
        var u, i, A;
        if (P) {
            if (l.popoverState === 1) return;
            switch(e.key){
                case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Space:
                case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Enter:
                    e.preventDefault(), (i = (u = e.target).click) == null || i.call(u), c({
                        type: 1
                    }), (A = l.button) == null || A.focus();
                    break;
            }
        } else switch(e.key){
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Space:
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Enter:
                e.preventDefault(), e.stopPropagation(), l.popoverState === 1 && (m == null || m(l.buttonId)), c({
                    type: 0
                });
                break;
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Escape:
                if (l.popoverState !== 0) return m == null ? void 0 : m(l.buttonId);
                if (!r.current || _ != null && _.activeElement && !r.current.contains(_.activeElement)) return;
                e.preventDefault(), e.stopPropagation(), c({
                    type: 1
                });
                break;
        }
    }), I = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((e)=>{
        P || e.key === (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Space && e.preventDefault();
    }), M = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((e)=>{
        var u, i;
        (0, $b3d8f67cd937a9d4$export$db61f031a278447c)(e.currentTarget) || T || (P ? (c({
            type: 1
        }), (u = l.button) == null || u.focus()) : (e.preventDefault(), e.stopPropagation(), l.popoverState === 1 && (m == null || m(l.buttonId)), c({
            type: 0
        }), (i = l.button) == null || i.focus()));
    }), k = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((e)=>{
        e.preventDefault(), e.stopPropagation();
    }), { isFocusVisible: B, focusProps: U } = (0, $445bbf4beaf356d1$export$4e328f61c538687f)({
        autoFocus: S
    }), { isHovered: O, hoverProps: N } = (0, $7c7777069b2743a0$export$ae780daf29e6d456)({
        isDisabled: T
    }), { pressed: w, pressProps: Y } = (0, $156b190393638fd9$export$73224eeef4bbe873)({
        disabled: T
    }), F = l.popoverState === 0, Q = (0, $l7WPE.useMemo)(()=>({
            open: F,
            active: w || F,
            disabled: T,
            hover: O,
            focus: B,
            autofocus: S
        }), [
        F,
        O,
        B,
        w,
        T,
        S
    ]), K = (0, $8538aa82d598df10$export$53652b2b272efe9c)(o, l.button), Z = P ? (0, $30c8a076c23acfb8$export$9d1611c77c2fe928)({
        ref: g,
        type: K,
        onKeyDown: L,
        onClick: M,
        disabled: T || void 0,
        autoFocus: S
    }, U, N, Y) : (0, $30c8a076c23acfb8$export$9d1611c77c2fe928)({
        ref: v,
        id: l.buttonId,
        type: K,
        "aria-expanded": l.popoverState === 0,
        "aria-controls": l.panel ? l.panelId : void 0,
        disabled: T || void 0,
        autoFocus: S,
        onKeyDown: L,
        onKeyUp: I,
        onClick: M,
        onMouseDown: k
    }, U, N, Y), $ = (0, $038dc6ab11a58732$export$19b797546aece48f)(), J = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        let e = l.panel;
        if (!e) return;
        function u() {
            (0, $f191f2ad0684b169$export$4659b591c19bdf3d)($.current, {
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(e, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).First),
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(e, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).Last)
            }) === (0, $c87ce7fcb4198fc6$export$abf286375dfa6dbd).Error && (0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)((0, $c87ce7fcb4198fc6$export$433aaa1f216cf32d)().filter((A)=>A.dataset.headlessuiFocusGuard !== "true"), (0, $f191f2ad0684b169$export$4659b591c19bdf3d)($.current, {
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Forwards]: (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).Next,
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Backwards]: (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).Previous
            }), {
                relativeTo: l.button
            });
        }
        u();
    }), t = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).Fragment, null, t({
        ourProps: Z,
        theirProps: p,
        slot: Q,
        defaultTag: $7ee33b891112b565$var$Pt,
        name: "Popover.Button"
    }), F && !P && d && (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $51071f2ec6b67d06$export$8dc98ba7eadeaa56), {
        id: s,
        ref: l.afterButtonSentinel,
        features: (0, $51071f2ec6b67d06$export$4e7f8864c6a16d8a).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: J
    }));
}
let $7ee33b891112b565$var$ct = "div", $7ee33b891112b565$var$vt = (0, $30c8a076c23acfb8$export$ba0ea3f20e7bf777).RenderStrategy | (0, $30c8a076c23acfb8$export$ba0ea3f20e7bf777).Static;
function $7ee33b891112b565$var$Oe(o, a) {
    let f = (0, $l7WPE.useId)(), { id: C = `headlessui-popover-backdrop-${f}`, transition: T = !1, ...S } = o, [{ popoverState: p }, l] = $7ee33b891112b565$var$se("Popover.Backdrop"), [c, d] = (0, $l7WPE.useState)(null), r = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(a, d), s = (0, $6612489ddb1f013a$export$fc6fdf0ecf360e)(), [R, m] = (0, $e7ac80ae06735674$export$7b286972b8d8ccbf)(T, c, s !== null ? (s & (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open) === (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open : p === 0), h = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((g)=>{
        if ((0, $b3d8f67cd937a9d4$export$db61f031a278447c)(g.currentTarget)) return g.preventDefault();
        l({
            type: 1
        });
    }), P = (0, $l7WPE.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), n = {
        ref: r,
        id: C,
        "aria-hidden": !0,
        onClick: h,
        ...(0, $e7ac80ae06735674$export$c291d481c40a2fc3)(m)
    };
    return (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)()({
        ourProps: n,
        theirProps: S,
        slot: P,
        defaultTag: $7ee33b891112b565$var$ct,
        features: $7ee33b891112b565$var$vt,
        visible: R,
        name: "Popover.Backdrop"
    });
}
let $7ee33b891112b565$var$Tt = "div", $7ee33b891112b565$var$mt = (0, $30c8a076c23acfb8$export$ba0ea3f20e7bf777).RenderStrategy | (0, $30c8a076c23acfb8$export$ba0ea3f20e7bf777).Static;
function $7ee33b891112b565$var$yt(o, a) {
    let f = (0, $l7WPE.useId)(), { id: C = `headlessui-popover-panel-${f}`, focus: T = !1, anchor: S, portal: p = !1, modal: l = !1, transition: c = !1, ...d } = o, [r, s] = $7ee33b891112b565$var$se("Popover.Panel"), { close: R, isPortalled: m } = $7ee33b891112b565$var$be("Popover.Panel"), h = `headlessui-focus-sentinel-before-${f}`, P = `headlessui-focus-sentinel-after-${f}`, n = (0, $l7WPE.useRef)(null), v = (0, $9d5a69901036af68$export$ee5342e485f0bdb0)(S), [g, _] = (0, $9d5a69901036af68$export$aff4be9ef2a28e43)(v), L = (0, $9d5a69901036af68$export$106e71f938eae412)();
    v && (p = !0);
    let [I, M] = (0, $l7WPE.useState)(null), k = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(n, a, v ? g : null, (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((t)=>s({
            type: 4,
            panel: t
        })), M), B = (0, $6761cdc5f43c39c6$export$dd9fbcea3de0ae36)(n);
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>(s({
            type: 5,
            panelId: C
        }), ()=>{
            s({
                type: 5,
                panelId: null
            });
        }), [
        C,
        s
    ]);
    let U = (0, $6612489ddb1f013a$export$fc6fdf0ecf360e)(), [O, N] = (0, $e7ac80ae06735674$export$7b286972b8d8ccbf)(c, I, U !== null ? (U & (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open) === (0, $6612489ddb1f013a$export$7254cc27399e90bd).Open : r.popoverState === 0);
    (0, $f05d8d85c884fb07$export$b41b9097915aa006)(O, r.button, ()=>{
        s({
            type: 1
        });
    });
    let w = r.__demoMode ? !1 : l && O;
    (0, $0723ad8e5f506aa0$export$e47ba1b900da5d3b)(w, B);
    let Y = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((t)=>{
        var e;
        switch(t.key){
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Escape:
                if (r.popoverState !== 0 || !n.current || B != null && B.activeElement && !n.current.contains(B.activeElement)) return;
                t.preventDefault(), t.stopPropagation(), s({
                    type: 1
                }), (e = r.button) == null || e.focus();
                break;
        }
    });
    (0, $l7WPE.useEffect)(()=>{
        var t;
        o.static || r.popoverState === 1 && ((t = o.unmount) == null || t) && s({
            type: 4,
            panel: null
        });
    }, [
        r.popoverState,
        o.unmount,
        o.static,
        s
    ]), (0, $l7WPE.useEffect)(()=>{
        if (r.__demoMode || !T || r.popoverState !== 0 || !n.current) return;
        let t = B == null ? void 0 : B.activeElement;
        n.current.contains(t) || (0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(n.current, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).First);
    }, [
        r.__demoMode,
        T,
        n.current,
        r.popoverState
    ]);
    let F = (0, $l7WPE.useMemo)(()=>({
            open: r.popoverState === 0,
            close: R
        }), [
        r.popoverState,
        R
    ]), Q = (0, $30c8a076c23acfb8$export$9d1611c77c2fe928)(v ? L() : {}, {
        ref: k,
        id: C,
        onKeyDown: Y,
        onBlur: T && r.popoverState === 0 ? (t)=>{
            var u, i, A, x, E;
            let e = t.relatedTarget;
            e && n.current && ((u = n.current) != null && u.contains(e) || (s({
                type: 1
            }), ((A = (i = r.beforePanelSentinel.current) == null ? void 0 : i.contains) != null && A.call(i, e) || (E = (x = r.afterPanelSentinel.current) == null ? void 0 : x.contains) != null && E.call(x, e)) && e.focus({
                preventScroll: !0
            })));
        } : void 0,
        tabIndex: -1,
        style: {
            ...d.style,
            ..._,
            "--button-width": (0, $75fd44aa0be2e2ce$export$2b86bedf890eab8)(r.button, !0).width
        },
        ...(0, $e7ac80ae06735674$export$c291d481c40a2fc3)(N)
    }), K = (0, $038dc6ab11a58732$export$19b797546aece48f)(), Z = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        let t = n.current;
        if (!t) return;
        function e() {
            (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(K.current, {
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    var i;
                    (0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(t, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).First) === (0, $c87ce7fcb4198fc6$export$abf286375dfa6dbd).Error && ((i = r.afterPanelSentinel.current) == null || i.focus());
                },
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var u;
                    (u = r.button) == null || u.focus({
                        preventScroll: !0
                    });
                }
            });
        }
        e();
    }), $ = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        let t = n.current;
        if (!t) return;
        function e() {
            (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(K.current, {
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    if (!r.button) return;
                    let u = (0, $c87ce7fcb4198fc6$export$433aaa1f216cf32d)(), i = u.indexOf(r.button), A = u.slice(0, i + 1), E = [
                        ...u.slice(i + 1),
                        ...A
                    ];
                    for (let de of E.slice())if (de.dataset.headlessuiFocusGuard === "true" || I != null && I.contains(de)) {
                        let Se = E.indexOf(de);
                        Se !== -1 && E.splice(Se, 1);
                    }
                    (0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(E, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).First, {
                        sorted: !1
                    });
                },
                [(0, $038dc6ab11a58732$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var i;
                    (0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(t, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).Previous) === (0, $c87ce7fcb4198fc6$export$abf286375dfa6dbd).Error && ((i = r.button) == null || i.focus());
                }
            });
        }
        e();
    }), J = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $6612489ddb1f013a$export$6748feed729c7cf3), null, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($7ee33b891112b565$var$ie.Provider, {
        value: C
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($7ee33b891112b565$var$ue.Provider, {
        value: {
            close: R,
            isPortalled: m
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $b96399f10495e180$export$602eac185826482c), {
        enabled: p ? o.static || O : !1
    }, O && m && (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $51071f2ec6b67d06$export$8dc98ba7eadeaa56), {
        id: h,
        ref: r.beforePanelSentinel,
        features: (0, $51071f2ec6b67d06$export$4e7f8864c6a16d8a).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: Z
    }), J({
        ourProps: Q,
        theirProps: d,
        slot: F,
        defaultTag: $7ee33b891112b565$var$Tt,
        features: $7ee33b891112b565$var$mt,
        visible: O,
        name: "Popover.Panel"
    }), O && m && (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $51071f2ec6b67d06$export$8dc98ba7eadeaa56), {
        id: P,
        ref: r.afterPanelSentinel,
        features: (0, $51071f2ec6b67d06$export$4e7f8864c6a16d8a).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: $
    })))));
}
let $7ee33b891112b565$var$Et = "div";
function $7ee33b891112b565$var$bt(o, a) {
    let f = (0, $l7WPE.useRef)(null), C = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(f, a), [T, S] = (0, $l7WPE.useState)([]), p = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((P)=>{
        S((n)=>{
            let v = n.indexOf(P);
            if (v !== -1) {
                let g = n.slice();
                return g.splice(v, 1), g;
            }
            return n;
        });
    }), l = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((P)=>(S((n)=>[
                ...n,
                P
            ]), ()=>p(P))), c = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)(()=>{
        var v;
        let P = (0, $be0aa046e776f98a$export$b204af158042fbac)(f);
        if (!P) return !1;
        let n = P.activeElement;
        return (v = f.current) != null && v.contains(n) ? !0 : T.some((g)=>{
            var _, L;
            return ((_ = P.getElementById(g.buttonId.current)) == null ? void 0 : _.contains(n)) || ((L = P.getElementById(g.panelId.current)) == null ? void 0 : L.contains(n));
        });
    }), d = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((P)=>{
        for (let n of T)n.buttonId.current !== P && n.close();
    }), r = (0, $l7WPE.useMemo)(()=>({
            registerPopover: l,
            unregisterPopover: p,
            isFocusWithinPopoverGroup: c,
            closeOthers: d
        }), [
        l,
        p,
        c,
        d
    ]), s = (0, $l7WPE.useMemo)(()=>({}), []), R = o, m = {
        ref: C
    }, h = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $6ed700a93f481555$export$61c2c570df73dc80), null, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($7ee33b891112b565$var$ge.Provider, {
        value: r
    }, h({
        ourProps: m,
        theirProps: R,
        slot: s,
        defaultTag: $7ee33b891112b565$var$Et,
        name: "Popover.Group"
    })));
}
let $7ee33b891112b565$var$gt = (0, $30c8a076c23acfb8$export$e43f39796049410c)($7ee33b891112b565$var$dt), $7ee33b891112b565$export$c71dc08a6f474856 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($7ee33b891112b565$var$ft), $7ee33b891112b565$export$ec8dd1b2334697d6 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($7ee33b891112b565$var$Oe), $7ee33b891112b565$export$c1dfca41042a7ba8 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($7ee33b891112b565$var$Oe), $7ee33b891112b565$export$479aa83e4f119f19 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($7ee33b891112b565$var$yt), $7ee33b891112b565$export$97015eea9f4d03a9 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($7ee33b891112b565$var$bt), $7ee33b891112b565$export$5b6b19405a83ff9d = Object.assign($7ee33b891112b565$var$gt, {
    Button: $7ee33b891112b565$export$c71dc08a6f474856,
    Backdrop: $7ee33b891112b565$export$c1dfca41042a7ba8,
    Overlay: $7ee33b891112b565$export$ec8dd1b2334697d6,
    Panel: $7ee33b891112b565$export$479aa83e4f119f19,
    Group: $7ee33b891112b565$export$97015eea9f4d03a9
});




const $b46e95d155ca029d$var$ColourSwatch = ({ colour: colour, className: className, ...props })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
        ...props,
        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('inline-block h-6 w-8 rounded border border-neutral-500', className),
        style: {
            backgroundColor: colour
        }
    });
var $b46e95d155ca029d$export$2e2bcd8739ae039 = $b46e95d155ca029d$var$ColourSwatch;




var $l7WPE = parcelRequire("l7WPE");
function $09c73c8b5bef6143$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $l7WPE.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $l7WPE.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $l7WPE.createElement("path", {
        d: "M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
    }));
}
const $09c73c8b5bef6143$var$ForwardRef = /*#__PURE__*/ $l7WPE.forwardRef($09c73c8b5bef6143$var$XMarkIcon);
var $09c73c8b5bef6143$export$2e2bcd8739ae039 = $09c73c8b5bef6143$var$ForwardRef;




// ColourPicker uses shades of `neutral` instead of the usual `slate`.
// This is to avoid the frame to visually pollute the colours.
const $51a997989923348b$var$ColourPicker = ({ colourId: colourId, onPick: onPick, children: children })=>{
    const [selectedColour, setSelectedColour] = (0, $l7WPE.useState)(colourId);
    (0, $l7WPE.useEffect)(()=>{
        setSelectedColour(colourId);
    }, [
        colourId
    ]);
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $7ee33b891112b565$export$5b6b19405a83ff9d), {
        className: "relative",
        as: "span",
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $7ee33b891112b565$export$c71dc08a6f474856), {
                className: "h-6 w-8",
                children: children
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $7ee33b891112b565$export$479aa83e4f119f19), {
                anchor: {
                    to: 'bottom',
                    gap: '0.125rem'
                },
                className: "rounded bg-neutral-500 drop-shadow",
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                        className: "mx-2 flex justify-end",
                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $b147478660981f6b$export$de65de8213222d10), {
                            as: "button",
                            type: "button",
                            className: "-m-2 rounded-md p-2 text-neutral-300 hover:text-neutral-100 dark:text-neutral-700 hover:dark:text-neutral-900",
                            children: [
                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Close menu"
                                }),
                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $09c73c8b5bef6143$export$2e2bcd8739ae039), {
                                    strokeWidth: "2",
                                    className: "size-6",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                        className: "mx-2 mb-2 grid grid-cols-14",
                        children: (0, $96a96c55effa2343$export$276f5054ae9adf17).map((c, i)=>i % 16 <= 13 ? /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b46e95d155ca029d$export$2e2bcd8739ae039), {
                                colour: c,
                                className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(i === selectedColour ? (0, $81be0fdaa3a8023c$export$6cad8993cdb9e5a6)(c) < 127 ? 'border-2 !border-neutral-100' : 'border-2 border-neutral-900' : 'rounded-none border-0'),
                                onClick: ()=>{
                                    setSelectedColour(i);
                                    onPick(i);
                                }
                            }, i) : null)
                    })
                ]
            })
        ]
    });
};
var $51a997989923348b$export$2e2bcd8739ae039 = $51a997989923348b$var$ColourPicker;




const $0bb90831a4ba40e1$var$Palettes = ({ palette: palette, onUpdate: onUpdate })=>{
    const colourSwatches = [];
    for(let i = 0; i < 16; i += 4){
        const colours = (0, $81be0fdaa3a8023c$export$747ccad006a63299)([
            palette[i],
            palette[i + 1],
            palette[i + 2],
            palette[i + 3]
        ], true);
        colourSwatches.push(/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("li", {
            className: "ml-6 space-x-4 whitespace-nowrap pl-2",
            children: [
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $51a997989923348b$export$2e2bcd8739ae039), {
                    colourId: palette[i],
                    onPick: (newColour)=>onUpdate(i, newColour),
                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b46e95d155ca029d$export$2e2bcd8739ae039), {
                        colour: colours[0]
                    })
                }),
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $51a997989923348b$export$2e2bcd8739ae039), {
                    colourId: palette[i + 1],
                    onPick: (newColour)=>onUpdate(i + 1, newColour),
                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b46e95d155ca029d$export$2e2bcd8739ae039), {
                        colour: colours[1]
                    })
                }),
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $51a997989923348b$export$2e2bcd8739ae039), {
                    colourId: palette[i + 2],
                    onPick: (newColour)=>onUpdate(i + 2, newColour),
                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b46e95d155ca029d$export$2e2bcd8739ae039), {
                        colour: colours[2]
                    })
                }),
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $51a997989923348b$export$2e2bcd8739ae039), {
                    colourId: palette[i + 3],
                    onPick: (newColour)=>onUpdate(i + 3, newColour),
                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b46e95d155ca029d$export$2e2bcd8739ae039), {
                        colour: colours[3]
                    })
                })
            ]
        }, i));
    }
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("ol", {
        className: "list-outside list-decimal space-y-1",
        children: colourSwatches
    });
};
var $0bb90831a4ba40e1$export$2e2bcd8739ae039 = $0bb90831a4ba40e1$var$Palettes;






var $l7WPE = parcelRequire("l7WPE");

// See https://colorhunt.co/palette/293462f24c4cec9b3bf7d716
const $1d8e3e03348bf685$var$ROOM_PALETTE = [
    '#293462',
    '#F24C4C',
    '#EC9B3B',
    '#F7D716'
];
// See https://colorhunt.co/palette/e9efc0b4e19783bd754e944f
const $1d8e3e03348bf685$var$OBJECT_PALETTE = [
    '#4E944F',
    '#83BD75',
    '#B4E197',
    '#E9EFC0'
];
const $1d8e3e03348bf685$var$UNUSED_PALETTE = [
    'hsl(0, 0%, 50%)',
    'hsl(0, 0%, 65%)',
    'hsl(0, 0%, 80%)',
    'hsl(0, 0%, 90%)'
];
const $1d8e3e03348bf685$var$GfxCanvasContainer = ({ gfx: gfx, nametable: nametable = null, objectImages: objectImages = null, nametableStart: nametableStart = 0, rowLength: rowLength = 16, zoom: zoom = 1, spacing: spacing = 1 })=>{
    const canvasRef = (0, $l7WPE.useRef)(null);
    const [isComputing, setIsComputing] = (0, $l7WPE.useState)(true);
    const lineLength = Math.ceil(gfx.length / 8 / 2 / rowLength);
    const width = rowLength * 8 + spacing * (rowLength - 1);
    const height = lineLength * 8 + spacing * (lineLength - 1);
    (0, $l7WPE.useEffect)(()=>{
        setIsComputing(true);
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        setTimeout(()=>{
            $1d8e3e03348bf685$var$draw(ctx, rowLength, spacing, gfx, nametable, objectImages, nametableStart);
            setIsComputing(false);
        });
    }, [
        gfx,
        nametable,
        nametableStart,
        objectImages,
        rowLength,
        spacing
    ]);
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("canvas", {
        ref: canvasRef,
        width: width,
        height: height,
        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('rounded', isComputing ? 'opacity-0' : 'opacity-100 transition-opacity'),
        style: {
            width: width * zoom,
            height: height * zoom
        }
    });
};
const $1d8e3e03348bf685$var$draw = (ctx, rowLength, spacing, gfx, nametable = null, objectImages = null, nametableStart = 0)=>{
    const tilesNum = gfx.length / 8 / 2;
    // Massage the different tilesets to speed up code later.
    const nametableTiles = nametable?.flat();
    const objectImagesTiles = objectImages?.map((objectImages)=>objectImages.tiles).filter(Boolean).flat(2);
    for(let tile = 0; tile < tilesNum; tile++)for(let j = 0; j < 8; j++){
        const n1 = gfx[tile * 16 + j];
        const n2 = gfx[(tile * 2 + 1) * 8 + j];
        for(let k = 0; k < 8; k++){
            const mask = 1 << k;
            const val = (n1 & mask ? 1 : 0) | (n2 & mask ? 1 : 0) << 1;
            let pal;
            if (!nametableTiles || nametableTiles.includes(tile + nametableStart)) pal = $1d8e3e03348bf685$var$ROOM_PALETTE;
            else if (objectImagesTiles.includes(tile + nametableStart)) pal = $1d8e3e03348bf685$var$OBJECT_PALETTE;
            else pal = $1d8e3e03348bf685$var$UNUSED_PALETTE;
            const sprX = tile % rowLength;
            const sprY = Math.floor(tile / rowLength);
            ctx.fillStyle = pal[val];
            ctx.fillRect(sprX * 8 + 7 - k + spacing * sprX, sprY * 8 + j + spacing * sprY, 1, 1);
        }
    }
};
var $1d8e3e03348bf685$export$2e2bcd8739ae039 = $1d8e3e03348bf685$var$GfxCanvasContainer;


const $10324d8d3ba37348$var$RoomGfx = ({ baseTiles: baseTiles, tileset: tileset, nametable: nametable, objectImages: objectImages, roomgfc: roomgfc, type: type = 'room' })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
        className: "flex gap-4 md:gap-5 xl:gap-6",
        children: [
            baseTiles.gfx.length ? /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                className: "text-center text-sm",
                to: "/roomgfx/0",
                children: [
                    "Base tileset (",
                    baseTiles.gfx.length / 8 / 2,
                    " tiles)",
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $1d8e3e03348bf685$export$2e2bcd8739ae039), {
                        gfx: baseTiles.gfx,
                        nametable: nametable,
                        objectImages: objectImages,
                        nametableStart: 0,
                        rowLength: 8,
                        zoom: 2
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $90539c90c270aca5$export$a6c7ac8248d6e38a), {
                className: "text-center text-sm",
                to: type === 'room' ? `/roomgfx/${tileset}` : `/titlegfx/${tileset}`,
                children: [
                    "Tileset ",
                    tileset,
                    " (",
                    roomgfc.gfx.length / 8 / 2,
                    " tiles)",
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $1d8e3e03348bf685$export$2e2bcd8739ae039), {
                        gfx: roomgfc.gfx,
                        nametable: nametable,
                        objectImages: objectImages,
                        nametableStart: baseTiles.gfx.length / 8 / 2,
                        rowLength: 8,
                        zoom: 2
                    })
                ]
            })
        ]
    });
};
var $10324d8d3ba37348$export$2e2bcd8739ae039 = $10324d8d3ba37348$var$RoomGfx;




const $05bec73d7eebcc36$var$RoomScripts = ({ excdScript: excdScript, encdScript: encdScript })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
        className: "flex flex-col gap-4 md:gap-5 lg:flex-row xl:gap-6",
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h2", {
                        className: "text-sm",
                        children: "Enter Script"
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b0a497209e720e02$export$2e2bcd8739ae039), {
                        code: encdScript
                    })
                ]
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h2", {
                        className: "text-sm",
                        children: "Exit Script"
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b0a497209e720e02$export$2e2bcd8739ae039), {
                        code: excdScript
                    })
                ]
            })
        ]
    });
};
var $05bec73d7eebcc36$export$2e2bcd8739ae039 = $05bec73d7eebcc36$var$RoomScripts;



const $067de7175cda56e8$var$MainHeader = ({ title: title, children: children })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
        className: "flex flex-col justify-between gap-2 md:gap-4 lg:flex-row",
        children: [
            title && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h1", {
                className: "order-last whitespace-nowrap text-xl font-semibold text-slate-700 md:text-2xl lg:order-first dark:text-slate-300",
                children: title
            }),
            children
        ]
    });
};
var $067de7175cda56e8$export$2e2bcd8739ae039 = $067de7175cda56e8$var$MainHeader;




var $jrGSV = parcelRequire("jrGSV");
const $b1704ccebb1bcb93$var$ResourceMetadata = ({ metadata: metadata })=>{
    const sizeInB = metadata.size > 1024 && (0, $jrGSV.formatBytes)(metadata.size);
    const compressionRow = metadata.decompressedSize && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                className: "font-bold",
                children: "unpacked size:"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                className: "font-mono text-right",
                children: metadata.decompressedSize
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                className: "font-mono opacity-50",
                children: [
                    "(",
                    (0, $jrGSV.formatPercentage)(1 - metadata.size / metadata.decompressedSize),
                    ' ',
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                        className: "font-sans",
                        children: " compr."
                    }),
                    ")"
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
        className: "grid w-max grid-cols-[auto_auto_auto] gap-x-2 gap-y-1 whitespace-nowrap rounded bg-slate-200 p-2 font-monocode text-xs text-slate-700 dark:bg-slate-800 dark:text-slate-300",
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                className: "font-bold",
                children: "payload offset:"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                className: "font-mono text-right",
                children: [
                    "0x",
                    (0, $jrGSV.hex)(metadata.offset)
                ]
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                className: "font-mono opacity-50",
                children: [
                    "(",
                    metadata.offset,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                className: "font-bold",
                children: "payload size:"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                className: "font-mono text-right",
                children: [
                    metadata.size,
                    " B"
                ]
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                className: "font-mono opacity-50",
                children: sizeInB
            }),
            compressionRow
        ]
    });
};
var $b1704ccebb1bcb93$export$2e2bcd8739ae039 = $b1704ccebb1bcb93$var$ResourceMetadata;


const $84f162550428efeb$var$RoomsContainer = ({ rooms: rooms, titles: titles, roomgfx: roomgfx, globdata: globdata })=>{
    const dispatch = (0, $289dddd4090929de$export$181baa7312ee9507)();
    const { id: id } = (0, $e8d0e236465e8031$export$99eaa27ddbbb95ef)();
    const [hoveredObject, setHoveredObject] = (0, $l7WPE.useState)(null);
    const [selectedObjects, setSelectedObjects] = (0, $l7WPE.useState)([]);
    const [hoveredBox, setHoveredBox] = (0, $l7WPE.useState)(null);
    const [currentTab, setCurrentTab] = (0, $l7WPE.useState)('Palettes');
    const [room, setRoom] = (0, $l7WPE.useState)(null);
    const [inspectedObject, setInspectedObject] = (0, $l7WPE.useState)(null);
    const currentId = typeof id === 'undefined' ? null : parseInt(id, 10);
    const baseTiles = roomgfx?.find(({ metadata: metadata })=>metadata.id === 0);
    const roomgfc = roomgfx?.find(({ metadata: metadata })=>metadata.id === room?.tileset);
    (0, $l7WPE.useEffect)(()=>{
        const room = rooms.find(({ metadata: metadata })=>metadata.id === currentId) || null;
        setRoom(room);
        // Clear the selected objects when the room changes.
        const selectedObjects = Array(room?.header?.objectsNum || 0);
        for(let i = 0; i < selectedObjects.length; i++){
            const objNum = room.objects[i].num;
            const initialState = globdata.globdata[objNum];
            selectedObjects[i] = !!(initialState & 128);
        }
        setSelectedObjects(selectedObjects);
        // Reset the inspected object when the room changes.
        setInspectedObject(null);
    }, [
        currentId,
        globdata,
        rooms
    ]);
    (0, $l7WPE.useEffect)(()=>{
        if (inspectedObject !== null) setCurrentTab('Object properties');
    }, [
        inspectedObject
    ]);
    const setSelectedObjectState = (id, state)=>{
        const newSelectedObjects = [
            ...selectedObjects
        ];
        newSelectedObjects[id] = state;
        setSelectedObjects(newSelectedObjects);
    };
    const toggleObjectState = (id)=>{
        const newSelectedObjects = [
            ...selectedObjects
        ];
        newSelectedObjects[id] = !newSelectedObjects[id];
        setSelectedObjects(newSelectedObjects);
    };
    const updatePalette = (i, colourId)=>{
        const newPalette = structuredClone(room.palette);
        if (i % 4 === 0) // Keep the first colours in sync.
        for(let i = 0; i < 16; i += 4)newPalette[i] = colourId;
        else newPalette[i] = colourId;
        dispatch({
            type: 'changed-palette',
            screenType: 'room',
            id: currentId,
            palette: newPalette
        });
    };
    if (room && !room.header) return null;
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $307bcb5ed139e868$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $8984ea72c3681412$export$2e2bcd8739ae039), {
                        rooms: rooms,
                        titles: titles
                    }),
                    room?.objectImages?.length > 0 && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $d0f5bf674d89138e$export$2e2bcd8739ae039), {
                        objects: room.objects,
                        objectImages: room.objectImages,
                        hoveredObject: hoveredObject,
                        setHoveredObject: setHoveredObject,
                        selectedObjects: selectedObjects,
                        setSelectedObjectState: setSelectedObjectState,
                        inspectedObject: inspectedObject,
                        setInspectedObject: setInspectedObject
                    }),
                    room?.boxes?.length > 0 && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $44d1c528da8bddf4$export$2e2bcd8739ae039), {
                        boxes: room.boxes,
                        setHoveredBox: setHoveredBox
                    })
                ]
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $77f5f4efaf83b50c$export$2e2bcd8739ae039), {
                children: !room ? /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h1", {
                    children: "Rooms"
                }) : /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $067de7175cda56e8$export$2e2bcd8739ae039), {
                            title: (0, $5b4f9380c818b26a$export$2e2bcd8739ae039)('room', room.metadata.id, true),
                            children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b1704ccebb1bcb93$export$2e2bcd8739ae039), {
                                metadata: room.metadata
                            })
                        }),
                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $c7510f4a3a8a189b$export$2e2bcd8739ae039), {
                            room: room,
                            baseTiles: baseTiles,
                            roomgfc: roomgfc,
                            hoveredObject: hoveredObject,
                            setHoveredObject: setHoveredObject,
                            selectedObjects: selectedObjects,
                            toggleObjectState: toggleObjectState,
                            hoveredBox: hoveredBox
                        }),
                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $292490abf81ee043$export$2e2bcd8739ae039), {
                            currentTab: currentTab,
                            setCurrentTab: setCurrentTab
                        }),
                        currentTab === 'Palettes' && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $0bb90831a4ba40e1$export$2e2bcd8739ae039), {
                            palette: room.palette,
                            onUpdate: updatePalette
                        }),
                        currentTab === 'Tilesets' && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $10324d8d3ba37348$export$2e2bcd8739ae039), {
                            baseTiles: baseTiles,
                            tileset: room.tileset,
                            nametable: room.nametable,
                            objectImages: room.objectImages,
                            roomgfc: roomgfc
                        }),
                        currentTab === 'Scripts' && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $05bec73d7eebcc36$export$2e2bcd8739ae039), {
                            excdScript: room.excdScript,
                            encdScript: room.encdScript
                        }),
                        currentTab === 'Object properties' && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $2af0afd349f9be9f$export$2e2bcd8739ae039), {
                            object: room.objects[inspectedObject]
                        })
                    ]
                })
            })
        ]
    });
};
var $84f162550428efeb$export$2e2bcd8739ae039 = $84f162550428efeb$var$RoomsContainer;





var $jrGSV = parcelRequire("jrGSV");
const $5f06442501db41c0$var$costumeNames = [
    [
        'Unused',
        'Syd',
        'Razor',
        'Dave',
        'Michael',
        'Bernard',
        'Wendy',
        'Jeff',
        'Radioactive suit',
        'Fred Edison',
        'Nurse Edna',
        'Weird Ed',
        'Cousin Ted',
        'Purple tentacle',
        'Green tentacle',
        'Meteor police',
        'Meteor',
        'Mark Eteer',
        'Wink Smiley',
        'Man eating plant',
        'Bubble',
        'Unused',
        'Unused',
        'Sandy',
        'Suit w/ meteor'
    ],
    [
        'Flying Edsel',
        'Meteor intro',
        'Cursor arrow',
        'Sprite0'
    ]
];
const $5f06442501db41c0$var$getCostumeLabel = (costumeSetId = 0, id = 0, long = false)=>{
    switch(localStorage.getItem('screen-name')){
        default:
        case 'mm':
            const costumeName = $5f06442501db41c0$var$costumeNames[costumeSetId][id];
            if (!costumeName) throw new Error(`Unknown costume id ${id} in costume set id ${costumeSetId}`);
            if (long) return `Costume ${(0, $jrGSV.zeroPad)(id)} - ${costumeName}`;
            return `${id} ${costumeName}`;
        case 'numbers':
            if (long) return `Costume ${(0, $jrGSV.zeroPad)(id)}`;
            return `Costume ${id}`;
    }
};
var $5f06442501db41c0$export$2e2bcd8739ae039 = $5f06442501db41c0$var$getCostumeLabel;







const $04b83394c25721c5$var$CostumesList = ({ costumeSets: costumeSets, currentSetId: currentSetId, currentId: currentId })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $97bca11ad51d3992$exports.Fragment), {
        children: costumeSets.map((costumeSet, costumeSetId)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $0f62127f10c56af6$export$2e2bcd8739ae039), {
                        children: [
                            "Costume set ",
                            costumeSetId
                        ]
                    }),
                    costumeSet.map((unused, id)=>{
                        const selected = costumeSetId === currentSetId && id === currentId;
                        const path = `/costumes/${costumeSetId}/${id}`;
                        const label = (0, $5f06442501db41c0$export$2e2bcd8739ae039)(costumeSetId, id);
                        return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $544d1fbe23ef0f14$export$2e2bcd8739ae039), {
                            path: selected ? null : path,
                            children: label
                        }, id);
                    })
                ]
            }, costumeSetId))
    });
};
var $04b83394c25721c5$export$2e2bcd8739ae039 = $04b83394c25721c5$var$CostumesList;







var $l7WPE = parcelRequire("l7WPE");


// Display a costume on a canvas.
// prettier-ignore
const $062a53e60acaca90$var$darkpalette = [
    0x2d,
    0x1d,
    0x2d,
    0x3d,
    0x2d,
    0x1d,
    0x2d,
    0x3d,
    0x2d,
    0x1d,
    0x2d,
    0x3d,
    0x2d,
    0x1d,
    0x2d,
    0x3d
];
const $062a53e60acaca90$var$CostumeCanvasContainer = ({ id: id, frame: frame, gfx: gfx, sprdesc: sprdesc, sproffs: sproffs, sprlens: sprlens, sprdata: sprdata, sprpals: sprpals, zoom: zoom = 1 })=>{
    const canvasRef = (0, $l7WPE.useRef)(null);
    const [isComputing, setIsComputing] = (0, $l7WPE.useState)(true);
    const desc = sprdesc[id];
    // this was 3 bytes per sprite in the data but has been parsed down to 1 byte
    const offset = sproffs[desc + frame] / 3;
    const spritesNum = sprlens[desc + frame];
    const palette = sprpals.palette;
    // Compute the bounding box.
    let left = 239;
    let right = 0;
    let top = 239;
    let bottom = 0;
    for(let i = 0; i < spritesNum; i++){
        const { x: x, y: y } = sprdata[offset + i];
        left = Math.min(left, x);
        right = Math.max(right, x + 8);
        top = Math.min(top, y);
        bottom = Math.max(bottom, y + 8);
    }
    const width = right - left;
    const height = bottom - top;
    (0, $l7WPE.useEffect)(()=>{
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        setTimeout(()=>{
            $062a53e60acaca90$var$draw(ctx, gfx.gfx, sprdata, offset, spritesNum, palette, left, top, width, height);
            setIsComputing(false);
        });
    }, [
        frame,
        gfx,
        sprdata,
        offset,
        spritesNum,
        palette,
        left,
        top,
        width,
        height
    ]);
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("canvas", {
        ref: canvasRef,
        width: width,
        height: height,
        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('rounded', isComputing ? 'opacity-0' : 'opacity-100 transition-opacity'),
        style: {
            width: width * zoom,
            height: height * zoom
        }
    });
};
const $062a53e60acaca90$var$draw = (ctx, gfx, sprdata, offset, spritesNum, palette, left, top, width, height)=>{
    // Clear the canvas.
    ctx.fillStyle = 'lightgrey';
    ctx.fillRect(0, 0, width, height);
    for(let i = 0; i < spritesNum; i++){
        const { x: x, y: y, tile: tile, flip: flip, paletteId: paletteId } = sprdata[offset + i];
        const pal = (0, $81be0fdaa3a8023c$export$747ccad006a63299)([
            palette[paletteId],
            palette[paletteId + 1],
            palette[paletteId + 2],
            palette[paletteId + 3]
        ]);
        for(let j = 0; j < 8; j++){
            const n1 = gfx[tile * 16 + j];
            const n2 = gfx[(tile * 2 + 1) * 8 + j];
            for(let k = 0; k < 8; k++){
                const mask = 1 << k;
                const val = (n1 & mask ? 1 : 0) | (n2 & mask ? 1 : 0) << 1;
                // Skip the transparent palette colour.
                if (val === 0) continue;
                ctx.fillStyle = pal[val];
                if (flip) ctx.fillRect(k + x - left, j + y - top, 1, 1);
                else ctx.fillRect(7 - k + x - left, j + y - top, 1, 1);
            }
        }
    }
};
var $062a53e60acaca90$export$2e2bcd8739ae039 = $062a53e60acaca90$var$CostumeCanvasContainer;


// @todo Parse it from 3DAED-3DB05 instead of hardcoding.
// prettier-ignore
const $099541d5aeda87db$var$costumeIdLookupTable = [
    0x00,
    0x03,
    0x01,
    0x06,
    0x08,
    0x02,
    0x00,
    0x07,
    0x0c,
    0x04,
    0x09,
    0x0a,
    0x12,
    0x0b,
    0x14,
    0x0d,
    0x11,
    0x0f,
    0x0e,
    0x10,
    0x17,
    0x00,
    0x01,
    0x05,
    0x16
];
const $099541d5aeda87db$var$CostumesContainer = ({ costumegfx: costumegfx, costumes: costumes, sprpals: sprpals, sprdesc: sprdesc, sproffs: sproffs, sprlens: sprlens, sprdata: sprdata })=>{
    const { setId: setId, id: id } = (0, $e8d0e236465e8031$export$99eaa27ddbbb95ef)();
    const currentSetId = typeof setId === 'undefined' ? null : parseInt(setId, 10);
    const currentId = typeof id === 'undefined' ? null : parseInt(id, 10);
    // Used for the side navbar:
    // * Costume set 0 has 25 costumes (hardcoded value?).
    // * Costume set 1 has as many costumes as entries in the corresponding sprdesc.
    const costumeSets = [
        Array($099541d5aeda87db$var$costumeIdLookupTable.length).fill(0),
        sprdesc[1].sprdesc
    ];
    const costume = costumes.find(({ metadata: metadata })=>metadata.id === currentId) || null;
    const costumeId = currentSetId === 0 ? $099541d5aeda87db$var$costumeIdLookupTable[currentId] : currentId;
    const getFramesNumbersFromCostumeId = (costumeId = 0)=>{
        if (costumeId === sprdesc[currentSetId].sprdesc.length - 1) // @todo Find a better way than hardcoding it.
        return currentSetId === 0 ? 2 : 1;
        return sprdesc[currentSetId].sprdesc[costumeId + 1] - sprdesc[currentSetId].sprdesc[costumeId];
    };
    const frameNum = getFramesNumbersFromCostumeId(costumeId);
    if (!costume) return null;
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $307bcb5ed139e868$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $04b83394c25721c5$export$2e2bcd8739ae039), {
                    costumeSets: costumeSets,
                    currentSetId: currentSetId,
                    currentId: currentId
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $77f5f4efaf83b50c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $067de7175cda56e8$export$2e2bcd8739ae039), {
                        title: (0, $5f06442501db41c0$export$2e2bcd8739ae039)(currentSetId, currentId, true),
                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b1704ccebb1bcb93$export$2e2bcd8739ae039), {
                            metadata: costume.metadata
                        })
                    }),
                    currentSetId === 0 ? /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                        className: "space-y-4",
                        children: costume.costumes.map((animation, i)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("h2", {
                                        className: "mb-1 text-sm font-semibold text-slate-700 md:text-base dark:text-slate-300",
                                        children: [
                                            "Animation ",
                                            i
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                                        className: "flex flex-row flex-wrap gap-4",
                                        children: animation.map((frame, key)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $062a53e60acaca90$export$2e2bcd8739ae039), {
                                                id: costumeId,
                                                frame: frame,
                                                gfx: costumegfx[currentSetId],
                                                sprdesc: sprdesc[currentSetId].sprdesc,
                                                sproffs: sproffs[currentSetId].sproffs,
                                                sprlens: sprlens[currentSetId].sprlens,
                                                sprdata: sprdata[currentSetId].sprdata,
                                                sprpals: sprpals[currentSetId],
                                                zoom: 2
                                            }, key))
                                    })
                                ]
                            }, i))
                    }) : /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                        className: "flex flex-row flex-wrap gap-4",
                        children: Array(frameNum).fill().map((unused, frame)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $062a53e60acaca90$export$2e2bcd8739ae039), {
                                id: costumeId,
                                frame: frame,
                                gfx: costumegfx[currentSetId],
                                sprdesc: sprdesc[currentSetId].sprdesc,
                                sproffs: sproffs[currentSetId].sproffs,
                                sprlens: sprlens[currentSetId].sprlens,
                                sprdata: sprdata[currentSetId].sprdata,
                                sprpals: sprpals[currentSetId],
                                zoom: 2
                            }, frame))
                    })
                ]
            })
        ]
    });
};
var $099541d5aeda87db$export$2e2bcd8739ae039 = $099541d5aeda87db$var$CostumesContainer;








const $b02402f9afe4a850$var$TitleGfxList = ({ gfx: gfx, currentId: currentId })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $0f62127f10c56af6$export$2e2bcd8739ae039), {
                children: "Title gfx"
            }),
            gfx.map(({ metadata: metadata })=>{
                const selected = metadata.id === currentId;
                const path = `/titlegfx/${metadata.id}`;
                const label = `Tileset ${metadata.id}`;
                return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $544d1fbe23ef0f14$export$2e2bcd8739ae039), {
                    path: selected ? null : path,
                    children: label
                }, metadata.id);
            })
        ]
    });
};
var $b02402f9afe4a850$export$2e2bcd8739ae039 = $b02402f9afe4a850$var$TitleGfxList;





const $97660955bf29be46$var$CostumeGfxList = ({ gfx: gfx, currentId: currentId })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $0f62127f10c56af6$export$2e2bcd8739ae039), {
                children: "Costume gfx"
            }),
            gfx.map(({ metadata: metadata })=>{
                const selected = metadata.id === currentId;
                const path = `/costumegfx/${metadata.id}`;
                const label = `Tileset ${metadata.id}`;
                return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $544d1fbe23ef0f14$export$2e2bcd8739ae039), {
                    path: selected ? null : path,
                    children: label
                }, metadata.id);
            })
        ]
    });
};
var $97660955bf29be46$export$2e2bcd8739ae039 = $97660955bf29be46$var$CostumeGfxList;





const $7134000cd420620f$var$RoomGfxList = ({ gfx: gfx, currentId: currentId })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $0f62127f10c56af6$export$2e2bcd8739ae039), {
                children: "Room gfx"
            }),
            gfx.map(({ metadata: metadata })=>{
                const selected = metadata.id === currentId;
                const path = `/roomgfx/${metadata.id}`;
                const label = `Tileset ${metadata.id}`;
                return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $544d1fbe23ef0f14$export$2e2bcd8739ae039), {
                    path: selected ? null : path,
                    children: label
                }, metadata.id);
            })
        ]
    });
};
var $7134000cd420620f$export$2e2bcd8739ae039 = $7134000cd420620f$var$RoomGfxList;






const $b4c5160b9dffa8d7$var$GfxContainer = ({ titlegfx: titlegfx, costumegfx: costumegfx, roomgfx: roomgfx })=>{
    const isTitleGfx = !!(0, $e8d0e236465e8031$export$6c330e8992e8a295)('/titlegfx/:id');
    const isCostumeGfx = !!(0, $e8d0e236465e8031$export$6c330e8992e8a295)('/costumegfx/:id');
    const isRoomGfx = !!(0, $e8d0e236465e8031$export$6c330e8992e8a295)('/roomgfx/:id');
    const { id: id } = (0, $e8d0e236465e8031$export$99eaa27ddbbb95ef)();
    const currentId = typeof id === 'undefined' ? null : parseInt(id, 10);
    const gfc = isTitleGfx ? titlegfx[currentId] : isCostumeGfx ? costumegfx[currentId] : roomgfx[currentId];
    if (!gfc) return null;
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $307bcb5ed139e868$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b02402f9afe4a850$export$2e2bcd8739ae039), {
                        gfx: titlegfx,
                        currentId: isTitleGfx ? currentId : null
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $97660955bf29be46$export$2e2bcd8739ae039), {
                        gfx: costumegfx,
                        currentId: isCostumeGfx ? currentId : null
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $7134000cd420620f$export$2e2bcd8739ae039), {
                        gfx: roomgfx,
                        currentId: isRoomGfx ? currentId : null
                    })
                ]
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $77f5f4efaf83b50c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $067de7175cda56e8$export$2e2bcd8739ae039), {
                        title: currentId === null ? 'Graphics' : isTitleGfx ? `Title graphics tileset ${currentId}` : isCostumeGfx ? `Costume graphics tileset ${currentId}` : `Room graphics tileset ${currentId}`,
                        children: currentId !== null && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b1704ccebb1bcb93$export$2e2bcd8739ae039), {
                            metadata: gfc.metadata
                        })
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $1d8e3e03348bf685$export$2e2bcd8739ae039), {
                        gfx: gfc.gfx,
                        zoom: 3
                    })
                ]
            })
        ]
    });
};
var $b4c5160b9dffa8d7$export$2e2bcd8739ae039 = $b4c5160b9dffa8d7$var$GfxContainer;







const $fd2454d1ef16144a$var$PrepositionsList = ({ preps: preps, lang: lang })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $0f62127f10c56af6$export$2e2bcd8739ae039), {
                children: "Prepositions"
            }),
            preps.preps.map((prep, id)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $544d1fbe23ef0f14$export$2e2bcd8739ae039), {
                    lang: lang,
                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("q", {
                        children: prep
                    })
                }, id))
        ]
    });
};
var $fd2454d1ef16144a$export$2e2bcd8739ae039 = $fd2454d1ef16144a$var$PrepositionsList;





const $1c55692d1a395796$var$PrepositionsContainer = ({ preps: preps, lang: lang })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $307bcb5ed139e868$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $fd2454d1ef16144a$export$2e2bcd8739ae039), {
                    preps: preps,
                    lang: lang
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $77f5f4efaf83b50c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $067de7175cda56e8$export$2e2bcd8739ae039), {
                    title: "Prepositions",
                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b1704ccebb1bcb93$export$2e2bcd8739ae039), {
                        metadata: preps.metadata
                    })
                })
            })
        ]
    });
};
var $1c55692d1a395796$export$2e2bcd8739ae039 = $1c55692d1a395796$var$PrepositionsContainer;








var $l7WPE = parcelRequire("l7WPE");

const $f0bc58466b592f2d$export$7c48ccc23e1227d5 = (rom, res)=>{
    const paddingSize = $f0bc58466b592f2d$var$getPaddingSize(rom);
    const romSize = rom.byteLength;
    const entries = [];
    let nonResourceSize = romSize;
    Object.entries(res).forEach(([label, resource])=>{
        if (!Array.isArray(resource)) return;
        const size = resource.reduce((a, b)=>a + b[1], 0);
        const percentage = size / romSize;
        entries.push({
            label: label,
            size: size,
            percentage: percentage
        });
        nonResourceSize -= size;
    });
    entries.push({
        label: 'padding',
        size: paddingSize,
        percentage: paddingSize / romSize
    });
    entries.push({
        label: 'other',
        size: nonResourceSize - paddingSize,
        percentage: (nonResourceSize - paddingSize) / romSize
    });
    entries.sort((a, b)=>b.size - a.size);
    return entries;
};
// @todo Exclude the resources here.
const $f0bc58466b592f2d$var$getPaddingSize = (rom)=>{
    const view = new DataView(rom);
    let paddingSize = 0;
    for(let j = 0; j < rom.byteLength; j += 4)if (view.getUint8(j) === 0xff && view.getUint8(j + 1) === 0xff && view.getUint8(j + 2) === 0xff && view.getUint8(j + 3) === 0xff) paddingSize += 4;
    return paddingSize;
};
// Returns a colour string to be displayed in a range.
const $f0bc58466b592f2d$export$ff9254038623888e = (step = 0, steps = 0)=>`oklch(${60 + (step % 2 ? 0 : 30)}% ${0.15 + (step % 2 ? 0.05 : 0)} ${360 / steps * step})`;


const $bb2d3c518a403db4$var$WIDTH = 512;
const $bb2d3c518a403db4$var$HEIGHT = 512;
const $bb2d3c518a403db4$var$RomMapCanvasContainer = ({ rom: rom, res: res, resourceList: resourceList })=>{
    const canvasRef = (0, $l7WPE.useRef)(null);
    const [isComputing, setIsComputing] = (0, $l7WPE.useState)(true);
    (0, $l7WPE.useEffect)(()=>{
        setIsComputing(true);
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        setTimeout(()=>{
            $bb2d3c518a403db4$var$draw(ctx, rom, res, resourceList);
            setIsComputing(false);
        });
    }, [
        rom,
        res,
        resourceList
    ]);
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("canvas", {
        ref: canvasRef,
        width: $bb2d3c518a403db4$var$WIDTH,
        height: $bb2d3c518a403db4$var$HEIGHT,
        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('aspect-[4/3] w-full rounded border border-slate-600 dark:border-slate-400', isComputing ? 'opacity-0' : 'opacity-100 transition-opacity'),
        style: {
            maxWidth: $bb2d3c518a403db4$var$WIDTH
        }
    });
};
const $bb2d3c518a403db4$var$draw = (ctx, rom, res, resourceList)=>{
    // Let's start by filling the canvas with the colour for 'other'.
    const otherColour = resourceList.indexOf('other');
    ctx.fillStyle = (0, $f0bc58466b592f2d$export$ff9254038623888e)(otherColour, resourceList.length);
    ctx.fillRect(0, 0, $bb2d3c518a403db4$var$WIDTH, $bb2d3c518a403db4$var$HEIGHT);
    // Mark padding (4 consecutive bytes of 0xff).
    const view = new DataView(rom);
    const paddingColour = resourceList.indexOf('padding');
    ctx.fillStyle = (0, $f0bc58466b592f2d$export$ff9254038623888e)(paddingColour, resourceList.length);
    for(let j = 0; j < rom.byteLength; j += 4)if (view.getUint8(j) === 0xff && view.getUint8(j + 1) === 0xff && view.getUint8(j + 2) === 0xff && view.getUint8(j + 3) === 0xff) {
        ctx.fillRect(j % $bb2d3c518a403db4$var$WIDTH, Math.floor(j / $bb2d3c518a403db4$var$WIDTH), 1, 1);
        ctx.fillRect((j + 1) % $bb2d3c518a403db4$var$WIDTH, Math.floor((j + 1) / $bb2d3c518a403db4$var$WIDTH), 1, 1);
        ctx.fillRect((j + 2) % $bb2d3c518a403db4$var$WIDTH, Math.floor((j + 2) / $bb2d3c518a403db4$var$WIDTH), 1, 1);
        ctx.fillRect((j + 3) % $bb2d3c518a403db4$var$WIDTH, Math.floor((j + 3) / $bb2d3c518a403db4$var$WIDTH), 1, 1);
    }
    resourceList// Remove pseudo-resources like 'other' or 'padding'.
    .filter((label)=>res[label]).forEach((label)=>{
        const resource = res[label];
        const colour = resourceList.indexOf(label);
        ctx.fillStyle = (0, $f0bc58466b592f2d$export$ff9254038623888e)(colour, resourceList.length);
        for(let i = 0; i < resource.length; i++){
            const [offset, length] = resource[i];
            for(let j = offset; j < offset + length; j++)ctx.fillRect(j % $bb2d3c518a403db4$var$WIDTH, Math.floor(j / $bb2d3c518a403db4$var$WIDTH), 1, 1);
        }
    });
};
var $bb2d3c518a403db4$export$2e2bcd8739ae039 = $bb2d3c518a403db4$var$RomMapCanvasContainer;





const $b8ef438c2b1f71eb$var$RomMapCaption = ({ resourceList: resourceList })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("dl", {
        className: "md:max-w-auto flex w-[512] max-w-full flex-wrap justify-between gap-4 text-xs md:w-auto md:flex-col md:text-sm",
        children: resourceList.map((label, i)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                className: "flex-no-wrap flex gap-x-2",
                children: [
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("dt", {
                        className: "h-6",
                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b46e95d155ca029d$export$2e2bcd8739ae039), {
                            colour: (0, $f0bc58466b592f2d$export$ff9254038623888e)(i, resourceList.length)
                        })
                    }),
                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("dd", {
                        className: "first-letter:capitalize",
                        children: label
                    })
                ]
            }, i))
    });
};
var $b8ef438c2b1f71eb$export$2e2bcd8739ae039 = $b8ef438c2b1f71eb$var$RomMapCaption;


const $768273e014d31fba$var$RomMap = ({ rom: rom, res: res, resourceList: resourceList })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
        className: "space-y-4 md:flex md:gap-5 md:space-y-0 xl:gap-6",
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $bb2d3c518a403db4$export$2e2bcd8739ae039), {
                rom: rom,
                res: res,
                resourceList: resourceList
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b8ef438c2b1f71eb$export$2e2bcd8739ae039), {
                resourceList: resourceList
            })
        ]
    });
};
var $768273e014d31fba$export$2e2bcd8739ae039 = $768273e014d31fba$var$RomMap;




var $jrGSV = parcelRequire("jrGSV");
const $630e866d9ad4c8bc$var$RomMapTable = ({ resourceSizes: resourceSizes })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("section", {
        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("table", {
            className: "w-[512] max-w-full table-auto text-xs text-slate-900 md:text-sm dark:text-slate-100",
            children: [
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("tr", {
                        className: "bg-slate-300 text-sm md:text-base dark:bg-slate-700",
                        children: [
                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("th", {
                                className: "px-4 py-1 text-left font-normal",
                                children: "Resource"
                            }),
                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("th", {
                                className: "px-4 py-1 text-right font-normal",
                                children: "Size"
                            }),
                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("th", {
                                className: "px-4 py-1 text-right font-normal",
                                children: "%"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("tbody", {
                    children: resourceSizes.map(({ label: label, size: size, percentage: percentage })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("tr", {
                            className: "even:bg-slate-200 even:dark:bg-slate-800",
                            children: [
                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("td", {
                                    className: "px-4 first-letter:capitalize",
                                    children: label
                                }),
                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("td", {
                                    className: "whitespace-nowrap px-4 py-1 text-right",
                                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                        className: "font-monocode",
                                        children: (0, $jrGSV.formatBytes)(size)
                                    })
                                }),
                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("td", {
                                    className: "whitespace-nowrap px-4 py-1 text-right",
                                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                        className: "font-monocode",
                                        children: (0, $jrGSV.formatPercentage)(percentage)
                                    })
                                })
                            ]
                        }, label))
                })
            ]
        })
    });
};
var $630e866d9ad4c8bc$export$2e2bcd8739ae039 = $630e866d9ad4c8bc$var$RomMapTable;



const $b8f95dd68eb0b444$var$RESOURCES_NUMBER_IN_GRAPH = 8;
const $b8f95dd68eb0b444$var$RomMapContainer = ({ rom: rom, res: res })=>{
    const resourceSizes = (0, $f0bc58466b592f2d$export$7c48ccc23e1227d5)(rom, res);
    const resourceList = resourceSizes.slice(0, $b8f95dd68eb0b444$var$RESOURCES_NUMBER_IN_GRAPH).map(({ label: label })=>label);
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $77f5f4efaf83b50c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $067de7175cda56e8$export$2e2bcd8739ae039), {
                title: "ROM Map"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $768273e014d31fba$export$2e2bcd8739ae039), {
                rom: rom,
                res: res,
                resourceList: resourceList
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $630e866d9ad4c8bc$export$2e2bcd8739ae039), {
                resourceSizes: resourceSizes
            })
        ]
    });
};
var $b8f95dd68eb0b444$export$2e2bcd8739ae039 = $b8f95dd68eb0b444$var$RomMapContainer;




var $l7WPE = parcelRequire("l7WPE");












const $bc4beef110a6811a$var$TitlesContainer = ({ rooms: rooms, titles: titles })=>{
    const dispatch = (0, $289dddd4090929de$export$181baa7312ee9507)();
    const { id: id } = (0, $e8d0e236465e8031$export$99eaa27ddbbb95ef)();
    const [currentTab, setCurrentTab] = (0, $l7WPE.useState)('Palettes');
    const [title, setTitle] = (0, $l7WPE.useState)(null);
    const zoom = 2;
    const currentId = typeof id === 'undefined' ? null : parseInt(id, 10);
    (0, $l7WPE.useEffect)(()=>{
        const title = titles[id];
        // Hack: so it has the same shape than rooms.
        title.header = {
            width: title.width,
            height: title.height
        };
        setTitle(title);
    }, [
        id,
        titles
    ]);
    const updatePalette = (i, colourId)=>{
        const newPalette = structuredClone(title.palette);
        if (i % 4 === 0) // Keep the first colours in sync.
        for(let i = 0; i < 16; i += 4)newPalette[i] = colourId;
        else newPalette[i] = colourId;
        dispatch({
            type: 'changed-palette',
            screenType: 'title',
            id: currentId,
            palette: newPalette
        });
    };
    if (!title) return null;
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $307bcb5ed139e868$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $8984ea72c3681412$export$2e2bcd8739ae039), {
                    rooms: rooms,
                    titles: titles
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $77f5f4efaf83b50c$export$2e2bcd8739ae039), {
                children: !title ? /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h1", {
                    children: "Titles"
                }) : /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $067de7175cda56e8$export$2e2bcd8739ae039), {
                            title: (0, $5b4f9380c818b26a$export$2e2bcd8739ae039)('title', title.metadata.id, true),
                            children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b1704ccebb1bcb93$export$2e2bcd8739ae039), {
                                metadata: title.metadata
                            })
                        }),
                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $1caa0bc32675e0e4$export$2e2bcd8739ae039), {
                            screen: title,
                            gfc: {
                                gfx: title.gfx
                            },
                            crop: false,
                            zoom: zoom
                        }),
                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $292490abf81ee043$export$2e2bcd8739ae039), {
                            currentTab: currentTab,
                            setCurrentTab: setCurrentTab,
                            allowList: [
                                'Palettes',
                                'Tilesets'
                            ]
                        }),
                        currentTab === 'Palettes' && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $0bb90831a4ba40e1$export$2e2bcd8739ae039), {
                            palette: title.palette,
                            onUpdate: updatePalette
                        }),
                        currentTab === 'Tilesets' && /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $10324d8d3ba37348$export$2e2bcd8739ae039), {
                            baseTiles: {
                                gfx: []
                            },
                            tileset: id,
                            nametable: title.nametable,
                            objectImages: title.objectImages,
                            roomgfc: {
                                gfx: title.gfx
                            },
                            type: "title"
                        })
                    ]
                })
            })
        ]
    });
};
var $bc4beef110a6811a$export$2e2bcd8739ae039 = $bc4beef110a6811a$var$TitlesContainer;




var $l7WPE = parcelRequire("l7WPE");






var $l7WPE = parcelRequire("l7WPE");





var $l7WPE = parcelRequire("l7WPE");















"use client";
var $58e7477de80552cc$var$ke = ((e)=>(e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))($58e7477de80552cc$var$ke || {});
let $58e7477de80552cc$var$Fe = {
    [0] (o, t) {
        let e = [
            ...o.options,
            {
                id: t.id,
                element: t.element,
                propsRef: t.propsRef
            }
        ];
        return {
            ...o,
            options: (0, $c87ce7fcb4198fc6$export$20305e96f91bf103)(e, (a)=>a.element.current)
        };
    },
    [1] (o, t) {
        let e = o.options.slice(), a = o.options.findIndex((g)=>g.id === t.id);
        return a === -1 ? o : (e.splice(a, 1), {
            ...o,
            options: e
        });
    }
}, $58e7477de80552cc$var$J = (0, $l7WPE.createContext)(null);
$58e7477de80552cc$var$J.displayName = "RadioGroupDataContext";
function $58e7477de80552cc$var$X(o) {
    let t = (0, $l7WPE.useContext)($58e7477de80552cc$var$J);
    if (t === null) {
        let e = new Error(`<${o} /> is missing a parent <RadioGroup /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $58e7477de80552cc$var$X), e;
    }
    return t;
}
let $58e7477de80552cc$var$z = (0, $l7WPE.createContext)(null);
$58e7477de80552cc$var$z.displayName = "RadioGroupActionsContext";
function $58e7477de80552cc$var$q(o) {
    let t = (0, $l7WPE.useContext)($58e7477de80552cc$var$z);
    if (t === null) {
        let e = new Error(`<${o} /> is missing a parent <RadioGroup /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $58e7477de80552cc$var$q), e;
    }
    return t;
}
function $58e7477de80552cc$var$Ie(o, t) {
    return (0, $f191f2ad0684b169$export$4659b591c19bdf3d)(t.type, $58e7477de80552cc$var$Fe, o, t);
}
let $58e7477de80552cc$var$Ue = "div";
function $58e7477de80552cc$var$Me(o, t) {
    let e = (0, $l7WPE.useId)(), a = (0, $3ffab61d59a88c3c$export$c763bb7a184a0f11)(), { id: g = `headlessui-radiogroup-${e}`, value: R, form: O, name: n, onChange: f, by: c, disabled: p = a || !1, defaultValue: I, ...m } = o, T = (0, $23dae15276e93483$export$988f0cf1b37580ae)(c), [P, C] = (0, $l7WPE.useReducer)($58e7477de80552cc$var$Ie, {
        options: []
    }), i = P.options, [U, h] = (0, $cc31415baf6a16fd$export$d6875122194c7b44)(), [v, L] = (0, $892a159bd3b0d0c5$export$babde88292020af7)(), D = (0, $l7WPE.useRef)(null), M = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(D, t), l = (0, $3140c01a3fe83286$export$8a91ee242b6d0fe3)(I), [s, A] = (0, $288b02513317d536$export$454217e89aea72b)(R, f, l), S = (0, $l7WPE.useMemo)(()=>i.find((r)=>!r.propsRef.current.disabled), [
        i
    ]), y = (0, $l7WPE.useMemo)(()=>i.some((r)=>T(r.propsRef.current.value, s)), [
        i,
        s
    ]), d = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((r)=>{
        var u;
        if (p || T(r, s)) return !1;
        let k = (u = i.find((w)=>T(w.propsRef.current.value, r))) == null ? void 0 : u.propsRef.current;
        return k != null && k.disabled ? !1 : (A == null || A(r), !0);
    }), _ = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((r)=>{
        let k = D.current;
        if (!k) return;
        let u = (0, $be0aa046e776f98a$export$b204af158042fbac)(k), w = i.filter((b)=>b.propsRef.current.disabled === !1).map((b)=>b.element.current);
        switch(r.key){
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Enter:
                (0, $db207137356ac424$export$ee02894bdc79dd36)(r.currentTarget);
                break;
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).ArrowLeft:
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).ArrowUp:
                if (r.preventDefault(), r.stopPropagation(), (0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(w, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).Previous | (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).WrapAround) === (0, $c87ce7fcb4198fc6$export$abf286375dfa6dbd).Success) {
                    let E = i.find((W)=>W.element.current === (u == null ? void 0 : u.activeElement));
                    E && d(E.propsRef.current.value);
                }
                break;
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).ArrowRight:
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).ArrowDown:
                if (r.preventDefault(), r.stopPropagation(), (0, $c87ce7fcb4198fc6$export$82e1f4f412218a1d)(w, (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).Next | (0, $c87ce7fcb4198fc6$export$807a7eae502106e7).WrapAround) === (0, $c87ce7fcb4198fc6$export$abf286375dfa6dbd).Success) {
                    let E = i.find((W)=>W.element.current === (u == null ? void 0 : u.activeElement));
                    E && d(E.propsRef.current.value);
                }
                break;
            case (0, $612f52da01364eb3$export$4b0075e5ea5e1f26).Space:
                {
                    r.preventDefault(), r.stopPropagation();
                    let b = i.find((E)=>E.element.current === (u == null ? void 0 : u.activeElement));
                    b && d(b.propsRef.current.value);
                }
                break;
        }
    }), Q = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((r)=>(C({
            type: 0,
            ...r
        }), ()=>C({
                type: 1,
                id: r.id
            }))), ue = (0, $l7WPE.useMemo)(()=>({
            value: s,
            firstOption: S,
            containsCheckedOption: y,
            disabled: p,
            compare: T,
            ...P
        }), [
        s,
        S,
        y,
        p,
        T,
        P
    ]), ce = (0, $l7WPE.useMemo)(()=>({
            registerOption: Q,
            change: d
        }), [
        Q,
        d
    ]), fe = {
        ref: M,
        id: g,
        role: "radiogroup",
        "aria-labelledby": U,
        "aria-describedby": v,
        onKeyDown: _
    }, Te = (0, $l7WPE.useMemo)(()=>({
            value: s
        }), [
        s
    ]), Re = (0, $l7WPE.useCallback)(()=>{
        if (l !== void 0) return d(l);
    }, [
        d,
        l
    ]), me = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(L, {
        name: "RadioGroup.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(h, {
        name: "RadioGroup.Label"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($58e7477de80552cc$var$z.Provider, {
        value: ce
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement($58e7477de80552cc$var$J.Provider, {
        value: ue
    }, n != null && (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $bdaef70e9c6257b4$export$125d0b248abd3e88), {
        disabled: p,
        data: {
            [n]: s || "on"
        },
        overrides: {
            type: "radio",
            checked: s != null
        },
        form: O,
        onReset: Re
    }), me({
        ourProps: fe,
        theirProps: m,
        slot: Te,
        defaultTag: $58e7477de80552cc$var$Ue,
        name: "RadioGroup"
    })))));
}
let $58e7477de80552cc$var$Se = "div";
function $58e7477de80552cc$var$He(o, t) {
    var y;
    let e = $58e7477de80552cc$var$X("RadioGroup.Option"), a = $58e7477de80552cc$var$q("RadioGroup.Option"), g = (0, $l7WPE.useId)(), { id: R = `headlessui-radiogroup-option-${g}`, value: O, disabled: n = e.disabled || !1, autoFocus: f = !1, ...c } = o, p = (0, $l7WPE.useRef)(null), I = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(p, t), [m, T] = (0, $cc31415baf6a16fd$export$d6875122194c7b44)(), [P, C] = (0, $892a159bd3b0d0c5$export$babde88292020af7)(), i = (0, $7395d73fc6971264$export$86c4283a11f23f95)({
        value: O,
        disabled: n
    });
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>a.registerOption({
            id: R,
            element: p,
            propsRef: i
        }), [
        R,
        a,
        p,
        i
    ]);
    let U = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((d)=>{
        var _;
        if ((0, $b3d8f67cd937a9d4$export$db61f031a278447c)(d.currentTarget)) return d.preventDefault();
        a.change(O) && ((_ = p.current) == null || _.focus());
    }), h = ((y = e.firstOption) == null ? void 0 : y.id) === R, { isFocusVisible: v, focusProps: L } = (0, $445bbf4beaf356d1$export$4e328f61c538687f)({
        autoFocus: f
    }), { isHovered: D, hoverProps: M } = (0, $7c7777069b2743a0$export$ae780daf29e6d456)({
        isDisabled: n
    }), l = e.compare(e.value, O), s = (0, $30c8a076c23acfb8$export$9d1611c77c2fe928)({
        ref: I,
        id: R,
        role: "radio",
        "aria-checked": l ? "true" : "false",
        "aria-labelledby": m,
        "aria-describedby": P,
        "aria-disabled": n ? !0 : void 0,
        tabIndex: (()=>n ? -1 : l || !e.containsCheckedOption && h ? 0 : -1)(),
        onClick: n ? void 0 : U,
        autoFocus: f
    }, L, M), A = (0, $l7WPE.useMemo)(()=>({
            checked: l,
            disabled: n,
            active: v,
            hover: D,
            focus: v,
            autofocus: f
        }), [
        l,
        n,
        D,
        v,
        f
    ]), S = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(C, {
        name: "RadioGroup.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(T, {
        name: "RadioGroup.Label"
    }, S({
        ourProps: s,
        theirProps: c,
        slot: A,
        defaultTag: $58e7477de80552cc$var$Se,
        name: "RadioGroup.Option"
    })));
}
let $58e7477de80552cc$var$we = "span";
function $58e7477de80552cc$var$Ne(o, t) {
    var y;
    let e = $58e7477de80552cc$var$X("Radio"), a = $58e7477de80552cc$var$q("Radio"), g = (0, $l7WPE.useId)(), R = (0, $5055a520bd3df962$export$6ba3910d268310db)(), O = (0, $3ffab61d59a88c3c$export$c763bb7a184a0f11)(), { id: n = R || `headlessui-radio-${g}`, value: f, disabled: c = e.disabled || O || !1, autoFocus: p = !1, ...I } = o, m = (0, $l7WPE.useRef)(null), T = (0, $0da5c6e87036e5c9$export$f6a25a78204acc7e)(m, t), P = (0, $cc31415baf6a16fd$export$1f86aee6764cddb2)(), C = (0, $892a159bd3b0d0c5$export$899851af1363628)(), i = (0, $7395d73fc6971264$export$86c4283a11f23f95)({
        value: f,
        disabled: c
    });
    (0, $3bbdb114024fc011$export$ce5ed857c741fd71)(()=>a.registerOption({
            id: n,
            element: m,
            propsRef: i
        }), [
        n,
        a,
        m,
        i
    ]);
    let U = (0, $0d74b41fc1905bf3$export$90fc3a17d93f704c)((d)=>{
        var _;
        if ((0, $b3d8f67cd937a9d4$export$db61f031a278447c)(d.currentTarget)) return d.preventDefault();
        a.change(f) && ((_ = m.current) == null || _.focus());
    }), { isFocusVisible: h, focusProps: v } = (0, $445bbf4beaf356d1$export$4e328f61c538687f)({
        autoFocus: p
    }), { isHovered: L, hoverProps: D } = (0, $7c7777069b2743a0$export$ae780daf29e6d456)({
        isDisabled: c
    }), M = ((y = e.firstOption) == null ? void 0 : y.id) === n, l = e.compare(e.value, f), s = (0, $30c8a076c23acfb8$export$9d1611c77c2fe928)({
        ref: T,
        id: n,
        role: "radio",
        "aria-checked": l ? "true" : "false",
        "aria-labelledby": P,
        "aria-describedby": C,
        "aria-disabled": c ? !0 : void 0,
        tabIndex: (()=>c ? -1 : l || !e.containsCheckedOption && M ? 0 : -1)(),
        autoFocus: p,
        onClick: c ? void 0 : U
    }, v, D), A = (0, $l7WPE.useMemo)(()=>({
            checked: l,
            disabled: c,
            hover: L,
            focus: h,
            autofocus: p
        }), [
        l,
        c,
        L,
        h,
        p
    ]);
    return (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)()({
        ourProps: s,
        theirProps: I,
        slot: A,
        defaultTag: $58e7477de80552cc$var$we,
        name: "Radio"
    });
}
let $58e7477de80552cc$var$We = (0, $30c8a076c23acfb8$export$e43f39796049410c)($58e7477de80552cc$var$Me), $58e7477de80552cc$export$abc686c969439be2 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($58e7477de80552cc$var$He), $58e7477de80552cc$export$d7b12c4107be0d61 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($58e7477de80552cc$var$Ne), $58e7477de80552cc$export$6d06580bd6ecb283 = (0, $cc31415baf6a16fd$export$b04be29aa201d4f5), $58e7477de80552cc$export$169d4e7b5b3bd79 = (0, $892a159bd3b0d0c5$export$393edc798c47379d), $58e7477de80552cc$export$a98f0dcb43a68a25 = Object.assign($58e7477de80552cc$var$We, {
    Option: $58e7477de80552cc$export$abc686c969439be2,
    Radio: $58e7477de80552cc$export$d7b12c4107be0d61,
    Label: $58e7477de80552cc$export$6d06580bd6ecb283,
    Description: $58e7477de80552cc$export$169d4e7b5b3bd79
});



const $fde8b2c6568801b0$var$ThemeSwitcher = ({ theme: theme, setTheme: setTheme, themeOptions: themeOptions })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h2", {
                className: "text-xl font-semibold leading-6 text-slate-700 md:text-2xl dark:text-slate-300",
                children: "Colour theme"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $58e7477de80552cc$export$a98f0dcb43a68a25), {
                value: theme,
                onChange: setTheme,
                className: "flex gap-4 pl-8 md:gap-5 xl:gap-6",
                children: themeOptions.map((option)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $58e7477de80552cc$export$a98f0dcb43a68a25).Option, {
                        value: option,
                        className: ({ focus: focus, checked: checked })=>(0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('cursor-pointer focus:outline-none', 'flex w-48 max-w-48 flex-initial items-center justify-center rounded-md px-3 py-3 text-sm font-medium sm:flex-1', focus && 'ring-2 ring-primary-600 ring-offset-2', checked ? 'bg-primary-600 text-slate-100' : 'bg-slate-200 text-slate-900 ring-1 ring-inset ring-slate-300 hover:bg-slate-200/50 dark:bg-slate-800 dark:text-slate-100 dark:ring-slate-700 hover:dark:bg-slate-800/50'),
                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $cc31415baf6a16fd$export$b04be29aa201d4f5), {
                            as: "span",
                            children: option.name
                        })
                    }, option.name))
            })
        ]
    });
};
var $fde8b2c6568801b0$export$2e2bcd8739ae039 = $fde8b2c6568801b0$var$ThemeSwitcher;





var $l7WPE = parcelRequire("l7WPE");
function $4dcbaa6edd0a7bfa$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $l7WPE.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $l7WPE.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $l7WPE.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
        clipRule: "evenodd"
    }));
}
const $4dcbaa6edd0a7bfa$var$ForwardRef = /*#__PURE__*/ $l7WPE.forwardRef($4dcbaa6edd0a7bfa$var$CheckCircleIcon);
var $4dcbaa6edd0a7bfa$export$2e2bcd8739ae039 = $4dcbaa6edd0a7bfa$var$ForwardRef;



const $055e468c89e43970$var$PaletteSelector = ({ palette: palette, paletteOptions: paletteOptions, setPalette: setPalette })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h2", {
                className: "text-xl font-semibold leading-6 text-slate-700 md:text-2xl dark:text-slate-300",
                children: "NES palette"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $58e7477de80552cc$export$a98f0dcb43a68a25), {
                value: palette,
                onChange: setPalette,
                className: "flex flex-wrap gap-4 pl-8 md:gap-5 xl:gap-6",
                children: paletteOptions.map((option)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $58e7477de80552cc$export$a98f0dcb43a68a25).Option, {
                        value: option,
                        className: ({ focus: focus, checked: checked })=>(0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('relative flex cursor-pointer flex-col gap-4 rounded-lg border bg-slate-200 p-4 text-slate-900 shadow-sm focus:outline-none dark:bg-slate-800 dark:text-slate-100', focus ? 'border-primary-600 ring-2 ring-primary-600' : 'border-slate-300 dark:border-slate-700', !checked ? 'hover:bg-slate-200/50 hover:dark:bg-slate-800/50' : ''),
                        children: ({ focus: focus, checked: checked })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("span", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                                className: "flex flex-1",
                                                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("span", {
                                                    className: "flex flex-col gap-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $cc31415baf6a16fd$export$b04be29aa201d4f5), {
                                                            as: "span",
                                                            className: "flex gap-1 text-sm font-medium leading-5 text-slate-900 dark:text-slate-100",
                                                            children: [
                                                                option.name,
                                                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    viewBox: "0 0 24 24",
                                                                    strokeWidth: "1.5",
                                                                    stroke: "currentColor",
                                                                    fill: "none",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round",
                                                                    className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(option.experimental ? '' : 'invisible', 'size-5 text-slate-500 dark:text-slate-500'),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("path", {
                                                                            d: "M18.5 15L5.5 15"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("path", {
                                                                            d: "M16 4L8 4"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("path", {
                                                                            d: "M9 4.5L9 10.2602C9 10.7376 8.82922 11.1992 8.51851 11.5617L3.48149 17.4383C3.17078 17.8008 3 18.2624 3 18.7398V19C3 20.1046 3.89543 21 5 21L19 21C20.1046 21 21 20.1046 21 19V18.7398C21 18.2624 20.8292 17.8008 20.5185 17.4383L15.4815 11.5617C15.1708 11.1992 15 10.7376 15 10.2602L15 4.5"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("path", {
                                                                            d: "M12 9.01L12.01 8.99889"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("path", {
                                                                            d: "M11 2.01L11.01 1.99889"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $892a159bd3b0d0c5$export$393edc798c47379d), {
                                                            as: "span",
                                                            className: "text-sm text-slate-500",
                                                            children: option.description
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $4dcbaa6edd0a7bfa$export$2e2bcd8739ae039), {
                                                className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)(!checked ? 'invisible' : '', 'size-5 text-primary-600'),
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $892a159bd3b0d0c5$export$393edc798c47379d), {
                                        as: "span",
                                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("img", {
                                            src: option.img,
                                            className: "w-48 rounded",
                                            alt: `Preview of a room with palette ${option.name}.`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                        className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('pointer-events-none absolute -inset-px rounded-lg', focus ? 'border' : 'border-2', checked ? 'border-primary-600' : 'border-transparent'),
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                    }, option.name))
            })
        ]
    });
};
var $055e468c89e43970$export$2e2bcd8739ae039 = $055e468c89e43970$var$PaletteSelector;




var $l7WPE = parcelRequire("l7WPE");

var $l7WPE = parcelRequire("l7WPE");

var $l7WPE = parcelRequire("l7WPE");






"use client";
let $cd1eeaf107e06abe$var$_ = "div";
function $cd1eeaf107e06abe$var$c(d, l) {
    let t = `headlessui-control-${(0, $l7WPE.useId)()}`, [s, p] = (0, $cc31415baf6a16fd$export$d6875122194c7b44)(), [n, a] = (0, $892a159bd3b0d0c5$export$babde88292020af7)(), m = (0, $3ffab61d59a88c3c$export$c763bb7a184a0f11)(), { disabled: e = m || !1, ...i } = d, o = (0, $l7WPE.useMemo)(()=>({
            disabled: e
        }), [
        e
    ]), F = {
        ref: l,
        disabled: e || void 0,
        "aria-disabled": e || void 0
    }, T = (0, $30c8a076c23acfb8$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $3ffab61d59a88c3c$export$a4d3bd77f4efe5ad), {
        value: e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(p, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement(a, {
        value: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $5055a520bd3df962$export$6be90bcb437e928f), {
        id: t
    }, T({
        ourProps: F,
        theirProps: {
            ...i,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($l7WPE))).createElement((0, $bdaef70e9c6257b4$export$172bce5caea3d96f), null, typeof i.children == "function" ? i.children(o) : i.children)
        },
        slot: o,
        defaultTag: $cd1eeaf107e06abe$var$_,
        name: "Field"
    })))));
}
let $cd1eeaf107e06abe$export$a455218a85c89869 = (0, $30c8a076c23acfb8$export$e43f39796049410c)($cd1eeaf107e06abe$var$c);



const $d5d5d2c7c78f4896$var$ScreenNamesSelector = ({ screenName: screenName, screenNameOptions: screenNameOptions, setScreenName: setScreenName })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h2", {
                className: "text-xl font-semibold leading-6 text-slate-700 md:text-2xl dark:text-slate-300",
                children: "Resource naming scheme"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $58e7477de80552cc$export$a98f0dcb43a68a25), {
                value: screenName,
                onChange: setScreenName,
                className: "flex flex-col gap-5 pl-8",
                children: screenNameOptions.map((option)=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $cd1eeaf107e06abe$export$a455218a85c89869), {
                        className: "flex items-center gap-1",
                        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $58e7477de80552cc$export$d7b12c4107be0d61), {
                            value: option,
                            as: (0, $l7WPE.Fragment),
                            children: ({ focus: focus, checked: checked })=>/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                                    className: "flex outline-none",
                                    children: [
                                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                                            className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('group flex size-4 cursor-pointer items-center justify-center rounded-full border', focus && 'ring-2 ring-primary-600 ring-offset-1', !checked ? 'bg-slate-200 hover:bg-slate-100 hover:dark:bg-slate-100' : 'bg-primary-600'),
                                            children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("span", {
                                                className: (0, $ffbe6821f5cb54f6$export$4f5d2d50c9deca37)('size-1.5 rounded-full bg-slate-200', !checked ? 'invisible' : 'visible')
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)("div", {
                                            className: "ml-3 text-sm leading-6",
                                            children: [
                                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $cc31415baf6a16fd$export$b04be29aa201d4f5), {
                                                    as: "p",
                                                    className: "font-medium leading-5 text-slate-900 dark:text-slate-100",
                                                    children: option.name
                                                }),
                                                /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $892a159bd3b0d0c5$export$393edc798c47379d), {
                                                    as: "p",
                                                    className: "text-slate-500",
                                                    children: option.description
                                                })
                                            ]
                                        })
                                    ]
                                })
                        })
                    }, option.value))
            })
        ]
    });
};
var $d5d5d2c7c78f4896$export$2e2bcd8739ae039 = $d5d5d2c7c78f4896$var$ScreenNamesSelector;


const $77d28a6bb413df22$var$mediaQuery = window.matchMedia('(prefers-color-scheme:dark)');
const $77d28a6bb413df22$var$mediaQueryEventListener = (event)=>{
    $77d28a6bb413df22$var$addColourThemeClass(event.matches ? 'dark' : 'light');
};
// Set the `dark` or `light` class name on the <html> tag.
const $77d28a6bb413df22$var$addColourThemeClass = (theme)=>{
    document.documentElement.classList.remove('dark', 'light');
    document.documentElement.classList.add(theme);
};
// Sets the colour theme, and update the DOM accordingly.
// If no theme is set, listens to changes in the system theme.
const $77d28a6bb413df22$export$41b4f27aaec43e22 = (theme = null)=>{
    $77d28a6bb413df22$var$mediaQuery.removeEventListener('change', $77d28a6bb413df22$var$mediaQueryEventListener);
    if (!theme) {
        $77d28a6bb413df22$var$mediaQuery.addEventListener('change', $77d28a6bb413df22$var$mediaQueryEventListener);
        theme = $77d28a6bb413df22$var$mediaQuery.matches ? 'dark' : 'light';
    }
    $77d28a6bb413df22$var$addColourThemeClass(theme);
};


var $ab8fb2666410c927$exports = {};
$ab8fb2666410c927$exports = new URL("digital-prime-fbx.85b71734.png", import.meta.url).toString();


var $e226bcc87e167a89$exports = {};
$e226bcc87e167a89$exports = new URL("greyscale.0d398306.png", import.meta.url).toString();


var $67ed4b210cdc27df$exports = {};
$67ed4b210cdc27df$exports = new URL("dmg.ae4f1a79.png", import.meta.url).toString();


const $94fba40936b80926$var$themeOptions = [
    {
        value: 'dark',
        name: 'Dark'
    },
    {
        value: 'system',
        name: 'System',
        defaultOption: true
    },
    {
        value: 'light',
        name: 'Light'
    }
];
const $94fba40936b80926$var$paletteOptions = [
    {
        value: 'fbx',
        name: 'Digital Prime (FBX)',
        description: 'As accurate as it can get',
        defaultOption: true,
        img: (0, (/*@__PURE__*/$parcel$interopDefault($ab8fb2666410c927$exports)))
    },
    {
        value: 'grey',
        name: 'Greyscale',
        description: 'No palette applied',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($e226bcc87e167a89$exports)))
    },
    {
        value: 'dmg',
        name: 'DMG',
        description: 'Plays well with GB Studio',
        experimental: true,
        img: (0, (/*@__PURE__*/$parcel$interopDefault($67ed4b210cdc27df$exports)))
    }
];
const $94fba40936b80926$var$nameOptions = [
    {
        value: 'mm',
        name: 'Names from Maniac Mansion',
        description: 'Useful when working on a Maniac Mansion ROM hack.',
        defaultOption: true
    },
    {
        value: 'numbers',
        name: 'Numbered items',
        description: 'Better if your ROM hack is a completely different game.'
    }
];
const $94fba40936b80926$var$SettingsContainer = ()=>{
    // Find the options set, or the default ones.
    const selectedThemeValue = localStorage.getItem('theme');
    const selectedTheme = $94fba40936b80926$var$themeOptions.find(({ value: value })=>value === selectedThemeValue) || $94fba40936b80926$var$themeOptions.find(({ defaultOption: defaultOption })=>defaultOption);
    const selectedPaletteValue = localStorage.getItem('palette');
    const selectedPalette = $94fba40936b80926$var$paletteOptions.find(({ value: value })=>value === selectedPaletteValue) || $94fba40936b80926$var$paletteOptions.find(({ defaultOption: defaultOption })=>defaultOption);
    const selectedNameValue = localStorage.getItem('screen-name');
    const selectedName = $94fba40936b80926$var$nameOptions.find(({ value: value })=>value === selectedNameValue) || $94fba40936b80926$var$nameOptions.find(({ defaultOption: defaultOption })=>defaultOption);
    const [theme, setTheme] = (0, $l7WPE.useState)(selectedTheme);
    const [palette, setPalette] = (0, $l7WPE.useState)(selectedPalette);
    const [name, setName] = (0, $l7WPE.useState)(selectedName);
    // Keep the local storage and the DOM in sync with the state.
    const setThemeWrapper = (theme)=>{
        setTheme(theme);
        if (theme.defaultOption) {
            localStorage.removeItem('theme');
            (0, $77d28a6bb413df22$export$41b4f27aaec43e22)();
            return;
        }
        localStorage.setItem('theme', theme.value);
        (0, $77d28a6bb413df22$export$41b4f27aaec43e22)(theme.value);
    };
    const setPaletteWrapper = (palette)=>{
        setPalette(palette);
        if (palette.defaultOption) {
            localStorage.removeItem('palette');
            return;
        }
        localStorage.setItem('palette', palette.value);
    };
    const setNameWrapper = (name)=>{
        setName(name);
        if (name.defaultOption) {
            localStorage.removeItem('screen-name');
            return;
        }
        localStorage.setItem('screen-name', name.value);
    };
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $77f5f4efaf83b50c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $067de7175cda56e8$export$2e2bcd8739ae039), {
                title: "Settings"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $fde8b2c6568801b0$export$2e2bcd8739ae039), {
                theme: theme,
                themeOptions: $94fba40936b80926$var$themeOptions,
                setTheme: setThemeWrapper
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $055e468c89e43970$export$2e2bcd8739ae039), {
                palette: palette,
                paletteOptions: $94fba40936b80926$var$paletteOptions,
                setPalette: setPaletteWrapper
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $d5d5d2c7c78f4896$export$2e2bcd8739ae039), {
                screenName: name,
                screenNameOptions: $94fba40936b80926$var$nameOptions,
                setScreenName: setNameWrapper
            })
        ]
    });
};
var $94fba40936b80926$export$2e2bcd8739ae039 = $94fba40936b80926$var$SettingsContainer;









const $b5578e8a78df3aad$var$ScriptsList = ({ scripts: scripts, currentId: currentId })=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $0f62127f10c56af6$export$2e2bcd8739ae039), {
                children: "Scripts"
            }),
            scripts.sort((a, b)=>a.num > b.num).map(({ metadata: metadata, code: code })=>{
                if (code.length === 0) return null;
                const selected = metadata.id === currentId;
                const path = `/scripts/${metadata.id}`;
                const label = `Script ${metadata.id}`;
                return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $544d1fbe23ef0f14$export$2e2bcd8739ae039), {
                    path: selected ? null : path,
                    children: label
                }, metadata.id);
            })
        ]
    });
};
var $b5578e8a78df3aad$export$2e2bcd8739ae039 = $b5578e8a78df3aad$var$ScriptsList;



parcelRequire("l7WPE");



const $8d0abd242a8c8e3e$var$Script = ({ script: script })=>{
    if (!script) return null;
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $067de7175cda56e8$export$2e2bcd8739ae039), {
                title: `Script ${script.metadata.id}`,
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b1704ccebb1bcb93$export$2e2bcd8739ae039), {
                    metadata: script.metadata
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("div", {
                className: "text-xs",
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b0a497209e720e02$export$2e2bcd8739ae039), {
                    code: script.code
                })
            })
        ]
    });
};
var $8d0abd242a8c8e3e$export$2e2bcd8739ae039 = $8d0abd242a8c8e3e$var$Script;


const $ec20a1a1212fe6c2$var$ScriptContainer = ({ scripts: scripts })=>{
    const { id: id } = (0, $e8d0e236465e8031$export$99eaa27ddbbb95ef)();
    const currentId = typeof id === 'undefined' ? null : parseInt(id, 10);
    const script = scripts.find(({ metadata: metadata })=>metadata.id === currentId) || null;
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $307bcb5ed139e868$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b5578e8a78df3aad$export$2e2bcd8739ae039), {
                    scripts: scripts,
                    currentId: currentId
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $77f5f4efaf83b50c$export$2e2bcd8739ae039), {
                children: !script ? /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h1", {
                    children: "Scripts"
                }) : /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $97bca11ad51d3992$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $8d0abd242a8c8e3e$export$2e2bcd8739ae039), {
                        script: script
                    })
                })
            })
        ]
    });
};
var $ec20a1a1212fe6c2$export$2e2bcd8739ae039 = $ec20a1a1212fe6c2$var$ScriptContainer;


const $4d3cc66149777d0f$var$Router = ()=>{
    const { prg: prg, res: res, resources: resources } = (0, $289dddd4090929de$export$70ea12b4fef8b763)();
    if (!resources) return null;
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $e8d0e236465e8031$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                path: "/titles",
                element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $bc4beef110a6811a$export$2e2bcd8739ae039), {
                    rooms: resources.rooms,
                    titles: resources.titles
                }),
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                    path: ":id",
                    element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $bc4beef110a6811a$export$2e2bcd8739ae039), {
                        rooms: resources.rooms,
                        titles: resources.titles
                    })
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                path: "/rooms",
                element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $84f162550428efeb$export$2e2bcd8739ae039), {
                    rooms: resources.rooms,
                    titles: resources.titles,
                    roomgfx: resources.roomgfx,
                    globdata: resources.globdata[0]
                }),
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                    path: ":id",
                    element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $84f162550428efeb$export$2e2bcd8739ae039), {
                        rooms: resources.rooms,
                        titles: resources.titles,
                        roomgfx: resources.roomgfx,
                        globdata: resources.globdata[0]
                    })
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                path: "/costumes",
                element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $099541d5aeda87db$export$2e2bcd8739ae039), {
                    costumegfx: resources.costumegfx,
                    costumes: resources.costumes,
                    sprpals: resources.sprpals,
                    sprdesc: resources.sprdesc,
                    sprlens: resources.sprlens,
                    sproffs: resources.sproffs,
                    sprdata: resources.sprdata
                }),
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                    path: ":setId/:id",
                    element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $099541d5aeda87db$export$2e2bcd8739ae039), {
                        costumegfx: resources.costumegfx,
                        costumes: resources.costumes,
                        sprpals: resources.sprpals,
                        sprdesc: resources.sprdesc,
                        sprlens: resources.sprlens,
                        sproffs: resources.sproffs,
                        sprdata: resources.sprdata
                    })
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                path: "/titlegfx",
                element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b4c5160b9dffa8d7$export$2e2bcd8739ae039), {
                    titlegfx: resources.titles,
                    costumegfx: resources.costumegfx,
                    roomgfx: resources.roomgfx
                }),
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                    path: ":id",
                    element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b4c5160b9dffa8d7$export$2e2bcd8739ae039), {
                        titlegfx: resources.titles,
                        costumegfx: resources.costumegfx,
                        roomgfx: resources.roomgfx
                    })
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                path: "/costumegfx",
                element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b4c5160b9dffa8d7$export$2e2bcd8739ae039), {
                    titlegfx: resources.titles,
                    costumegfx: resources.costumegfx,
                    roomgfx: resources.roomgfx
                }),
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                    path: ":id",
                    element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b4c5160b9dffa8d7$export$2e2bcd8739ae039), {
                        titlegfx: resources.titles,
                        costumegfx: resources.costumegfx,
                        roomgfx: resources.roomgfx
                    })
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                path: "/roomgfx",
                element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b4c5160b9dffa8d7$export$2e2bcd8739ae039), {
                    titlegfx: resources.titles,
                    costumegfx: resources.costumegfx,
                    roomgfx: resources.roomgfx
                }),
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                    path: ":id",
                    element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b4c5160b9dffa8d7$export$2e2bcd8739ae039), {
                        titlegfx: resources.titles,
                        costumegfx: resources.costumegfx,
                        roomgfx: resources.roomgfx
                    })
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                path: "/preps",
                element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $1c55692d1a395796$export$2e2bcd8739ae039), {
                    preps: resources.preps[0],
                    lang: res.lang
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                path: "/scripts",
                element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $ec20a1a1212fe6c2$export$2e2bcd8739ae039), {
                    scripts: resources.scripts
                }),
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                    path: ":id",
                    element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $ec20a1a1212fe6c2$export$2e2bcd8739ae039), {
                        scripts: resources.scripts
                    })
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                path: "/rom-map",
                element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $b8f95dd68eb0b444$export$2e2bcd8739ae039), {
                    rom: prg,
                    res: res
                })
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $e8d0e236465e8031$export$e7b0ac011bb776c6), {
                path: "/settings",
                element: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $94fba40936b80926$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $4d3cc66149777d0f$export$2e2bcd8739ae039 = $4d3cc66149777d0f$var$Router;


const $ddb706d7a8938c4c$var$App = ()=>{
    const { prg: prg, res: res, resources: resources } = (0, $289dddd4090929de$export$70ea12b4fef8b763)();
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $29df82a1c17cc86b$export$2e2bcd8739ae039), {
        children: !prg || !res || !resources ? /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $0bb29f963430fcbe$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $4d3cc66149777d0f$export$2e2bcd8739ae039), {})
    });
};
var $ddb706d7a8938c4c$export$2e2bcd8739ae039 = $ddb706d7a8938c4c$var$App;



const $a4d68343e9022af3$var$ErrorMessage = ()=>{
    return /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsxs)((0, $97bca11ad51d3992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("h1", {
                className: "mb-2 whitespace-nowrap text-2xl font-semibold text-slate-700 md:text-3xl dark:text-slate-300",
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)("p", {
                children: "Open the console for more info."
            })
        ]
    });
};
var $a4d68343e9022af3$export$2e2bcd8739ae039 = $a4d68343e9022af3$var$ErrorMessage;



const $cae0e42ceac11d6b$var$basename = '/scumm-nes';
const $cae0e42ceac11d6b$var$root = (0, $de39b070b9788eff$export$882461b6382ed46c)(document.body);
$cae0e42ceac11d6b$var$root.render(/*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $l7WPE.StrictMode), {
    children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $7414ea9a2692b0f5$export$e926676385687eaf), {
        FallbackComponent: (0, $a4d68343e9022af3$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $90539c90c270aca5$export$9ba4e89fdfa1fc54), {
            basename: $cae0e42ceac11d6b$var$basename,
            children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $289dddd4090929de$export$d6fd23419d7c6b4f), {
                children: /*#__PURE__*/ (0, $97bca11ad51d3992$exports.jsx)((0, $ddb706d7a8938c4c$export$2e2bcd8739ae039), {})
            })
        })
    })
}));
(0, $77d28a6bb413df22$export$41b4f27aaec43e22)(localStorage.getItem('theme'));
// eslint-disable-next-line no-undef
if (insights) {
    // Load the analytics.
    // eslint-disable-next-line no-undef
    insights.init('OTy7QFoUv4bUuKzo');
    // eslint-disable-next-line no-undef
    insights.trackPages();
}


//# sourceMappingURL=index.1cc0b294.js.map
